var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as React from "react";
import React__default, { forwardRef, useState, useRef, useEffect, Component, useCallback, Fragment as Fragment$1, Children, cloneElement, useMemo, createContext, createElement, PureComponent, useImperativeHandle } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { createPortal, findDOMNode } from "react-dom";
var globals = "";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var a = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n2, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n2[k];
      }
    });
  });
  return a;
}
var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
var shams = function hasSymbols() {
  if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
    return false;
  }
  if (typeof Symbol.iterator === "symbol") {
    return true;
  }
  var obj = {};
  var sym = Symbol("test");
  var symObj = Object(sym);
  if (typeof sym === "string") {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
    return false;
  }
  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  }
  if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === "function") {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams;
var hasSymbols$1 = function hasNativeSymbols() {
  if (typeof origSymbol !== "function") {
    return false;
  }
  if (typeof Symbol !== "function") {
    return false;
  }
  if (typeof origSymbol("foo") !== "symbol") {
    return false;
  }
  if (typeof Symbol("bar") !== "symbol") {
    return false;
  }
  return hasSymbolSham();
};
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var slice = Array.prototype.slice;
var toStr$1 = Object.prototype.toString;
var funcType = "[object Function]";
var implementation$1 = function bind(that) {
  var target = this;
  if (typeof target !== "function" || toStr$1.call(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slice.call(arguments, 1);
  var bound;
  var binder = function() {
    if (this instanceof bound) {
      var result = target.apply(this, args.concat(slice.call(arguments)));
      if (Object(result) === result) {
        return result;
      }
      return this;
    } else {
      return target.apply(that, args.concat(slice.call(arguments)));
    }
  };
  var boundLength = Math.max(0, target.length - args.length);
  var boundArgs = [];
  for (var i = 0; i < boundLength; i++) {
    boundArgs.push("$" + i);
  }
  bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target.prototype) {
    var Empty = function Empty2() {
    };
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};
var implementation = implementation$1;
var functionBind = Function.prototype.bind || implementation;
var bind$1 = functionBind;
var src = bind$1.call(Function.call, Object.prototype.hasOwnProperty);
var undefined$1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e) {
  }
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
  try {
    $gOPD({}, "");
  } catch (e) {
    $gOPD = null;
  }
}
var throwTypeError = function() {
  throw new $TypeError$1();
};
var ThrowTypeError = $gOPD ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols2 = hasSymbols$1();
var getProto = Object.getPrototypeOf || function(x) {
  return x.__proto__;
};
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols2 ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols2 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols2 ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols2 ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols2 ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols2 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$1,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
var doEval = function doEval2(name2) {
  var value;
  if (name2 === "%AsyncFunction%") {
    value = getEvalledConstructor("async function () {}");
  } else if (name2 === "%GeneratorFunction%") {
    value = getEvalledConstructor("function* () {}");
  } else if (name2 === "%AsyncGeneratorFunction%") {
    value = getEvalledConstructor("async function* () {}");
  } else if (name2 === "%AsyncGenerator%") {
    var fn2 = doEval2("%AsyncGeneratorFunction%");
    if (fn2) {
      value = fn2.prototype;
    }
  } else if (name2 === "%AsyncIteratorPrototype%") {
    var gen = doEval2("%AsyncGenerator%");
    if (gen) {
      value = getProto(gen.prototype);
    }
  }
  INTRINSICS[name2] = value;
  return value;
};
var LEGACY_ALIASES = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind2 = functionBind;
var hasOwn$1 = src;
var $concat$1 = bind2.call(Function.call, Array.prototype.concat);
var $spliceApply = bind2.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind2.call(Function.call, String.prototype.replace);
var $strSlice = bind2.call(Function.call, String.prototype.slice);
var $exec = bind2.call(Function.call, RegExp.prototype.exec);
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = function stringToPath2(string) {
  var first = $strSlice(string, 0, 1);
  var last = $strSlice(string, -1);
  if (first === "%" && last !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
  } else if (last === "%" && first !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace$1(string, rePropName, function(match, number, quote2, subString) {
    result[result.length] = quote2 ? $replace$1(subString, reEscapeChar, "$1") : number || match;
  });
  return result;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
  var intrinsicName = name2;
  var alias;
  if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn$1(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval(intrinsicName);
    }
    if (typeof value === "undefined" && !allowMissing) {
      throw new $TypeError$1("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value
    };
  }
  throw new $SyntaxError("intrinsic " + name2 + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name2, allowMissing) {
  if (typeof name2 !== "string" || name2.length === 0) {
    throw new $TypeError$1("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$1('"allowMissing" argument must be a boolean');
  }
  if ($exec(/^%?[^%]*%?$/g, name2) === null) {
    throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  }
  var parts = stringToPath(name2);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
  var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat$1([0, 1], alias));
  }
  for (var i = 1, isOwn = true; i < parts.length; i += 1) {
    var part = parts[i];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
      throw new $SyntaxError("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError$1("base intrinsic for " + name2 + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD && i + 1 >= parts.length) {
        var desc = $gOPD(value, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn$1(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};
var callBind$1 = { exports: {} };
(function(module) {
  var bind3 = functionBind;
  var GetIntrinsic3 = getIntrinsic;
  var $apply = GetIntrinsic3("%Function.prototype.apply%");
  var $call = GetIntrinsic3("%Function.prototype.call%");
  var $reflectApply = GetIntrinsic3("%Reflect.apply%", true) || bind3.call($call, $apply);
  var $gOPD2 = GetIntrinsic3("%Object.getOwnPropertyDescriptor%", true);
  var $defineProperty = GetIntrinsic3("%Object.defineProperty%", true);
  var $max = GetIntrinsic3("%Math.max%");
  if ($defineProperty) {
    try {
      $defineProperty({}, "a", { value: 1 });
    } catch (e) {
      $defineProperty = null;
    }
  }
  module.exports = function callBind2(originalFunction) {
    var func = $reflectApply(bind3, $call, arguments);
    if ($gOPD2 && $defineProperty) {
      var desc = $gOPD2(func, "length");
      if (desc.configurable) {
        $defineProperty(func, "length", { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) });
      }
    }
    return func;
  };
  var applyBind = function applyBind2() {
    return $reflectApply(bind3, $apply, arguments);
  };
  if ($defineProperty) {
    $defineProperty(module.exports, "apply", { value: applyBind });
  } else {
    module.exports.apply = applyBind;
  }
})(callBind$1);
var GetIntrinsic$1 = getIntrinsic;
var callBind = callBind$1.exports;
var $indexOf = callBind(GetIntrinsic$1("String.prototype.indexOf"));
var callBound$1 = function callBoundIntrinsic(name2, allowMissing) {
  var intrinsic = GetIntrinsic$1(name2, !!allowMissing);
  if (typeof intrinsic === "function" && $indexOf(name2, ".prototype.") > -1) {
    return callBind(intrinsic);
  }
  return intrinsic;
};
var __viteBrowserExternal = {};
var __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
var require$$0 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap$1 = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap$1 ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap$1 && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap$1 && Map.prototype.forEach;
var hasSet$1 = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet$1 ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet$1 && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet$1 && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
  return O.__proto__;
} : null);
function addNumericSeparator(num, str) {
  if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) {
    return str;
  }
  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof num === "number") {
    var int = num < 0 ? -$floor(-num) : $floor(num);
    if (int !== num) {
      var intStr = String(int);
      var dec = $slice.call(str, intStr.length + 1);
      return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace.call(str, sepRegex, "$&_");
}
var utilInspect = require$$0;
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
var objectInspect = function inspect_(obj, options, depth, seen) {
  var opts = options || {};
  if (has$3(opts, "quoteStyle") && (opts.quoteStyle !== "single" && opts.quoteStyle !== "double")) {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has$3(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has$3(opts, "customInspect") ? opts.customInspect : true;
  if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  }
  if (has$3(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (has$3(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  }
  var numericSeparator = opts.numericSeparator;
  if (typeof obj === "undefined") {
    return "undefined";
  }
  if (obj === null) {
    return "null";
  }
  if (typeof obj === "boolean") {
    return obj ? "true" : "false";
  }
  if (typeof obj === "string") {
    return inspectString(obj, opts);
  }
  if (typeof obj === "number") {
    if (obj === 0) {
      return Infinity / obj > 0 ? "0" : "-0";
    }
    var str = String(obj);
    return numericSeparator ? addNumericSeparator(obj, str) : str;
  }
  if (typeof obj === "bigint") {
    var bigIntStr = String(obj) + "n";
    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
  }
  var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
  if (typeof depth === "undefined") {
    depth = 0;
  }
  if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
    return isArray$4(obj) ? "[Array]" : "[Object]";
  }
  var indent = getIndent(opts, depth);
  if (typeof seen === "undefined") {
    seen = [];
  } else if (indexOf(seen, obj) >= 0) {
    return "[Circular]";
  }
  function inspect2(value, from, noIndent) {
    if (from) {
      seen = $arrSlice.call(seen);
      seen.push(from);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has$3(opts, "quoteStyle")) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_(value, newOpts, depth + 1, seen);
    }
    return inspect_(value, opts, depth + 1, seen);
  }
  if (typeof obj === "function" && !isRegExp$1(obj)) {
    var name2 = nameOf(obj);
    var keys = arrObjKeys(obj, inspect2);
    return "[Function" + (name2 ? ": " + name2 : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $join.call(keys, ", ") + " }" : "");
  }
  if (isSymbol(obj)) {
    var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
    return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
  }
  if (isElement$1(obj)) {
    var s = "<" + $toLowerCase.call(String(obj.nodeName));
    var attrs = obj.attributes || [];
    for (var i = 0; i < attrs.length; i++) {
      s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
    }
    s += ">";
    if (obj.childNodes && obj.childNodes.length) {
      s += "...";
    }
    s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
    return s;
  }
  if (isArray$4(obj)) {
    if (obj.length === 0) {
      return "[]";
    }
    var xs = arrObjKeys(obj, inspect2);
    if (indent && !singleLineValues(xs)) {
      return "[" + indentedJoin(xs, indent) + "]";
    }
    return "[ " + $join.call(xs, ", ") + " ]";
  }
  if (isError(obj)) {
    var parts = arrObjKeys(obj, inspect2);
    if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) {
      return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect2(obj.cause), parts), ", ") + " }";
    }
    if (parts.length === 0) {
      return "[" + String(obj) + "]";
    }
    return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
  }
  if (typeof obj === "object" && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) {
      return utilInspect(obj, { depth: maxDepth - depth });
    } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
      return obj.inspect();
    }
  }
  if (isMap(obj)) {
    var mapParts = [];
    mapForEach.call(obj, function(value, key) {
      mapParts.push(inspect2(key, obj, true) + " => " + inspect2(value, obj));
    });
    return collectionOf("Map", mapSize.call(obj), mapParts, indent);
  }
  if (isSet(obj)) {
    var setParts = [];
    setForEach.call(obj, function(value) {
      setParts.push(inspect2(value, obj));
    });
    return collectionOf("Set", setSize.call(obj), setParts, indent);
  }
  if (isWeakMap(obj)) {
    return weakCollectionOf("WeakMap");
  }
  if (isWeakSet(obj)) {
    return weakCollectionOf("WeakSet");
  }
  if (isWeakRef(obj)) {
    return weakCollectionOf("WeakRef");
  }
  if (isNumber(obj)) {
    return markBoxed(inspect2(Number(obj)));
  }
  if (isBigInt(obj)) {
    return markBoxed(inspect2(bigIntValueOf.call(obj)));
  }
  if (isBoolean(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }
  if (isString(obj)) {
    return markBoxed(inspect2(String(obj)));
  }
  if (!isDate(obj) && !isRegExp$1(obj)) {
    var ys = arrObjKeys(obj, inspect2);
    var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? "" : "null prototype";
    var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
    var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
    var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
    if (ys.length === 0) {
      return tag + "{}";
    }
    if (indent) {
      return tag + "{" + indentedJoin(ys, indent) + "}";
    }
    return tag + "{ " + $join.call(ys, ", ") + " }";
  }
  return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
  return quoteChar + s + quoteChar;
}
function quote(s) {
  return $replace.call(String(s), /"/g, "&quot;");
}
function isArray$4(obj) {
  return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate(obj) {
  return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp$1(obj) {
  return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
  return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString(obj) {
  return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber(obj) {
  return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean(obj) {
  return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isSymbol(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === "object" && obj instanceof Symbol;
  }
  if (typeof obj === "symbol") {
    return true;
  }
  if (!obj || typeof obj !== "object" || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e) {
  }
  return false;
}
function isBigInt(obj) {
  if (!obj || typeof obj !== "object" || !bigIntValueOf) {
    return false;
  }
  try {
    bigIntValueOf.call(obj);
    return true;
  } catch (e) {
  }
  return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
  return key in this;
};
function has$3(obj, key) {
  return hasOwn.call(obj, key);
}
function toStr(obj) {
  return objectToString.call(obj);
}
function nameOf(f2) {
  if (f2.name) {
    return f2.name;
  }
  var m2 = $match.call(functionToString.call(f2), /^function\s*([\w$]+)/);
  if (m2) {
    return m2[1];
  }
  return null;
}
function indexOf(xs, x) {
  if (xs.indexOf) {
    return xs.indexOf(x);
  }
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) {
      return i;
    }
  }
  return -1;
}
function isMap(x) {
  if (!mapSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    mapSize.call(x);
    try {
      setSize.call(x);
    } catch (s) {
      return true;
    }
    return x instanceof Map;
  } catch (e) {
  }
  return false;
}
function isWeakMap(x) {
  if (!weakMapHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakMapHas.call(x, weakMapHas);
    try {
      weakSetHas.call(x, weakSetHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakMap;
  } catch (e) {
  }
  return false;
}
function isWeakRef(x) {
  if (!weakRefDeref || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakRefDeref.call(x);
    return true;
  } catch (e) {
  }
  return false;
}
function isSet(x) {
  if (!setSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    setSize.call(x);
    try {
      mapSize.call(x);
    } catch (m2) {
      return true;
    }
    return x instanceof Set;
  } catch (e) {
  }
  return false;
}
function isWeakSet(x) {
  if (!weakSetHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakSetHas.call(x, weakSetHas);
    try {
      weakMapHas.call(x, weakMapHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakSet;
  } catch (e) {
  }
  return false;
}
function isElement$1(x) {
  if (!x || typeof x !== "object") {
    return false;
  }
  if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
    return true;
  }
  return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
    return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
  }
  var s = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s, "single", opts);
}
function lowbyte(c) {
  var n2 = c.charCodeAt(0);
  var x = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[n2];
  if (x) {
    return "\\" + x;
  }
  return "\\x" + (n2 < 16 ? "0" : "") + $toUpperCase.call(n2.toString(16));
}
function markBoxed(str) {
  return "Object(" + str + ")";
}
function weakCollectionOf(type) {
  return type + " { ? }";
}
function collectionOf(type, size, entries, indent) {
  var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
  return type + " (" + size + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
  for (var i = 0; i < xs.length; i++) {
    if (indexOf(xs[i], "\n") >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent(opts, depth) {
  var baseIndent;
  if (opts.indent === "	") {
    baseIndent = "	";
  } else if (typeof opts.indent === "number" && opts.indent > 0) {
    baseIndent = $join.call(Array(opts.indent + 1), " ");
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: $join.call(Array(depth + 1), baseIndent)
  };
}
function indentedJoin(xs, indent) {
  if (xs.length === 0) {
    return "";
  }
  var lineJoiner = "\n" + indent.prev + indent.base;
  return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect2) {
  var isArr = isArray$4(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i = 0; i < obj.length; i++) {
      xs[i] = has$3(obj, i) ? inspect2(obj[i], obj) : "";
    }
  }
  var syms = typeof gOPS === "function" ? gOPS(obj) : [];
  var symMap;
  if (hasShammedSymbols) {
    symMap = {};
    for (var k = 0; k < syms.length; k++) {
      symMap["$" + syms[k]] = syms[k];
    }
  }
  for (var key in obj) {
    if (!has$3(obj, key)) {
      continue;
    }
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    }
    if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
      continue;
    } else if ($test.call(/[^\w$]/, key)) {
      xs.push(inspect2(key, obj) + ": " + inspect2(obj[key], obj));
    } else {
      xs.push(key + ": " + inspect2(obj[key], obj));
    }
  }
  if (typeof gOPS === "function") {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable.call(obj, syms[j])) {
        xs.push("[" + inspect2(syms[j]) + "]: " + inspect2(obj[syms[j]], obj));
      }
    }
  }
  return xs;
}
var GetIntrinsic2 = getIntrinsic;
var callBound = callBound$1;
var inspect = objectInspect;
var $TypeError = GetIntrinsic2("%TypeError%");
var $WeakMap = GetIntrinsic2("%WeakMap%", true);
var $Map = GetIntrinsic2("%Map%", true);
var $weakMapGet = callBound("WeakMap.prototype.get", true);
var $weakMapSet = callBound("WeakMap.prototype.set", true);
var $weakMapHas = callBound("WeakMap.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSet = callBound("Map.prototype.set", true);
var $mapHas = callBound("Map.prototype.has", true);
var listGetNode = function(list, key) {
  for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
    if (curr.key === key) {
      prev.next = curr.next;
      curr.next = list.next;
      list.next = curr;
      return curr;
    }
  }
};
var listGet = function(objects, key) {
  var node = listGetNode(objects, key);
  return node && node.value;
};
var listSet = function(objects, key, value) {
  var node = listGetNode(objects, key);
  if (node) {
    node.value = value;
  } else {
    objects.next = {
      key,
      next: objects.next,
      value
    };
  }
};
var listHas = function(objects, key) {
  return !!listGetNode(objects, key);
};
var sideChannel = function getSideChannel() {
  var $wm;
  var $m;
  var $o;
  var channel = {
    assert: function(key) {
      if (!channel.has(key)) {
        throw new $TypeError("Side channel does not contain " + inspect(key));
      }
    },
    get: function(key) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapGet($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapGet($m, key);
        }
      } else {
        if ($o) {
          return listGet($o, key);
        }
      }
    },
    has: function(key) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapHas($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapHas($m, key);
        }
      } else {
        if ($o) {
          return listHas($o, key);
        }
      }
      return false;
    },
    set: function(key, value) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if (!$wm) {
          $wm = new $WeakMap();
        }
        $weakMapSet($wm, key, value);
      } else if ($Map) {
        if (!$m) {
          $m = new $Map();
        }
        $mapSet($m, key, value);
      } else {
        if (!$o) {
          $o = { key: {}, next: null };
        }
        listSet($o, key, value);
      }
    }
  };
  return channel;
};
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
};
var formats$3 = {
  "default": Format.RFC3986,
  formatters: {
    RFC1738: function(value) {
      return replace.call(value, percentTwenties, "+");
    },
    RFC3986: function(value) {
      return String(value);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
};
var formats$2 = formats$3;
var has$2 = Object.prototype.hasOwnProperty;
var isArray$3 = Array.isArray;
var hexTable = function() {
  var array = [];
  for (var i = 0; i < 256; ++i) {
    array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
  }
  return array;
}();
var compactQueue = function compactQueue2(queue) {
  while (queue.length > 1) {
    var item2 = queue.pop();
    var obj = item2.obj[item2.prop];
    if (isArray$3(obj)) {
      var compacted = [];
      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== "undefined") {
          compacted.push(obj[j]);
        }
      }
      item2.obj[item2.prop] = compacted;
    }
  }
};
var arrayToObject = function arrayToObject2(source, options) {
  var obj = options && options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var i = 0; i < source.length; ++i) {
    if (typeof source[i] !== "undefined") {
      obj[i] = source[i];
    }
  }
  return obj;
};
var merge$1 = function merge(target, source, options) {
  if (!source) {
    return target;
  }
  if (typeof source !== "object") {
    if (isArray$3(target)) {
      target.push(source);
    } else if (target && typeof target === "object") {
      if (options && (options.plainObjects || options.allowPrototypes) || !has$2.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }
    return target;
  }
  if (!target || typeof target !== "object") {
    return [target].concat(source);
  }
  var mergeTarget = target;
  if (isArray$3(target) && !isArray$3(source)) {
    mergeTarget = arrayToObject(target, options);
  }
  if (isArray$3(target) && isArray$3(source)) {
    source.forEach(function(item2, i) {
      if (has$2.call(target, i)) {
        var targetItem = target[i];
        if (targetItem && typeof targetItem === "object" && item2 && typeof item2 === "object") {
          target[i] = merge(targetItem, item2, options);
        } else {
          target.push(item2);
        }
      } else {
        target[i] = item2;
      }
    });
    return target;
  }
  return Object.keys(source).reduce(function(acc, key) {
    var value = source[key];
    if (has$2.call(acc, key)) {
      acc[key] = merge(acc[key], value, options);
    } else {
      acc[key] = value;
    }
    return acc;
  }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function(acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};
var decode = function(str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, " ");
  if (charset === "iso-8859-1") {
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  }
  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};
var encode = function encode2(str, defaultEncoder, charset, kind, format) {
  if (str.length === 0) {
    return str;
  }
  var string = str;
  if (typeof str === "symbol") {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== "string") {
    string = String(str);
  }
  if (charset === "iso-8859-1") {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
      return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
  }
  var out = "";
  for (var i = 0; i < string.length; ++i) {
    var c = string.charCodeAt(i);
    if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === formats$2.RFC1738 && (c === 40 || c === 41)) {
      out += string.charAt(i);
      continue;
    }
    if (c < 128) {
      out = out + hexTable[c];
      continue;
    }
    if (c < 2048) {
      out = out + (hexTable[192 | c >> 6] + hexTable[128 | c & 63]);
      continue;
    }
    if (c < 55296 || c >= 57344) {
      out = out + (hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63]);
      continue;
    }
    i += 1;
    c = 65536 + ((c & 1023) << 10 | string.charCodeAt(i) & 1023);
    out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
  }
  return out;
};
var compact = function compact2(value) {
  var queue = [{ obj: { o: value }, prop: "o" }];
  var refs = [];
  for (var i = 0; i < queue.length; ++i) {
    var item2 = queue[i];
    var obj = item2.obj[item2.prop];
    var keys = Object.keys(obj);
    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];
      if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
        queue.push({ obj, prop: key });
        refs.push(val);
      }
    }
  }
  compactQueue(queue);
  return value;
};
var isRegExp = function isRegExp2(obj) {
  return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer = function isBuffer2(obj) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine2(a, b) {
  return [].concat(a, b);
};
var maybeMap = function maybeMap2(val, fn2) {
  if (isArray$3(val)) {
    var mapped = [];
    for (var i = 0; i < val.length; i += 1) {
      mapped.push(fn2(val[i]));
    }
    return mapped;
  }
  return fn2(val);
};
var utils$2 = {
  arrayToObject,
  assign,
  combine,
  compact,
  decode,
  encode,
  isBuffer,
  isRegExp,
  maybeMap,
  merge: merge$1
};
var getSideChannel2 = sideChannel;
var utils$1 = utils$2;
var formats$1 = formats$3;
var has$1 = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + "[]";
  },
  comma: "comma",
  indices: function indices(prefix, key) {
    return prefix + "[" + key + "]";
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray$2 = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
  push.apply(arr, isArray$2(valueOrArray) ? valueOrArray : [valueOrArray]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats$1["default"];
var defaults$1 = {
  addQueryPrefix: false,
  allowDots: false,
  charset: "utf-8",
  charsetSentinel: false,
  delimiter: "&",
  encode: true,
  encoder: utils$1.encode,
  encodeValuesOnly: false,
  format: defaultFormat,
  formatter: formats$1.formatters[defaultFormat],
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive2(v) {
  return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var stringify$1 = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate2, format, formatter, encodeValuesOnly, charset, sideChannel2) {
  var obj = object;
  if (sideChannel2.has(object)) {
    throw new RangeError("Cyclic object value");
  }
  if (typeof filter === "function") {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate2(obj);
  } else if (generateArrayPrefix === "comma" && isArray$2(obj)) {
    obj = utils$1.maybeMap(obj, function(value2) {
      if (value2 instanceof Date) {
        return serializeDate2(value2);
      }
      return value2;
    });
  }
  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, "key", format) : prefix;
    }
    obj = "";
  }
  if (isNonNullishPrimitive(obj) || utils$1.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, "key", format);
      return [formatter(keyValue) + "=" + formatter(encoder(obj, defaults$1.encoder, charset, "value", format))];
    }
    return [formatter(prefix) + "=" + formatter(String(obj))];
  }
  var values = [];
  if (typeof obj === "undefined") {
    return values;
  }
  var objKeys;
  if (generateArrayPrefix === "comma" && isArray$2(obj)) {
    objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
  } else if (isArray$2(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }
  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];
    var value = typeof key === "object" && key.value !== void 0 ? key.value : obj[key];
    if (skipNulls && value === null) {
      continue;
    }
    var keyPrefix = isArray$2(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
    sideChannel2.set(object, true);
    var valueSideChannel = getSideChannel2();
    pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate2, format, formatter, encodeValuesOnly, charset, valueSideChannel));
  }
  return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions2(opts) {
  if (!opts) {
    return defaults$1;
  }
  if (opts.encoder !== null && opts.encoder !== void 0 && typeof opts.encoder !== "function") {
    throw new TypeError("Encoder has to be a function.");
  }
  var charset = opts.charset || defaults$1.charset;
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var format = formats$1["default"];
  if (typeof opts.format !== "undefined") {
    if (!has$1.call(formats$1.formatters, opts.format)) {
      throw new TypeError("Unknown format option provided.");
    }
    format = opts.format;
  }
  var formatter = formats$1.formatters[format];
  var filter = defaults$1.filter;
  if (typeof opts.filter === "function" || isArray$2(opts.filter)) {
    filter = opts.filter;
  }
  return {
    addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
    allowDots: typeof opts.allowDots === "undefined" ? defaults$1.allowDots : !!opts.allowDots,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults$1.charsetSentinel,
    delimiter: typeof opts.delimiter === "undefined" ? defaults$1.delimiter : opts.delimiter,
    encode: typeof opts.encode === "boolean" ? opts.encode : defaults$1.encode,
    encoder: typeof opts.encoder === "function" ? opts.encoder : defaults$1.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
    filter,
    format,
    formatter,
    serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults$1.serializeDate,
    skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults$1.skipNulls,
    sort: typeof opts.sort === "function" ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults$1.strictNullHandling
  };
};
var stringify_1 = function(object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions(opts);
  var objKeys;
  var filter;
  if (typeof options.filter === "function") {
    filter = options.filter;
    obj = filter("", obj);
  } else if (isArray$2(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }
  var keys = [];
  if (typeof obj !== "object" || obj === null) {
    return "";
  }
  var arrayFormat;
  if (opts && opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if (opts && "indices" in opts) {
    arrayFormat = opts.indices ? "indices" : "repeat";
  } else {
    arrayFormat = "indices";
  }
  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
  if (!objKeys) {
    objKeys = Object.keys(obj);
  }
  if (options.sort) {
    objKeys.sort(options.sort);
  }
  var sideChannel2 = getSideChannel2();
  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];
    if (options.skipNulls && obj[key] === null) {
      continue;
    }
    pushToArray(keys, stringify$1(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel2));
  }
  var joined = keys.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? "?" : "";
  if (options.charsetSentinel) {
    if (options.charset === "iso-8859-1") {
      prefix += "utf8=%26%2310003%3B&";
    } else {
      prefix += "utf8=%E2%9C%93&";
    }
  }
  return joined.length > 0 ? prefix + joined : "";
};
var utils = utils$2;
var has = Object.prototype.hasOwnProperty;
var isArray$1 = Array.isArray;
var defaults = {
  allowDots: false,
  allowPrototypes: false,
  allowSparse: false,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: false,
  comma: false,
  decoder: utils.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1e3,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};
var interpretNumericEntities = function(str) {
  return str.replace(/&#(\d+);/g, function($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};
var parseArrayValue = function(val, options) {
  if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
    return val.split(",");
  }
  return val;
};
var isoSentinel = "utf8=%26%2310003%3B";
var charsetSentinel = "utf8=%E2%9C%93";
var parseValues = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
  var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1;
  var i;
  var charset = options.charset;
  if (options.charsetSentinel) {
    for (i = 0; i < parts.length; ++i) {
      if (parts[i].indexOf("utf8=") === 0) {
        if (parts[i] === charsetSentinel) {
          charset = "utf-8";
        } else if (parts[i] === isoSentinel) {
          charset = "iso-8859-1";
        }
        skipIndex = i;
        i = parts.length;
      }
    }
  }
  for (i = 0; i < parts.length; ++i) {
    if (i === skipIndex) {
      continue;
    }
    var part = parts[i];
    var bracketEqualsPos = part.indexOf("]=");
    var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
    var key, val;
    if (pos === -1) {
      key = options.decoder(part, defaults.decoder, charset, "key");
      val = options.strictNullHandling ? null : "";
    } else {
      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
      val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
        return options.decoder(encodedVal, defaults.decoder, charset, "value");
      });
    }
    if (val && options.interpretNumericEntities && charset === "iso-8859-1") {
      val = interpretNumericEntities(val);
    }
    if (part.indexOf("[]=") > -1) {
      val = isArray$1(val) ? [val] : val;
    }
    if (has.call(obj, key)) {
      obj[key] = utils.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }
  return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
  var leaf = valuesParsed ? val : parseArrayValue(val, options);
  for (var i = chain.length - 1; i >= 0; --i) {
    var obj;
    var root = chain[i];
    if (root === "[]" && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
      var index2 = parseInt(cleanRoot, 10);
      if (!options.parseArrays && cleanRoot === "") {
        obj = { 0: leaf };
      } else if (!isNaN(index2) && root !== cleanRoot && String(index2) === cleanRoot && index2 >= 0 && (options.parseArrays && index2 <= options.arrayLimit)) {
        obj = [];
        obj[index2] = leaf;
      } else {
        obj[cleanRoot] = leaf;
      }
    }
    leaf = obj;
  }
  return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  }
  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
  var brackets2 = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g;
  var segment = options.depth > 0 && brackets2.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key;
  var keys = [];
  if (parent) {
    if (!options.plainObjects && has.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(parent);
  }
  var i = 0;
  while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;
    if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(segment[1]);
  }
  if (segment) {
    keys.push("[" + key.slice(segment.index) + "]");
  }
  return parseObject(keys, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions2(opts) {
  if (!opts) {
    return defaults;
  }
  if (opts.decoder !== null && opts.decoder !== void 0 && typeof opts.decoder !== "function") {
    throw new TypeError("Decoder has to be a function.");
  }
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
  return {
    allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
    allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
    arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
    comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
    decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
    delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
    depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
  };
};
var parse$1 = function(str, opts) {
  var options = normalizeParseOptions(opts);
  if (str === "" || str === null || typeof str === "undefined") {
    return options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  }
  var tempObj = typeof str === "string" ? parseValues(str, options) : str;
  var obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  var keys = Object.keys(tempObj);
  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
    obj = utils.merge(obj, newObj, options);
  }
  if (options.allowSparse === true) {
    return obj;
  }
  return utils.compact(obj);
};
var stringify2 = stringify_1;
var parse = parse$1;
var formats = formats$3;
var lib = {
  formats,
  parse,
  stringify: stringify2
};
var defaultAvatar = "data:image/png;base64,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";
function md5(s) {
  function L(k, d) {
    return k << d | k >>> 32 - d;
  }
  function K(G, k) {
    var I, d, F, H, x;
    F = G & 2147483648;
    H = k & 2147483648;
    I = G & 1073741824;
    d = k & 1073741824;
    x = (G & 1073741823) + (k & 1073741823);
    if (I & d) {
      return x ^ 2147483648 ^ F ^ H;
    }
    if (I | d) {
      if (x & 1073741824) {
        return x ^ 3221225472 ^ F ^ H;
      } else {
        return x ^ 1073741824 ^ F ^ H;
      }
    } else {
      return x ^ F ^ H;
    }
  }
  function r(d, F, k) {
    return d & F | ~d & k;
  }
  function q2(d, F, k) {
    return d & k | F & ~k;
  }
  function p2(d, F, k) {
    return d ^ F ^ k;
  }
  function n2(d, F, k) {
    return F ^ (d | ~k);
  }
  function u(G, F, aa, Z, k, H, I) {
    G = K(G, K(K(r(F, aa, Z), k), I));
    return K(L(G, H), F);
  }
  function f2(G, F, aa, Z, k, H, I) {
    G = K(G, K(K(q2(F, aa, Z), k), I));
    return K(L(G, H), F);
  }
  function D(G, F, aa, Z, k, H, I) {
    G = K(G, K(K(p2(F, aa, Z), k), I));
    return K(L(G, H), F);
  }
  function t(G, F, aa, Z, k, H, I) {
    G = K(G, K(K(n2(F, aa, Z), k), I));
    return K(L(G, H), F);
  }
  function e(G) {
    var Z;
    var F = G.length;
    var x = F + 8;
    var k = (x - x % 64) / 64;
    var I = (k + 1) * 16;
    var aa = Array(I - 1);
    var d = 0;
    var H = 0;
    while (H < F) {
      Z = (H - H % 4) / 4;
      d = H % 4 * 8;
      aa[Z] = aa[Z] | G.charCodeAt(H) << d;
      H++;
    }
    Z = (H - H % 4) / 4;
    d = H % 4 * 8;
    aa[Z] = aa[Z] | 128 << d;
    aa[I - 2] = F << 3;
    aa[I - 1] = F >>> 29;
    return aa;
  }
  function B(x) {
    var k = "", F = "", G, d;
    for (d = 0; d <= 3; d++) {
      G = x >>> d * 8 & 255;
      F = "0" + G.toString(16);
      k = k + F.substr(F.length - 2, 2);
    }
    return k;
  }
  function J(k) {
    k = k.replace(/rn/g, "n");
    var d = "";
    for (var F = 0; F < k.length; F++) {
      var x = k.charCodeAt(F);
      if (x < 128) {
        d += String.fromCharCode(x);
      } else {
        if (x > 127 && x < 2048) {
          d += String.fromCharCode(x >> 6 | 192);
          d += String.fromCharCode(x & 63 | 128);
        } else {
          d += String.fromCharCode(x >> 12 | 224);
          d += String.fromCharCode(x >> 6 & 63 | 128);
          d += String.fromCharCode(x & 63 | 128);
        }
      }
    }
    return d;
  }
  var C = Array();
  var P, h, E, v, g2, Y, X, W, V;
  var S = 7, Q = 12, N = 17, M = 22;
  var A = 5, z = 9, y = 14, w = 20;
  var o = 4, m2 = 11, l = 16, j = 23;
  var U = 6, T = 10, R = 15, O = 21;
  s = J(s);
  C = e(s);
  Y = 1732584193;
  X = 4023233417;
  W = 2562383102;
  V = 271733878;
  for (P = 0; P < C.length; P += 16) {
    h = Y;
    E = X;
    v = W;
    g2 = V;
    Y = u(Y, X, W, V, C[P + 0], S, 3614090360);
    V = u(V, Y, X, W, C[P + 1], Q, 3905402710);
    W = u(W, V, Y, X, C[P + 2], N, 606105819);
    X = u(X, W, V, Y, C[P + 3], M, 3250441966);
    Y = u(Y, X, W, V, C[P + 4], S, 4118548399);
    V = u(V, Y, X, W, C[P + 5], Q, 1200080426);
    W = u(W, V, Y, X, C[P + 6], N, 2821735955);
    X = u(X, W, V, Y, C[P + 7], M, 4249261313);
    Y = u(Y, X, W, V, C[P + 8], S, 1770035416);
    V = u(V, Y, X, W, C[P + 9], Q, 2336552879);
    W = u(W, V, Y, X, C[P + 10], N, 4294925233);
    X = u(X, W, V, Y, C[P + 11], M, 2304563134);
    Y = u(Y, X, W, V, C[P + 12], S, 1804603682);
    V = u(V, Y, X, W, C[P + 13], Q, 4254626195);
    W = u(W, V, Y, X, C[P + 14], N, 2792965006);
    X = u(X, W, V, Y, C[P + 15], M, 1236535329);
    Y = f2(Y, X, W, V, C[P + 1], A, 4129170786);
    V = f2(V, Y, X, W, C[P + 6], z, 3225465664);
    W = f2(W, V, Y, X, C[P + 11], y, 643717713);
    X = f2(X, W, V, Y, C[P + 0], w, 3921069994);
    Y = f2(Y, X, W, V, C[P + 5], A, 3593408605);
    V = f2(V, Y, X, W, C[P + 10], z, 38016083);
    W = f2(W, V, Y, X, C[P + 15], y, 3634488961);
    X = f2(X, W, V, Y, C[P + 4], w, 3889429448);
    Y = f2(Y, X, W, V, C[P + 9], A, 568446438);
    V = f2(V, Y, X, W, C[P + 14], z, 3275163606);
    W = f2(W, V, Y, X, C[P + 3], y, 4107603335);
    X = f2(X, W, V, Y, C[P + 8], w, 1163531501);
    Y = f2(Y, X, W, V, C[P + 13], A, 2850285829);
    V = f2(V, Y, X, W, C[P + 2], z, 4243563512);
    W = f2(W, V, Y, X, C[P + 7], y, 1735328473);
    X = f2(X, W, V, Y, C[P + 12], w, 2368359562);
    Y = D(Y, X, W, V, C[P + 5], o, 4294588738);
    V = D(V, Y, X, W, C[P + 8], m2, 2272392833);
    W = D(W, V, Y, X, C[P + 11], l, 1839030562);
    X = D(X, W, V, Y, C[P + 14], j, 4259657740);
    Y = D(Y, X, W, V, C[P + 1], o, 2763975236);
    V = D(V, Y, X, W, C[P + 4], m2, 1272893353);
    W = D(W, V, Y, X, C[P + 7], l, 4139469664);
    X = D(X, W, V, Y, C[P + 10], j, 3200236656);
    Y = D(Y, X, W, V, C[P + 13], o, 681279174);
    V = D(V, Y, X, W, C[P + 0], m2, 3936430074);
    W = D(W, V, Y, X, C[P + 3], l, 3572445317);
    X = D(X, W, V, Y, C[P + 6], j, 76029189);
    Y = D(Y, X, W, V, C[P + 9], o, 3654602809);
    V = D(V, Y, X, W, C[P + 12], m2, 3873151461);
    W = D(W, V, Y, X, C[P + 15], l, 530742520);
    X = D(X, W, V, Y, C[P + 2], j, 3299628645);
    Y = t(Y, X, W, V, C[P + 0], U, 4096336452);
    V = t(V, Y, X, W, C[P + 7], T, 1126891415);
    W = t(W, V, Y, X, C[P + 14], R, 2878612391);
    X = t(X, W, V, Y, C[P + 5], O, 4237533241);
    Y = t(Y, X, W, V, C[P + 12], U, 1700485571);
    V = t(V, Y, X, W, C[P + 3], T, 2399980690);
    W = t(W, V, Y, X, C[P + 10], R, 4293915773);
    X = t(X, W, V, Y, C[P + 1], O, 2240044497);
    Y = t(Y, X, W, V, C[P + 8], U, 1873313359);
    V = t(V, Y, X, W, C[P + 15], T, 4264355552);
    W = t(W, V, Y, X, C[P + 6], R, 2734768916);
    X = t(X, W, V, Y, C[P + 13], O, 1309151649);
    Y = t(Y, X, W, V, C[P + 4], U, 4149444226);
    V = t(V, Y, X, W, C[P + 11], T, 3174756917);
    W = t(W, V, Y, X, C[P + 2], R, 718787259);
    X = t(X, W, V, Y, C[P + 9], O, 3951481745);
    Y = K(Y, h);
    X = K(X, E);
    W = K(W, v);
    V = K(V, g2);
  }
  var i = B(Y) + B(X) + B(W) + B(V);
  return i.toLowerCase();
}
const icon$x = "epic__icon__49d";
const avatar = "epic__avatar__2eb";
const ripple$x = "epic__ripple__94d";
const badge$1 = "epic__badge__fa4";
const small$2 = "epic__small__8a8";
const active$5 = "epic__active__d24";
var styles$x = {
  icon: icon$x,
  "epic-icon": "epic__epic-icon__1b0",
  "epic-icon-add": "epic__epic-icon-add__223",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__34c",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__e41",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__614",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__8cb",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__f29",
  "epic-icon-calendar": "epic__epic-icon-calendar__a8f",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__f93",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__539",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__48d",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__936",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__8d6",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__638",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__d95",
  "epic-icon-close-x": "epic__epic-icon-close-x__916",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__d5c",
  "epic-icon-confluence": "epic__epic-icon-confluence__713",
  "epic-icon-contact": "epic__epic-icon-contact__835",
  "epic-icon-delete": "epic__epic-icon-delete__6de",
  "epic-icon-edit": "epic__epic-icon-edit__43c",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__606",
  "epic-icon-filter": "epic__epic-icon-filter__246",
  "epic-icon-github": "epic__epic-icon-github__979",
  "epic-icon-information": "epic__epic-icon-information__fe9",
  "epic-icon-jira": "epic__epic-icon-jira__823",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__26c",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__198",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__c33",
  "epic-icon-preview": "epic__epic-icon-preview__c13",
  "epic-icon-profile": "epic__epic-icon-profile__de5",
  "epic-icon-quotes": "epic__epic-icon-quotes__369",
  "epic-icon-search": "epic__epic-icon-search__c5f",
  "epic-icon-share": "epic__epic-icon-share__6d6",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__2ff",
  "epic-icon-slack": "epic__epic-icon-slack__db3",
  "epic-icon-steps": "epic__epic-icon-steps__285",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__0e0",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__401",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__afe",
  "epic-icon-warning": "epic__epic-icon-warning__49f",
  "epic-font-base": "epic__epic-font-base__7ef",
  "epic-font-base-md": "epic__epic-font-base-md__b28",
  "epic-font-marketing": "epic__epic-font-marketing__638",
  "epic-font-brand": "epic__epic-font-brand__a97",
  avatar,
  ripple: ripple$x,
  badge: badge$1,
  small: small$2,
  "default": "epic__default__ae3",
  active: active$5
};
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = React__default, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, k) {
  var b, d = {}, e = null, l = null;
  k !== void 0 && (e = "" + k);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (l = a.ref);
  for (b in a)
    n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      d[b] === void 0 && (d[b] = a[b]);
  return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx$1 = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const query = (v) => {
  let q2 = lib.stringify(v);
  return q2 ? `?${q2}` : "";
};
function Gravatar({
  email = "",
  missing = "mm",
  size = 100
}) {
  return /* @__PURE__ */ jsx$1("img", {
    className: "gravatar",
    src: `https://www.gravatar.com/avatar/${md5(email.trim().toLowerCase())}${query({
      d: missing,
      s: size
    })}`
  });
}
const Avatar = ({
  src: src2,
  children,
  small: small2,
  email,
  badgeCount,
  isActive
}) => {
  let imageSrc = children ? "" : src2 !== "" ? src2 : defaultAvatar;
  let isSmall = small2 ? styles$x.small : styles$x.default;
  let active2 = isActive ? styles$x.active : "";
  return /* @__PURE__ */ jsxs("div", {
    className: `${styles$x.avatar} ${isSmall} ${active2}`.trim(),
    children: [email !== "" ? /* @__PURE__ */ jsx$1(Gravatar, {
      email
    }) : imageSrc !== "" ? /* @__PURE__ */ jsx$1("img", {
      alt: "avatar image",
      src: imageSrc
    }) : /* @__PURE__ */ jsx$1("div", {
      className: styles$x.nested,
      children
    }), /* @__PURE__ */ jsx$1(Badge, {
      count: badgeCount,
      className: styles$x.badge
    })]
  });
};
Avatar.propTypes = {
  src: PropTypes.string,
  children: PropTypes.any,
  small: PropTypes.bool,
  email: PropTypes.string,
  badgeCount: PropTypes.number
};
Avatar.defaultProps = {
  src: "",
  email: "",
  small: false,
  badgeCount: 0
};
const icon$w = "epic__icon__8a3";
const badge = "epic__badge__a23";
const ripple$w = "epic__ripple__7ec";
var styles$w = {
  icon: icon$w,
  "epic-icon": "epic__epic-icon__4a8",
  "epic-icon-add": "epic__epic-icon-add__0ea",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__756",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__ad6",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__941",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__4a6",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__1e8",
  "epic-icon-calendar": "epic__epic-icon-calendar__050",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__c4d",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__0f7",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__56e",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__985",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__50b",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__5c6",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__a82",
  "epic-icon-close-x": "epic__epic-icon-close-x__578",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__bd8",
  "epic-icon-confluence": "epic__epic-icon-confluence__97b",
  "epic-icon-contact": "epic__epic-icon-contact__d74",
  "epic-icon-delete": "epic__epic-icon-delete__fe5",
  "epic-icon-edit": "epic__epic-icon-edit__130",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__905",
  "epic-icon-filter": "epic__epic-icon-filter__7d1",
  "epic-icon-github": "epic__epic-icon-github__d06",
  "epic-icon-information": "epic__epic-icon-information__941",
  "epic-icon-jira": "epic__epic-icon-jira__ec9",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__6b7",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__22f",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__55d",
  "epic-icon-preview": "epic__epic-icon-preview__f05",
  "epic-icon-profile": "epic__epic-icon-profile__c97",
  "epic-icon-quotes": "epic__epic-icon-quotes__d37",
  "epic-icon-search": "epic__epic-icon-search__361",
  "epic-icon-share": "epic__epic-icon-share__788",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__fb6",
  "epic-icon-slack": "epic__epic-icon-slack__7f9",
  "epic-icon-steps": "epic__epic-icon-steps__af8",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__144",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__218",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__f4b",
  "epic-icon-warning": "epic__epic-icon-warning__480",
  "epic-font-base": "epic__epic-font-base__481",
  badge,
  "epic-font-base-md": "epic__epic-font-base-md__2c8",
  "epic-font-marketing": "epic__epic-font-marketing__168",
  "epic-font-brand": "epic__epic-font-brand__c0e",
  ripple: ripple$w
};
const Badge = ({
  count: count2,
  className
}) => {
  return /* @__PURE__ */ jsx$1("span", {
    "badge-data": count2,
    className: `${styles$w.badge} ${className}`.trim()
  });
};
Badge.propTypes = {
  count: PropTypes.number,
  className: PropTypes.string
};
Badge.defaultProps = {
  count: 0,
  className: ""
};
var classnames$2 = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn2 = {}.hasOwnProperty;
    function classNames2() {
      var classes = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg)
          continue;
        var argType = typeof arg;
        if (argType === "string" || argType === "number") {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner2 = classNames2.apply(null, arg);
            if (inner2) {
              classes.push(inner2);
            }
          }
        } else if (argType === "object") {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn2.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }
      return classes.join(" ");
    }
    if (module.exports) {
      classNames2.default = classNames2;
      module.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames$2);
var classnames$1 = classnames$2.exports;
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function DefaultLink(_a) {
  var _b = _a, {
    onClick,
    href,
    children
  } = _b, props = __objRest(_b, [
    "onClick",
    "href",
    "children"
  ]);
  return /* @__PURE__ */ jsx$1("a", __spreadProps(__spreadValues({}, props), {
    href,
    onClick: (event) => {
      let {
        target
      } = props;
      onClick();
      if (event.button === 0 && (!target || target === "_self") && !isModifiedEvent(event)) {
        event.preventDefault();
        window.history.pushState({}, "", href);
      }
    },
    children
  }));
}
const icon$v = "epic__icon__642";
const ripple$v = "epic__ripple__66c";
const breadcrumbs = "epic__breadcrumbs__c43";
const links = "epic__links__53f";
const link$1 = "epic__link__8b8";
const slash = "epic__slash__c4c";
var styles$v = {
  icon: icon$v,
  "epic-icon": "epic__epic-icon__e2e",
  "epic-icon-add": "epic__epic-icon-add__107",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__385",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__070",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__ffe",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__68c",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__706",
  "epic-icon-calendar": "epic__epic-icon-calendar__79d",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__d07",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__599",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__934",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__beb",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__566",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__22c",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__416",
  "epic-icon-close-x": "epic__epic-icon-close-x__758",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__1f5",
  "epic-icon-confluence": "epic__epic-icon-confluence__04e",
  "epic-icon-contact": "epic__epic-icon-contact__8ad",
  "epic-icon-delete": "epic__epic-icon-delete__733",
  "epic-icon-edit": "epic__epic-icon-edit__27e",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__f71",
  "epic-icon-filter": "epic__epic-icon-filter__1e9",
  "epic-icon-github": "epic__epic-icon-github__5ed",
  "epic-icon-information": "epic__epic-icon-information__0e1",
  "epic-icon-jira": "epic__epic-icon-jira__788",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__fa4",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__656",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__24a",
  "epic-icon-preview": "epic__epic-icon-preview__f98",
  "epic-icon-profile": "epic__epic-icon-profile__ddd",
  "epic-icon-quotes": "epic__epic-icon-quotes__ebe",
  "epic-icon-search": "epic__epic-icon-search__80a",
  "epic-icon-share": "epic__epic-icon-share__f97",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__55d",
  "epic-icon-slack": "epic__epic-icon-slack__b95",
  "epic-icon-steps": "epic__epic-icon-steps__b25",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__541",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__9b3",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__564",
  "epic-icon-warning": "epic__epic-icon-warning__715",
  "epic-font-base": "epic__epic-font-base__9d9",
  "epic-font-base-md": "epic__epic-font-base-md__22e",
  "epic-font-marketing": "epic__epic-font-marketing__09a",
  "epic-font-brand": "epic__epic-font-brand__75f",
  ripple: ripple$v,
  "epic-display-base": "epic__epic-display-base__90d",
  "epic-display-1": "epic__epic-display-1__99a",
  "epic-display-2": "epic__epic-display-2__9a0",
  "epic-display-3": "epic__epic-display-3__26d",
  "epic-display-4": "epic__epic-display-4__aba",
  "epic-display-5": "epic__epic-display-5__ba1",
  "epic-title-base": "epic__epic-title-base__5f3",
  "epic-title-1": "epic__epic-title-1__ffa",
  "epic-title-2": "epic__epic-title-2__c80",
  "epic-title-3": "epic__epic-title-3__3f0",
  "epic-title-4": "epic__epic-title-4__f13",
  "epic-title-5": "epic__epic-title-5__389",
  "epic-title-6": "epic__epic-title-6__db1",
  "epic-subtitle-base": "epic__epic-subtitle-base__1a7",
  "epic-subtitle-1": "epic__epic-subtitle-1__8c6",
  "epic-subtitle-2": "epic__epic-subtitle-2__81c",
  "epic-subtitle-3": "epic__epic-subtitle-3__def",
  "epic-body-text-base": "epic__epic-body-text-base__fcc",
  "epic-body-text-1": "epic__epic-body-text-1__de4",
  "epic-body-text-2": "epic__epic-body-text-2__260",
  "epic-body-text": "epic__epic-body-text__e11",
  "epic-body-text-3": "epic__epic-body-text-3__d07",
  "epic-legal-text": "epic__epic-legal-text__e2a",
  breadcrumbs,
  "epic-label-text": "epic__epic-label-text__015",
  "epic-button-base": "epic__epic-button-base__8d5",
  "epic-button-1": "epic__epic-button-1__b42",
  "epic-button-2": "epic__epic-button-2__195",
  "epic-button-3": "epic__epic-button-3__f8e",
  links,
  link: link$1,
  slash
};
function Breadcrumbs({
  RouterLink,
  links: links2,
  className
}) {
  const Link2 = RouterLink || DefaultLink;
  return /* @__PURE__ */ jsx$1("div", {
    className: classnames$1(styles$v.breadcrumbs, className),
    children: /* @__PURE__ */ jsx$1("div", {
      className: styles$v.links,
      children: links2.map(({
        title: title2,
        href
      }, i) => {
        const link2 = href ? /* @__PURE__ */ jsx$1(Link2, {
          href,
          children: title2
        }) : title2;
        return /* @__PURE__ */ jsxs("span", {
          className: styles$v.link,
          children: [i > 0 && i <= links2.length && /* @__PURE__ */ jsx$1("span", {
            className: styles$v.slash,
            children: "/"
          }), link2]
        }, title2 + i);
      })
    })
  });
}
Breadcrumbs.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    href: PropTypes.string
  })),
  className: PropTypes.string,
  RouterLink: PropTypes.object
};
Breadcrumbs.defaultProps = {
  links: [],
  className: "",
  iconType: "Home"
};
const icon$u = "epic__icon__1f8";
const button$4 = "epic__button__710";
const ripple$u = "epic__ripple__ee0";
const extraSmall = "epic__extraSmall__49a";
const small$1 = "epic__small__5af";
const large$2 = "epic__large__a39";
const inverse$3 = "epic__inverse__369";
const inverseRipple = "epic__inverseRipple__04a";
const text = "epic__text__45c";
const isDark = "epic__isDark__b84";
var styles$u = {
  icon: icon$u,
  "epic-icon": "epic__epic-icon__642",
  "epic-icon-add": "epic__epic-icon-add__fcb",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__1e3",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__d60",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__eb5",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__333",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__280",
  "epic-icon-calendar": "epic__epic-icon-calendar__d69",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__b04",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__d7b",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__105",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__867",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__12d",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__3ac",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__1c1",
  "epic-icon-close-x": "epic__epic-icon-close-x__162",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__f21",
  "epic-icon-confluence": "epic__epic-icon-confluence__855",
  "epic-icon-contact": "epic__epic-icon-contact__79b",
  "epic-icon-delete": "epic__epic-icon-delete__301",
  "epic-icon-edit": "epic__epic-icon-edit__33a",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__e83",
  "epic-icon-filter": "epic__epic-icon-filter__07f",
  "epic-icon-github": "epic__epic-icon-github__6c7",
  "epic-icon-information": "epic__epic-icon-information__571",
  "epic-icon-jira": "epic__epic-icon-jira__220",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__6e3",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__b31",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__8df",
  "epic-icon-preview": "epic__epic-icon-preview__4ce",
  "epic-icon-profile": "epic__epic-icon-profile__3b3",
  "epic-icon-quotes": "epic__epic-icon-quotes__0ea",
  "epic-icon-search": "epic__epic-icon-search__eb5",
  "epic-icon-share": "epic__epic-icon-share__ec3",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__ac3",
  "epic-icon-slack": "epic__epic-icon-slack__89a",
  "epic-icon-steps": "epic__epic-icon-steps__e9e",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__e87",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__31b",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__237",
  "epic-icon-warning": "epic__epic-icon-warning__0ae",
  "epic-font-base": "epic__epic-font-base__5c6",
  "epic-font-base-md": "epic__epic-font-base-md__015",
  button: button$4,
  "epic-font-marketing": "epic__epic-font-marketing__58b",
  "epic-font-brand": "epic__epic-font-brand__381",
  ripple: ripple$u,
  "epic-display-base": "epic__epic-display-base__9ca",
  "epic-display-1": "epic__epic-display-1__f94",
  "epic-display-2": "epic__epic-display-2__b82",
  "epic-display-3": "epic__epic-display-3__0e7",
  "epic-display-4": "epic__epic-display-4__a7d",
  "epic-display-5": "epic__epic-display-5__791",
  "epic-title-base": "epic__epic-title-base__5e9",
  "epic-title-1": "epic__epic-title-1__0c4",
  "epic-title-2": "epic__epic-title-2__291",
  "epic-title-3": "epic__epic-title-3__2d0",
  "epic-title-4": "epic__epic-title-4__f08",
  "epic-title-5": "epic__epic-title-5__bb8",
  "epic-title-6": "epic__epic-title-6__25a",
  "epic-subtitle-base": "epic__epic-subtitle-base__2c0",
  "epic-subtitle-1": "epic__epic-subtitle-1__d53",
  "epic-subtitle-2": "epic__epic-subtitle-2__668",
  "epic-subtitle-3": "epic__epic-subtitle-3__721",
  "epic-body-text-base": "epic__epic-body-text-base__726",
  "epic-body-text-1": "epic__epic-body-text-1__975",
  "epic-body-text-2": "epic__epic-body-text-2__1c4",
  "epic-body-text": "epic__epic-body-text__c27",
  "epic-body-text-3": "epic__epic-body-text-3__91a",
  "epic-legal-text": "epic__epic-legal-text__4c4",
  "epic-label-text": "epic__epic-label-text__412",
  "epic-button-base": "epic__epic-button-base__379",
  "epic-button-1": "epic__epic-button-1__aad",
  "epic-button-2": "epic__epic-button-2__657",
  "epic-button-3": "epic__epic-button-3__42e",
  extraSmall,
  small: small$1,
  large: large$2,
  inverse: inverse$3,
  inverseRipple,
  text,
  isDark
};
const Button$1 = (_c) => {
  var _d = _c, {
    className,
    children,
    extraSmall: extraSmall2,
    small: small2,
    large: large2,
    isDark: isDark2,
    theme,
    inverse: inverse2,
    text: text2,
    style,
    type = "button",
    disabledTip
  } = _d, others = __objRest(_d, [
    "className",
    "children",
    "extraSmall",
    "small",
    "large",
    "isDark",
    "theme",
    "inverse",
    "text",
    "style",
    "type",
    "disabledTip"
  ]);
  let buttonClass = classnames$1(styles$u.button, className);
  if (extraSmall2)
    buttonClass = classnames$1(styles$u.extraSmall, buttonClass);
  if (small2)
    buttonClass = classnames$1(styles$u.small, buttonClass);
  if (large2)
    buttonClass = classnames$1(styles$u.large, buttonClass);
  if (inverse2)
    buttonClass = classnames$1(styles$u.inverse, buttonClass);
  if (text2)
    buttonClass = classnames$1(styles$u.text, buttonClass);
  let themeStyles = {};
  if (theme.primary && theme.secondary) {
    if (inverse2) {
      themeStyles = {
        background: `${theme.secondary} radial-gradient(circle, transparent 1%, ${theme.secondary} 1%) center / 15000%`,
        color: theme.primary,
        border: `1px solid ${theme.primary}`,
        transition: "background 0.2s"
      };
    } else if (text2) {
      themeStyles = {
        color: theme.primary,
        background: `${theme.secondary} radial-gradient(circle, transparent 1%, ${theme.secondary} 1%) center / 15000%`,
        transition: "background 0.2s"
      };
    } else {
      themeStyles = {
        background: `${theme.primary} radial-gradient(circle, transparent 1%, ${theme.primary} 1%) center / 15000%`,
        color: theme.secondary,
        border: `1px solid ${theme.primary}`,
        transition: "background 0.2s"
      };
    }
  }
  let buttonStyles = __spreadValues(__spreadValues({}, style), themeStyles);
  const button2 = /* @__PURE__ */ jsx$1("button", __spreadProps(__spreadValues({
    className: classnames$1(buttonClass, styles$u.ripple, isDark2 && styles$u.isDark),
    style: buttonStyles,
    type
  }, others), {
    children
  }));
  const _a = disabledTip || {}, {
    message
  } = _a, tooltipProps = __objRest(_a, [
    "message"
  ]);
  const wrapInTooltip = others.disabled && message;
  return wrapInTooltip ? /* @__PURE__ */ jsx$1(Tooltip, __spreadProps(__spreadValues({
    message
  }, tooltipProps), {
    children: button2
  })) : button2;
};
Button$1.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  extraSmall: PropTypes.bool,
  small: PropTypes.bool,
  large: PropTypes.bool,
  isDark: PropTypes.bool,
  theme: PropTypes.shape({
    primary: PropTypes.string,
    secondary: PropTypes.string
  }),
  inverse: PropTypes.bool,
  text: PropTypes.bool,
  disabledTip: PropTypes.shape({
    message: PropTypes.string,
    position: PropTypes.string
  })
};
Button$1.defaultProps = {
  className: "",
  disabledTip: {},
  theme: {},
  extraSmall: false,
  small: false,
  large: false,
  inverse: false,
  isDark: false
};
const icon$t = "epic__icon__852";
const card = "epic__card__dbd";
const description = "epic__description__55d";
const subtitle$3 = "epic__subtitle__649";
const title$5 = "epic__title__cb7";
const ripple$t = "epic__ripple__222";
const hover$1 = "epic__hover__d9f";
var styles$t = {
  icon: icon$t,
  "epic-icon": "epic__epic-icon__81f",
  "epic-icon-add": "epic__epic-icon-add__c15",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__dbf",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__142",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__c67",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__5e5",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__0e2",
  "epic-icon-calendar": "epic__epic-icon-calendar__7d0",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__146",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__a85",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__c24",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__04c",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__798",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__28a",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__288",
  "epic-icon-close-x": "epic__epic-icon-close-x__906",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__505",
  "epic-icon-confluence": "epic__epic-icon-confluence__fef",
  "epic-icon-contact": "epic__epic-icon-contact__f4b",
  "epic-icon-delete": "epic__epic-icon-delete__70e",
  "epic-icon-edit": "epic__epic-icon-edit__a8b",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__b60",
  "epic-icon-filter": "epic__epic-icon-filter__c81",
  "epic-icon-github": "epic__epic-icon-github__d92",
  "epic-icon-information": "epic__epic-icon-information__120",
  "epic-icon-jira": "epic__epic-icon-jira__8c7",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__f4f",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__121",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__0b1",
  "epic-icon-preview": "epic__epic-icon-preview__b36",
  "epic-icon-profile": "epic__epic-icon-profile__309",
  "epic-icon-quotes": "epic__epic-icon-quotes__2a1",
  "epic-icon-search": "epic__epic-icon-search__386",
  "epic-icon-share": "epic__epic-icon-share__ce7",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__9b9",
  "epic-icon-slack": "epic__epic-icon-slack__ba7",
  "epic-icon-steps": "epic__epic-icon-steps__d07",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__3e4",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__d53",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__1e0",
  "epic-icon-warning": "epic__epic-icon-warning__101",
  "epic-font-base": "epic__epic-font-base__ad7",
  card,
  description,
  "epic-font-base-md": "epic__epic-font-base-md__e47",
  subtitle: subtitle$3,
  "epic-font-marketing": "epic__epic-font-marketing__6ae",
  "epic-font-brand": "epic__epic-font-brand__a96",
  title: title$5,
  ripple: ripple$t,
  hover: hover$1
};
const Card = (_e) => {
  var _f = _e, {
    icon: icon2,
    iconPath,
    title: title2,
    subtitle: subtitle2,
    description: description2,
    className,
    hover: hover2,
    height,
    width,
    children
  } = _f, props = __objRest(_f, [
    "icon",
    "iconPath",
    "title",
    "subtitle",
    "description",
    "className",
    "hover",
    "height",
    "width",
    "children"
  ]);
  if (icon2 && iconPath)
    throw new Error("The icon and iconPath props cannot be used together.");
  const epicIcon = icon2 ? /* @__PURE__ */ jsx$1(Icon, {
    type: icon2,
    fontSize: "24px"
  }) : null;
  const imageIcon = iconPath ? /* @__PURE__ */ jsx$1("img", {
    src: iconPath,
    alt: "card-logo"
  }) : null;
  return /* @__PURE__ */ jsxs("div", __spreadProps(__spreadValues({}, props), {
    className: `${styles$t.card} ${hover2 ? styles$t.hover : ""} ${className}`,
    style: {
      height,
      width
    },
    children: [/* @__PURE__ */ jsx$1("div", {
      className: styles$t.icon,
      children: epicIcon || imageIcon
    }), title2 !== "" ? /* @__PURE__ */ jsx$1("h1", {
      className: styles$t.title,
      children: title2
    }) : null, subtitle2 !== "" ? /* @__PURE__ */ jsx$1("h3", {
      className: styles$t.subtitle,
      children: subtitle2
    }) : null, description2 !== "" ? /* @__PURE__ */ jsx$1("p", {
      className: styles$t.description,
      children: description2
    }) : null, children]
  }));
};
Card.propTypes = {
  icon: PropTypes.string,
  iconPath: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  hover: PropTypes.bool,
  height: PropTypes.string,
  width: PropTypes.string
};
Card.defaultProps = {
  title: "",
  subtitle: "",
  description: "",
  className: "",
  hover: false,
  height: "250px",
  width: "250px"
};
var fromEntries = function fromEntries2(entries) {
  return entries.reduce(function(acc, _ref3) {
    var key = _ref3[0], value = _ref3[1];
    acc[key] = value;
    return acc;
  }, {});
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;
var top$1 = "top";
var bottom$1 = "bottom";
var right$1 = "right";
var left$1 = "left";
var auto$1 = "auto";
var basePlacements = [top$1, bottom$1, right$1, left$1];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto$1]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}
function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function applyStyles(_ref3) {
  var state = _ref3.state;
  Object.keys(state.elements).forEach(function(name2) {
    var style = state.styles[name2] || {};
    var attributes = state.attributes[name2] || {};
    var element = state.elements[name2];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name3) {
      var value = attributes[name3];
      if (value === false) {
        element.removeAttribute(name3);
      } else {
        element.setAttribute(name3, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref22) {
  var state = _ref22.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name2) {
      var element = state.elements[name2];
      var attributes = state.attributes[name2] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name2) ? state.styles[name2] : initialStyles[name2]);
      var style = styleProperties.reduce(function(style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round = Math.round;
function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth;
    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }
    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }
  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
  var isIE2 = navigator.userAgent.indexOf("Trident") !== -1;
  if (isIE2 && isHTMLElement(element)) {
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css4 = getComputedStyle$1(currentNode);
    if (css4.transform !== "none" || css4.perspective !== "none" || css4.contain === "paint" || ["transform", "perspective"].indexOf(css4.willChange) !== -1 || isFirefox && css4.willChange === "filter" || isFirefox && css4.filter && css4.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys) {
  return keys.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref3) {
  var _state$modifiersData$;
  var state = _ref3.state, name2 = _ref3.name, options = _ref3.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left$1, right$1].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top$1 : left$1;
  var maxProp = axis === "y" ? bottom$1 : right$1;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name2] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref22) {
  var state = _ref22.state, options = _ref22.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref3) {
  var x = _ref3.x, y = _ref3.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref22) {
  var _Object$assign2;
  var popper2 = _ref22.popper, popperRect = _ref22.popperRect, placement = _ref22.placement, variation = _ref22.variation, offsets = _ref22.offsets, position = _ref22.position, gpuAcceleration = _ref22.gpuAcceleration, adaptive = _ref22.adaptive, roundOffsets = _ref22.roundOffsets, isFixed = _ref22.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left$1;
  var sideY = top$1;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle$1(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top$1 || (placement === left$1 || placement === right$1) && variation === end) {
      sideY = bottom$1;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left$1 || (placement === top$1 || placement === bottom$1) && variation === end) {
      sideX = right$1;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref3) {
  var state = _ref3.state, instance = _ref3.instance, options = _ref3.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent$1(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent$1(getParentNode(node));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent$1(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref3) {
  var reference2 = _ref3.reference, element = _ref3.element, placement = _ref3.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top$1:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom$1:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right$1:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left$1:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right$1, bottom$1].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top$1, bottom$1].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b) {
    return overflows[a] - overflows[b];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto$1) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref3) {
  var state = _ref3.state, options = _ref3.options, name2 = _ref3.name;
  if (state.modifiersData[name2]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto$1 ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top$1, bottom$1].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right$1 : left$1 : isStartVariation ? bottom$1 : top$1;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name2]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top$1, right$1, bottom$1, left$1].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref3) {
  var state = _ref3.state, name2 = _ref3.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name2] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left$1, top$1].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref3 = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref3[0], distance = _ref3[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left$1, right$1].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref22) {
  var state = _ref22.state, options = _ref22.options, name2 = _ref22.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name2] = data;
}
var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref3) {
  var state = _ref3.state, name2 = _ref3.name;
  state.modifiersData[name2] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref3) {
  var state = _ref3.state, options = _ref3.options, name2 = _ref3.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top$1 : left$1;
    var altSide = mainAxis === "y" ? bottom$1 : right$1;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$1 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top$1 : left$1;
    var _altSide = mainAxis === "x" ? bottom$1 : right$1;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top$1, left$1].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name2] = data;
}
var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m2) {
          return m2.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name2 = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name: name2,
              instance
            }) || state;
          }
        }
      },
      update: debounce(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name2 = _ref3.name, _ref3$options = _ref3.options, options2 = _ref3$options === void 0 ? {} : _ref3$options, effect2 = _ref3.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name: name2,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal$1(a, b) {
  if (a === b)
    return true;
  if (a && b && typeof a == "object" && typeof b == "object") {
    if (a.constructor !== b.constructor)
      return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length)
        return false;
      for (i = length; i-- !== 0; )
        if (!equal$1(a[i], b[i]))
          return false;
      return true;
    }
    var it;
    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size)
        return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0]))
          return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal$1(i.value[1], b.get(i.value[0])))
          return false;
      return true;
    }
    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size)
        return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0]))
          return false;
      return true;
    }
    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length)
        return false;
      for (i = length; i-- !== 0; )
        if (a[i] !== b[i])
          return false;
      return true;
    }
    if (a.constructor === RegExp)
      return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf)
      return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString)
      return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length)
      return false;
    for (i = length; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
        return false;
    if (hasElementType && a instanceof Element)
      return false;
    for (i = length; i-- !== 0; ) {
      if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) {
        continue;
      }
      if (!equal$1(a[keys[i]], b[keys[i]]))
        return false;
    }
    return true;
  }
  return a !== a && b !== b;
}
var reactFastCompare = function isEqual(a, b) {
  try {
    return equal$1(a, b);
  } catch (error) {
    if ((error.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error;
  }
};
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper2(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || "bottom",
    strategy: options.strategy || "absolute",
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), state = _React$useState[0], setState = _React$useState[1];
  var updateStateModifier = React.useMemo(function() {
    return {
      name: "updateState",
      enabled: true,
      phase: "write",
      fn: function fn2(_ref3) {
        var state2 = _ref3.state;
        var elements = Object.keys(state2.elements);
        ReactDOM.flushSync(function() {
          setState({
            styles: fromEntries(elements.map(function(element) {
              return [element, state2.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function(element) {
              return [element, state2.attributes[element]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []);
  var popperOptions = React.useMemo(function() {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: "applyStyles",
        enabled: false
      }])
    };
    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function() {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function() {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function() {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
const icon$s = "epic__icon__6e6";
const ripple$s = "epic__ripple__af3";
const button$3 = "epic__button__a03";
const buttonActive = "epic__buttonActive__045";
const tooltipContainer = "epic__tooltipContainer__ed6";
const tooltipContent = "epic__tooltipContent__294";
const tooltipLink = "epic__tooltipLink__d43";
const chipsList = "epic__chipsList__692";
const chipsListItem = "epic__chipsListItem__543";
var styles$s = {
  icon: icon$s,
  "epic-icon": "epic__epic-icon__e4f",
  "epic-icon-add": "epic__epic-icon-add__8c8",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__798",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__017",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__e7a",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__92a",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__0c0",
  "epic-icon-calendar": "epic__epic-icon-calendar__df4",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__a47",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__972",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__090",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__0c0",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__be8",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__aa1",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__03e",
  "epic-icon-close-x": "epic__epic-icon-close-x__d58",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__d24",
  "epic-icon-confluence": "epic__epic-icon-confluence__30c",
  "epic-icon-contact": "epic__epic-icon-contact__221",
  "epic-icon-delete": "epic__epic-icon-delete__eb7",
  "epic-icon-edit": "epic__epic-icon-edit__59b",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__823",
  "epic-icon-filter": "epic__epic-icon-filter__7d4",
  "epic-icon-github": "epic__epic-icon-github__1d5",
  "epic-icon-information": "epic__epic-icon-information__2be",
  "epic-icon-jira": "epic__epic-icon-jira__c34",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__1ec",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__698",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__5b5",
  "epic-icon-preview": "epic__epic-icon-preview__6de",
  "epic-icon-profile": "epic__epic-icon-profile__663",
  "epic-icon-quotes": "epic__epic-icon-quotes__b9c",
  "epic-icon-search": "epic__epic-icon-search__1bb",
  "epic-icon-share": "epic__epic-icon-share__52e",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__ac8",
  "epic-icon-slack": "epic__epic-icon-slack__4e0",
  "epic-icon-steps": "epic__epic-icon-steps__553",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__a97",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__e3a",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__86c",
  "epic-icon-warning": "epic__epic-icon-warning__3d2",
  "epic-font-base": "epic__epic-font-base__c2e",
  "epic-font-base-md": "epic__epic-font-base-md__b94",
  "epic-font-marketing": "epic__epic-font-marketing__32e",
  "epic-font-brand": "epic__epic-font-brand__af6",
  ripple: ripple$s,
  button: button$3,
  buttonActive,
  tooltipContainer,
  tooltipContent,
  tooltipLink,
  chipsList,
  chipsListItem
};
const TooltipContent = ({
  content: content2,
  link: link2,
  linkDescription
}) => /* @__PURE__ */ jsxs("div", {
  className: styles$s.tooltipContainer,
  children: [/* @__PURE__ */ jsx$1("p", {
    className: styles$s.tooltipContent,
    children: content2
  }), link2 && /* @__PURE__ */ jsx$1("a", {
    className: styles$s.tooltipLink,
    href: link2,
    children: linkDescription
  })]
});
const Button = forwardRef(({
  label: label2,
  isActive,
  onChipClick,
  onMouseEnter,
  onMouseLeave
}, ref) => /* @__PURE__ */ jsx$1("button", {
  ref,
  type: "button",
  className: classnames$1(styles$s.button, {
    [styles$s.buttonActive]: isActive
  }),
  onClick: () => onChipClick(label2),
  onMouseEnter,
  onMouseLeave,
  children: label2
}));
const Chip = ({
  label: label2,
  onChipClick,
  tooltip: tooltip2,
  isActive,
  tooltipProps
}) => {
  let mouseLeaveTimeout = null;
  const [referenceElement, setReferenceElement] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isTooltipHovered, setIsTooltipHovered] = useState(false);
  const referenceElementRef = useRef(null);
  const popperElementRef = useRef(null);
  const isTooltipHoveredRef = useRef(isTooltipHovered);
  const {
    styles: styles2,
    attributes
  } = usePopper(referenceElement, popperElementRef.current, {
    placement: "top"
  });
  isTooltipHoveredRef.current = isTooltipHovered;
  useEffect(() => {
    return () => {
      clearTimeout(mouseLeaveTimeout);
    };
  }, []);
  const chip = /* @__PURE__ */ jsx$1(Button, {
    label: label2,
    ref: referenceElementRef,
    onChipClick,
    isActive,
    onMouseEnter: () => {
      setReferenceElement(referenceElementRef.current);
      setIsHovered(true);
    },
    onMouseLeave: () => {
      mouseLeaveTimeout = setTimeout(() => {
        if (!isTooltipHoveredRef.current) {
          setReferenceElement(null);
          setIsHovered(false);
          setIsTooltipHovered(false);
        }
      }, 250);
    }
  });
  if (tooltip2) {
    return /* @__PURE__ */ jsx$1(Tooltip, __spreadProps(__spreadValues({
      component: TooltipContent,
      ref: popperElementRef,
      componentProps: __spreadValues({}, tooltip2),
      medium: true
    }, tooltipProps), {
      hasPopperSupport: true,
      popperProps: {
        style: styles2.popper,
        attributes: attributes.popper
      },
      isHovered,
      setIsHovered,
      setIsTooltipHovered,
      children: chip
    }));
  }
  return chip;
};
function Chips({
  chips,
  activeItems,
  onChipClick
}) {
  return /* @__PURE__ */ jsx$1("ul", {
    className: styles$s.chipsList,
    children: chips.map((chip) => {
      const isActive = activeItems.includes(chip.label);
      return /* @__PURE__ */ jsx$1("li", {
        className: styles$s.chipsListItem,
        children: /* @__PURE__ */ jsx$1(Chip, {
          label: chip.label,
          onChipClick,
          tooltip: chip.tooltip,
          isActive
        })
      }, chip.label);
    })
  });
}
Chips.propTypes = {
  chips: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    tooltip: PropTypes.shape({
      content: PropTypes.string,
      link: PropTypes.string,
      linkDescription: PropTypes.string
    })
  })).isRequired,
  onChipClick: PropTypes.func,
  activeItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  tooltipProps: PropTypes.object
};
Chips.defaultProps = {
  chips: [],
  activeItems: []
};
Chip.propTypes = {
  label: PropTypes.string.isRequired,
  onChipClick: PropTypes.func,
  tooltip: PropTypes.shape({
    content: PropTypes.string,
    link: PropTypes.string,
    linkDescription: PropTypes.string
  }),
  isActive: PropTypes.bool,
  tooltipProps: PropTypes.object
};
TooltipContent.propTypes = {
  content: PropTypes.string.isRequired,
  link: PropTypes.string,
  linkDescription: PropTypes.string
};
Button.propTypes = {
  onChipClick: PropTypes.func,
  label: PropTypes.string,
  isActive: PropTypes.bool
};
const icon$r = "epic__icon__86e";
const ripple$r = "epic__ripple__d8b";
const title$4 = "epic__title__6b3";
const subtitle$2 = "epic__subtitle__4a4";
const trigger$1 = "epic__trigger__001";
const triggerIcon = "epic__triggerIcon__784";
const collapsibleInner = "epic__collapsibleInner__d4d";
var styles$r = {
  icon: icon$r,
  "epic-icon": "epic__epic-icon__d74",
  "epic-icon-add": "epic__epic-icon-add__01c",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__bee",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__b59",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__e3b",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__b03",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__d74",
  "epic-icon-calendar": "epic__epic-icon-calendar__c32",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__abc",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__1b6",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__a27",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__3ec",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__51c",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__920",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__b48",
  "epic-icon-close-x": "epic__epic-icon-close-x__345",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__831",
  "epic-icon-confluence": "epic__epic-icon-confluence__875",
  "epic-icon-contact": "epic__epic-icon-contact__33e",
  "epic-icon-delete": "epic__epic-icon-delete__cf5",
  "epic-icon-edit": "epic__epic-icon-edit__51b",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__888",
  "epic-icon-filter": "epic__epic-icon-filter__a14",
  "epic-icon-github": "epic__epic-icon-github__f8b",
  "epic-icon-information": "epic__epic-icon-information__80b",
  "epic-icon-jira": "epic__epic-icon-jira__26b",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__962",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__3f7",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__689",
  "epic-icon-preview": "epic__epic-icon-preview__473",
  "epic-icon-profile": "epic__epic-icon-profile__9b1",
  "epic-icon-quotes": "epic__epic-icon-quotes__efd",
  "epic-icon-search": "epic__epic-icon-search__dee",
  "epic-icon-share": "epic__epic-icon-share__a0a",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__23f",
  "epic-icon-slack": "epic__epic-icon-slack__6a8",
  "epic-icon-steps": "epic__epic-icon-steps__21f",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__766",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__42e",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__200",
  "epic-icon-warning": "epic__epic-icon-warning__567",
  "epic-font-base": "epic__epic-font-base__52e",
  "epic-font-base-md": "epic__epic-font-base-md__c07",
  "epic-font-marketing": "epic__epic-font-marketing__29b",
  "epic-font-brand": "epic__epic-font-brand__1f9",
  ripple: ripple$r,
  "epic-display-base": "epic__epic-display-base__30a",
  "epic-display-1": "epic__epic-display-1__817",
  "epic-display-2": "epic__epic-display-2__48e",
  "epic-display-3": "epic__epic-display-3__692",
  "epic-display-4": "epic__epic-display-4__64c",
  "epic-display-5": "epic__epic-display-5__2a5",
  "epic-title-base": "epic__epic-title-base__732",
  "epic-title-1": "epic__epic-title-1__2ce",
  "epic-title-2": "epic__epic-title-2__cc5",
  "epic-title-3": "epic__epic-title-3__441",
  "epic-title-4": "epic__epic-title-4__7d6",
  "epic-title-5": "epic__epic-title-5__ba1",
  "epic-title-6": "epic__epic-title-6__a55",
  title: title$4,
  "epic-subtitle-base": "epic__epic-subtitle-base__1f8",
  "epic-subtitle-1": "epic__epic-subtitle-1__c39",
  "epic-subtitle-2": "epic__epic-subtitle-2__03e",
  "epic-subtitle-3": "epic__epic-subtitle-3__303",
  "epic-body-text-base": "epic__epic-body-text-base__189",
  "epic-body-text-1": "epic__epic-body-text-1__86c",
  "epic-body-text-2": "epic__epic-body-text-2__078",
  "epic-body-text": "epic__epic-body-text__e1d",
  "epic-body-text-3": "epic__epic-body-text-3__2a4",
  subtitle: subtitle$2,
  "epic-legal-text": "epic__epic-legal-text__4b9",
  "epic-label-text": "epic__epic-label-text__e08",
  "epic-button-base": "epic__epic-button-base__952",
  "epic-button-1": "epic__epic-button-1__b96",
  "epic-button-2": "epic__epic-button-2__aa5",
  "epic-button-3": "epic__epic-button-3__63a",
  trigger: trigger$1,
  triggerIcon,
  collapsibleInner
};
const setInTransition = (innerRefScrollHeight) => innerRefScrollHeight !== 0;
class ReactCollapsible extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "continueOpenCollapsible", () => {
      const {
        innerRef
      } = this;
      this.setState({
        height: innerRef.scrollHeight,
        transition: `height ${this.props.transitionTime}ms ${this.props.easing}`,
        isClosed: false,
        hasBeenOpened: true,
        inTransition: setInTransition(innerRef.scrollHeight),
        shouldOpenOnNextCycle: false
      });
    });
    __publicField(this, "handleTriggerClick", (event) => {
      if (this.props.triggerDisabled || this.state.inTransition) {
        return;
      }
      event.preventDefault();
      if (this.props.handleTriggerClick) {
        this.props.handleTriggerClick(this.props.accordionPosition);
      } else {
        if (this.state.isClosed === true) {
          this.openCollapsible();
          this.props.onOpening();
          this.props.onTriggerOpening();
        } else {
          this.closeCollapsible();
          this.props.onClosing();
          this.props.onTriggerClosing();
        }
      }
    });
    __publicField(this, "handleTransitionEnd", (e) => {
      if (e.target !== this.innerRef) {
        return;
      }
      if (!this.state.isClosed) {
        this.setState({
          height: "auto",
          overflow: this.props.overflowWhenOpen,
          inTransition: false
        });
        this.props.onOpen();
      } else {
        this.setState({
          inTransition: false
        });
        this.props.onClose();
      }
    });
    __publicField(this, "setInnerRef", (ref) => this.innerRef = ref);
    this.timeout = void 0;
    this.contentId = props.contentElementId || `collapsible-content-${Date.now()}`;
    this.triggerId = props.triggerElementProps.id || `collapsible-trigger-${Date.now()}`;
    if (props.open) {
      this.state = {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: "auto",
        transition: "none",
        hasBeenOpened: true,
        overflow: props.overflowWhenOpen,
        inTransition: false
      };
    } else {
      this.state = {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: `height ${props.transitionTime}ms ${props.easing}`,
        hasBeenOpened: false,
        overflow: "hidden",
        inTransition: false
      };
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.shouldOpenOnNextCycle) {
      this.continueOpenCollapsible();
    }
    if ((prevState.height === "auto" || prevState.height === 0) && this.state.shouldSwitchAutoOnNextCycle === true) {
      window.clearTimeout(this.timeout);
      this.timeout = window.setTimeout(() => {
        this.setState({
          height: 0,
          overflow: "hidden",
          isClosed: true,
          shouldSwitchAutoOnNextCycle: false
        });
      }, 50);
    }
    if (prevProps.open !== this.props.open) {
      if (this.props.open === true) {
        this.openCollapsible();
        this.props.onOpening();
      } else {
        this.closeCollapsible();
        this.props.onClosing();
      }
    }
  }
  componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }
  closeCollapsible() {
    const {
      innerRef
    } = this;
    this.setState({
      shouldSwitchAutoOnNextCycle: true,
      height: innerRef.scrollHeight,
      transition: `height ${this.props.transitionCloseTime ? this.props.transitionCloseTime : this.props.transitionTime}ms ${this.props.easing}`,
      inTransition: setInTransition(innerRef.scrollHeight)
    });
  }
  openCollapsible() {
    this.setState({
      inTransition: setInTransition(this.innerRef.scrollHeight),
      shouldOpenOnNextCycle: true
    });
  }
  renderNonClickableTriggerElement() {
    const {
      triggerSibling,
      classParentString
    } = this.props;
    if (!triggerSibling)
      return null;
    const triggerSiblingType = typeof triggerSibling;
    switch (triggerSiblingType) {
      case "string":
        return /* @__PURE__ */ jsx$1("span", {
          className: `${classParentString}__trigger-sibling`,
          children: triggerSibling
        });
      case "function":
        return triggerSibling();
      case "object":
        return triggerSibling;
      default:
        return null;
    }
  }
  render() {
    const dropdownStyle = {
      height: this.state.height,
      WebkitTransition: this.state.transition,
      msTransition: this.state.transition,
      transition: this.state.transition,
      overflow: this.state.overflow
    };
    var openClass = this.state.isClosed ? "is-closed" : "is-open";
    var disabledClass = this.props.triggerDisabled ? "is-disabled" : "";
    var trigger2 = this.state.isClosed === false && this.props.triggerWhenOpen !== void 0 ? this.props.triggerWhenOpen : this.props.trigger;
    const ContentContainerElement = this.props.contentContainerTagName;
    const TriggerElement = this.props.triggerTagName;
    var children = this.props.lazyRender && !this.state.hasBeenOpened && this.state.isClosed && !this.state.inTransition ? null : this.props.children;
    const {
      classParentString,
      contentOuterClassName,
      contentInnerClassName
    } = this.props;
    const triggerClassString = `${classParentString}__trigger ${openClass} ${disabledClass} ${this.state.isClosed ? this.props.triggerClassName : this.props.triggerOpenedClassName}`;
    const parentClassString = `${classParentString} ${this.state.isClosed ? this.props.className : this.props.openedClassName}`;
    const outerClassString = `${classParentString}__contentOuter ${contentOuterClassName}`;
    const innerClassString = `${classParentString}__contentInner ${contentInnerClassName}`;
    return /* @__PURE__ */ jsxs(ContentContainerElement, __spreadProps(__spreadValues({
      className: parentClassString.trim()
    }, this.props.containerElementProps), {
      children: [/* @__PURE__ */ jsx$1(TriggerElement, __spreadProps(__spreadValues({
        id: this.triggerId,
        className: triggerClassString.trim(),
        onClick: this.handleTriggerClick,
        style: this.props.triggerStyle && this.props.triggerStyle,
        onKeyPress: (event) => {
          const {
            key
          } = event;
          if (key === " " && this.props.triggerTagName.toLowerCase() !== "button" || key === "Enter") {
            this.handleTriggerClick(event);
          }
        },
        tabIndex: this.props.tabIndex && this.props.tabIndex,
        "aria-expanded": !this.state.isClosed,
        "aria-disabled": this.props.triggerDisabled,
        "aria-controls": this.contentId,
        role: "button"
      }, this.props.triggerElementProps), {
        children: trigger2
      })), this.renderNonClickableTriggerElement(), /* @__PURE__ */ jsx$1("div", {
        id: this.contentId,
        className: outerClassString.trim(),
        style: dropdownStyle,
        onTransitionEnd: this.handleTransitionEnd,
        ref: this.setInnerRef,
        hidden: this.props.contentHiddenWhenClosed && this.state.isClosed && !this.state.inTransition,
        role: "region",
        "aria-labelledby": this.triggerId,
        children: /* @__PURE__ */ jsx$1("div", {
          className: innerClassString.trim(),
          children
        })
      })]
    }));
  }
}
ReactCollapsible.propTypes = {
  transitionTime: PropTypes.number,
  transitionCloseTime: PropTypes.number,
  triggerTagName: PropTypes.string,
  easing: PropTypes.string,
  open: PropTypes.bool,
  containerElementProps: PropTypes.object,
  triggerElementProps: PropTypes.object,
  contentElementId: PropTypes.string,
  classParentString: PropTypes.string,
  className: PropTypes.string,
  openedClassName: PropTypes.string,
  triggerStyle: PropTypes.object,
  triggerClassName: PropTypes.string,
  triggerOpenedClassName: PropTypes.string,
  contentOuterClassName: PropTypes.string,
  contentInnerClassName: PropTypes.string,
  accordionPosition: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleTriggerClick: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onOpening: PropTypes.func,
  onClosing: PropTypes.func,
  onTriggerOpening: PropTypes.func,
  onTriggerClosing: PropTypes.func,
  trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  triggerWhenOpen: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  triggerDisabled: PropTypes.bool,
  lazyRender: PropTypes.bool,
  overflowWhenOpen: PropTypes.oneOf(["hidden", "visible", "auto", "scroll", "inherit", "initial", "unset"]),
  contentHiddenWhenClosed: PropTypes.bool,
  triggerSibling: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
  tabIndex: PropTypes.number,
  contentContainerTagName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
ReactCollapsible.defaultProps = {
  transitionTime: 400,
  transitionCloseTime: null,
  triggerTagName: "span",
  easing: "linear",
  open: false,
  classParentString: "Collapsible",
  triggerDisabled: false,
  lazyRender: false,
  overflowWhenOpen: "hidden",
  contentHiddenWhenClosed: false,
  openedClassName: "",
  triggerStyle: null,
  triggerClassName: "",
  triggerOpenedClassName: "",
  contentOuterClassName: "",
  contentInnerClassName: "",
  className: "",
  triggerSibling: null,
  onOpen: () => {
  },
  onClose: () => {
  },
  onOpening: () => {
  },
  onClosing: () => {
  },
  onTriggerOpening: () => {
  },
  onTriggerClosing: () => {
  },
  tabIndex: null,
  contentContainerTagName: "div",
  triggerElementProps: {}
};
const Trigger = ({
  isOpen,
  title: title2,
  subtitle: subtitle2
}) => /* @__PURE__ */ jsxs("div", {
  className: styles$r.trigger,
  children: [/* @__PURE__ */ jsx$1("div", {
    className: styles$r.triggerIcon,
    children: /* @__PURE__ */ jsx$1(Icon, {
      type: isOpen ? "CaretUp" : "CaretDown",
      size: "m"
    })
  }), /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx$1("div", {
      className: styles$r.title,
      children: /* @__PURE__ */ jsx$1("span", {
        children: title2
      })
    }), subtitle2 && /* @__PURE__ */ jsx$1("div", {
      className: styles$r.subtitle,
      children: /* @__PURE__ */ jsx$1("span", {
        children: subtitle2
      })
    })]
  })]
});
function Collapsible({
  className,
  innerClassName,
  title: title2,
  subtitle: subtitle2,
  transitionTime,
  children,
  isOpen
}) {
  return /* @__PURE__ */ jsx$1(ReactCollapsible, {
    className,
    openedClassName: className,
    transitionTime,
    open: isOpen,
    triggerWhenOpen: /* @__PURE__ */ jsx$1(Trigger, {
      title: title2,
      subtitle: subtitle2,
      isOpen: true
    }),
    trigger: /* @__PURE__ */ jsx$1(Trigger, {
      title: title2,
      subtitle: subtitle2
    }),
    children: /* @__PURE__ */ jsx$1("div", {
      className: classnames$1(styles$r.collapsibleInner, innerClassName),
      children
    })
  });
}
Collapsible.propTypes = {
  className: PropTypes.string,
  innerClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  transitionTime: PropTypes.number,
  isOpen: PropTypes.bool
};
Collapsible.defaultProps = {
  className: "",
  innerClassName: "",
  title: "",
  subtitle: null,
  transitionTime: 50,
  isOpen: false
};
const icon$q = "epic__icon__58b";
const ripple$q = "epic__ripple__61a";
const container$1 = "epic__container__338";
var styles$q = {
  icon: icon$q,
  "epic-icon": "epic__epic-icon__d7d",
  "epic-icon-add": "epic__epic-icon-add__b72",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__f5c",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__605",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__689",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__f11",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__137",
  "epic-icon-calendar": "epic__epic-icon-calendar__66d",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__8d0",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__399",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__d41",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__9eb",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__841",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__3cf",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__8da",
  "epic-icon-close-x": "epic__epic-icon-close-x__4a8",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__13b",
  "epic-icon-confluence": "epic__epic-icon-confluence__55d",
  "epic-icon-contact": "epic__epic-icon-contact__29a",
  "epic-icon-delete": "epic__epic-icon-delete__8ba",
  "epic-icon-edit": "epic__epic-icon-edit__faf",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__39f",
  "epic-icon-filter": "epic__epic-icon-filter__a1c",
  "epic-icon-github": "epic__epic-icon-github__0b1",
  "epic-icon-information": "epic__epic-icon-information__b5f",
  "epic-icon-jira": "epic__epic-icon-jira__dfb",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__572",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__99c",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__fbe",
  "epic-icon-preview": "epic__epic-icon-preview__9b3",
  "epic-icon-profile": "epic__epic-icon-profile__60a",
  "epic-icon-quotes": "epic__epic-icon-quotes__7af",
  "epic-icon-search": "epic__epic-icon-search__6df",
  "epic-icon-share": "epic__epic-icon-share__cb4",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__71a",
  "epic-icon-slack": "epic__epic-icon-slack__8ca",
  "epic-icon-steps": "epic__epic-icon-steps__b3f",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__2e0",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__4a3",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__147",
  "epic-icon-warning": "epic__epic-icon-warning__ebb",
  "epic-font-base": "epic__epic-font-base__137",
  "epic-font-base-md": "epic__epic-font-base-md__4ff",
  "epic-font-marketing": "epic__epic-font-marketing__d13",
  "epic-font-brand": "epic__epic-font-brand__428",
  ripple: ripple$q,
  container: container$1
};
const Container$1 = ({
  children,
  className = ""
}) => /* @__PURE__ */ jsx$1("div", {
  className: `${styles$q.container} ${className}`,
  children
});
Container$1.propTypes = {
  children: PropTypes.PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};
Container$1.defaultProps = {
  className: ""
};
const icon$p = "epic__icon__89a";
const ripple$p = "epic__ripple__d55";
const drawerContainer = "epic__drawerContainer__0a3";
const drawer = "epic__drawer__001";
const show$2 = "epic__show__f15";
var styles$p = {
  icon: icon$p,
  "epic-icon": "epic__epic-icon__8cc",
  "epic-icon-add": "epic__epic-icon-add__2b2",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__d38",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__4c2",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__cd2",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__54c",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__256",
  "epic-icon-calendar": "epic__epic-icon-calendar__357",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__549",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__38a",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__4a1",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__846",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__b98",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__256",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__049",
  "epic-icon-close-x": "epic__epic-icon-close-x__3ef",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__629",
  "epic-icon-confluence": "epic__epic-icon-confluence__581",
  "epic-icon-contact": "epic__epic-icon-contact__02b",
  "epic-icon-delete": "epic__epic-icon-delete__792",
  "epic-icon-edit": "epic__epic-icon-edit__d2e",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__dd4",
  "epic-icon-filter": "epic__epic-icon-filter__b7a",
  "epic-icon-github": "epic__epic-icon-github__e74",
  "epic-icon-information": "epic__epic-icon-information__4bf",
  "epic-icon-jira": "epic__epic-icon-jira__7f2",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__308",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__565",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__038",
  "epic-icon-preview": "epic__epic-icon-preview__447",
  "epic-icon-profile": "epic__epic-icon-profile__1d8",
  "epic-icon-quotes": "epic__epic-icon-quotes__c66",
  "epic-icon-search": "epic__epic-icon-search__0aa",
  "epic-icon-share": "epic__epic-icon-share__088",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__f0a",
  "epic-icon-slack": "epic__epic-icon-slack__208",
  "epic-icon-steps": "epic__epic-icon-steps__c37",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__f03",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__3d0",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__ca2",
  "epic-icon-warning": "epic__epic-icon-warning__edd",
  "epic-font-base": "epic__epic-font-base__a9b",
  "epic-font-base-md": "epic__epic-font-base-md__9aa",
  "epic-font-marketing": "epic__epic-font-marketing__fe5",
  "epic-font-brand": "epic__epic-font-brand__05b",
  ripple: ripple$p,
  drawerContainer,
  drawer,
  show: show$2
};
const Drawer = ({
  show: show2,
  className,
  offsetTop,
  children
}) => /* @__PURE__ */ jsx$1("div", {
  className: classnames$1(styles$p.drawerContainer, className, show2 && styles$p.show),
  children: /* @__PURE__ */ jsx$1("div", {
    className: styles$p.drawer,
    style: {
      top: `${offsetTop}px`
    },
    children
  })
});
Drawer.propTypes = {
  show: PropTypes.bool.isRequired,
  className: PropTypes.string,
  offsetTop: PropTypes.number,
  children: PropTypes.any
};
Drawer.defaultProps = {
  show: false,
  className: "",
  offsetTop: 0
};
const icon$o = "epic__icon__708";
const ripple$o = "epic__ripple__03f";
const epFavorites = "epic__epFavorites__09f";
const favoritesIcon = "epic__favoritesIcon__4ee";
var styles$o = {
  icon: icon$o,
  "epic-icon": "epic__epic-icon__820",
  "epic-icon-add": "epic__epic-icon-add__4f8",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__e36",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__c34",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__a16",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__613",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__570",
  "epic-icon-calendar": "epic__epic-icon-calendar__945",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__a5b",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__f10",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__f55",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__a5b",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__d91",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__c86",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__0cc",
  "epic-icon-close-x": "epic__epic-icon-close-x__f73",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__959",
  "epic-icon-confluence": "epic__epic-icon-confluence__a50",
  "epic-icon-contact": "epic__epic-icon-contact__cfd",
  "epic-icon-delete": "epic__epic-icon-delete__c30",
  "epic-icon-edit": "epic__epic-icon-edit__985",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__752",
  "epic-icon-filter": "epic__epic-icon-filter__80f",
  "epic-icon-github": "epic__epic-icon-github__9d2",
  "epic-icon-information": "epic__epic-icon-information__3e2",
  "epic-icon-jira": "epic__epic-icon-jira__b4c",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__303",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__1a6",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__885",
  "epic-icon-preview": "epic__epic-icon-preview__844",
  "epic-icon-profile": "epic__epic-icon-profile__51d",
  "epic-icon-quotes": "epic__epic-icon-quotes__b05",
  "epic-icon-search": "epic__epic-icon-search__756",
  "epic-icon-share": "epic__epic-icon-share__acf",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__bdb",
  "epic-icon-slack": "epic__epic-icon-slack__9ab",
  "epic-icon-steps": "epic__epic-icon-steps__4c3",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__66b",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__8c8",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__0c0",
  "epic-icon-warning": "epic__epic-icon-warning__f16",
  "epic-font-base": "epic__epic-font-base__7f1",
  "epic-font-base-md": "epic__epic-font-base-md__fe6",
  "epic-font-marketing": "epic__epic-font-marketing__2eb",
  "epic-font-brand": "epic__epic-font-brand__353",
  ripple: ripple$o,
  epFavorites,
  favoritesIcon
};
const Favorites = (props) => {
  const [selected2, setSelected] = useState(false);
  const onClick = () => {
    props.onClick && props.onClick(!selected2);
    props.isInteractive && setSelected(!selected2);
  };
  return /* @__PURE__ */ jsx$1("div", {
    onClick,
    className: classnames$1(styles$o.epFavorites),
    children: /* @__PURE__ */ jsx$1(Icon, {
      type: selected2 ? "FavoriteFilled" : "Favorite",
      size: props.size,
      className: classnames$1(styles$o.favoritesIcon)
    })
  });
};
Favorites.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.string,
  isInteractive: PropTypes.bool
};
Favorites.defaultProps = {
  size: "s",
  isInteractive: true
};
function EditSmall(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.26429 3.74232H3.92716C2.82132 3.74232 1.92487 4.63878 1.92487 5.74462V12.4189C1.92487 13.5247 2.82132 14.4212 3.92716 14.4212H10.6015C11.7073 14.4212 12.6037 13.5247 12.6037 12.4189V5.74461C12.6037 5.74174 12.6037 5.73887 12.6037 5.736V9.08176H11.6026V12.4189C11.6026 12.9718 11.1544 13.4201 10.6015 13.4201H3.92716C3.37424 13.4201 2.92601 12.9718 2.92601 12.4189V5.74462C2.92601 5.1917 3.37424 4.74347 3.92716 4.74347H7.26429V3.74232Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M8.85589 6.79736L12.7785 2.87472",
      stroke: "currentColor",
      strokeWidth: 1.66857
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M9.21853 7.62467L8.04422 6.45036L7.57685 8.08001L9.21853 7.62467Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("rect", {
      x: 12.8984,
      y: 1.57877,
      width: 1.66405,
      height: 0.667778,
      transform: "rotate(45 12.8984 1.57877)",
      fill: "currentColor"
    })]
  }));
}
function EditMedium(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8982 7.1208H5.89819C5.06977 7.1208 4.39819 7.79238 4.39819 8.6208V18.6208C4.39819 19.4492 5.06977 20.1208 5.89819 20.1208H15.8982C16.7266 20.1208 17.3982 19.4492 17.3982 18.6208V13.6208H18.8982V18.6208C18.8982 20.2777 17.555 21.6208 15.8982 21.6208H5.89819C4.24134 21.6208 2.89819 20.2777 2.89819 18.6208V8.6208C2.89819 6.96395 4.24134 5.6208 5.89819 5.6208H10.8982V7.1208Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13.2829 10.1981L19.1601 4.3209",
      stroke: "currentColor",
      strokeWidth: 2.5
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13.8249 11.4367L12.0664 9.67819L11.3665 12.1186L13.8249 11.4367Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("rect", {
      x: 19.3397,
      y: 2.3792,
      width: 2.49192,
      height: 1,
      transform: "rotate(45 19.3397 2.3792)",
      fill: "currentColor"
    })]
  }));
}
function EditLarge(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.0252 11.4934L12.0094 11.4934C8.69052 11.4934 6 14.1839 6 17.5028V37.5343C6 40.8532 8.69051 43.5437 12.0094 43.5437H32.0409C35.3598 43.5437 38.0503 40.8532 38.0503 37.5343V27.5186H35.0456V37.5343C35.0456 39.1938 33.7004 40.539 32.0409 40.539H12.0094C10.35 40.539 9.00472 39.1938 9.00472 37.5343V17.5028C9.00472 15.8434 10.35 14.4981 12.0094 14.4981H22.0252V11.4934Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M26.802 20.6624L38.575 8.88943",
      stroke: "currentColor",
      strokeWidth: 5.00786
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M27.8879 23.1436L24.3653 19.621L22.9633 24.5095L27.8879 23.1436Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("rect", {
      x: 38.9348,
      y: 5.00002,
      width: 4.99167,
      height: 2.00315,
      transform: "rotate(45 38.9348 5.00002)",
      fill: "currentColor"
    })]
  }));
}
function NewTabSmall(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.04337 5.3913H2.72815C1.62958 5.3913 0.739014 6.28186 0.739014 7.38043V14.0109C0.739014 15.1095 1.62958 16 2.72815 16H9.35861C10.4572 16 11.3477 15.1095 11.3477 14.0109V7.38043C11.3477 7.37807 11.3477 7.3757 11.3477 7.37334V10.6957H10.3477V14.0109C10.3477 14.5572 9.90489 15 9.35861 15H2.72815C2.18187 15 1.73901 14.5572 1.73901 14.0109V7.38043C1.73901 6.83415 2.18187 6.3913 2.72815 6.3913H6.04337V5.3913Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M5.16823 10.8825L12.2009 3.84982",
      stroke: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M12.1835 8.36524L12.1835 3.88966L7.70747 3.88918",
      stroke: "currentColor"
    })]
  }));
}
function NewTabMedium(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.19983 8.50003H3.19983C2.3714 8.50003 1.69983 9.1716 1.69983 10V20C1.69983 20.8285 2.3714 21.5 3.19983 21.5H13.1998C14.0283 21.5 14.6998 20.8285 14.6998 20V15H16.1998V20C16.1998 21.6569 14.8567 23 13.1998 23H3.19983C1.54297 23 0.199829 21.6569 0.199829 20V10C0.199829 8.34318 1.54297 7.00003 3.19983 7.00003H8.19983V8.50003Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M6.87987 15.2819L17.4865 4.67528",
      stroke: "currentColor",
      strokeWidth: 1.5
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.4603 11.4854L17.4603 4.73541L10.7096 4.73468",
      stroke: "currentColor",
      strokeWidth: 1.5
    })]
  }));
}
function NewTabLarge(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 14.1421H6C2.68629 14.1421 0 16.8284 0 20.1421V42.1421C0 45.4558 2.68629 48.1421 6 48.1421H28C31.3137 48.1421 34 45.4558 34 42.1421V31H31V42.1421C31 43.799 29.6569 45.1421 28 45.1421H6C4.34315 45.1421 3 43.799 3 42.1421V20.1421C3 18.4853 4.34315 17.1421 6 17.1421H18V14.1421Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.3483 30.5812L38.5615 9.36802",
      stroke: "currentColor",
      strokeWidth: 3
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M38.5092 22.9883L38.5091 9.48827L25.0077 9.48682",
      stroke: "currentColor",
      strokeWidth: 3
    })]
  }));
}
function ShareSmall(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M3.00601 8.67831V12.6783C3.00601 13.507 3.67801 14.1783 4.50601 14.1783H12.506C13.334 14.1783 14.006 13.507 14.006 12.6783V8.67831",
      stroke: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M8.50598 12.6784V2.67838",
      stroke: "currentColor",
      strokeWidth: 1.03448
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M11.6883 5.90102L8.5063 2.71902L5.32364 5.90102",
      stroke: "currentColor"
    })]
  }));
}
function ShareMedium(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M3.75 13V19C3.75 20.243 4.758 21.25 6 21.25H18C19.242 21.25 20.25 20.243 20.25 19V13",
      stroke: "currentColor",
      strokeWidth: 1.5
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M12 19.0001V4.00006",
      stroke: "currentColor",
      strokeWidth: 1.55172
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.7734 8.83403L12.0004 4.06104L7.22644 8.83403",
      stroke: "currentColor",
      strokeWidth: 1.5
    })]
  }));
}
function ShareLarge(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M7.5 26.4225V38.4225C7.5 40.9085 9.516 42.9225 12 42.9225H36C38.484 42.9225 40.5 40.9085 40.5 38.4225V26.4225",
      stroke: "currentColor",
      strokeWidth: 3
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M24.0001 38.4225V8.42255",
      stroke: "currentColor",
      strokeWidth: 3.10345
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M33.5469 18.0904L24.0009 8.54449L14.4529 18.0904",
      stroke: "currentColor",
      strokeWidth: 3
    })]
  }));
}
function SortAscending$4(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12 14.25H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.5 9.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5 18.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13.5 9.29008L17.21 5.58008L20.92 9.29008",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.25 15V6",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  }));
}
function SortAscending$3(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12 14.25H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.5 9.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5 18.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13.5 9.29008L17.21 5.58008L20.92 9.29008",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.25 15V6",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  }));
}
function SortAscending$2(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12 14.25H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.5 9.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5 18.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13.5 9.29008L17.21 5.58008L20.92 9.29008",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.25 15V6",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  }));
}
function SortDescending$4(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12.0098 9.75H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.50977 14.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5098 5.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.2598 9V18",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M20.9708 14.73L17.2608 18.44L13.5508 14.73",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  }));
}
function SortDescending$3(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12.0098 9.75H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.50977 14.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5098 5.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.2598 9V18",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M20.9708 14.73L17.2608 18.44L13.5508 14.73",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  }));
}
function SortDescending$2(props) {
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12.0098 9.75H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.50977 14.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5098 5.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.2598 9V18",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M20.9708 14.73L17.2608 18.44L13.5508 14.73",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  }));
}
var CXIcons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EditSmall,
  EditMedium,
  EditLarge,
  NewTabSmall,
  NewTabMedium,
  NewTabLarge,
  ShareSmall,
  ShareMedium,
  ShareLarge,
  SortAscendingSmall: SortAscending$4,
  SortAscendingMedium: SortAscending$3,
  SortAscendingLarge: SortAscending$2,
  SortDescendingSmall: SortDescending$4,
  SortDescendingMedium: SortDescending$3,
  SortDescendingLarge: SortDescending$2
}, Symbol.toStringTag, { value: "Module" }));
const sizes$1 = {
  s: "Small",
  m: "Medium",
  l: "Large"
};
function CXIcon(_g) {
  var _h = _g, {
    type,
    size
  } = _h, props = __objRest(_h, [
    "type",
    "size"
  ]);
  if (!type)
    return null;
  const compName = `${type}${sizes$1[size]}`;
  const IconComponent = CXIcons[compName];
  if (!IconComponent)
    return null;
  return /* @__PURE__ */ jsx$1(IconComponent, __spreadValues({
    type,
    size
  }, props));
}
const CXTypes = ["Edit", "NewTab", "Share", "SortAscending", "SortDescending"];
CXIcon.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(CXTypes).isRequired,
  size: PropTypes.oneOf(["s", "m", "l"])
};
CXIcon.defaultProps = {
  size: "m"
};
const nike = {
  colorContentPrimary: "#111111",
  colorContentPrimaryInverse: "#ffffff",
  colorContentSecondary: "#757575",
  colorContentSecondaryInverse: "#cccccc",
  colorContentFocus: "#111111",
  colorContentActive: "#111111",
  colorContentDisabled: "#cccccc",
  colorContentError: "#d43f21",
  colorContentSuccess: "#128a09",
  colorBackgroundPrimary: "#ffffff",
  colorBackgroundAlwaysDark: "#111111",
  colorBackgroundAlwaysLight: "#ffffff",
  colorBorderBase: "#cccccc",
  colorBorderFocus: "#111111",
  colorBorderActive: "#111111",
  colorBorderDisabled: "#e5e5e5",
  colorBorderError: "#d43f21",
  colorFocusRing: "#f5f5f5",
  buttonBorderRadius: "30px",
  buttonBorderWidth: "1.5px",
  buttonBoxShadowWidth: "0",
  buttonBoxShadowHoverWidth: "0",
  buttonPaddingTopS: "4.5px",
  buttonPaddingTopM: "10.5px",
  buttonPaddingTopL: "16.5px",
  buttonPaddingBottomS: "4.5px",
  buttonPaddingBottomM: "10.5px",
  buttonPaddingBottomL: "16.5px",
  buttonPaddingSidesS: "18.5px",
  buttonPaddingSidesM: "22.5px",
  buttonPaddingSidesL: "22.5px",
  buttonPaddingUnderline: "0",
  buttonHeightS: "36px",
  buttonHeightM: "48px",
  buttonHeightL: "60px",
  buttonColorHover: "#757575",
  buttonColorHoverInverse: "#b2b2b2",
  dialogBackgroundBlur: "4px",
  elevation10: "10",
  elevation20: "20",
  elevation30: "30",
  elevation40: "40",
  elevation50: "50",
  elevation60: "60",
  elevation70: "70",
  elevation80: "80",
  elevation90: "90",
  elevation100: "100",
  fontWeightRegular: "400",
  fontWeightMedium: "500",
  fontWeightBold: "700",
  fontSizeXxs: "12px",
  fontSizeXs: "14px",
  fontSizeS: "16px",
  fontSizeM: "20px",
  fontSizeL: "24px",
  fontSizeXl: "28px",
  fontSizeXxl: "32px",
  fontSizeXxxl: "40px",
  fontSizeXxxxl: "48px",
  fontSizeXxxxxl: "72px",
  fontStyleNormal: "normal",
  paletteBlack: "#111111",
  paletteGrey1: "#757575",
  paletteGrey2: "#cccccc",
  paletteGrey3: "#e5e5e5",
  paletteGrey4: "#f5f5f5",
  paletteGrey5: "#fafafa",
  paletteWhite: "#ffffff",
  paletteError: "#d43f21",
  paletteSuccess: "#128a09",
  sizeSpacingXs: "4px",
  sizeSpacingS: "8px",
  sizeSpacingM: "12px",
  sizeSpacingL: "24px",
  sizeSpacingXl: "36px",
  sizeSpacingXxl: "60px",
  sizeSpacingXxxl: "84px",
  sizeSpacingXxxxl: "120px",
  sizeSpacingGridGutter: "16px",
  sizeSpacingGridGutterL: "12px",
  sizeSpacingGridExteriorGutterS: "24px",
  sizeSpacingGridExteriorGutterL: "48px",
  sizeBorderRadiusS: "4px",
  sizeBorderRadiusM: "8px",
  sizeBorderRadiusL: "12px",
  sizeBorderRadiusXl: "24px",
  sizeBorderWidthS: "1px",
  sizeBorderWidthM: "1.5px",
  sizeBorderWidthL: "2px",
  sizeIconS: "16px",
  sizeIconM: "24px",
  sizeIconL: "48px",
  sizeFormInputContainerHeight: "84px",
  sizeFormInputFieldHeight: "56px",
  transitionTimingFunctionEase: "cubic-bezier(.25, .1, .25, 1)",
  transitionDurationFast: "150ms",
  transitionDurationNormal: "250ms",
  breakpointXs: "320px",
  breakpointS: "600px",
  breakpointM: "960px",
  breakpointL: "1440px",
  breakpointXl: "1920px",
  formShadowFocus: "0 0 0 12px #f5f5f5",
  i18nTokens: {
    globalFallback: {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    get "ca-es"() {
      return this.globalFallback;
    },
    get "cs-cz"() {
      return this.globalFallback;
    },
    get "da-dk"() {
      return this.globalFallback;
    },
    get "de-de"() {
      return this.globalFallback;
    },
    "el-gr": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "60px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "34px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "36px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "32px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "32px",
      fontHeightXl: "34px",
      fontHeightXxl: "36px",
      fontHeightXxxl: "40px",
      fontHeightXxxxl: "60px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    get "en-ca"() {
      return this["en-us"];
    },
    get "en-gb"() {
      return this["en-us"];
    },
    "en-us": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "60px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "34px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "36px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "32px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "32px",
      fontHeightXl: "34px",
      fontHeightXxl: "36px",
      fontHeightXxxl: "40px",
      fontHeightXxxxl: "60px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    get "es-ar"() {
      return this.globalFallback;
    },
    get "es-ca"() {
      return this.globalFallback;
    },
    get "es-cl"() {
      return this.globalFallback;
    },
    get "es-es"() {
      return this.globalFallback;
    },
    get "es-la"() {
      return this.globalFallback;
    },
    get "es-mx"() {
      return this.globalFallback;
    },
    get "es-uy"() {
      return this.globalFallback;
    },
    get "fr-fr"() {
      return this.globalFallback;
    },
    get "hu-hu"() {
      return this.globalFallback;
    },
    get "it-it"() {
      return this.globalFallback;
    },
    "jp-jp": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
      fontFamilyBrand: '"Nike TG", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    "ko-kr": {
      typographyBody1: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
      fontFamilyBrand: '"Nike TG", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
      fontFamilyMarketing: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif'
    },
    get "nl-en"() {
      return this.globalFallback;
    },
    get "nl-nl"() {
      return this.globalFallback;
    },
    get "no-no"() {
      return this.globalFallback;
    },
    "pl-pl": {
      typographyBody1: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    get "pt-br"() {
      return this.globalFallback;
    },
    get "pt-pt"() {
      return this.globalFallback;
    },
    "ru-ru": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    get "sv-se"() {
      return this.globalFallback;
    },
    "th-th": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue W31", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif'
    },
    get "tr-tr"() {
      return this.globalFallback;
    },
    "zh-cn": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif'
    },
    "zh-tw": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif'
    }
  }
};
function _objectWithoutProperties$2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$6(source, excluded), sourceSymbolKeys;
  var key, i;
  if (Object.getOwnPropertySymbols) {
    sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var sizeIconM = nike.sizeIconM, sizeIconL = nike.sizeIconL;
var viewBoxes = {
  s: "0 0 ".concat(parseInt(sizeIconM), " ").concat(parseInt(sizeIconM)),
  m: "0 0 ".concat(parseInt(sizeIconM), " ").concat(parseInt(sizeIconM)),
  l: "0 0 ".concat(parseInt(sizeIconL), " ").concat(parseInt(sizeIconL))
};
var sizes = {
  s: sizeIconM,
  m: sizeIconM,
  l: sizeIconL
};
var SvgIcon = function(_ref3) {
  var ariaHidden = _ref3["aria-hidden"], className = _ref3.className, fill = _ref3.fill, height = _ref3.height, paths2 = _ref3.paths, _ref$role = _ref3.role, role = _ref$role === void 0 ? "img" : _ref$role, title2 = _ref3.title, _ref$size = _ref3.size, size = _ref$size === void 0 ? "m" : _ref$size, viewBox = _ref3.viewBox, width = _ref3.width, rest = _objectWithoutProperties$2(_ref3, ["aria-hidden", "className", "fill", "height", "paths", "role", "title", "size", "viewBox", "width"]);
  var isInaccessible = function(ariaHiddenValue2) {
    return !ariaHiddenValue2 && !title2;
  };
  var ariaHiddenValue = ariaHidden;
  if (isInaccessible(ariaHidden)) {
    ariaHiddenValue = true;
  }
  var vb = viewBox ? viewBox : viewBoxes[size] || viewBoxes.m;
  var svgWidth = width ? width : sizes[size];
  var svgHeight = height ? height : sizes[size];
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({}, Object.assign({
    "aria-hidden": ariaHiddenValue ? "true" : "false",
    className,
    focusable: "false",
    viewBox: vb,
    role,
    width: svgWidth,
    height: svgHeight,
    fill
  }, rest)), {
    children: [(paths2 === null || paths2 === void 0 ? void 0 : paths2[size]) ? paths2[size] : paths2 === null || paths2 === void 0 ? void 0 : paths2["m"], title2 && /* @__PURE__ */ jsx$1("title", {
      children: title2
    })]
  }));
};
var smallPath$2 = /* @__PURE__ */ React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React__default.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /* @__PURE__ */ React__default.createElement("rect", {
  x: "0",
  y: "0",
  width: "20",
  height: "20",
  rx: "10"
}), /* @__PURE__ */ React__default.createElement("rect", {
  className: "checkicon-fill",
  x: "0",
  y: "0",
  width: "20",
  height: "20",
  rx: "5"
}), /* @__PURE__ */ React__default.createElement("path", {
  className: "checkicon-check",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6.00134645 9.81868355 9.12119517 13.003429 14.9964286 7"
})));
var paths$2 = {
  s: smallPath$2,
  m: smallPath$2,
  l: smallPath$2
};
var CheckboxIcon = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({
    paths: paths$2
  }, props));
});
CheckboxIcon.displayName = "Checkbox";
var smallPath$1 = /* @__PURE__ */ React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React__default.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /* @__PURE__ */ React__default.createElement("circle", {
  className: "radio-outline",
  stroke: "currentColor",
  strokeWidth: "1.5",
  cx: "10",
  cy: "10",
  r: "9.25"
}), /* @__PURE__ */ React__default.createElement("circle", {
  className: "radio-fill",
  fill: "currentColor",
  cx: "10",
  cy: "10",
  r: "5"
})));
var paths$1 = {
  s: smallPath$1,
  m: smallPath$1,
  l: smallPath$1
};
var RadioIcon = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({
    paths: paths$1
  }, props));
});
RadioIcon.displayName = "Radio";
var paletteSuccess = nike.paletteSuccess;
var smallPath = /* @__PURE__ */ React__default.createElement("g", {
  transform: "translate(8,8)"
}, /* @__PURE__ */ React__default.createElement("circle", {
  xmlns: "http://www.w3.org/2000/svg",
  cx: "4",
  cy: "4",
  r: "4",
  fill: paletteSuccess
}));
var paths = {
  s: smallPath,
  m: smallPath,
  l: smallPath
};
var SuccessIcon = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({
    paths
  }, props));
});
SuccessIcon.displayName = "Success";
var compPaths$4k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.045 10.99V7.73L6.19 10.37 3.115 9.35l1.94 2.64-1.905 2.64 3.045-1.005 1.855 2.64v-3.26l3.11-1.02-3.115-.995zm12.84 1.02l-6.82 7.49H8.21l6.825-7.49L8.21 4.5h5.856l6.819 7.51z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.045 10.99V7.73L6.19 10.37 3.115 9.35l1.94 2.64-1.905 2.64 3.045-1.005 1.855 2.64v-3.26l3.11-1.02-3.115-.995zm12.84 1.02l-6.82 7.49H8.21l6.825-7.49L8.21 4.5h5.856l6.819 7.51z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.09 21.98v-6.52l-3.708 5.28-6.152-2.042 3.88 5.282-3.81 5.28 6.09-2.01 3.71 5.278V26.01l6.22-2.04-6.23-1.99zm25.68 2.04L28.132 39H16.42l13.65-14.98L16.42 9h11.712L41.77 24.02z",
    clipRule: "evenodd"
  }))
};
var Converse = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4k,
    fill: "none"
  }));
});
var compPaths$4j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.909 19.105c-.61-.58-1.27-1.145-1.724-1.869-2.4-3.418-2.084-8.5.82-11.529.314-.345.704-.61 1.004-.97-.05-.38-.49-.175-.74-.16-1.24.295-2.493.394-3.733.61-.99.145-1.634 1.034-1.914 1.93-.47 1.552-.94 3.122-1.034 4.753.045 1.428.389 2.841.799 4.222.235.835.485 1.744 1.21 2.289.614.49 1.429.49 2.168.578.985.096 1.945.317 2.919.506.21.155.375-.25.225-.36zM9.838 5.972c-.41-.52-1.04-.8-1.664-.865a27.193 27.193 0 01-3.389-.534c-.264-.05-.659-.205-.739.189.475.475 1.02.865 1.42 1.404 2.793 3.359 2.698 8.722-.266 11.94-.36.474-.909.755-1.209 1.269.454.175.91-.03 1.364-.11 1.065-.25 2.18-.3 3.264-.49.924-.19 1.54-1.033 1.804-1.883.394-1.24.72-2.494.94-3.764.264-1.723-.175-3.448-.66-5.112-.205-.69-.375-1.46-.865-2.044z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.909 19.105c-.61-.58-1.27-1.145-1.724-1.869-2.4-3.418-2.084-8.5.82-11.529.314-.345.704-.61 1.004-.97-.05-.38-.49-.175-.74-.16-1.24.295-2.493.394-3.733.61-.99.145-1.634 1.034-1.914 1.93-.47 1.552-.94 3.122-1.034 4.753.045 1.428.389 2.841.799 4.222.235.835.485 1.744 1.21 2.289.614.49 1.429.49 2.168.578.985.096 1.945.317 2.919.506.21.155.375-.25.225-.36zM9.838 5.972c-.41-.52-1.04-.8-1.664-.865a27.193 27.193 0 01-3.389-.534c-.264-.05-.659-.205-.739.189.475.475 1.02.865 1.42 1.404 2.793 3.359 2.698 8.722-.266 11.94-.36.474-.909.755-1.209 1.269.454.175.91-.03 1.364-.11 1.065-.25 2.18-.3 3.264-.49.924-.19 1.54-1.033 1.804-1.883.394-1.24.72-2.494.94-3.764.264-1.723-.175-3.448-.66-5.112-.205-.69-.375-1.46-.865-2.044z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39.818 38.211c-1.22-1.16-2.54-2.29-3.45-3.738-4.796-6.838-4.168-17.002 1.64-23.058.63-.692 1.41-1.222 2.01-1.94-.1-.76-.982-.35-1.48-.32-2.48.59-4.988.788-7.466 1.218-1.98.292-3.27 2.07-3.828 3.86-.94 3.106-1.88 6.246-2.07 9.506.09 2.856.778 5.684 1.6 8.444.47 1.67.97 3.488 2.42 4.578 1.228.98 2.856.98 4.336 1.158 1.97.192 3.888.632 5.836 1.01.42.312.75-.5.452-.718zm-20.14-26.268c-.82-1.04-2.08-1.6-3.33-1.73-2.258-.22-4.546-.56-6.776-1.068-.528-.1-1.32-.41-1.48.378.952.95 2.04 1.73 2.84 2.808 5.586 6.718 5.396 17.444-.53 23.88-.72.948-1.82 1.51-2.42 2.538.91.35 1.82-.06 2.73-.218 2.128-.5 4.356-.6 6.526-.98 1.85-.38 3.078-2.068 3.608-3.768.79-2.478 1.44-4.988 1.88-7.528.53-3.446-.35-6.896-1.32-10.224-.41-1.38-.75-2.918-1.728-4.088z",
    clipRule: "evenodd"
  }))
};
var Hurley = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4j,
    fill: "none"
  }));
});
var compPaths$4i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.182 3.733c-.012-.039-.012-.039-.012-.072a.966.966 0 01.922-1.007.97.97 0 011.007.922.964.964 0 01-.917 1.007c-.027.004-.062 0-.101 0-.016.004-.04.004-.056.022-.056.084.14.073-.005.44 0 0 0 .038-.012.077-.012.14-.08.562-.096.793.029.04.04.05.029.13a6.003 6.003 0 01-.09.534c-.04.14-.096.174-.147.202-.073.298-.095.545-.281.905-.022.276-.045.35-.106.484-.017.4.01.46-.281 1.101-.08.3-.017.507.05.821.068.321.276.461.298.793.05.771.017 1.305-.163 1.907l.135.348c.18.084.618.326.36.675.343.19.865.394 1.28.781.176.147.35.315.513.5.316.057.276.08.506.231.675.438 1.749 1.304 2.373 1.906.112.067.147.112.236.163.01.023.017.034.01.04-.026.072-.026.072-.06.14.039.04.095.073.134.107.04.005.04-.006.096-.017.079.073.18.135.214.135.106-.022.084-.005.185-.1.029-.035.084 0 .084 0 .04-.04.113-.119.214-.176.079-.045.23-.045.23-.045.052.006.04.051.029.073-.057.023-.18.057-.247.108-.152.14-.276.353-.276.353.299-.033.484.045.719.023.136-.005.237.006.377-.09 0 0 .14-.096.265-.14.118-.05.23-.017.33.062.069.084.119.084 0 .196-.044.045-.1.096-.18.17-.133.123-.313.291-.5.432a3.11 3.11 0 01-.527.315c-.338.23-.26.174-.523.394-.03.022-.124.078-.163.106-.107.062-.135.006-.197-.118 0 0-.028-.045-.08-.14-.05-.107-.09-.23-.072-.23-.062-.007-.331-.344-.331-.41-.063-.013-.304-.26-.31-.31l-.214-.18c-.253.044-.31-.113-.961-.608-.08-.006-.197-.05-.36-.174-.298-.253-1.007-.815-1.124-.883-.13-.067-.281-.134-.383-.214-.146-.022-.218-.05-.298-.067-.08-.022-.14-.057-.326-.079-.303-.045-.618-.18-.911-.337-.14-.073-.264-.107-.382-.169-.27-.124-.506-.236-.686-.28a2.148 2.148 0 01-.568-.226c-.061-.034-.095-.06-.134-.073-.09-.022-.153.006-.192.022-.23.108-.438.203-.636.31-.18.09-.348.186-.528.286a7.971 7.971 0 01-.534.254s-.534.253-.832.348c-.26.197-.787.546-1.107.715-.158.073-.467.252-.608.292-.08.061-.371.258-.596.421-.18.124-.31.231-.31.231-.106.084-.101.13-.28.045a1.491 1.491 0 00-.13.096c-.14.095-.146.073-.202.067-.101.08-.113.04-.197.13-.061.084 0 .061-.118.106-.028.006-.04.04-.057.056-.094.073-.1.293-.325.304-.135.09-.107.203-.197.191 0 .102-.18.23-.214.23-.292.096-.304-.118-.646.035-.045.016-.113.072-.197.084-.152.022-.332-.006-.444-.102a1.93 1.93 0 01-.326-.398c-.051-.13-.017-.208.163-.332.073-.045.084-.079.208-.084.06-.024.045.01.15-.024.064-.016.064-.005.193-.005.028-.017.067-.022.124-.045.1-.034.196-.062.196-.062s.028-.023.124-.01c.078-.035.169-.08.214-.097-.012-.124.005-.124.06-.174.08-.062.09-.05.148-.01.022-.007.039-.013.027-.035-.01-.073-.061-.107-.045-.247-.022-.057-.061-.129-.05-.174.01-.045.028-.069.056-.079.029-.012.045.006.057.022.028.034.05.135.05.135.006.118.04.26.152.18.067-.062.084-.242.214-.203l.096.085c.084-.073.084-.073.14-.107 0 0-.08-.073-.012-.135.045-.039.108-.067.208-.175.276-.292.422-.42.714-.657a6.811 6.811 0 011.699-.939c.146-.174.28-.286.585-.304.377-.606 1.085-1.136 1.248-1.22.134-.23.19-.208.365-.247.135-.107.175-.107.23-.214.063-.23-.112-.86.383-.877.112-.146.078-.112.196-.248a2.19 2.19 0 01-.118-.5c-.005-.016-.196-.157-.13-.332a2.33 2.33 0 01-.268-.432.202.202 0 01-.063-.012c-.022-.005-.055-.005-.09-.005-.078.196-.163.208-.303.253-.26.512-.35.731-1.046 1.142-.28.298-.382.64-.382.634a.46.46 0 00-.012.321c-.045.107-.027.124-.027.124.01.045.056.106.106.112.079.023.169.023.158.118-.011.113-.163.09-.237.073-.275-.05-.185-.23-.365-.174-.141.085-.196.348-.416.31-.028-.023-.017-.074.006-.119.028-.06.084-.118.056-.14-.146.04-.433.123-.433.123-.135.04-.281-.039-.147-.124.063-.022.153-.05.265-.118 0 0 .062-.072-.057-.039a1.144 1.144 0 01-.416.045s-.257-.039-.292-.056c-.028-.022-.061-.107.017-.1a2.71 2.71 0 00.563-.068c.095-.035.28-.14.382-.186 0 0 .113-.157.18-.19.107-.114.19-.18.28-.299.09-.18.192-.46.5-.906a4.16 4.16 0 01.535-.646s.062-.338.343-.573c.063-.14.157-.31.259-.462a1.7 1.7 0 00.106-.168c.09-.13.186-.377.518-.41 0 0 .147-.102.197-.175.084-.073.074-.186.14-.259-.106-.106-.365-.309-.382-.573a.85.85 0 01.265-.692c.196-.185.398-.275.646-.258.309.055.366.157.455.258.09.101.13.04.163.146.259.073.248.045.237.236.045.057.106.108.1.214.085-.175.108-.208.344-.399.062-.157.1-.315.15-.478.052-.146.114-.298.154-.41-.04-.326.06-.377.196-.664-.022-.039-.016-.05-.006-.112.057-.192.136-.433.186-.596 0 0 .017-.063.085-.063.06-.202.157-.579.179-.663.062-.208.029-.287-.01-.41-.012-.04-.006-.09-.03-.136a5.483 5.483 0 01-.19-.41c-.028-.073-.08-.354-.08-.354-.004-.062-.004-.09-.004-.09z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.182 3.733c-.012-.039-.012-.039-.012-.072a.966.966 0 01.922-1.007.97.97 0 011.007.922.964.964 0 01-.917 1.007c-.027.004-.062 0-.101 0-.016.004-.04.004-.056.022-.056.084.14.073-.005.44 0 0 0 .038-.012.077-.012.14-.08.562-.096.793.029.04.04.05.029.13a6.003 6.003 0 01-.09.534c-.04.14-.096.174-.147.202-.073.298-.095.545-.281.905-.022.276-.045.35-.106.484-.017.4.01.46-.281 1.101-.08.3-.017.507.05.821.068.321.276.461.298.793.05.771.017 1.305-.163 1.907l.135.348c.18.084.618.326.36.675.343.19.865.394 1.28.781.176.147.35.315.513.5.316.057.276.08.506.231.675.438 1.749 1.304 2.373 1.906.112.067.147.112.236.163.01.023.017.034.01.04-.026.072-.026.072-.06.14.039.04.095.073.134.107.04.005.04-.006.096-.017.079.073.18.135.214.135.106-.022.084-.005.185-.1.029-.035.084 0 .084 0 .04-.04.113-.119.214-.176.079-.045.23-.045.23-.045.052.006.04.051.029.073-.057.023-.18.057-.247.108-.152.14-.276.353-.276.353.299-.033.484.045.719.023.136-.005.237.006.377-.09 0 0 .14-.096.265-.14.118-.05.23-.017.33.062.069.084.119.084 0 .196-.044.045-.1.096-.18.17-.133.123-.313.291-.5.432a3.11 3.11 0 01-.527.315c-.338.23-.26.174-.523.394-.03.022-.124.078-.163.106-.107.062-.135.006-.197-.118 0 0-.028-.045-.08-.14-.05-.107-.09-.23-.072-.23-.062-.007-.331-.344-.331-.41-.063-.013-.304-.26-.31-.31l-.214-.18c-.253.044-.31-.113-.961-.608-.08-.006-.197-.05-.36-.174-.298-.253-1.007-.815-1.124-.883-.13-.067-.281-.134-.383-.214-.146-.022-.218-.05-.298-.067-.08-.022-.14-.057-.326-.079-.303-.045-.618-.18-.911-.337-.14-.073-.264-.107-.382-.169-.27-.124-.506-.236-.686-.28a2.148 2.148 0 01-.568-.226c-.061-.034-.095-.06-.134-.073-.09-.022-.153.006-.192.022-.23.108-.438.203-.636.31-.18.09-.348.186-.528.286a7.971 7.971 0 01-.534.254s-.534.253-.832.348c-.26.197-.787.546-1.107.715-.158.073-.467.252-.608.292-.08.061-.371.258-.596.421-.18.124-.31.231-.31.231-.106.084-.101.13-.28.045a1.491 1.491 0 00-.13.096c-.14.095-.146.073-.202.067-.101.08-.113.04-.197.13-.061.084 0 .061-.118.106-.028.006-.04.04-.057.056-.094.073-.1.293-.325.304-.135.09-.107.203-.197.191 0 .102-.18.23-.214.23-.292.096-.304-.118-.646.035-.045.016-.113.072-.197.084-.152.022-.332-.006-.444-.102a1.93 1.93 0 01-.326-.398c-.051-.13-.017-.208.163-.332.073-.045.084-.079.208-.084.06-.024.045.01.15-.024.064-.016.064-.005.193-.005.028-.017.067-.022.124-.045.1-.034.196-.062.196-.062s.028-.023.124-.01c.078-.035.169-.08.214-.097-.012-.124.005-.124.06-.174.08-.062.09-.05.148-.01.022-.007.039-.013.027-.035-.01-.073-.061-.107-.045-.247-.022-.057-.061-.129-.05-.174.01-.045.028-.069.056-.079.029-.012.045.006.057.022.028.034.05.135.05.135.006.118.04.26.152.18.067-.062.084-.242.214-.203l.096.085c.084-.073.084-.073.14-.107 0 0-.08-.073-.012-.135.045-.039.108-.067.208-.175.276-.292.422-.42.714-.657a6.811 6.811 0 011.699-.939c.146-.174.28-.286.585-.304.377-.606 1.085-1.136 1.248-1.22.134-.23.19-.208.365-.247.135-.107.175-.107.23-.214.063-.23-.112-.86.383-.877.112-.146.078-.112.196-.248a2.19 2.19 0 01-.118-.5c-.005-.016-.196-.157-.13-.332a2.33 2.33 0 01-.268-.432.202.202 0 01-.063-.012c-.022-.005-.055-.005-.09-.005-.078.196-.163.208-.303.253-.26.512-.35.731-1.046 1.142-.28.298-.382.64-.382.634a.46.46 0 00-.012.321c-.045.107-.027.124-.027.124.01.045.056.106.106.112.079.023.169.023.158.118-.011.113-.163.09-.237.073-.275-.05-.185-.23-.365-.174-.141.085-.196.348-.416.31-.028-.023-.017-.074.006-.119.028-.06.084-.118.056-.14-.146.04-.433.123-.433.123-.135.04-.281-.039-.147-.124.063-.022.153-.05.265-.118 0 0 .062-.072-.057-.039a1.144 1.144 0 01-.416.045s-.257-.039-.292-.056c-.028-.022-.061-.107.017-.1a2.71 2.71 0 00.563-.068c.095-.035.28-.14.382-.186 0 0 .113-.157.18-.19.107-.114.19-.18.28-.299.09-.18.192-.46.5-.906a4.16 4.16 0 01.535-.646s.062-.338.343-.573c.063-.14.157-.31.259-.462a1.7 1.7 0 00.106-.168c.09-.13.186-.377.518-.41 0 0 .147-.102.197-.175.084-.073.074-.186.14-.259-.106-.106-.365-.309-.382-.573a.85.85 0 01.265-.692c.196-.185.398-.275.646-.258.309.055.366.157.455.258.09.101.13.04.163.146.259.073.248.045.237.236.045.057.106.108.1.214.085-.175.108-.208.344-.399.062-.157.1-.315.15-.478.052-.146.114-.298.154-.41-.04-.326.06-.377.196-.664-.022-.039-.016-.05-.006-.112.057-.192.136-.433.186-.596 0 0 .017-.063.085-.063.06-.202.157-.579.179-.663.062-.208.029-.287-.01-.41-.012-.04-.006-.09-.03-.136a5.483 5.483 0 01-.19-.41c-.028-.073-.08-.354-.08-.354-.004-.062-.004-.09-.004-.09z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.363 7.467c-.024-.078-.024-.078-.024-.144a1.933 1.933 0 011.844-2.014 1.94 1.94 0 012.014 1.844 1.927 1.927 0 01-1.834 2.014c-.054.008-.124 0-.202 0-.032.008-.078.008-.112.044-.112.168.28.146-.01.878 0 0 0 .078-.024.156-.024.28-.158 1.124-.192 1.586.058.08.08.1.058.26-.024.212-.102.73-.18 1.068-.08.28-.192.348-.294.404-.146.596-.19 1.09-.562 1.81-.044.552-.09.698-.212.968-.034.798.022.92-.562 2.202-.16.598-.034 1.014.1 1.642.136.642.552.922.596 1.586.102 1.542.034 2.61-.326 3.814l.27.696c.36.168 1.236.652.72 1.35.686.38 1.73.788 2.562 1.562.35.294.698.63 1.024 1 .632.114.552.158 1.012.462 1.35.876 3.498 2.608 4.746 3.812.224.134.294.224.472.326.022.046.034.068.022.078-.054.146-.054.146-.122.282.078.08.19.146.268.214.08.01.08-.012.192-.034.158.146.36.27.428.27.212-.044.168-.01.37-.202.058-.068.168 0 .168 0 .082-.078.226-.236.428-.35.158-.09.462-.09.462-.09.102.012.078.102.056.146-.114.046-.36.114-.494.216-.304.28-.552.706-.552.706.598-.066.968.09 1.438.046.272-.01.474.012.754-.18 0 0 .282-.192.53-.282.236-.1.46-.032.662.126.136.168.236.168 0 .392-.09.09-.202.192-.36.338-.268.248-.628.584-1 .866-.382.28-.798.516-1.056.63-.676.46-.518.348-1.046.788-.058.044-.248.156-.326.212-.214.124-.27.012-.394-.236 0 0-.056-.09-.158-.282-.102-.212-.18-.46-.146-.46-.124-.012-.662-.686-.662-.82-.126-.024-.608-.518-.62-.62l-.428-.36c-.506.09-.618-.224-1.922-1.214-.158-.012-.394-.102-.72-.348-.596-.506-2.014-1.63-2.248-1.766-.26-.134-.562-.268-.766-.428-.292-.044-.436-.1-.596-.134-.158-.044-.28-.114-.652-.158-.606-.09-1.236-.36-1.822-.674-.28-.146-.528-.214-.764-.338-.54-.248-1.012-.472-1.372-.562-.136-.012-.798-.236-1.136-.45-.122-.068-.19-.122-.268-.146-.18-.044-.306.012-.384.044-.46.216-.876.406-1.272.62-.358.18-.696.372-1.056.572-.314.17-.686.338-1.068.508 0 0-1.068.506-1.664.696-.518.394-1.574 1.092-2.214 1.43-.316.146-.934.504-1.216.584-.158.122-.742.516-1.192.842-.36.248-.618.462-.618.462-.214.168-.204.258-.562.09a2.983 2.983 0 00-.258.192c-.282.19-.294.146-.406.134-.202.158-.226.078-.394.258-.122.17 0 .124-.236.214-.056.012-.078.078-.114.112-.188.146-.2.586-.65.608-.27.178-.214.406-.394.382 0 .204-.36.46-.428.46-.584.192-.608-.236-1.292.07-.09.032-.226.144-.394.168-.304.044-.664-.012-.888-.204-.338-.282-.652-.796-.652-.796-.102-.26-.034-.416.326-.664.146-.09.168-.158.416-.168.122-.048.09.02.302-.048.126-.032.126-.01.384-.01.056-.034.134-.044.248-.09.2-.068.392-.124.392-.124s.056-.046.248-.022c.156-.068.338-.158.428-.192-.024-.248.01-.248.122-.348.16-.124.18-.1.294-.022.044-.012.078-.024.054-.068-.02-.146-.122-.214-.09-.494-.044-.114-.122-.258-.098-.348.02-.09.054-.138.11-.158.058-.024.09.012.114.044.056.068.102.27.102.27.01.236.078.518.302.36.134-.124.168-.484.428-.406l.192.17c.168-.146.168-.146.28-.214 0 0-.158-.146-.024-.27.09-.078.216-.134.416-.35.552-.584.844-.84 1.428-1.314a13.622 13.622 0 013.398-1.878c.292-.348.562-.572 1.17-.608.754-1.212 2.17-2.272 2.496-2.44.268-.46.382-.416.73-.494.27-.214.35-.214.46-.428.126-.46-.224-1.72.766-1.754.224-.292.156-.224.392-.496a4.382 4.382 0 01-.236-1c-.01-.032-.392-.314-.258-.664-.158-.2-.46-.652-.538-.864a.403.403 0 01-.126-.024c-.044-.01-.11-.01-.18-.01-.156.392-.326.416-.606.506-.518 1.024-.698 1.462-2.092 2.284-.56.596-.764 1.28-.764 1.268-.102.204-.078.486-.024.642-.09.214-.054.248-.054.248.022.09.112.212.212.224.158.046.338.046.316.236-.022.226-.326.18-.474.146-.55-.1-.37-.46-.73-.348-.282.17-.392.696-.832.618-.056-.044-.034-.146.012-.236.056-.122.168-.236.112-.282-.292.08-.866.248-.866.248-.27.08-.562-.078-.294-.248.126-.044.306-.1.53-.236 0 0 .124-.144-.114-.078a2.288 2.288 0 01-.832.09s-.514-.078-.584-.112c-.056-.044-.122-.214.034-.202.214.012.732-.046 1.126-.134.19-.07.562-.282.764-.372 0 0 .226-.314.36-.382.214-.226.382-.36.562-.596.18-.36.382-.922 1-1.812.282-.404.63-.876 1.068-1.292 0 0 .124-.676.686-1.146a6.53 6.53 0 01.518-.924 3.4 3.4 0 00.212-.336c.182-.26.372-.754 1.036-.822 0 0 .294-.202.394-.348.168-.146.148-.372.282-.518-.214-.212-.732-.618-.766-1.146-.032-.586.168-1.036.53-1.384.392-.37.796-.55 1.292-.516.618.11.732.314.91.516.18.202.26.08.326.292.518.146.496.09.474.472.09.114.212.216.202.428.168-.35.214-.416.686-.798.124-.314.202-.63.302-.956.102-.292.226-.596.306-.82-.08-.652.122-.754.392-1.328-.044-.078-.032-.102-.012-.224.114-.384.272-.866.372-1.192 0 0 .034-.126.17-.126.122-.404.314-1.158.358-1.326.124-.416.058-.574-.02-.82-.024-.08-.012-.18-.058-.272-.134-.246-.28-.584-.382-.82-.056-.146-.158-.708-.158-.708-.01-.124-.01-.18-.01-.18z",
    clipRule: "evenodd"
  }))
};
var Jordan = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4i,
    fill: "none"
  }));
});
var compPaths$4h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M11.27 5.97H4.32v13.883h13.863V12.9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M19.002 3.425s.833-.34 1.55.377c.717.717.377 1.55.377 1.55l-8.31 8.306a.994.994 0 01-.398.243l-2.606.835.835-2.606a.994.994 0 01.244-.399l8.308-8.306z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M12.601 13.693s.34-.834-.376-1.55c-.717-.717-1.55-.378-1.55-.378"
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(6.93142 0 0 6.94133 11.251 12.911)",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React__default.createElement("stop", {
    stopColor: "#1390DD"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  })))),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M11.27 5.97H4.32v13.883h13.863V12.9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M19.002 3.425s.833-.34 1.55.377c.717.717.377 1.55.377 1.55l-8.31 8.306a.994.994 0 01-.398.243l-2.606.835.835-2.606a.994.994 0 01.244-.399l8.308-8.306z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M12.601 13.693s.34-.834-.376-1.55c-.717-.717-1.55-.378-1.55-.378"
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(6.93142 0 0 6.94133 11.251 12.911)",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React__default.createElement("stop", {
    stopColor: "#1390DD"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  })))),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3.96",
    d: "M21.54 12.94H7.64v27.765h27.726V26.801"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M37.005 7.85s1.666-.679 3.1.755c1.433 1.433.752 3.1.752 3.1L24.24 28.315c-.223.224-.497.39-.798.487l-5.212 1.67 1.67-5.212c.096-.301.264-.575.487-.798L37.005 7.851z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M24.203 28.385s.68-1.666-.753-3.1c-1.434-1.433-3.1-.754-3.1-.754"
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(13.8628 0 0 13.8827 21.503 26.823)",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React__default.createElement("stop", {
    stopColor: "#1390DD"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  }))))
};
var NBY = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4h,
    fill: "none"
  }));
});
var compPaths$4g = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
      clipRule: "evenodd"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
      clipRule: "evenodd"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M42 17.438L15.672 28.606C13.48 29.536 11.636 30 10.15 30c-1.672 0-2.89-.59-3.638-1.768-.97-1.518-.546-3.964 1.118-6.544.988-1.508 2.244-2.892 3.468-4.216-.288.468-2.83 4.698-.05 6.69.55.4 1.332.596 2.294.596.772 0 1.658-.126 2.632-.38L42 17.438z",
      clipRule: "evenodd"
    })
  })
};
var NikeApp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon, __spreadValues({}, Object.assign({}, props, {
    paths: compPaths$4g,
    fill: "none"
  })));
});
NikeApp.displayName = "[Deprecated] NikeApp";
var compPaths$4f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M42 17.438L15.672 28.606C13.48 29.536 11.636 30 10.15 30c-1.672 0-2.89-.59-3.638-1.768-.97-1.518-.546-3.964 1.118-6.544.988-1.508 2.244-2.892 3.468-4.216-.288.468-2.83 4.698-.05 6.69.55.4 1.332.596 2.294.596.772 0 1.658-.126 2.632-.38L42 17.438z",
    clipRule: "evenodd"
  }))
};
var NikeSwoosh = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4f,
    fill: "none"
  }));
});
var compPaths$4e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.196 12.105l2.442 1.313c.66.36 1.31.758 1.815 1.18.036.022.06.048.084.071.457.398.782.83.854 1.323a.89.89 0 01-.18.686c-.156.218-.505.495-1.214.567-.194.023-.867.072-1.36.023-.192-.01-.373-.035-.529-.048a9.552 9.552 0 01-.77-.107l.008.185c.007.523-.088.99-.344 1.343a.906.906 0 01-.613.348c-.265.037-.71-.012-1.262-.456-.145-.12-.662-.554-.975-.939-.426-.503-.684-.828-.79-.991l-.027-.045c-.397.458-.83.782-1.323.855a.895.895 0 01-.686-.18c-.217-.157-.493-.506-.565-1.216a7.688 7.688 0 01-.024-1.36c.072-.723.12-1.155.156-1.312.036-.013.073-.013.108-.013.012.098.06.796.157 1.024.216.505.48.783.793.854.554.109 1.239-.444 1.9-1.059l.072-.07c.322-.321 1.556-1.547 1.924-1.916 0 0 0 .013.013.013l.018.012.018.012-1.31 2.455c-.301.552-.619 1.095-.967 1.553l-.213.265c.072.06.601.516.83.613.517.206.902.229 1.167.049.438-.292.55-1.078.592-1.915l.009-.18v-2.816h.06l.817 2.647c.205.723.386 1.457.445 2.118l.004.013c.092-.013.79-.06 1.02-.157.504-.216.78-.481.852-.794.109-.553-.444-1.24-1.058-1.902l-.672-.672c-.355-.355-.775-.775-1.064-1.066l-.248-.248c0-.011.013-.011.013-.023.011-.012.023-.024.023-.037zm4.474-5.319s.012.011.036.024c.204.168.468.518.541 1.204.024.192.072.866.024 1.36-.07.704-.118 1.133-.154 1.3.596-.035 1.12.05 1.513.336.012.013.024.013.036.025.18.131.288.337.325.577.035.265-.012.71-.458 1.263-.12.145-.553.663-.938.976-.553.469-.889.734-1.034.818-.035-.023-.06-.048-.084-.072.06-.073.517-.603.613-.83.205-.518.23-.904.048-1.168-.313-.47-1.19-.566-2.092-.602h-2.813c0-.012 0-.036-.013-.06l2.659-.806c.72-.206 1.454-.386 2.115-.445l.01-.003.002.014c-.012-.095-.06-.793-.156-1.022-.217-.506-.481-.795-.794-.856-.553-.12-1.238.434-1.9 1.048-.06.06-.552.554-1.044 1.045l-.94.94c-.012-.01-.012-.023-.024-.023l-.018-.013-.018-.011 1.298-2.443c.362-.662.746-1.313 1.18-1.818.023-.036.048-.06.072-.085.396-.457.829-.781 1.322-.854a.895.895 0 01.686.181zM7.434 9.337c.037.025.06.048.084.072-.06.073-.517.603-.613.831-.204.518-.229.903-.048 1.167.292.439 1.077.552 1.913.595l.18.007h2.813c0 .008 0 .021.004.037l.008.024-2.657.818c-.601.17-1.211.324-1.78.405l-.337.04h-.108c-.601.036-1.142-.048-1.54-.337a.86.86 0 01-.348-.601c-.024-.265.024-.71.457-1.264l.107-.127c.184-.217.523-.598.831-.848.541-.458.89-.734 1.034-.82zm5.436-3.863c.144.12.66.553.973.938.47.554.734.891.819 1.036-.024.036-.049.06-.073.085-.072-.062-.6-.518-.83-.615-.517-.204-.901-.229-1.166-.048-.437.292-.55 1.077-.593 1.913l-.008.182v2.804l-.036.001-.036.01-.806-2.659c-.17-.603-.324-1.212-.406-1.781l-.039-.338v.013c-.096.012-.793.06-1.022.156-.505.216-.794.481-.854.794-.108.553.445 1.24 1.059 1.902l.602.603 1.134 1.136.248.246-.012.012-.012.02-.012.017-2.442-1.312c-.66-.362-1.31-.746-1.815-1.18a.468.468 0 01-.084-.072c-.458-.398-.783-.83-.854-1.323a.898.898 0 01.168-.674c.156-.217.504-.494 1.215-.566a7.676 7.676 0 011.359-.024c.721.072 1.154.12 1.31.157v-.013c-.035-.602.048-1.144.337-1.54a.906.906 0 01.613-.349c.277-.025.71.024 1.263.469z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.252 12.136l3.14 1.687c.849.465 1.684.976 2.333 1.517.047.03.077.062.108.092.588.512 1.006 1.068 1.098 1.702.047.31-.03.62-.232.882-.2.28-.649.636-1.56.728-.25.03-1.114.093-1.748.03-.247-.014-.48-.045-.68-.062-.526-.06-.851-.107-.99-.138l.01.239c.009.672-.114 1.272-.444 1.727a1.165 1.165 0 01-.787.447c-.34.047-.913-.015-1.623-.587-.186-.154-.851-.712-1.253-1.207-.549-.647-.88-1.064-1.017-1.274l-.034-.058c-.51.59-1.067 1.006-1.7 1.1-.31.046-.62-.032-.883-.232-.278-.202-.633-.65-.726-1.564-.03-.247-.093-1.113-.03-1.748.092-.929.154-1.486.2-1.687.046-.016.093-.016.139-.016.015.125.078 1.022.201 1.316.278.65.618 1.006 1.02 1.098.712.14 1.593-.57 2.444-1.362l.09-.09c.415-.412 2.002-1.99 2.475-2.463 0 0 0 .017.017.017l.023.015.023.016-1.685 3.156c-.387.709-.795 1.407-1.242 1.997l-.274.34c.093.077.773.664 1.067.789.665.264 1.16.294 1.5.062.563-.375.708-1.386.762-2.461l.01-.233v-3.62h.078l1.05 3.404c.265.929.496 1.872.573 2.723l.005.017c.119-.017 1.016-.077 1.31-.202.65-.278 1.005-.619 1.097-1.021.14-.712-.571-1.595-1.36-2.446l-.865-.864-1.368-1.37-.319-.32c0-.014.017-.014.017-.03.014-.015.03-.03.03-.046zm5.751-6.839s.016.015.047.03c.263.217.603.666.696 1.548.03.247.093 1.114.03 1.749-.09.906-.15 1.458-.198 1.671.767-.044 1.44.066 1.945.433.016.016.032.016.047.032.232.169.371.433.418.742.046.34-.016.912-.588 1.624-.155.186-.712.852-1.206 1.254-.712.604-1.144.944-1.33 1.052-.045-.03-.076-.062-.108-.092.077-.094.665-.775.789-1.068.262-.665.294-1.162.06-1.501-.401-.604-1.53-.727-2.688-.774h-3.618c0-.016 0-.046-.016-.078l3.418-1.036c.926-.264 1.87-.495 2.72-.572l.013-.004.003.018c-.016-.122-.078-1.02-.202-1.314-.278-.65-.618-1.022-1.02-1.1-.712-.154-1.592.558-2.443 1.347-.078.078-.71.712-1.343 1.344l-1.207 1.209c-.017-.015-.017-.03-.031-.03l-.024-.017-.023-.014 1.67-3.14c.463-.853.958-1.69 1.515-2.338.03-.047.062-.077.093-.11.51-.588 1.066-1.004 1.7-1.098.31-.046.619.032.881.233zM6.13 8.577c.046.032.076.062.108.092-.077.094-.665.775-.789 1.07-.263.664-.294 1.16-.061 1.5.374.563 1.384.709 2.459.764l.23.01h3.618c0 .009 0 .027.005.047l.01.03-3.416 1.053c-.772.218-1.557.416-2.29.52l-.431.051h-.14c-.772.047-1.468-.061-1.978-.433-.247-.17-.402-.448-.45-.773-.029-.34.032-.913.589-1.625l.137-.163c.237-.278.673-.768 1.069-1.09.696-.589 1.145-.944 1.33-1.053zm6.988-4.967c.185.155.85.712 1.252 1.206.604.713.943 1.146 1.052 1.332-.03.047-.062.077-.093.11-.093-.08-.773-.667-1.067-.792-.665-.261-1.16-.294-1.5-.06-.562.375-.708 1.384-.762 2.46l-.01.232v3.606l-.046.001-.047.013L10.86 8.3c-.22-.776-.416-1.56-.522-2.291l-.05-.435v.017c-.124.016-1.02.077-1.314.2-.65.279-1.021.62-1.098 1.022-.14.711.572 1.595 1.36 2.445l.774.776 1.46 1.46.318.317-.016.015-.015.024-.016.023-3.14-1.686c-.849-.465-1.684-.96-2.333-1.518a.603.603 0 01-.108-.092c-.588-.511-1.006-1.067-1.098-1.702-.047-.31.03-.618.216-.866.201-.279.649-.635 1.562-.727.247-.032 1.113-.094 1.747-.032.928.093 1.485.155 1.685.202v-.016c-.046-.775.061-1.47.433-1.98a1.16 1.16 0 01.789-.448c.355-.033.912.03 1.623.602z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24.504 24.272l6.278 3.374c1.7.929 3.37 1.951 4.668 3.034.094.06.154.125.216.185 1.176 1.022 2.012 2.136 2.196 3.403.094.621-.06 1.24-.463 1.764-.4.559-1.298 1.272-3.122 1.457-.497.06-2.227.184-3.495.06-.494-.03-.96-.092-1.36-.125-1.052-.12-1.702-.214-1.98-.276l.019.477c.019 1.344-.226 2.544-.886 3.454-.37.494-.926.804-1.574.895-.682.094-1.827-.031-3.247-1.173-.372-.31-1.702-1.426-2.506-2.415-1.097-1.293-1.76-2.129-2.033-2.549l-.07-.115c-1.02 1.179-2.133 2.011-3.4 2.199a2.303 2.303 0 01-1.764-.464c-.557-.403-1.267-1.3-1.452-3.127-.063-.494-.187-2.227-.063-3.497.185-1.857.31-2.97.401-3.374.094-.031.188-.031.279-.031.03.25.156 2.045.403 2.633.554 1.298 1.236 2.01 2.04 2.196 1.423.278 3.185-1.143 4.886-2.724l.183-.183c.828-.823 4.003-3.977 4.948-4.925 0 0 0 .034.034.034l.046.031.045.032-3.37 6.311c-.772 1.419-1.588 2.816-2.483 3.994l-.547.682c.184.153 1.545 1.327 2.133 1.576 1.33.528 2.318.588 3 .125 1.126-.751 1.416-2.772 1.524-4.922l.022-.466v-7.24h.153l2.103 6.808c.528 1.858.99 3.744 1.144 5.446a.197.197 0 01.01.033c.238-.033 2.033-.153 2.62-.403 1.3-.557 2.01-1.238 2.194-2.042.279-1.423-1.142-3.19-2.721-4.891l-1.728-1.728-2.736-2.741-.639-.639c0-.028.034-.028.034-.06.029-.03.06-.06.06-.093zm11.503-13.678s.031.03.094.06c.525.435 1.205 1.332 1.392 3.096.06.495.185 2.227.06 3.497-.18 1.812-.303 2.916-.396 3.343 1.533-.088 2.88.132 3.89.867.031.03.063.03.094.062.463.339.741.867.835 1.486.091.679-.031 1.824-1.176 3.247-.31.372-1.423 1.704-2.412 2.508-1.423 1.207-2.287 1.889-2.66 2.105-.09-.06-.153-.125-.215-.185.153-.187 1.33-1.55 1.577-2.136.525-1.33.588-2.323.122-3.003-.804-1.207-3.06-1.454-5.378-1.547h-7.236c0-.032 0-.092-.032-.157l6.836-2.07c1.852-.529 3.739-.992 5.44-1.145l.027-.008.005.036c-.032-.244-.156-2.04-.404-2.628-.556-1.3-1.236-2.044-2.04-2.2-1.423-.308-3.184 1.116-4.886 2.695-.156.156-1.42 1.423-2.686 2.688l-2.414 2.417c-.034-.03-.034-.06-.062-.06l-.048-.034-.046-.029 3.338-6.28c.93-1.705 1.918-3.378 3.032-4.676.062-.093.124-.153.187-.218 1.017-1.176 2.131-2.01 3.4-2.196a2.291 2.291 0 011.762.465zm-23.748 6.56c.094.064.154.124.216.184-.153.188-1.33 1.55-1.576 2.139-.526 1.33-.588 2.32-.123 3 .749 1.128 2.767 1.418 4.918 1.529l.46.019h7.236c0 .019 0 .055.01.096l.022.06-6.833 2.104c-1.546.437-3.115.833-4.58 1.042l-.863.1h-.279c-1.545.095-2.937-.122-3.957-.866-.495-.34-.804-.895-.898-1.545-.06-.682.063-1.826 1.176-3.25l.274-.326c.475-.557 1.346-1.536 2.138-2.182 1.392-1.176 2.29-1.886 2.66-2.104zM26.237 7.22c.37.31 1.699 1.423 2.503 2.412 1.207 1.426 1.886 2.292 2.105 2.664-.063.094-.125.154-.187.218-.185-.158-1.546-1.332-2.134-1.581-1.33-.523-2.318-.588-3-.123-1.123.752-1.416 2.77-1.524 4.92l-.022.466v7.212l-.09.002-.094.027-2.072-6.838c-.439-1.55-.832-3.117-1.044-4.581l-.1-.87v.034c-.247.032-2.04.154-2.628.401-1.299.557-2.043 1.239-2.196 2.043-.279 1.423 1.144 3.19 2.721 4.89l1.548 1.551 2.919 2.92.636.635-.031.03-.032.049-.03.045-6.28-3.372c-1.698-.93-3.369-1.92-4.667-3.036a1.205 1.205 0 01-.216-.184c-1.176-1.023-2.011-2.134-2.196-3.404a2.309 2.309 0 01.432-1.732c.403-.557 1.298-1.27 3.124-1.455.495-.062 2.225-.187 3.495-.062 1.855.185 2.969.31 3.37.403v-.031c-.092-1.55.122-2.943.866-3.963.37-.494.926-.804 1.577-.895.71-.065 1.824.06 3.247 1.205z",
    clipRule: "evenodd"
  }))
};
var Sustainability = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4e,
    fill: "none"
  }));
});
var compPaths$4d = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
      clipRule: "evenodd"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
      clipRule: "evenodd"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "3",
      d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
      clipRule: "evenodd"
    })
  })
};
var Activity = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon, __spreadValues({}, Object.assign({}, props, {
    paths: compPaths$4d,
    fill: "none"
  })));
});
Activity.displayName = "[Deprecated] Activity";
var compPaths$4c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var ActivityFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4c,
    fill: "none"
  }));
});
var compPaths$4b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var ActivityStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4b,
    fill: "none"
  }));
});
var compPaths$4a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 15V7.5M15 11.25h7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 15V7.5M15 11.25h7.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 30V15M30 22.5h15"
  }))
};
var AddFriends = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4a,
    fill: "none"
  }));
});
var compPaths$49 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 16.5v-9A2.25 2.25 0 0018 5.25H6A2.25 2.25 0 003.75 7.5v9A2.25 2.25 0 006 18.75h6m-8.25-9h16.5m-3 5.25v7.5M21 18.75h-7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 16.5v-9A2.25 2.25 0 0018 5.25H6A2.25 2.25 0 003.75 7.5v9A2.25 2.25 0 006 18.75h6m-8.25-9h16.5m-3 5.25v7.5M21 18.75h-7.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 33V15a4.5 4.5 0 00-4.5-4.5H12A4.5 4.5 0 007.5 15v18c0 2.484 2.016 4.5 4.5 4.5h12m-16.5-18h33m-6 10.5v15m7.5-7.5H27"
  }))
};
var AddPayment = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$49,
    fill: "none"
  }));
});
var compPaths$48 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 17v-1.5m0-1.5V7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M11.99 15V6m0 12v-1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M23.98 30V12m0 24v-3"
  }))
};
var Alert = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$48,
    fill: "none"
  }));
});
var compPaths$47 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 19.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25zM12 17v-1.5m0-1.5V7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M11.99 15V6m0 12v-1.5m.01 5.25c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M23.98 30V12m0 24v-3M24 43.5c10.77 0 19.5-8.73 19.5-19.5S34.77 4.5 24 4.5 4.5 13.23 4.5 24 13.23 43.5 24 43.5z"
  }))
};
var AlertCircle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$47,
    fill: "none"
  }));
});
var compPaths$46 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm.75 13h-1.5v-1.5h1.5V17zm0-3h-1.5V7h1.5v7z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm.74 16.5h-1.5v-1.5h1.5V18zm0-3h-1.5V6h1.5v9z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm1.48 33h-3v-3h3v3zm0-6h-3V12h3v18z"
  }))
};
var AlertCircleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$46,
    fill: "none"
  }));
});
var compPaths$45 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var Analytics = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$45,
    fill: "none"
  }));
});
var compPaths$44 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var AnalyticsFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$44,
    fill: "none"
  }));
});
var compPaths$43 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var AnalyticsStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$43,
    fill: "none"
  }));
});
var compPaths$42 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.389 10.5l2.61 1.5 2.613-1.5M12 12v2.5m0 2.5v2.814m6.75-3.897L16.308 14.5M5.25 15.917L7.692 14.5M12 7.314V4.5M5.25 8.397l2.442 1.417M18.75 8.397l-2.442 1.417m-6.875 8.518L12 19.814l2.567-1.482m0-12.35L12 4.5 9.433 5.982m6.75 11.418l2.567-1.483v-2.964m0-1.592V8.397l-2.567-1.482M7.817 17.4L5.25 15.916v-2.964m0-1.591V8.397l2.567-1.482"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.389 10.5l2.61 1.5 2.613-1.5M12 12v2.5m0 2.5v2.814m6.75-3.897L16.308 14.5M5.25 15.917L7.692 14.5M12 7.314V4.5M5.25 8.397l2.442 1.417M18.75 8.397l-2.442 1.417m-6.875 8.518L12 19.814l2.567-1.482m0-12.35L12 4.5 9.433 5.982m6.75 11.418l2.567-1.483v-2.964m0-1.592V8.397l-2.567-1.482M7.817 17.4L5.25 15.916v-2.964m0-1.591V8.397l2.567-1.482"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.777 21L24 24l5.224-3M24 24v5m0 5v5.628m13.5-7.794L32.616 29M10.5 31.834L15.384 29M24 14.629V9.001m-13.5 7.794l4.884 2.834M37.5 16.795l-4.884 2.834m-13.75 17.035L24 39.628l5.134-2.964m0-24.699L24 9l-5.134 2.964m13.5 22.835l5.134-2.964v-5.928m0-3.184v-5.928l-5.134-2.964M15.634 34.799L10.5 31.835v-5.928m0-3.184v-5.928l5.134-2.964"
  }))
};
var AR = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$42,
    fill: "none"
  }));
});
var compPaths$41 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5V12A4.5 4.5 0 0121 7.5h6a4.5 4.5 0 014.5 4.5 4.5 4.5 0 01-4.5 4.5H7.5V33a7.5 7.5 0 007.5 7.5h18a7.5 7.5 0 007.5-7.5V16.5H35"
  }))
};
var Bag = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$41,
    fill: "none"
  }));
});
var compPaths$40 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 6c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V6zm7.083 1.5c.258-.443.417-.951.417-1.5 0-1.654-1.346-3-3-3h-3c-1.654 0-3 1.346-3 3v1.5H3v9C3 18.981 5.019 21 7.5 21h9c2.481 0 4.5-2.019 4.5-4.5v-9h-4.917z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 6c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V6zm7.083 1.5c.258-.443.417-.951.417-1.5 0-1.654-1.346-3-3-3h-3c-1.654 0-3 1.346-3 3v1.5H3v9C3 18.981 5.019 21 7.5 21h9c2.481 0 4.5-2.019 4.5-4.5v-9h-4.917z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 12c0-1.654 1.346-3 3-3h6c1.654 0 3 1.346 3 3s-1.346 3-3 3h-9v-3zm14.166 3c.516-.886.834-1.902.834-3 0-3.308-2.692-6-6-6h-6c-3.308 0-6 2.692-6 6v3H6v18c0 4.962 4.038 9 9 9h18c4.962 0 9-4.038 9-9V15h-9.834z",
    clipRule: "evenodd"
  }))
};
var BagFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$40,
    fill: "none"
  }));
});
var compPaths$3$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M16.5 16.5V12A4.5 4.5 0 0121 7.5h6a4.5 4.5 0 014.5 4.5 4.5 4.5 0 01-4.5 4.5H7.5V33a7.5 7.5 0 007.5 7.5h18a7.5 7.5 0 007.5-7.5V16.5H35"
  }))
};
var BagStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3$,
    fill: "none"
  }));
});
var compPaths$3_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 7.5h18a4.5 4.5 0 014.5 4.5v26.998c0 1.336-1.616 2.004-2.56 1.06L24 29.118l-10.94 10.94c-.944.944-2.56.276-2.56-1.06V12A4.5 4.5 0 0115 7.5z",
    clipRule: "evenodd"
  }))
};
var Bookmark = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3_,
    fill: "none"
  }));
});
var compPaths$3Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.999 21c-.39 0-.771-.154-1.06-.44L12 15.62l-4.939 4.94a1.497 1.497 0 01-1.635.325 1.495 1.495 0 01-.926-1.387V6c0-1.654 1.346-3 3-3h9c1.654 0 3 1.346 3 3v13.498A1.505 1.505 0 0117.999 21z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.999 21c-.39 0-.771-.154-1.06-.44L12 15.62l-4.939 4.94a1.497 1.497 0 01-1.635.325 1.495 1.495 0 01-.926-1.387V6c0-1.654 1.346-3 3-3h9c1.654 0 3 1.346 3 3v13.498A1.505 1.505 0 0117.999 21z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M35.998 41.999c-.78 0-1.542-.306-2.12-.88L24 31.239l-9.878 9.88a2.995 2.995 0 01-3.27.65A2.99 2.99 0 019 38.997V11.999c0-3.308 2.692-6 6-6h18c3.308 0 6 2.692 6 6v26.998a2.99 2.99 0 01-1.852 2.772 3.01 3.01 0 01-1.15.23z",
    clipRule: "evenodd"
  }))
};
var BookmarkFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3Z,
    fill: "none"
  }));
});
var compPaths$3Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M15 7.5h18a4.5 4.5 0 014.5 4.5v26.998c0 1.336-1.616 2.004-2.56 1.06L24 29.118l-10.94 10.94c-.944.944-2.56.276-2.56-1.06V12A4.5 4.5 0 0115 7.5z",
    clipRule: "evenodd"
  }))
};
var BookmarkStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3Y,
    fill: "none"
  }));
});
var compPaths$3X = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      d: "M39 36.88L11.12 9 9 11.12l3.4 3.4C10.28 17.1 9 20.4 9 24c0 8.28 6.72 15 15 15 3.6 0 6.9-1.28 9.48-3.4l3.4 3.4L39 36.88zM24 36c-6.62 0-12-5.38-12-12 0-2.76.96-5.3 2.54-7.34l16.8 16.8C29.3 35.04 26.76 36 24 36zm0-24c6.62 0 12 5.38 12 12 0 1.66-.34 3.24-.96 4.68l2.24 2.24c1.08-2.08 1.7-4.42 1.7-6.92 0-8.28-6.72-15-15-15-2.5 0-4.86.62-6.92 1.7l2.24 2.24c1.46-.6 3.04-.94 4.7-.94z"
    })
  })
};
var BrightnessNone = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon, __spreadValues({}, Object.assign({}, props, {
    paths: compPaths$3X,
    fill: "none"
  })));
});
BrightnessNone.displayName = "[Deprecated] BrightnessNone";
var compPaths$3W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M8.25 3v4.5m7.5-4.5v4.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M8.25 3v4.5m7.5-4.5v4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V15a4.5 4.5 0 014.5-4.5h24a4.5 4.5 0 014.5 4.5v21a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 19.5h-33m9-13.5v9m15-9v9"
  }))
};
var Calendar = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3W,
    fill: "none"
  }));
});
var compPaths$3V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 13.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 6.75h2A2.25 2.25 0 0121.75 9v7.5A3.75 3.75 0 0118 20.25H6a3.75 3.75 0 01-3.75-3.75V9A2.25 2.25 0 014.5 6.75h9.75a1.5 1.5 0 100-3h-4.5a1.5 1.5 0 00-1.5 1.5V6M6 9.75H4.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 13.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 6.75h2A2.25 2.25 0 0121.75 9v7.5A3.75 3.75 0 0118 20.25H6a3.75 3.75 0 01-3.75-3.75V9A2.25 2.25 0 014.5 6.75h9.75a1.5 1.5 0 100-3h-4.5a1.5 1.5 0 00-1.5 1.5V6M6 9.75H4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 27a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M35 13.5h4a4.5 4.5 0 014.5 4.5v15a7.5 7.5 0 01-7.5 7.5H12A7.5 7.5 0 014.5 33V18A4.5 4.5 0 019 13.5h19.5a3 3 0 100-6h-9a3 3 0 00-3 3V12M12 19.5H9"
  }))
};
var Camera = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3V,
    fill: "none"
  }));
});
var compPaths$3U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 3.75h15A2.25 2.25 0 0123.25 6v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.468 13.293c-.747-.548-.177-1.646.025-1.973-.364.402-.728.803-1.011 1.24-.446.685-.637 1.436-.335 1.919.54.868 1.84.466 2.668.117l7.685-3.242-7.594 2.005c-.636.166-1.147.144-1.438-.066z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9A2.25 2.25 0 014.5 6.75H18A2.25 2.25 0 0120.25 9v7.5A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 3.75h15A2.25 2.25 0 0123.25 6v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.468 13.293c-.747-.548-.177-1.646.025-1.973-.364.402-.728.803-1.011 1.24-.446.685-.637 1.436-.335 1.919.54.868 1.84.466 2.668.117l7.685-3.242-7.594 2.005c-.636.166-1.147.144-1.438-.066z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9A2.25 2.25 0 014.5 6.75H18A2.25 2.25 0 0120.25 9v7.5A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 7.5h30c2.484 0 4.5 2.016 4.5 4.5v18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.936 26.586c-1.494-1.096-.354-3.292.05-3.946-.728.804-1.456 1.606-2.022 2.482-.892 1.368-1.274 2.87-.67 3.836 1.082 1.736 3.68.932 5.336.234L33 22.708l-15.188 4.01c-1.272.332-2.294.288-2.876-.132z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 37.5H9A4.502 4.502 0 014.5 33V18c0-2.484 2.016-4.5 4.5-4.5h27c2.484 0 4.5 2.016 4.5 4.5v15c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Cards = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3U,
    fill: "none"
  }));
});
var compPaths$3T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.5 11.5l3.75 3.75L17.5 8"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.03 11.69l4.753 4.754 9.186-9.188"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.06 23.382l9.507 9.506 18.372-18.376"
  }))
};
var Check = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3T,
    fill: "none"
  }));
});
var compPaths$3S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 10l-4 4-2-2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 19.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.712 9.663l-4.772 4.773-2.652-2.65"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.424 19.326l-9.544 9.546-5.304-5.302"
  }))
};
var CheckCircle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3S,
    fill: "none"
  }));
});
var compPaths$3R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm-1 11.06l-2.53-2.53 1.06-1.06L11 12.94l3.47-3.47 1.06 1.06L11 15.06z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm-1.06 14l-3.18-3.18 1.06-1.06 2.12 2.12 4.24-4.24 1.06 1.06-5.3 5.3z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm-2.12 28l-6.36-6.36 2.12-2.12 4.24 4.24 8.48-8.48 2.12 2.12L21.88 31z"
  }))
};
var CheckCircleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3R,
    fill: "none"
  }));
});
var compPaths$3Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6M30 25.5h6a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm15 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    clipRule: "evenodd"
  }))
};
var Club = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3Q,
    fill: "none"
  }));
});
var compPaths$3P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 21H1.5v-3c0-2.481 2.019-4.5 4.5-4.5h6c2.481 0 4.5 2.019 4.5 4.5v3H15",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 19.5V12h3c2.481 0 4.5 2.019 4.5 4.5v3H21M9 12a4.505 4.505 0 01-4.5-4.5C4.5 5.019 6.519 3 9 3s4.5 2.019 4.5 4.5S11.481 12 9 12zm9-1.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 21H1.5v-3c0-2.481 2.019-4.5 4.5-4.5h6c2.481 0 4.5 2.019 4.5 4.5v3H15",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 19.5V12h3c2.481 0 4.5 2.019 4.5 4.5v3H21M9 12a4.505 4.505 0 01-4.5-4.5C4.5 5.019 6.519 3 9 3s4.5 2.019 4.5 4.5S11.481 12 9 12zm9-1.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 42H3v-6c0-4.962 4.038-9 9-9h12c4.962 0 9 4.038 9 9v6h-3",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30 39V24h6c4.962 0 9 4.038 9 9v6h-3M18 24c-4.962 0-9-4.038-9-9s4.038-9 9-9 9 4.038 9 9-4.038 9-9 9zm18-3c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z",
    clipRule: "evenodd"
  }))
};
var ClubFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3P,
    fill: "none"
  }));
});
var compPaths$3O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6M30 25.5h6a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm15 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    clipRule: "evenodd"
  }))
};
var ClubStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3O,
    fill: "none"
  }));
});
var compPaths$3N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 21v-3c0-2.07 1.68-3.75 3.75-3.75h9c2.07 0 3.75 1.68 3.75 3.75v3m-12-14.25H19.5m-7.5 4.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 21v-3c0-2.07 1.68-3.75 3.75-3.75h9c2.07 0 3.75 1.68 3.75 3.75v3m-12-14.25H19.5m-7.5 4.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.5 42v-6c0-4.14 3.36-7.5 7.5-7.5h18c4.14 0 7.5 3.36 7.5 7.5v6m-24-28.5H39m-15 9a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
  }))
};
var Coach = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3N,
    fill: "none"
  }));
});
var compPaths$3M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 21v-6.75H3M14.25 3v6.75H21"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 21v-6.75H3M14.25 3v6.75H21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.5 42V28.5H6M28.5 6v13.5H42"
  }))
};
var Collapse = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3M,
    fill: "none"
  }));
});
var compPaths$3L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M32 34.5h4a4.5 4.5 0 004.5-4.5V12A4.5 4.5 0 0036 7.5H12A4.5 4.5 0 007.5 12v18a4.5 4.5 0 004.5 4.5h12a4.5 4.5 0 014.5 4.5v3"
  }))
};
var Comments = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3L,
    fill: "none"
  }));
});
var compPaths$3K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20 8.25H4.5m3.27 11.21l-3.71-3.71 3.71-3.71m8.46-7.5l3.71 3.71-3.71 3.71M4 15.75h15.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20 8.25H4.5m3.27 11.21l-3.71-3.71 3.71-3.71m8.46-7.5l3.71 3.71-3.71 3.71M4 15.75h15.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40 16.5H9m6.54 22.42L8.12 31.5l7.42-7.42m16.92-15l7.42 7.42-7.42 7.42M8 31.5h31"
  }))
};
var Compare = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3K,
    fill: "none"
  }));
});
var compPaths$3J = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M19.25 12c0 4-3.24 7.25-7.25 7.25S4.75 16 4.75 12 7.99 4.75 12 4.75 19.25 8 19.25 12zM12 8v8m4-4H8"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M21.75 12c0 5.39-4.36 9.75-9.75 9.75S2.25 17.39 2.25 12 6.61 2.25 12 2.25s9.75 4.36 9.75 9.75zM12 6v12m6-6H6"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "3",
      d: "M43.5 24c0 10.78-8.72 19.5-19.5 19.5S4.5 34.78 4.5 24 13.22 4.5 24 4.5 43.5 13.22 43.5 24zM24 12v24m12-12H12"
    })
  })
};
var CreateRule = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon, __spreadValues({}, Object.assign({}, props, {
    paths: compPaths$3J,
    fill: "none"
  })));
});
CreateRule.displayName = "[Deprecated] CreateRule";
var compPaths$3I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm4 8.75h-3.25V16h-1.5v-3.25H8v-1.5h3.25V8h1.5v3.25H16v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm6 11.25h-5.25V18h-1.5v-5.25H6v-1.5h5.25V6h1.5v5.25H18v1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm12 22.5H25.5V36h-3V25.5H12v-3h10.5V12h3v10.5H36v3z"
  }))
};
var CreateRuleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3I,
    fill: "none"
  }));
});
var compPaths$3H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M13.75 10v7m-3.5-7v7m-3.5-8.5V17c0 1.24 1.01 2.25 2.25 2.25h6c1.24 0 2.25-1.01 2.25-2.25V7.75h2.25m-10-3h3.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H4.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 7.5v12m-4.5-12v12M5.25 6v13.5c0 1.24 1.01 2.25 2.25 2.25h9c1.24 0 2.25-1.01 2.25-2.25V5.25h2.75m-2.75 0H21m-12-3h5.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 15v24m-9-24v24m-9-27v27c0 2.48 2.02 4.5 4.5 4.5h18c2.48 0 4.5-2.02 4.5-4.5V10.5H43m-5.5 0H42m-24-6h10.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H6"
  }))
};
var Delete = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3H,
    fill: "none"
  }));
});
var compPaths$3G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.51 20.25h9m-3-3h6c1.24 0 2.25-1.01 2.25-2.25V6c0-1.24-1.01-2.25-2.25-2.25h-15C3.27 3.75 2.26 4.76 2.26 6v9c0 1.24 1.01 2.25 2.25 2.25h5c1.24 0 2.25 1.01 2.25 2.25v.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.51 20.25h9m-3-3h6c1.24 0 2.25-1.01 2.25-2.25V6c0-1.24-1.01-2.25-2.25-2.25h-15C3.27 3.75 2.26 4.76 2.26 6v9c0 1.24 1.01 2.25 2.25 2.25h5c1.24 0 2.25 1.01 2.25 2.25v.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15.02 40.5h18m-6-6h12c2.48 0 4.5-2.02 4.5-4.5V12c0-2.48-2.02-4.5-4.5-4.5h-30c-2.48 0-4.5 2.02-4.5 4.5v18c0 2.48 2.02 4.5 4.5 4.5h10c2.48 0 4.5 2.02 4.5 4.5v1.5"
  }))
};
var Desktop = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3G,
    fill: "none"
  }));
});
var compPaths$3F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.102 19.102l-3.586 13.384 13.382-3.588 3.586-13.382-13.382 3.586z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }))
};
var Discover = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3F,
    fill: "none"
  }));
});
var compPaths$3E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.837 13.837l-5.02 1.345 1.346-5.02 5.019-1.344-1.345 5.019zM12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.837 13.837l-5.02 1.345 1.346-5.02 5.019-1.344-1.345 5.019zM12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.674 27.674l-10.038 2.69 2.69-10.038 10.038-2.69-2.69 10.038zM24 3C12.42 3 3 12.422 3 24c0 11.58 9.42 21 21 21s21-9.42 21-21c0-11.578-9.42-21-21-21z",
    clipRule: "evenodd"
  }))
};
var DiscoverFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3E,
    fill: "none"
  }));
});
var compPaths$3D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M19.102 19.102l-3.586 13.384 13.382-3.588 3.586-13.382-13.382 3.586z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }))
};
var DiscoverStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3D,
    fill: "none"
  }));
});
var compPaths$3C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.125 14.25A4.125 4.125 0 1012 10.125m2.25 4.125h2m-9 0h2.5m-2.25 0a3.75 3.75 0 010-7.5m8.212 10.97L12 21.432 8.288 17.72M12 20.75V10M6.75 7.5a5.25 5.25 0 019.094-3.576"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.125 14.25A4.125 4.125 0 1012 10.125m2.25 4.125h2m-9 0h2.5m-2.25 0a3.75 3.75 0 010-7.5m8.212 10.97L12 21.432 8.288 17.72M12 20.75V10M6.75 7.5a5.25 5.25 0 019.094-3.576"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M32.25 28.5A8.25 8.25 0 1024 20.25m4.5 8.25h4m-18 0h5m-4.5 0a7.5 7.5 0 010-15m16.424 21.94L24 42.864l-7.424-7.424M24 41.5V20"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5 3.036 0 5.77 1.288 7.688 3.348"
  }))
};
var Download = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3C,
    fill: "none"
  }));
});
var compPaths$3B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6.94 20.25H3.76v-3.18L16.77 4.06l3.18 3.18L6.94 20.25zm8.08-13.69l2.63 2.63"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6.94 20.25H3.76v-3.18L16.77 4.06l3.18 3.18L6.94 20.25zm8.08-13.69l2.63 2.63"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M13.88 40.5H7.52v-6.36L33.54 8.12l6.36 6.36L13.88 40.5zm16.16-27.38l5.26 5.26"
  }))
};
var Edit = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3B,
    fill: "none"
  }));
});
var compPaths$3A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 14.25a2.25 2.25 0 11.002-4.502A2.25 2.25 0 014.5 14.25zm7.5 0a2.25 2.25 0 11.002-4.502A2.25 2.25 0 0112 14.25zm7.5 0a2.25 2.25 0 11.002-4.502 2.25 2.25 0 01-.002 4.502z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 14.25a2.25 2.25 0 11.002-4.502A2.25 2.25 0 014.5 14.25zm7.5 0a2.25 2.25 0 11.002-4.502A2.25 2.25 0 0112 14.25zm7.5 0a2.25 2.25 0 11.002-4.502 2.25 2.25 0 01-.002 4.502z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 28.5A4.502 4.502 0 014.5 24c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5-2.016 4.5-4.5 4.5zm15 0a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5-2.016 4.5-4.5 4.5zm15 0a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Ellipsis = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3A,
    fill: "none"
  }));
});
var compPaths$3z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 19.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002zm0-7.5a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12zm0-7.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 19.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002zm0-7.5a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12zm0-7.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 39c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5zm0-15c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5zm0-15c0 2.484-2.016 4.5-4.5 4.5A4.502 4.502 0 0119.5 9c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var EllipsisVertical = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3z,
    fill: "none"
  }));
});
var compPaths$3y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13.5v6.75h6.75m9.75-9.75V3.75H13.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13.5v6.75h6.75m9.75-9.75V3.75H13.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 27v13.5H21M40.5 21V7.5H27"
  }))
};
var Expand = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3y,
    fill: "none"
  }));
});
var compPaths$3x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9m-6.75.5v5.89c0 .6-.24 1.17-.66 1.59l-4.68 4.68C3 17.83 4 20.25 6 20.25h12c2 0 3.01-2.42 1.59-3.84l-4.68-4.68c-.42-.42-.66-.99-.66-1.59V4M6.5 14.25h11.12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9m-6.75.5v5.89c0 .6-.24 1.17-.66 1.59l-4.68 4.68C3 17.83 4 20.25 6 20.25h12c2 0 3.01-2.42 1.59-3.84l-4.68-4.68c-.42-.42-.66-.99-.66-1.59V4M6.5 14.25h11.12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15 7.5h18m-13.501 1v11.78c0 1.2-.48 2.34-1.32 3.18l-9.36 9.36c-2.82 2.84-.82 7.68 3.18 7.68h24c4 0 6.02-4.84 3.18-7.68l-9.36-9.36a4.496 4.496 0 01-1.32-3.18V8M13 28.5h22.24"
  }))
};
var Experiments = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3x,
    fill: "none"
  }));
});
var compPaths$3w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.92 7.25h-5c-1.24 0-2.25 1.01-2.25 2.25V17c0 1.24 1.01 2.25 2.25 2.25h7.5c1.24 0 2.25-1.01 2.25-2.25v-4.5m2.5-2.5V4.75h-5.25m-2.25 7.5l7.5-7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 5.25H6c-1.24 0-2.25 1.01-2.25 2.25V18c0 1.24 1.01 2.25 2.25 2.25h10.5c1.24 0 2.25-1.01 2.25-2.25v-6m3-3V2.25H15m-3.75 10.5l10.5-10.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 10.5H12c-2.48 0-4.5 2.02-4.5 4.5v21c0 2.48 2.02 4.5 4.5 4.5h21c2.48 0 4.5-2.02 4.5-4.5V24m6-6V4.5H30m-7.5 21l21-21"
  }))
};
var ExternalLink = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3w,
    fill: "none"
  }));
});
var compPaths$3v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5"
  }))
};
var Favorite = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3v,
    fill: "none"
  }));
});
var compPaths$3u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5"
  }))
};
var FavoriteFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3u,
    fill: "none"
  }));
});
var compPaths$3t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5"
  }))
};
var FavoriteStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3t,
    fill: "none"
  }));
});
var compPaths$3s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 16.5h18m-18 9h15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 16.5h18m-18 9h15"
  }))
};
var Feed = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3s,
    fill: "none"
  }));
});
var compPaths$3r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 16.5h18m-18 9h15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M15 16.5h18m-18 9h15"
  }))
};
var FeedStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3r,
    fill: "none"
  }));
});
var compPaths$3q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 8v0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19 9.5h-9m-2 0H5m0 5h9m2 0h3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 13v0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 8.25H10m-5.25 0H3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 6v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3 15.75h10.75m5 0H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 13.5v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 16.5H20m-10.5 0H6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 12v0a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M6 31.5h21.5m10 0H42"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 27v0a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
    clipRule: "evenodd"
  }))
};
var Filter = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3q,
    fill: "none"
  }));
});
var compPaths$3p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.547",
    d: "M10.696 14.886a5.787 5.787 0 01-2.09.095 5.683 5.683 0 01-4.807-4.841 5.648 5.648 0 016.333-6.342 5.674 5.674 0 014.85 4.815 5.64 5.64 0 01-1.466 4.633 2.144 2.144 0 00.095 2.967l.99.99h1.735v1.734l1.301 1.302h2.603v-2.603l-4.286-4.286"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "1.5",
    d: "M8.75 10.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.547",
    d: "M10.696 14.886a5.787 5.787 0 01-2.09.095 5.683 5.683 0 01-4.807-4.841 5.648 5.648 0 016.333-6.342 5.674 5.674 0 014.85 4.815 5.64 5.64 0 01-1.466 4.633 2.144 2.144 0 00.095 2.967l.99.99h1.735v1.734l1.301 1.302h2.603v-2.603l-4.286-4.286"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "1.5",
    d: "M8.75 10.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3.094",
    d: "M21.393 29.771a11.561 11.561 0 01-4.182.191 11.366 11.366 0 01-9.613-9.682A11.296 11.296 0 0120.265 7.596a11.348 11.348 0 019.7 9.63 11.278 11.278 0 01-2.933 9.266 4.286 4.286 0 00.19 5.934l1.979 1.978h3.47v3.47l2.603 2.603h5.206v-5.205L31.908 26.7"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "3",
    d: "M17.5 21a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
  }))
};
var FirstAccess = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3p,
    fill: "none"
  }));
});
var compPaths$3o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 26v13c0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5V21.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M21.658 22.5h4.684a6 6 0 005.618-3.893l2.533-6.756a1 1 0 00-.936-1.351H14.443a1 1 0 00-.936 1.351l2.533 6.756a6 6 0 005.618 3.893z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 30v3"
  }))
};
var FlashlightOff = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3o,
    fill: "none"
  }));
});
var compPaths$3n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5M11.94 3V0M9.65 2.98L8.15.38m6.2 2.6l1.5-2.6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5M11.94 3V0M9.65 2.98L8.15.38m6.2 2.6l1.5-2.6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 26v13c0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5V21.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M21.658 22.5h4.684a6 6 0 005.618-3.893l2.533-6.756a1 1 0 00-.936-1.351H14.443a1 1 0 00-.936 1.351l2.533 6.756a6 6 0 005.618 3.893z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 30v3m-.12-27V0M19.3 5.96l-3-5.2m12.4 5.2l3-5.2"
  }))
};
var FlashlightOn = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3n,
    fill: "none"
  }));
});
var compPaths$3m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 10-3 0m0 2.25V9.75a1.5 1.5 0 10-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 113 0v2a6.726 6.726 0 01-1.977 4.773A6.732 6.732 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.013 2.166l1.591 1.591L14 5.334M5.487 2.166L3.896 3.757 5.5 5.334",
    opacity: ".2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 10-3 0m0 2.25V9.75a1.5 1.5 0 10-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 113 0v2a6.726 6.726 0 01-1.977 4.773A6.732 6.732 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.013 2.166l1.591 1.591L14 5.334M5.487 2.166L3.896 3.757 5.5 5.334",
    opacity: ".2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 27v-4.5a3 3 0 10-6 0m0 4.5v-7.5a3 3 0 10-6 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 26a3 3 0 116 0v4c0 3.728-1.51 7.104-3.954 9.546A13.464 13.464 0 0127 43.5a13.464 13.464 0 01-9.546-3.954L5.336 27.428a3 3 0 014.244-4.242l4.36 4.36c.944.944 2.56.276 2.56-1.062V10.5a3 3 0 116 0V27"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.026 4.332l3.182 3.182L28 10.668M10.974 4.332L7.792 7.514 11 10.668",
    opacity: ".2"
  }))
};
var GestureSwipe = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3m,
    fill: "none"
  }));
});
var compPaths$3l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.396 8.25a4.5 4.5 0 117.598-1.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 00-3 0m0 2.25V9.75a1.5 1.5 0 00-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 013 0v2a6.73 6.73 0 01-1.977 4.773A6.73 6.73 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.396 8.25a4.5 4.5 0 117.598-1.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 00-3 0m0 2.25V9.75a1.5 1.5 0 00-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 013 0v2a6.73 6.73 0 01-1.977 4.773A6.73 6.73 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12.792 16.5a9 9 0 1115.196-3",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 27v-4.5a3.001 3.001 0 00-6 0m0 4.5v-7.5a3.001 3.001 0 00-6 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 26a3.001 3.001 0 016 0v4a13.46 13.46 0 01-3.954 9.546A13.46 13.46 0 0127 43.5a13.464 13.464 0 01-9.546-3.954L5.336 27.428a3 3 0 014.244-4.242l4.36 4.36c.944.944 2.56.276 2.56-1.062V10.5a3 3 0 116 0V27"
  }))
};
var GestureTap = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3l,
    fill: "none"
  }));
});
var compPaths$3k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.76 10.5V8.25h16.5v3H6.76c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h10.5c.83 0 1.5-.67 1.5-1.5v-7.5m-4.5-7.5c-1.24 0-2.25 1.01-2.25 2.25v2.25h2.25c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25zm-4.5 0c1.24 0 2.25 1.01 2.25 2.25v2.25H9.76C8.51 8.25 7.51 7.24 7.51 6s1-2.25 2.25-2.25zm2.25 4.78v11.72"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.76 10.5V8.25h16.5v3H6.76c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h10.5c.83 0 1.5-.67 1.5-1.5v-7.5m-4.5-7.5c-1.24 0-2.25 1.01-2.25 2.25v2.25h2.25c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25zm-4.5 0c1.24 0 2.25 1.01 2.25 2.25v2.25H9.76C8.51 8.25 7.51 7.24 7.51 6s1-2.25 2.25-2.25zm2.25 4.78v11.72"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.52 21v-4.5h33v6h-27c-1.66 0-3 1.34-3 3v12c0 1.66 1.34 3 3 3h21c1.66 0 3-1.34 3-3v-15m-9-15c-2.48 0-4.5 2.02-4.5 4.5v4.5h4.5c2.48 0 4.5-2.02 4.5-4.5S31 7.5 28.52 7.5zm-9 0c2.48 0 4.5 2.02 4.5 4.5v4.5h-4.5c-2.5 0-4.5-2.02-4.5-4.5s2-4.5 4.5-4.5zm4.5 9.56V40.5"
  }))
};
var Gift = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3k,
    fill: "none"
  }));
});
var compPaths$3j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.678 13.018c-.854-.627-.202-1.88.029-2.255-.417.459-.833.917-1.157 1.418-.51.782-.727 1.64-.383 2.19.618.995 2.104.536 3.05.136L18 10.8l-8.677 2.293c-.728.189-1.313.163-1.645-.076z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 16.5v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.678 13.018c-.854-.627-.202-1.88.029-2.255-.417.459-.833.917-1.157 1.418-.51.782-.727 1.64-.383 2.19.618.995 2.104.536 3.05.136L18 10.8l-8.677 2.293c-.728.189-1.313.163-1.645-.076z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 16.5v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.355 26.035c-1.708-1.254-.404-3.76.058-4.51-.834.918-1.666 1.834-2.314 2.836-1.018 1.564-1.454 3.282-.766 4.382 1.236 1.988 4.208 1.07 6.1.27L36 21.601l-17.354 4.586c-1.456.378-2.626.326-3.29-.152z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 37.5H9A4.502 4.502 0 014.5 33V15c0-2.484 2.016-4.5 4.5-4.5h30c2.484 0 4.5 2.016 4.5 4.5v18c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var GiftCard = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3j,
    fill: "none"
  }));
});
var compPaths$3i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c2.9 0 5.25-4.365 5.25-9.75S14.9 2.25 12 2.25 6.75 6.615 6.75 12 9.1 21.75 12 21.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75c5.385 0 9.75-1.679 9.75-3.75 0-2.071-4.365-3.75-9.75-3.75S2.25 9.929 2.25 12c0 2.071 4.365 3.75 9.75 3.75z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c2.9 0 5.25-4.365 5.25-9.75S14.9 2.25 12 2.25 6.75 6.615 6.75 12 9.1 21.75 12 21.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75c5.385 0 9.75-1.679 9.75-3.75 0-2.071-4.365-3.75-9.75-3.75S2.25 9.929 2.25 12c0 2.071 4.365 3.75 9.75 3.75z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 43.5c10.77 0 19.5-8.73 19.5-19.5S34.77 4.5 24 4.5 4.5 13.23 4.5 24 13.23 43.5 24 43.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 43.5c5.799 0 10.5-8.73 10.5-19.5S29.799 4.5 24 4.5 13.5 13.23 13.5 24 18.201 43.5 24 43.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5c10.77 0 19.5-3.358 19.5-7.5 0-4.142-8.73-7.5-19.5-7.5S4.5 19.858 4.5 24c0 4.142 8.73 7.5 19.5 7.5z"
  }))
};
var Global = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3i,
    fill: "none"
  }));
});
var compPaths$3h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 19.5h6v-6h-6v6zm-9 0h6v-6h-6v6zm9-9h6v-6h-6v6zm-9 0h6v-6h-6v6z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 19.5h6v-6h-6v6zm-9 0h6v-6h-6v6zm9-9h6v-6h-6v6zm-9 0h6v-6h-6v6z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27 39h12V27H27v12zM9 39h12V27H9v12zm18-18h12V9H27v12zM9 21h12V9H9v12z",
    clipRule: "evenodd"
  }))
};
var GridView = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3h,
    fill: "none"
  }));
});
var compPaths$3g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.98 11.795l1.354 1.354c.098-.37.167-.75.167-1.149 0-2.481-2.02-4.5-4.5-4.5-.4 0-.78.069-1.15.167l1.355 1.354a2.986 2.986 0 012.774 2.774zM12 18c-4.37 0-7.979-4.594-8.982-5.998.568-.798 1.981-2.611 3.886-4.039l1.437 1.436A4.443 4.443 0 007.501 12a4.504 4.504 0 004.5 4.5 4.44 4.44 0 002.6-.842l1.224 1.225C14.661 17.545 13.37 18 12 18zm-2.577-7.52l4.096 4.097A2.938 2.938 0 0112 15c-1.654 0-3-1.346-3-3 0-.557.156-1.074.423-1.52zm8.744 6.624l-1.06-1.061-1.446-1.444v-.001l-1.085-1.085-4.089-4.089L9.402 8.34 8.175 7.112h.001L7.093 6.029 4.06 2.998 3 4.06l2.844 2.843c-1.999 1.537-3.451 3.391-4.048 4.23a1.495 1.495 0 000 1.735C2.903 14.424 6.912 19.5 12 19.5c1.8 0 3.461-.64 4.911-1.531l3.03 3.029L21 19.937l-2.834-2.833z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.213 11.131C21.103 9.575 17.086 4.5 12 4.5c-1.248 0-2.43.309-3.523.793l1.146 1.146A6.945 6.945 0 0112 6c4.367 0 7.984 4.59 8.99 6a20.26 20.26 0 01-2.725 3.08l1.056 1.057a21.717 21.717 0 002.892-3.268 1.5 1.5 0 000-1.738z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.98 11.795l1.354 1.354c.098-.37.167-.75.167-1.149 0-2.481-2.02-4.5-4.5-4.5-.4 0-.78.069-1.15.167l1.355 1.354a2.986 2.986 0 012.774 2.774zM12 18c-4.37 0-7.979-4.594-8.982-5.998.568-.798 1.981-2.611 3.886-4.039l1.437 1.436A4.443 4.443 0 007.501 12a4.504 4.504 0 004.5 4.5 4.44 4.44 0 002.6-.842l1.224 1.225C14.661 17.545 13.37 18 12 18zm-2.577-7.52l4.096 4.097A2.938 2.938 0 0112 15c-1.654 0-3-1.346-3-3 0-.557.156-1.074.423-1.52zm8.744 6.624l-1.06-1.061-1.446-1.444v-.001l-1.085-1.085-4.089-4.089L9.402 8.34 8.175 7.112h.001L7.093 6.029 4.06 2.998 3 4.06l2.844 2.843c-1.999 1.537-3.451 3.391-4.048 4.23a1.495 1.495 0 000 1.735C2.903 14.424 6.912 19.5 12 19.5c1.8 0 3.461-.64 4.911-1.531l3.03 3.029L21 19.937l-2.834-2.833z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.213 11.131C21.103 9.575 17.086 4.5 12 4.5c-1.248 0-2.43.309-3.523.793l1.146 1.146A6.945 6.945 0 0112 6c4.367 0 7.984 4.59 8.99 6a20.26 20.26 0 01-2.725 3.08l1.056 1.057a21.717 21.717 0 002.892-3.268 1.5 1.5 0 000-1.738z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.96 23.59l2.707 2.708c.196-.74.334-1.5.334-2.298 0-4.962-4.038-9-9-9-.8 0-1.56.138-2.298.334l2.708 2.708a5.973 5.973 0 015.548 5.548z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M44.426 22.262C42.206 19.15 34.172 9 24 9c-2.496 0-4.862.618-7.046 1.586l2.292 2.292C20.76 12.328 22.352 12 24 12c8.734 0 15.968 9.18 17.98 12-.894 1.254-2.822 3.76-5.45 6.16l2.112 2.114c2.802-2.57 4.83-5.2 5.784-6.536a2.999 2.999 0 000-3.476zM24 36c-8.742 0-15.958-9.188-17.964-11.996 1.136-1.596 3.962-5.222 7.772-8.078l2.874 2.872A8.886 8.886 0 0015 24c0 4.962 4.038 9 9 9a8.879 8.879 0 005.202-1.684l2.448 2.45C29.322 35.09 26.738 36 24 36zm-5.154-15.04l8.192 8.194A5.876 5.876 0 0124 30c-3.308 0-6-2.692-6-6 0-1.114.312-2.148.846-3.04zm17.488 13.248l-2.122-2.122-2.89-2.888v-.002l-2.17-2.17-8.178-8.178-2.17-2.17-2.454-2.454h.002l-2.166-2.166h-.002L8.122 5.996 6 8.118l5.688 5.686c-3.998 3.074-6.902 6.782-8.096 8.46a2.99 2.99 0 000 3.47C5.806 28.848 13.824 39 24 39c3.6 0 6.922-1.28 9.822-3.062l6.058 6.058L42 39.874l-5.666-5.666z",
    clipRule: "evenodd"
  }))
};
var Hide = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3g,
    fill: "none"
  }));
});
var compPaths$3f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 7v5l2.64 2.64"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 6.02v3.73h3.73"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 4.75c4.01 0 7.25 3.24 7.25 7.25s-3.24 7.25-7.25 7.25S4.75 16.01 4.75 12m.34-2.2C6.02 6.88 8.77 4.75 12 4.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 6v6l3 3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.25 5.5v4.25H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 3.75c4.56 0 8.25 3.69 8.25 8.25 0 4.56-3.69 8.25-8.25 8.25-4.56 0-8.25-3.69-8.25-8.25m.39-2.5A8.25 8.25 0 0112 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 12v12l6 6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M6.5 11v8.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 7.5c9.12 0 16.5 7.38 16.5 16.5 0 9.12-7.38 16.5-16.5 16.5-9.12 0-16.5-7.38-16.5-16.5m.78-5C10.38 12.34 16.64 7.5 24 7.5"
  }))
};
var History = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3f,
    fill: "none"
  }));
});
var compPaths$3e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 20.25h12A2.25 2.25 0 0020.25 18v-7.148L12 3.975l-8.25 6.877V21"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 20.25h12A2.25 2.25 0 0020.25 18v-7.148L12 3.975l-8.25 6.877V21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 40.5h24a4.5 4.5 0 004.5-4.5V21.704L24 7.95 7.5 21.704V42"
  }))
};
var Home = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3e,
    fill: "none"
  }));
});
var compPaths$3d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.999L3 10.5V21h15c1.654 0 3-1.346 3-3v-7.5L12 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.999L3 10.5V21h15c1.654 0 3-1.346 3-3v-7.5L12 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 5.997L6 21v20.998h30c3.308 0 6-2.69 6-6V21L24 5.997z",
    clipRule: "evenodd"
  }))
};
var HomeFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3d,
    fill: "none"
  }));
});
var compPaths$3c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: ".5",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: ".5",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 42H12v-3h24c1.654 0 3-1.346 3-3V22.406L24 9.904 9 22.406V42H6V21.002L24 5.998l18 15.004V36c0 3.308-2.692 6-6 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    d: "M36 42H12v-3h24c1.654 0 3-1.346 3-3V22.406L24 9.904 9 22.406V42H6V21.002L24 5.998l18 15.004V36c0 3.308-2.692 6-6 6z",
    clipRule: "evenodd"
  }))
};
var HomeStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3c,
    fill: "none"
  }));
});
var compPaths$3b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.324l3.746-3.746 2.342 2.342 6.666-6.665 3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.324l3.746-3.746 2.342 2.342 6.666-6.665 3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 18a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 36.648l7.492-7.492 4.684 4.684 13.332-13.33 7.5 7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var ImagenoImage = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3b,
    fill: "none"
  }));
});
var compPaths$3a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39.135 12.201L27.177 24.16a4.503 4.503 0 01-6.364 0l-11.1-11.098c-.944-.944-.276-2.562 1.062-2.562h25.226c2.484 0 4.5 2.016 4.5 4.5v18a4.5 4.5 0 01-4.5 4.5h-24a4.5 4.5 0 01-4.5-4.5V18"
  }))
};
var Inbox = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3a,
    fill: "none"
  }));
});
var compPaths$39 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.937 11.55a1.503 1.503 0 002.12 0l6.566-6.566A2.975 2.975 0 0018 4.5H6c-.6 0-1.157.181-1.626.486l6.563 6.563z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.118 12.61a2.994 2.994 0 01-2.121.877 2.992 2.992 0 01-2.121-.877L3.364 6.098A2.96 2.96 0 003 7.5v9c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-9c0-.511-.14-.984-.366-1.406l-6.516 6.516z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.937 11.55a1.503 1.503 0 002.12 0l6.566-6.566A2.975 2.975 0 0018 4.5H6c-.6 0-1.157.181-1.626.486l6.563 6.563z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.118 12.61a2.994 2.994 0 01-2.121.877 2.992 2.992 0 01-2.121-.877L3.364 6.098A2.96 2.96 0 003 7.5v9c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-9c0-.511-.14-.984-.366-1.406l-6.516 6.516z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.873 23.099a3.006 3.006 0 004.242 0l13.132-13.13A5.95 5.95 0 0036 9H12c-1.2 0-2.314.362-3.252.972l13.126 13.126z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.236 25.22a5.988 5.988 0 01-4.242 1.754 5.984 5.984 0 01-4.241-1.754L6.728 12.196C6.278 13.038 6 13.982 6 15v18c0 3.308 2.692 6 6 6h24c3.309 0 6-2.692 6-6V15c0-1.022-.28-1.968-.731-2.812L28.237 25.22z",
    clipRule: "evenodd"
  }))
};
var InboxFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$39,
    fill: "none"
  }));
});
var compPaths$38 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M39.135 12.201L27.177 24.16a4.503 4.503 0 01-6.364 0l-11.1-11.098c-.944-.944-.276-2.562 1.062-2.562h25.226c2.484 0 4.5 2.016 4.5 4.5v18a4.5 4.5 0 01-4.5 4.5h-24a4.5 4.5 0 01-4.5-4.5V18"
  }))
};
var InboxStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$38,
    fill: "none"
  }));
});
var compPaths$37 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7v1.5m0 1.5v7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 9v9m0-12v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 18v18m0-24v3"
  }))
};
var Info = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$37,
    fill: "none"
  }));
});
var compPaths$36 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7v1.5m0 1.5v7m0 2.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 9v9m0-12v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 18v18m0-24v3"
  }))
};
var InfoCircle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$36,
    fill: "none"
  }));
});
var compPaths$35 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm.75 13h-1.5v-7h1.5v7zm0-8.5h-1.5V7h1.5v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm.75 16.5h-1.5V9h1.5v9zm0-10.5h-1.5V6h1.5v1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm1.5 33h-3V18h3v18zm0-21h-3v-3h3v3z"
  }))
};
var InfoCircleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$35,
    fill: "none"
  }));
});
var compPaths$34 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.5 3.75H5.75a2 2 0 00-2 2v14a2 2 0 002 2h12.5a2 2 0 002-2v-14a2 2 0 00-2-2H17"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 6.75h5.5m-5.5 3h4m.75 12h4a2.498 2.498 0 002.5-2.5m0 0a2.46 2.46 0 00-.732-1.75 2.518 2.518 0 00-1.768-.75h-1V2.25h1a2.5 2.5 0 012.5 2.5v14.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.5 3.75H5.75a2 2 0 00-2 2v14a2 2 0 002 2h12.5a2 2 0 002-2v-14a2 2 0 00-2-2H17"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 6.75h5.5m-5.5 3h4m.75 12h4a2.498 2.498 0 002.5-2.5m0 0a2.46 2.46 0 00-.732-1.75 2.518 2.518 0 00-1.768-.75h-1V2.25h1a2.5 2.5 0 012.5 2.5v14.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23 7.5H11.5a4 4 0 00-4 4v28a4 4 0 004 4h25a4 4 0 004-4v-28a4 4 0 00-4-4H34"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M12 13.5h11m-11 6h8m1.5 24h8a4.995 4.995 0 005-5m0 0a4.918 4.918 0 00-1.465-3.5c-.937-.938-2.209-1.5-3.535-1.5h-2v-29h2a5 5 0 015 5v29z"
  }))
};
var Journal = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$34,
    fill: "none"
  }));
});
var compPaths$33 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.53 16.773l-2.12 2.121a3.752 3.752 0 01-5.305-5.304l3.182-3.18a3.75 3.75 0 015.304 0l1.061 1.06"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.47 7.227l2.12-2.122a3.752 3.752 0 015.305 5.304l-3.182 3.182a3.75 3.75 0 01-5.304 0l-1.061-1.06"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.53 16.773l-2.12 2.121a3.752 3.752 0 01-5.305-5.304l3.182-3.18a3.75 3.75 0 015.304 0l1.061 1.06"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.47 7.227l2.12-2.122a3.752 3.752 0 015.305 5.304l-3.182 3.182a3.75 3.75 0 01-5.304 0l-1.061-1.06"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.06 33.547l-4.241 4.242a7.503 7.503 0 01-10.608 0 7.503 7.503 0 010-10.608l6.364-6.362a7.5 7.5 0 0110.608 0l2.122 2.12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M22.94 14.454l4.241-4.244a7.503 7.503 0 0110.608 0 7.503 7.503 0 010 10.608l-6.364 6.364a7.5 7.5 0 01-10.608 0l-2.122-2.122"
  }))
};
var Link = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$33,
    fill: "none"
  }));
});
var compPaths$32 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 2.25A9.75 9.75 0 0121.75 12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 2.25A9.75 9.75 0 0121.75 12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 4.5c10.77 0 19.5 8.73 19.5 19.5"
  }))
};
var Loading = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$32,
    fill: "none"
  }));
});
var compPaths$31 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 19.25l-.61.436a.75.75 0 001.22 0L12 19.25zm4.5-8.998c0 1.32-.854 2.947-2.006 4.577-.56.794-1.164 1.55-1.714 2.229-.54.666-1.052 1.282-1.39 1.756l1.22.872c.304-.425.77-.987 1.335-1.683a43.976 43.976 0 001.774-2.308C16.871 14.065 18 12.091 18 10.252h-1.5zm-3.89 8.562c-.338-.474-.85-1.09-1.39-1.756a42.613 42.613 0 01-1.714-2.229C8.354 13.2 7.5 11.572 7.5 10.252H6c0 1.84 1.129 3.813 2.281 5.443.591.836 1.22 1.625 1.774 2.308.565.696 1.031 1.258 1.335 1.683l1.22-.872zM7.5 10.252C7.5 7.594 9.547 5.5 12 5.5V4c-3.347 0-6 2.833-6 6.252h1.5zM12 5.5c2.453 0 4.5 2.094 4.5 4.752H18C18 6.832 15.347 4 12 4v1.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.5 10a2.5 2.5 0 11-5 .002 2.5 2.5 0 015-.001z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 21.747l-.468.586a.75.75 0 00.936 0L12 21.747zM18 9c0 .92-.303 2.081-.824 3.362-.515 1.269-1.222 2.6-1.974 3.843a38.411 38.411 0 01-2.217 3.274c-.695.914-1.223 1.498-1.453 1.682l.936 1.172c.395-.314 1.023-1.042 1.711-1.947a39.904 39.904 0 002.306-3.404c.78-1.288 1.526-2.691 2.08-4.055.55-1.352.935-2.723.935-3.927H18zm-5.532 12.16c-.23-.183-.758-.767-1.453-1.681a38.41 38.41 0 01-2.217-3.274c-.752-1.243-1.458-2.574-1.974-3.843C6.303 11.081 6 9.921 6 9H4.5c0 1.204.385 2.575.934 3.927.555 1.364 1.302 2.767 2.08 4.055.78 1.288 1.6 2.474 2.307 3.404.688.905 1.316 1.633 1.711 1.947l.936-1.172zM6 9a6 6 0 016-6V1.5A7.5 7.5 0 004.5 9H6zm6-6a6 6 0 016 6h1.5A7.5 7.5 0 0012 1.5V3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.25 9a3.25 3.25 0 11-6.5 0 3.25 3.25 0 016.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 43.5l-.936 1.173a1.5 1.5 0 001.872 0L24 43.5zm12-25.498c0 1.841-.606 4.163-1.647 6.725-1.032 2.538-2.444 5.2-3.949 7.688a76.834 76.834 0 01-4.434 6.547c-1.39 1.83-2.445 2.998-2.905 3.365l1.87 2.346c.79-.63 2.048-2.085 3.423-3.895a79.802 79.802 0 004.613-6.81c1.558-2.576 3.052-5.383 4.16-8.111C38.232 23.153 39 20.41 39 18.002h-3zM24.936 42.327c-.461-.367-1.516-1.535-2.906-3.364a76.834 76.834 0 01-4.434-6.548c-1.505-2.488-2.917-5.15-3.949-7.688C12.606 22.165 12 19.843 12 18.002H9c0 2.41.77 5.151 1.868 7.855 1.11 2.728 2.603 5.535 4.161 8.11a79.802 79.802 0 004.613 6.81c1.375 1.81 2.633 3.266 3.422 3.896l1.872-2.346zM12 18.002C12 11.373 17.373 6 24 6V3C15.715 3 9 9.717 9 18.002h3zM24 6c6.627 0 12 5.373 12 12.002h3C39 9.717 32.285 3 24 3v3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.5 18a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z",
    clipRule: "evenodd"
  }))
};
var LocationPin = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$31,
    fill: "none"
  }));
});
var compPaths$30 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 10.252C6 6.832 8.653 4 12 4s6 2.833 6 6.252c0 1.84-1.129 3.813-2.281 5.443a43.976 43.976 0 01-1.774 2.308l-.277.34c-.44.541-.805.99-1.058 1.343a.75.75 0 01-1.22 0 30.643 30.643 0 00-1.058-1.343l-.277-.34a44.003 44.003 0 01-1.774-2.308C7.129 14.065 6 12.091 6 10.252zm6 2.25a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 9.001a7.5 7.5 0 1115 0c0 1.205-.385 2.576-.934 3.928-.555 1.364-1.302 2.767-2.08 4.055a39.918 39.918 0 01-2.307 3.405c-.688.905-1.316 1.632-1.711 1.947a.75.75 0 01-.936 0c-.395-.315-1.023-1.042-1.711-1.947a39.916 39.916 0 01-2.306-3.405c-.78-1.288-1.526-2.691-2.08-4.056-.55-1.351-.935-2.722-.935-3.927zM12 12.25a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 18.002C9 9.717 15.715 3 24 3s15 6.717 15 15.002c0 2.41-.77 5.151-1.868 7.855-1.11 2.728-2.603 5.535-4.161 8.11a79.802 79.802 0 01-4.613 6.81c-1.375 1.81-2.633 3.266-3.422 3.896a1.5 1.5 0 01-1.872 0c-.789-.63-2.047-2.085-3.422-3.895a79.802 79.802 0 01-4.613-6.81c-1.558-2.576-3.052-5.383-4.16-8.111C9.768 23.153 9 20.41 9 18.002zM24 24.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
    clipRule: "evenodd"
  }))
};
var LocationPinFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$30,
    fill: "none"
  }));
});
var compPaths$2$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zm-1.5-11V7.5c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v2.25M12 16v2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zm-1.5-11V7.5c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v2.25M12 16v2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 40.5h-21c-1.66 0-3-1.34-3-3v-15c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3v15c0 1.66-1.34 3-3 3zm-3-22V15c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5v4.5M24 32v4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5a3 3 0 100-6 3 3 0 000 6z"
  }))
};
var Lock = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2$,
    fill: "none"
  }));
});
var compPaths$2_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.25 9h-.75V7.5C16.5 5.02 14.48 3 12 3S7.5 5.02 7.5 7.5V9h-.75C5.51 9 4.5 10.01 4.5 11.25v7.5C4.5 19.99 5.51 21 6.75 21h10.5c1.24 0 2.25-1.01 2.25-2.25v-7.5c0-1.24-1.01-2.25-2.25-2.25zM9 7.5c0-1.65 1.35-3 3-3s3 1.35 3 3V9H9V7.5zm3.75 8.86V18h-1.5v-1.64c-.87-.31-1.5-1.14-1.5-2.11C9.75 13.01 10.76 12 12 12s2.25 1.01 2.25 2.25c0 .98-.63 1.8-1.5 2.11z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.25 9h-.75V7.5C16.5 5.02 14.48 3 12 3S7.5 5.02 7.5 7.5V9h-.75C5.51 9 4.5 10.01 4.5 11.25v7.5C4.5 19.99 5.51 21 6.75 21h10.5c1.24 0 2.25-1.01 2.25-2.25v-7.5c0-1.24-1.01-2.25-2.25-2.25zM9 7.5c0-1.65 1.35-3 3-3s3 1.35 3 3V9H9V7.5zm3.75 8.86V18h-1.5v-1.64c-.87-.31-1.5-1.14-1.5-2.11C9.75 13.01 10.76 12 12 12s2.25 1.01 2.25 2.25c0 .98-.63 1.8-1.5 2.11z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M34.5 18H33v-3c0-4.96-4.04-9-9-9s-9 4.04-9 9v3h-1.5C11.02 18 9 20.02 9 22.5v15c0 2.48 2.02 4.5 4.5 4.5h21c2.48 0 4.5-2.02 4.5-4.5v-15c0-2.48-2.02-4.5-4.5-4.5zM18 15c0-3.3 2.7-6 6-6s6 2.7 6 6v3H18v-3zm7.5 17.72V36h-3v-3.28c-1.74-.62-3-2.28-3-4.22 0-2.48 2.02-4.5 4.5-4.5s4.5 2.02 4.5 4.5c0 1.96-1.26 3.6-3 4.22z"
  }))
};
var LockFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2_,
    fill: "none"
  }));
});
var compPaths$2Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 10.5v6.75a1.5 1.5 0 01-1.5 1.5H3.75a1.5 1.5 0 01-1.5-1.5V10.5m3.308-2.25h12.885"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.79 5.599l2.652 2.65-2.652 2.653M8.21 5.599l-2.652 2.65 2.652 2.653M17.25 19v-2.5M12 19v-2.5M6.75 19v-2.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 10.5v6.75a1.5 1.5 0 01-1.5 1.5H3.75a1.5 1.5 0 01-1.5-1.5V10.5m3.308-2.25h12.885"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.79 5.599l2.652 2.65-2.652 2.653M8.21 5.599l-2.652 2.65 2.652 2.653M17.25 19v-2.5M12 19v-2.5M6.75 19v-2.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 21v13.5a3 3 0 01-3 3h-33a3 3 0 01-3-3V21m6.615-4.5h25.77"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.581 11.197l5.304 5.302-5.304 5.304M16.419 11.197L11.115 16.5l5.304 5.304M34.5 38v-5M24 38v-5m-10.5 5v-5"
  }))
};
var Measure = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2Z,
    fill: "none"
  }));
});
var compPaths$2Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75l1.5-6h13.5l1.5 6v7.5a3 3 0 01-3 3H3.75V9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M12 4v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.26 14.694c-.64-.474-.154-1.414.02-1.694-.314.347-.628.687-.868 1.06-.38.587-.546 1.234-.286 1.647.466.747 1.58.4 2.287.1L17 13.027l-6.507 1.72c-.547.14-.987.127-1.234-.053z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75l1.5-6h13.5l1.5 6v7.5a3 3 0 01-3 3H3.75V9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M12 4v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.26 14.694c-.64-.474-.154-1.414.02-1.694-.314.347-.628.687-.868 1.06-.38.587-.546 1.234-.286 1.647.466.747 1.58.4 2.287.1L17 13.027l-6.507 1.72c-.547.14-.987.127-1.234-.053z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 19.5l3-12h27l3 12v15a6 6 0 01-6 6h-27v-21z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 19.5h-33M24 8v12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.518 29.387c-1.28-.947-.306-2.827.04-3.387-.626.693-1.253 1.373-1.733 2.12-.76 1.174-1.094 2.467-.574 3.294.934 1.493 3.16.8 4.574.2L34 26.054l-13.015 3.44c-1.093.28-1.973.253-2.467-.107z"
  }))
};
var MemberProduct = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2Y,
    fill: "none"
  }));
});
var compPaths$2X = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17v4.25a.5.5 0 01-.596.484c-.096-.019-.254-.134-.254-.134L12 19l-3.65 2.6s-.158.115-.254.134a.499.499 0 01-.596-.484V14"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.214 9.133c-.617-.457-.148-1.363.02-1.633-.303.334-.605.662-.836 1.022-.367.566-.527 1.19-.277 1.588.45.72 1.524.385 2.205.096l6.35-2.68-6.273 1.658c-.527.135-.951.122-1.19-.051z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17v4.25a.5.5 0 01-.596.484c-.096-.019-.254-.134-.254-.134L12 19l-3.65 2.6s-.158.115-.254.134a.499.499 0 01-.596-.484V14"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.214 9.133c-.617-.457-.148-1.363.02-1.633-.303.334-.605.662-.836 1.022-.367.566-.527 1.19-.277 1.588.45.72 1.524.385 2.205.096l6.35-2.68-6.273 1.658c-.527.135-.951.122-1.19-.051z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 34v8.5a1 1 0 01-1.191.968c-.192-.038-.509-.268-.509-.268L24 38l-7.3 5.2s-.317.23-.509.267A1 1 0 0115 42.5V28"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5c7.456 0 13.5-6.044 13.5-13.5S31.456 4.5 24 4.5 10.5 10.544 10.5 18 16.544 31.5 24 31.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.428 18.265c-1.234-.913-.296-2.725.038-3.265-.604.668-1.208 1.324-1.67 2.044-.734 1.131-1.055 2.378-.554 3.175.9 1.44 3.047.772 4.41.193l12.7-5.36-12.546 3.316c-1.054.27-1.903.244-2.378-.103z"
  }))
};
var MemberRewards = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2X,
    fill: "none"
  }));
});
var compPaths$2W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 5.25H3M21 12H3m18 6.75H3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 5.25H3M21 12H3m18 6.75H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 10.5H6M42 24H6m36 13.5H6"
  }))
};
var Menu$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2W,
    fill: "none"
  }));
});
var compPaths$2V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3 8.25h18m-18 7.5h15"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3 8.25h18m-18 7.5h15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 16.5H6m30 15H6"
  }))
};
var Menu2lines = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2V,
    fill: "none"
  }));
});
var compPaths$2U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21m.75-8.25H7.5m9-4.5h-9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21m.75-8.25H7.5m9-4.5h-9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M32 34.5h4a4.5 4.5 0 004.5-4.5V12A4.5 4.5 0 0036 7.5H12A4.5 4.5 0 007.5 12v18a4.5 4.5 0 004.5 4.5h12a4.5 4.5 0 014.5 4.5v3M30 25.5H15m18-9H15"
  }))
};
var Message = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2U,
    fill: "none"
  }));
});
var compPaths$2T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 10.5a3.75 3.75 0 007.5 0V6a3.75 3.75 0 00-7.5 0v4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5a6.75 6.75 0 1013.5 0M12 22.5v-6m-3 5.25h6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 10.5a3.75 3.75 0 007.5 0V6a3.75 3.75 0 00-7.5 0v4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5a6.75 6.75 0 1013.5 0M12 22.5v-6m-3 5.25h6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 21a7.5 7.5 0 0015 0v-9a7.5 7.5 0 00-15 0v9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.5 21c0 7.456 6.044 13.5 13.5 13.5S37.5 28.456 37.5 21M24 45V33m-6 10.5h12"
  }))
};
var Microphone = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2T,
    fill: "none"
  }));
});
var compPaths$2S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5 20.25h14m-13.43-3L3.16 8.23c-.14-.49.47-.84.83-.48l4.45 4.45c.27.27.74.15.84-.22l2.24-8.35c.13-.49.83-.49.97 0l2.24 8.35c.1.37.56.5.84.22l4.45-4.45c.36-.36.97-.01.84.48l-2.42 9.02H5.57z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5 20.25h14m-13.43-3L3.16 8.23c-.14-.49.47-.84.83-.48l4.45 4.45c.27.27.74.15.84-.22l2.24-8.35c.13-.49.83-.49.97 0l2.24 8.35c.1.37.56.5.84.22l4.45-4.45c.36-.36.97-.01.84.48l-2.42 9.02H5.57z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M10 40.5h28m-26.86-6L6.32 16.46c-.28-.98.94-1.68 1.66-.96l8.9 8.9c.54.54 1.48.3 1.68-.44l4.48-16.7c.26-.98 1.66-.98 1.94 0l4.48 16.7c.2.74 1.12 1 1.68.44l8.9-8.9c.72-.72 1.94-.02 1.68.96L36.88 34.5H11.14z"
  }))
};
var Monarch = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2S,
    fill: "none"
  }));
});
var compPaths$2R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M13.5 20.25h-9c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 8.25v-.76c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25h-3.75m2.24-9h1.5m-1.5 3h1.5m-1.5 3h1.5m-12.74 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-1 5.95L12 13.95l3.75 3.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M13.5 20.25h-9c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 8.25v-.76c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25h-3.75m2.24-9h1.5m-1.5 3h1.5m-1.5 3h1.5m-12.74 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-1 5.95L12 13.95l3.75 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M27 40.5H9c-2.48 0-4.5-2.02-4.5-4.5V21c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5v15c0 2.48-2.02 4.5-4.5 4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.5 16.5v-1.52c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5V30c0 2.48-2.02 4.5-4.5 4.5h-7.5m4.48-18h3m-3 6h3m-3 6h3m-25.48 0a3 3 0 100-6 3 3 0 000 6zm-2 11.9L24 27.9l7.5 7.5"
  }))
};
var Multimedia = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2R,
    fill: "none"
  }));
});
var compPaths$2Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 6.75V9c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V6.75c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zm0 8.25v2.25c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V15c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zM3 16.25h1.5M3 7.75h1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 6.75V9c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V6.75c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zm0 8.25v2.25c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V15c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zM3 16.25h1.5M3 7.75h1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 13.5V18c0 1.66-1.34 3-3 3h-21c-1.66 0-3-1.34-3-3v-4.5c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3zm0 16.5v4.5c0 1.66-1.34 3-3 3h-21c-1.66 0-3-1.34-3-3V30c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3zM6 32.5h3m-3-17h3"
  }))
};
var MultiSelect = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2Q,
    fill: "none"
  }));
});
var compPaths$2P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.775 8.338L18.26 3.843c1.172-.391 2.288.725 1.898 1.897l-4.495 13.485c-.448 1.341-2.33 1.376-2.827.051l-2.313-5.798-5.799-2.313c-1.324-.496-1.289-2.38.052-2.827z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.775 8.338L18.26 3.843c1.172-.391 2.288.725 1.898 1.897l-4.495 13.485c-.448 1.341-2.33 1.376-2.827.051l-2.313-5.798-5.799-2.313c-1.324-.496-1.289-2.38.052-2.827z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9.552 16.676l26.968-8.99c2.344-.782 4.576 1.45 3.794 3.794l-8.99 26.97c-.894 2.682-4.662 2.752-5.654.102l-4.624-11.596-11.6-4.626c-2.646-.992-2.576-4.76.106-5.654z",
    clipRule: "evenodd"
  }))
};
var Navigation = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2P,
    fill: "none"
  }));
});
var compPaths$2O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 14v-.5A2.5 2.5 0 0110 11h4a2.5 2.5 0 012.5 2.5v.5M14 6.5a2 2 0 11-4 0 2 2 0 014 0v0z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 16h12M6 19h8"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "16.5",
    height: "20",
    x: "3.75",
    y: "2",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 14v-.5A2.5 2.5 0 0110 11h4a2.5 2.5 0 012.5 2.5v.5M14 6.5a2 2 0 11-4 0 2 2 0 014 0v0z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 16h12M6 19h8"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "16.5",
    height: "20",
    x: "3.75",
    y: "2",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 28v-1a5 5 0 015-5h8a5 5 0 015 5v1m-5-15a4 4 0 11-8 0 4 4 0 018 0v0z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M12 32h24m-24 6h16"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "33",
    height: "40",
    x: "7.5",
    y: "4",
    stroke: "currentColor",
    strokeWidth: "3",
    rx: "4"
  }))
};
var NikeMembership = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2O,
    fill: "none"
  }));
});
var compPaths$2N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.12 6.62c-1.88.75-3.2 2.58-3.2 4.72V12c0 .62-.54 1.13-1.17 1.13v2.62h12.5v-2.62c-.62 0-1.17-.5-1.17-1.13v-.66c0-2.59-1.93-4.72-4.43-5.04a.745.745 0 01-.65-.74V4m1.69 13.56c0 .93-.76 1.69-1.69 1.69-.93 0-1.69-.76-1.69-1.69"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 4.98a6.751 6.751 0 00-4.25 6.27v1.5c0 .83-.67 1.5-1.5 1.5v3h16.5v-3c-.83 0-1.5-.67-1.5-1.5v-1.5c0-3.43-2.56-6.27-5.88-6.69-.5-.07-.87-.49-.87-.99V1.5m2.25 18c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 9.96c-4.98 1.98-8.5 6.86-8.5 12.54v3c0 1.66-1.34 3-3 3v6h33v-6c-1.66 0-3-1.34-3-3v-3c0-6.86-5.12-12.54-11.76-13.38-1-.14-1.74-.98-1.74-1.98V3m4.5 36c0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5"
  }))
};
var Notification = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2N,
    fill: "none"
  }));
});
var compPaths$2M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M39 36.88L11.12 9 9 11.12l3.4 3.4C10.28 17.1 9 20.4 9 24c0 8.28 6.72 15 15 15 3.6 0 6.9-1.28 9.48-3.4l3.4 3.4L39 36.88zM24 36c-6.62 0-12-5.38-12-12 0-2.76.96-5.3 2.54-7.34l16.8 16.8C29.3 35.04 26.76 36 24 36zm0-24c6.62 0 12 5.38 12 12 0 1.66-.34 3.24-.96 4.68l2.24 2.24c1.08-2.08 1.7-4.42 1.7-6.92 0-8.28-6.72-15-15-15-2.5 0-4.86.62-6.92 1.7l2.24 2.24c1.46-.6 3.04-.94 4.7-.94z"
  }))
};
var Null = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2M,
    fill: "none"
  }));
});
var compPaths$2L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 4.75C13.01 4.75 12 5.76 12 7.5v6m6.93-3.75H4.83"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 4.75h3.66l1.34 5v9.5H4.75v-9.5l1.34-5H10"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 3.75C13.01 3.75 12 4.76 12 6.5v7m8.25-3.75H3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 3.75h4.39l1.61 6v10.5H3.75V9.75l1.61-6h5.14"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 7.5C26.02 7.5 24 9.52 24 13v14m16.5-7.5h-33"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 7.5h8.78l3.22 12v21h-33v-21l3.22-12H21"
  }))
};
var Orders = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2L,
    fill: "none"
  }));
});
var compPaths$2K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H6a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75h16.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H6a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75h16.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 37.5H12A4.502 4.502 0 017.5 33V15a4.5 4.5 0 014.5-4.5h24a4.5 4.5 0 014.5 4.5v18c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 19.5h33"
  }))
};
var Payment = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2K,
    fill: "none"
  }));
});
var compPaths$2J = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M22.955 9.167l-4.773 4.773-2.652-2.651"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M22.955 9.167l-4.773 4.773-2.652-2.651"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M45.91 18.334l-9.546 9.546-5.304-5.302"
  }))
};
var Personalization = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2J,
    fill: "none"
  }));
});
var compPaths$2I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 21.75h-15c-1.24 0-2.25-1.01-2.25-2.25V6c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v13.5c0 1.24-1.01 2.25-2.25 2.25zm2.25-13.5H2.25m6-6.75V6m7.5-4.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.05 16.97l4.42-4.42m-4.42 0l4.42 4.42m-7.57-4.48l-3.42 3.92-1.95-1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 21.75h-15c-1.24 0-2.25-1.01-2.25-2.25V6c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v13.5c0 1.24-1.01 2.25-2.25 2.25zm2.25-13.5H2.25m6-6.75V6m7.5-4.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.05 16.97l4.42-4.42m-4.42 0l4.42 4.42m-7.57-4.48l-3.42 3.92-1.95-1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 43.5H9c-2.48 0-4.5-2.02-4.5-4.5V12c0-2.48 2.02-4.5 4.5-4.5h30c2.48 0 4.5 2.02 4.5 4.5v27c0 2.48-2.02 4.5-4.5 4.5zm4.5-27h-39M16.5 3v9m15-9v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.1 33.94l8.84-8.84m-8.84 0l8.84 8.84M21.8 24.98l-6.84 7.84-3.9-3.88"
  }))
};
var Plan = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2I,
    fill: "none"
  }));
});
var compPaths$2H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.25 12c0 4-3.24 7.25-7.25 7.25S4.75 16 4.75 12 7.99 4.75 12 4.75 19.25 8 19.25 12zM12 8v8m4-4H8"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12c0 5.39-4.36 9.75-9.75 9.75S2.25 17.39 2.25 12 6.61 2.25 12 2.25s9.75 4.36 9.75 9.75zM12 6v12m6-6H6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.78-8.72 19.5-19.5 19.5S4.5 34.78 4.5 24 13.22 4.5 24 4.5 43.5 13.22 43.5 24zM24 12v24m12-12H12"
  }))
};
var PlusCircle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2H,
    fill: "none"
  }));
});
var compPaths$2G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm4 8.75h-3.25V16h-1.5v-3.25H8v-1.5h3.25V8h1.5v3.25H16v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm6 11.25h-5.25V18h-1.5v-5.25H6v-1.5h5.25V6h1.5v5.25H18v1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm12 22.5H25.5V36h-3V25.5H12v-3h10.5V12h3v10.5H36v3z"
  }))
};
var PlusCircleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2G,
    fill: "none"
  }));
});
var compPaths$2F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 14.25h-7.5v6h7.5v-6zm-7.5-6.5v-4h7.5v4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8 17.25H6c-1.24 0-2.25-1.01-2.25-2.25v-4.5c0-1.24 1.01-2.25 2.25-2.25h12c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25m-12-6h1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 14.25h-7.5v6h7.5v-6zm-7.5-6.5v-4h7.5v4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8 17.25H6c-1.24 0-2.25-1.01-2.25-2.25v-4.5c0-1.24 1.01-2.25 2.25-2.25h12c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25m-12-6h1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M31.5 28.5h-15v12h15v-12zm-15-13v-8h15v8"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16 34.5h-4c-2.48 0-4.5-2.02-4.5-4.5v-9c0-2.48 2.02-4.5 4.5-4.5h24c2.48 0 4.5 2.02 4.5 4.5v9c0 2.48-2.02 4.5-4.5 4.5m-24-12h3"
  }))
};
var Print = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2F,
    fill: "none"
  }));
});
var compPaths$2E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3h9v-1.5h-9V15zm9 0a3 3 0 013 3H21a4.5 4.5 0 00-4.5-4.5V15zm3 3v3H21v-3h-1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3h9v-1.5h-9V15zm9 0a3 3 0 013 3H21a4.5 4.5 0 00-4.5-4.5V15zm3 3v3H21v-3h-1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 42v-6a7.5 7.5 0 017.5-7.5h18a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }))
};
var Profile = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2E,
    fill: "none"
  }));
});
var compPaths$2D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 21H3v-3c0-2.481 2.019-4.5 4.5-4.5h9c2.481 0 4.5 2.019 4.5 4.5v3h-1.5M12 12a4.505 4.505 0 01-4.5-4.5C7.5 5.019 9.519 3 12 3s4.5 2.019 4.5 4.5S14.481 12 12 12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 21H3v-3c0-2.481 2.019-4.5 4.5-4.5h9c2.481 0 4.5 2.019 4.5 4.5v3h-1.5M12 12a4.505 4.505 0 01-4.5-4.5C7.5 5.019 9.519 3 12 3s4.5 2.019 4.5 4.5S14.481 12 12 12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 42H6v-6c0-4.962 4.038-9 9-9h18c4.962 0 9 4.038 9 9v6h-3M24 24c-4.962 0-9-4.038-9-9s4.038-9 9-9 9 4.038 9 9-4.038 9-9 9z",
    clipRule: "evenodd"
  }))
};
var ProfileFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2D,
    fill: "none"
  }));
});
var compPaths$2C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M3.75 21v-3a3.75 3.75 0 013.75-3.75h9A3.75 3.75 0 0120.25 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M3.75 21v-3a3.75 3.75 0 013.75-3.75h9A3.75 3.75 0 0120.25 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M7.5 42v-6a7.5 7.5 0 017.5-7.5h18a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M31.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }))
};
var ProfileStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2C,
    fill: "none"
  }));
});
var compPaths$2B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3H17v-1.5H7.5V15z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3H17v-1.5H7.5V15z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 6a9 9 0 00-9 9h3a6 6 0 016-6V6zm-9 9a9 9 0 009 9v-3a6 6 0 01-6-6h-3zm9 9a9 9 0 009-9h-3a6 6 0 01-6 6v3zm9-9a9 9 0 00-9-9v3a6 6 0 016 6h3zM9 42v-6H6v6h3zm0-6a6 6 0 016-6v-3a9 9 0 00-9 9h3zm6-6h19v-3H15v3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M45 34l-16.82 7.135c-1.4.594-2.579.89-3.528.89-1.068 0-1.846-.376-2.324-1.129-.62-.97-.35-2.532.714-4.18.631-.964 1.434-1.848 2.216-2.694-.184.299-1.808 3.001-.032 4.274.351.255.85.38 1.465.38.494 0 1.06-.08 1.682-.242L45 34z",
    clipRule: "evenodd"
  }))
};
var ProfileSwoosh = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2B,
    fill: "none"
  }));
});
var compPaths$2A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 2.75A4.75 4.75 0 007.25 7.5h2A2.75 2.75 0 0112 4.75v-2zM7.25 7.5A4.75 4.75 0 0012 12.25v-2A2.75 2.75 0 019.25 7.5h-2zM12 12.25a4.75 4.75 0 004.75-4.75h-2A2.75 2.75 0 0112 10.25v2zm4.75-4.75A4.75 4.75 0 0012 2.75v2a2.75 2.75 0 012.75 2.75h2zM4.75 21v-3h-2v3h2zm0-3a2.75 2.75 0 012.75-2.75v-2A4.75 4.75 0 002.75 18h2zm2.75-2.75H17v-2H7.5v2z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 2.75A4.75 4.75 0 007.25 7.5h2A2.75 2.75 0 0112 4.75v-2zM7.25 7.5A4.75 4.75 0 0012 12.25v-2A2.75 2.75 0 019.25 7.5h-2zM12 12.25a4.75 4.75 0 004.75-4.75h-2A2.75 2.75 0 0112 10.25v2zm4.75-4.75A4.75 4.75 0 0012 2.75v2a2.75 2.75 0 012.75 2.75h2zM4.75 21v-3h-2v3h2zm0-3a2.75 2.75 0 012.75-2.75v-2A4.75 4.75 0 002.75 18h2zm2.75-2.75H17v-2H7.5v2z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 6a9 9 0 00-9 9h3a6 6 0 016-6V6zm-9 9a9 9 0 009 9v-3a6 6 0 01-6-6h-3zm9 9a9 9 0 009-9h-3a6 6 0 01-6 6v3zm9-9a9 9 0 00-9-9v3a6 6 0 016 6h3zM9 42v-6H6v6h3zm0-6a6 6 0 016-6v-3a9 9 0 00-9 9h3zm6-6h19v-3H15v3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M45 34l-16.82 7.135c-1.4.594-2.579.89-3.528.89-1.068 0-1.846-.376-2.324-1.129-.62-.97-.35-2.532.714-4.18.631-.964 1.434-1.848 2.216-2.694-.184.299-1.808 3.001-.032 4.274.351.255.85.38 1.465.38.494 0 1.06-.08 1.682-.242L45 34z",
    clipRule: "evenodd"
  }))
};
var ProfileSwooshStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2A,
    fill: "none"
  }));
});
var compPaths$2z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.75 10.75h5v-5h-5v5zm0 7.5h5v-5h-5v5zm7.5-7.5h5v-5h-5v5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.5 13.25H16m1 0h2m-6.5 2.5H14m5 2.5h-3.25v-2.5H19"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 10.5h6v-6h-6v6zm0 9h6v-6h-6v6zm9-9h6v-6h-6v6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 13.5h4.5m1.5 0h1.5m-7.5 3h1.5m6 3H16.5v-3h3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 21h12V9H9v12zm0 18h12V27H9v12zm18-18h12V9H27v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 27h9m3 0h3m-15 6h3m-3 6h3m12 0H33v-6h7.5"
  }))
};
var QRCode = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2z,
    fill: "none"
  }));
});
var compPaths$2y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 17v-1.5M9.75 10a2.25 2.25 0 113.217 2.032c-.585.278-.967.87-.967 1.523V14"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M11.99 18v-1.5M9 9.75a3 3 0 114.29 2.71c-.78.37-1.29 1.16-1.29 2.03V15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M23.98 36v-3M18 19.5c0-3.66 3.3-6.58 7.08-5.9 2.42.42 4.4 2.4 4.82 4.82.5 2.84-1 5.4-3.32 6.5A4.51 4.51 0 0024 28.98V30"
  }))
};
var Question = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2y,
    fill: "none"
  }));
});
var compPaths$2x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 17v-1.5M9.75 10c0-1.37 1.24-2.47 2.65-2.21.91.16 1.65.9 1.81 1.81.19 1.07-.38 2.03-1.24 2.44-.59.27-.97.86-.97 1.51V14"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 19.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75zM11.99 18v-1.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 9.75a3 3 0 114.29 2.71c-.78.37-1.29 1.16-1.29 2.03V15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 43.5c10.77 0 19.5-8.73 19.5-19.5S34.77 4.5 24 4.5 4.5 13.23 4.5 24 13.23 43.5 24 43.5zm-.02-7.5v-3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M18 19.5c0-3.66 3.3-6.58 7.08-5.9 2.42.42 4.4 2.4 4.82 4.82.5 2.84-1 5.4-3.32 6.5A4.51 4.51 0 0024 28.98V30"
  }))
};
var QuestionCircle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2x,
    fill: "none"
  }));
});
var compPaths$2w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm.75 13h-1.5v-1.5h1.5V17zm.54-4.29c-.33.16-.54.49-.54.84V14h-1.5v-.45c0-.93.55-1.8 1.4-2.2.51-.24.97-.84.83-1.63-.1-.59-.61-1.1-1.2-1.2A1.498 1.498 0 0010.5 10H9c0-.89.39-1.73 1.08-2.3a2.993 2.993 0 014.87 1.77c.24 1.33-.45 2.66-1.66 3.24z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm.74 16.5h-1.5v-1.5h1.5V18zm.87-4.86c-.52.25-.86.78-.86 1.35V15h-1.5v-.51c0-1.15.67-2.21 1.72-2.71.92-.44 1.42-1.42 1.24-2.44-.16-.9-.9-1.64-1.8-1.8-.68-.12-1.33.05-1.85.48s-.81 1.06-.81 1.73h-1.5c0-1.11.49-2.16 1.35-2.88.85-.71 1.97-1.01 3.07-.81 1.51.26 2.75 1.5 3.02 3.02.3 1.7-.54 3.33-2.08 4.06z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm1.48 33h-3v-3h3v3zm1.74-9.72c-1.04.5-1.72 1.56-1.72 2.7V30h-3v-1.02c0-2.3 1.34-4.42 3.44-5.42 1.84-.88 2.84-2.84 2.48-4.88-.32-1.8-1.8-3.28-3.6-3.6-1.36-.24-2.66.1-3.7.96a4.462 4.462 0 00-1.62 3.46h-3c0-2.22.98-4.32 2.7-5.76a7.476 7.476 0 016.14-1.62c3.02.52 5.5 3 6.04 6.04.6 3.4-1.08 6.66-4.16 8.12z"
  }))
};
var QuestionCircleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2w,
    fill: "none"
  }));
});
var compPaths$2v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.223 10.726l3.675 2.695-1.403 4.363c-.162.502.408.92.83.61L12 15.697l3.675 2.697c.422.31.992-.108.83-.61l-1.403-4.363 3.675-2.695c.422-.31.205-.987-.318-.987h-4.542l-1.404-4.362a.538.538 0 00-1.026 0l-1.404 4.362H5.54c-.523 0-.74.676-.318.986z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.56 10.346l5.12 3.694-1.955 5.978c-.225.688.568 1.261 1.157.836L12 17.159l5.12 3.695c.587.425 1.381-.148 1.155-.836l-1.954-5.978 5.118-3.694c.589-.425.286-1.352-.442-1.352H14.67l-.166-.507-1.789-5.47c-.225-.69-1.205-.69-1.43 0L9.33 8.993H3.003c-.728 0-1.03.927-.442 1.352z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M5.122 20.692l10.236 7.389-3.909 11.955c-.449 1.377 1.137 2.523 2.315 1.672L24 34.318l10.238 7.39c1.175.85 2.764-.295 2.313-1.672l-3.91-11.955 10.237-7.389c1.177-.85.572-2.704-.884-2.704H29.34L25.43 6.033c-.45-1.377-2.41-1.377-2.86 0l-3.91 11.955H6.005c-1.456 0-2.061 1.853-.884 2.704z",
    clipRule: "evenodd"
  }))
};
var Rating = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2v,
    fill: "none"
  }));
});
var compPaths$2u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.223 10.726l3.675 2.695-1.403 4.363c-.162.502.408.92.83.61L12 15.697l3.675 2.697c.422.31.992-.108.83-.61l-1.403-4.363 3.675-2.695c.422-.31.205-.987-.318-.987h-4.542l-1.404-4.362a.538.538 0 00-1.026 0l-1.404 4.362H5.54c-.523 0-.74.676-.318.986z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.56 10.346l5.12 3.694-1.955 5.978c-.225.688.568 1.261 1.157.836L12 17.159l5.12 3.695c.587.425 1.381-.148 1.155-.836l-1.954-5.978 5.118-3.694c.589-.425.286-1.352-.442-1.352H14.67l-.166-.507-1.789-5.47c-.225-.69-1.205-.69-1.43 0L9.33 8.993H3.003c-.728 0-1.03.927-.442 1.352z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M5.122 20.692l10.236 7.389-3.909 11.955c-.449 1.377 1.137 2.523 2.315 1.672L24 34.318l10.238 7.39c1.175.85 2.764-.295 2.313-1.672l-3.91-11.955 10.237-7.389c1.177-.85.572-2.704-.884-2.704H29.34l-.333-1.014L25.43 6.033c-.45-1.377-2.41-1.377-2.86 0l-3.91 11.955H6.005c-1.456 0-2.061 1.853-.884 2.704z",
    clipRule: "evenodd"
  }))
};
var RatingFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2u,
    fill: "none"
  }));
});
var compPaths$2t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M5.223 10.726l3.675 2.695-1.403 4.363c-.162.502.408.92.83.61L12 15.697l3.675 2.697c.422.31.992-.108.83-.61l-1.403-4.363 3.675-2.695c.422-.31.205-.987-.318-.987h-4.542l-1.404-4.362a.538.538 0 00-1.026 0l-1.404 4.362H5.54c-.523 0-.74.676-.318.986z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M2.56 10.346l5.12 3.694-1.955 5.978c-.225.688.568 1.261 1.157.836L12 17.159l5.12 3.695c.587.425 1.381-.148 1.155-.836l-1.954-5.978 5.118-3.694c.589-.425.286-1.352-.442-1.352H14.67l-1.955-5.978c-.225-.688-1.205-.688-1.43 0L9.33 8.994H3.003c-.728 0-1.03.927-.442 1.352z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M5.122 20.692l10.236 7.389-3.909 11.955c-.449 1.377 1.137 2.523 2.315 1.672L24 34.318l10.238 7.39c1.175.85 2.764-.295 2.313-1.672l-3.91-11.955 10.237-7.389c1.177-.85.572-2.704-.884-2.704H29.34l-.333-1.014L25.43 6.033c-.45-1.377-2.41-1.377-2.86 0l-3.91 11.955H6.005c-1.456 0-2.061 1.853-.884 2.704z",
    clipRule: "evenodd"
  }))
};
var RatingStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2t,
    fill: "none"
  }));
});
var compPaths$2s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.5 6.75H18m-7.5 3H18m-7.5 3h6M6 20.25h12c1.24 0 2.25-1.01 2.25-2.25V3.75h-12V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 18c0 1.24-1.01 2.25-2.25 2.25S3.75 19.24 3.75 18v-5.25H6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.5 6.75H18m-7.5 3H18m-7.5 3h6M6 20.25h12c1.24 0 2.25-1.01 2.25-2.25V3.75h-12V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 18c0 1.24-1.01 2.25-2.25 2.25S3.75 19.24 3.75 18v-5.25H6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M21 13.5h15m-15 6h15m-15 6h12m-21 15h24c2.48 0 4.5-2.02 4.5-4.5V7.5h-24V36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.5 36c0 2.48-2.02 4.5-4.5 4.5S7.5 38.48 7.5 36V25.5H12"
  }))
};
var Receipt = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2s,
    fill: "none"
  }));
});
var compPaths$2r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.354 22.476L2.994 5.116l1.014-1.014 17.36 17.36-1.014 1.014z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 3H7.5v2.48L9 6.98V4.5h10.5v12.98l1.376 1.375c.08-.27.124-.558.124-.855V3zm-.93 17.17l-1.062-1.061c-.267.243-.62.391-1.008.391H8.597c.256-.442.403-.954.403-1.5V9.1L7.5 7.6V18c0 .826-.674 1.5-1.5 1.5s-1.5-.674-1.5-1.5v-4.5H6V12H3v6c0 1.654 1.346 3 3 3h12a2.99 2.99 0 002.07-.83zM11.9 12h-1.4v.5l1 1h1.9L11.9 12zm3.62 1.5h.98V12h-2.48l1.5 1.5zm-3-3H18V9h-6.98l1.5 1.5zm-2.02-3H18V6h-7.5v1.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.354 22.476L2.994 5.116l1.014-1.014 17.36 17.36-1.014 1.014z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 3H7.5v2.48L9 6.98V4.5h10.5v12.98l1.376 1.375c.08-.27.124-.558.124-.855V3zm-.93 17.17l-1.062-1.061c-.267.243-.62.391-1.008.391H8.597c.256-.442.403-.954.403-1.5V9.1L7.5 7.6V18c0 .826-.674 1.5-1.5 1.5s-1.5-.674-1.5-1.5v-4.5H6V12H3v6c0 1.654 1.346 3 3 3h12a2.99 2.99 0 002.07-.83zM11.9 12h-1.4v.5l1 1h1.9L11.9 12zm3.62 1.5h.98V12h-2.48l1.5 1.5zm-3-3H18V9h-6.98l1.5 1.5zm-2.02-3H18V6h-7.5v1.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M40.71 44.953L5.988 10.232l2.028-2.028 34.72 34.72-2.028 2.029z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M42 6H15v4.959l3 3V9h21v25.959l2.752 2.752A5.985 5.985 0 0042 36V6zm-1.861 34.34l-2.123-2.122A2.988 2.988 0 0136 39H17.195A5.964 5.964 0 0018 36V18.201l-3-3V36c0 1.652-1.348 3-3 3s-3-1.348-3-3v-9h3v-3H6v12c0 3.308 2.692 6 6 6h24a5.98 5.98 0 004.139-1.66zM23.799 24H21v1l2 2h3.799l-3-3zm7.242 3H33v-3h-4.959l3 3zm-6-6H36v-3H22.041l3 3zM21 15h15v-3H21v3z",
    clipRule: "evenodd"
  }))
};
var ReceiptNone = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2r,
    fill: "none"
  }));
});
var compPaths$2q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.27 6.02v3.73H8m10.98 4.23A7.256 7.256 0 0112 19.25c-4.01 0-7.25-3.24-7.25-7.25M12 4.75c4.01 0 7.25 3.24 7.25 7.25M5.15 9.8a7.238 7.238 0 016.91-5.05"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.73 17.98v-3.73H16"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.25 5.5v4.25H7.5m12.44 4.5c-.98 3.46-4.16 6-7.94 6-4.56 0-8.25-3.69-8.25-8.25M12 3.75c4.56 0 8.25 3.69 8.25 8.25M4.14 9.5A8.25 8.25 0 0112 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.75 18.5v-4.25H16.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M6.5 11v8.5H15m24.88 9c-1.96 6.92-8.32 12-15.88 12-9.12 0-16.5-7.38-16.5-16.5M24 7.5c9.12 0 16.5 7.38 16.5 16.5M8.28 19C10.38 12.34 16.64 7.5 24 7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M41.5 37v-8.5H33"
  }))
};
var Repeat = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2q,
    fill: "none"
  }));
});
var compPaths$2p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 6.02v3.73h3.73"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 4.75c4.01 0 7.25 3.24 7.25 7.25s-3.24 7.25-7.25 7.25S4.75 16.01 4.75 12m.34-2.2C6.02 6.88 8.77 4.75 12 4.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.5 19.86A8.25 8.25 0 0020.25 12m-17-6.5v4.25H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 3.75c4.56 0 8.25 3.69 8.25 8.25 0 4.56-3.69 8.25-8.25 8.25-4.56 0-8.25-3.69-8.25-8.25m.39-2.5A8.25 8.25 0 0112 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M6.5 11v8.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 7.5c9.12 0 16.5 7.38 16.5 16.5 0 9.12-7.38 16.5-16.5 16.5-9.12 0-16.5-7.38-16.5-16.5m.78-5C10.38 12.34 16.64 7.5 24 7.5"
  }))
};
var Replay = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2p,
    fill: "none"
  }));
});
var compPaths$2o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 21.75h-9c-1.242 0-2.25-1.191-2.25-2.66V4.91c0-1.469 1.008-2.66 2.25-2.66h6.75l4.5 4.5v12.34c0 1.469-1.008 2.66-2.25 2.66z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 6.75H15.5a1.5 1.5 0 01-1.5-1.5V2m2.25 10.5l-3 3-1.5-1.5L8 17.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 21.75h-9c-1.242 0-2.25-1.191-2.25-2.66V4.91c0-1.469 1.008-2.66 2.25-2.66h6.75l4.5 4.5v12.34c0 1.469-1.008 2.66-2.25 2.66z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 6.75H15.5a1.5 1.5 0 01-1.5-1.5V2m2.25 10.5l-3 3-1.5-1.5L8 17.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 43.5H15c-2.484 0-4.5-2.383-4.5-5.318V9.818C10.5 6.883 12.516 4.5 15 4.5h13.5l9 9v24.682c0 2.935-2.016 5.318-4.5 5.318z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M37.5 13.5H31a3 3 0 01-3-3V4m4.5 21l-6 6-3-3-7.5 7.5"
  }))
};
var Report = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2o,
    fill: "none"
  }));
});
var compPaths$2n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.26 21.35l-2.19-2.1 2.19-2.15M12 4.75v8.75m6.93-3.75H4.83"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.75 20V9.75l1.34-5h11.82l1.34 5V17c0 1.24-1.01 2.25-2.25 2.25H8.08"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 21V9.75l1.61-6h13.28l1.61 6V18c0 1.24-1.01 2.25-2.25 2.25m0 0H8m12.25-10.5H3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.71 22.9l-2.65-2.65 2.65-2.65M12 3.75v9.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.5 42V19.5l3.22-12h26.56l3.22 12V36c0 2.48-2.02 4.5-4.5 4.5m0 0H16m24.5-21h-33"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19.42 45.8l-5.3-5.3 5.3-5.3M24 7.5V27"
  }))
};
var Return = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2n,
    fill: "none"
  }));
});
var compPaths$2m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.5 9.5l5 5m0-5l-5 5m-3.75-5L6.25 14 4.5 12.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.5 9.5l5 5m0-5l-5 5m-3.75-5L6.25 14 4.5 12.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M29 19l10 10m0-10L29 29m-7.5-10l-9 9L9 24.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 37.5H1.5v-27H24m0 0h22.5v27H24"
  }))
};
var Review = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2m,
    fill: "none"
  }));
});
var compPaths$2l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 14.8l2.8-2.8-2.8-2.8V5.25H14.8L12 2.45l-2.8 2.8H5.25V9.2L2.45 12l2.8 2.8v3.95H9.2l2.8 2.8 2.8-2.8h3.95V14.8z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.45 9.35l-4.77 4.77-2.65-2.65"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 14.8l2.8-2.8-2.8-2.8V5.25H14.8L12 2.45l-2.8 2.8H5.25V9.2L2.45 12l2.8 2.8v3.95H9.2l2.8 2.8 2.8-2.8h3.95V14.8z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.45 9.35l-4.77 4.77-2.65-2.65"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M37.5 29.6l5.6-5.6-5.6-5.6v-7.9h-7.9L24 4.9l-5.6 5.6h-7.9v7.9L4.9 24l5.6 5.6v7.9h7.9l5.6 5.6 5.6-5.6h7.9v-7.9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M30.9 18.7l-9.54 9.54-5.3-5.3"
  }))
};
var Rewards = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2l,
    fill: "none"
  }));
});
var compPaths$2k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 15.71a5.245 5.245 0 010-7.42m7.42 0a5.245 5.245 0 010 7.42m-9.54 2.12c-3.22-3.22-3.22-8.45 0-11.67m11.66.01c3.22 3.22 3.22 8.45 0 11.67M12 14.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 15.71a5.245 5.245 0 010-7.42m7.42 0a5.245 5.245 0 010 7.42m-9.54 2.12c-3.22-3.22-3.22-8.45 0-11.67m11.66.01c3.22 3.22 3.22 8.45 0 11.67M12 14.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.58 31.42a10.49 10.49 0 010-14.84m14.84 0c4.1 4.1 4.1 10.74 0 14.84m-19.08 4.24c-6.44-6.44-6.44-16.9 0-23.34m23.32.02c6.44 6.44 6.44 16.9 0 23.34M24 28.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
  }))
};
var Rfid = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2k,
    fill: "none"
  }));
});
var compPaths$2j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 18v1.75a2 2 0 002 2H6m12 0h1.75a2 2 0 002-2V18m0-12V4.25a2 2 0 00-2-2H18m-12 0H4.25a2 2 0 00-2 2V6m11.5 0v12m-7-12v12m10.5-12v12m-7-12v12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 18v1.75a2 2 0 002 2H6m12 0h1.75a2 2 0 002-2V18m0-12V4.25a2 2 0 00-2-2H18m-12 0H4.25a2 2 0 00-2 2V6m11.5 0v12m-7-12v12m10.5-12v12m-7-12v12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M4.5 36v3.5a4 4 0 004 4H12m24 0h3.5a4 4 0 004-4V36m0-24V8.5a4 4 0 00-4-4H36m-24 0H8.5a4 4 0 00-4 4V12m23 0v24m-14-24v24m21-24v24m-14-24v24"
  }))
};
var Scan = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2j,
    fill: "none"
  }));
});
var compPaths$2i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.924 32.592A13.432 13.432 0 0121 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 017.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0121 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0134.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706"
  }))
};
var Search = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2i,
    fill: "none"
  }));
});
var compPaths$2h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.248 10.125a3.75 3.75 0 11-6.495 3.75 3.75 3.75 0 016.495-3.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.729 5.857h3.1l1.406 2.434-1.55 2.685a2.25 2.25 0 000 2.25l1.433 2.482-1.406 2.434h-2.866a2.25 2.25 0 00-1.95 1.125l-1.432 2.483h-2.81L9.22 19.267a2.25 2.25 0 00-1.95-1.125h-3.1L2.766 15.71l1.55-2.687a2.25 2.25 0 000-2.25L2.883 8.291l1.406-2.434h2.866a2.25 2.25 0 001.949-1.125l1.433-2.482h2.81l1.433 2.482a2.25 2.25 0 001.949 1.125z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.248 10.125a3.75 3.75 0 11-6.495 3.75 3.75 3.75 0 016.495-3.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.729 5.857h3.1l1.406 2.434-1.55 2.685a2.25 2.25 0 000 2.25l1.433 2.482-1.406 2.434h-2.866a2.25 2.25 0 00-1.95 1.125l-1.432 2.483h-2.81L9.22 19.267a2.25 2.25 0 00-1.95-1.125h-3.1L2.766 15.71l1.55-2.687a2.25 2.25 0 000-2.25L2.883 8.291l1.406-2.434h2.866a2.25 2.25 0 001.949-1.125l1.433-2.482h2.81l1.433 2.482a2.25 2.25 0 001.949 1.125z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.495 20.25a7.5 7.5 0 11-12.99 7.5 7.5 7.5 0 0112.99-7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.457 11.715h6.202l2.81 4.868-3.1 5.37a4.5 4.5 0 000 4.5l2.866 4.964-2.812 4.868H33.69a4.502 4.502 0 00-3.898 2.25L26.927 43.5h-5.62l-2.866-4.966a4.502 4.502 0 00-3.898-2.25H8.34l-2.81-4.866 3.1-5.372a4.5 4.5 0 000-4.5l-2.866-4.964 2.812-4.868h5.732a4.502 4.502 0 003.898-2.25L21.073 4.5h5.62l2.866 4.964a4.502 4.502 0 003.898 2.25z",
    clipRule: "evenodd"
  }))
};
var Settings = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2h,
    fill: "none"
  }));
});
var compPaths$2g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M20.33 11.35l1.77-3.06-1.84-3.18h-3.53c-.53 0-1.03-.29-1.3-.75L13.78 1.5H10.1L8.45 4.36c-.27.46-.76.75-1.3.75h-3.3L2.02 8.29l1.65 2.86c.27.46.27 1.04 0 1.5L1.9 15.71l1.84 3.18h3.53c.53 0 1.03.29 1.3.75l1.65 2.86h3.68l1.65-2.86c.27-.46.76-.75 1.3-.75h3.3l1.84-3.18-1.65-2.86c-.27-.46-.27-1.04-.01-1.5zM13.5 14.6c-1.43.83-3.27.33-4.1-1.1-.83-1.43-.33-3.27 1.1-4.1.46-.27.97-.4 1.49-.4.26 0 .52.04.78.1.77.21 1.42.7 1.82 1.4.84 1.43.34 3.27-1.09 4.1z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M20.33 11.35l1.77-3.06-1.84-3.18h-3.53c-.53 0-1.03-.29-1.3-.75L13.78 1.5H10.1L8.45 4.36c-.27.46-.76.75-1.3.75h-3.3L2.02 8.29l1.65 2.86c.27.46.27 1.04 0 1.5L1.9 15.71l1.84 3.18h3.53c.53 0 1.03.29 1.3.75l1.65 2.86h3.68l1.65-2.86c.27-.46.76-.75 1.3-.75h3.3l1.84-3.18-1.65-2.86c-.27-.46-.27-1.04-.01-1.5zM13.5 14.6c-1.43.83-3.27.33-4.1-1.1-.83-1.43-.33-3.27 1.1-4.1.46-.27.97-.4 1.49-.4.26 0 .52.04.78.1.77.21 1.42.7 1.82 1.4.84 1.43.34 3.27-1.09 4.1z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M40.66 22.7l3.54-6.12-3.68-6.36h-7.06a3.04 3.04 0 01-2.6-1.5L27.56 3H20.2l-3.3 5.72c-.54.92-1.52 1.5-2.6 1.5H7.7l-3.66 6.36 3.3 5.72c.54.92.54 2.08 0 3L3.8 31.42l3.68 6.36h7.06c1.06 0 2.06.58 2.6 1.5l3.3 5.72h7.36l3.3-5.72c.54-.92 1.52-1.5 2.6-1.5h6.6l3.68-6.36-3.3-5.72a3.03 3.03 0 01-.02-3zM27 29.2c-2.86 1.66-6.54.66-8.2-2.2-1.66-2.86-.66-6.54 2.2-8.2.92-.54 1.94-.8 2.98-.8.52 0 1.04.08 1.56.2 1.54.42 2.84 1.4 3.64 2.8 1.68 2.86.68 6.54-2.18 8.2z"
  }))
};
var SettingsFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2g,
    fill: "none"
  }));
});
var compPaths$2f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13v6A2.25 2.25 0 006 21.25h12A2.25 2.25 0 0020.25 19v-6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.552",
    d: "M12 19V4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.773 8.834l-4.772-4.773-4.774 4.773"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13v6A2.25 2.25 0 006 21.25h12A2.25 2.25 0 0020.25 19v-6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.552",
    d: "M12 19V4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.773 8.834l-4.772-4.773-4.774 4.773"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 26v12a4.5 4.5 0 004.5 4.5h24a4.5 4.5 0 004.5-4.5V26"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3.103",
    d: "M24 38V8"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.547 17.668l-9.546-9.546-9.548 9.546"
  }))
};
var Share = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2f,
    fill: "none"
  }));
});
var compPaths$2e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm0 12a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-12-6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.013 13.006L16 17m-.013-9.994l-7.975 3.987"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm0 12a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-12-6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.013 13.006L16 17m-.013-9.994l-7.975 3.987"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 24a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-24-12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.025 26.013L32 34m-.025-19.987l-15.95 7.974"
  }))
};
var Shareaos = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2e,
    fill: "none"
  }));
});
var compPaths$2d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 16.5a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm12 .033a2.25 2.25 0 11-4.502-.001 2.25 2.25 0 014.502.001z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 16.565H8.5M.75 11.5V14A2.25 2.25 0 003 16.25h.25m16.25-6.5H3A2.25 2.25 0 01.75 7.5V5.25h17.189c.2 0 .39.079.531.22l4.56 4.56a.75.75 0 01.22.531v3.689A2.25 2.25 0 0121 16.5h-.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 16.5a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm12 .033a2.25 2.25 0 11-4.502-.001 2.25 2.25 0 014.502.001z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 16.565H8.5M.75 11.5V14A2.25 2.25 0 003 16.25h.25m16.25-6.5H3A2.25 2.25 0 01.75 7.5V5.25h17.189c.2 0 .39.079.531.22l4.56 4.56a.75.75 0 01.22.531v3.689A2.25 2.25 0 0121 16.5h-.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 33a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm24 .066c0 2.484-2.016 4.5-4.5 4.5a4.5 4.5 0 114.5-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 33.13H17M1.5 23v5A4.5 4.5 0 006 32.5h.5m32.5-13H6A4.5 4.5 0 011.5 15v-4.5h34.378c.4 0 .78.158 1.062.44l9.12 9.12c.282.282.44.662.44 1.062V28.5c0 2.484-2.016 4.5-4.5 4.5h-1.5"
  }))
};
var Shipping = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2d,
    fill: "none"
  }));
});
var compPaths$2c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.366 6.5l1.51 2.636a2.819 2.819 0 01-1.02 3.835l-7.865 4.574a5.203 5.203 0 01-2.614.705H5.859c-1.11 0-1.53-1.462-.59-2.057a4.284 4.284 0 001.422-1.488l4.093-7.143c2.482.67 5.032-.813 5.698-3.312"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.977-.026.505.104.967.414 1.132.56.298 1.132-.32 1.467-.763L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.872 13.976c-.789-.087-.836-1.146-.826-1.475-.099.454-.197.908-.22 1.354-.037.699.143 1.339.573 1.567.775.413 1.567-.442 2.032-1.056l4.315-5.701-4.777 4.744c-.402.396-.79.598-1.097.567z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.222 4.556l2.032 3.52a3.75 3.75 0 01-1.372 5.123L9.3 19.308a7.039 7.039 0 01-3.517.942H3.742c-1.494 0-2.057-1.952-.793-2.747a5.74 5.74 0 001.913-1.987l5.506-9.54a6.258 6.258 0 007.665-4.424"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.744 27.951c-1.578-.174-1.672-2.292-1.652-2.95-.198.908-.394 1.816-.44 2.708-.074 1.398.286 2.678 1.146 3.134 1.55.826 3.134-.884 4.064-2.112l8.63-11.402-9.554 9.488c-.804.792-1.582 1.196-2.194 1.134z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M38.443 9.112l4.064 7.042a7.499 7.499 0 01-2.744 10.244L18.601 38.614a14.077 14.077 0 01-7.034 1.884H7.483c-2.988 0-4.114-3.904-1.586-5.494a11.48 11.48 0 003.826-3.974l11.012-19.08c6.678 1.79 13.54-2.171 15.33-8.847"
  }))
};
var Shoe = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2c,
    fill: "none"
  }));
});
var compPaths$2b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.366 6.5l1.51 2.636a2.819 2.819 0 01-1.02 3.835l-7.865 4.574a5.203 5.203 0 01-2.614.705H5.859c-1.11 0-1.53-1.462-.59-2.057a4.284 4.284 0 001.422-1.488l4.093-7.143c2.482.67 5.032-.813 5.698-3.312"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.977-.026.505.104.967.414 1.132.56.298 1.132-.32 1.467-.763L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.43 14.366c-.464.614-1.256 1.469-2.03 1.056-.431-.228-.611-.868-.573-1.567.022-.447.12-.901.219-1.355-.01.33.037 1.389.827 1.476.305.03.695-.172 1.096-.568l4.777-4.743-4.315 5.7zM21.905 7.7L19.87 4.18l-1.217-2.11c.034-.11.074-.214.103-.325l-1.45-.39a5.514 5.514 0 01-6.744 3.896l-.557-.15L4.211 15.14a4.999 4.999 0 01-1.663 1.727 2.222 2.222 0 00-.96 2.514A2.221 2.221 0 003.743 21h2.042a7.8 7.8 0 003.892-1.043l10.58-6.11a4.473 4.473 0 002.098-2.731 4.476 4.476 0 00-.45-3.415z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.861 28.731c-.93 1.228-2.514 2.938-4.062 2.112-.862-.456-1.222-1.736-1.146-3.134.044-.894.242-1.802.438-2.71-.02.66.074 2.778 1.654 2.952.61.062 1.39-.344 2.192-1.136l9.554-9.486-8.63 11.402zm20.946-13.33l-4.066-7.04-2.434-4.22c.068-.218.148-.428.206-.65l-2.898-.778c-1.57 5.868-7.626 9.36-13.49 7.79l-1.114-.298L8.423 30.281a9.998 9.998 0 01-3.326 3.454 4.443 4.443 0 00-1.918 5.028A4.442 4.442 0 007.483 42h4.084c2.728 0 5.42-.722 7.784-2.086l21.162-12.218a8.947 8.947 0 004.194-5.464 8.953 8.953 0 00-.9-6.83z",
    clipRule: "evenodd"
  }))
};
var ShoeFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2b,
    fill: "none"
  }));
});
var compPaths$2a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.366 6.5l1.51 2.636a2.819 2.819 0 01-1.02 3.835l-7.865 4.574a5.203 5.203 0 01-2.614.705H5.859c-1.11 0-1.53-1.462-.59-2.057a4.284 4.284 0 001.422-1.488l4.093-7.143c2.482.67 5.032-.813 5.698-3.312"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.977-.026.505.104.967.414 1.132.56.298 1.132-.32 1.467-.763L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.872 13.976c-.789-.087-.836-1.146-.826-1.475-.099.454-.197.908-.22 1.354-.037.699.143 1.339.573 1.567.775.413 1.567-.442 2.032-1.056l4.315-5.701-4.777 4.744c-.402.396-.79.598-1.097.567z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M19.222 4.556l2.032 3.52a3.75 3.75 0 01-1.372 5.123L9.3 19.308a7.039 7.039 0 01-3.517.942H3.742c-1.494 0-2.057-1.952-.793-2.747a5.74 5.74 0 001.913-1.987l5.506-9.54a6.258 6.258 0 007.665-4.424"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.744 27.951c-1.578-.174-1.672-2.292-1.652-2.95-.198.908-.394 1.816-.44 2.708-.074 1.398.286 2.678 1.146 3.134 1.55.826 3.134-.884 4.064-2.112l8.63-11.402-9.554 9.488c-.804.792-1.582 1.196-2.194 1.134z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M38.443 9.112l4.064 7.042a7.499 7.499 0 01-2.744 10.244L18.601 38.614a14.077 14.077 0 01-7.034 1.884H7.483c-2.988 0-4.114-3.904-1.586-5.494a11.48 11.48 0 003.826-3.974l11.012-19.08c6.678 1.79 13.54-2.171 15.33-8.847"
  }))
};
var ShoeStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2a,
    fill: "none"
  }));
});
var compPaths$29 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M0 16.5h9m-9 9h9m24.924 7.092A13.432 13.432 0 0127 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 0113.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0127 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0140.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706"
  }))
};
var ShopnikeApp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$29,
    fill: "none"
  }));
});
var compPaths$28 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 9h4.5V7.501H0V9zm0 4.5h4.5v-1.499H0V13.5zm20.148 2.587c-.463-.463-.532-1.187-.172-1.801.016-.028.027-.057.043-.085a7.51 7.51 0 00.398-.799l.008-.022c.112-.269.203-.545.284-.827.021-.075.039-.15.058-.227a7.69 7.69 0 00.137-.681c.012-.08.026-.157.036-.237.036-.298.06-.6.06-.907 0-.255-.013-.509-.038-.76-.006-.06-.019-.118-.026-.179a7.597 7.597 0 00-.087-.564c-.01-.048-.024-.093-.034-.14a7.637 7.637 0 00-.15-.582l-.032-.087a7.165 7.165 0 00-.221-.605c-.007-.018-.016-.034-.024-.05a7.16 7.16 0 00-.292-.606l-.031-.053a7.35 7.35 0 00-.343-.563c-.032-.05-.071-.095-.105-.142-.105-.147-.209-.294-.325-.435a7.502 7.502 0 00-1.028-1.027 7.103 7.103 0 00-.434-.325c-.048-.034-.093-.073-.142-.106a8.117 8.117 0 00-.563-.342c-.019-.01-.035-.022-.053-.032a7.17 7.17 0 00-.606-.29l-.05-.026a7.675 7.675 0 00-.605-.22c-.03-.01-.058-.023-.087-.032a7.886 7.886 0 00-.582-.15c-.047-.01-.093-.025-.14-.035a8.158 8.158 0 00-.564-.086c-.061-.007-.119-.02-.18-.026a7.618 7.618 0 00-1.516 0c-.061.006-.119.02-.179.026-.19.024-.379.05-.565.086-.047.01-.093.025-.14.035-.195.044-.39.091-.582.15-.029.01-.057.022-.086.031a7.393 7.393 0 00-.605.221l-.051.025a7.32 7.32 0 00-.606.291l-.052.032a7.907 7.907 0 00-.564.342c-.049.033-.094.072-.142.106a7.103 7.103 0 00-.434.325 7.502 7.502 0 00-1.028 1.027c-.116.141-.22.288-.325.435-.034.047-.072.092-.105.142a7.034 7.034 0 00-.342.563l-.032.053a7.16 7.16 0 00-.292.605c-.007.017-.017.033-.024.051-.084.198-.155.4-.221.605l-.032.087a7.631 7.631 0 00-.149.582c-.011.047-.025.092-.035.14a7.103 7.103 0 00-.086.564c-.008.061-.021.12-.027.18a7.654 7.654 0 000 1.516c.006.06.019.12.027.18.023.19.048.378.086.564.01.047.024.092.035.14.044.196.09.39.149.582.01.03.022.057.032.086.066.205.137.407.221.605.007.019.017.035.024.052.089.205.184.407.292.604l.032.053c.106.192.218.381.342.564.033.05.071.095.105.143.105.146.209.293.325.434.309.374.653.718 1.028 1.027.14.115.287.22.434.324.048.035.093.073.142.107.183.123.372.236.564.341.018.01.034.023.052.032.198.107.4.203.606.291l.051.026c.197.082.4.154.605.22.029.01.057.023.086.032.192.059.387.105.582.15.047.01.093.024.14.034.186.038.375.063.565.087.06.006.118.02.179.026.25.024.503.038.758.038.312 0 .617-.024.919-.061.082-.01.162-.026.243-.038.236-.037.467-.084.695-.142.074-.02.148-.035.221-.056.295-.085.584-.183.862-.302.016-.006.03-.015.045-.021a7.42 7.42 0 00.759-.389c.034-.018.07-.032.103-.052l-.004-.006a7.59 7.59 0 001.103-.805c.14.377.348.727.641 1.02l3.854 3.854 1.061-1.06-3.854-3.855z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 9h4.5V7.501H0V9zm0 4.5h4.5v-1.499H0V13.5zm20.148 2.587c-.463-.463-.532-1.187-.172-1.801.016-.028.027-.057.043-.085a7.51 7.51 0 00.398-.799l.008-.022c.112-.269.203-.545.284-.827.021-.075.039-.15.058-.227a7.69 7.69 0 00.137-.681c.012-.08.026-.157.036-.237.036-.298.06-.6.06-.907 0-.255-.013-.509-.038-.76-.006-.06-.019-.118-.026-.179a7.597 7.597 0 00-.087-.564c-.01-.048-.024-.093-.034-.14a7.637 7.637 0 00-.15-.582l-.032-.087a7.165 7.165 0 00-.221-.605c-.007-.018-.016-.034-.024-.05a7.16 7.16 0 00-.292-.606l-.031-.053a7.35 7.35 0 00-.343-.563c-.032-.05-.071-.095-.105-.142-.105-.147-.209-.294-.325-.435a7.502 7.502 0 00-1.028-1.027 7.103 7.103 0 00-.434-.325c-.048-.034-.093-.073-.142-.106a8.117 8.117 0 00-.563-.342c-.019-.01-.035-.022-.053-.032a7.17 7.17 0 00-.606-.29l-.05-.026a7.675 7.675 0 00-.605-.22c-.03-.01-.058-.023-.087-.032a7.886 7.886 0 00-.582-.15c-.047-.01-.093-.025-.14-.035a8.158 8.158 0 00-.564-.086c-.061-.007-.119-.02-.18-.026a7.618 7.618 0 00-1.516 0c-.061.006-.119.02-.179.026-.19.024-.379.05-.565.086-.047.01-.093.025-.14.035-.195.044-.39.091-.582.15-.029.01-.057.022-.086.031a7.393 7.393 0 00-.605.221l-.051.025a7.32 7.32 0 00-.606.291l-.052.032a7.907 7.907 0 00-.564.342c-.049.033-.094.072-.142.106a7.103 7.103 0 00-.434.325 7.502 7.502 0 00-1.028 1.027c-.116.141-.22.288-.325.435-.034.047-.072.092-.105.142a7.034 7.034 0 00-.342.563l-.032.053a7.16 7.16 0 00-.292.605c-.007.017-.017.033-.024.051-.084.198-.155.4-.221.605l-.032.087a7.631 7.631 0 00-.149.582c-.011.047-.025.092-.035.14a7.103 7.103 0 00-.086.564c-.008.061-.021.12-.027.18a7.654 7.654 0 000 1.516c.006.06.019.12.027.18.023.19.048.378.086.564.01.047.024.092.035.14.044.196.09.39.149.582.01.03.022.057.032.086.066.205.137.407.221.605.007.019.017.035.024.052.089.205.184.407.292.604l.032.053c.106.192.218.381.342.564.033.05.071.095.105.143.105.146.209.293.325.434.309.374.653.718 1.028 1.027.14.115.287.22.434.324.048.035.093.073.142.107.183.123.372.236.564.341.018.01.034.023.052.032.198.107.4.203.606.291l.051.026c.197.082.4.154.605.22.029.01.057.023.086.032.192.059.387.105.582.15.047.01.093.024.14.034.186.038.375.063.565.087.06.006.118.02.179.026.25.024.503.038.758.038.312 0 .617-.024.919-.061.082-.01.162-.026.243-.038.236-.037.467-.084.695-.142.074-.02.148-.035.221-.056.295-.085.584-.183.862-.302.016-.006.03-.015.045-.021a7.42 7.42 0 00.759-.389c.034-.018.07-.032.103-.052l-.004-.006a7.59 7.59 0 001.103-.805c.14.377.348.727.641 1.02l3.854 3.854 1.061-1.06-3.854-3.855z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 18h9v-2.998H0V18zm0 9h9v-2.998H0V27zm40.296 5.175c-.926-.926-1.064-2.374-.344-3.604.032-.056.054-.114.086-.17a15.02 15.02 0 00.796-1.596c.006-.016.01-.032.016-.046a15.03 15.03 0 00.568-1.652c.042-.15.078-.302.116-.454.112-.448.202-.902.274-1.364.024-.158.052-.314.072-.474.072-.596.12-1.2.12-1.814 0-.51-.026-1.016-.076-1.518-.012-.12-.038-.236-.052-.358a15.195 15.195 0 00-.174-1.128c-.02-.096-.048-.186-.068-.28a15.273 15.273 0 00-.3-1.164c-.02-.058-.044-.116-.064-.174a14.33 14.33 0 00-.442-1.21c-.014-.036-.032-.068-.048-.102a14.319 14.319 0 00-.584-1.21l-.062-.106a14.7 14.7 0 00-.686-1.126c-.064-.1-.142-.19-.21-.284-.21-.294-.418-.588-.65-.87a15.001 15.001 0 00-2.056-2.054c-.28-.232-.574-.442-.868-.65-.096-.068-.186-.146-.284-.212-.366-.246-.744-.47-1.126-.684-.038-.02-.07-.044-.106-.064-.394-.214-.8-.406-1.212-.582l-.1-.05a15.35 15.35 0 00-1.21-.442c-.06-.018-.116-.044-.174-.062a15.772 15.772 0 00-1.164-.3c-.094-.02-.186-.05-.28-.07-.372-.074-.75-.124-1.128-.172-.122-.014-.238-.04-.36-.052a15.236 15.236 0 00-3.032 0c-.122.012-.238.038-.358.052-.38.048-.758.098-1.13.172-.094.02-.186.05-.28.07-.39.088-.78.182-1.164.3-.058.018-.114.044-.172.062-.41.132-.816.276-1.21.442-.036.016-.068.034-.102.05a14.64 14.64 0 00-1.212.582c-.036.02-.068.044-.104.064-.384.214-.762.438-1.128.684-.098.066-.188.144-.284.212-.294.208-.588.418-.868.65a15.001 15.001 0 00-2.056 2.054c-.232.282-.44.576-.65.87-.068.094-.144.184-.21.284-.248.364-.472.742-.684 1.126-.022.036-.044.07-.064.106-.216.394-.406.798-.584 1.21-.014.034-.034.066-.048.102-.168.396-.31.8-.442 1.21-.02.058-.044.116-.064.174-.118.382-.21.772-.298 1.164-.022.094-.05.184-.07.28-.076.372-.126.75-.172 1.128-.016.122-.042.238-.054.358a15.307 15.307 0 000 3.034c.012.12.038.238.054.358.046.38.096.758.172 1.13.02.094.048.184.07.278.088.392.18.782.298 1.164.02.06.044.116.064.174.132.41.274.814.442 1.21.014.036.034.068.048.102.178.412.368.816.584 1.21.02.036.042.07.064.106.212.384.436.762.684 1.128.066.098.142.188.21.284.21.294.418.588.65.868.618.75 1.306 1.438 2.056 2.056.28.23.574.44.868.648.096.068.186.146.284.212.366.246.744.472 1.128.684.036.02.068.044.104.064.396.214.8.406 1.212.582.034.016.066.034.102.05.394.166.8.31 1.21.442.058.02.114.044.172.062.384.118.774.212 1.164.3.094.02.186.05.28.07.372.074.75.124 1.13.172.12.014.236.04.358.054.5.048 1.006.076 1.516.076.624 0 1.234-.05 1.838-.124.164-.02.324-.05.486-.076.472-.072.934-.168 1.39-.284.148-.038.296-.07.442-.112.59-.17 1.168-.366 1.724-.604.032-.012.06-.03.09-.042a14.84 14.84 0 001.518-.776c.068-.038.14-.064.206-.104l-.008-.014a15.181 15.181 0 002.206-1.608c.28.752.696 1.452 1.282 2.04l7.708 7.706 2.122-2.12-7.708-7.708z",
    clipRule: "evenodd"
  }))
};
var ShopnikeAppFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$28,
    fill: "none"
  }));
});
var compPaths$27 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.632 3.632"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.632 3.632"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M0 16.5h9m-9 9h9m24.924 7.092A13.432 13.432 0 0127 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 0113.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0127 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0140.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422L46.5 40.5"
  }))
};
var ShopnikeAppStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$27,
    fill: "none"
  }));
});
var compPaths$26 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.704-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 13.5a9.044 9.044 0 008.625-6.328c.34-1.084 1.681-1.446 2.488-.64l7.081 7.08a4.49 4.49 0 010 6.348L21.635 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.135-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var Shopnrc = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$26,
    fill: "none"
  }));
});
var compPaths$25 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.704-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 13.5a9.044 9.044 0 008.625-6.328c.34-1.084 1.681-1.446 2.488-.64l7.081 7.08a4.49 4.49 0 010 6.348L21.635 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.135-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var ShopnrcStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$25,
    fill: "none"
  }));
});
var compPaths$24 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.39 14.31c-.96-.71-.23-2.12.03-2.54-.47.52-.94 1.03-1.3 1.59-.57.88-.82 1.85-.43 2.47.7 1.12 2.37.6 3.43.15L21 11.81l-9.76 2.58c-.82.21-1.48.19-1.85-.08z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M23.25 4.5v12c0 1.24-1.01 2.25-2.25 2.25H3c-1.24 0-2.25-1.01-2.25-2.25v-1.93l8.76-5.06c.17-.1.33-.22.47-.36l3.9-3.9h4.13c1.24 0 2.25 1.01 2.25 2.25V9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.39 14.31c-.96-.71-.23-2.12.03-2.54-.47.52-.94 1.03-1.3 1.59-.57.88-.82 1.85-.43 2.47.7 1.12 2.37.6 3.43.15L21 11.81l-9.76 2.58c-.82.21-1.48.19-1.85-.08z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M23.25 4.5v12c0 1.24-1.01 2.25-2.25 2.25H3c-1.24 0-2.25-1.01-2.25-2.25v-1.93l8.76-5.06c.17-.1.33-.22.47-.36l3.9-3.9h4.13c1.24 0 2.25 1.01 2.25 2.25V9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.78 28.62c-1.92-1.42-.46-4.24.06-5.08-.94 1.04-1.88 2.06-2.6 3.18-1.14 1.76-1.64 3.7-.86 4.94 1.4 2.24 4.74 1.2 6.86.3L42 23.62l-19.52 5.16c-1.64.42-2.96.38-3.7-.16z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M46.5 9v24c0 2.48-2.02 4.5-4.5 4.5H6c-2.48 0-4.5-2.02-4.5-4.5v-3.86l17.52-10.12c.34-.2.66-.44.94-.72l7.8-7.8h8.26c2.48 0 4.5 2.02 4.5 4.5v3"
  }))
};
var ShopSNKRS = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$24,
    fill: "none"
  }));
});
var compPaths$23 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.602 11.566a.74.74 0 010 .867C20.54 13.924 16.73 18.75 12 18.75s-8.532-4.828-9.593-6.318a.74.74 0 010-.864C3.468 10.078 7.27 5.25 12 5.25c4.73 0 8.54 4.826 9.602 6.316z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.602 11.566a.74.74 0 010 .867C20.54 13.924 16.73 18.75 12 18.75s-8.532-4.828-9.593-6.318a.74.74 0 010-.864C3.468 10.078 7.27 5.25 12 5.25c4.73 0 8.54 4.826 9.602 6.316z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 24a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.204 23.133a1.48 1.48 0 010 1.734C41.078 27.847 33.46 37.5 24 37.5c-9.462 0-17.064-9.656-19.186-12.636a1.48 1.48 0 010-1.73C6.936 20.155 14.538 10.5 24 10.5c9.46 0 17.078 9.652 19.204 12.632z",
    clipRule: "evenodd"
  }))
};
var Show = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$23,
    fill: "none"
  }));
});
var compPaths$22 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.28 18.4l2.65-2.65-2.65-2.65m0-2.2l2.65-2.65-2.65-2.65"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 8.25h-4.14c-.62 0-1.18.25-1.59.66l-6.18 6.18c-.41.41-.97.66-1.59.66H3m6.09-5.34l-1.5-1.5c-.41-.41-.97-.66-1.59-.66H3m16.5 7.5h-4.14c-.62 0-1.18-.25-1.59-.66l-1.5-1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.28 18.4l2.65-2.65-2.65-2.65m0-2.2l2.65-2.65-2.65-2.65"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 8.25h-4.14c-.62 0-1.18.25-1.59.66l-6.18 6.18c-.41.41-.97.66-1.59.66H3m6.09-5.34l-1.5-1.5c-.41-.41-.97-.66-1.59-.66H3m16.5 7.5h-4.14c-.62 0-1.18-.25-1.59-.66l-1.5-1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.559 36.8l5.3-5.3-5.3-5.3m0-4.4l5.3-5.3-5.3-5.3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M39 16.5h-8.28c-1.24 0-2.36.5-3.18 1.32L15.18 30.18c-.82.82-1.94 1.32-3.18 1.32H6m12.18-10.68l-3-3A4.474 4.474 0 0012 16.5H6m33 15h-8.28c-1.24 0-2.36-.5-3.18-1.32l-3-3"
  }))
};
var Shuffle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$22,
    fill: "none"
  }));
});
var compPaths$21 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 7.5v9c0 1.24-1.01 2.25-2.25 2.25H9c-1.24 0-2.25-1.01-2.25-2.25v-9c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25zm-16.5 3.75v1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 7.5v9c0 1.24-1.01 2.25-2.25 2.25H9c-1.24 0-2.25-1.01-2.25-2.25v-9c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25zm-16.5 3.75v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 15v18c0 2.48-2.02 4.5-4.5 4.5H18c-2.48 0-4.5-2.02-4.5-4.5V15c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5zm-33 7.5v3"
  }))
};
var SingleSelect = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$21,
    fill: "none"
  }));
});
var compPaths$20 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.925 16.229l-3.712 3.713-3.713-3.713M17.212 20V4.5M3.075 7.772l3.712-3.713L10.5 7.772M6.788 4v15.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.925 16.229l-3.712 3.713-3.713-3.713M17.212 20V4.5M3.075 7.772l3.712-3.713L10.5 7.772M6.788 4v15.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M41.85 32.457l-7.427 7.426L27 32.457M34.424 40V9M6.15 15.543l7.426-7.426L21 15.543M13.576 8v31"
  }))
};
var Sort = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$20,
    fill: "none"
  }));
});
var compPaths$1$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 14.25H3m4.5-4.5H3m13.5 9H3m10.5-9.46l3.71-3.71 3.71 3.71M17.25 15V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 14.25H3m4.5-4.5H3m13.5 9H3m10.5-9.46l3.71-3.71 3.71 3.71M17.25 15V6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 28.5H6m9-9H6m27 18H6m21-18.92l7.42-7.42 7.42 7.42M34.5 30V12"
  }))
};
var SortAscending$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1$,
    fill: "none"
  }));
});
var compPaths$1_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12.01 9.75h-9m4.5 4.5h-4.5m13.5-9H3.01M17.26 9v9m3.71-3.27l-3.71 3.71-3.71-3.71"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12.01 9.75h-9m4.5 4.5h-4.5m13.5-9H3.01M17.26 9v9m3.71-3.27l-3.71 3.71-3.71-3.71"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24.02 19.5h-18m9 9h-9m27-18h-27m28.5 7.5v18m7.422-6.54l-7.42 7.42-7.42-7.42"
  }))
};
var SortDescending$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1_,
    fill: "none"
  }));
});
var compPaths$1Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.25 6v9.75c0 .827-.765 1.5-1.704 1.5H7.455c-.94 0-1.705-.673-1.705-1.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 17v-6h6v6m-3-5.5V17M4 6.75h16"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 5.25V16.5c0 1.24-1.01 2.25-2.25 2.25H6c-1.24 0-2.25-1.01-2.25-2.25V5.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 18.5v-7.25h7.5v7.25M12 11.25v7.25M1.5 5.25h21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 10.5V33c0 2.48-2.02 4.5-4.5 4.5H12c-2.48 0-4.5-2.02-4.5-4.5V10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.5 37V22.5h15V37M24 22.5V37M3 10.5h42"
  }))
};
var Store = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1Z,
    fill: "none"
  }));
});
var compPaths$1Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 16.51v-9c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v9c0 1.24-1.01 2.25-2.25 2.25h-15c-1.24 0-2.25-1.01-2.25-2.25zm3-6.01v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 16.51v-9c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v9c0 1.24-1.01 2.25-2.25 2.25h-15c-1.24 0-2.25-1.01-2.25-2.25zm3-6.01v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M4.5 33.02v-18c0-2.48 2.02-4.5 4.5-4.5h30c2.48 0 4.5 2.02 4.5 4.5v18c0 2.48-2.02 4.5-4.5 4.5H9c-2.48 0-4.5-2.02-4.5-4.5zm6-12.02v6"
  }))
};
var TabletHorizontal = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1Y,
    fill: "none"
  }));
});
var compPaths$1X = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.51 21.75h-9c-1.24 0-2.25-1.01-2.25-2.25v-15c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25v15c0 1.24-1.01 2.25-2.25 2.25zm-6.01-3h3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.51 21.75h-9c-1.24 0-2.25-1.01-2.25-2.25v-15c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25v15c0 1.24-1.01 2.25-2.25 2.25zm-6.01-3h3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.02 43.5h-18c-2.48 0-4.5-2.02-4.5-4.5V9c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5v30c0 2.48-2.02 4.5-4.5 4.5zM21 37.5h6"
  }))
};
var TabletVertical = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1X,
    fill: "none"
  }));
});
var compPaths$1W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 3.75h7.42l9.93 9.93c.86.86.86 2.25 0 3.11l-4.31 4.31c-.86.86-2.25.86-3.11 0l-9.93-9.93V3.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 3.75h7.42l9.93 9.93c.86.86.86 2.25 0 3.11l-4.31 4.31c-.86.86-2.25.86-3.11 0l-9.93-9.93V3.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.5 7.5h14.84L42.2 27.36a4.394 4.394 0 010 6.22l-8.62 8.62a4.394 4.394 0 01-6.22 0L7.5 22.34V7.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M18 22.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
  }))
};
var Tag = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1W,
    fill: "none"
  }));
});
var compPaths$1V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 9c0-1.86.76-3.55 1.98-4.77A6.735 6.735 0 0111 2.25h6.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-.75 1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-7.68c-.38 0-.63.42-.43.75l1.73 3c.41.72.17 1.63-.55 2.05-.72.41-1.63.17-2.05-.55l-4.15-7.2A6.58 6.58 0 014.25 9zm0 0c0-3.73 3.02-6.75 6.75-6.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 9c0-1.86.76-3.55 1.98-4.77A6.735 6.735 0 0111 2.25h6.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-.75 1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-7.68c-.38 0-.63.42-.43.75l1.73 3c.41.72.17 1.63-.55 2.05-.72.41-1.63.17-2.05-.55l-4.15-7.2A6.58 6.58 0 014.25 9zm0 0c0-3.73 3.02-6.75 6.75-6.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M8.5 18c0-3.72 1.52-7.1 3.96-9.54A13.47 13.47 0 0122 4.5h12.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H33h3.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H33h3.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H33h3.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H21.14c-.76 0-1.26.84-.86 1.5l3.46 6c.82 1.44.34 3.26-1.1 4.1-1.44.82-3.26.34-4.1-1.1l-8.3-14.4C9.12 22.66 8.5 20.4 8.5 18zm0 0c0-7.46 6.04-13.5 13.5-13.5"
  }))
};
var ThumbsDown = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1V,
    fill: "none"
  }));
});
var compPaths$1U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 13.5c0 1.86.76 3.55 1.98 4.77A6.735 6.735 0 0011 20.25h6.25c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.75 1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-7.68c-.38 0-.63-.42-.43-.75l1.73-3A1.501 1.501 0 009.27 3l-4.15 7.2c-.56.97-.87 2.1-.87 3.3zm0 0c0 3.73 3.02 6.75 6.75 6.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 13.5c0 1.86.76 3.55 1.98 4.77A6.735 6.735 0 0011 20.25h6.25c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.75 1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-7.68c-.38 0-.63-.42-.43-.75l1.73-3A1.501 1.501 0 009.27 3l-4.15 7.2c-.56.97-.87 2.1-.87 3.3zm0 0c0 3.73 3.02 6.75 6.75 6.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M8.5 27c0 3.72 1.52 7.1 3.96 9.54A13.47 13.47 0 0022 40.5h12.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H21.14c-.76 0-1.26-.84-.86-1.5l3.46-6c.82-1.44.34-3.26-1.1-4.1-1.44-.82-3.28-.34-4.1 1.1l-8.3 14.4C9.12 22.34 8.5 24.6 8.5 27zm0 0c0 7.46 6.04 13.5 13.5 13.5"
  }))
};
var ThumbsUp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1U,
    fill: "none"
  }));
});
var compPaths$1T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 7v5h5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.25 12a7.25 7.25 0 11-14.5 0 7.25 7.25 0 0114.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 6v6h5.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 12a8.25 8.25 0 11-16.5 0 8.25 8.25 0 1116.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 12v12h10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 24c0 9.114-7.388 16.5-16.5 16.5S7.5 33.114 7.5 24 14.888 7.5 24 7.5 40.5 14.886 40.5 24z",
    clipRule: "evenodd"
  }))
};
var Time = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1T,
    fill: "none"
  }));
});
var compPaths$1S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M10.285 16.131h-.75v.75h.75v-.75zm3.429 0v.75h.75v-.75h-.75zm-3.429-1.352h.75v-.432l-.374-.217-.376.65zm3.429 0l-.376-.649-.374.217v.432h.75zM11.249 4v2.286h1.5V4h-1.5zM4 12.75h2.286v-1.5H4v1.5zm13.714 0H20v-1.5h-2.286v1.5zM5.834 6.928L7.45 8.544l1.06-1.06-1.616-1.617-1.06 1.06zm11.27-1.061L15.49 7.483l1.06 1.06 1.617-1.615-1.061-1.061zM9.553 20h4.894v-1.5H9.552V20zm-.23-8.19a2.678 2.678 0 012.678-2.679v-1.5a4.179 4.179 0 00-4.179 4.178h1.5zM12 9.13c1.479 0 2.678 1.2 2.678 2.678h1.5A4.179 4.179 0 0012 7.631v1.5zm-1.715 7.75h3.429v-1.5h-3.429v1.5zm.376-2.75a2.677 2.677 0 01-1.34-2.322h-1.5a4.18 4.18 0 002.089 3.62l.75-1.299zm-1.126.648v1.352h1.5v-1.352h-1.5zm5.143-2.97c0 .991-.537 1.857-1.34 2.321l.752 1.299a4.177 4.177 0 002.088-3.62h-1.5zm-1.714 2.97v1.352h1.5v-1.352h-1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.75 17.75H9v.75h.75v-.75zm4.5 0v.75H15v-.75h-.75zm-4.5-2.102h.75v-.433L10.126 15l-.376.649zm4.5 0l-.376-.65-.374.217v.433h.75zm-3-14.148v3h1.5v-3h-1.5zM1.5 12.75h3v-1.5h-3v1.5zm18 0h3v-1.5h-3v1.5zM4.073 5.177l2.121 2.121 1.061-1.06-2.121-2.122-1.06 1.06zm14.793-1.06l-2.12 2.12 1.06 1.061 2.121-2.121-1.06-1.06zM9 21h6v-1.5H9V21zm-.75-9.25A3.75 3.75 0 0112 8V6.5a5.25 5.25 0 00-5.25 5.25h1.5zM12 8a3.75 3.75 0 013.75 3.75h1.5c0-2.9-2.35-5.25-5.25-5.25V8zM9.75 18.5h4.5V17h-4.5v1.5zm.376-3.501A3.748 3.748 0 018.25 11.75h-1.5a5.248 5.248 0 002.625 4.547l.75-1.298zM9 15.648v2.102h1.5v-2.102H9zm6.75-3.898c0 1.387-.753 2.6-1.876 3.249l.752 1.298a5.248 5.248 0 002.624-4.547h-1.5zm-2.25 3.898v2.102H15v-2.102h-1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M19.5 35.5H18V37h1.5v-1.5zm9 0V37H30v-1.5h-1.5zm-9-4.204H21v-.865l-.75-.433-.75 1.298zm9 0l-.752-1.298-.749.433v.865h1.5zM22.498 3v6h3V3h-3zM3 25.5h6v-3H3v3zm36 0h6v-3h-6v3zM8.145 10.354l4.243 4.242 2.121-2.121-4.242-4.243-2.122 2.122zm29.587-2.122l-4.243 4.243 2.122 2.121 4.242-4.242-2.121-2.122zM17.999 42h12v-3H18v3zm-1.5-18.5A7.5 7.5 0 0124 16v-3c-5.799 0-10.5 4.701-10.5 10.5h3zM24 16a7.5 7.5 0 017.5 7.5h3C34.5 17.701 29.8 13 24 13v3zm-4.5 21h9v-3h-9v3zm.751-7.002A7.497 7.497 0 0116.5 23.5h-3c0 3.888 2.114 7.281 5.248 9.094l1.502-2.596zM18 31.296V35.5h3v-4.204h-3zM31.5 23.5a7.497 7.497 0 01-3.752 6.498l1.502 2.596A10.496 10.496 0 0034.5 23.5h-3zM27 31.296V35.5h3v-4.204h-3z"
  }))
};
var Tip = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1S,
    fill: "none"
  }));
});
var compPaths$1R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 14.25H18c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25h-7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6.71 16.9l-2.65-2.65 2.65-2.65m13.04-1.85H6c-1.24 0-2.25-1.01-2.25-2.25S4.76 5.25 6 5.25h7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.29 7.1l2.65 2.65-2.65 2.65"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 14.25H18c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25h-7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6.71 16.9l-2.65-2.65 2.65-2.65m13.04-1.85H6c-1.24 0-2.25-1.01-2.25-2.25S4.76 5.25 6 5.25h7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.29 7.1l2.65 2.65-2.65 2.65"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M8.5 28.5H36c2.48 0 4.5 2.02 4.5 4.5s-2.02 4.5-4.5 4.5H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M13.42 33.8l-5.3-5.3 5.3-5.3m26.08-3.7H12c-2.48 0-4.5-2.02-4.5-4.5s2.02-4.5 4.5-4.5h15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.58 14.2l5.3 5.3-5.3 5.3"
  }))
};
var Transfers = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1R,
    fill: "none"
  }));
});
var compPaths$1Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M6.68 8.25h1.77l2.65 7.5H9.4l-.49-1.54H6.15l-.51 1.54H4l2.68-7.5zm-.11 4.67h1.92l-.94-2.96-.98 2.96z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 10c0 .746-.183 1.461-.514 2.108a5.516 5.516 0 01-1.403 1.728A6.672 6.672 0 0114 15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.014 12.108c.33.647.807 1.233 1.403 1.728.597.494 1.294.89 2.083 1.164m-2.25-6.75V10"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.5 10H20"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M6.68 8.25h1.77l2.65 7.5H9.4l-.49-1.54H6.15l-.51 1.54H4l2.68-7.5zm-.11 4.67h1.92l-.94-2.96-.98 2.96z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 10c0 .746-.183 1.461-.514 2.108a5.516 5.516 0 01-1.403 1.728A6.672 6.672 0 0114 15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.014 12.108c.33.647.807 1.233 1.403 1.728.597.494 1.294.89 2.083 1.164m-2.25-6.75V10"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.5 10H20"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 37.5H1.5v-27H24m0 0h22.5v27H24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M13.36 16.5h3.54l5.3 15h-3.4l-.98-3.08H12.3l-1.02 3.08H8l5.36-15zm-.22 9.34h3.84l-1.88-5.92-1.96 5.92z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 20a9.245 9.245 0 01-1.028 4.216c-.66 1.294-1.614 2.466-2.807 3.455A13.34 13.34 0 0128 30"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M30.027 24.216c.661 1.294 1.615 2.466 2.808 3.455A13.356 13.356 0 0037 30.001M32.5 16.5V20"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25 20h15"
  }))
};
var Translation = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1Q,
    fill: "none"
  }));
});
var compPaths$1P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15 8.25h5.25V3m0 5.25L14 2.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 20.25h5.5v-4.5h-5.5v4.5zm-8.75 0h3.25V3.75h-5.5V18c0 1.24 1.01 2.25 2.25 2.25zm3.25 0h5.5v-9h-5.5v9z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15 8.25h5.25V3m0 5.25L14 2.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 20.25h5.5v-4.5h-5.5v4.5zm-8.75 0h3.25V3.75h-5.5V18c0 1.24 1.01 2.25 2.25 2.25zm3.25 0h5.5v-9h-5.5v9z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M30 16.5h10.5V6m0 10.5L28 5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M29.5 40.5h11v-9h-11v9zm-17.5 0h6.5v-33h-11V36c0 2.48 2.02 4.5 4.5 4.5zm6.5 0h11v-18h-11v18z"
  }))
};
var TrendingDown = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1P,
    fill: "none"
  }));
});
var compPaths$1O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.25 9V3.75H4m5.25 0L3 9.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 15.75h-5.5v4.49h5.5v-4.49zm8.75 4.5h-3.25V3.75h5.5V18c0 1.24-1.01 2.25-2.25 2.25zm-3.25-9h-5.5v9h5.5v-9z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.25 9V3.75H4m5.25 0L3 9.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 15.75h-5.5v4.49h5.5v-4.49zm8.75 4.5h-3.25V3.75h5.5V18c0 1.24-1.01 2.25-2.25 2.25zm-3.25-9h-5.5v9h5.5v-9z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M18.5 18V7.5H8m10.5 0L6 19"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 31.5h-11v8.98h11V31.5zm17.5 9h-6.5v-33h11V36c0 2.48-2.02 4.5-4.5 4.5zm-6.5-18h-11v18h11v-18z"
  }))
};
var TrendingUp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1O,
    fill: "none"
  }));
});
var compPaths$1N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75V18m0-2.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zM15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75V18m0-2.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zM15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5V36m0-4.5a3 3 0 100-6 3 3 0 000 6z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 40.5h-21c-1.66 0-3-1.34-3-3v-15c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3v15c0 1.66-1.34 3-3 3zm-3-28.5c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5v7.5"
  }))
};
var Unlock = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1N,
    fill: "none"
  }));
});
var compPaths$1M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 11.25A2.248 2.248 0 016.75 9h10.5a2.248 2.248 0 012.25 2.25v7.5A2.248 2.248 0 0117.25 21H6.75a2.248 2.248 0 01-2.25-2.25v-7.5zm5.25 3a2.25 2.25 0 113 2.122V18h-1.5v-1.628a2.251 2.251 0 01-1.5-2.122z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 11.25A2.248 2.248 0 016.75 9h10.5a2.248 2.248 0 012.25 2.25v7.5A2.248 2.248 0 0117.25 21H6.75a2.248 2.248 0 01-2.25-2.25v-7.5zm5.25 3a2.25 2.25 0 113 2.122V18h-1.5v-1.628a2.251 2.251 0 01-1.5-2.122z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 22.5c0-2.488 2.012-4.5 4.5-4.5h21c2.488 0 4.5 2.012 4.5 4.5v15c0 2.488-2.012 4.5-4.5 4.5h-21A4.496 4.496 0 019 37.5v-15zm10.5 6a4.5 4.5 0 116 4.244V36h-3v-3.256a4.502 4.502 0 01-3-4.244z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M31.5 12c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5v7.5"
  }))
};
var UnlockFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1M,
    fill: "none"
  }));
});
var compPaths$1L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7.5v9c0 2.07-1.68 3.75-3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 7.51a5.254 5.254 0 00-5.24-5.26c-2.9-.01-5.25 2.34-5.26 5.24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.49 6.75c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75h2.26m4.5 0h2.24c2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 10.78L12 7.07l3.71 3.71"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7.5v9c0 2.07-1.68 3.75-3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 7.51a5.254 5.254 0 00-5.24-5.26c-2.9-.01-5.25 2.34-5.26 5.24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.49 6.75c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75h2.26m4.5 0h2.24c2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 10.78L12 7.07l3.71 3.71"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 15v18c0 4.14-3.36 7.5-7.5 7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 15.02A10.508 10.508 0 0024.02 4.5c-5.8-.02-10.5 4.68-10.52 10.48"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M14.98 13.5c-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5h4.52m9 0h4.48c4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.578 21.56l7.42-7.42 7.42 7.42"
  }))
};
var Upload = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1L,
    fill: "none"
  }));
});
var compPaths$1K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.39 11.35L10.28 8.4a.75.75 0 00-1.125.649v5.903a.75.75 0 001.125.649l5.11-2.951a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25h15z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.39 11.35L10.28 8.4a.75.75 0 00-1.125.649v5.903a.75.75 0 001.125.649l5.11-2.951a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25h15z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.781 22.701L20.56 16.8c-1-.576-2.25.144-2.25 1.298v11.806c0 1.154 1.25 1.874 2.25 1.298L30.781 25.3a1.5 1.5 0 000-2.598z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 37.5a4.5 4.5 0 004.5-4.5V15a4.5 4.5 0 00-4.5-4.5H9A4.5 4.5 0 004.5 15v18A4.5 4.5 0 009 37.5h30z",
    clipRule: "evenodd"
  }))
};
var VideoPlayer = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1K,
    fill: "none"
  }));
});
var compPaths$1J = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.396 10.527l2.61 1.5 2.612-1.5m-2.611 1.5v2.5m0 2.5v2.814m6.75-3.897l-2.442-1.417M5.257 15.944l2.442-1.417m4.308-7.186V4.527m-6.75 3.897l2.442 1.417m11.058-1.417l-2.442 1.417M9.44 18.36l2.567 1.481 2.567-1.482m0-12.349l-2.567-1.483L9.44 6.01m6.75 11.417l2.567-1.482V12.98m0-1.592V8.424L16.19 6.942M7.824 17.427l-2.567-1.482V12.98m0-1.592V8.424l2.567-1.482"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M23.257 12.004c0 6.214-5.039 11.254-11.253 11.254C5.788 23.258.75 18.218.75 12.004.75 5.789 5.788.75 12.004.75c6.214 0 11.253 5.039 11.253 11.254z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.396 10.527l2.61 1.5 2.612-1.5m-2.611 1.5v2.5m0 2.5v2.814m6.75-3.897l-2.442-1.417M5.257 15.944l2.442-1.417m4.308-7.186V4.527m-6.75 3.897l2.442 1.417m11.058-1.417l-2.442 1.417M9.44 18.36l2.567 1.481 2.567-1.482m0-12.349l-2.567-1.483L9.44 6.01m6.75 11.417l2.567-1.482V12.98m0-1.592V8.424L16.19 6.942M7.824 17.427l-2.567-1.482V12.98m0-1.592V8.424l2.567-1.482"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M23.257 12.004c0 6.214-5.039 11.254-11.253 11.254C5.788 23.258.75 18.218.75 12.004.75 5.789 5.788.75 12.004.75c6.214 0 11.253 5.039 11.253 11.254z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.791 21.054l5.223 3 5.224-3m-5.223 3v5m0 5v5.628m13.499-7.794l-4.884-2.834m-22.115 2.834l4.884-2.834m8.616-14.371V9.055m-13.5 7.794l4.884 2.834m22.115-2.834l-4.884 2.834M18.88 36.718l5.135 2.964 5.134-2.964m-.001-24.699l-5.134-2.964-5.134 2.964m13.5 22.834l5.135-2.964V25.96m-.001-3.184V16.85l-5.134-2.965M15.648 34.853l-5.134-2.964V25.96m.001-3.184V16.85l5.134-2.965"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M46.514 24.007c0 12.43-10.078 22.508-22.506 22.508-12.43 0-22.508-10.078-22.508-22.508S11.576 1.499 24.01 1.499c12.428 0 22.505 10.078 22.505 22.508z",
    clipRule: "evenodd"
  }))
};
var VR = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1J,
    fill: "none"
  }));
});
var compPaths$1I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 8.25H6A2.25 2.25 0 013.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18v-7.5A2.25 2.25 0 0018 8.25h-2.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 6.5V3.75H6A2.25 2.25 0 003.75 6v1.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 15.75h-3a1.5 1.5 0 010-3h3v3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 8.25H6A2.25 2.25 0 013.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18v-7.5A2.25 2.25 0 0018 8.25h-2.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 6.5V3.75H6A2.25 2.25 0 003.75 6v1.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 15.75h-3a1.5 1.5 0 010-3h3v3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 16.5H12A4.5 4.5 0 017.5 12v24c0 2.484 2.016 4.5 4.5 4.5h24c2.484 0 4.5-2.016 4.5-4.5V21c0-2.484-2.016-4.5-4.5-4.5h-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 13V7.5H12A4.5 4.5 0 007.5 12v2.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 31.5h-6a3.001 3.001 0 010-6h6v6z",
    clipRule: "evenodd"
  }))
};
var Wallet = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1I,
    fill: "none"
  }));
});
var compPaths$1H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853M10.5 13.5v-6m-3 3h6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853M10.5 13.5v-6m-3 3h6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.924 32.592A13.432 13.432 0 0121 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 017.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0121 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0134.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706M21 27V15m-6 6h12"
  }))
};
var Zoomin = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1H,
    fill: "none"
  }));
});
var compPaths$1G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.774 1.977A6.735 6.735 0 0117.25 10.5a6.717 6.717 0 01-.922 3.407c-.516.882-.433 1.988.29 2.711l3.854 3.853M7.5 10.5h6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.774 1.977A6.735 6.735 0 0117.25 10.5a6.717 6.717 0 01-.922 3.407c-.516.882-.433 1.988.29 2.711l3.854 3.853M7.5 10.5h6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.924 32.592A13.432 13.432 0 0121 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 017.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0121 7.5a13.46 13.46 0 019.548 3.954A13.47 13.47 0 0134.5 21c0 2.486-.672 4.814-1.844 6.814-1.032 1.764-.866 3.976.58 5.422l7.708 7.706M15 21h12"
  }))
};
var Zoomout = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1G,
    fill: "none"
  }));
});
var compPaths$1F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 5.75H5.75v12.5H12m0-12.5v12.5m0-12.5h6.25v12.5H12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 3.75H3.75v16.5H12m0-16.5v16.5m0-16.5h8.25v16.5H12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 7.5H7.5v33H24m0-33v33m0-33h16.5v33H24"
  }))
};
var Columns = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1F,
    fill: "none"
  }));
});
var compPaths$1E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 3.75h6m-9 0h-.25a2 2 0 00-2 2V6M18 3.75h.25a2 2 0 012 2V6M15 20.25H9m9 0h.25a2 2 0 002-2V18M6 20.25h-.25a2 2 0 01-2-2V18m0-3V9m16.5 6V9.375"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 3.75h6m-9 0h-.25a2 2 0 00-2 2V6M18 3.75h.25a2 2 0 012 2V6M15 20.25H9m9 0h.25a2 2 0 002-2V18M6 20.25h-.25a2 2 0 01-2-2V18m0-3V9m16.5 6V9.375"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 7.5h12m-18 0h-.5a4 4 0 00-4 4v.5M36 7.5h.5a4 4 0 014 4v.5M30 40.5H18m18 0h.5a4 4 0 004-4V36M12 40.5h-.5a4 4 0 01-4-4V36m0-6V18m33 12V18.75"
  }))
};
var Container = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1E,
    fill: "none"
  }));
});
var compPaths$1D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7 9.25h5.5c1.24 0 2.25 1.01 2.25 2.25V17c0 1.24-1.01 2.25-2.25 2.25H7c-1.24 0-2.25-1.01-2.25-2.25v-5.5c0-1.24 1.01-2.25 2.25-2.25zM9.25 7c0-1.24 1.01-2.25 2.25-2.25m5.5 10c1.24 0 2.25-1.01 2.25-2.25m0-5.5c0-1.24-1.01-2.25-2.25-2.25m2.25 3.75V11M13 4.75h2.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 8.25h7.5c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25H6c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25zM8.25 6c0-1.24 1.01-2.25 2.25-2.25m7.5 12c1.24 0 2.25-1.01 2.25-2.25m0-7.5c0-1.24-1.01-2.25-2.25-2.25m2.25 3.75V12M12 3.75h4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 16.5h15c2.48 0 4.5 2.02 4.5 4.5v15c0 2.48-2.02 4.5-4.5 4.5H12c-2.48 0-4.5-2.02-4.5-4.5V21c0-2.48 2.02-4.5 4.5-4.5zm4.5-4.5c0-2.48 2.02-4.5 4.5-4.5m15 24c2.48 0 4.5-2.02 4.5-4.5m0-15c0-2.48-2.02-4.5-4.5-4.5m4.5 7.5v9M24 7.5h9"
  }))
};
var CopyPaste = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1D,
    fill: "none"
  }));
});
var compPaths$1C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.25 8.5V11"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7 9.25h5.5c1.24 0 2.25 1.01 2.25 2.25V17c0 1.24-1.01 2.25-2.25 2.25H7c-1.24 0-2.25-1.01-2.25-2.25v-5.5c0-1.24 1.01-2.25 2.25-2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 7c0-1.24 1.01-2.25 2.25-2.25m5.5 10c1.24 0 2.25-1.01 2.25-2.25m0-5.5c0-1.24-1.01-2.25-2.25-2.25m-4 0h2.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 8.25h7.5c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25H6c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 6c0-1.24 1.01-2.25 2.25-2.25m7.5 12c1.24 0 2.25-1.01 2.25-2.25m0-7.5c0-1.24-1.01-2.25-2.25-2.25m2.25 3.75V12M12 3.75h4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 16.5h15c2.48 0 4.5 2.02 4.5 4.5v15c0 2.48-2.02 4.5-4.5 4.5H12c-2.48 0-4.5-2.02-4.5-4.5V21c0-2.48 2.02-4.5 4.5-4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 12c0-2.48 2.02-4.5 4.5-4.5m15 24c2.48 0 4.5-2.02 4.5-4.5m0-15c0-2.48-2.02-4.5-4.5-4.5m4.5 7.5v9M24 7.5h9"
  }))
};
var CopyPasteFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1C,
    fill: "none"
  }));
});
var compPaths$1B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.323 5.75h5.486c1.883 0 3.405 1.4 3.405 3.125 0 1.726-1.522 3.125-3.404 3.125M7.322 5.75V12m0-6.25H5.5m1.823 12.5h7.264c1.883 0 3.413-1.4 3.413-3.125C18 13.399 16.47 12 14.587 12H7.323m0 6.25V12m0 6.25H5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.798 3.75h6.912c2.372 0 4.29 1.847 4.29 4.125S16.082 12 13.71 12M6.798 3.75V12m0-8.25H4.5m2.298 16.5h9.152c2.372 0 4.3-1.847 4.3-4.125S18.322 12 15.95 12H6.798m0 8.25V12m0 8.25H4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12.595 7.5H26.42c4.743 0 8.58 3.694 8.58 8.25S31.163 24 26.42 24M12.595 7.5V24m0-16.5H8m4.595 33H30.9c4.743 0 8.6-3.694 8.6-8.25S35.643 24 30.9 24H12.595m0 16.5V24m0 16.5H8"
  }))
};
var FormatBold = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1B,
    fill: "none"
  }));
});
var compPaths$1A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M21 4.5H9V6h12V4.5zm-16.5 0H3V6h1.5V4.5zM21 11.25H9v1.5h12v-1.5zm-16.5 0H3v1.5h1.5v-1.5zM21 18H9v1.5h12V18zM4.5 18H3v1.5h1.5V18z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M21 4.5H9V6h12V4.5zm-16.5 0H3V6h1.5V4.5zM21 11.25H9v1.5h12v-1.5zm-16.5 0H3v1.5h1.5v-1.5zM21 18H9v1.5h12V18zM4.5 18H3v1.5h1.5V18z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M42 9H18v3h24V9zM9 9H6v3h3V9zm33 13.5H18v3h24v-3zm-33 0H6v3h3v-3zM42 36H18v3h24v-3zM9 36H6v3h3v-3z"
  }))
};
var FormatBullet = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1A,
    fill: "none"
  }));
});
var compPaths$1z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.032 5.75h6.06M7 18.25h6.06m-3.35 0l3.352-12.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10 3.75h8M5.998 20.25h8m-4.422 0L14 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M20.004 7.5h16M12 40.5h16m-8.844 0l8.848-33"
  }))
};
var FormatItalics = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1z,
    fill: "none"
  }));
});
var compPaths$1y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M3.75 20.25H3V21h.75v-.75zm0-1h.75-.75zm1.5-2l.238.712-.237-.712zM5 3.75v.75-.75zM7.5 19.5H3.75V21H7.5v-1.5zm-3-.25c0-.2.1-.481.314-.76.213-.277.473-.461.674-.528l-.474-1.424c-.55.183-1.04.585-1.389 1.038-.348.452-.624 1.046-.624 1.674h1.5zm0 1v-1H3v1h1.5zm1.5-4.5c0 .15-.055.268-.206.397-.173.147-.44.278-.78.392l.474 1.422c.41-.136.891-.341 1.28-.674.412-.351.732-.86.732-1.537H6zM5.25 15a.75.75 0 01.75.75h1.5a2.25 2.25 0 00-2.25-2.25V15zm0-1.5H3V15h2.25v-1.5zm5.25-.75H21v-1.5H10.5v1.5zm0-8.25H21V3H10.5v1.5zm0 16.5H21v-1.5H10.5V21zM4.75 4.25v6.25h1.5V4.25h-1.5zM3 4.5h2V3H3v1.5zm3.25-.25C6.25 3.56 5.69 3 5 3v1.5a.25.25 0 01-.25-.25h1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M3.75 20.25H3V21h.75v-.75zm0-1h.75-.75zm1.5-2l.238.712-.237-.712zM5 3.75v.75-.75zM7.5 19.5H3.75V21H7.5v-1.5zm-3-.25c0-.2.1-.481.314-.76.213-.277.473-.461.674-.528l-.474-1.424c-.55.183-1.04.585-1.389 1.038-.348.452-.624 1.046-.624 1.674h1.5zm0 1v-1H3v1h1.5zm1.5-4.5c0 .15-.055.268-.206.397-.173.147-.44.278-.78.392l.474 1.422c.41-.136.891-.341 1.28-.674.412-.351.732-.86.732-1.537H6zM5.25 15a.75.75 0 01.75.75h1.5a2.25 2.25 0 00-2.25-2.25V15zm0-1.5H3V15h2.25v-1.5zm5.25-.75H21v-1.5H10.5v1.5zm0-8.25H21V3H10.5v1.5zm0 16.5H21v-1.5H10.5V21zM4.75 4.25v6.25h1.5V4.25h-1.5zM3 4.5h2V3H3v1.5zm3.25-.25C6.25 3.56 5.69 3 5 3v1.5a.25.25 0 01-.25-.25h1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 40.5L6 40.499 5.999 42H7.5v-1.5zm.002-2l1.5.001V38.5h-1.5zm3-4l.474 1.423-.474-1.423zM10 7.5V9 7.5zM15.002 39H7.5v3h7.502v-3zm-6-.5c0-.4.197-.962.625-1.519.427-.555.947-.924 1.349-1.058l-.948-2.846c-1.1.366-2.08 1.168-2.778 2.074-.696.904-1.248 2.093-1.248 3.349h3zM9 40.501l.002-2-3-.002-.002 2 3 .002zm3-9.001c0 .302-.11.535-.412.793-.345.296-.882.557-1.561.784l.95 2.846c.818-.273 1.781-.684 2.56-1.349C14.36 33.872 15 32.855 15 31.5h-3zM10.5 30a1.5 1.5 0 011.5 1.5h3a4.5 4.5 0 00-4.5-4.5v3zm0-3H6v3h4.5v-3zM21 25.5h21v-3H21v3zM21 12h21V9H21v3zm0 27h21v-3H21v3zM9.5 8.5V21h3V8.5h-3zM6 9h4V6H6v3zm6.5-.5A2.5 2.5 0 0010 6v3a.5.5 0 01-.5-.5h3z"
  }))
};
var FormatNumberedList = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1y,
    fill: "none"
  }));
});
var compPaths$1x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.84 11.818h.75-.75zm3.031 1.705v.75-.75zM5 5v6.818h1.5V5H5zm0 6.818v7.068h1.5v-7.068H5zM14.09 5v6.818h1.5V5h-1.5zm0 6.818v7.068h1.5v-7.068h-1.5zm-8.34.75h9.09v-1.5H5.75v1.5zm11.75 1.334v4.984H19v-4.984h-1.5zm-.954.37h1.325v-1.5h-1.326v1.5zm2.454-.37a1.13 1.13 0 00-1.129-1.13v1.5a.371.371 0 01-.371-.37H19z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.75 12h.75-.75zm4 2.25V15v-.75zM3 3v9h1.5V3H3zm0 9v9h1.5v-9H3zm12-9v9h1.5V3H15zm0 9v9h1.5v-9H15zm-11.25.75h12v-1.5h-12v1.5zm15.75 2V21H21v-6.25h-1.5zM18 15h1.75v-1.5H18V15zm3-.25c0-.69-.56-1.25-1.25-1.25V15a.25.25 0 01-.25-.25H21z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M31.5 24H33h-1.5zm8 4.5V30v-1.5zM6 6v18h3V6H6zm0 18v18h3V24H6zM30 6v18h3V6h-3zm0 18v18h3V24h-3zM7.5 25.5h24v-3h-24v3zm31.5 4V42h3V29.5h-3zm-3 .5h3.5v-3H36v3zm6-.5a2.5 2.5 0 00-2.5-2.5v3a.5.5 0 01-.5-.5h3z"
  }))
};
var Heading = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1x,
    fill: "none"
  }));
});
var compPaths$1w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9 9.75H7.5v1.5H9v-1.5zm7.5 3h-9v1.5h9v-1.5zm-5-3H10v1.5h1.5v-1.5zm2.5 0h-1.5v1.5H14v-1.5zm2.5 0H15v1.5h1.5v-1.5z"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "14.5",
    height: "10.5",
    x: "4.75",
    y: "6.75",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "2.25"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("rect", {
    width: "19.5",
    height: "13.5",
    x: "2.25",
    y: "5.25",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "3.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.75 9.75h1.5m-1.5 4h1.5m1.75 0h8m-8-4h1.5m1.75 0h1.5m1.75 0H16m1.75 0h1.5m-1.5 4h1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("rect", {
    width: "39",
    height: "27",
    x: "4.5",
    y: "10.5",
    stroke: "currentColor",
    strokeWidth: "3",
    rx: "6.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9.5 19.5h3m-3 8h3m3.5 0h16m-16-8h3m3.5 0h3m3.5 0h3m3.5 0h3m-3 8h3"
  }))
};
var Keyboard = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1w,
    fill: "none"
  }));
});
var compPaths$1v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.22 7.858l.532.53.528-.53-.528-.53-.531.53zm-7.29.001v.75-.75zm-5.18 5.196h.75-.75zm5.18 5.195v-.75.75zm4.972-7.005l2.85-2.858-1.062-1.059-2.85 2.857 1.062 1.06zm2.85-3.917l-2.85-2.858-1.062 1.06 2.85 2.857 1.062-1.059zm-.532-.22l-7.29.001v1.5l7.29-.001v-1.5zM5 13.055C5 16.336 7.653 19 10.93 19v-1.5a4.438 4.438 0 01-4.43-4.445H5zm5.93-5.946C7.653 7.11 5 9.773 5 13.055h1.5a4.438 4.438 0 014.43-4.446v-1.5zM17.837 17.5H10.93V19h6.907v-1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M20 6.748l.53.53.53-.53-.53-.53-.53.53zm-9.5.002v.75-.75zM3.75 13.5h.75-.75zm6.75 6.75v-.75.75zm6.317-9.26l3.713-3.71-1.06-1.061-3.713 3.712 1.06 1.06zm3.713-4.772l-3.713-3.713-1.06 1.06 3.713 3.713 1.06-1.06zm-.53-.22L10.5 6v1.5l9.5-.002v-1.5zM3 13.5a7.5 7.5 0 007.5 7.5v-1.5a6 6 0 01-6-6H3zM10.5 6A7.5 7.5 0 003 13.5h1.5a6 6 0 016-6V6zm9 13.5h-9V21h9v-1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M39.833 13.637l1.062 1.06 1.056-1.06-1.056-1.059-1.062 1.06zm-18.845.004v1.5-1.5zm-13.39 13.43h1.5-1.5zM20.988 40.5V39v1.5zm12.541-18.418l7.366-7.386-2.124-2.118-7.366 7.385 2.124 2.119zm7.366-9.504L33.53 5.191l-2.125 2.118 7.366 7.387 2.124-2.118zm-1.062-.44l-18.846.003.001 3 18.845-.004v-3zM6.098 27.07c0 8.24 6.662 14.93 14.89 14.93v-3c-6.563 0-11.89-5.337-11.89-11.93h-3zm14.89-14.93c-8.228 0-14.89 6.688-14.89 14.93h3c0-6.593 5.327-11.93 11.89-11.93v-3zM38.84 39H20.988v3H38.84v-3z"
  }))
};
var Redo = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1v,
    fill: "none"
  }));
});
var compPaths$1u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.773 7.457V5.75H17.25v1.707M8.981 18.25h6.06m-3.03 0V5.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 6.004V3.75h13.5v2.254M8 20.25h8m-4 0V3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.5 12.008V7.5h27v4.508M16 40.5h16m-8 0v-33"
  }))
};
var Text = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1u,
    fill: "none"
  }));
});
var compPaths$1t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M5.75 7.856l-.53-.53-.53.53.53.53.53-.53zm7.308.002v.75-.75zm5.192 5.192h-.75.75zm-5.192 5.192v-.75.75zm-3.922-8.06L6.28 7.325l-1.06 1.06 2.856 2.856 1.06-1.06zM6.28 8.385L9.136 5.53l-1.06-1.06L5.22 7.326l1.06 1.06zm-.53.22l7.307.002v-1.5L5.75 7.106v1.5zM17.5 13.05a4.442 4.442 0 01-4.442 4.442v1.5A5.942 5.942 0 0019 13.05h-1.5zm-4.442-4.442A4.442 4.442 0 0117.5 13.05H19a5.942 5.942 0 00-5.942-5.942v1.5zM6.135 18.992h6.923v-1.5H6.135v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M4 6.748l-.53-.53-.53.53.53.53.53-.53zm9.5.002v.75-.75zm6.75 6.75h-.75.75zm-6.75 6.75v-.75.75zM8.243 9.93L4.53 6.218l-1.06 1.06 3.713 3.713 1.06-1.061zM4.53 7.278l3.713-3.713-1.06-1.06L3.47 6.218l1.06 1.06zm-.53.22l9.5.002V6L4 5.998v1.5zM19.5 13.5a6 6 0 01-6 6V21a7.5 7.5 0 007.5-7.5h-1.5zm-6-6a6 6 0 016 6H21A7.5 7.5 0 0013.5 6v1.5zM4.5 21h9v-1.5h-9V21z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15.465 21.022L8.1 13.637m0 0l7.365-7.387M8.1 13.637l18.845.004c7.395 0 13.39 6.013 13.39 13.43 0 7.416-5.995 13.429-13.39 13.429H9.09"
  }))
};
var Undo = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1t,
    fill: "none"
  }));
});
var compPaths$1s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12.809l-.007.106a3.75 3.75 0 01-.303 1.287 3.093 3.093 0 01-1.741 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 0112.381 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.463-.22.995-.331 1.579-.331.434 0 .851.061 1.237.181.393.123.739.301 1.033.531.297.23.542.516.727.848.184.331.3.715.344 1.141l.012.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.573 1.573 0 00-.364-.453 1.61 1.61 0 00-.519-.298 2.112 2.112 0 00-.698-.106c-.388 0-.727.078-1.007.233a1.995 1.995 0 00-.688.627 2.87 2.87 0 00-.397.905 4.224 4.224 0 000 2.091c.085.336.219.64.397.905.175.26.407.471.688.627.28.155.619.233 1.007.233.283 0 .536-.048.751-.146.213-.097.401-.233.554-.403.155-.171.278-.375.366-.606.089-.232.149-.486.176-.756l.009-.09H19.5zm-9.384 0h1.503l-.007.106c-.03.469-.132.902-.302 1.287a3.093 3.093 0 01-1.742 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 014.5 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.464-.22.995-.331 1.579-.331.435 0 .852.061 1.238.181.392.123.739.301 1.032.531.297.23.542.516.727.848.184.331.3.715.345 1.141l.011.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.615 1.615 0 00-.362-.453 1.632 1.632 0 00-.52-.298c-.2-.07-.435-.106-.699-.106-.388 0-.727.078-1.006.233a1.988 1.988 0 00-.689.627 2.879 2.879 0 00-.397.905 4.224 4.224 0 000 2.091c.086.338.22.643.397.905.175.26.408.471.689.627.279.155.618.233 1.006.233.283 0 .536-.048.751-.146.214-.096.4-.232.554-.403.157-.173.28-.377.366-.605.09-.233.149-.487.176-.757l.009-.09z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75h-15a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12.809l-.007.106a3.75 3.75 0 01-.303 1.287 3.093 3.093 0 01-1.741 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 0112.381 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.463-.22.995-.331 1.579-.331.434 0 .851.061 1.237.181.393.123.739.301 1.033.531.297.23.542.516.727.848.184.331.3.715.344 1.141l.012.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.573 1.573 0 00-.364-.453 1.61 1.61 0 00-.519-.298 2.112 2.112 0 00-.698-.106c-.388 0-.727.078-1.007.233a1.995 1.995 0 00-.688.627 2.87 2.87 0 00-.397.905 4.224 4.224 0 000 2.091c.085.336.219.64.397.905.175.26.407.471.688.627.28.155.619.233 1.007.233.283 0 .536-.048.751-.146.213-.097.401-.233.554-.403.155-.171.278-.375.366-.606.089-.232.149-.486.176-.756l.009-.09H19.5zm-9.384 0h1.503l-.007.106c-.03.469-.132.902-.302 1.287a3.093 3.093 0 01-1.742 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 014.5 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.464-.22.995-.331 1.579-.331.435 0 .852.061 1.238.181.392.123.739.301 1.032.531.297.23.542.516.727.848.184.331.3.715.345 1.141l.011.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.615 1.615 0 00-.362-.453 1.632 1.632 0 00-.52-.298c-.2-.07-.435-.106-.699-.106-.388 0-.727.078-1.006.233a1.988 1.988 0 00-.689.627 2.879 2.879 0 00-.397.905 4.224 4.224 0 000 2.091c.086.338.22.643.397.905.175.26.408.471.689.627.279.155.618.233 1.006.233.283 0 .536-.048.751-.146.214-.096.4-.232.554-.403.157-.173.28-.377.366-.605.09-.233.149-.487.176-.757l.009-.09z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75h-15a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39 25.618l-.014.212c-.06.938-.264 1.804-.606 2.574a6.304 6.304 0 01-1.404 2.022 6.186 6.186 0 01-2.078 1.316c-.792.308-1.674.464-2.616.464-1.162 0-2.226-.218-3.156-.65a7.04 7.04 0 01-2.37-1.774 7.932 7.932 0 01-1.482-2.614A9.67 9.67 0 0124.762 24a9.62 9.62 0 01.512-3.148 7.954 7.954 0 011.48-2.612 7.114 7.114 0 012.37-1.784c.926-.44 1.99-.662 3.158-.662.868 0 1.702.122 2.474.362a6.453 6.453 0 012.066 1.062 5.55 5.55 0 011.454 1.696c.368.662.6 1.43.688 2.282l.024.22h-3.052l-.04-.15a5.236 5.236 0 00-.452-1.174 3.147 3.147 0 00-.728-.906 3.222 3.222 0 00-1.038-.596c-.398-.14-.868-.212-1.396-.212-.776 0-1.454.156-2.014.466a3.99 3.99 0 00-1.376 1.254 5.742 5.742 0 00-.794 1.81 8.447 8.447 0 000 4.182c.17.672.438 1.28.794 1.81.35.52.814.942 1.376 1.254.56.31 1.238.466 2.014.466.566 0 1.072-.096 1.502-.292a3.352 3.352 0 001.108-.806c.31-.342.556-.75.732-1.212.178-.464.298-.972.352-1.512l.018-.18H39zm-18.768 0h3.006l-.014.212a7.545 7.545 0 01-.604 2.574 6.373 6.373 0 01-1.406 2.022 6.186 6.186 0 01-2.078 1.316c-.792.308-1.674.464-2.616.464-1.162 0-2.226-.218-3.156-.65a7.04 7.04 0 01-2.37-1.774 7.932 7.932 0 01-1.482-2.614A9.67 9.67 0 019 24a9.62 9.62 0 01.512-3.148 7.954 7.954 0 011.48-2.612 7.114 7.114 0 012.37-1.784c.928-.44 1.99-.662 3.158-.662.87 0 1.704.122 2.476.362a6.443 6.443 0 012.064 1.062 5.55 5.55 0 011.454 1.696c.368.662.6 1.43.69 2.282l.022.22h-3.052l-.04-.15a5.236 5.236 0 00-.452-1.174 3.23 3.23 0 00-.724-.906 3.265 3.265 0 00-1.04-.596c-.4-.14-.87-.212-1.398-.212-.776 0-1.454.156-2.012.466a3.977 3.977 0 00-1.378 1.254 5.757 5.757 0 00-.794 1.81 8.447 8.447 0 000 4.182c.172.676.44 1.286.794 1.81.35.52.816.942 1.378 1.254.558.31 1.236.466 2.012.466.566 0 1.072-.096 1.502-.292.428-.192.8-.464 1.108-.806a3.77 3.77 0 00.732-1.21c.18-.466.298-.974.352-1.514l.018-.18z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 37.5H9A4.5 4.5 0 014.5 33V15A4.5 4.5 0 019 10.5h30a4.5 4.5 0 014.5 4.5v18a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var ClosedCaption = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1s,
    fill: "none"
  }));
});
var compPaths$1r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.493 12.915c-.03.469-.132.902-.303 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.622 3.622 0 01-1.309.232 3.73 3.73 0 01-1.578-.326 3.49 3.49 0 01-1.184-.888 3.934 3.934 0 01-.74-1.306A4.841 4.841 0 0112.38 12a4.8 4.8 0 01.256-1.572 3.95 3.95 0 01.74-1.306 3.54 3.54 0 011.184-.892c.464-.22.995-.332 1.58-.332.434 0 .851.06 1.237.182.392.122.74.3 1.033.53.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.695 2.695 0 00-.226-.587 1.6 1.6 0 00-.883-.75 2.091 2.091 0 00-.699-.107c-.387 0-.726.079-1.006.234a1.986 1.986 0 00-.688.627c-.18.263-.312.568-.397.904a4.216 4.216 0 000 2.091c.085.337.218.64.397.905.175.26.406.47.688.628.28.154.62.232 1.006.232.284 0 .537-.049.751-.146.214-.096.402-.232.555-.403.154-.171.277-.374.365-.605.09-.232.15-.488.177-.758l.01-.088H19.5l-.007.105zm-7.88 0c-.03.469-.133.902-.304 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.62 3.62 0 01-1.308.232 3.73 3.73 0 01-1.579-.326 3.5 3.5 0 01-1.184-.888 3.951 3.951 0 01-.74-1.306A4.841 4.841 0 014.5 12a4.8 4.8 0 01.256-1.572c.17-.494.42-.933.74-1.306A3.55 3.55 0 016.68 8.23c.464-.22.996-.332 1.58-.332.435 0 .852.06 1.238.182a3.25 3.25 0 011.032.53c.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.645 2.645 0 00-.226-.587 1.615 1.615 0 00-.363-.453 1.633 1.633 0 00-.519-.297 2.096 2.096 0 00-.699-.107c-.388 0-.727.079-1.006.234a1.97 1.97 0 00-.689.627 2.879 2.879 0 00-.397.904 4.216 4.216 0 000 2.091c.086.338.22.643.397.905.175.26.407.47.69.628.278.154.617.232 1.005.232.283 0 .536-.049.751-.146.213-.096.4-.232.554-.403.157-.173.28-.377.365-.605.09-.232.15-.488.177-.758l.01-.088h1.502l-.007.105zM19.5 4.5h-15c-1.654 0-3 1.346-3 3v9c0 1.654 1.346 3 3 3h15c1.654 0 3-1.346 3-3v-9c0-1.654-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.493 12.915c-.03.469-.132.902-.303 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.622 3.622 0 01-1.309.232 3.73 3.73 0 01-1.578-.326 3.49 3.49 0 01-1.184-.888 3.934 3.934 0 01-.74-1.306A4.841 4.841 0 0112.38 12a4.8 4.8 0 01.256-1.572 3.95 3.95 0 01.74-1.306 3.54 3.54 0 011.184-.892c.464-.22.995-.332 1.58-.332.434 0 .851.06 1.237.182.392.122.74.3 1.033.53.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.695 2.695 0 00-.226-.587 1.6 1.6 0 00-.883-.75 2.091 2.091 0 00-.699-.107c-.387 0-.726.079-1.006.234a1.986 1.986 0 00-.688.627c-.18.263-.312.568-.397.904a4.216 4.216 0 000 2.091c.085.337.218.64.397.905.175.26.406.47.688.628.28.154.62.232 1.006.232.284 0 .537-.049.751-.146.214-.096.402-.232.555-.403.154-.171.277-.374.365-.605.09-.232.15-.488.177-.758l.01-.088H19.5l-.007.105zm-7.88 0c-.03.469-.133.902-.304 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.62 3.62 0 01-1.308.232 3.73 3.73 0 01-1.579-.326 3.5 3.5 0 01-1.184-.888 3.951 3.951 0 01-.74-1.306A4.841 4.841 0 014.5 12a4.8 4.8 0 01.256-1.572c.17-.494.42-.933.74-1.306A3.55 3.55 0 016.68 8.23c.464-.22.996-.332 1.58-.332.435 0 .852.06 1.238.182a3.25 3.25 0 011.032.53c.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.645 2.645 0 00-.226-.587 1.615 1.615 0 00-.363-.453 1.633 1.633 0 00-.519-.297 2.096 2.096 0 00-.699-.107c-.388 0-.727.079-1.006.234a1.97 1.97 0 00-.689.627 2.879 2.879 0 00-.397.904 4.216 4.216 0 000 2.091c.086.338.22.643.397.905.175.26.407.47.69.628.278.154.617.232 1.005.232.283 0 .536-.049.751-.146.213-.096.4-.232.554-.403.157-.173.28-.377.365-.605.09-.232.15-.488.177-.758l.01-.088h1.502l-.007.105zM19.5 4.5h-15c-1.654 0-3 1.346-3 3v9c0 1.654 1.346 3 3 3h15c1.654 0 3-1.346 3-3v-9c0-1.654-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.986 25.831a7.522 7.522 0 01-.606 2.574 6.358 6.358 0 01-1.404 2.022 6.249 6.249 0 01-2.078 1.316 7.244 7.244 0 01-2.618.464c-1.162 0-2.224-.22-3.156-.652a6.98 6.98 0 01-2.368-1.774 7.868 7.868 0 01-1.482-2.612 9.682 9.682 0 01-.512-3.17c0-1.104.172-2.164.512-3.146a7.898 7.898 0 011.48-2.612 7.08 7.08 0 012.368-1.784c.928-.44 1.99-.664 3.158-.664.87 0 1.704.122 2.476.364a6.47 6.47 0 012.066 1.06 5.58 5.58 0 011.454 1.698c.368.662.6 1.428.688 2.282l.024.22h-3.052l-.04-.15a5.39 5.39 0 00-.452-1.176 3.181 3.181 0 00-1.766-1.5c-.4-.142-.868-.214-1.398-.214-.774 0-1.452.158-2.012.468a3.972 3.972 0 00-1.376 1.254 5.658 5.658 0 00-.794 1.81 8.431 8.431 0 000 4.182c.17.672.436 1.28.794 1.81.35.518.812.94 1.376 1.254.56.308 1.238.466 2.012.466.568 0 1.074-.098 1.502-.292a3.318 3.318 0 001.11-.808c.308-.342.554-.748.73-1.21.18-.464.3-.974.354-1.514l.018-.178H39l-.014.212zm-15.762 0a7.522 7.522 0 01-.606 2.574 6.358 6.358 0 01-1.404 2.022 6.249 6.249 0 01-2.078 1.316 7.241 7.241 0 01-2.616.464c-1.162 0-2.226-.22-3.158-.652a7 7 0 01-2.368-1.774 7.903 7.903 0 01-1.482-2.612A9.682 9.682 0 019 23.999c0-1.104.172-2.164.512-3.146a7.933 7.933 0 011.48-2.612 7.1 7.1 0 012.368-1.784c.928-.44 1.992-.664 3.16-.664.87 0 1.704.122 2.476.364a6.5 6.5 0 012.064 1.06 5.58 5.58 0 011.454 1.698c.368.662.598 1.428.688 2.282l.024.22h-3.052l-.04-.15a5.29 5.29 0 00-.452-1.176 3.23 3.23 0 00-.726-.906 3.266 3.266 0 00-1.038-.594c-.4-.142-.87-.214-1.398-.214-.776 0-1.454.158-2.012.468a3.94 3.94 0 00-1.378 1.254 5.757 5.757 0 00-.794 1.81 8.431 8.431 0 000 4.182c.172.676.44 1.284.794 1.81.35.52.814.94 1.378 1.254.558.308 1.236.466 2.012.466.566 0 1.072-.098 1.502-.292.426-.194.8-.464 1.108-.808.314-.346.56-.752.73-1.21.18-.464.3-.974.354-1.514l.018-.178h3.006l-.014.212zM39 8.999H9c-3.308 0-6 2.692-6 6v18c0 3.31 2.692 6 6 6h30c3.308 0 6-2.69 6-6v-18c0-3.308-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var ClosedCaptionFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1r,
    fill: "none"
  }));
});
var compPaths$1q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.01 12V7.242a.75.75 0 011.126-.65l8.239 4.757a.75.75 0 010 1.3l-8.24 4.757a.75.75 0 01-1.125-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.644 11.365a.732.732 0 010 1.268l-8.268 4.773a.75.75 0 01-1.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15.172v-7.93a.751.751 0 011.126-.65l6.632 3.83"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.01 12V7.242a.75.75 0 011.126-.65l8.239 4.757a.75.75 0 010 1.3l-8.24 4.757a.75.75 0 01-1.125-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.644 11.365a.732.732 0 010 1.268l-8.268 4.773a.75.75 0 01-1.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15.172v-7.93a.751.751 0 011.126-.65l6.632 3.83"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24.02 24v-9.516c0-1.156 1.25-1.876 2.252-1.3l16.478 9.514c1 .578 1 2.022 0 2.6l-16.478 9.514a1.5 1.5 0 01-2.252-1.3v-3.656"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.287 22.73a1.464 1.464 0 010 2.537L6.751 34.813a1.501 1.501 0 01-2.252-1.3v-3.52"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 30.344v-15.86c0-1.156 1.252-1.876 2.252-1.3l13.264 7.658"
  }))
};
var FastForward = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1q,
    fill: "none"
  }));
});
var compPaths$1p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M43.48 21.4l-15.962-9.216a2.967 2.967 0 00-2.998-.002 2.966 2.966 0 00-1.502 2.598v6.352L7.534 12.194a2.98 2.98 0 00-3-.002 2.978 2.978 0 00-1.5 2.6v18.41c0 1.086.562 2.058 1.5 2.6.472.27.986.406 1.5.406a2.98 2.98 0 001.5-.408l15.484-8.94v6.354c0 1.086.56 2.058 1.5 2.6.468.27.984.406 1.5.406a2.99 2.99 0 001.5-.408l15.96-9.216a2.964 2.964 0 001.502-2.594c0-1.086-.56-2.06-1.5-2.602z",
    clipRule: "evenodd"
  }))
};
var FastForwardFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1p,
    fill: "none"
  }));
});
var compPaths$1o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 18V6m10.5 10.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 8.25H8.25v-3a1.5 1.5 0 011.5-1.5h7.5a1.5 1.5 0 011.5 1.5v3zM8.25 18a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 018.25 18zm10.5-1.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 18V6m10.5 10.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 8.25H8.25v-3a1.5 1.5 0 011.5-1.5h7.5a1.5 1.5 0 011.5 1.5v3zM8.25 18a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 018.25 18zm10.5-1.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 36V12m21 21V12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 16.5h-21v-6c0-1.656 1.344-3 3-3h15c1.656 0 3 1.344 3 3v6zM16.5 36c0 2.484-2.016 4.5-4.5 4.5A4.502 4.502 0 017.5 36c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5zm21-3c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Music = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1o,
    fill: "none"
  }));
});
var compPaths$1n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 3h-7.5C8.51 3 7.5 4.01 7.5 5.25v10.167A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V9h9v4.917a2.968 2.968 0 00-1.5-.417c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V5.25C19.5 4.01 18.49 3 17.25 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 3h-7.5C8.51 3 7.5 4.01 7.5 5.25v10.167A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V9h9v4.917a2.968 2.968 0 00-1.5-.417c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V5.25C19.5 4.01 18.49 3 17.25 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M34.5 6h-15C17.02 6 15 8.02 15 10.5v20.334c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6V18h18v9.834c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6V10.5C39 8.02 36.98 6 34.5 6z",
    clipRule: "evenodd"
  }))
};
var MusicFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1n,
    fill: "none"
  }));
});
var compPaths$1m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 18a1.498 1.498 0 01-.814-2.756l2.07 2.07c-.267.412-.73.686-1.256.686zM6 19.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm16.5.437l-3.04-3.041-3.356-3.356h-.001L11.563 9l-1.5-1.5L9 6.437 7.529 4.965v.001L5.561 2.998 4.5 4.06l3 3v8.358A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V8.559l5.62 5.619A2.967 2.967 0 0013.5 16.5c0 1.654 1.346 3 3 3 .941 0 1.776-.438 2.322-1.119l2.618 2.617 1.06-1.061zM9.75 4.5h7.5a.75.75 0 01.75.75V7.5h-5.815l1.5 1.5H18v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.573 0-1.091.222-1.489.576l1.069 1.07a.73.73 0 01.42-.146z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 18a1.498 1.498 0 01-.814-2.756l2.07 2.07c-.267.412-.73.686-1.256.686zM6 19.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm16.5.437l-3.04-3.041-3.356-3.356h-.001L11.563 9l-1.5-1.5L9 6.437 7.529 4.965v.001L5.561 2.998 4.5 4.06l3 3v8.358A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V8.559l5.62 5.619A2.967 2.967 0 0013.5 16.5c0 1.654 1.346 3 3 3 .941 0 1.776-.438 2.322-1.119l2.618 2.617 1.06-1.061zM9.75 4.5h7.5a.75.75 0 01.75.75V7.5h-5.815l1.5 1.5H18v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.573 0-1.091.222-1.489.576l1.069 1.07a.73.73 0 01.42-.146z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33 36c-1.654 0-3-1.346-3-3 0-1.052.548-1.976 1.372-2.512l4.14 4.14A2.993 2.993 0 0133 36zm-21 3c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm33 .874l-6.08-6.082-6.712-6.712h-.002L23.126 18l-3-3L18 12.874 15.058 9.93v.002l-3.936-3.936L9 8.118l6 6v16.716c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6V17.118l11.24 11.238A5.934 5.934 0 0027 33c0 3.308 2.692 6 6 6a5.935 5.935 0 004.644-2.238l5.236 5.234L45 39.874zM19.5 9h15c.828 0 1.5.674 1.5 1.5V15H24.37l3 3H36v8.63l3 3V10.5C39 8.02 36.982 6 34.5 6h-15a4.467 4.467 0 00-2.978 1.152l2.138 2.14c.244-.17.522-.292.84-.292z",
    clipRule: "evenodd"
  }))
};
var MusicNone = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1m,
    fill: "none"
  }));
});
var compPaths$1l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 9v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.574 0-1.096.218-1.492.574L13.685 9H18zm1.46 7.896l-3.356-3.356h-.001L11.563 9h.001L7.529 4.967 5.561 2.999l-1.06 1.06 2.999 3v8.359A2.968 2.968 0 006 15c-1.654 0-3 1.345-3 3 0 1.653 1.346 3 3 3s3-1.347 3-3V8.558l5.622 5.62A2.984 2.984 0 0013.5 16.5c0 1.654 1.346 3 3 3 .94 0 1.77-.444 2.32-1.122l2.62 2.62 1.061-1.06-3.041-3.041z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 9v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.574 0-1.096.218-1.492.574L13.685 9H18zm1.46 7.896l-3.356-3.356h-.001L11.563 9h.001L7.529 4.967 5.561 2.999l-1.06 1.06 2.999 3v8.359A2.968 2.968 0 006 15c-1.654 0-3 1.345-3 3 0 1.653 1.346 3 3 3s3-1.347 3-3V8.558l5.622 5.62A2.984 2.984 0 0013.5 16.5c0 1.654 1.346 3 3 3 .94 0 1.77-.444 2.32-1.122l2.62 2.62 1.061-1.06-3.041-3.041z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 18v8.63l3 3V10.5C39 8.02 36.982 6 34.5 6h-15a4.448 4.448 0 00-2.984 1.148L27.37 18H36zm2.92 15.793l-6.712-6.712h-.002l-9.08-9.08h.002l-8.07-8.07-3.936-3.934-2.12 2.12 5.998 6v16.718c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.69-6 6 0 3.308 2.692 6 6 6s6-2.692 6-6V17.117L29.244 28.36C27.886 29.461 27 31.121 27 33.001c0 3.308 2.692 6 6 6 1.88 0 3.54-.888 4.64-2.246l5.24 5.242 2.122-2.122-6.082-6.082z",
    clipRule: "evenodd"
  }))
};
var MusicNoneFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1l,
    fill: "none"
  }));
});
var compPaths$1k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m8.775-6.401l5.303 5.303m0-5.303l-5.303 5.303"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m8.775-6.401l5.303 5.303m0-5.303l-5.303 5.303"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 31.5h9v-15h-9v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5l9.44-9.44c.944-.944 2.56-.274 2.56 1.062v31.756c0 1.336-1.616 2.006-2.56 1.062L16.5 31.5m17.55-12.803l10.607 10.606m-.001-10.606L34.05 29.303"
  }))
};
var Mute = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1k,
    fill: "none"
  }));
});
var compPaths$1j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zm8.784 7.204l-1.06-1.061-2.122 2.122-2.12-2.122-1.06 1.06L18.615 12l-2.12 2.12 1.06 1.062 2.12-2.121 2.121 2.12 1.061-1.06L20.738 12l2.12-2.121z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zm8.784 7.204l-1.06-1.061-2.122 2.122-2.12-2.122-1.06 1.06L18.615 12l-2.12 2.12 1.06 1.062 2.12-2.121 2.121 2.12 1.061-1.06L20.738 12l2.12-2.121z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.148 5.35a2.998 2.998 0 00-3.27.65l-9 9H6v18h9.879l9 9a2.983 2.983 0 003.27.65A2.992 2.992 0 0030 39.88V8.12a2.993 2.993 0 00-1.853-2.772zm17.569 14.408l-2.122-2.122-4.242 4.244-4.242-4.244-2.12 2.122L37.233 24l-4.242 4.242 2.12 2.122 4.242-4.242 4.242 4.242 2.122-2.122L41.475 24l4.242-4.242z",
    clipRule: "evenodd"
  }))
};
var MuteFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1j,
    fill: "none"
  }));
});
var compPaths$1i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 20.25v0A2.25 2.25 0 0114.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25zm-9 0v0A2.25 2.25 0 015.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 20.25v0A2.25 2.25 0 0114.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25zm-9 0v0A2.25 2.25 0 015.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 40.5v0a4.502 4.502 0 01-4.5-4.5V12c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5zm-18 0v0a4.502 4.502 0 01-4.5-4.5V12c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Pause = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1i,
    fill: "none"
  }));
});
var compPaths$1h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33 6c-3.308 0-6 2.692-6 6v24c0 3.308 2.692 6 6 6s6-2.692 6-6V12c0-3.308-2.692-6-6-6zM15 6c-3.308 0-6 2.692-6 6v24c0 3.308 2.692 6 6 6s6-2.692 6-6V12c0-3.308-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var PauseFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1h,
    fill: "none"
  }));
});
var compPaths$1g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 7.5v9.794a1 1 0 001.489.872l9.45-5.292a1 1 0 00-.002-1.746L6.25 4.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.248 5.09V19.5a.75.75 0 001.125.65l13.487-7.787a.75.75 0 000-1.3L6.374 3.278v0l-1.5-.867"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.496 10.182v28.816c0 1.154 1.25 1.878 2.25 1.3L39.72 24.724c1-.578 1-2.02 0-2.598L12.748 6.554v-.001l-3-1.732"
  }))
};
var Play = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1g,
    fill: "none"
  }));
});
var compPaths$1f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.692 12.872a1 1 0 000-1.745L8.239 5.834a1 1 0 00-1.489.872v10.588a1 1 0 001.489.872l9.453-5.294z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.314 11.35L6.367 3.877a.75.75 0 00-1.125.65v14.949a.75.75 0 001.125.649l12.947-7.474a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.314 11.35L6.367 3.877a.75.75 0 00-1.125.65v14.949a.75.75 0 001.125.649l12.947-7.474a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39.377 21.402L13.485 6.452a2.98 2.98 0 00-3-.002 2.971 2.971 0 00-1.5 2.6v29.898c0 1.086.56 2.058 1.5 2.6.47.27.984.406 1.5.406s1.03-.136 1.5-.408l25.892-14.948A2.964 2.964 0 0040.88 24c0-1.086-.56-2.056-1.502-2.598z",
    clipRule: "evenodd"
  }))
};
var PlayFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1f,
    fill: "none"
  }));
});
var compPaths$1e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 12V7.242a.75.75 0 00-1.126-.65L2.625 11.35a.75.75 0 000 1.3l8.239 4.757a.75.75 0 001.126-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.356 11.365a.732.732 0 000 1.268l8.268 4.773a.75.75 0 001.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15.172v-7.93a.751.751 0 00-1.126-.65l-6.632 3.83"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 12V7.242a.75.75 0 00-1.126-.65L2.625 11.35a.75.75 0 000 1.3l8.239 4.757a.75.75 0 001.126-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.356 11.365a.732.732 0 000 1.268l8.268 4.773a.75.75 0 001.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15.172v-7.93a.751.751 0 00-1.126-.65l-6.632 3.83"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 24v-9.516c0-1.156-1.25-1.876-2.252-1.3L5.25 22.698c-1 .578-1 2.022 0 2.6l16.479 9.514a1.5 1.5 0 002.252-1.3v-3.656"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24.713 22.73a1.464 1.464 0 000 2.537l16.536 9.546c1 .578 2.252-.145 2.252-1.3v-3.52"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 30.344v-15.86c0-1.156-1.252-1.876-2.252-1.3l-13.264 7.658"
  }))
};
var Rewind = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1e,
    fill: "none"
  }));
});
var compPaths$1d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M43.48 12.193a2.97 2.97 0 00-3 .002L25 21.133v-6.352a2.976 2.976 0 00-1.502-2.6 2.977 2.977 0 00-2.998.002L4.534 21.401a2.973 2.973 0 00-1.5 2.6c0 1.084.564 2.054 1.5 2.594L20.5 35.813c.468.27.984.408 1.502.408.514 0 1.028-.138 1.498-.406a2.975 2.975 0 001.5-2.6v-6.352l15.48 8.938c.468.27.984.408 1.502.408.514 0 1.03-.138 1.498-.406a2.971 2.971 0 001.5-2.6v-18.41c0-1.084-.56-2.058-1.5-2.6z",
    clipRule: "evenodd"
  }))
};
var RewindFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1d,
    fill: "none"
  }));
});
var compPaths$1c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 12v24c0 2.484 2.016 4.5 4.5 4.5h24c2.484 0 4.5-2.016 4.5-4.5V12c0-2.484-2.016-4.5-4.5-4.5H6"
  }))
};
var Stop = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1c,
    fill: "none"
  }));
});
var compPaths$1b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 6H12c-3.308 0-6 2.692-6 6v24c0 3.308 2.692 6 6 6h24c3.308 0 6-2.692 6-6V12c0-3.308-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var StopFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1b,
    fill: "none"
  }));
});
var compPaths$1a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6m3-7.5v9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6m3-7.5v9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 31.5h9v-15h-9v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5l9.44-9.44c.944-.944 2.56-.274 2.56 1.062v31.756c0 1.336-1.616 2.006-2.56 1.062L16.5 31.5m18-13.5v12m6-15v18"
  }))
};
var VolumeHigh = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1a,
    fill: "none"
  }));
});
var compPaths$19 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.499 1.499 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6zm3 1.5H21v-9h-1.5v9z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.499 1.499 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6zm3 1.5H21v-9h-1.5v9z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.148 5.35a2.998 2.998 0 00-3.27.65l-9 9H6v18h9.878l9 9a2.983 2.983 0 003.27.65A2.992 2.992 0 0030 39.88V8.12a2.993 2.993 0 00-1.852-2.772zM33 30h3V18h-3v12zm6 3h3V15h-3v18z",
    clipRule: "evenodd"
  }))
};
var VolumeHighFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$19,
    fill: "none"
  }));
});
var compPaths$18 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 31.5h9v-15h-9v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5l9.44-9.44c.944-.944 2.56-.274 2.56 1.062v31.756c0 1.336-1.616 2.006-2.56 1.062L16.5 31.5m18-13.5v12"
  }))
};
var VolumeLow = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$18,
    fill: "none"
  }));
});
var compPaths$17 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.148 5.35a2.999 2.999 0 00-3.27.65l-9 9H6v18h9.878l9 9a2.983 2.983 0 003.27.65A2.992 2.992 0 0030 39.88V8.12a2.993 2.993 0 00-1.852-2.772zM33 30h3V18h-3v12z",
    clipRule: "evenodd"
  }))
};
var VolumeLowFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$17,
    fill: "none"
  }));
});
var compPaths$16 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17.28a5.28 5.28 0 000-10.56H7.529a5.28 5.28 0 000 10.56H16.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 12a3 3 0 11-6 0 3 3 0 016 0zm9 0a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17.28a5.28 5.28 0 000-10.56H7.529a5.28 5.28 0 000 10.56H16.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 12a3 3 0 11-6 0 3 3 0 016 0zm9 0a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 34.559c5.83 0 10.558-4.728 10.558-10.558S38.83 13.44 33 13.44H15.058C9.226 13.44 4.5 18.17 4.5 24s4.726 10.558 10.558 10.558H33z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 24a6 6 0 11-12 0 6 6 0 0112 0zm18 0a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }))
};
var Adapt = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$16,
    fill: "none"
  }));
});
var compPaths$15 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12c0 4.143-3.357 7.5-7.5 7.5A7.499 7.499 0 014.5 12c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12c0 4.143-3.357 7.5-7.5 7.5A7.499 7.499 0 014.5 12c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39 24c0 8.286-6.714 15-15 15S9 32.286 9 24 15.714 9 24 9s15 6.714 15 15z",
    clipRule: "evenodd"
  }))
};
var AdaptLight = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$15,
    fill: "none"
  }));
});
var compPaths$14 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 18.75h-7.5a3 3 0 01-3-3v-7.5a3 3 0 013-3h7.5a3 3 0 013 3v7.5a3 3 0 01-3 3zm-2.25 3h-3a2.25 2.25 0 01-2.25-2.25v-.75h7.5v.75a2.25 2.25 0 01-2.25 2.25zm-3-19.5h3a2.25 2.25 0 012.25 2.25v.75h-7.5V4.5a2.25 2.25 0 012.25-2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 18.75h-7.5a3 3 0 01-3-3v-7.5a3 3 0 013-3h7.5a3 3 0 013 3v7.5a3 3 0 01-3 3zm-2.25 3h-3a2.25 2.25 0 01-2.25-2.25v-.75h7.5v.75a2.25 2.25 0 01-2.25 2.25zm-3-19.5h3a2.25 2.25 0 012.25 2.25v.75h-7.5V4.5a2.25 2.25 0 012.25-2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 37.5h-15a6 6 0 01-6-6v-15a6 6 0 016-6h15a6 6 0 016 6v15a6 6 0 01-6 6zm-4.5 6h-6a4.502 4.502 0 01-4.5-4.5v-1.5h15V39c0 2.484-2.016 4.5-4.5 4.5zm-6-39h6c2.484 0 4.5 2.016 4.5 4.5v1.5h-15V9c0-2.484 2.016-4.5 4.5-4.5z",
    clipRule: "evenodd"
  }))
};
var AppleWatch = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$14,
    fill: "none"
  }));
});
var compPaths$13 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.59 10.41a2.25 2.25 0 010 3.181m-3.18-.001a2.25 2.25 0 010-3.181m5.302-2.121a5.248 5.248 0 010 7.424m-7.424 0a5.248 5.248 0 010-7.424m9.546-2.122a8.25 8.25 0 010 11.668m-11.668 0a8.25 8.25 0 010-11.668"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.59 10.41a2.25 2.25 0 010 3.181m-3.18-.001a2.25 2.25 0 010-3.181m5.302-2.121a5.248 5.248 0 010 7.424m-7.424 0a5.248 5.248 0 010-7.424m9.546-2.122a8.25 8.25 0 010 11.668m-11.668 0a8.25 8.25 0 010-11.668"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.182 20.818a4.499 4.499 0 010 6.364m-6.364 0a4.499 4.499 0 010-6.364m10.606-4.242c4.102 4.1 4.102 10.748 0 14.848m-14.848 0c-4.102-4.1-4.102-10.748 0-14.848m19.092-4.244c6.444 6.446 6.444 16.89 0 23.336m-23.336 0c-6.444-6.446-6.444-16.89 0-23.336"
  }))
};
var AudioFeedback = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$13,
    fill: "none"
  }));
});
var compPaths$12 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.051 3.947h1.555L10.754 18l1.05-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.051 3.947h1.555L10.754 18l1.05-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 18H19v18h10V18z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.61 28.108H20.5L26.336 18l-2.102 7.894h3.11L21.508 36l2.102-7.892z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryChargingFull = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$12,
    fill: "none"
  }));
});
var compPaths$11 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.05 3.947h1.554L10.754 18l1.051-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.05 3.947h1.554L10.754 18l1.051-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 27H19v9h10v-9z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.61 28.108H20.5L26.336 18l-2.102 7.894h3.11L21.508 36l2.102-7.892z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryChargingLow = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$11,
    fill: "none"
  }));
});
var compPaths$10 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 18H19v18h10V18z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryFull = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$10,
    fill: "none"
  }));
});
var compPaths$$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 27H19v9h10v-9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryLow = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$$,
    fill: "none"
  }));
});
var compPaths$_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.757 16.242l-3.182 3.183m14.85-14.85l-3.182 3.183M6 12H1.5m21 0H18M7.757 7.758L4.575 4.575m14.85 14.85l-3.182-3.183"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.757 16.242l-3.182 3.183m14.85-14.85l-3.182 3.183M6 12H1.5m21 0H18M7.757 7.758L4.575 4.575m14.85 14.85l-3.182-3.183"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 24a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15.515 32.484L9.15 38.85m29.7-29.7l-6.364 6.366M12 24H3m42 0h-9m-20.485-8.484L9.15 9.15m29.7 29.7l-6.364-6.366"
  }))
};
var Brightness = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$_,
    fill: "none"
  }));
});
var compPaths$Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 11.25c-2.077 0-2.716-4.312-2.912-8.211-.04-.787-1.093-.998-1.426-.285C8.694 6.964 5.25 12.321 5.25 15a6.75 6.75 0 1013.5 0c0-3.75-3.5-6.75-3.5-10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.876 18.626c0-1.277 1.693-3.214 2.587-4.146a.736.736 0 011.074 0c.894.932 2.587 2.87 2.587 4.146a3.123 3.123 0 11-6.248 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 11.25c-2.077 0-2.716-4.312-2.912-8.211-.04-.787-1.093-.998-1.426-.285C8.694 6.964 5.25 12.321 5.25 15a6.75 6.75 0 1013.5 0c0-3.75-3.5-6.75-3.5-10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.876 18.626c0-1.277 1.693-3.214 2.587-4.146a.736.736 0 011.074 0c.894.932 2.587 2.87 2.587 4.146a3.123 3.123 0 11-6.248 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30 22.5c-4.154 0-5.432-8.624-5.824-16.422-.08-1.574-2.186-1.996-2.852-.57C17.388 13.928 10.5 24.642 10.5 30c0 7.456 6.044 13.5 13.5 13.5S37.5 37.456 37.5 30c0-7.5-7-13.5-7-21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M17.752 37.252c0-2.554 3.386-6.428 5.174-8.292a1.473 1.473 0 012.148 0c1.788 1.864 5.174 5.738 5.174 8.292A6.246 6.246 0 0124 43.5a6.246 6.246 0 01-6.248-6.248z",
    clipRule: "evenodd"
  }))
};
var Burn = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$Z,
    fill: "none"
  }));
});
var compPaths$Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 20.25h9m-3-3.002h6a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 6v8.998a2.25 2.25 0 002.25 2.25h5a2.25 2.25 0 012.25 2.25v.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.827 10.068L10.5 7.57a.5.5 0 00-.75.433v4.996a.5.5 0 00.75.433l4.327-2.498a.5.5 0 000-.866z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 20.25h9m-3-3.002h6a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 6v8.998a2.25 2.25 0 002.25 2.25h5a2.25 2.25 0 012.25 2.25v.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.827 10.068L10.5 7.57a.5.5 0 00-.75.433v4.996a.5.5 0 00.75.433l4.327-2.498a.5.5 0 000-.866z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 40.5h18m-6-6.004h12a4.5 4.5 0 004.5-4.5V12c0-2.484-2.016-4.5-4.5-4.5H9A4.502 4.502 0 004.5 12v17.996a4.5 4.5 0 004.5 4.5h10c2.484 0 4.5 2.016 4.5 4.5v1.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M29.654 20.135L21 15.139a1 1 0 00-1.5.866v9.994a1 1 0 001.5.866l8.654-4.998a.999.999 0 000-1.732z",
    clipRule: "evenodd"
  }))
};
var ClassWorkout = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$Y,
    fill: "none"
  }));
});
var compPaths$X = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H9a2.25 2.25 0 01-2.25-2.25v-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25v15A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.5 18.75h3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H9a2.25 2.25 0 01-2.25-2.25v-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25v15A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.5 18.75h3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30 43.5H18a4.502 4.502 0 01-4.5-4.5V9c0-2.484 2.016-4.5 4.5-4.5h12c2.484 0 4.5 2.016 4.5 4.5v30c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M21 37.5h6"
  }))
};
var Device = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$X,
    fill: "none"
  }));
});
var compPaths$W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15V9A2.25 2.25 0 014.5 6.75h15A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25h-15A2.25 2.25 0 012.25 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15V9A2.25 2.25 0 014.5 6.75h15A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25h-15A2.25 2.25 0 012.25 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 39c0 2.484-2.016 4.5-4.5 4.5H18a4.502 4.502 0 01-4.5-4.5m0-30c0-2.484 2.016-4.5 4.5-4.5h12c2.484 0 4.5 2.016 4.5 4.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 30V18c0-2.484 2.016-4.5 4.5-4.5h30c2.484 0 4.5 2.016 4.5 4.5v12c0 2.484-2.016 4.5-4.5 4.5H9A4.502 4.502 0 014.5 30z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.5 21v6"
  }))
};
var DeviceLeft = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$W,
    fill: "none"
  }));
});
var compPaths$V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15V9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 9v6a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 10.5v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15V9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 9v6a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 10.5v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 39a4.5 4.5 0 01-4.5 4.5H18a4.5 4.5 0 01-4.5-4.5m0-30A4.5 4.5 0 0118 4.5h12A4.5 4.5 0 0134.5 9",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 30V18a4.5 4.5 0 00-4.5-4.5H9A4.5 4.5 0 004.5 18v12A4.5 4.5 0 009 34.5h30a4.5 4.5 0 004.5-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 21v6"
  }))
};
var DeviceRight = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$V,
    fill: "none"
  }));
});
var compPaths$U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25A2.25 2.25 0 012.25 15V9A2.25 2.25 0 014.5 6.75m15 0A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h6a2.25 2.25 0 002.25-2.25v-15A2.25 2.25 0 0015 2.25H9A2.25 2.25 0 006.75 4.5v15A2.25 2.25 0 009 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 18.75h-3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25A2.25 2.25 0 012.25 15V9A2.25 2.25 0 014.5 6.75m15 0A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h6a2.25 2.25 0 002.25-2.25v-15A2.25 2.25 0 0015 2.25H9A2.25 2.25 0 006.75 4.5v15A2.25 2.25 0 009 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 18.75h-3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 34.5A4.5 4.5 0 014.5 30V18A4.5 4.5 0 019 13.5m30 0a4.5 4.5 0 014.5 4.5v12a4.5 4.5 0 01-4.5 4.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 43.5h12a4.5 4.5 0 004.5-4.5V9A4.5 4.5 0 0030 4.5H18A4.5 4.5 0 0013.5 9v30a4.5 4.5 0 004.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27 37.5h-6"
  }))
};
var DeviceVertical = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$U,
    fill: "none"
  }));
});
var compPaths$T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.503 4.503 0 00-6.37 0 4.503 4.503 0 000 6.37"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.503 4.503 0 006.37 0 4.503 4.503 0 000-6.37"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.503 4.503 0 00-6.37 0 4.503 4.503 0 000 6.37"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.503 4.503 0 006.37 0 4.503 4.503 0 000-6.37"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 37.5c7.456 0 13.5-6.044 13.5-13.5S31.456 10.5 24 10.5 10.5 16.544 10.5 24 16.544 37.5 24 37.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M30.36 17.64a9.005 9.005 0 00-12.74 0 9.005 9.005 0 000 12.74"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.64 30.36a9.005 9.005 0 0012.74 0 9.005 9.005 0 000-12.74"
  }))
};
var DualLightsColorChip = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$T,
    fill: "none"
  }));
});
var compPaths$S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 12c0-2.72 1.22-5.16 3.13-6.81A7.43 7.43 0 007.5 4.5C3.36 4.5 0 7.86 0 12c0 4.14 3.36 7.5 7.5 7.5 1.12 0 2.18-.25 3.13-.69A8.987 8.987 0 017.5 12z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 12c0-2.72 1.22-5.16 3.13-6.81A7.43 7.43 0 007.5 4.5C3.36 4.5 0 7.86 0 12c0 4.14 3.36 7.5 7.5 7.5 1.12 0 2.18-.25 3.13-.69A8.987 8.987 0 017.5 12z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15 24c0-5.44 2.44-10.32 6.26-13.62C19.36 9.5 17.24 9 15 9 6.72 9 0 15.72 0 24c0 8.28 6.72 15 15 15 2.24 0 4.36-.5 6.26-1.38C17.44 34.32 15 29.44 15 24z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33 37.5c7.456 0 13.5-6.044 13.5-13.5S40.456 10.5 33 10.5 19.5 16.544 19.5 24 25.544 37.5 33 37.5z"
  }))
};
var EffectActive = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$S,
    fill: "none"
  }));
});
var compPaths$R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 19.5c-.31 0-.62-.02-.93-.06l.19-1.49c.5.06.99.06 1.48 0l.18 1.49c-.31.04-.61.06-.92.06zm-2.89-.58l-.05-.02a7.33 7.33 0 01-1.58-.92l.9-1.2c.39.29.81.54 1.27.73l.09.05-.34.57-.29.79zm5.8-.01l-.58-1.38c.46-.19.89-.44 1.28-.74l.9 1.2c-.49.37-1.03.68-1.6.92zm-8.89-2.39a7.47 7.47 0 01-.92-1.6l1.38-.59c.19.46.44.89.74 1.28l-1.2.91zM.06 12.93a6.953 6.953 0 010-1.84l1.49.18c-.04.24-.05.48-.05.73s.02.5.05.75l-1.49.18zm1.92-3.28L.58 9.1l.02-.05c.23-.55.54-1.07.9-1.55l1.2.9c-.28.38-.53.8-.72 1.25zm1.89-2.43l-.91-1.19c.49-.37 1.03-.68 1.6-.93l.59 1.38c-.46.19-.89.44-1.28.74zm7.23-.02c-.38-.29-.8-.53-1.24-.71l.58-1.38c.56.24 1.09.54 1.56.9l-.9 1.19zM6.74 6.05l-.19-1.49c.31-.04.63-.07.96-.06.29 0 .59.02.89.05l-.18 1.49c-.24-.03-.48-.03-.73-.04-.25 0-.5.02-.75.05z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 19.5c-.31 0-.62-.02-.93-.06l.19-1.49c.5.06.99.06 1.48 0l.18 1.49c-.31.04-.61.06-.92.06zm-2.89-.58l-.05-.02a7.33 7.33 0 01-1.58-.92l.9-1.2c.39.29.81.54 1.27.73l.09.05-.34.57-.29.79zm5.8-.01l-.58-1.38c.46-.19.89-.44 1.28-.74l.9 1.2c-.49.37-1.03.68-1.6.92zm-8.89-2.39a7.47 7.47 0 01-.92-1.6l1.38-.59c.19.46.44.89.74 1.28l-1.2.91zM.06 12.93a6.953 6.953 0 010-1.84l1.49.18c-.04.24-.05.48-.05.73s.02.5.05.75l-1.49.18zm1.92-3.28L.58 9.1l.02-.05c.23-.55.54-1.07.9-1.55l1.2.9c-.28.38-.53.8-.72 1.25zm1.89-2.43l-.91-1.19c.49-.37 1.03-.68 1.6-.93l.59 1.38c-.46.19-.89.44-1.28.74zm7.23-.02c-.38-.29-.8-.53-1.24-.71l.58-1.38c.56.24 1.09.54 1.56.9l-.9 1.19zM6.74 6.05l-.19-1.49c.31-.04.63-.07.96-.06.29 0 .59.02.89.05l-.18 1.49c-.24-.03-.48-.03-.73-.04-.25 0-.5.02-.75.05z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33 37.5c7.456 0 13.5-6.044 13.5-13.5S40.456 10.5 33 10.5 19.5 16.544 19.5 24 25.544 37.5 33 37.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15 39c-.62 0-1.24-.04-1.86-.12l.38-2.98c1 .12 1.98.12 2.96 0l.36 2.98c-.62.08-1.22.12-1.84.12zm-5.78-1.16l-.1-.04c-1.12-.48-2.2-1.1-3.16-1.84l1.8-2.4c.78.58 1.62 1.08 2.54 1.46l.18.1-.68 1.14-.58 1.58zm11.6-.02l-1.16-2.76c.92-.38 1.78-.88 2.56-1.48l1.8 2.4c-.98.74-2.06 1.36-3.2 1.84zM3.04 33.04c-.74-.98-1.36-2.06-1.84-3.2l2.76-1.18c.38.92.88 1.78 1.48 2.56l-2.4 1.82zM.12 25.86C.04 25.24 0 24.62 0 24c0-.6.04-1.22.12-1.82l2.98.36c-.08.48-.1.96-.1 1.46s.04 1 .1 1.5l-2.98.36zm3.84-6.56l-2.8-1.1.04-.1C1.66 17 2.28 15.96 3 15l2.4 1.8c-.56.76-1.06 1.6-1.44 2.5zm3.78-4.86l-1.82-2.38c.98-.74 2.06-1.36 3.2-1.86l1.18 2.76c-.92.38-1.78.88-2.56 1.48zm14.46-.04c-.76-.58-1.6-1.06-2.48-1.42l1.16-2.76c1.12.48 2.18 1.08 3.12 1.8l-1.8 2.38zm-8.72-2.3l-.38-2.98c.62-.08 1.26-.14 1.92-.12.58 0 1.18.04 1.78.1l-.36 2.98c-.48-.06-.96-.06-1.46-.08-.5 0-1 .04-1.5.1z"
  }))
};
var EffectInactive = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$R,
    fill: "none"
  }));
});
var compPaths$Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.284 9.349l2.651 2.65-2.65 2.653M9.716 9.349l-2.651 2.65 2.65 2.653"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.284 9.349l2.651 2.65-2.65 2.653M9.716 9.349l-2.651 2.65 2.65 2.653"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.568 18.697L33.87 24l-5.302 5.304m-9.136-10.607L14.13 24l5.302 5.304"
  }))
};
var Effort = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$Q,
    fill: "none"
  }));
});
var compPaths$P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 8.913L7.625 5.81a2.25 2.25 0 012.25 0l4.25 2.455a2.254 2.254 0 002.25 0L21.75 5.16"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.306 18.75H4.75a2.5 2.5 0 01-2.5-2.5v-3.87l5.375-3.103a2.25 2.25 0 012.25 0l4.25 2.453a2.245 2.245 0 002.25 0l4.25-2.453a.75.75 0 011.125.65v6.323a2.5 2.5 0 01-2.5 2.5h-8.944z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 8.913L7.625 5.81a2.25 2.25 0 012.25 0l4.25 2.455a2.254 2.254 0 002.25 0L21.75 5.16"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.306 18.75H4.75a2.5 2.5 0 01-2.5-2.5v-3.87l5.375-3.103a2.25 2.25 0 012.25 0l4.25 2.453a2.245 2.245 0 002.25 0l4.25-2.453a.75.75 0 011.125.65v6.323a2.5 2.5 0 01-2.5 2.5h-8.944z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 17.826l10.75-6.208a4.5 4.5 0 014.5 0l8.5 4.91a4.509 4.509 0 004.5 0L43.5 10.32"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9.5 37.5a5 5 0 01-5-5v-7.74l10.75-6.206a4.5 4.5 0 014.5 0l8.5 4.906a4.49 4.49 0 004.5 0l8.5-4.906c1-.578 2.25.146 2.25 1.3V32.5a5 5 0 01-5 5h-29z",
    clipRule: "evenodd"
  }))
};
var ElevationChange = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$P,
    fill: "none"
  }));
});
var compPaths$O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.153 11.434A5.251 5.251 0 0019.8 4.917c-2.11-1.72-5.225-1.417-7.15.508l-.657.657-.78-.794C8.76 2.837 4.49 3.316 2.75 6.723c-1.014 1.985-.54 4.414 1.036 5.989l.038.038h3.158l2.517-2.5 4 4 1.5-1.5h4.042a.5.5 0 01.353.854L11.99 21 5.9 14.9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.153 11.434A5.251 5.251 0 0019.8 4.917c-2.11-1.72-5.225-1.417-7.15.508l-.657.657-.78-.794C8.76 2.837 4.49 3.316 2.75 6.723c-1.014 1.985-.54 4.414 1.036 5.989l.038.038h3.158l2.517-2.5 4 4 1.5-1.5h4.042a.5.5 0 01.353.854L11.99 21 5.9 14.9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42.307 22.867A10.503 10.503 0 0039.6 9.833C35.38 6.395 29.15 7 25.3 10.85l-1.314 1.314-1.562-1.588c-4.902-4.902-13.442-3.944-16.922 2.87-2.028 3.97-1.08 8.828 2.072 11.978l.076.076h6.316l5.034-5 8 8 3-3h8.084c.89 0 1.336 1.078.706 1.708L23.979 42 11.8 29.801"
  }))
};
var HeartRate = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$O,
    fill: "none"
  }));
});
var compPaths$N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 18.752h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 14.253h12M6 9.75h12M6 5.25h12",
    opacity: ".2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 18.752h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 14.253h12M6 9.75h12M6 5.25h12",
    opacity: ".2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 37.504h24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 28.506h24M12 19.5h24m-24-9h24",
    opacity: ".2"
  }))
};
var LaceDown = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$N,
    fill: "none"
  }));
});
var compPaths$M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 14.25H6m12-4.5H6m12 9H6",
    opacity: ".2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 14.25H6m12-4.5H6m12 9H6",
    opacity: ".2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 10.5H12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 28.5H12m24-9H12m24 18H12",
    opacity: ".2"
  }))
};
var LaceUp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$M,
    fill: "none"
  }));
});
var compPaths$L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.65 15.46c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l10.11 10.11zM5.36 8.54A7.358 7.358 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.25 0 2.42-.31 3.46-.86L5.36 8.54z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.65 15.46c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l10.11 10.11zM5.36 8.54A7.358 7.358 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.25 0 2.42-.31 3.46-.86L5.36 8.54z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M10.06 10.06l27.88 27.88"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M10.06 10.06l27.88 27.88"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M37.3 30.92C38.38 28.84 39 26.5 39 24c0-8.28-6.72-15-15-15-2.5 0-4.86.62-6.92 1.7L37.3 30.92zM10.72 17.08C9.62 19.16 9 21.5 9 24c0 8.28 6.72 15 15 15 2.5 0 4.84-.62 6.92-1.72l-20.2-20.2z"
  }))
};
var LightsOff = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$L,
    fill: "none"
  }));
});
var compPaths$K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 18.75H6m9-9H9m6 4.5H9m6-9H9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 18.75H6m9-9H9m6 4.5H9m6-9H9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 37.5H12m18-18H18m12 9H18m12-18H18"
  }))
};
var Loosen = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$K,
    fill: "none"
  }));
});
var compPaths$J = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 5.25a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.793 22.112l4.966-8.602a1.5 1.5 0 00-1.299-2.25H3m10.974 4.365l-3.75 6.495M14 11.25h7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 5.25a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.793 22.112l4.966-8.602a1.5 1.5 0 00-1.299-2.25H3m10.974 4.365l-3.75 6.495M14 11.25h7"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 10.5a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.586 44.224l9.932-17.203c1.154-2-.29-4.5-2.598-4.5H6m21.947 8.729l-7.5 12.99M28 22.5h14"
  }))
};
var MuscleGroup = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$J,
    fill: "none"
  }));
});
var compPaths$I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 9h9V7.5h-9V9zm0-3h9V4.5h-9V6zm0 6h6v-1.5h-6V12zm4.52 4.299v3.18h3.18l2.8-2.797.933-.931h-.002l4.308-4.308-3.18-3.182-8.04 8.039zm6.977-4.857l1.061-1.061 1.061 1.06-1.06 1.06-1.062-1.06zM13.52 16.92l4.416-4.418L19 13.562l-4.418 4.419H13.52V16.92z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 19.5c0 .827-.673 1.5-1.5 1.5h-9c-.827 0-1.5-.673-1.5-1.5v-15C6 3.673 6.673 3 7.5 3h9c.827 0 1.5.673 1.5 1.5v3.697l1.5-1.5V4.5c0-1.654-1.346-3-3-3h-9c-1.654 0-3 1.346-3 3v15c0 1.654 1.346 3 3 3h9c1.654 0 3-1.346 3-3v-2.197l-1.5 1.5v.697z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 9h9V7.5h-9V9zm0-3h9V4.5h-9V6zm0 6h6v-1.5h-6V12zm4.52 4.299v3.18h3.18l2.8-2.797.933-.931h-.002l4.308-4.308-3.18-3.182-8.04 8.039zm6.977-4.857l1.061-1.061 1.061 1.06-1.06 1.06-1.062-1.06zM13.52 16.92l4.416-4.418L19 13.562l-4.418 4.419H13.52V16.92z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 19.5c0 .827-.673 1.5-1.5 1.5h-9c-.827 0-1.5-.673-1.5-1.5v-15C6 3.673 6.673 3 7.5 3h9c.827 0 1.5.673 1.5 1.5v3.697l1.5-1.5V4.5c0-1.654-1.346-3-3-3h-9c-1.654 0-3 1.346-3 3v15c0 1.654 1.346 3 3 3h9c1.654 0 3-1.346 3-3v-2.197l-1.5 1.5v.697z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 18h18v-3H15v3zm0-6h18V9H15v3zm0 12h12v-3H15v3zm9.04 8.597v6.362h6.363L36 33.361l1.866-1.862h-.002l8.616-8.616-6.362-6.364L24.04 32.597zm13.955-9.714l2.122-2.122 2.122 2.122-2.122 2.12-2.122-2.12zM27.04 33.84l8.834-8.836 2.124 2.122-8.836 8.836H27.04V33.84z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 39c0 1.654-1.346 3-3 3H15c-1.654 0-3-1.346-3-3V9c0-1.654 1.346-3 3-3h18c1.654 0 3 1.346 3 3v7.394l3-3V9c0-3.308-2.692-6-6-6H15c-3.308 0-6 2.692-6 6v30c0 3.308 2.692 6 6 6h18c3.308 0 6-2.692 6-6v-4.394l-3 3V39z",
    clipRule: "evenodd"
  }))
};
var Notes = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$I,
    fill: "none"
  }));
});
var compPaths$H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.75 3.75h-2.5v3h-4v3h-4v3h-3.5V18A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V3.75h-2.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.75 3.75h-2.5v3h-4v3h-4v3h-3.5V18A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V3.75h-2.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M35.5 7.5h-5v6h-8v6h-8v6h-7V36c0 2.484 2.016 4.5 4.5 4.5h24c2.484 0 4.5-2.016 4.5-4.5V7.5h-5z",
    clipRule: "evenodd"
  }))
};
var ProgramIntensity = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$H,
    fill: "none"
  }));
});
var compPaths$G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.5 10.5H36a4.5 4.5 0 014.5 4.5v21a4.5 4.5 0 01-4.5 4.5H12A4.5 4.5 0 017.5 36V15a4.5 4.5 0 014.5-4.5h5.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 13.5h12v-6H18v6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.425 21.334l-9.546 9.546-5.304-5.302"
  }))
};
var Programs = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$G,
    fill: "none"
  }));
});
var compPaths$F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.94 16.5l-3.182-3.18 1.06-1.06 2.122 2.12 4.242-4.242 1.06 1.06L10.94 16.5zM9.75 6h4.5V4.5h-4.5V6zM18 4.5h-2.25V3h-7.5v1.5H6c-1.654 0-3 1.345-3 3V18c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V7.5c0-1.655-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.94 16.5l-3.182-3.18 1.06-1.06 2.122 2.12 4.242-4.242 1.06 1.06L10.94 16.5zM9.75 6h4.5V4.5h-4.5V6zM18 4.5h-2.25V3h-7.5v1.5H6c-1.654 0-3 1.345-3 3V18c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V7.5c0-1.655-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.879 33.001l-6.364-6.364 2.12-2.12 4.244 4.242 8.486-8.486 2.12 2.122-10.606 10.606zm-2.378-21h9v-3h-9v3zm16.5-3h-4.5v-3h-15v3h-4.5c-3.31 0-6 2.69-6 6v21c0 3.308 2.69 6 6 6h24c3.308 0 6-2.692 6-6v-21c0-3.31-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var ProgramsFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$F,
    fill: "none"
  }));
});
var compPaths$E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M30.5 10.5H36a4.5 4.5 0 014.5 4.5v21a4.5 4.5 0 01-4.5 4.5H12A4.5 4.5 0 017.5 36V15a4.5 4.5 0 014.5-4.5h5.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M18 13.5h12v-6H18v6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M31.425 21.334l-9.546 9.546-5.304-5.302"
  }))
};
var ProgramsStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$E,
    fill: "none"
  }));
});
var compPaths$D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M30.36 17.64c-3.5-3.5-9.22-3.5-12.72 0s-3.5 9.22 0 12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15.52 32.48l-6.36 6.36M38.84 9.16l-6.36 6.36M12 24H3m42 0h-9m-20.48-8.48L9.16 9.16m29.68 29.68l-6.36-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.64 30.36c3.5 3.5 9.22 3.5 12.72 0s3.5-9.22 0-12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }))
};
var PulsingDualLights = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$D,
    fill: "none"
  }));
});
var compPaths$C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M30.36 17.64c-3.5-3.5-9.22-3.5-12.72 0s-3.5 9.22 0 12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15.52 32.48l-6.36 6.36M38.84 9.16l-6.36 6.36M12 24H3m42 0h-9m-20.48-8.48L9.16 9.16m29.68 29.68l-6.36-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.64 30.36c3.5 3.5 9.22 3.5 12.72 0s3.5-9.22 0-12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }))
};
var PulsingLights = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$C,
    fill: "none"
  }));
});
var compPaths$B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 1.5v21m10.5 0v-21M12 19.5v3m0-7.5v3m0-7.5v3M12 6v3m0-7.5v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 1.5v21m10.5 0v-21M12 19.5v3m0-7.5v3m0-7.5v3M12 6v3m0-7.5v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 3v42m21 0V3M24 39v6m0-15v6m0-15v6m0-15v6m0-15v6"
  }))
};
var Road = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$B,
    fill: "none"
  }));
});
var compPaths$A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 40.5H28m20-9.008L37 31.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.703-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 13.5c4.046 0 7.472-2.66 8.624-6.328.34-1.084 1.682-1.446 2.488-.64l7.082 7.08a4.49 4.49 0 010 6.348L21.634 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.134-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var Run = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$A,
    fill: "none"
  }));
});
var compPaths$z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 21h7v-1.5h-7V21zm4.5-4.5l5.5-.004v-1.5L18.5 15v1.5zm-4.969-2.851c-.287.706-.825 1.726-1.67 1.53-.47-.11-.807-.674-.95-1.351-.093-.433-.115-.892-.137-1.351.075.318.391 1.318 1.168 1.198.3-.048.62-.342.902-.823l3.352-5.757-2.665 6.554zm8.086-7.373l-3.54-3.541a1.477 1.477 0 00-1.407-.395 1.503 1.503 0 00-1.082 1.022A3.756 3.756 0 0111.99 6h-1.3l1.034-3.865-1.449-.388-3.197 11.937a1.9 1.9 0 01-1.224 1.307l-2.566.873A2.638 2.638 0 004.138 21h6.99l10.49-10.49a2.996 2.996 0 000-4.234z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 21h7v-1.5h-7V21zm4.5-4.5l5.5-.004v-1.5L18.5 15v1.5zm-4.969-2.851c-.287.706-.825 1.726-1.67 1.53-.47-.11-.807-.674-.95-1.351-.093-.433-.115-.892-.137-1.351.075.318.391 1.318 1.168 1.198.3-.048.62-.342.902-.823l3.352-5.757-2.665 6.554zm8.086-7.373l-3.54-3.541a1.477 1.477 0 00-1.407-.395 1.503 1.503 0 00-1.082 1.022A3.756 3.756 0 0111.99 6h-1.3l1.034-3.865-1.449-.388-3.197 11.937a1.9 1.9 0 01-1.224 1.307l-2.566.873A2.638 2.638 0 004.138 21h6.99l10.49-10.49a2.996 2.996 0 000-4.234z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28 42h14v-3H28v3zm9-12v3l11-.008v-3L37 30zm-9.937-2.702c-.575 1.412-1.65 3.452-3.342 3.06-.94-.218-1.613-1.348-1.898-2.702-.186-.866-.23-1.784-.274-2.702.15.636.782 2.636 2.335 2.396.6-.096 1.24-.684 1.805-1.646l6.703-11.514-5.33 13.108zm16.171-14.746L36.153 5.47a2.954 2.954 0 00-2.813-.79 3.006 3.006 0 00-2.164 2.044A7.512 7.512 0 0123.982 12h-2.603l2.07-7.73-2.898-.776-6.394 23.874a3.8 3.8 0 01-2.447 2.614l-5.133 1.746A5.276 5.276 0 008.276 42h13.979l20.98-20.98a5.992 5.992 0 000-8.468z",
    clipRule: "evenodd"
  }))
};
var RunFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$z,
    fill: "none"
  }));
});
var compPaths$y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 16.5a6 6 0 100-12 6 6 0 000 12zM18 30L4.06 43.94M17 40.5h12.86c1.34 0 2.02-1.62 1.06-2.58l-8.3-8.3c-1.18-1.18-1.18-3.08 0-4.24l3.32-3.32c.94-.94.28-2.56-1.06-2.56H15L10.5 24m20.46-1.9l4.42 4.4a3.018 3.018 0 004.24 0l4.42-4.4"
  }))
};
var Runner = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$y,
    fill: "none"
  }));
});
var compPaths$x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "4",
    d: "M34.5 16.5a6 6 0 100-12 6 6 0 000 12zM18 30L4.06 43.94M17 40.5h12.86c1.34 0 2.02-1.62 1.06-2.58l-8.3-8.3c-1.18-1.18-1.18-3.08 0-4.24l3.32-3.32c.94-.94.28-2.56-1.06-2.56H15L10.5 24m20.46-1.9l4.42 4.4a3.018 3.018 0 004.24 0l4.42-4.4"
  }))
};
var RunnerStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$x,
    fill: "none"
  }));
});
var compPaths$w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M42 40.5H28m20-9.008L37 31.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.703-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M23.98 13.5c4.046 0 7.472-2.66 8.624-6.328.34-1.084 1.682-1.446 2.488-.64l7.082 7.08a4.49 4.49 0 010 6.348L21.634 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.134-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var RunStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$w,
    fill: "none"
  }));
});
var compPaths$v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 6.75a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 16.5A3.75 3.75 0 1118 20.25h-7.5a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 0013.5 9.75M6.75 2V.5m3.359 2.892l1.06-1.061M2.33 11.169l1.062-1.061M11.5 6.75H13m-12.5 0H2m.33-4.419l1.062 1.061"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 6.75a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 16.5A3.75 3.75 0 1118 20.25h-7.5a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 0013.5 9.75M6.75 2V.5m3.359 2.892l1.06-1.061M2.33 11.169l1.062-1.061M11.5 6.75H13m-12.5 0H2m.33-4.419l1.062 1.061"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.5 13.5a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 33a7.5 7.5 0 117.5 7.5H21a7.5 7.5 0 010-15M19.5 27a7.5 7.5 0 0112-6m.658.555A7.472 7.472 0 0027 19.5M13.5 4V1m6.718 5.783l2.122-2.122M4.661 22.338l2.122-2.122M23 13.5h3m-25 0h3m.661-8.838l2.122 2.122"
  }))
};
var Sport = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$v,
    fill: "none"
  }));
});
var compPaths$u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25H18a2.25 2.25 0 012.25 2.25V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H6a2.25 2.25 0 01-2.25-2.25v-12A2.25 2.25 0 016 5.25h9a2.25 2.25 0 012.25 2.25v12A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.209 10.667L9.436 15.44l-2.652-2.652"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25H18a2.25 2.25 0 012.25 2.25V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H6a2.25 2.25 0 01-2.25-2.25v-12A2.25 2.25 0 016 5.25h9a2.25 2.25 0 012.25 2.25v12A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.209 10.667L9.436 15.44l-2.652-2.652"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 4.5h21c2.484 0 4.5 2.016 4.5 4.5v27"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30 43.5H12A4.502 4.502 0 017.5 39V15c0-2.484 2.016-4.5 4.5-4.5h18c2.484 0 4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.418 21.334l-9.546 9.546-5.304-5.304"
  }))
};
var Stages = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$u,
    fill: "none"
  }));
});
var compPaths$t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6m9 4.5H9m6 4.5H9m6 4.5H9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6m9 4.5H9m6 4.5H9m6 4.5H9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 10.5H12m18 9H18m12 9H18m12 9H18"
  }))
};
var Tighten = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$t,
    fill: "none"
  }));
});
var compPaths$s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 21.75v0a6.002 6.002 0 01-6.002-6.002V8.252a6.002 6.002 0 0112.004 0v7.496A6.002 6.002 0 0112 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.998 18.75v0a3 3 0 01-3-3V8.249a3 3 0 016 0v7.501a3 3 0 01-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M5.998 15.75h2.887m.17-2.25h2.887m.113-3h2.887m.363-2.25h2.583"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.961 7.5l.037 9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 21.75v0a6.002 6.002 0 01-6.002-6.002V8.252a6.002 6.002 0 0112.004 0v7.496A6.002 6.002 0 0112 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.998 18.75v0a3 3 0 01-3-3V8.249a3 3 0 016 0v7.501a3 3 0 01-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M5.998 15.75h2.887m.17-2.25h2.887m.113-3h2.887m.363-2.25h2.583"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.961 7.5l.037 9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 43.5v0c-6.63 0-12.004-5.376-12.004-12.004V16.504C11.996 9.876 17.37 4.5 24 4.5s12.004 5.376 12.004 12.004v14.992C36.004 38.124 30.63 43.5 24 43.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.995 37.5v0a6 6 0 01-6-6V16.498a6 6 0 0112 0V31.5a6 6 0 01-6 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "3",
    d: "M11.996 31.5h5.774m.34-4.5h5.773m.227-6h5.773m.727-4.5h5.165"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.923 15l.072 18"
  }))
};
var Track = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$s,
    fill: "none"
  }));
});
var compPaths$r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25H3M3.75 15V7.5a3.75 3.75 0 017.5 0v8.25a4.5 4.5 0 009 0V7.5a2.25 2.25 0 00-4.5 0V14a3.25 3.25 0 01-3.25 3.25H6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25H3M3.75 15V7.5a3.75 3.75 0 017.5 0v8.25a4.5 4.5 0 009 0V7.5a2.25 2.25 0 00-4.5 0V14a3.25 3.25 0 01-3.25 3.25H6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 34.5H6M7.5 30V15a7.5 7.5 0 0115 0v16.5a9 9 0 0018 0V15c0-2.484-2.016-4.5-4.5-4.5a4.502 4.502 0 00-4.5 4.5v13a6.5 6.5 0 01-6.5 6.5H12"
  }))
};
var Trail = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$r,
    fill: "none"
  }));
});
var compPaths$q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 20.25a1.5 1.5 0 000-3H5.25a1.5 1.5 0 000 3h13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.265 16.958L20 6.75h-8.75a1.5 1.5 0 000 3h5.25m.744-2.7l1.05-3.917"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 18.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zm13.5 0a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 20.25a1.5 1.5 0 000-3H5.25a1.5 1.5 0 000 3h13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.265 16.958L20 6.75h-8.75a1.5 1.5 0 000 3h5.25m.744-2.7l1.05-3.917"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 18.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zm13.5 0a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 40.5a3.001 3.001 0 000-6h-27a3.001 3.001 0 000 6h27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.529 33.916l5.47-20.416h-17.5a3.001 3.001 0 000 6h10.5m1.489-5.398l2.1-7.836"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 37.5a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0zm27 0a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0z",
    clipRule: "evenodd"
  }))
};
var Treadmill = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$q,
    fill: "none"
  }));
});
var compPaths$p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.49 4.49 0 003.182-1.318 4.49 4.49 0 001.318-3.182 4.49 4.49 0 00-1.318-3.182A4.49 4.49 0 0017.25 6.75a4.49 4.49 0 00-3.182 1.318 4.49 4.49 0 00-1.318 3.182m-6-3.75a5.25 5.25 0 019.645-2.873M15.25 20.821l-.75 1.3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.35 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.995-5.188L10.1 19.146l1.3.75 2.245-3.888-1.3-.75zM4.1 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.994-5.187L4.85 19.146l1.3.75 2.244-3.887-1.3-.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.326 15.493L16 19.521"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.49 4.49 0 003.182-1.318 4.49 4.49 0 001.318-3.182 4.49 4.49 0 00-1.318-3.182A4.49 4.49 0 0017.25 6.75a4.49 4.49 0 00-3.182 1.318 4.49 4.49 0 00-1.318 3.182m-6-3.75a5.25 5.25 0 019.645-2.873M15.25 20.821l-.75 1.3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.35 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.995-5.188L10.1 19.146l1.3.75 2.245-3.888-1.3-.75zM4.1 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.994-5.187L4.85 19.146l1.3.75 2.244-3.887-1.3-.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.326 15.493L16 19.521"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 13.5a9 9 0 000 18h21a8.98 8.98 0 006.364-2.636A8.98 8.98 0 0043.5 22.5a8.98 8.98 0 00-2.636-6.364A8.98 8.98 0 0034.5 13.5a8.98 8.98 0 00-6.364 2.636A8.98 8.98 0 0025.5 22.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754M30.5 41.643L29 44.24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.701 40.893l-1.5 2.598 2.598 1.5 1.5-2.598-2.598-1.5zm5.99-10.377l-4.49 7.776 2.598 1.5 4.49-7.775-2.598-1.5zM8.201 40.892l-1.5 2.598 2.598 1.5 1.5-2.597-2.598-1.5zm5.988-10.373L9.7 38.293l2.598 1.5 4.488-7.774-2.598-1.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36.652 30.986L32 39.042"
  }))
};
var WeatherHail = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$p,
    fill: "none"
  }));
});
var compPaths$o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 6.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zM8.25 9c0-2.293.736-4.413 1.983-6.14.134-.185-.018-.445-.241-.398-4.647.974-8.08 5.252-7.716 10.267.331 4.557 3.921 8.366 8.454 8.94a9.72 9.72 0 007.02-1.8c.184-.135.092-.42-.135-.443C12.352 18.859 8.25 14.414 8.25 9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.72 10.72l1.06 1.06m1.94-1.06l1.06 1.06m-1.06-4.09l1.06 1.06"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 6.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zM8.25 9c0-2.293.736-4.413 1.983-6.14.134-.185-.018-.445-.241-.398-4.647.974-8.08 5.252-7.716 10.267.331 4.557 3.921 8.366 8.454 8.94a9.72 9.72 0 007.02-1.8c.184-.135.092-.42-.135-.443C12.352 18.859 8.25 14.414 8.25 9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.72 10.72l1.06 1.06m1.94-1.06l1.06 1.06m-1.06-4.09l1.06 1.06"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 13.5a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0zm-18 4.5c0-4.586 1.472-8.826 3.966-12.28.268-.37-.036-.89-.482-.796C10.69 6.872 3.824 15.428 4.552 25.458c.662 9.114 7.842 16.732 16.908 17.88 5.274.67 10.19-.78 14.04-3.6.368-.27.184-.838-.27-.886C24.704 37.718 16.5 28.828 16.5 18z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.44 21.44l2.121 2.121m3.879-2.121l2.121 2.121m-2.121-8.182l2.12 2.121"
  }))
};
var WeatherNightClear = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$o,
    fill: "none"
  }));
});
var compPaths$n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 16.5a3.75 3.75 0 113.75 3.75H6a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 009 9.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.223 6.325c0-.65.134-1.27.374-1.833.19-.444-.27-.907-.7-.685a4.342 4.342 0 00-2.293 4.531c.286 1.89 1.864 3.407 3.763 3.631a4.347 4.347 0 002.069-.253c.448-.17.404-.819-.05-.973a4.669 4.669 0 01-3.163-4.418z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 16.5a3.75 3.75 0 113.75 3.75H6a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 009 9.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.223 6.325c0-.65.134-1.27.374-1.833.19-.444-.27-.907-.7-.685a4.342 4.342 0 00-2.293 4.531c.286 1.89 1.864 3.407 3.763 3.631a4.347 4.347 0 002.069-.253c.448-.17.404-.819-.05-.973a4.669 4.669 0 01-3.163-4.418z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.5 33a7.5 7.5 0 117.5 7.5H12a7.5 7.5 0 010-15M10.5 27a7.5 7.5 0 0112-6m.658.555A7.472 7.472 0 0018 19.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36.445 12.65c0-1.302.268-2.542.748-3.666.38-.888-.54-1.814-1.398-1.37a8.683 8.683 0 00-4.588 9.062c.572 3.78 3.728 6.814 7.526 7.262a8.693 8.693 0 004.138-.506c.896-.342.808-1.638-.1-1.946-3.678-1.254-6.326-4.732-6.326-8.836z",
    clipRule: "evenodd"
  }))
};
var WeatherNightOvercast = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$n,
    fill: "none"
  }));
});
var compPaths$m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 19.5a9 9 0 000 18h21a9 9 0 10-9-9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 21c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754"
  }))
};
var WeatherOvercast = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$m,
    fill: "none"
  }));
});
var compPaths$l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h10.5m-6-3h-12m11.25-7.5a4.5 4.5 0 114.5 4.5H6.75a4.5 4.5 0 010-9m0 .75a5.25 5.25 0 019.645-2.873M21.75 19.5a2.25 2.25 0 01-2.25 2.25"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h10.5m-6-3h-12m11.25-7.5a4.5 4.5 0 114.5 4.5H6.75a4.5 4.5 0 010-9m0 .75a5.25 5.25 0 019.645-2.873M21.75 19.5a2.25 2.25 0 01-2.25 2.25"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 43.5h21m-12-6H3m22.5-15a9 9 0 119 9h-21a9 9 0 010-18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754M43.5 39c0 2.484-2.016 4.5-4.5 4.5"
  }))
};
var WeatherOvercastWind = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$l,
    fill: "none"
  }));
});
var compPaths$k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.995 15.633l-2.245 3.889-1.5 2.598m-1.506-6.485L5.5 19.522 4 22.12m14.326-6.627L16 19.521l-1.5 2.6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.995 15.633l-2.245 3.889-1.5 2.598m-1.506-6.485L5.5 19.522 4 22.12m14.326-6.627L16 19.521l-1.5 2.6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 13.5a9 9 0 000 18h21a9 9 0 10-9-9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754m-6.8 22.012l-4.49 7.778-3 5.196m-3.012-12.97L11 39.044 8 44.24m28.653-13.254L32 39.042l-3 5.198"
  }))
};
var WeatherRain = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$k,
    fill: "none"
  }));
});
var compPaths$j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.5 12h-5m14.75 0H14.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 12a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 21v-3.75H21M9.349 21.977l2.65-2.65 2.653 2.65M6.75 21v-3.75H3M6.75 3v3.75H3M17.25 3v3.75H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.349 21.974l2.65-2.651 2.653 2.65m-.001-19.947l-2.65 2.651-2.653-2.65M2.026 9.349l2.651 2.65-2.65 2.653m19.947-.001l-2.651-2.65 2.65-2.653m-11.778.972L6.66 6.785m10.43 10.43l-3.358-3.358m-1.857-4.232v-5m0 14.75v-4.75m1.68-4.305l3.535-3.535M6.66 17.215l3.358-3.358"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.5 12h-5m14.75 0H14.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 12a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 21v-3.75H21M9.349 21.977l2.65-2.65 2.653 2.65M6.75 21v-3.75H3M6.75 3v3.75H3M17.25 3v3.75H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.349 21.974l2.65-2.651 2.653 2.65m-.001-19.947l-2.65 2.651-2.653-2.65M2.026 9.349l2.651 2.65-2.65 2.653m19.947-.001l-2.651-2.65 2.65-2.653m-11.778.972L6.66 6.785m10.43 10.43l-3.358-3.358m-1.857-4.232v-5m0 14.75v-4.75m1.68-4.305l3.535-3.535M6.66 17.215l3.358-3.358"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19 24H9m29.5 0H29"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 24c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 42v-7.5H42m-23.303 9.455l5.302-5.302 5.304 5.302M13.5 42v-7.5H6M13.5 6v7.5H6M34.5 6v7.5H42"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.697 43.947l5.302-5.302 5.304 5.302m0-39.894L24 9.355l-5.304-5.302M4.053 18.697l5.302 5.302-5.302 5.304m39.894 0L38.645 24l5.302-5.304M20.39 20.64l-7.07-7.07m20.86 20.86l-6.716-6.716M23.75 19.25v-10m0 29.5v-9.5m3.36-8.61l7.07-7.07M13.32 34.43l6.716-6.716"
  }))
};
var WeatherSnow = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$j,
    fill: "none"
  }));
});
var compPaths$i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 19.5v3m0-21v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 12a5.25 5.25 0 11-10.501-.001A5.25 5.25 0 0117.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.697 17.304l-2.122 2.12m14.85-14.849l-2.122 2.121M4.5 12h-3m21 0h-3M6.697 6.696l-2.122-2.12m14.85 14.849l-2.122-2.121"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 19.5v3m0-21v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 12a5.25 5.25 0 11-10.501-.001A5.25 5.25 0 0117.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.697 17.304l-2.122 2.12m14.85-14.849l-2.122 2.121M4.5 12h-3m21 0h-3M6.697 6.696l-2.122-2.12m14.85 14.849l-2.122-2.121"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 39v6m0-42v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 24c0 5.798-4.702 10.5-10.5 10.5S13.5 29.798 13.5 24 18.202 13.5 24 13.5 34.5 18.202 34.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.394 34.607L9.15 38.85m29.7-29.7l-4.244 4.242M9 24H3m42 0h-6M13.394 13.393L9.15 9.15m29.7 29.7l-4.244-4.242"
  }))
};
var WeatherSunny = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$i,
    fill: "none"
  }));
});
var compPaths$h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 6a3.75 3.75 0 01-3.75 3.75h-9m15.75.75a2.25 2.25 0 112.25 2.25h-18M12.75 18A2.25 2.25 0 1015 15.75H1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 6a3.75 3.75 0 01-3.75 3.75h-9m15.75.75a2.25 2.25 0 112.25 2.25h-18M12.75 18A2.25 2.25 0 1015 15.75H1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 12a7.5 7.5 0 01-7.5 7.5H3M34.5 21a4.5 4.5 0 114.5 4.5H3M25.5 36a4.5 4.5 0 104.5-4.5H3"
  }))
};
var WeatherWind = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$h,
    fill: "none"
  }));
});
var compPaths$g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 8.25h6m-6 3.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 8.25H7.5M9 12H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 15.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 15.75H7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 8.25h6m-6 3.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 8.25H7.5M9 12H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 15.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 15.75H7.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M21 16.5h12M21 24h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24c2.484 0 4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 16.5h-3m3 7.5h-3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M21 31.5h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 31.5h-3"
  }))
};
var Whiteboard = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$g,
    fill: "none"
  }));
});
var compPaths$f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.75h3V5.25h-3v13.5zm13.5 0h3V5.25h-3v13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 12h8.25M20 12h2.5m-21 0H4"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.75h3V5.25h-3v13.5zm13.5 0h3V5.25h-3v13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 12h8.25M20 12h2.5m-21 0H4"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 37.5h6v-27h-6v27zm27 0h6v-27h-6v27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 24h16.5m5.5 0h5M3 24h5"
  }))
};
var WorkoutEquipment = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$f,
    fill: "none"
  }));
});
var compPaths$e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.712 8.72l-4.242 4.243 1.06 1.06 4.243-4.243-1.061-1.06zm-3.181 5.303l4.242-4.243-1.061-1.06-4.242 4.243 1.06 1.06zM7.5 3h9V1.5h-9V3zm9-1.5h-9V3h9V1.5zm3 12A7.5 7.5 0 0112 21v1.5a9 9 0 009-9h-1.5zM12 21a7.5 7.5 0 01-7.5-7.5H3a9 9 0 009 9V21zm-7.5-7.5A7.5 7.5 0 0112 6V4.5a9 9 0 00-9 9h1.5zM12 6a7.5 7.5 0 017.5 7.5H21a9 9 0 00-9-9V6z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.712 8.72l-4.242 4.243 1.06 1.06 4.243-4.243-1.061-1.06zm-3.181 5.303l4.242-4.243-1.061-1.06-4.242 4.243 1.06 1.06zM7.5 3h9V1.5h-9V3zm9-1.5h-9V3h9V1.5zm3 12A7.5 7.5 0 0112 21v1.5a9 9 0 009-9h-1.5zM12 21a7.5 7.5 0 01-7.5-7.5H3a9 9 0 009 9V21zm-7.5-7.5A7.5 7.5 0 0112 6V4.5a9 9 0 00-9 9h1.5zM12 6a7.5 7.5 0 017.5 7.5H21a9 9 0 00-9-9V6z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 27c0 9.112-7.386 16.5-16.5 16.5S7.5 36.112 7.5 27 14.886 10.5 24 10.5 40.5 17.888 40.5 27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 4.5h18m-.516 14L24 26.986"
  }))
};
var Workouts = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$e,
    fill: "none"
  }));
});
var compPaths$d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25h9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.53 14.023l-1.06-1.061 4.242-4.242 1.06 1.06-4.241 4.243zM12 4.5c-4.963 0-9 4.038-9 9s4.037 9 9 9 9-4.038 9-9-4.037-9-9-9z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25h9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.53 14.023l-1.06-1.061 4.242-4.242 1.06 1.06-4.241 4.243zM12 4.5c-4.963 0-9 4.038-9 9s4.037 9 9 9 9-4.038 9-9-4.037-9-9-9z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 4.5h18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.06 28.046l-2.121-2.122 8.485-8.484 2.12 2.12-8.483 8.486zM24 9C14.075 9 6 17.076 6 27s8.075 18 18 18c9.926 0 18-8.076 18-18S33.927 9 24 9z",
    clipRule: "evenodd"
  }))
};
var WorkoutsFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$d,
    fill: "none"
  }));
});
var compPaths$c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M20.25 13.5a8.25 8.25 0 11-16.5 0 8.25 8.25 0 1116.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 2.25h9m-.258 7L12 13.493"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M20.25 13.5a8.25 8.25 0 11-16.5 0 8.25 8.25 0 1116.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 2.25h9m-.258 7L12 13.493"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M40.5 27c0 9.112-7.386 16.5-16.5 16.5S7.5 36.112 7.5 27 14.886 10.5 24 10.5 40.5 17.888 40.5 27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M15 4.5h18m-.516 14L24 26.986"
  }))
};
var WorkoutsStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$c,
    fill: "none"
  }));
});
var compPaths$b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 17.5V5m-5.5 7.5L12 18l5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.966 12.979L12 19.945 5.033 12.98M12 20V3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.933 25.957L24 39.891 10.067 25.957M24 40V6"
  }))
};
var ArrowDown = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$b,
    fill: "none"
  }));
});
var compPaths$a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.5 12H19m-7.5 5.5L6 12l5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.021 18.967L4.055 12l6.966-6.967M4 12h17"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M22.042 37.933L8.11 24l13.932-13.934M8 24h34"
  }))
};
var ArrowLeft = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$a,
    fill: "none"
  }));
});
var compPaths$9 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 12H5m7.5 5.5L18 12l-5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.979 18.967L19.945 12 12.98 5.033M20 12H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.957 37.933L39.891 24 25.957 10.065M40 24H6"
  }))
};
var ArrowRight = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$9,
    fill: "none"
  }));
});
var compPaths$8 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 6.5V19m-5.5-7.5L12 6l5.5 5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.033 11.022L12 4.055l6.967 6.967M12 4v17"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.066 22.043L24 8.109l13.934 13.934M24 8v34"
  }))
};
var ArrowUp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$8,
    fill: "none"
  }));
});
var compPaths$7 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 9.25l-5.5 5.5-5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.966 8.476L12 15.443 5.033 8.476"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.933 16.951L24 30.885 10.067 16.951"
  }))
};
var CaretDown = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$7,
    fill: "none"
  }));
});
var compPaths$6 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 17.5L9.25 12l5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.525 18.966L8.558 12l6.967-6.967"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.05 37.932L17.118 24 31.05 10.066"
  }))
};
var CaretLeft = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$6,
    fill: "none"
  }));
});
var compPaths$5 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 17.5l5.5-5.5-5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.474 18.966L15.44 12 8.474 5.033"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.947 37.932L30.881 24 16.947 10.066"
  }))
};
var CaretRight = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$5,
    fill: "none"
  }));
});
var compPaths$4 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 14.75L12 9.25l-5.5 5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.034 15.527L12 8.561l6.967 6.966"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.067 31.054L24 17.122l13.934 13.932"
  }))
};
var CaretUp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4,
    fill: "none"
  }));
});
var compPaths$3 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 6.5l-11 11m0-11l11 11"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.973 5.027L5.028 18.972M5.027 5.027l13.945 13.945"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.945 10.055l-27.89 27.89m0-27.89l27.89 27.89"
  }))
};
var Close = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3,
    fill: "none"
  }));
});
var compPaths$2 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 12H6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 12h-15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M39 24H9"
  }))
};
var Minus = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2,
    fill: "none"
  }));
});
var compPaths$1 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 12H6m6 6V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 12h-15m7.5 7.5v-15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M39 24H9m15 15V9"
  }))
};
var Plus = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1,
    fill: "none"
  }));
});
var compPaths = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10 10H5m14 4.5h-5m-6.5-2v-5M7.958 19l8.084-14"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 10.5H3m18 3.75h-6m-9-.75v-6m1.5 12.294l9-15.588"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 21H6m36 7.5H30M12 27V15m3 24.588L33 8.412"
  }))
};
var PlusMinus = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});
var DSIcons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Converse,
  Hurley,
  Jordan,
  NBY,
  NikeApp,
  NikeSwoosh,
  Sustainability,
  Activity,
  ActivityFilled,
  ActivityStroke,
  AddFriends,
  AddPayment,
  Alert,
  AlertCircle,
  AlertCircleFilled,
  Analytics,
  AnalyticsFilled,
  AnalyticsStroke,
  AR,
  Bag,
  BagFilled,
  BagStroke,
  Bookmark,
  BookmarkFilled,
  BookmarkStroke,
  BrightnessNone,
  Calendar,
  Camera,
  Cards,
  Check,
  CheckCircle,
  CheckCircleFilled,
  Club,
  ClubFilled,
  ClubStroke,
  Coach,
  Collapse,
  Comments,
  Compare,
  CreateRule,
  CreateRuleFilled,
  Delete,
  Desktop,
  Discover,
  DiscoverFilled,
  DiscoverStroke,
  Download,
  Edit,
  Ellipsis,
  EllipsisVertical,
  Expand,
  Experiments,
  ExternalLink,
  Favorite,
  FavoriteFilled,
  FavoriteStroke,
  Feed,
  FeedStroke,
  Filter,
  FirstAccess,
  FlashlightOff,
  FlashlightOn,
  GestureSwipe,
  GestureTap,
  Gift,
  GiftCard,
  Global,
  GridView,
  Hide,
  History,
  Home,
  HomeFilled,
  HomeStroke,
  ImagenoImage,
  Inbox,
  InboxFilled,
  InboxStroke,
  Info,
  InfoCircle,
  InfoCircleFilled,
  Journal,
  Link,
  Loading,
  LocationPin,
  LocationPinFilled,
  Lock,
  LockFilled,
  Measure,
  MemberProduct,
  MemberRewards,
  Menu: Menu$1,
  Menu2lines,
  Message,
  Microphone,
  Monarch,
  Multimedia,
  MultiSelect,
  Navigation,
  NikeMembership,
  Notification,
  Null,
  Orders,
  Payment,
  Personalization,
  Plan,
  PlusCircle,
  PlusCircleFilled,
  Print,
  Profile,
  ProfileFilled,
  ProfileStroke,
  ProfileSwoosh,
  ProfileSwooshStroke,
  QRCode,
  Question,
  QuestionCircle,
  QuestionCircleFilled,
  Rating,
  RatingFilled,
  RatingStroke,
  Receipt,
  ReceiptNone,
  Repeat,
  Replay,
  Report,
  Return,
  Review,
  Rewards,
  Rfid,
  Scan,
  Search,
  Settings,
  SettingsFilled,
  Share,
  Shareaos,
  Shipping,
  Shoe,
  ShoeFilled,
  ShoeStroke,
  ShopnikeApp,
  ShopnikeAppFilled,
  ShopnikeAppStroke,
  Shopnrc,
  ShopnrcStroke,
  ShopSNKRS,
  Show,
  Shuffle,
  SingleSelect,
  Sort,
  SortAscending: SortAscending$1,
  SortDescending: SortDescending$1,
  Store,
  TabletHorizontal,
  TabletVertical,
  Tag,
  ThumbsDown,
  ThumbsUp,
  Time,
  Tip,
  Transfers,
  Translation,
  TrendingDown,
  TrendingUp,
  Unlock,
  UnlockFilled,
  Upload,
  VideoPlayer,
  VR,
  Wallet,
  Zoomin,
  Zoomout,
  Columns,
  Container,
  CopyPaste,
  CopyPasteFilled,
  FormatBold,
  FormatBullet,
  FormatItalics,
  FormatNumberedList,
  Heading,
  Keyboard,
  Redo,
  Text,
  Undo,
  ClosedCaption,
  ClosedCaptionFilled,
  FastForward,
  FastForwardFilled,
  Music,
  MusicFilled,
  MusicNone,
  MusicNoneFilled,
  Mute,
  MuteFilled,
  Pause,
  PauseFilled,
  Play,
  PlayFilled,
  Rewind,
  RewindFilled,
  Stop,
  StopFilled,
  VolumeHigh,
  VolumeHighFilled,
  VolumeLow,
  VolumeLowFilled,
  Adapt,
  AdaptLight,
  AppleWatch,
  AudioFeedback,
  BatteryChargingFull,
  BatteryChargingLow,
  BatteryFull,
  BatteryLow,
  Brightness,
  Burn,
  ClassWorkout,
  Device,
  DeviceLeft,
  DeviceRight,
  DeviceVertical,
  DualLightsColorChip,
  EffectActive,
  EffectInactive,
  Effort,
  ElevationChange,
  HeartRate,
  LaceDown,
  LaceUp,
  LightsOff,
  Loosen,
  MuscleGroup,
  Notes,
  ProgramIntensity,
  Programs,
  ProgramsFilled,
  ProgramsStroke,
  PulsingDualLights,
  PulsingLights,
  Road,
  Run,
  RunFilled,
  Runner,
  RunnerStroke,
  RunStroke,
  Sport,
  Stages,
  Tighten,
  Track,
  Trail,
  Treadmill,
  WeatherHail,
  WeatherNightClear,
  WeatherNightOvercast,
  WeatherOvercast,
  WeatherOvercastWind,
  WeatherRain,
  WeatherSnow,
  WeatherSunny,
  WeatherWind,
  Whiteboard,
  WorkoutEquipment,
  Workouts,
  WorkoutsFilled,
  WorkoutsStroke,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  Close,
  Minus,
  Plus,
  PlusMinus,
  CheckboxIcon,
  RadioIcon,
  SuccessIcon,
  SvgIcon
}, Symbol.toStringTag, { value: "Module" }));
const DSIcon = (_i) => {
  var _j = _i, {
    type
  } = _j, rest = __objRest(_j, [
    "type"
  ]);
  const IconComponent = DSIcons[type];
  if (!IconComponent)
    return null;
  return /* @__PURE__ */ jsx$1(IconComponent, __spreadValues({}, rest));
};
const DSTypes = Object.keys(DSIcons).filter((type) => {
  return type !== "CheckboxIcon" && type !== "SuccessIcon" && type !== "SvgIcon" && type !== "RadioIcon";
});
DSIcon.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(DSTypes).isRequired,
  size: PropTypes.oneOf(["s", "m", "l"])
};
const Icon = (_k) => {
  var _l = _k, {
    type,
    className,
    fontSize
  } = _l, props = __objRest(_l, [
    "type",
    "className",
    "fontSize"
  ]);
  if (CXTypes.includes(type)) {
    return /* @__PURE__ */ jsx$1(CXIcon, __spreadValues({
      type,
      className
    }, props));
  }
  if (DSTypes.includes(type)) {
    return /* @__PURE__ */ jsx$1(DSIcon, __spreadValues({
      type,
      className
    }, props));
  }
  return /* @__PURE__ */ jsx$1("i", __spreadValues({
    className: `epic-icon epic-icon-${type} ${className}`,
    style: {
      fontSize
    }
  }, props));
};
Icon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(["s", "m", "l"]),
  type: PropTypes.oneOf([...DSTypes, ...CXTypes, "add", "arrow-backward", "arrow-down", "arrow-forward", "arrow-up", "bookmark", "calendar", "checkmark", "chevron-back", "chevron-circle-back", "chevron-circle-forward", "chevron-down", "chevron-forward", "chevron-up", "close-x", "collaborate", "confluence", "contact", "delete", "edit", "filter-x", "filter", "github", "information", "jira", "map-pin", "nike-logo", "preview-eye", "preview", "profile", "quotes", "search", "share", "slack-with-name", "slack", "steps", "up-and-running", "user-profile", "walkthrough", "warning"]).isRequired,
  fontSize: PropTypes.string
};
Icon.defaultProps = {
  className: "",
  fontSize: "14px"
};
const icon$n = "epic__icon__268";
const ripple$n = "epic__ripple__948";
const button$2 = "epic__button__130";
const bare = "epic__bare__df6";
const positionFirst = "epic__positionFirst__f88";
const content$2 = "epic__content__351";
var styles$n = {
  icon: icon$n,
  "epic-icon": "epic__epic-icon__996",
  "epic-icon-add": "epic__epic-icon-add__1ba",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__7a1",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__242",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__fa7",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__a7a",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__7d4",
  "epic-icon-calendar": "epic__epic-icon-calendar__ec8",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__9f6",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__164",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__bf4",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__cca",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__6de",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__a8f",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__e97",
  "epic-icon-close-x": "epic__epic-icon-close-x__0f1",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__129",
  "epic-icon-confluence": "epic__epic-icon-confluence__565",
  "epic-icon-contact": "epic__epic-icon-contact__efb",
  "epic-icon-delete": "epic__epic-icon-delete__68a",
  "epic-icon-edit": "epic__epic-icon-edit__f72",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__f79",
  "epic-icon-filter": "epic__epic-icon-filter__696",
  "epic-icon-github": "epic__epic-icon-github__e23",
  "epic-icon-information": "epic__epic-icon-information__26b",
  "epic-icon-jira": "epic__epic-icon-jira__55e",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__a83",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__616",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__2f2",
  "epic-icon-preview": "epic__epic-icon-preview__2a6",
  "epic-icon-profile": "epic__epic-icon-profile__934",
  "epic-icon-quotes": "epic__epic-icon-quotes__c5f",
  "epic-icon-search": "epic__epic-icon-search__4ac",
  "epic-icon-share": "epic__epic-icon-share__e13",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__5f5",
  "epic-icon-slack": "epic__epic-icon-slack__1e5",
  "epic-icon-steps": "epic__epic-icon-steps__c79",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__a84",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__ead",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__7f7",
  "epic-icon-warning": "epic__epic-icon-warning__a07",
  "epic-font-base": "epic__epic-font-base__3bb",
  "epic-font-base-md": "epic__epic-font-base-md__3c6",
  "epic-font-marketing": "epic__epic-font-marketing__3ac",
  "epic-font-brand": "epic__epic-font-brand__de6",
  ripple: ripple$n,
  button: button$2,
  bare,
  positionFirst,
  content: content$2
};
function IconButton(_m) {
  var _n = _m, {
    positionFirst: positionFirst2,
    type,
    bare: bare2 = false,
    children,
    iconFontSize,
    iconClassName,
    buttonClassName,
    iconSize
  } = _n, props = __objRest(_n, [
    "positionFirst",
    "type",
    "bare",
    "children",
    "iconFontSize",
    "iconClassName",
    "buttonClassName",
    "iconSize"
  ]);
  const size = iconFontSize || (props.large ? "30px" : "");
  let buttonClass = `${styles$n.button} ${bare2 ? styles$n.bare : ""}`;
  if (positionFirst2)
    buttonClass += ` ${styles$n.positionFirst}`;
  let icon2 = /* @__PURE__ */ jsx$1(Icon, {
    className: iconClassName,
    type,
    fontSize: size,
    size: iconSize
  });
  let content2 = /* @__PURE__ */ jsx$1("div", {
    className: styles$n.content,
    children
  });
  return positionFirst2 ? /* @__PURE__ */ jsxs(Button$1, __spreadProps(__spreadValues({}, props), {
    className: classnames$1(buttonClass, buttonClassName),
    children: [icon2, content2]
  })) : /* @__PURE__ */ jsxs(Button$1, __spreadProps(__spreadValues({}, props), {
    className: classnames$1(buttonClass, buttonClassName),
    children: [content2, icon2]
  }));
}
IconButton.propTypes = {
  type: PropTypes.string.isRequired,
  iconFontSize: PropTypes.string,
  positionFirst: PropTypes.bool,
  bare: PropTypes.bool,
  iconClassName: PropTypes.string,
  iconSize: PropTypes.string,
  buttonClassName: PropTypes.string
};
IconButton.defaultProps = {
  positionFirst: false,
  iconFontSize: "14px",
  iconSize: "m",
  bare: false
};
const icon$m = "epic__icon__a42";
const ripple$m = "epic__ripple__201";
const listItem$1 = "epic__listItem__4b0";
const inner$1 = "epic__inner__6b3";
const title$3 = "epic__title__bf2";
const name = "epic__name__04d";
const subtitle$1 = "epic__subtitle__31b";
const noBorder = "epic__noBorder__6cc";
const thumbnail = "epic__thumbnail__2c4";
const info = "epic__info__97a";
const content$1 = "epic__content__0be";
const action = "epic__action__fd9";
var styles$m = {
  icon: icon$m,
  "epic-icon": "epic__epic-icon__529",
  "epic-icon-add": "epic__epic-icon-add__ae6",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__493",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__bd9",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__56a",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__e95",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__c75",
  "epic-icon-calendar": "epic__epic-icon-calendar__915",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__6fc",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__8a1",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__f99",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__f69",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__eb5",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__892",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__762",
  "epic-icon-close-x": "epic__epic-icon-close-x__b1b",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__ac9",
  "epic-icon-confluence": "epic__epic-icon-confluence__422",
  "epic-icon-contact": "epic__epic-icon-contact__4d5",
  "epic-icon-delete": "epic__epic-icon-delete__585",
  "epic-icon-edit": "epic__epic-icon-edit__6ba",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__bc1",
  "epic-icon-filter": "epic__epic-icon-filter__7dc",
  "epic-icon-github": "epic__epic-icon-github__b2f",
  "epic-icon-information": "epic__epic-icon-information__420",
  "epic-icon-jira": "epic__epic-icon-jira__90e",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__555",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__dbb",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__2d5",
  "epic-icon-preview": "epic__epic-icon-preview__4e3",
  "epic-icon-profile": "epic__epic-icon-profile__fe3",
  "epic-icon-quotes": "epic__epic-icon-quotes__0f1",
  "epic-icon-search": "epic__epic-icon-search__1a7",
  "epic-icon-share": "epic__epic-icon-share__701",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__da8",
  "epic-icon-slack": "epic__epic-icon-slack__11f",
  "epic-icon-steps": "epic__epic-icon-steps__99a",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__f3c",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__419",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__114",
  "epic-icon-warning": "epic__epic-icon-warning__14d",
  "epic-font-base": "epic__epic-font-base__40b",
  "epic-font-base-md": "epic__epic-font-base-md__305",
  "epic-font-marketing": "epic__epic-font-marketing__4b3",
  "epic-font-brand": "epic__epic-font-brand__5c9",
  ripple: ripple$m,
  "epic-display-base": "epic__epic-display-base__790",
  "epic-display-1": "epic__epic-display-1__f27",
  "epic-display-2": "epic__epic-display-2__415",
  "epic-display-3": "epic__epic-display-3__e50",
  "epic-display-4": "epic__epic-display-4__cbe",
  "epic-display-5": "epic__epic-display-5__3fb",
  "epic-title-base": "epic__epic-title-base__0d9",
  "epic-title-1": "epic__epic-title-1__ed2",
  "epic-title-2": "epic__epic-title-2__7d5",
  "epic-title-3": "epic__epic-title-3__b52",
  "epic-title-4": "epic__epic-title-4__61e",
  "epic-title-5": "epic__epic-title-5__b08",
  "epic-title-6": "epic__epic-title-6__3e8",
  "epic-subtitle-base": "epic__epic-subtitle-base__bdd",
  "epic-subtitle-1": "epic__epic-subtitle-1__5da",
  "epic-subtitle-2": "epic__epic-subtitle-2__a46",
  "epic-subtitle-3": "epic__epic-subtitle-3__bfd",
  "epic-body-text-base": "epic__epic-body-text-base__d0b",
  "epic-body-text-1": "epic__epic-body-text-1__d19",
  "epic-body-text-2": "epic__epic-body-text-2__30c",
  "epic-body-text": "epic__epic-body-text__0a9",
  "epic-body-text-3": "epic__epic-body-text-3__934",
  listItem: listItem$1,
  inner: inner$1,
  title: title$3,
  name,
  subtitle: subtitle$1,
  "epic-legal-text": "epic__epic-legal-text__65a",
  "epic-label-text": "epic__epic-label-text__8d8",
  "epic-button-base": "epic__epic-button-base__6ac",
  "epic-button-1": "epic__epic-button-1__ba3",
  "epic-button-2": "epic__epic-button-2__008",
  "epic-button-3": "epic__epic-button-3__f3f",
  noBorder,
  thumbnail,
  info,
  content: content$1,
  action
};
function ListItem({
  iconType,
  onAction,
  thumbnail: thumbnail2,
  content: content2,
  subtitle: subtitle2,
  name: name2,
  className,
  noBorder: noBorder2
}) {
  let containerClass = classnames$1(styles$m.listItem, className);
  if (noBorder2) {
    containerClass = classnames$1(containerClass, styles$m.noBorder);
  }
  return /* @__PURE__ */ jsx$1("div", {
    className: containerClass,
    children: /* @__PURE__ */ jsxs("div", {
      className: styles$m.inner,
      children: [/* @__PURE__ */ jsxs("div", {
        className: styles$m.title,
        children: [/* @__PURE__ */ jsx$1("div", {
          className: styles$m.thumbnail,
          children: thumbnail2 && thumbnail2
        }), /* @__PURE__ */ jsxs("div", {
          className: styles$m.info,
          children: [/* @__PURE__ */ jsx$1("div", {
            className: styles$m.name,
            children: name2
          }), /* @__PURE__ */ jsx$1("div", {
            className: styles$m.subtitle,
            children: subtitle2
          })]
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: styles$m.content,
        children: content2
      }), iconType && /* @__PURE__ */ jsx$1("div", {
        className: styles$m.action,
        children: /* @__PURE__ */ jsx$1(IconButton, {
          bare: true,
          type: iconType,
          iconSize: "m",
          onClick: onAction
        })
      })]
    })
  });
}
ListItem.propTypes = {
  iconType: PropTypes.string,
  onAction: PropTypes.func,
  content: PropTypes.oneOf([PropTypes.string, PropTypes.node, PropTypes.func]),
  thumbnail: PropTypes.node,
  name: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string
};
ListItem.defaultProps = {
  className: "",
  name: "",
  date: "",
  onAction: () => void 0
};
const icon$l = "epic__icon__f43";
const ripple$l = "epic__ripple__32d";
const modal = "epic__modal__0d8";
const xsm = "epic__xsm__a04";
const sm = "epic__sm__2ed";
const md = "epic__md__f16";
const lg = "epic__lg__5d4";
const auto = "epic__auto__4d0";
const show$1 = "epic__show__eb2";
const close = "epic__close__eec";
const fadeIn = "epic__fadeIn__c4b";
const modalInner = "epic__modalInner__b6b";
const title$2 = "epic__title__0d6";
const content = "epic__content__9df";
const actions = "epic__actions__5c6";
var styles$l = {
  icon: icon$l,
  "epic-icon": "epic__epic-icon__02a",
  "epic-icon-add": "epic__epic-icon-add__7c3",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__85f",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__19c",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__cc1",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__023",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__151",
  "epic-icon-calendar": "epic__epic-icon-calendar__7a1",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__228",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__f72",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__d8c",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__95c",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__62e",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__a30",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__daf",
  "epic-icon-close-x": "epic__epic-icon-close-x__9ce",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__c67",
  "epic-icon-confluence": "epic__epic-icon-confluence__706",
  "epic-icon-contact": "epic__epic-icon-contact__a7e",
  "epic-icon-delete": "epic__epic-icon-delete__0d3",
  "epic-icon-edit": "epic__epic-icon-edit__6c6",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__04f",
  "epic-icon-filter": "epic__epic-icon-filter__2f2",
  "epic-icon-github": "epic__epic-icon-github__ea1",
  "epic-icon-information": "epic__epic-icon-information__44b",
  "epic-icon-jira": "epic__epic-icon-jira__3a3",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__d38",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__91c",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__97e",
  "epic-icon-preview": "epic__epic-icon-preview__9f0",
  "epic-icon-profile": "epic__epic-icon-profile__eab",
  "epic-icon-quotes": "epic__epic-icon-quotes__b75",
  "epic-icon-search": "epic__epic-icon-search__dde",
  "epic-icon-share": "epic__epic-icon-share__cfa",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__cbf",
  "epic-icon-slack": "epic__epic-icon-slack__e6e",
  "epic-icon-steps": "epic__epic-icon-steps__e28",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__d98",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__6d4",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__22b",
  "epic-icon-warning": "epic__epic-icon-warning__744",
  "epic-font-base": "epic__epic-font-base__ee3",
  "epic-font-base-md": "epic__epic-font-base-md__cb3",
  "epic-font-marketing": "epic__epic-font-marketing__302",
  "epic-font-brand": "epic__epic-font-brand__754",
  ripple: ripple$l,
  modal,
  xsm,
  sm,
  md,
  lg,
  auto,
  show: show$1,
  close,
  fadeIn,
  modalInner,
  title: title$2,
  content,
  actions
};
function AddChildrenWarning() {
  return /* @__PURE__ */ jsxs("p", {
    children: ["You must add children to this component. Please see documentation", " ", /* @__PURE__ */ jsx$1("a", {
      href: "/?path=/story/next-gen-modal--show-modal-with-button",
      children: "here"
    })]
  });
}
const Modal = (_o) => {
  var _p = _o, {
    onClose
  } = _p, props = __objRest(_p, [
    "onClose"
  ]);
  const [show2, setShow] = useState(false);
  const {
    className,
    children,
    closeButton,
    modalSize
  } = props;
  let sizeClass;
  if (modalSize === "sm" || modalSize === "md" || modalSize === "lg") {
    sizeClass = modalSize;
  }
  const close2 = () => {
    setShow(false);
    onClose && onClose();
  };
  const keyDown = (e) => {
    if (e.key === "Escape")
      close2();
  };
  useEffect(() => {
    window.addEventListener("keydown", keyDown);
    setShow(props.show);
    return () => {
      window.removeEventListener("keydown", keyDown);
    };
  }, [props.show]);
  return /* @__PURE__ */ jsx$1(Overlay, {
    show: show2,
    onClick: close2,
    children: /* @__PURE__ */ jsxs("div", {
      className: `${styles$l.modal} ${sizeClass ? styles$l[sizeClass] : ""} ${show2 ? styles$l.show : ""} epic-font-base ${className}`,
      children: [closeButton ? /* @__PURE__ */ jsx$1("div", {
        className: styles$l.close,
        children: /* @__PURE__ */ jsx$1("button", {
          onClick: close2,
          children: /* @__PURE__ */ jsx$1(Icon, {
            type: "Close",
            size: "s"
          })
        })
      }) : null, /* @__PURE__ */ jsx$1("div", {
        className: styles$l.modalInner,
        children: children || AddChildrenWarning()
      })]
    })
  });
};
Modal.Title = function({
  children
}) {
  return /* @__PURE__ */ jsx$1("div", {
    className: styles$l.title,
    children
  });
};
Modal.Content = function({
  children
}) {
  return /* @__PURE__ */ jsx$1("div", {
    className: styles$l.content,
    children
  });
};
Modal.Actions = function({
  children
}) {
  return /* @__PURE__ */ jsx$1("div", {
    className: styles$l.actions,
    children
  });
};
Modal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  closeButton: PropTypes.bool,
  onClose: PropTypes.func,
  modalSize: PropTypes.string
};
Modal.defaultProps = {
  show: false,
  className: "",
  modalSize: "sm",
  closeButton: true
};
const ChildrenFocusBlur = (_q) => {
  var _r = _q, {
    children,
    onBlur,
    onFocus
  } = _r, props = __objRest(_r, [
    "children",
    "onBlur",
    "onFocus"
  ]);
  const handleBlur = useCallback(({
    currentTarget
  }) => {
    requestAnimationFrame(() => {
      if (!currentTarget.contains(document.activeElement)) {
        onBlur();
      }
    });
  }, [onBlur]);
  const handleFocus = useCallback(() => {
    requestAnimationFrame(() => {
      onFocus();
    });
  }, [onFocus]);
  return /* @__PURE__ */ jsx$1("div", __spreadProps(__spreadValues({}, props), {
    onBlur: handleBlur,
    onFocus: handleFocus,
    children
  }));
};
ChildrenFocusBlur.propTypes = {
  onBlur: PropTypes.func,
  onFocus: PropTypes.func
};
ChildrenFocusBlur.defaultProps = {};
const icon$k = "epic__icon__ad3";
const navbar = "epic__navbar__8fc";
const ripple$k = "epic__ripple__d9c";
const navigation$1 = "epic__navigation__485";
const logo = "epic__logo__7c5";
const title$1 = "epic__title__e8b";
const innerNav = "epic__innerNav__7fd";
const link = "epic__link__7bd";
const subNavWrapper = "epic__subNavWrapper__834";
const hover = "epic__hover__fec";
const subNavBg = "epic__subNavBg__845";
const subNavTitle = "epic__subNavTitle__ac7";
const subNavContent = "epic__subNavContent__6bb";
const subNavColumn = "epic__subNavColumn__542";
const inverse$2 = "epic__inverse__b49";
const asideContainer = "epic__asideContainer__243";
const asideSidePad = "epic__asideSidePad__a49";
const searchContainer = "epic__searchContainer__acb";
const fixed = "epic__fixed__d18";
const nikeLogo = "epic__nikeLogo__333";
const underline = "epic__underline__036";
const active$4 = "epic__active__fa1";
const subNavBgOverlay = "epic__subNavBgOverlay__a57";
const subNavExpand = "epic__subNavExpand__deb";
const subNavMega = "epic__subNavMega__01c";
var styles$k = {
  icon: icon$k,
  "epic-icon": "epic__epic-icon__6ee",
  "epic-icon-add": "epic__epic-icon-add__f67",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__e80",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__711",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__329",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__698",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__e82",
  "epic-icon-calendar": "epic__epic-icon-calendar__e4c",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__c78",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__241",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__533",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__2f5",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__c2f",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__f1a",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__d41",
  "epic-icon-close-x": "epic__epic-icon-close-x__034",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__51c",
  "epic-icon-confluence": "epic__epic-icon-confluence__613",
  "epic-icon-contact": "epic__epic-icon-contact__da0",
  "epic-icon-delete": "epic__epic-icon-delete__a08",
  "epic-icon-edit": "epic__epic-icon-edit__e12",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__e1d",
  "epic-icon-filter": "epic__epic-icon-filter__519",
  "epic-icon-github": "epic__epic-icon-github__a7e",
  "epic-icon-information": "epic__epic-icon-information__a1f",
  "epic-icon-jira": "epic__epic-icon-jira__a2b",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__24e",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__00b",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__550",
  "epic-icon-preview": "epic__epic-icon-preview__6c0",
  "epic-icon-profile": "epic__epic-icon-profile__0ea",
  "epic-icon-quotes": "epic__epic-icon-quotes__803",
  "epic-icon-search": "epic__epic-icon-search__38c",
  "epic-icon-share": "epic__epic-icon-share__085",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__7ab",
  "epic-icon-slack": "epic__epic-icon-slack__2c7",
  "epic-icon-steps": "epic__epic-icon-steps__50a",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__cf7",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__2de",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__7b9",
  "epic-icon-warning": "epic__epic-icon-warning__b4b",
  "epic-font-base": "epic__epic-font-base__8c5",
  navbar,
  "epic-font-base-md": "epic__epic-font-base-md__c46",
  "epic-font-marketing": "epic__epic-font-marketing__d28",
  "epic-font-brand": "epic__epic-font-brand__666",
  ripple: ripple$k,
  "epic-display-base": "epic__epic-display-base__7f3",
  "epic-display-1": "epic__epic-display-1__0fc",
  "epic-display-2": "epic__epic-display-2__264",
  "epic-display-3": "epic__epic-display-3__1d4",
  "epic-display-4": "epic__epic-display-4__c29",
  "epic-display-5": "epic__epic-display-5__99f",
  "epic-title-base": "epic__epic-title-base__1c8",
  "epic-title-1": "epic__epic-title-1__41b",
  "epic-title-2": "epic__epic-title-2__554",
  "epic-title-3": "epic__epic-title-3__f06",
  "epic-title-4": "epic__epic-title-4__df8",
  "epic-title-5": "epic__epic-title-5__f8a",
  "epic-title-6": "epic__epic-title-6__bb8",
  navigation: navigation$1,
  logo,
  title: title$1,
  "epic-subtitle-base": "epic__epic-subtitle-base__77b",
  "epic-subtitle-1": "epic__epic-subtitle-1__7e3",
  "epic-subtitle-2": "epic__epic-subtitle-2__330",
  "epic-subtitle-3": "epic__epic-subtitle-3__a13",
  innerNav,
  link,
  subNavWrapper,
  hover,
  subNavBg,
  subNavTitle,
  "epic-body-text-base": "epic__epic-body-text-base__db4",
  "epic-body-text-1": "epic__epic-body-text-1__833",
  "epic-body-text-2": "epic__epic-body-text-2__612",
  "epic-body-text": "epic__epic-body-text__49a",
  "epic-body-text-3": "epic__epic-body-text-3__7a6",
  subNavContent,
  subNavColumn,
  "epic-legal-text": "epic__epic-legal-text__747",
  "epic-label-text": "epic__epic-label-text__7f6",
  "epic-button-base": "epic__epic-button-base__d98",
  "epic-button-1": "epic__epic-button-1__f91",
  "epic-button-2": "epic__epic-button-2__d36",
  "epic-button-3": "epic__epic-button-3__3c0",
  inverse: inverse$2,
  asideContainer,
  asideSidePad,
  searchContainer,
  fixed,
  nikeLogo,
  underline,
  active: active$4,
  subNavBgOverlay,
  subNavExpand,
  subNavMega
};
const keyGen = (...args) => args.join("-").trim();
const ExternalNavLink = ({
  path,
  children,
  className = null
}) => /* @__PURE__ */ jsx$1("a", {
  href: path,
  className,
  target: "_blank",
  rel: "noopener noreferrer",
  children
});
function NavBarLinks({
  routes,
  RouterLink,
  activeRoute,
  fixed: fixed2,
  menuType
}) {
  const [focusedLink, setFocusedLink] = useState("");
  return routes.map(({
    path,
    text: text2,
    external,
    exact,
    title: title2,
    menuItems,
    className,
    secondColumnItems
  }) => {
    const uniqueId = keyGen(text2, path);
    let activeClass = "";
    if (exact) {
      activeClass = activeRoute === path ? styles$k.active : "";
    } else if (path) {
      const pathName = path.split("?");
      activeClass = activeRoute.includes(pathName[0]) ? styles$k.active : "";
    }
    const handleFocus = () => {
      setFocusedLink(uniqueId);
    };
    const handleFocusClear = () => {
      setFocusedLink("");
    };
    const isExternal = !!external;
    const isSubMenu = !!menuType && !!menuItems;
    const isDefault = !isExternal && !isSubMenu;
    return /* @__PURE__ */ jsxs(ChildrenFocusBlur, {
      onFocus: handleFocus,
      onBlur: handleFocusClear,
      onClick: handleFocusClear,
      children: [isExternal && /* @__PURE__ */ jsx$1(ExternalNavLink, {
        path,
        className,
        children: /* @__PURE__ */ jsx$1("span", {
          className: styles$k.link,
          children: text2
        })
      }), isSubMenu && /* @__PURE__ */ jsx$1("div", {
        className: classnames$1({
          [styles$k.subNavMega]: menuType === "mega"
        }, {
          [styles$k.subNavExpand]: menuType === "expand"
        }),
        children: /* @__PURE__ */ jsx$1(SubNav, {
          title: title2,
          menuItems,
          RouterLink,
          fixed: fixed2,
          isMega: menuType === "mega",
          isParentFocused: focusedLink === uniqueId,
          secondColumnItems,
          children: /* @__PURE__ */ jsx$1(RouterLink, {
            href: path,
            className,
            children: /* @__PURE__ */ jsx$1("span", {
              className: classnames$1(styles$k.underline, styles$k.link, activeClass),
              children: text2
            })
          })
        })
      }), isDefault && /* @__PURE__ */ jsx$1(RouterLink, {
        href: path,
        className,
        children: /* @__PURE__ */ jsx$1("span", {
          className: classnames$1(styles$k.underline, styles$k.link, activeClass),
          children: text2
        })
      })]
    }, uniqueId);
  });
}
function SubNav({
  title: title2,
  menuItems,
  RouterLink,
  children,
  fixed: fixed2,
  isMega,
  isParentFocused,
  secondColumnItems
}) {
  const [scrollOffset, setScrollOffset] = useState(0);
  const [subNavOpen, setSubNavOpen] = useState(false);
  const handleOpenSubNav = () => {
    setSubNavOpen(true);
    if (!fixed2) {
      document.body.style.overflowY = "hidden";
      setScrollOffset(window.scrollY);
    }
  };
  const handleCloseSubNav = () => {
    setSubNavOpen(false);
    if (!fixed2) {
      document.body.style.overflowY = "auto";
    }
  };
  const groupedMenuItems = [];
  for (let i = 0; i < menuItems.length; i += 10) {
    groupedMenuItems.push(menuItems.slice(i, i + 10));
  }
  return /* @__PURE__ */ jsxs("div", {
    className: classnames$1(styles$k.subNavWrapper, {
      [styles$k.hover]: subNavOpen || isParentFocused
    }),
    onMouseEnter: handleOpenSubNav,
    onMouseLeave: handleCloseSubNav,
    onClick: handleCloseSubNav,
    children: [children, /* @__PURE__ */ jsx$1("div", {
      className: classnames$1(styles$k.subNavBg, {
        [styles$k.subNavBgOverlay]: isMega
      }),
      children: /* @__PURE__ */ jsx$1("div", {
        className: classnames$1({
          [styles$k.subNavBg]: isMega
        }),
        style: {
          transform: `translateY(-${scrollOffset}px)`
        },
        children: /* @__PURE__ */ jsxs("div", {
          className: styles$k.subNavContent,
          children: [groupedMenuItems.map((group, i) => {
            return /* @__PURE__ */ jsxs("div", {
              className: styles$k.subNavColumn,
              children: [title2 && /* @__PURE__ */ jsx$1("div", {
                className: styles$k.subNavTitle,
                children: i === 0 && /* @__PURE__ */ jsx$1("h4", {
                  children: title2
                })
              }), group.map(({
                text: text2,
                path
              }) => {
                return /* @__PURE__ */ jsx$1(RouterLink, {
                  className: styles$k.subNavLink,
                  href: path,
                  children: /* @__PURE__ */ jsx$1("span", {
                    children: text2
                  })
                }, keyGen(text2, path));
              })]
            }, i);
          }), secondColumnItems && /* @__PURE__ */ jsx$1("div", {
            className: styles$k.subNavColumn,
            children: secondColumnItems.map(({
              isTitle,
              text: text2,
              path
            }, index2) => {
              return /* @__PURE__ */ jsx$1(Fragment$1, {
                children: isTitle ? /* @__PURE__ */ jsx$1("div", {
                  className: styles$k.subNavTitle,
                  children: /* @__PURE__ */ jsx$1("h4", {
                    children: text2
                  })
                }, keyGen(text2, path)) : /* @__PURE__ */ jsx$1(RouterLink, {
                  className: styles$k.subNavLink,
                  href: path,
                  children: /* @__PURE__ */ jsx$1("span", {
                    children: text2
                  })
                }, keyGen(text2, path))
              }, index2);
            })
          })]
        })
      })
    })]
  });
}
function NavBar({
  aside,
  className,
  fixed: fixed2,
  inverse: inverse2,
  logo: logo2,
  menuType,
  name: name2,
  onSearch,
  rootPath,
  RouterLink,
  routes,
  searchCleanup,
  searchPlaceholder
}) {
  const fullPath = `${window.location.pathname}${window.location.search}`;
  const [activeRoute, setActiveRoute] = useState(fullPath);
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    setActiveRoute(fullPath);
  }, [window.location.pathname]);
  const searchInputRef = useRef();
  const navClassName = classnames$1(styles$k.navbar, className, {
    [styles$k.inverse]: inverse2
  });
  function NavLink(props) {
    let Component2 = RouterLink || DefaultLink;
    return /* @__PURE__ */ jsx$1(Component2, __spreadValues({}, props));
  }
  function handleSearch() {
    onSearch == null ? void 0 : onSearch(searchValue);
    if (searchCleanup) {
      setSearchValue("");
      searchInputRef.current.value = "";
    }
  }
  function handleChange(e) {
    var _a;
    setSearchValue(((_a = e == null ? void 0 : e.currentTarget) == null ? void 0 : _a.value) || "");
  }
  return /* @__PURE__ */ jsx$1("div", {
    className: classnames$1(navClassName, {
      [styles$k.fixed]: fixed2
    }),
    children: /* @__PURE__ */ jsxs("nav", {
      className: styles$k.navigation,
      children: [/* @__PURE__ */ jsxs(NavLink, {
        className: styles$k.logo,
        href: rootPath,
        "aria-label": "home link",
        children: [logo2 && (typeof logo2 === "string" ? /* @__PURE__ */ jsx$1("img", {
          className,
          src: logo2,
          alt: `${name2} logo`
        }) : logo2), name2 ? /* @__PURE__ */ jsx$1("span", {
          className: styles$k.title,
          children: name2
        }) : null]
      }), /* @__PURE__ */ jsx$1("div", {
        className: styles$k.innerNav,
        children: /* @__PURE__ */ jsx$1(NavBarLinks, {
          activeRoute,
          fixed: fixed2,
          menuType,
          rootPath,
          RouterLink: NavLink,
          routes
        })
      }), (onSearch || aside) && /* @__PURE__ */ jsxs("div", {
        className: styles$k.asideContainer,
        children: [onSearch && /* @__PURE__ */ jsx$1("div", {
          className: classnames$1(styles$k.searchContainer, {
            [styles$k.asideSidePad]: !aside
          }),
          children: /* @__PURE__ */ jsx$1(ActionInput, {
            ariaLabel: "Search",
            onAction: handleSearch,
            onChange: handleChange,
            placeholder: searchPlaceholder,
            submitOnEnter: true,
            ref: searchInputRef
          })
        }), aside && /* @__PURE__ */ jsx$1("div", {
          children: aside
        })]
      })]
    })
  });
}
NavBar.propTypes = {
  name: PropTypes.string,
  logo: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  routes: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string,
    text: PropTypes.string.isRequired,
    search: PropTypes.string,
    exact: PropTypes.bool,
    external: PropTypes.bool,
    className: PropTypes.string,
    title: PropTypes.string,
    menuItems: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired
    })),
    secondColumnItems: PropTypes.arrayOf(PropTypes.shape({
      isTitle: PropTypes.bool.isRequired,
      text: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired
    }))
  })).isRequired,
  rootPath: PropTypes.string,
  className: PropTypes.string,
  RouterLink: PropTypes.elementType,
  aside: PropTypes.object,
  inverse: PropTypes.bool,
  onSearch: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  searchCleanup: PropTypes.bool,
  fixed: PropTypes.bool,
  menuType: PropTypes.oneOf([false, "expand", "mega"])
};
NavBar.defaultProps = {
  menuType: "mega",
  rootPath: "/",
  routes: [],
  searchCleanup: true,
  searchPlaceholder: "Search"
};
const icon$j = "epic__icon__80a";
const ripple$j = "epic__ripple__300";
const overlayContainer = "epic__overlayContainer__3fd";
const show = "epic__show__adb";
const overlay = "epic__overlay__e4a";
var styles$j = {
  icon: icon$j,
  "epic-icon": "epic__epic-icon__63c",
  "epic-icon-add": "epic__epic-icon-add__def",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__84e",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__892",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__f92",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__36f",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__c18",
  "epic-icon-calendar": "epic__epic-icon-calendar__034",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__a15",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__547",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__853",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__e27",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__8ad",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__51b",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__e14",
  "epic-icon-close-x": "epic__epic-icon-close-x__c5e",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__bf3",
  "epic-icon-confluence": "epic__epic-icon-confluence__3b6",
  "epic-icon-contact": "epic__epic-icon-contact__038",
  "epic-icon-delete": "epic__epic-icon-delete__3e0",
  "epic-icon-edit": "epic__epic-icon-edit__e49",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__3dd",
  "epic-icon-filter": "epic__epic-icon-filter__269",
  "epic-icon-github": "epic__epic-icon-github__eae",
  "epic-icon-information": "epic__epic-icon-information__e21",
  "epic-icon-jira": "epic__epic-icon-jira__a61",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__899",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__46f",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__5cd",
  "epic-icon-preview": "epic__epic-icon-preview__c33",
  "epic-icon-profile": "epic__epic-icon-profile__c88",
  "epic-icon-quotes": "epic__epic-icon-quotes__3a8",
  "epic-icon-search": "epic__epic-icon-search__d76",
  "epic-icon-share": "epic__epic-icon-share__78d",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__05f",
  "epic-icon-slack": "epic__epic-icon-slack__865",
  "epic-icon-steps": "epic__epic-icon-steps__89c",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__592",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__0dc",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__3d0",
  "epic-icon-warning": "epic__epic-icon-warning__53d",
  "epic-font-base": "epic__epic-font-base__f1b",
  "epic-font-base-md": "epic__epic-font-base-md__695",
  "epic-font-marketing": "epic__epic-font-marketing__d4c",
  "epic-font-brand": "epic__epic-font-brand__031",
  ripple: ripple$j,
  overlayContainer,
  show,
  overlay
};
const Overlay = ({
  show: show2,
  onClick,
  className,
  children
}) => /* @__PURE__ */ jsxs("div", {
  className: `${styles$j.overlayContainer}  ${className || ""} ${show2 ? styles$j.show : ""}`,
  children: [/* @__PURE__ */ jsx$1("div", {
    className: styles$j.overlay,
    onClick
  }), children]
});
Overlay.propTypes = {
  show: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string
};
var scrollspy = {};
var interopRequireDefault = { exports: {} };
(function(module) {
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  module.exports = _interopRequireDefault2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(interopRequireDefault);
var _extends$3 = { exports: {} };
(function(module) {
  function _extends3() {
    module.exports = _extends3 = Object.assign ? Object.assign.bind() : function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends3.apply(this, arguments);
  }
  module.exports = _extends3, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_extends$3);
var defineProperty = { exports: {} };
(function(module) {
  function _defineProperty3(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  module.exports = _defineProperty3, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(defineProperty);
var toConsumableArray = { exports: {} };
var arrayWithoutHoles = { exports: {} };
var arrayLikeToArray = { exports: {} };
(function(module) {
  function _arrayLikeToArray2(arr, len) {
    if (len == null || len > arr.length)
      len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  module.exports = _arrayLikeToArray2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(arrayLikeToArray);
(function(module) {
  var arrayLikeToArray$1 = arrayLikeToArray.exports;
  function _arrayWithoutHoles2(arr) {
    if (Array.isArray(arr))
      return arrayLikeToArray$1(arr);
  }
  module.exports = _arrayWithoutHoles2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(arrayWithoutHoles);
var iterableToArray = { exports: {} };
(function(module) {
  function _iterableToArray2(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
      return Array.from(iter);
  }
  module.exports = _iterableToArray2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(iterableToArray);
var unsupportedIterableToArray = { exports: {} };
(function(module) {
  var arrayLikeToArray$1 = arrayLikeToArray.exports;
  function _unsupportedIterableToArray2(o, minLen) {
    if (!o)
      return;
    if (typeof o === "string")
      return arrayLikeToArray$1(o, minLen);
    var n2 = Object.prototype.toString.call(o).slice(8, -1);
    if (n2 === "Object" && o.constructor)
      n2 = o.constructor.name;
    if (n2 === "Map" || n2 === "Set")
      return Array.from(o);
    if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
      return arrayLikeToArray$1(o, minLen);
  }
  module.exports = _unsupportedIterableToArray2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(unsupportedIterableToArray);
var nonIterableSpread = { exports: {} };
(function(module) {
  function _nonIterableSpread2() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  module.exports = _nonIterableSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(nonIterableSpread);
(function(module) {
  var arrayWithoutHoles$1 = arrayWithoutHoles.exports;
  var iterableToArray$1 = iterableToArray.exports;
  var unsupportedIterableToArray$1 = unsupportedIterableToArray.exports;
  var nonIterableSpread$1 = nonIterableSpread.exports;
  function _toConsumableArray3(arr) {
    return arrayWithoutHoles$1(arr) || iterableToArray$1(arr) || unsupportedIterableToArray$1(arr) || nonIterableSpread$1();
  }
  module.exports = _toConsumableArray3, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(toConsumableArray);
var classCallCheck = { exports: {} };
(function(module) {
  function _classCallCheck3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  module.exports = _classCallCheck3, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(classCallCheck);
var possibleConstructorReturn = { exports: {} };
var _typeof$1 = { exports: {} };
(function(module) {
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    return module.exports = _typeof2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
      return typeof obj2;
    } : function(obj2) {
      return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof2(obj);
  }
  module.exports = _typeof2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_typeof$1);
var assertThisInitialized = { exports: {} };
(function(module) {
  function _assertThisInitialized3(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  module.exports = _assertThisInitialized3, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(assertThisInitialized);
(function(module) {
  var _typeof2 = _typeof$1.exports["default"];
  var assertThisInitialized$1 = assertThisInitialized.exports;
  function _possibleConstructorReturn3(self2, call) {
    if (call && (_typeof2(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return assertThisInitialized$1(self2);
  }
  module.exports = _possibleConstructorReturn3, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(possibleConstructorReturn);
var getPrototypeOf = { exports: {} };
(function(module) {
  function _getPrototypeOf3(o) {
    module.exports = _getPrototypeOf3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf4(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _getPrototypeOf3(o);
  }
  module.exports = _getPrototypeOf3, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(getPrototypeOf);
var createClass = { exports: {} };
(function(module) {
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass3(Constructor, protoProps, staticProps) {
    if (protoProps)
      _defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      _defineProperties2(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  module.exports = _createClass3, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(createClass);
var inherits = { exports: {} };
var setPrototypeOf = { exports: {} };
(function(module) {
  function _setPrototypeOf2(o, p2) {
    module.exports = _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf3(o2, p3) {
      o2.__proto__ = p3;
      return o2;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _setPrototypeOf2(o, p2);
  }
  module.exports = _setPrototypeOf2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(setPrototypeOf);
(function(module) {
  var setPrototypeOf$1 = setPrototypeOf.exports;
  function _inherits3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass)
      setPrototypeOf$1(subClass, superClass);
  }
  module.exports = _inherits3, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(inherits);
var throttle$1 = {};
Object.defineProperty(throttle$1, "__esModule", {
  value: true
});
throttle$1.default = void 0;
var throttle = function throttle2(fn2) {
  var threshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
  var last;
  var timer;
  return function() {
    var now = +new Date();
    var timePassed = !!last && now < last + threshold;
    if (timePassed) {
      clearTimeout(timer);
      timer = setTimeout(function() {
        last = now;
        fn2();
      }, threshold);
    } else {
      last = now;
      fn2();
    }
  };
};
var _default$2 = throttle;
throttle$1.default = _default$2;
var _interopRequireDefault$1 = interopRequireDefault.exports;
Object.defineProperty(scrollspy, "__esModule", {
  value: true
});
var _default$1 = scrollspy.default = void 0;
var _extends2 = _interopRequireDefault$1(_extends$3.exports);
var _defineProperty2 = _interopRequireDefault$1(defineProperty.exports);
var _toConsumableArray2 = _interopRequireDefault$1(toConsumableArray.exports);
var _classCallCheck2 = _interopRequireDefault$1(classCallCheck.exports);
var _possibleConstructorReturn2 = _interopRequireDefault$1(possibleConstructorReturn.exports);
var _getPrototypeOf2 = _interopRequireDefault$1(getPrototypeOf.exports);
var _assertThisInitialized2 = _interopRequireDefault$1(assertThisInitialized.exports);
var _createClass2 = _interopRequireDefault$1(createClass.exports);
var _inherits2 = _interopRequireDefault$1(inherits.exports);
var _propTypes$1 = _interopRequireDefault$1(propTypes.exports);
var _react$1 = _interopRequireDefault$1(React__default);
var _classnames = _interopRequireDefault$1(classnames$2.exports);
var _throttle = _interopRequireDefault$1(throttle$1);
function isEqualArray(a, b) {
  return a.length === b.length && a.every(function(item2, index2) {
    return item2 === b[index2];
  });
}
var Scrollspy$1 = /* @__PURE__ */ function(_React$Component) {
  (0, _inherits2.default)(Scrollspy2, _React$Component);
  (0, _createClass2.default)(Scrollspy2, null, [{
    key: "propTypes",
    get: function get() {
      return {
        items: _propTypes$1.default.arrayOf(_propTypes$1.default.string).isRequired,
        currentClassName: _propTypes$1.default.string.isRequired,
        scrolledPastClassName: _propTypes$1.default.string,
        style: _propTypes$1.default.object,
        componentTag: _propTypes$1.default.oneOfType([_propTypes$1.default.string, _propTypes$1.default.elementType]),
        offset: _propTypes$1.default.number,
        rootEl: _propTypes$1.default.string,
        onUpdate: _propTypes$1.default.func
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        items: [],
        currentClassName: "",
        style: {},
        componentTag: "ul",
        offset: 0,
        onUpdate: function onUpdate() {
        }
      };
    }
  }]);
  function Scrollspy2(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Scrollspy2);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Scrollspy2).call(this, props));
    _this.state = {
      targetItems: [],
      inViewState: [],
      isScrolledPast: []
    };
    _this._handleSpy = _this._handleSpy.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(Scrollspy2, [{
    key: "_initSpyTarget",
    value: function _initSpyTarget(items) {
      var targetItems = items.map(function(item2) {
        return document.getElementById(item2);
      });
      return targetItems;
    }
  }, {
    key: "_fillArray",
    value: function _fillArray(array, val) {
      var newArray = [];
      for (var i = 0, max2 = array.length; i < max2; i++) {
        newArray[i] = val;
      }
      return newArray;
    }
  }, {
    key: "_isScrolled",
    value: function _isScrolled() {
      return this._getScrollDimension().scrollTop > 0;
    }
  }, {
    key: "_getScrollDimension",
    value: function _getScrollDimension() {
      var doc = document;
      var rootEl = this.props.rootEl;
      var scrollTop = rootEl ? doc.querySelector(rootEl).scrollTop : doc.documentElement.scrollTop || doc.body.parentNode.scrollTop || doc.body.scrollTop;
      var scrollHeight = rootEl ? doc.querySelector(rootEl).scrollHeight : doc.documentElement.scrollHeight || doc.body.parentNode.scrollHeight || doc.body.scrollHeight;
      return {
        scrollTop,
        scrollHeight
      };
    }
  }, {
    key: "_getElemsViewState",
    value: function _getElemsViewState(targets) {
      var elemsInView = [];
      var elemsOutView = [];
      var viewStatusList = [];
      var targetItems = targets ? targets : this.state.targetItems;
      var hasInViewAlready = false;
      for (var i = 0, max2 = targetItems.length; i < max2; i++) {
        var currentContent = targetItems[i];
        var isInView = hasInViewAlready ? false : this._isInView(currentContent);
        if (isInView) {
          hasInViewAlready = true;
          elemsInView.push(currentContent);
        } else {
          elemsOutView.push(currentContent);
        }
        var isLastItem = i === max2 - 1;
        var isScrolled = this._isScrolled();
        var isLastShortItemAtBottom = this._isAtBottom() && this._isInView(currentContent) && !isInView && isLastItem && isScrolled;
        if (isLastShortItemAtBottom) {
          elemsOutView.pop();
          elemsOutView.push.apply(elemsOutView, (0, _toConsumableArray2.default)(elemsInView));
          elemsInView = [currentContent];
          viewStatusList = this._fillArray(viewStatusList, false);
          isInView = true;
        }
        viewStatusList.push(isInView);
      }
      return {
        inView: elemsInView,
        outView: elemsOutView,
        viewStatusList,
        scrolledPast: this.props.scrolledPastClassName && this._getScrolledPast(viewStatusList)
      };
    }
  }, {
    key: "_isInView",
    value: function _isInView(el) {
      if (!el) {
        return false;
      }
      var _this$props = this.props, rootEl = _this$props.rootEl, offset2 = _this$props.offset;
      var rootRect;
      if (rootEl) {
        rootRect = document.querySelector(rootEl).getBoundingClientRect();
      }
      var rect = el.getBoundingClientRect();
      var winH = rootEl ? rootRect.height : window.innerHeight;
      var _this$_getScrollDimen = this._getScrollDimension(), scrollTop = _this$_getScrollDimen.scrollTop;
      var scrollBottom = scrollTop + winH;
      var elTop = rootEl ? rect.top + scrollTop - rootRect.top + offset2 : rect.top + scrollTop + offset2;
      var elBottom = elTop + el.offsetHeight;
      return elTop < scrollBottom && elBottom > scrollTop;
    }
  }, {
    key: "_isAtBottom",
    value: function _isAtBottom() {
      var rootEl = this.props.rootEl;
      var _this$_getScrollDimen2 = this._getScrollDimension(), scrollTop = _this$_getScrollDimen2.scrollTop, scrollHeight = _this$_getScrollDimen2.scrollHeight;
      var winH = rootEl ? document.querySelector(rootEl).getBoundingClientRect().height : window.innerHeight;
      var scrolledToBottom = scrollTop + winH >= scrollHeight;
      return scrolledToBottom;
    }
  }, {
    key: "_getScrolledPast",
    value: function _getScrolledPast(viewStatusList) {
      if (!viewStatusList.some(function(item2) {
        return item2;
      })) {
        return viewStatusList;
      }
      var hasFoundInView = false;
      var scrolledPastItems = viewStatusList.map(function(item2) {
        if (item2 && !hasFoundInView) {
          hasFoundInView = true;
          return false;
        }
        return !hasFoundInView;
      });
      return scrolledPastItems;
    }
  }, {
    key: "_spy",
    value: function _spy(targets) {
      var _this2 = this;
      var elemensViewState = this._getElemsViewState(targets);
      var currentStatuses = this.state.inViewState;
      this.setState({
        inViewState: elemensViewState.viewStatusList,
        isScrolledPast: elemensViewState.scrolledPast
      }, function() {
        _this2._update(currentStatuses);
      });
    }
  }, {
    key: "_update",
    value: function _update(prevStatuses) {
      if (isEqualArray(this.state.inViewState, prevStatuses)) {
        return;
      }
      this.props.onUpdate(this.state.targetItems[this.state.inViewState.indexOf(true)]);
    }
  }, {
    key: "_handleSpy",
    value: function _handleSpy() {
      (0, _throttle.default)(this._spy(), 100);
    }
  }, {
    key: "_initFromProps",
    value: function _initFromProps() {
      var targetItems = this._initSpyTarget(this.props.items);
      this.setState({
        targetItems
      });
      this._spy(targetItems);
    }
  }, {
    key: "offEvent",
    value: function offEvent() {
      var el = this.props.rootEl ? document.querySelector(this.props.rootEl) : window;
      el.removeEventListener("scroll", this._handleSpy);
    }
  }, {
    key: "onEvent",
    value: function onEvent() {
      var el = this.props.rootEl ? document.querySelector(this.props.rootEl) : window;
      el.addEventListener("scroll", this._handleSpy);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._initFromProps();
      this.onEvent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.offEvent();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps() {
      this._initFromProps();
    }
  }, {
    key: "render",
    value: function render3() {
      var _this3 = this;
      var Tag2 = this.props.componentTag;
      var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, scrolledPastClassName = _this$props2.scrolledPastClassName, style = _this$props2.style;
      var counter = 0;
      var items = _react$1.default.Children.map(children, function(child, idx) {
        var _classNames;
        if (!child) {
          return null;
        }
        var ChildTag = child.type;
        var isScrolledPast = scrolledPastClassName && _this3.state.isScrolledPast[idx];
        var childClass = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(child.props.className), child.props.className), (0, _defineProperty2.default)(_classNames, "".concat(_this3.props.currentClassName), _this3.state.inViewState[idx]), (0, _defineProperty2.default)(_classNames, "".concat(_this3.props.scrolledPastClassName), isScrolledPast), _classNames));
        return _react$1.default.createElement(ChildTag, (0, _extends2.default)({}, child.props, {
          className: childClass,
          key: counter++
        }), child.props.children);
      });
      var itemClass = (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(className), className));
      return _react$1.default.createElement(Tag2, {
        className: itemClass,
        style
      }, items);
    }
  }]);
  return Scrollspy2;
}(_react$1.default.Component);
_default$1 = scrollspy.default = Scrollspy$1;
const icon$i = "epic__icon__1df";
const ripple$i = "epic__ripple__d47";
const navTitle = "epic__navTitle__f38";
const navLinks = "epic__navLinks__6ae";
const activeNavItem = "epic__activeNavItem__eb4";
const activeLinkBar = "epic__activeLinkBar__4e5";
const uppercase = "epic__uppercase__0d8";
const listItem = "epic__listItem__178";
var styles$i = {
  icon: icon$i,
  "epic-icon": "epic__epic-icon__b56",
  "epic-icon-add": "epic__epic-icon-add__e00",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__cf1",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__6d8",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__d8d",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__c4d",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__25c",
  "epic-icon-calendar": "epic__epic-icon-calendar__1cf",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__46c",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__445",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__ecc",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__16f",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__03a",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__1a1",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__767",
  "epic-icon-close-x": "epic__epic-icon-close-x__afc",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__4c3",
  "epic-icon-confluence": "epic__epic-icon-confluence__af5",
  "epic-icon-contact": "epic__epic-icon-contact__5ac",
  "epic-icon-delete": "epic__epic-icon-delete__e39",
  "epic-icon-edit": "epic__epic-icon-edit__e97",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__649",
  "epic-icon-filter": "epic__epic-icon-filter__96f",
  "epic-icon-github": "epic__epic-icon-github__521",
  "epic-icon-information": "epic__epic-icon-information__bc5",
  "epic-icon-jira": "epic__epic-icon-jira__559",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__8fd",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__b07",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__ab4",
  "epic-icon-preview": "epic__epic-icon-preview__e33",
  "epic-icon-profile": "epic__epic-icon-profile__497",
  "epic-icon-quotes": "epic__epic-icon-quotes__0e2",
  "epic-icon-search": "epic__epic-icon-search__4c5",
  "epic-icon-share": "epic__epic-icon-share__9d2",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__3ed",
  "epic-icon-slack": "epic__epic-icon-slack__552",
  "epic-icon-steps": "epic__epic-icon-steps__bee",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__310",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__80b",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__c6e",
  "epic-icon-warning": "epic__epic-icon-warning__2fd",
  "epic-font-base": "epic__epic-font-base__af6",
  "epic-font-base-md": "epic__epic-font-base-md__7f7",
  "epic-font-marketing": "epic__epic-font-marketing__482",
  "epic-font-brand": "epic__epic-font-brand__d60",
  ripple: ripple$i,
  navTitle,
  navLinks,
  activeNavItem,
  activeLinkBar,
  uppercase,
  listItem
};
const Scrollspy = (_s) => {
  var _t = _s, {
    title: title2,
    children,
    className,
    uppercaseTitle,
    uppercaseItems,
    items,
    rootEl
  } = _t, props = __objRest(_t, [
    "title",
    "children",
    "className",
    "uppercaseTitle",
    "uppercaseItems",
    "items",
    "rootEl"
  ]);
  return /* @__PURE__ */ jsxs("div", {
    className: className || "",
    children: [title2 && /* @__PURE__ */ jsx$1("h3", {
      className: `${styles$i.navTitle} ${uppercaseTitle && styles$i.uppercase}`,
      children: title2
    }), /* @__PURE__ */ jsx$1(_default$1, __spreadProps(__spreadValues({
      items: items.map((l) => l.hash),
      className: styles$i.navLinks,
      currentClassName: styles$i.activeNavItem,
      rootEl
    }, props), {
      children: items.map((l) => {
        return /* @__PURE__ */ jsx$1("li", {
          className: styles$i.listItem,
          children: /* @__PURE__ */ jsxs("a", {
            href: `#${l.hash}`,
            className: `${uppercaseItems && styles$i.uppercase}`,
            children: [l.text, /* @__PURE__ */ jsx$1("span", {
              className: styles$i.activeLinkBar
            })]
          })
        }, `nav-${l.text}`);
      })
    })), children]
  });
};
Scrollspy.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    hash: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  })).isRequired,
  rootEl: PropTypes.string,
  className: PropTypes.string,
  uppercaseTitle: PropTypes.bool,
  uppercaseItems: PropTypes.bool,
  children: PropTypes.PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
Scrollspy.defaultProps = {
  uppercaseTitle: false,
  uppercaseItems: false
};
const icon$h = "epic__icon__b24";
const section$1 = "epic__section__671";
const header$1 = "epic__header__12f";
const ripple$h = "epic__ripple__0b4";
const done$1 = "epic__done__631";
const sectionContent = "epic__sectionContent__947";
const fullContent = "epic__fullContent__6b6";
const collapseIcon = "epic__collapseIcon__95b";
const plus = "epic__plus__ae1";
const minus = "epic__minus__925";
var styles$h = {
  icon: icon$h,
  "epic-icon": "epic__epic-icon__b87",
  "epic-icon-add": "epic__epic-icon-add__dc8",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__56a",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__186",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__788",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__0c0",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__7cc",
  "epic-icon-calendar": "epic__epic-icon-calendar__917",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__3a4",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__3a2",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__40f",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__e6c",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__8cd",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__0e9",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__0ee",
  "epic-icon-close-x": "epic__epic-icon-close-x__bd6",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__55e",
  "epic-icon-confluence": "epic__epic-icon-confluence__297",
  "epic-icon-contact": "epic__epic-icon-contact__e61",
  "epic-icon-delete": "epic__epic-icon-delete__4e0",
  "epic-icon-edit": "epic__epic-icon-edit__be5",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__f2b",
  "epic-icon-filter": "epic__epic-icon-filter__733",
  "epic-icon-github": "epic__epic-icon-github__745",
  "epic-icon-information": "epic__epic-icon-information__4dc",
  "epic-icon-jira": "epic__epic-icon-jira__315",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__100",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__a72",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__1c0",
  "epic-icon-preview": "epic__epic-icon-preview__ba7",
  "epic-icon-profile": "epic__epic-icon-profile__379",
  "epic-icon-quotes": "epic__epic-icon-quotes__153",
  "epic-icon-search": "epic__epic-icon-search__2c9",
  "epic-icon-share": "epic__epic-icon-share__5e2",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__9b9",
  "epic-icon-slack": "epic__epic-icon-slack__8b0",
  "epic-icon-steps": "epic__epic-icon-steps__01c",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__0e9",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__bd6",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__279",
  "epic-icon-warning": "epic__epic-icon-warning__841",
  "epic-font-base": "epic__epic-font-base__747",
  section: section$1,
  header: header$1,
  "epic-font-base-md": "epic__epic-font-base-md__6f9",
  "epic-font-marketing": "epic__epic-font-marketing__db2",
  "epic-font-brand": "epic__epic-font-brand__5a9",
  ripple: ripple$h,
  done: done$1,
  sectionContent,
  fullContent,
  collapseIcon,
  plus,
  minus
};
const trigger = (isOpen) => /* @__PURE__ */ jsx$1("span", {
  className: `${styles$h.collapseIcon} ${isOpen ? styles$h.minus : styles$h.plus}`,
  children: isOpen ? "-" : "+"
});
function Section(_u) {
  var _v = _u, {
    title: title2,
    children,
    subtitle: subtitle2,
    className,
    collapsible,
    collapsibleConfig
  } = _v, props = __objRest(_v, [
    "title",
    "children",
    "subtitle",
    "className",
    "collapsible",
    "collapsibleConfig"
  ]);
  let sectionClassName = className ? `${styles$h.section} ${className}` : styles$h.section;
  let sectionClass = classnames$1(styles$h.sectionContent);
  if (!(title2 || subtitle2))
    sectionClass = classnames$1(styles$h.fullContent);
  return /* @__PURE__ */ jsx$1("section", {
    children: /* @__PURE__ */ jsxs("div", __spreadProps(__spreadValues({}, props), {
      className: sectionClassName,
      children: [(title2 || subtitle2) && /* @__PURE__ */ jsxs("div", {
        className: styles$h.header,
        children: [title2 && /* @__PURE__ */ jsx$1("h1", {
          children: title2
        }), subtitle2 && /* @__PURE__ */ jsx$1("h3", {
          children: subtitle2
        })]
      }), collapsible ? /* @__PURE__ */ jsx$1(ReactCollapsible, __spreadProps(__spreadValues({
        trigger: trigger(false),
        triggerWhenOpen: trigger(true)
      }, collapsibleConfig), {
        children: /* @__PURE__ */ jsx$1("div", {
          className: sectionClass,
          children
        })
      })) : /* @__PURE__ */ jsx$1("div", {
        className: sectionClass,
        children
      })]
    }))
  });
}
Section.propTypes = {
  className: PropTypes.string,
  title: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.string,
  collapsible: PropTypes.bool,
  collapsibleConfig: PropTypes.object,
  children: PropTypes.PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
Section.defaultProps = {
  className: "",
  collapsibleConfig: {}
};
const spinner = "epic__spinner__ed9";
const spinnerLG = "epic__spinnerLG__c45";
const spinnerMD = "epic__spinnerMD__499";
var styles$g = {
  spinner,
  spinnerLG,
  spinnerMD
};
const Spinner = ({
  medium: medium2,
  large: large2,
  color,
  className
}) => {
  const mediumSpinner = medium2 ? styles$g.spinnerMD : "";
  const largeSpinner = large2 ? styles$g.spinnerLG : "";
  const colorStyle = color ? {
    borderTop: `2px solid ${color}`
  } : "";
  return /* @__PURE__ */ jsx$1("div", {
    className: `${styles$g.spinner} ${mediumSpinner} ${largeSpinner} ${className}`,
    style: colorStyle
  });
};
Spinner.propTypes = {
  large: PropTypes.bool,
  medium: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.string
};
Spinner.defaultProps = {
  className: "",
  large: false,
  medium: false,
  color: "#03ade0"
};
function makeTypeChecker(tabsRole) {
  return function(element) {
    return !!element.type && element.type.tabsRole === tabsRole;
  };
}
var isTab = makeTypeChecker("Tab");
var isTabList = makeTypeChecker("TabList");
var isTabPanel = makeTypeChecker("TabPanel");
function _extends$2() {
  _extends$2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function isTabChild(child) {
  return isTab(child) || isTabList(child) || isTabPanel(child);
}
function deepMap(children, callback) {
  return Children.map(children, function(child) {
    if (child === null)
      return null;
    if (isTabChild(child)) {
      return callback(child);
    }
    if (child.props && child.props.children && typeof child.props.children === "object") {
      return /* @__PURE__ */ cloneElement(child, _extends$2({}, child.props, {
        children: deepMap(child.props.children, callback)
      }));
    }
    return child;
  });
}
function deepForEach(children, callback) {
  return Children.forEach(children, function(child) {
    if (child === null)
      return;
    if (isTab(child) || isTabPanel(child)) {
      callback(child);
    } else if (child.props && child.props.children && typeof child.props.children === "object") {
      if (isTabList(child))
        callback(child);
      deepForEach(child.props.children, callback);
    }
  });
}
function toVal(mix) {
  var k, y, str = "";
  if (typeof mix === "string" || typeof mix === "number") {
    str += mix;
  } else if (typeof mix === "object") {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if (y = toVal(mix[k])) {
            str && (str += " ");
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += " ");
          str += k;
        }
      }
    }
  }
  return str;
}
function cx() {
  var i = 0, tmp, x, str = "";
  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += " ");
        str += x;
      }
    }
  }
  return str;
}
var count = 0;
function uuid() {
  return "react-tabs-" + count++;
}
function getTabsCount(children) {
  var tabCount = 0;
  deepForEach(children, function(child) {
    if (isTab(child))
      tabCount++;
  });
  return tabCount;
}
function getPanelsCount(children) {
  var panelCount = 0;
  deepForEach(children, function(child) {
    if (isTabPanel(child))
      panelCount++;
  });
  return panelCount;
}
function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _inheritsLoose$4(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$5(subClass, superClass);
}
function _setPrototypeOf$5(o, p2) {
  _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$5(o, p2);
}
function isNode(node) {
  return node && "getAttribute" in node;
}
function isTabNode(node) {
  return isNode(node) && node.getAttribute("role") === "tab";
}
function isTabDisabled(node) {
  return isNode(node) && node.getAttribute("aria-disabled") === "true";
}
var canUseActiveElement;
function determineCanUseActiveElement(environment) {
  var env = environment || (typeof window !== "undefined" ? window : void 0);
  try {
    canUseActiveElement = !!(typeof env !== "undefined" && env.document && env.document.activeElement);
  } catch (e) {
    canUseActiveElement = false;
  }
}
var UncontrolledTabs = /* @__PURE__ */ function(_Component) {
  _inheritsLoose$4(UncontrolledTabs2, _Component);
  function UncontrolledTabs2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.tabNodes = [];
    _this.handleKeyDown = function(e) {
      var _this$props = _this.props, direction = _this$props.direction, disableUpDownKeys = _this$props.disableUpDownKeys;
      if (_this.isTabFromContainer(e.target)) {
        var index2 = _this.props.selectedIndex;
        var preventDefault = false;
        var useSelectedIndex = false;
        if (e.keyCode === 32 || e.keyCode === 13) {
          preventDefault = true;
          useSelectedIndex = false;
          _this.handleClick(e);
        }
        if (e.keyCode === 37 || !disableUpDownKeys && e.keyCode === 38) {
          if (direction === "rtl") {
            index2 = _this.getNextTab(index2);
          } else {
            index2 = _this.getPrevTab(index2);
          }
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 39 || !disableUpDownKeys && e.keyCode === 40) {
          if (direction === "rtl") {
            index2 = _this.getPrevTab(index2);
          } else {
            index2 = _this.getNextTab(index2);
          }
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 35) {
          index2 = _this.getLastTab();
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 36) {
          index2 = _this.getFirstTab();
          preventDefault = true;
          useSelectedIndex = true;
        }
        if (preventDefault) {
          e.preventDefault();
        }
        if (useSelectedIndex) {
          _this.setSelected(index2, e);
        }
      }
    };
    _this.handleClick = function(e) {
      var node = e.target;
      do {
        if (_this.isTabFromContainer(node)) {
          if (isTabDisabled(node)) {
            return;
          }
          var index2 = [].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);
          _this.setSelected(index2, e);
          return;
        }
      } while ((node = node.parentNode) != null);
    };
    return _this;
  }
  var _proto = UncontrolledTabs2.prototype;
  _proto.setSelected = function setSelected(index2, event) {
    if (index2 < 0 || index2 >= this.getTabsCount())
      return;
    var _this$props2 = this.props, onSelect = _this$props2.onSelect, selectedIndex = _this$props2.selectedIndex;
    onSelect(index2, selectedIndex, event);
  };
  _proto.getNextTab = function getNextTab(index2) {
    var count2 = this.getTabsCount();
    for (var i = index2 + 1; i < count2; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }
    for (var _i = 0; _i < index2; _i++) {
      if (!isTabDisabled(this.getTab(_i))) {
        return _i;
      }
    }
    return index2;
  };
  _proto.getPrevTab = function getPrevTab(index2) {
    var i = index2;
    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }
    i = this.getTabsCount();
    while (i-- > index2) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }
    return index2;
  };
  _proto.getFirstTab = function getFirstTab() {
    var count2 = this.getTabsCount();
    for (var i = 0; i < count2; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }
    return null;
  };
  _proto.getLastTab = function getLastTab() {
    var i = this.getTabsCount();
    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }
    return null;
  };
  _proto.getTabsCount = function getTabsCount$1() {
    var children = this.props.children;
    return getTabsCount(children);
  };
  _proto.getPanelsCount = function getPanelsCount$1() {
    var children = this.props.children;
    return getPanelsCount(children);
  };
  _proto.getTab = function getTab(index2) {
    return this.tabNodes["tabs-" + index2];
  };
  _proto.getChildren = function getChildren() {
    var _this2 = this;
    var index2 = 0;
    var _this$props3 = this.props, children = _this$props3.children, disabledTabClassName = _this$props3.disabledTabClassName, focus = _this$props3.focus, forceRenderTabPanel = _this$props3.forceRenderTabPanel, selectedIndex = _this$props3.selectedIndex, selectedTabClassName = _this$props3.selectedTabClassName, selectedTabPanelClassName = _this$props3.selectedTabPanelClassName, environment = _this$props3.environment;
    this.tabIds = this.tabIds || [];
    this.panelIds = this.panelIds || [];
    var diff = this.tabIds.length - this.getTabsCount();
    while (diff++ < 0) {
      this.tabIds.push(uuid());
      this.panelIds.push(uuid());
    }
    return deepMap(children, function(child) {
      var result = child;
      if (isTabList(child)) {
        var listIndex = 0;
        var wasTabFocused = false;
        if (canUseActiveElement == null) {
          determineCanUseActiveElement(environment);
        }
        if (canUseActiveElement) {
          wasTabFocused = React__default.Children.toArray(child.props.children).filter(isTab).some(function(tab2, i) {
            var env = environment || (typeof window !== "undefined" ? window : void 0);
            return env && env.document.activeElement === _this2.getTab(i);
          });
        }
        result = /* @__PURE__ */ cloneElement(child, {
          children: deepMap(child.props.children, function(tab2) {
            var key = "tabs-" + listIndex;
            var selected2 = selectedIndex === listIndex;
            var props2 = {
              tabRef: function tabRef(node) {
                _this2.tabNodes[key] = node;
              },
              id: _this2.tabIds[listIndex],
              panelId: _this2.panelIds[listIndex],
              selected: selected2,
              focus: selected2 && (focus || wasTabFocused)
            };
            if (selectedTabClassName)
              props2.selectedClassName = selectedTabClassName;
            if (disabledTabClassName)
              props2.disabledClassName = disabledTabClassName;
            listIndex++;
            return /* @__PURE__ */ cloneElement(tab2, props2);
          })
        });
      } else if (isTabPanel(child)) {
        var props = {
          id: _this2.panelIds[index2],
          tabId: _this2.tabIds[index2],
          selected: selectedIndex === index2
        };
        if (forceRenderTabPanel)
          props.forceRender = forceRenderTabPanel;
        if (selectedTabPanelClassName)
          props.selectedClassName = selectedTabPanelClassName;
        index2++;
        result = /* @__PURE__ */ cloneElement(child, props);
      }
      return result;
    });
  };
  _proto.isTabFromContainer = function isTabFromContainer(node) {
    if (!isTabNode(node)) {
      return false;
    }
    var nodeAncestor = node.parentElement;
    do {
      if (nodeAncestor === this.node)
        return true;
      if (nodeAncestor.getAttribute("data-tabs"))
        break;
      nodeAncestor = nodeAncestor.parentElement;
    } while (nodeAncestor);
    return false;
  };
  _proto.render = function render3() {
    var _this3 = this;
    var _this$props4 = this.props;
    _this$props4.children;
    var className = _this$props4.className;
    _this$props4.disabledTabClassName;
    var domRef = _this$props4.domRef;
    _this$props4.focus;
    _this$props4.forceRenderTabPanel;
    _this$props4.onSelect;
    _this$props4.selectedIndex;
    _this$props4.selectedTabClassName;
    _this$props4.selectedTabPanelClassName;
    _this$props4.environment;
    _this$props4.disableUpDownKeys;
    var attributes = _objectWithoutPropertiesLoose$5(_this$props4, ["children", "className", "disabledTabClassName", "domRef", "focus", "forceRenderTabPanel", "onSelect", "selectedIndex", "selectedTabClassName", "selectedTabPanelClassName", "environment", "disableUpDownKeys"]);
    return /* @__PURE__ */ jsx$1("div", __spreadProps(__spreadValues({}, attributes), {
      className: cx(className),
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      ref: function ref(node) {
        _this3.node = node;
        if (domRef)
          domRef(node);
      },
      "data-tabs": true,
      children: this.getChildren()
    }));
  };
  return UncontrolledTabs2;
}(Component);
UncontrolledTabs.defaultProps = {
  className: "react-tabs",
  focus: false
};
UncontrolledTabs.propTypes = {};
function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _inheritsLoose$3(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$4(subClass, superClass);
}
function _setPrototypeOf$4(o, p2) {
  _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$4(o, p2);
}
var MODE_CONTROLLED = 0;
var MODE_UNCONTROLLED = 1;
var Tabs$1 = /* @__PURE__ */ function(_Component) {
  _inheritsLoose$3(Tabs2, _Component);
  function Tabs2(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.handleSelected = function(index2, last, event) {
      var onSelect = _this.props.onSelect;
      var mode = _this.state.mode;
      if (typeof onSelect === "function") {
        if (onSelect(index2, last, event) === false)
          return;
      }
      var state = {
        focus: event.type === "keydown"
      };
      if (mode === MODE_UNCONTROLLED) {
        state.selectedIndex = index2;
      }
      _this.setState(state);
    };
    _this.state = Tabs2.copyPropsToState(_this.props, {}, props.defaultFocus);
    return _this;
  }
  Tabs2.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    return Tabs2.copyPropsToState(props, state);
  };
  Tabs2.getModeFromProps = function getModeFromProps(props) {
    return props.selectedIndex === null ? MODE_UNCONTROLLED : MODE_CONTROLLED;
  };
  Tabs2.copyPropsToState = function copyPropsToState(props, state, focus) {
    if (focus === void 0) {
      focus = false;
    }
    var newState = {
      focus,
      mode: Tabs2.getModeFromProps(props)
    };
    if (newState.mode === MODE_UNCONTROLLED) {
      var maxTabIndex = Math.max(0, getTabsCount(props.children) - 1);
      var selectedIndex = null;
      if (state.selectedIndex != null) {
        selectedIndex = Math.min(state.selectedIndex, maxTabIndex);
      } else {
        selectedIndex = props.defaultIndex || 0;
      }
      newState.selectedIndex = selectedIndex;
    }
    return newState;
  };
  var _proto = Tabs2.prototype;
  _proto.render = function render3() {
    var _this$props = this.props, children = _this$props.children;
    _this$props.defaultIndex;
    _this$props.defaultFocus;
    var props = _objectWithoutPropertiesLoose$4(_this$props, ["children", "defaultIndex", "defaultFocus"]);
    var _this$state = this.state, focus = _this$state.focus, selectedIndex = _this$state.selectedIndex;
    props.focus = focus;
    props.onSelect = this.handleSelected;
    if (selectedIndex != null) {
      props.selectedIndex = selectedIndex;
    }
    return /* @__PURE__ */ jsx$1(UncontrolledTabs, __spreadProps(__spreadValues({}, props), {
      children
    }));
  };
  return Tabs2;
}(Component);
Tabs$1.defaultProps = {
  defaultFocus: false,
  forceRenderTabPanel: false,
  selectedIndex: null,
  defaultIndex: null,
  environment: null,
  disableUpDownKeys: false
};
Tabs$1.propTypes = {};
Tabs$1.tabsRole = "Tabs";
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$3(subClass, superClass);
}
function _setPrototypeOf$3(o, p2) {
  _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$3(o, p2);
}
var TabList = /* @__PURE__ */ function(_Component) {
  _inheritsLoose$2(TabList2, _Component);
  function TabList2() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = TabList2.prototype;
  _proto.render = function render3() {
    var _this$props = this.props, children = _this$props.children, className = _this$props.className, attributes = _objectWithoutPropertiesLoose$3(_this$props, ["children", "className"]);
    return /* @__PURE__ */ jsx$1("ul", __spreadProps(__spreadValues({}, attributes), {
      className: cx(className),
      role: "tablist",
      children
    }));
  };
  return TabList2;
}(Component);
TabList.defaultProps = {
  className: "react-tabs__tab-list"
};
TabList.propTypes = {};
TabList.tabsRole = "TabList";
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o, p2) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$2(o, p2);
}
var DEFAULT_CLASS$1 = "react-tabs__tab";
var Tab = /* @__PURE__ */ function(_Component) {
  _inheritsLoose$1(Tab2, _Component);
  function Tab2() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Tab2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.checkFocus();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.checkFocus();
  };
  _proto.checkFocus = function checkFocus() {
    var _this$props = this.props, selected2 = _this$props.selected, focus = _this$props.focus;
    if (selected2 && focus) {
      this.node.focus();
    }
  };
  _proto.render = function render3() {
    var _cx, _this = this;
    var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, disabled2 = _this$props2.disabled, disabledClassName = _this$props2.disabledClassName;
    _this$props2.focus;
    var id2 = _this$props2.id, panelId = _this$props2.panelId, selected2 = _this$props2.selected, selectedClassName = _this$props2.selectedClassName, tabIndex = _this$props2.tabIndex, tabRef = _this$props2.tabRef, attributes = _objectWithoutPropertiesLoose$2(_this$props2, ["children", "className", "disabled", "disabledClassName", "focus", "id", "panelId", "selected", "selectedClassName", "tabIndex", "tabRef"]);
    return /* @__PURE__ */ jsx$1("li", __spreadProps(__spreadValues({}, attributes), {
      className: cx(className, (_cx = {}, _cx[selectedClassName] = selected2, _cx[disabledClassName] = disabled2, _cx)),
      ref: function ref(node) {
        _this.node = node;
        if (tabRef)
          tabRef(node);
      },
      role: "tab",
      id: id2,
      "aria-selected": selected2 ? "true" : "false",
      "aria-disabled": disabled2 ? "true" : "false",
      "aria-controls": panelId,
      tabIndex: tabIndex || (selected2 ? "0" : null),
      children
    }));
  };
  return Tab2;
}(Component);
Tab.defaultProps = {
  className: DEFAULT_CLASS$1,
  disabledClassName: DEFAULT_CLASS$1 + "--disabled",
  focus: false,
  id: null,
  panelId: null,
  selected: false,
  selectedClassName: DEFAULT_CLASS$1 + "--selected"
};
Tab.propTypes = {};
Tab.tabsRole = "Tab";
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p2) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$1(o, p2);
}
var DEFAULT_CLASS = "react-tabs__tab-panel";
var TabPanel = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(TabPanel2, _Component);
  function TabPanel2() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = TabPanel2.prototype;
  _proto.render = function render3() {
    var _cx;
    var _this$props = this.props, children = _this$props.children, className = _this$props.className, forceRender = _this$props.forceRender, id2 = _this$props.id, selected2 = _this$props.selected, selectedClassName = _this$props.selectedClassName, tabId = _this$props.tabId, attributes = _objectWithoutPropertiesLoose$1(_this$props, ["children", "className", "forceRender", "id", "selected", "selectedClassName", "tabId"]);
    return /* @__PURE__ */ jsx$1("div", __spreadProps(__spreadValues({}, attributes), {
      className: cx(className, (_cx = {}, _cx[selectedClassName] = selected2, _cx)),
      role: "tabpanel",
      id: id2,
      "aria-labelledby": tabId,
      children: forceRender || selected2 ? children : null
    }));
  };
  return TabPanel2;
}(Component);
TabPanel.defaultProps = {
  className: DEFAULT_CLASS,
  forceRender: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};
TabPanel.propTypes = {};
TabPanel.tabsRole = "TabPanel";
const icon$g = "epic__icon__72c";
const ripple$g = "epic__ripple__8ba";
const tabList = "epic__tabList__a85";
const tab = "epic__tab__e1c";
const active$3 = "epic__active__7c5";
const disabled$3 = "epic__disabled__a08";
var styles$f = {
  icon: icon$g,
  "epic-icon": "epic__epic-icon__95a",
  "epic-icon-add": "epic__epic-icon-add__7ca",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__1ab",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__b39",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__78e",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__40d",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__678",
  "epic-icon-calendar": "epic__epic-icon-calendar__da2",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__131",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__3e5",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__602",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__737",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__cd2",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__841",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__02f",
  "epic-icon-close-x": "epic__epic-icon-close-x__ec3",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__4ce",
  "epic-icon-confluence": "epic__epic-icon-confluence__ba2",
  "epic-icon-contact": "epic__epic-icon-contact__ba4",
  "epic-icon-delete": "epic__epic-icon-delete__aa3",
  "epic-icon-edit": "epic__epic-icon-edit__c13",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__dc7",
  "epic-icon-filter": "epic__epic-icon-filter__a50",
  "epic-icon-github": "epic__epic-icon-github__2c2",
  "epic-icon-information": "epic__epic-icon-information__73c",
  "epic-icon-jira": "epic__epic-icon-jira__5c0",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__5cc",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__ba6",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__66f",
  "epic-icon-preview": "epic__epic-icon-preview__cb3",
  "epic-icon-profile": "epic__epic-icon-profile__316",
  "epic-icon-quotes": "epic__epic-icon-quotes__1ba",
  "epic-icon-search": "epic__epic-icon-search__c9b",
  "epic-icon-share": "epic__epic-icon-share__3c7",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__a88",
  "epic-icon-slack": "epic__epic-icon-slack__f2f",
  "epic-icon-steps": "epic__epic-icon-steps__d39",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__625",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__6ac",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__937",
  "epic-icon-warning": "epic__epic-icon-warning__1f0",
  "epic-font-base": "epic__epic-font-base__fce",
  "epic-font-base-md": "epic__epic-font-base-md__8dc",
  "epic-font-marketing": "epic__epic-font-marketing__514",
  "epic-font-brand": "epic__epic-font-brand__e7d",
  ripple: ripple$g,
  tabList,
  tab,
  active: active$3,
  disabled: disabled$3
};
const Tabs = ({
  tabs,
  className,
  tabClassName,
  tabListClassName,
  selectedTabClassName,
  selectedTabPanelClassName,
  defaultFocus,
  defaultIndex,
  onSelect,
  forceRenderTabPanel,
  selectedIndex,
  disabledTabs,
  children
}) => {
  return /* @__PURE__ */ jsxs(Tabs$1, {
    className: className || "",
    selectedTabClassName: `${styles$f.active} ${selectedTabClassName || ""}`,
    selectedTabPanelClassName,
    defaultFocus,
    defaultIndex,
    forceRenderTabPanel,
    onSelect,
    selectedIndex,
    children: [/* @__PURE__ */ jsx$1(TabList, {
      className: `${styles$f.tabList} ${tabListClassName || ""}`,
      children: tabs.map((title2, i) => {
        const disabled2 = disabledTabs.includes(i);
        return /* @__PURE__ */ jsx$1(Tab, {
          className: `${styles$f.tab} ${tabClassName || ""} ${disabled2 && styles$f.disabled}`,
          disabled: disabled2,
          children: title2
        }, `title-${i}`);
      })
    }), children]
  });
};
Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  disabledTabs: PropTypes.array,
  className: PropTypes.string,
  tabListClassName: PropTypes.string,
  tabClassName: PropTypes.string,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string,
  defaultFocus: PropTypes.bool,
  defaultIndex: PropTypes.number,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: PropTypes.bool,
  selectedIndex: PropTypes.number
};
Tabs.defaultProps = {
  defaultFocus: false,
  defaultIndex: 0,
  forceRenderTabPanel: false,
  disabledTabs: []
};
Tabs.TabPanel = TabPanel;
const icon$f = "epic__icon__5ad";
const ripple$f = "epic__ripple__254";
const tooltip = "epic__tooltip__710";
const tooltiptext = "epic__tooltiptext__f50";
const small = "epic__small__c41";
const medium = "epic__medium__b30";
const large$1 = "epic__large__01a";
const top = "epic__top__81d";
const bottom = "epic__bottom__32d";
const right = "epic__right__a66";
const left = "epic__left__85b";
const inverse$1 = "epic__inverse__1cf";
var styles$e = {
  icon: icon$f,
  "epic-icon": "epic__epic-icon__124",
  "epic-icon-add": "epic__epic-icon-add__1e5",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__9f4",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__144",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__572",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__fdf",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__1a8",
  "epic-icon-calendar": "epic__epic-icon-calendar__45d",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__a3e",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__593",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__26c",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__3d5",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__4a1",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__88f",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__24a",
  "epic-icon-close-x": "epic__epic-icon-close-x__b6c",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__0c8",
  "epic-icon-confluence": "epic__epic-icon-confluence__c39",
  "epic-icon-contact": "epic__epic-icon-contact__7be",
  "epic-icon-delete": "epic__epic-icon-delete__dd3",
  "epic-icon-edit": "epic__epic-icon-edit__800",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__80c",
  "epic-icon-filter": "epic__epic-icon-filter__e77",
  "epic-icon-github": "epic__epic-icon-github__d8e",
  "epic-icon-information": "epic__epic-icon-information__22f",
  "epic-icon-jira": "epic__epic-icon-jira__95a",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__db3",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__185",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__455",
  "epic-icon-preview": "epic__epic-icon-preview__f69",
  "epic-icon-profile": "epic__epic-icon-profile__bae",
  "epic-icon-quotes": "epic__epic-icon-quotes__655",
  "epic-icon-search": "epic__epic-icon-search__433",
  "epic-icon-share": "epic__epic-icon-share__af4",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__ce1",
  "epic-icon-slack": "epic__epic-icon-slack__41f",
  "epic-icon-steps": "epic__epic-icon-steps__fd7",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__b59",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__d00",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__5c5",
  "epic-icon-warning": "epic__epic-icon-warning__ccd",
  "epic-font-base": "epic__epic-font-base__7bc",
  "epic-font-base-md": "epic__epic-font-base-md__c18",
  "epic-font-marketing": "epic__epic-font-marketing__7d4",
  "epic-font-brand": "epic__epic-font-brand__5e6",
  ripple: ripple$f,
  tooltip,
  "portal-tooltip-hover": "epic__portal-tooltip-hover__bbd",
  tooltiptext,
  small,
  medium,
  large: large$1,
  top,
  bottom,
  right,
  left,
  "tooltip-content": "epic__tooltip-content__d78",
  inverse: inverse$1,
  "tooltip-container": "epic__tooltip-container__5e4"
};
const Tooltip = forwardRef(({
  className = "",
  message,
  text: text2,
  position = "top",
  size = "default",
  inverse: inverse2 = false,
  small: small2 = false,
  large: large2 = false,
  medium: medium2 = false,
  children,
  component: component2 = "",
  componentProps,
  tooltipProps,
  hasPopperSupport = false,
  portalParentNode,
  popperProps,
  isHovered,
  setIsHovered,
  setIsTooltipHovered
}, ref) => {
  const tooltipSize = small2 ? "small" : large2 ? "large" : medium2 ? "medium" : size;
  const containerClassNames = `${styles$e.tooltip}`;
  const tooltipClassNames = classnames$1(styles$e.tooltiptext, styles$e[position], styles$e[tooltipSize], {
    [styles$e.inverse]: inverse2,
    [styles$e["portal-tooltip-hover"]]: hasPopperSupport && isHovered
  });
  const CustomComponent = useMemo(() => component2 && typeof component2 !== "object" ? React__default.forwardRef((componentProps2, ref2) => React__default.createElement(component2, __spreadProps(__spreadValues({}, componentProps2), {
    ref: ref2
  }))) : /* @__PURE__ */ jsx$1(Fragment, {
    children: React__default.isValidElement(component2) && component2
  }), [component2, componentProps]);
  const renderTooltip = () => /* @__PURE__ */ jsx$1("span", __spreadProps(__spreadValues({
    "aria-label": text2 || message || "Tooltip",
    className: tooltipClassNames,
    "data-testid": "tooltipMessage",
    ref,
    onMouseEnter: () => {
      if (setIsTooltipHovered) {
        setIsTooltipHovered(true);
      }
    },
    onMouseLeave: () => {
      if (setIsTooltipHovered && setIsHovered) {
        setIsTooltipHovered(false);
        setIsHovered(false);
      }
    }
  }, hasPopperSupport ? __spreadValues({
    style: popperProps.style
  }, popperProps.attributes) : {}), {
    children: component2 && typeof component2 !== "object" ? /* @__PURE__ */ jsx$1("div", {
      className: styles$e["tooltip-content"],
      children: /* @__PURE__ */ jsx$1(CustomComponent, __spreadValues({}, componentProps))
    }) : `${text2 || message || "Tooltip"}`
  }));
  return /* @__PURE__ */ jsxs("div", __spreadProps(__spreadValues({
    className: `${containerClassNames} ${className}`
  }, tooltipProps), {
    "data-testid": "tooltipContainer",
    children: [children, hasPopperSupport ? ReactDOM__default.createPortal(renderTooltip(), portalParentNode || document.body) : renderTooltip()]
  }));
});
Tooltip.propTypes = {
  className: PropTypes.string,
  tooltipProps: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  text: PropTypes.string,
  message: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType, PropTypes.string]),
  componentProps: PropTypes.object,
  position: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  size: PropTypes.oneOf(["small", "default", "large"]),
  small: PropTypes.bool,
  large: PropTypes.bool,
  inverse: PropTypes.bool,
  hasPopperSupport: PropTypes.bool,
  portalParentNode: PropTypes.instanceOf(HTMLElement),
  popperProps: PropTypes.shape({
    attributes: PropTypes.shape(PropTypes.objectOf(PropTypes.string)),
    style: PropTypes.shape({
      styles: PropTypes.shape(PropTypes.objectOf(PropTypes.string))
    })
  }),
  isHovered: PropTypes.bool,
  setIsHovered: PropTypes.func,
  setIsTooltipHovered: PropTypes.func
};
Tooltip.defaultProps = {
  className: "",
  message: "",
  position: "top",
  size: "default",
  inverse: false,
  tooltipProps: {}
};
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _setPrototypeOf(o, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf(o, p2);
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn$1(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf3(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual2(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual2(newInputs[i], lastInputs[i])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual3) {
  if (isEqual3 === void 0) {
    isEqual3 = areInputsEqual;
  }
  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (calledOnce && lastThis === this && isEqual3(newArgs, lastArgs)) {
      return lastResult;
    }
    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }
  return memoized;
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      var _tag = createStyleElement(this);
      var before;
      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }
      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64;
        sheet.insertRule(rule, isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
function stylis_min(W) {
  function M(d, c, e, h, a) {
    for (var m2 = 0, b = 0, v = 0, n2 = 0, q2, g2, x = 0, K = 0, k, u = k = q2 = 0, l = 0, r = 0, I = 0, t = 0, B2 = e.length, J = B2 - 1, y, f2 = "", p2 = "", F2 = "", G2 = "", C; l < B2; ) {
      g2 = e.charCodeAt(l);
      l === J && b + n2 + v + m2 !== 0 && (b !== 0 && (g2 = b === 47 ? 10 : 47), n2 = v = m2 = 0, B2++, J++);
      if (b + n2 + v + m2 === 0) {
        if (l === J && (0 < r && (f2 = f2.replace(N, "")), 0 < f2.trim().length)) {
          switch (g2) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f2 += e.charAt(l);
          }
          g2 = 59;
        }
        switch (g2) {
          case 123:
            f2 = f2.trim();
            q2 = f2.charCodeAt(0);
            k = 1;
            for (t = ++l; l < B2; ) {
              switch (g2 = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;
                case 125:
                  k--;
                  break;
                case 47:
                  switch (g2 = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (g2 === 42 && e.charCodeAt(u - 1) === 42 && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (g2 === 47) {
                                l = u + 1;
                                break a;
                              }
                          }
                        }
                        l = u;
                      }
                  }
                  break;
                case 91:
                  g2++;
                case 40:
                  g2++;
                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g2; ) {
                  }
              }
              if (k === 0)
                break;
              l++;
            }
            k = e.substring(t, l);
            q2 === 0 && (q2 = (f2 = f2.replace(ca, "").trim()).charCodeAt(0));
            switch (q2) {
              case 64:
                0 < r && (f2 = f2.replace(N, ""));
                g2 = f2.charCodeAt(1);
                switch (g2) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;
                  default:
                    r = O;
                }
                k = M(c, r, k, g2, a + 1);
                t = k.length;
                0 < A && (r = X(O, f2, I), C = H(3, k, r, c, D, z, t, g2, a, h), f2 = r.join(""), C !== void 0 && (t = (k = C.trim()).length) === 0 && (g2 = 0, k = ""));
                if (0 < t)
                  switch (g2) {
                    case 115:
                      f2 = f2.replace(da, ea);
                    case 100:
                    case 109:
                    case 45:
                      k = f2 + "{" + k + "}";
                      break;
                    case 107:
                      f2 = f2.replace(fa, "$1 $2");
                      k = f2 + "{" + k + "}";
                      k = w === 1 || w === 2 && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                      break;
                    default:
                      k = f2 + k, h === 112 && (k = (p2 += k, ""));
                  }
                else
                  k = "";
                break;
              default:
                k = M(c, X(c, f2, I), k, h, a + 1);
            }
            F2 += k;
            k = I = r = u = q2 = 0;
            f2 = "";
            g2 = e.charCodeAt(++l);
            break;
          case 125:
          case 59:
            f2 = (0 < r ? f2.replace(N, "") : f2).trim();
            if (1 < (t = f2.length))
              switch (u === 0 && (q2 = f2.charCodeAt(0), q2 === 45 || 96 < q2 && 123 > q2) && (t = (f2 = f2.replace(" ", ":")).length), 0 < A && (C = H(1, f2, c, d, D, z, p2.length, h, a, h)) !== void 0 && (t = (f2 = C.trim()).length) === 0 && (f2 = "\0\0"), q2 = f2.charCodeAt(0), g2 = f2.charCodeAt(1), q2) {
                case 0:
                  break;
                case 64:
                  if (g2 === 105 || g2 === 99) {
                    G2 += f2 + e.charAt(l);
                    break;
                  }
                default:
                  f2.charCodeAt(t - 1) !== 58 && (p2 += P(f2, q2, g2, f2.charCodeAt(2)));
              }
            I = r = u = q2 = 0;
            f2 = "";
            g2 = e.charCodeAt(++l);
        }
      }
      switch (g2) {
        case 13:
        case 10:
          b === 47 ? b = 0 : 1 + q2 === 0 && h !== 107 && 0 < f2.length && (r = 1, f2 += "\0");
          0 < A * Y && H(0, f2, c, d, D, z, p2.length, h, a, h);
          z = 1;
          D++;
          break;
        case 59:
        case 125:
          if (b + n2 + v + m2 === 0) {
            z++;
            break;
          }
        default:
          z++;
          y = e.charAt(l);
          switch (g2) {
            case 9:
            case 32:
              if (n2 + m2 + b === 0)
                switch (x) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y = "";
                    break;
                  default:
                    g2 !== 32 && (y = " ");
                }
              break;
            case 0:
              y = "\\0";
              break;
            case 12:
              y = "\\f";
              break;
            case 11:
              y = "\\v";
              break;
            case 38:
              n2 + b + m2 === 0 && (r = I = 1, y = "\f" + y);
              break;
            case 108:
              if (n2 + b + m2 + E === 0 && 0 < u)
                switch (l - u) {
                  case 2:
                    x === 112 && e.charCodeAt(l - 3) === 58 && (E = x);
                  case 8:
                    K === 111 && (E = K);
                }
              break;
            case 58:
              n2 + b + m2 === 0 && (u = l);
              break;
            case 44:
              b + v + n2 + m2 === 0 && (r = 1, y += "\r");
              break;
            case 34:
            case 39:
              b === 0 && (n2 = n2 === g2 ? 0 : n2 === 0 ? g2 : n2);
              break;
            case 91:
              n2 + b + v === 0 && m2++;
              break;
            case 93:
              n2 + b + v === 0 && m2--;
              break;
            case 41:
              n2 + b + m2 === 0 && v--;
              break;
            case 40:
              if (n2 + b + m2 === 0) {
                if (q2 === 0)
                  switch (2 * x + 3 * K) {
                    case 533:
                      break;
                    default:
                      q2 = 1;
                  }
                v++;
              }
              break;
            case 64:
              b + v + n2 + m2 + u + k === 0 && (k = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n2 + m2 + v))
                switch (b) {
                  case 0:
                    switch (2 * g2 + 3 * e.charCodeAt(l + 1)) {
                      case 235:
                        b = 47;
                        break;
                      case 220:
                        t = l, b = 42;
                    }
                    break;
                  case 42:
                    g2 === 47 && x === 42 && t + 2 !== l && (e.charCodeAt(t + 2) === 33 && (p2 += e.substring(t, l + 1)), y = "", b = 0);
                }
          }
          b === 0 && (f2 += y);
      }
      K = x;
      x = g2;
      l++;
    }
    t = p2.length;
    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p2, r, d, D, z, t, h, a, h), C !== void 0 && (p2 = C).length === 0))
        return G2 + p2 + F2;
      p2 = r.join(",") + "{" + p2 + "}";
      if (w * E !== 0) {
        w !== 2 || L(p2, 2) || (E = 0);
        switch (E) {
          case 111:
            p2 = p2.replace(ha, ":-moz-$1") + p2;
            break;
          case 112:
            p2 = p2.replace(Q, "::-webkit-input-$1") + p2.replace(Q, "::-moz-$1") + p2.replace(Q, ":-ms-input-$1") + p2;
        }
        E = 0;
      }
    }
    return G2 + p2 + F2;
  }
  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length, m2 = d.length;
    switch (m2) {
      case 0:
      case 1:
        var b = 0;
        for (d = m2 === 0 ? "" : d[0] + " "; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }
        break;
      default:
        var v = b = 0;
        for (c = []; b < a; ++b) {
          for (var n2 = 0; n2 < m2; ++n2) {
            c[v++] = Z(d[n2] + " ", h[b], e).trim();
          }
        }
    }
    return c;
  }
  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));
    switch (h) {
      case 38:
        return c.replace(F, "$1" + d.trim());
      case 58:
        return d.trim() + c.replace(F, "$1" + d.trim());
      default:
        if (0 < 1 * e && 0 < c.indexOf("\f"))
          return c.replace(F, (d.charCodeAt(0) === 58 ? "" : "$1") + d.trim());
    }
    return d + c;
  }
  function P(d, c, e, h) {
    var a = d + ";", m2 = 2 * c + 3 * e + 4 * h;
    if (m2 === 944) {
      d = a.indexOf(":", 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ";";
      return w === 1 || w === 2 && L(b, 1) ? "-webkit-" + b + b : b;
    }
    if (w === 0 || w === 2 && !L(a, 1))
      return a;
    switch (m2) {
      case 1015:
        return a.charCodeAt(10) === 97 ? "-webkit-" + a + a : a;
      case 951:
        return a.charCodeAt(3) === 116 ? "-webkit-" + a + a : a;
      case 963:
        return a.charCodeAt(5) === 110 ? "-webkit-" + a + a : a;
      case 1009:
        if (a.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (a.charCodeAt(8) === 45)
          return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11))
          return a.replace(ja, "$1-webkit-$2") + a;
        break;
      case 932:
        if (a.charCodeAt(4) === 45)
          switch (a.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
            case 115:
              return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
            case 98:
              return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
          }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (a.charCodeAt(8) !== 99)
          break;
        b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
      case 1005:
        return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf("-") + 1;
        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, "tb");
            break;
          case 232:
            b = a.replace(G, "tb-rl");
            break;
          case 220:
            b = a.replace(G, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + b + a;
      case 1017:
        if (a.indexOf("sticky", 9) === -1)
          break;
      case 975:
        c = (a = d).length - 10;
        b = (a.charCodeAt(c) === 33 ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
        switch (m2 = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8))
              break;
          case 115:
            a = a.replace(b, "-webkit-" + b) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(b, "-webkit-" + (102 < m2 ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (a.charCodeAt(5) === 45)
          switch (a.charCodeAt(6)) {
            case 105:
              return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
            case 115:
              return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
            default:
              return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
          }
        break;
      case 973:
      case 989:
        if (a.charCodeAt(3) !== 45 || a.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (la.test(d) === true)
          return (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) === 115 ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (a.charCodeAt(5) === 102 ? "-ms-" + a : "") + a, e + h === 211 && a.charCodeAt(13) === 105 && 0 < a.indexOf("transform", 10))
          return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
    }
    return a;
  }
  function L(d, c) {
    var e = d.indexOf(c === 1 ? ":" : "{"), h = d.substring(0, c !== 3 ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(c !== 2 ? h : h.replace(na, "$1"), e, c);
  }
  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
  }
  function H(d, c, e, h, a, m2, b, v, n2, q2) {
    for (var g2 = 0, x = c, w2; g2 < A; ++g2) {
      switch (w2 = S[g2].call(B, d, x, e, h, a, m2, b, v, n2, q2)) {
        case void 0:
        case false:
        case true:
        case null:
          break;
        default:
          x = w2;
      }
    }
    if (x !== c)
      return x;
  }
  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;
      default:
        if (typeof d === "function")
          S[A++] = d;
        else if (typeof d === "object")
          for (var c = 0, e = d.length; c < e; ++c) {
            T(d[c]);
          }
        else
          Y = !!d | 0;
    }
    return T;
  }
  function U(d) {
    d = d.prefix;
    d !== void 0 && (R = null, d ? typeof d !== "function" ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }
  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];
    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      h !== void 0 && typeof h === "string" && (c = h);
    }
    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), h !== void 0 && (a = h));
    V = "";
    E = 0;
    z = D = 1;
    return a;
  }
  var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
  B.use = T;
  B.set = U;
  W !== void 0 && U(W);
  return B;
}
var delimiter = "/*|*/";
var needle = delimiter + "}";
function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + "}");
  }
}
var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet2(context, content2, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    case 1: {
      switch (content2.charCodeAt(0)) {
        case 64: {
          Sheet.current.insert(content2 + ";");
          return "";
        }
        case 108: {
          if (content2.charCodeAt(2) === 98) {
            return "";
          }
        }
      }
      break;
    }
    case 2: {
      if (ns === 0)
        return content2 + delimiter;
      break;
    }
    case 3: {
      switch (ns) {
        case 102:
        case 112: {
          Sheet.current.insert(selectors[0] + content2);
          return "";
        }
        default: {
          return content2 + (at === 0 ? delimiter : "");
        }
      }
    }
    case -2: {
      content2.split(needle).forEach(toSheet);
    }
  }
};
var createCache = function createCache2(options) {
  if (options === void 0)
    options = {};
  var key = options.key || "css";
  var stylisOptions;
  if (options.prefix !== void 0) {
    stylisOptions = {
      prefix: options.prefix
    };
  }
  var stylis = new stylis_min(stylisOptions);
  var inserted = {};
  var container2;
  {
    container2 = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
      var attrib = node.getAttribute("data-emotion-" + key);
      attrib.split(" ").forEach(function(id2) {
        inserted[id2] = true;
      });
      if (node.parentNode !== container2) {
        container2.appendChild(node);
      }
    });
  }
  var _insert;
  {
    stylis.use(options.stylisPlugins)(ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name2 = serialized.name;
      Sheet.current = sheet;
      stylis(selector, serialized.styles);
      if (shouldCache) {
        cache.inserted[name2] = true;
      }
    };
  }
  var cache = {
    key,
    sheet: new StyleSheet({
      key,
      container: container2,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if ((isStringTag === false || isBrowser === false) && cache.registered[className] === void 0) {
    cache.registered[className] = serialized.styles;
  }
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache.insert("." + className, current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h = 0;
  var k, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k = (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= k >>> 24;
    h = (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 255;
      h = (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  h ^= h >>> 13;
  h = (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize(fn2) {
  var cache = {};
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn2(arg);
    return cache[arg];
  };
}
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = memoize(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next = interpolation.next;
        if (next !== void 0) {
          while (next !== void 0) {
            cursor = {
              name: next.name,
              styles: next.styles,
              next: cursor
            };
            next = next.next;
          }
        }
        var styles2 = interpolation.styles + ";";
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
      }
      break;
    }
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 && !couldBeSelectorInterpolation ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);
          switch (_key) {
            case "animation":
            case "animationName": {
              string += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    styles2 += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i], styles2.charCodeAt(styles2.length - 1) === 46);
    if (stringMode) {
      styles2 += strings[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match;
  while ((match = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + match[1];
  }
  var name2 = murmur2(styles2) + identifierName;
  return {
    name: name2,
    styles: styles2,
    next: cursor
  };
};
var hasOwnProperty = Object.prototype.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ createContext(typeof HTMLElement !== "undefined" ? createCache() : null);
var ThemeContext = /* @__PURE__ */ createContext({});
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  var render3 = function render4(props, ref) {
    return /* @__PURE__ */ createElement(EmotionCacheContext.Consumer, null, function(cache) {
      return func(props, cache, ref);
    });
  };
  return /* @__PURE__ */ forwardRef(render3);
};
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type, props) {
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }
  newProps[typePropName] = type;
  return newProps;
};
var Noop$1 = function Noop() {
  return null;
};
var render = function render2(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme);
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles);
  insertStyles(cache, serialized, typeof type === "string");
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== "css" && key !== typePropName && true) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  var ele = /* @__PURE__ */ createElement(type, newProps);
  var possiblyStyleElement = /* @__PURE__ */ createElement(Noop$1, null);
  return /* @__PURE__ */ createElement(Fragment$1, null, possiblyStyleElement, ele);
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache, ref) {
  if (typeof props.css === "function") {
    return /* @__PURE__ */ createElement(ThemeContext.Consumer, null, function(theme) {
      return render(cache, props, theme, ref);
    });
  }
  return render(cache, props, null, ref);
});
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var jsx = function jsx2(type, props) {
  var args = arguments;
  if (props == null || !hasOwnProperty.call(props, "css")) {
    return createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return createElement.apply(null, createElementArgArray);
};
var keyframes = function keyframes2() {
  var insertable = css$2.apply(void 0, arguments);
  var name2 = "animation-" + insertable.name;
  return {
    name: name2,
    styles: "@keyframes " + name2 + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var classnames = function classnames2(args) {
  var len = args.length;
  var i = 0;
  var cls = "";
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null)
      continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(arg)) {
          toAdd = classnames2(arg);
        } else {
          toAdd = "";
          for (var k in arg) {
            if (arg[k] && k) {
              toAdd && (toAdd += " ");
              toAdd += k;
            }
          }
        }
        break;
      }
      default: {
        toAdd = arg;
      }
    }
    if (toAdd) {
      cls && (cls += " ");
      cls += toAdd;
    }
  }
  return cls;
};
function merge2(registered, css4, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css4(registeredStyles);
}
var Noop2 = function Noop3() {
  return null;
};
var ClassNames = withEmotionCache(function(props, context) {
  return /* @__PURE__ */ createElement(ThemeContext.Consumer, null, function(theme) {
    var hasRendered = false;
    var css4 = function css5() {
      if (hasRendered && false) {
        throw new Error("css can only be used during render");
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var serialized = serializeStyles(args, context.registered);
      {
        insertStyles(context, serialized, false);
      }
      return context.key + "-" + serialized.name;
    };
    var cx2 = function cx3() {
      if (hasRendered && false) {
        throw new Error("cx can only be used during render");
      }
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return merge2(context.registered, css4, classnames(args));
    };
    var content2 = {
      css: css4,
      cx: cx2,
      theme
    };
    var ele = props.children(content2);
    hasRendered = true;
    var possiblyStyleElement = /* @__PURE__ */ createElement(Noop2, null);
    return /* @__PURE__ */ createElement(Fragment$1, null, possiblyStyleElement, ele);
  });
});
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var AutosizeInput$1 = {};
Object.defineProperty(AutosizeInput$1, "__esModule", {
  value: true
});
var _extends = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = React__default;
var _react2 = _interopRequireDefault(_react);
var _propTypes = propTypes.exports;
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
      continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizerStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  visibility: "hidden",
  height: 0,
  overflow: "scroll",
  whiteSpace: "pre"
};
var INPUT_PROPS_BLACKLIST = ["extraWidth", "injectStyles", "inputClassName", "inputRef", "inputStyle", "minWidth", "onAutosize", "placeholderIsMinWidth"];
var cleanInputProps = function cleanInputProps2(inputProps) {
  INPUT_PROPS_BLACKLIST.forEach(function(field) {
    return delete inputProps[field];
  });
  return inputProps;
};
var copyStyles = function copyStyles2(styles2, node) {
  node.style.fontSize = styles2.fontSize;
  node.style.fontFamily = styles2.fontFamily;
  node.style.fontWeight = styles2.fontWeight;
  node.style.fontStyle = styles2.fontStyle;
  node.style.letterSpacing = styles2.letterSpacing;
  node.style.textTransform = styles2.textTransform;
};
var isIE = typeof window !== "undefined" && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
var generateId = function generateId2() {
  return isIE ? "_" + Math.random().toString(36).substr(2, 12) : void 0;
};
var AutosizeInput = function(_Component) {
  _inherits(AutosizeInput2, _Component);
  _createClass(AutosizeInput2, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var id2 = props.id;
      return id2 !== state.prevId ? { inputId: id2 || generateId(), prevId: id2 } : null;
    }
  }]);
  function AutosizeInput2(props) {
    _classCallCheck(this, AutosizeInput2);
    var _this = _possibleConstructorReturn(this, (AutosizeInput2.__proto__ || Object.getPrototypeOf(AutosizeInput2)).call(this, props));
    _this.inputRef = function(el) {
      _this.input = el;
      if (typeof _this.props.inputRef === "function") {
        _this.props.inputRef(el);
      }
    };
    _this.placeHolderSizerRef = function(el) {
      _this.placeHolderSizer = el;
    };
    _this.sizerRef = function(el) {
      _this.sizer = el;
    };
    _this.state = {
      inputWidth: props.minWidth,
      inputId: props.id || generateId(),
      prevId: props.id
    };
    return _this;
  }
  _createClass(AutosizeInput2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.copyInputStyles();
      this.updateInputWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.inputWidth !== this.state.inputWidth) {
        if (typeof this.props.onAutosize === "function") {
          this.props.onAutosize(this.state.inputWidth);
        }
      }
      this.updateInputWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "copyInputStyles",
    value: function copyInputStyles() {
      if (!this.mounted || !window.getComputedStyle) {
        return;
      }
      var inputStyles = this.input && window.getComputedStyle(this.input);
      if (!inputStyles) {
        return;
      }
      copyStyles(inputStyles, this.sizer);
      if (this.placeHolderSizer) {
        copyStyles(inputStyles, this.placeHolderSizer);
      }
    }
  }, {
    key: "updateInputWidth",
    value: function updateInputWidth() {
      if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === "undefined") {
        return;
      }
      var newInputWidth = void 0;
      if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
        newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
      } else {
        newInputWidth = this.sizer.scrollWidth + 2;
      }
      var extraWidth = this.props.type === "number" && this.props.extraWidth === void 0 ? 16 : parseInt(this.props.extraWidth) || 0;
      newInputWidth += extraWidth;
      if (newInputWidth < this.props.minWidth) {
        newInputWidth = this.props.minWidth;
      }
      if (newInputWidth !== this.state.inputWidth) {
        this.setState({
          inputWidth: newInputWidth
        });
      }
    }
  }, {
    key: "getInput",
    value: function getInput() {
      return this.input;
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select2() {
      this.input.select();
    }
  }, {
    key: "renderStyles",
    value: function renderStyles() {
      var injectStyles = this.props.injectStyles;
      return isIE && injectStyles ? _react2.default.createElement("style", { dangerouslySetInnerHTML: {
        __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}"
      } }) : null;
    }
  }, {
    key: "render",
    value: function render3() {
      var sizerValue = [this.props.defaultValue, this.props.value, ""].reduce(function(previousValue, currentValue) {
        if (previousValue !== null && previousValue !== void 0) {
          return previousValue;
        }
        return currentValue;
      });
      var wrapperStyle = _extends({}, this.props.style);
      if (!wrapperStyle.display)
        wrapperStyle.display = "inline-block";
      var inputStyle3 = _extends({
        boxSizing: "content-box",
        width: this.state.inputWidth + "px"
      }, this.props.inputStyle);
      var inputProps = _objectWithoutProperties(this.props, []);
      cleanInputProps(inputProps);
      inputProps.className = this.props.inputClassName;
      inputProps.id = this.state.inputId;
      inputProps.style = inputStyle3;
      return _react2.default.createElement("div", { className: this.props.className, style: wrapperStyle }, this.renderStyles(), _react2.default.createElement("input", _extends({}, inputProps, { ref: this.inputRef })), _react2.default.createElement("div", { ref: this.sizerRef, style: sizerStyle }, sizerValue), this.props.placeholder ? _react2.default.createElement("div", { ref: this.placeHolderSizerRef, style: sizerStyle }, this.props.placeholder) : null);
    }
  }]);
  return AutosizeInput2;
}(_react.Component);
AutosizeInput.propTypes = {
  className: _propTypes2.default.string,
  defaultValue: _propTypes2.default.any,
  extraWidth: _propTypes2.default.oneOfType([
    _propTypes2.default.number,
    _propTypes2.default.string
  ]),
  id: _propTypes2.default.string,
  injectStyles: _propTypes2.default.bool,
  inputClassName: _propTypes2.default.string,
  inputRef: _propTypes2.default.func,
  inputStyle: _propTypes2.default.object,
  minWidth: _propTypes2.default.oneOfType([
    _propTypes2.default.number,
    _propTypes2.default.string
  ]),
  onAutosize: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  placeholderIsMinWidth: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  value: _propTypes2.default.any
};
AutosizeInput.defaultProps = {
  minWidth: 1,
  injectStyles: true
};
var _default = AutosizeInput$1.default = AutosizeInput;
var noop = function noop2() {
};
function applyPrefixToName(prefix, name2) {
  if (!name2) {
    return prefix;
  } else if (name2[0] === "-") {
    return prefix + name2;
  } else {
    return prefix + "__" + name2;
  }
}
function classNames(prefix, state, className) {
  var arr = [className];
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }
  return arr.filter(function(i) {
    return i;
  }).map(function(i) {
    return String(i).trim();
  }).join(" ");
}
var cleanValue = function cleanValue2(value) {
  if (Array.isArray(value))
    return value.filter(Boolean);
  if (_typeof(value) === "object" && value !== null)
    return [value];
  return [];
};
function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}
function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top2) {
  if (isDocumentElement(el)) {
    window.scrollTo(0, top2);
    return;
  }
  el.scrollTop = top2;
}
function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement;
  if (style.position === "fixed")
    return docEl;
  for (var parent = element; parent = parent.parentElement; ) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return docEl;
}
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop;
  var start2 = getScrollTop(element);
  var change = to - start2;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start2, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}
function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
function isTouchCapable() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
}
function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _createSuper$5(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$5();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _isNativeReflectConstruct$5() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function getMenuPlacement(_ref3) {
  var maxHeight = _ref3.maxHeight, menuEl = _ref3.menuEl, minHeight = _ref3.minHeight, placement = _ref3.placement, shouldScroll = _ref3.shouldScroll, isFixedPosition = _ref3.isFixedPosition, theme = _ref3.theme;
  var spacing2 = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: "bottom",
    maxHeight
  };
  if (!menuEl || !menuEl.offsetParent)
    return defaultState;
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (placement) {
    case "auto":
    case "bottom":
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: "bottom",
          maxHeight
        };
      }
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: "bottom",
          maxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: "bottom",
          maxHeight: constrainedHeight
        };
      }
      if (placement === "auto" || isFixedPosition) {
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing2.controlHeight, maxHeight);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight
        };
      }
      if (placement === "bottom") {
        scrollTo(scrollParent, scrollDown);
        return {
          placement: "bottom",
          maxHeight
        };
      }
      break;
    case "top":
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: "top",
          maxHeight
        };
      }
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight;
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight2
        };
      }
      return {
        placement: "bottom",
        maxHeight
      };
    default:
      throw new Error('Invalid placement provided "'.concat(placement, '".'));
  }
  return defaultState;
}
function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: "top",
    top: "bottom"
  };
  return placement ? placementToCSSProp[placement] : "bottom";
}
var coercePlacement = function coercePlacement2(p2) {
  return p2 === "auto" ? "bottom" : p2;
};
var menuCSS = function menuCSS2(_ref22) {
  var _ref3;
  var placement = _ref22.placement, _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, spacing2 = _ref2$theme.spacing, colors2 = _ref2$theme.colors;
  return _ref3 = {
    label: "menu"
  }, _defineProperty(_ref3, alignToControl(placement), "100%"), _defineProperty(_ref3, "backgroundColor", colors2.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius2), _defineProperty(_ref3, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), _defineProperty(_ref3, "marginBottom", spacing2.menuGutter), _defineProperty(_ref3, "marginTop", spacing2.menuGutter), _defineProperty(_ref3, "position", "absolute"), _defineProperty(_ref3, "width", "100%"), _defineProperty(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /* @__PURE__ */ createContext({
  getPortalPlacement: null
});
var MenuPlacer = /* @__PURE__ */ function(_Component) {
  _inherits$1(MenuPlacer2, _Component);
  var _super = _createSuper$5(MenuPlacer2);
  function MenuPlacer2() {
    var _this;
    _classCallCheck$1(this, MenuPlacer2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };
    _this.getPlacement = function(ref) {
      var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
      if (!ref)
        return;
      var isFixedPosition = menuPosition === "fixed";
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll,
        isFixedPosition,
        theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement)
        getPortalPlacement(state);
      _this.setState(state);
    };
    _this.getUpdatedProps = function() {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread$3(_objectSpread$3({}, _this.props), {}, {
        placement,
        maxHeight: _this.state.maxHeight
      });
    };
    return _this;
  }
  _createClass$1(MenuPlacer2, [{
    key: "render",
    value: function render3() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);
  return MenuPlacer2;
}(Component);
MenuPlacer.contextType = PortalPlacementContext;
var Menu = function Menu2(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles("menu", props),
    className: cx2({
      menu: true
    }, className)
  }, innerProps, {
    ref: innerRef
  }), children);
};
var menuListCSS = function menuListCSS2(_ref4) {
  var maxHeight = _ref4.maxHeight, baseUnit2 = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight,
    overflowY: "auto",
    paddingBottom: baseUnit2,
    paddingTop: baseUnit2,
    position: "relative",
    WebkitOverflowScrolling: "touch"
  };
};
var MenuList$1 = function MenuList(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles, isMulti = props.isMulti, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles("menuList", props),
    className: cx2({
      "menu-list": true,
      "menu-list--is-multi": isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
};
var noticeCSS = function noticeCSS2(_ref5) {
  var _ref5$theme = _ref5.theme, baseUnit2 = _ref5$theme.spacing.baseUnit, colors2 = _ref5$theme.colors;
  return {
    color: colors2.neutral40,
    padding: "".concat(baseUnit2 * 2, "px ").concat(baseUnit2 * 3, "px"),
    textAlign: "center"
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage2(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles("noOptionsMessage", props),
    className: cx2({
      "menu-notice": true,
      "menu-notice--no-options": true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: "No options"
};
var LoadingMessage = function LoadingMessage2(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles("loadingMessage", props),
    className: cx2({
      "menu-notice": true,
      "menu-notice--loading": true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: "Loading..."
};
var menuPortalCSS = function menuPortalCSS2(_ref6) {
  var rect = _ref6.rect, offset2 = _ref6.offset, position = _ref6.position;
  return {
    left: rect.left,
    position,
    top: offset2,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /* @__PURE__ */ function(_Component2) {
  _inherits$1(MenuPortal2, _Component2);
  var _super2 = _createSuper$5(MenuPortal2);
  function MenuPortal2() {
    var _this2;
    _classCallCheck$1(this, MenuPortal2);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };
    _this2.getPortalPlacement = function(_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement);
      if (placement !== initialPlacement) {
        _this2.setState({
          placement
        });
      }
    };
    return _this2;
  }
  _createClass$1(MenuPortal2, [{
    key: "render",
    value: function render3() {
      var _this$props2 = this.props, appendTo = _this$props2.appendTo, children = _this$props2.children, controlElement = _this$props2.controlElement, menuPlacement = _this$props2.menuPlacement, position = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
      var isFixed = position === "fixed";
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }
      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset2 = rect[placement] + scrollDistance;
      var state = {
        offset: offset2,
        position,
        rect
      };
      var menuWrapper = jsx("div", {
        css: getStyles("menuPortal", state)
      }, children);
      return jsx(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /* @__PURE__ */ createPortal(menuWrapper, appendTo) : menuWrapper);
    }
  }]);
  return MenuPortal2;
}(Component);
var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
function equal(a, b) {
  if (a === b)
    return true;
  if (a && b && _typeof(a) == "object" && _typeof(b) == "object") {
    var arrA = isArray(a), arrB = isArray(b), i, length, key;
    if (arrA && arrB) {
      length = a.length;
      if (length != b.length)
        return false;
      for (i = length; i-- !== 0; ) {
        if (!equal(a[i], b[i]))
          return false;
      }
      return true;
    }
    if (arrA != arrB)
      return false;
    var dateA = a instanceof Date, dateB = b instanceof Date;
    if (dateA != dateB)
      return false;
    if (dateA && dateB)
      return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
    if (regexpA != regexpB)
      return false;
    if (regexpA && regexpB)
      return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;
    if (length !== keyList(b).length) {
      return false;
    }
    for (i = length; i-- !== 0; ) {
      if (!hasProp.call(b, keys[i]))
        return false;
    }
    for (i = length; i-- !== 0; ) {
      key = keys[i];
      if (key === "_owner" && a.$$typeof) {
        continue;
      } else {
        if (!equal(a[key], b[key]))
          return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
      return false;
    }
    throw error;
  }
}
var containerCSS = function containerCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isRtl = _ref3.isRtl;
  return {
    label: "container",
    direction: isRtl ? "rtl" : null,
    pointerEvents: isDisabled ? "none" : null,
    position: "relative"
  };
};
var SelectContainer = function SelectContainer2(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
  return jsx("div", _extends$1({
    css: getStyles("container", props),
    className: cx2({
      "--is-disabled": isDisabled,
      "--is-rtl": isRtl
    }, className)
  }, innerProps), children);
};
var valueContainerCSS = function valueContainerCSS2(_ref22) {
  var spacing2 = _ref22.theme.spacing;
  return {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    padding: "".concat(spacing2.baseUnit / 2, "px ").concat(spacing2.baseUnit * 2, "px"),
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  };
};
var ValueContainer = function ValueContainer2(props) {
  var children = props.children, className = props.className, cx2 = props.cx, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
  return jsx("div", {
    css: getStyles("valueContainer", props),
    className: cx2({
      "value-container": true,
      "value-container--is-multi": isMulti,
      "value-container--has-value": hasValue
    }, className)
  }, children);
};
var indicatorsContainerCSS = function indicatorsContainerCSS2() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer2(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles;
  return jsx("div", {
    css: getStyles("indicatorsContainer", props),
    className: cx2({
      indicators: true
    }, className)
  }, children);
};
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);
  _templateObject = function _templateObject2() {
    return data;
  };
  return data;
}
var _ref2 = {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
};
var Svg = function Svg2(_ref3) {
  var size = _ref3.size, props = _objectWithoutProperties$1(_ref3, ["size"]);
  return jsx("svg", _extends$1({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};
var CrossIcon = function CrossIcon2(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron2(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};
var baseCSS = function baseCSS2(_ref3) {
  var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit2 = _ref3$theme.spacing.baseUnit, colors2 = _ref3$theme.colors;
  return {
    label: "indicatorContainer",
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    display: "flex",
    padding: baseUnit2 * 2,
    transition: "color 150ms",
    ":hover": {
      color: isFocused ? colors2.neutral80 : colors2.neutral40
    }
  };
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator$1 = function DropdownIndicator(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, innerProps, {
    css: getStyles("dropdownIndicator", props),
    className: cx2({
      indicator: true,
      "dropdown-indicator": true
    }, className)
  }), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator2(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, innerProps, {
    css: getStyles("clearIndicator", props),
    className: cx2({
      indicator: true,
      "clear-indicator": true
    }, className)
  }), children || jsx(CrossIcon, null));
};
var indicatorSeparatorCSS = function indicatorSeparatorCSS2(_ref4) {
  var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit2 = _ref4$theme.spacing.baseUnit, colors2 = _ref4$theme.colors;
  return {
    label: "indicatorSeparator",
    alignSelf: "stretch",
    backgroundColor: isDisabled ? colors2.neutral10 : colors2.neutral20,
    marginBottom: baseUnit2 * 2,
    marginTop: baseUnit2 * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator2(props) {
  var className = props.className, cx2 = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("span", _extends$1({}, innerProps, {
    css: getStyles("indicatorSeparator", props),
    className: cx2({
      "indicator-separator": true
    }, className)
  }));
};
var loadingDotAnimations = keyframes(_templateObject());
var loadingIndicatorCSS = function loadingIndicatorCSS2(_ref5) {
  var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors2 = _ref5$theme.colors, baseUnit2 = _ref5$theme.spacing.baseUnit;
  return {
    label: "loadingIndicator",
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    display: "flex",
    padding: baseUnit2 * 2,
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: "center",
    verticalAlign: "middle"
  };
};
var LoadingDot = function LoadingDot2(_ref6) {
  var delay = _ref6.delay, offset2 = _ref6.offset;
  return jsx("span", {
    css: /* @__PURE__ */ css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: offset2 ? "1em" : null,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, "")
  });
};
var LoadingIndicator = function LoadingIndicator2(props) {
  var className = props.className, cx2 = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
  return jsx("div", _extends$1({}, innerProps, {
    css: getStyles("loadingIndicator", props),
    className: cx2({
      indicator: true,
      "loading-indicator": true
    }, className)
  }), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};
var css = function css2(_ref3) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, _ref$theme = _ref3.theme, colors2 = _ref$theme.colors, borderRadius2 = _ref$theme.borderRadius, spacing2 = _ref$theme.spacing;
  return {
    label: "control",
    alignItems: "center",
    backgroundColor: isDisabled ? colors2.neutral5 : colors2.neutral0,
    borderColor: isDisabled ? colors2.neutral10 : isFocused ? colors2.primary : colors2.neutral20,
    borderRadius: borderRadius2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors2.primary) : null,
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: spacing2.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms",
    "&:hover": {
      borderColor: isFocused ? colors2.primary : colors2.neutral30
    }
  };
};
var Control$1 = function Control(props) {
  var children = props.children, cx2 = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$1({
    ref: innerRef,
    css: getStyles("control", props),
    className: cx2({
      control: true,
      "control--is-disabled": isDisabled,
      "control--is-focused": isFocused,
      "control--menu-is-open": menuIsOpen
    }, className)
  }, innerProps), children);
};
function ownKeys$1$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1$1(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1$1(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var groupCSS = function groupCSS2(_ref3) {
  var spacing2 = _ref3.theme.spacing;
  return {
    paddingBottom: spacing2.baseUnit * 2,
    paddingTop: spacing2.baseUnit * 2
  };
};
var Group = function Group2(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles, Heading2 = props.Heading, headingProps = props.headingProps, label2 = props.label, theme = props.theme, selectProps = props.selectProps;
  return jsx("div", {
    css: getStyles("group", props),
    className: cx2({
      group: true
    }, className)
  }, jsx(Heading2, _extends$1({}, headingProps, {
    selectProps,
    theme,
    getStyles,
    cx: cx2
  }), label2), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS2(_ref22) {
  var spacing2 = _ref22.theme.spacing;
  return {
    label: "group",
    color: "#999",
    cursor: "default",
    display: "block",
    fontSize: "75%",
    fontWeight: "500",
    marginBottom: "0.25em",
    paddingLeft: spacing2.baseUnit * 3,
    paddingRight: spacing2.baseUnit * 3,
    textTransform: "uppercase"
  };
};
var GroupHeading = function GroupHeading2(props) {
  var className = props.className, cx2 = props.cx, getStyles = props.getStyles, theme = props.theme;
  props.selectProps;
  var cleanProps = _objectWithoutProperties$1(props, ["className", "cx", "getStyles", "theme", "selectProps"]);
  return jsx("div", _extends$1({
    css: getStyles("groupHeading", _objectSpread$1$1({
      theme
    }, cleanProps)),
    className: cx2({
      "group-heading": true
    }, className)
  }, cleanProps));
};
function ownKeys$2$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$2$1(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2$1(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var inputCSS = function inputCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    margin: spacing2.baseUnit / 2,
    paddingBottom: spacing2.baseUnit / 2,
    paddingTop: spacing2.baseUnit / 2,
    visibility: isDisabled ? "hidden" : "visible",
    color: colors2.neutral80
  };
};
var inputStyle = function inputStyle2(isHidden) {
  return {
    label: "input",
    background: 0,
    border: 0,
    fontSize: "inherit",
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: "inherit"
  };
};
var Input = function Input2(_ref22) {
  var className = _ref22.className, cx2 = _ref22.cx, getStyles = _ref22.getStyles, innerRef = _ref22.innerRef, isHidden = _ref22.isHidden, isDisabled = _ref22.isDisabled, theme = _ref22.theme;
  _ref22.selectProps;
  var props = _objectWithoutProperties$1(_ref22, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);
  return jsx("div", {
    css: getStyles("input", _objectSpread$2$1({
      theme
    }, props))
  }, jsx(_default, _extends$1({
    className: cx2({
      input: true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};
function ownKeys$3$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$3$1(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3$1(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var multiValueCSS = function multiValueCSS2(_ref3) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, borderRadius2 = _ref$theme.borderRadius, colors2 = _ref$theme.colors;
  return {
    label: "multiValue",
    backgroundColor: colors2.neutral10,
    borderRadius: borderRadius2 / 2,
    display: "flex",
    margin: spacing2.baseUnit / 2,
    minWidth: 0
  };
};
var multiValueLabelCSS = function multiValueLabelCSS2(_ref22) {
  var _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, colors2 = _ref2$theme.colors, cropWithEllipsis = _ref22.cropWithEllipsis;
  return {
    borderRadius: borderRadius2 / 2,
    color: colors2.neutral80,
    fontSize: "85%",
    overflow: "hidden",
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? "ellipsis" : null,
    whiteSpace: "nowrap"
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS2(_ref3) {
  var _ref3$theme = _ref3.theme, spacing2 = _ref3$theme.spacing, borderRadius2 = _ref3$theme.borderRadius, colors2 = _ref3$theme.colors, isFocused = _ref3.isFocused;
  return {
    alignItems: "center",
    borderRadius: borderRadius2 / 2,
    backgroundColor: isFocused && colors2.dangerLight,
    display: "flex",
    paddingLeft: spacing2.baseUnit,
    paddingRight: spacing2.baseUnit,
    ":hover": {
      backgroundColor: colors2.dangerLight,
      color: colors2.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric2(_ref4) {
  var children = _ref4.children, innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children, innerProps = _ref5.innerProps;
  return jsx("div", innerProps, children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue2(props) {
  var children = props.children, className = props.className, components2 = props.components, cx2 = props.cx, data = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
  var Container2 = components2.Container, Label2 = components2.Label, Remove = components2.Remove;
  return jsx(ClassNames, null, function(_ref6) {
    var css4 = _ref6.css, emotionCx = _ref6.cx;
    return jsx(Container2, {
      data,
      innerProps: _objectSpread$3$1(_objectSpread$3$1({}, innerProps), {}, {
        className: emotionCx(css4(getStyles("multiValue", props)), cx2({
          "multi-value": true,
          "multi-value--is-disabled": isDisabled
        }, className))
      }),
      selectProps
    }, jsx(Label2, {
      data,
      innerProps: {
        className: emotionCx(css4(getStyles("multiValueLabel", props)), cx2({
          "multi-value__label": true
        }, className))
      },
      selectProps
    }, children), jsx(Remove, {
      data,
      innerProps: _objectSpread$3$1({
        className: emotionCx(css4(getStyles("multiValueRemove", props)), cx2({
          "multi-value__remove": true
        }, className))
      }, removeProps),
      selectProps
    }));
  });
};
MultiValue.defaultProps = {
  cropWithEllipsis: true
};
var optionCSS = function optionCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, isSelected = _ref3.isSelected, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "option",
    backgroundColor: isSelected ? colors2.primary : isFocused ? colors2.primary25 : "transparent",
    color: isDisabled ? colors2.neutral20 : isSelected ? colors2.neutral0 : "inherit",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    padding: "".concat(spacing2.baseUnit * 2, "px ").concat(spacing2.baseUnit * 3, "px"),
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    ":active": {
      backgroundColor: !isDisabled && (isSelected ? colors2.primary : colors2.primary50)
    }
  };
};
var Option$1 = function Option(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles("option", props),
    className: cx2({
      option: true,
      "option--is-disabled": isDisabled,
      "option--is-focused": isFocused,
      "option--is-selected": isSelected
    }, className),
    ref: innerRef
  }, innerProps), children);
};
var placeholderCSS = function placeholderCSS2(_ref3) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "placeholder",
    color: colors2.neutral50,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)"
  };
};
var Placeholder = function Placeholder2(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles("placeholder", props),
    className: cx2({
      placeholder: true
    }, className)
  }, innerProps), children);
};
var css$1 = function css3(_ref3) {
  var isDisabled = _ref3.isDisabled, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "singleValue",
    color: isDisabled ? colors2.neutral40 : colors2.neutral80,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing2.baseUnit * 2, "px)"),
    overflow: "hidden",
    position: "absolute",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    top: "50%",
    transform: "translateY(-50%)"
  };
};
var SingleValue = function SingleValue2(props) {
  var children = props.children, className = props.className, cx2 = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles("singleValue", props),
    className: cx2({
      "single-value": true,
      "single-value--is-disabled": isDisabled
    }, className)
  }, innerProps), children);
};
function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var components = {
  ClearIndicator,
  Control: Control$1,
  DropdownIndicator: DropdownIndicator$1,
  DownChevron,
  CrossIcon,
  Group,
  GroupHeading,
  IndicatorsContainer,
  IndicatorSeparator,
  Input,
  LoadingIndicator,
  Menu,
  MenuList: MenuList$1,
  MenuPortal,
  LoadingMessage,
  NoOptionsMessage,
  MultiValue,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  Option: Option$1,
  Placeholder,
  SelectContainer,
  SingleValue,
  ValueContainer
};
var defaultComponents = function defaultComponents2(props) {
  return _objectSpread$4(_objectSpread$4({}, components), props.components);
};
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var diacritics = [{
  base: "A",
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: "AA",
  letters: "\uA732"
}, {
  base: "AE",
  letters: "\xC6\u01FC\u01E2"
}, {
  base: "AO",
  letters: "\uA734"
}, {
  base: "AU",
  letters: "\uA736"
}, {
  base: "AV",
  letters: "\uA738\uA73A"
}, {
  base: "AY",
  letters: "\uA73C"
}, {
  base: "B",
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: "C",
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: "D",
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: "DZ",
  letters: "\u01F1\u01C4"
}, {
  base: "Dz",
  letters: "\u01F2\u01C5"
}, {
  base: "E",
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: "F",
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: "G",
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: "H",
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: "I",
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: "J",
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: "K",
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: "L",
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: "LJ",
  letters: "\u01C7"
}, {
  base: "Lj",
  letters: "\u01C8"
}, {
  base: "M",
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: "N",
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: "NJ",
  letters: "\u01CA"
}, {
  base: "Nj",
  letters: "\u01CB"
}, {
  base: "O",
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: "OI",
  letters: "\u01A2"
}, {
  base: "OO",
  letters: "\uA74E"
}, {
  base: "OU",
  letters: "\u0222"
}, {
  base: "P",
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: "Q",
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: "R",
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: "S",
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: "T",
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: "TZ",
  letters: "\uA728"
}, {
  base: "U",
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: "V",
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: "VY",
  letters: "\uA760"
}, {
  base: "W",
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: "X",
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: "Y",
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: "Z",
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: "a",
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: "aa",
  letters: "\uA733"
}, {
  base: "ae",
  letters: "\xE6\u01FD\u01E3"
}, {
  base: "ao",
  letters: "\uA735"
}, {
  base: "au",
  letters: "\uA737"
}, {
  base: "av",
  letters: "\uA739\uA73B"
}, {
  base: "ay",
  letters: "\uA73D"
}, {
  base: "b",
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: "c",
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: "d",
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: "dz",
  letters: "\u01F3\u01C6"
}, {
  base: "e",
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: "f",
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: "g",
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: "h",
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: "hv",
  letters: "\u0195"
}, {
  base: "i",
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: "j",
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: "k",
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: "l",
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: "lj",
  letters: "\u01C9"
}, {
  base: "m",
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: "n",
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: "nj",
  letters: "\u01CC"
}, {
  base: "o",
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: "oi",
  letters: "\u01A3"
}, {
  base: "ou",
  letters: "\u0223"
}, {
  base: "oo",
  letters: "\uA74F"
}, {
  base: "p",
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: "q",
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: "r",
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: "s",
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: "t",
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: "tz",
  letters: "\uA729"
}, {
  base: "u",
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: "v",
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: "vy",
  letters: "\uA761"
}, {
  base: "w",
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: "x",
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: "y",
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: "z",
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp("[" + diacritics.map(function(d) {
  return d.letters;
}).join("") + "]", "g");
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics2(str) {
  return str.replace(anyDiacritic, function(match) {
    return diacriticToBase[match];
  });
};
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var trimString = function trimString2(str) {
  return str.replace(/^\s+|\s+$/g, "");
};
var defaultStringify = function defaultStringify2(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter2(config) {
  return function(option, rawInput) {
    var _ignoreCase$ignoreAcc = _objectSpread$1({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: "any"
    }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify3 = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input2 = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify3(option)) : stringify3(option);
    if (ignoreCase) {
      input2 = input2.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input2 = stripDiacritics(input2);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === "start" ? candidate.substr(0, input2.length) === input2 : candidate.indexOf(input2) > -1;
  };
};
var _ref = {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
};
var A11yText = function A11yText2(props) {
  return jsx("span", _extends$1({
    css: _ref
  }, props));
};
function DummyInput(_ref3) {
  _ref3.in;
  _ref3.out;
  _ref3.onExited;
  _ref3.appear;
  _ref3.enter;
  _ref3.exit;
  var innerRef = _ref3.innerRef;
  _ref3.emotion;
  var props = _objectWithoutProperties$1(_ref3, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
  return jsx("input", _extends$1({
    ref: innerRef
  }, props, {
    css: /* @__PURE__ */ css$2({
      label: "dummyInput",
      background: 0,
      border: 0,
      fontSize: "inherit",
      outline: 0,
      padding: 0,
      width: 1,
      color: "transparent",
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(0)"
    }, "")
  }));
}
function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var NodeResolver = /* @__PURE__ */ function(_Component) {
  _inherits$1(NodeResolver2, _Component);
  var _super = _createSuper$2(NodeResolver2);
  function NodeResolver2() {
    _classCallCheck$1(this, NodeResolver2);
    return _super.apply(this, arguments);
  }
  _createClass$1(NodeResolver2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.innerRef(findDOMNode(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function render3() {
      return this.props.children;
    }
  }]);
  return NodeResolver2;
}(Component);
var STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"];
var LOCK_STYLES = {
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top2 = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top2 + this.offsetHeight;
  if (top2 === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top2 - 1;
  }
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
function _createSuper$1$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _isNativeReflectConstruct$1$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var canUseDOM = !!(window.document && window.document.createElement);
var activeScrollLocks = 0;
var ScrollLock = /* @__PURE__ */ function(_Component) {
  _inherits$1(ScrollLock2, _Component);
  var _super = _createSuper$1$1(ScrollLock2);
  function ScrollLock2() {
    var _this;
    _classCallCheck$1(this, ScrollLock2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.originalStyles = {};
    _this.listenerOptions = {
      capture: false,
      passive: false
    };
    return _this;
  }
  _createClass$1(ScrollLock2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!canUseDOM)
        return;
      var _this$props = this.props, accountForScrollbars = _this$props.accountForScrollbars, touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;
      if (accountForScrollbars) {
        STYLE_KEYS.forEach(function(key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      }
      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function(key) {
          var val = LOCK_STYLES[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      }
      if (target && isTouchDevice()) {
        target.addEventListener("touchmove", preventTouchMove, this.listenerOptions);
        if (touchScrollTarget) {
          touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener("touchmove", allowTouchMove, this.listenerOptions);
        }
      }
      activeScrollLocks += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;
      if (!canUseDOM)
        return;
      var _this$props2 = this.props, accountForScrollbars = _this$props2.accountForScrollbars, touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;
      activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function(key) {
          var val = _this3.originalStyles[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      }
      if (target && isTouchDevice()) {
        target.removeEventListener("touchmove", preventTouchMove, this.listenerOptions);
        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener("touchmove", allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: "render",
    value: function render3() {
      return null;
    }
  }]);
  return ScrollLock2;
}(Component);
ScrollLock.defaultProps = {
  accountForScrollbars: true
};
function _createSuper$2$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _isNativeReflectConstruct$2$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var _ref$1 = {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
};
var ScrollBlock = /* @__PURE__ */ function(_PureComponent) {
  _inherits$1(ScrollBlock2, _PureComponent);
  var _super = _createSuper$2$1(ScrollBlock2);
  function ScrollBlock2() {
    var _this;
    _classCallCheck$1(this, ScrollBlock2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      touchScrollTarget: null
    };
    _this.getScrollTarget = function(ref) {
      if (ref === _this.state.touchScrollTarget)
        return;
      _this.setState({
        touchScrollTarget: ref
      });
    };
    _this.blurSelectInput = function() {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    };
    return _this;
  }
  _createClass$1(ScrollBlock2, [{
    key: "render",
    value: function render3() {
      var _this$props = this.props, children = _this$props.children, isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget;
      if (!isEnabled)
        return children;
      return jsx("div", null, jsx("div", {
        onClick: this.blurSelectInput,
        css: _ref$1
      }), jsx(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? jsx(ScrollLock, {
        touchScrollTarget
      }) : null);
    }
  }]);
  return ScrollBlock2;
}(PureComponent);
function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var ScrollCaptor = /* @__PURE__ */ function(_Component) {
  _inherits$1(ScrollCaptor2, _Component);
  var _super = _createSuper$3(ScrollCaptor2);
  function ScrollCaptor2() {
    var _this;
    _classCallCheck$1(this, ScrollCaptor2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.isBottom = false;
    _this.isTop = false;
    _this.scrollTarget = void 0;
    _this.touchStart = void 0;
    _this.cancelScroll = function(event) {
      event.preventDefault();
      event.stopPropagation();
    };
    _this.handleEventDelta = function(event, delta) {
      var _this$props = _this.props, onBottomArrive = _this$props.onBottomArrive, onBottomLeave = _this$props.onBottomLeave, onTopArrive = _this$props.onTopArrive, onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget, scrollTop = _this$scrollTarget.scrollTop, scrollHeight = _this$scrollTarget.scrollHeight, clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false;
      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave)
          onBottomLeave(event);
        _this.isBottom = false;
      }
      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave)
          onTopLeave(event);
        _this.isTop = false;
      }
      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }
        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true;
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }
        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      }
      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    };
    _this.onWheel = function(event) {
      _this.handleEventDelta(event, event.deltaY);
    };
    _this.onTouchStart = function(event) {
      _this.touchStart = event.changedTouches[0].clientY;
    };
    _this.onTouchMove = function(event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
      _this.handleEventDelta(event, deltaY);
    };
    _this.getScrollTarget = function(ref) {
      _this.scrollTarget = ref;
    };
    return _this;
  }
  _createClass$1(ScrollCaptor2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function startListening(el) {
      if (!el)
        return;
      if (typeof el.addEventListener === "function") {
        el.addEventListener("wheel", this.onWheel, false);
      }
      if (typeof el.addEventListener === "function") {
        el.addEventListener("touchstart", this.onTouchStart, false);
      }
      if (typeof el.addEventListener === "function") {
        el.addEventListener("touchmove", this.onTouchMove, false);
      }
    }
  }, {
    key: "stopListening",
    value: function stopListening(el) {
      if (!el)
        return;
      if (typeof el.removeEventListener === "function") {
        el.removeEventListener("wheel", this.onWheel, false);
      }
      if (typeof el.removeEventListener === "function") {
        el.removeEventListener("touchstart", this.onTouchStart, false);
      }
      if (typeof el.removeEventListener === "function") {
        el.removeEventListener("touchmove", this.onTouchMove, false);
      }
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ jsx$1(NodeResolver, {
        innerRef: this.getScrollTarget,
        children: this.props.children
      });
    }
  }]);
  return ScrollCaptor2;
}(Component);
function ScrollCaptorSwitch(_ref3) {
  var _ref$isEnabled = _ref3.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, props = _objectWithoutProperties$1(_ref3, ["isEnabled"]);
  return isEnabled ? /* @__PURE__ */ jsx$1(ScrollCaptor, __spreadValues({}, props)) : props.children;
}
var instructionsAriaMessage = function instructionsAriaMessage2(event) {
  var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var isSearchable = context.isSearchable, isMulti = context.isMulti, label2 = context.label, isDisabled = context.isDisabled, tabSelectsValue = context.tabSelectsValue;
  switch (event) {
    case "menu":
      return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
    case "input":
      return "".concat(label2 ? label2 : "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
    case "value":
      return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
  }
};
var valueEventAriaMessage = function valueEventAriaMessage2(event, context) {
  var value = context.value, isDisabled = context.isDisabled;
  if (!value)
    return;
  switch (event) {
    case "deselect-option":
    case "pop-value":
    case "remove-value":
      return "option ".concat(value, ", deselected.");
    case "select-option":
      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage2(_ref3) {
  var focusedValue = _ref3.focusedValue, getOptionLabel3 = _ref3.getOptionLabel, selectValue = _ref3.selectValue;
  return "value ".concat(getOptionLabel3(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var optionFocusAriaMessage = function optionFocusAriaMessage2(_ref22) {
  var focusedOption = _ref22.focusedOption, getOptionLabel3 = _ref22.getOptionLabel, options = _ref22.options;
  return "option ".concat(getOptionLabel3(focusedOption), " focused").concat(focusedOption.isDisabled ? " disabled" : "", ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var resultsAriaMessage = function resultsAriaMessage2(_ref3) {
  var inputValue = _ref3.inputValue, screenReaderMessage = _ref3.screenReaderMessage;
  return "".concat(screenReaderMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
};
var formatGroupLabel = function formatGroupLabel2(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel2(option) {
  return option.label;
};
var getOptionValue = function getOptionValue2(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled2(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$1,
  valueContainer: valueContainerCSS
};
var colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
var baseUnit = 4;
var controlHeight = 38;
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit,
  controlHeight,
  menuGutter
};
var defaultTheme = {
  borderRadius,
  colors,
  spacing
};
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _createSuper$4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var defaultProps$2 = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel,
  getOptionLabel,
  getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(_ref3) {
    var count2 = _ref3.count;
    return "".concat(count2, " result").concat(count2 !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: "0",
  tabSelectsValue: true
};
var instanceId = 1;
var Select$1 = /* @__PURE__ */ function(_Component) {
  _inherits$1(Select2, _Component);
  var _super = _createSuper$4(Select2);
  function Select2(_props) {
    var _this;
    _classCallCheck$1(this, Select2);
    _this = _super.call(this, _props);
    _this.state = {
      ariaLiveSelection: "",
      ariaLiveContext: "",
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.clearFocusValueOnUpdate = false;
    _this.commonProps = void 0;
    _this.components = void 0;
    _this.hasGroups = false;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.inputIsHiddenAfterUpdate = void 0;
    _this.instancePrefix = "";
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;
    _this.getControlRef = function(ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function(ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function(ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function(ref) {
      _this.inputRef = ref;
    };
    _this.cacheComponents = function(components2) {
      _this.components = defaultComponents({
        components: components2
      });
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function(newValue, actionMeta) {
      var _this$props = _this.props, onChange = _this$props.onChange, name2 = _this$props.name;
      onChange(newValue, _objectSpread$2(_objectSpread$2({}, actionMeta), {}, {
        name: name2
      }));
    };
    _this.setValue = function(newValue) {
      var action2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "set-value";
      var option = arguments.length > 2 ? arguments[2] : void 0;
      var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti;
      _this.onInputChange("", {
        action: "set-value"
      });
      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;
        _this.onMenuClose();
      }
      _this.clearFocusValueOnUpdate = true;
      _this.onChange(newValue, {
        action: action2,
        option
      });
    };
    _this.selectOption = function(newValue) {
      var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti;
      var selectValue = _this.state.selectValue;
      if (isMulti) {
        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);
          _this.setValue(selectValue.filter(function(i) {
            return _this.getOptionValue(i) !== candidate;
          }), "deselect-option", newValue);
          _this.announceAriaLiveSelection({
            event: "deselect-option",
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue([].concat(_toConsumableArray(selectValue), [newValue]), "select-option", newValue);
            _this.announceAriaLiveSelection({
              event: "select-option",
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            _this.announceAriaLiveSelection({
              event: "select-option",
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
      } else {
        if (!_this.isOptionDisabled(newValue, selectValue)) {
          _this.setValue(newValue, "select-option");
          _this.announceAriaLiveSelection({
            event: "select-option",
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          _this.announceAriaLiveSelection({
            event: "select-option",
            context: {
              value: _this.getOptionLabel(newValue),
              isDisabled: true
            }
          });
        }
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function(removedValue) {
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValue = selectValue.filter(function(i) {
        return _this.getOptionValue(i) !== candidate;
      });
      _this.onChange(newValue.length ? newValue : null, {
        action: "remove-value",
        removedValue
      });
      _this.announceAriaLiveSelection({
        event: "remove-value",
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ""
        }
      });
      _this.focusInput();
    };
    _this.clearValue = function() {
      _this.onChange(null, {
        action: "clear"
      });
    };
    _this.popValue = function() {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValue = selectValue.slice(0, selectValue.length - 1);
      _this.announceAriaLiveSelection({
        event: "pop-value",
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ""
        }
      });
      _this.onChange(newValue.length ? newValue : null, {
        action: "pop-value",
        removedValue: lastSelectedValue
      });
    };
    _this.getValue = function() {
      return _this.state.selectValue;
    };
    _this.cx = function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function(data) {
      return _this.props.getOptionLabel(data);
    };
    _this.getOptionValue = function(data) {
      return _this.props.getOptionValue(data);
    };
    _this.getStyles = function(key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = "border-box";
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getElementId = function(element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };
    _this.getActiveDescendentId = function() {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state, menuOptions = _this$state.menuOptions, focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen)
        return void 0;
      var index2 = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index2];
      return option && option.key;
    };
    _this.announceAriaLiveSelection = function(_ref22) {
      var event = _ref22.event, context = _ref22.context;
      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    };
    _this.announceAriaLiveContext = function(_ref3) {
      var event = _ref3.event, context = _ref3.context;
      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, _objectSpread$2(_objectSpread$2({}, context), {}, {
          label: _this.props["aria-label"]
        }))
      });
    };
    _this.onMenuMouseDown = function(event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function(event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function(event) {
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu("first");
        }
      } else {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled)
        return;
      var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;
        _this.onMenuClose();
      } else {
        _this.openMenu("first");
      }
      event.preventDefault();
      event.stopPropagation();
    };
    _this.onClearIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.stopPropagation();
      _this.openAfterFocus = false;
      if (event.type === "touchend") {
        _this.focusInput();
      } else {
        setTimeout(function() {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function(event) {
      if (typeof _this.props.closeMenuOnScroll === "boolean") {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === "function") {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function() {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function() {
      _this.isComposing = false;
    };
    _this.onTouchStart = function(_ref4) {
      var touches = _ref4.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function(_ref5) {
      var touches = _ref5.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function(event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;
      _this.onInputChange(inputValue, {
        action: "input-change"
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function(event) {
      var _this$props5 = _this.props, isSearchable = _this$props5.isSearchable, isMulti = _this$props5.isMulti;
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.inputIsHiddenAfterUpdate = false;
      _this.announceAriaLiveContext({
        event: "input",
        context: {
          isSearchable,
          isMulti
        }
      });
      _this.setState({
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu("first");
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function(event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange("", {
        action: "input-blur"
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function(focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      _this.setState({
        focusedOption
      });
    };
    _this.shouldHideSelectedOptions = function() {
      var _this$props6 = _this.props, hideSelectedOptions = _this$props6.hideSelectedOptions, isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === void 0)
        return isMulti;
      return hideSelectedOptions;
    };
    _this.onKeyDown = function(event) {
      var _this$props7 = _this.props, isMulti = _this$props7.isMulti, backspaceRemovesValue = _this$props7.backspaceRemovesValue, escapeClearsValue = _this$props7.escapeClearsValue, inputValue = _this$props7.inputValue, isClearable = _this$props7.isClearable, isDisabled = _this$props7.isDisabled, menuIsOpen = _this$props7.menuIsOpen, onKeyDown = _this$props7.onKeyDown, tabSelectsValue = _this$props7.tabSelectsValue, openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state, focusedOption = _this$state2.focusedOption, focusedValue = _this$state2.focusedValue, selectValue = _this$state2.selectValue;
      if (isDisabled)
        return;
      if (typeof onKeyDown === "function") {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }
      _this.blockOptionHover = true;
      switch (event.key) {
        case "ArrowLeft":
          if (!isMulti || inputValue)
            return;
          _this.focusValue("previous");
          break;
        case "ArrowRight":
          if (!isMulti || inputValue)
            return;
          _this.focusValue("next");
          break;
        case "Delete":
        case "Backspace":
          if (inputValue)
            return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue)
              return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case "Tab":
          if (_this.isComposing)
            return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case "Enter":
          if (event.keyCode === 229) {
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption)
              return;
            if (_this.isComposing)
              return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case "Escape":
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;
            _this.onInputChange("", {
              action: "menu-close"
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case " ":
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu("first");
            break;
          }
          if (!focusedOption)
            return;
          _this.selectOption(focusedOption);
          break;
        case "ArrowUp":
          if (menuIsOpen) {
            _this.focusOption("up");
          } else {
            _this.openMenu("last");
          }
          break;
        case "ArrowDown":
          if (menuIsOpen) {
            _this.focusOption("down");
          } else {
            _this.openMenu("first");
          }
          break;
        case "PageUp":
          if (!menuIsOpen)
            return;
          _this.focusOption("pageup");
          break;
        case "PageDown":
          if (!menuIsOpen)
            return;
          _this.focusOption("pagedown");
          break;
        case "Home":
          if (!menuIsOpen)
            return;
          _this.focusOption("first");
          break;
        case "End":
          if (!menuIsOpen)
            return;
          _this.focusOption("last");
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.buildMenuOptions = function(props, selectValue) {
      var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue, options = props.options;
      var toOption = function toOption2(option, id2) {
        var isDisabled = _this.isOptionDisabled(option, selectValue);
        var isSelected = _this.isOptionSelected(option, selectValue);
        var label2 = _this.getOptionLabel(option);
        var value = _this.getOptionValue(option);
        if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
          label: label2,
          value,
          data: option
        }, inputValue)) {
          return;
        }
        var onHover = isDisabled ? void 0 : function() {
          return _this.onOptionHover(option);
        };
        var onSelect = isDisabled ? void 0 : function() {
          return _this.selectOption(option);
        };
        var optionId = "".concat(_this.getElementId("option"), "-").concat(id2);
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled,
          isSelected,
          key: optionId,
          label: label2,
          type: "option",
          value
        };
      };
      return options.reduce(function(acc, item2, itemIndex) {
        if (item2.options) {
          if (!_this.hasGroups)
            _this.hasGroups = true;
          var items = item2.options;
          var children = items.map(function(child, i) {
            var option2 = toOption(child, "".concat(itemIndex, "-").concat(i));
            if (option2)
              acc.focusable.push(child);
            return option2;
          }).filter(Boolean);
          if (children.length) {
            var groupId = "".concat(_this.getElementId("group"), "-").concat(itemIndex);
            acc.render.push({
              type: "group",
              key: groupId,
              data: item2,
              options: children
            });
          }
        } else {
          var option = toOption(item2, "".concat(itemIndex));
          if (option) {
            acc.render.push(option);
            acc.focusable.push(item2);
          }
        }
        return acc;
      }, {
        render: [],
        focusable: []
      });
    };
    var _value = _props.value;
    _this.cacheComponents = memoizeOne(_this.cacheComponents, exportedEqual).bind(_assertThisInitialized(_this));
    _this.cacheComponents(_props.components);
    _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
    var _selectValue = cleanValue(_value);
    _this.buildMenuOptions = memoizeOne(_this.buildMenuOptions, function(newArgs, lastArgs) {
      var _ref6 = newArgs, _ref7 = _slicedToArray(_ref6, 2), newProps = _ref7[0], newSelectValue = _ref7[1];
      var _ref8 = lastArgs, _ref9 = _slicedToArray(_ref8, 2), lastProps = _ref9[0], lastSelectValue = _ref9[1];
      return newSelectValue === lastSelectValue && newProps.inputValue === lastProps.inputValue && newProps.options === lastProps.options;
    }).bind(_assertThisInitialized(_this));
    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
      render: [],
      focusable: []
    };
    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }
  _createClass$1(Select2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        document.addEventListener("scroll", this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props, options = _this$props8.options, value = _this$props8.value, menuIsOpen = _this$props8.menuIsOpen, inputValue = _this$props8.inputValue;
      this.cacheComponents(nextProps.components);
      if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
        var selectValue = cleanValue(nextProps.value);
        var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
          render: [],
          focusable: []
        };
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions,
          selectValue,
          focusedOption,
          focusedValue
        });
      }
      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props, isDisabled = _this$props9.isDisabled, menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      }
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener("scroll", this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      var _this$props10 = this.props, isSearchable = _this$props10.isSearchable, isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: "input",
        context: {
          isSearchable,
          isMulti
        }
      });
      this.onInputChange("", {
        action: "menu-close"
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef)
        return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef)
        return;
      this.inputRef.blur();
    }
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state3 = this.state, selectValue = _this$state3.selectValue, isFocused = _this$state3.isFocused;
      var menuOptions = this.buildMenuOptions(this.props, selectValue);
      var _this$props11 = this.props, isMulti = _this$props11.isMulti, tabSelectsValue = _this$props11.tabSelectsValue;
      var openAtIndex = focusOption === "first" ? 0 : menuOptions.focusable.length - 1;
      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.setState({
        menuOptions,
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      }, function() {
        _this2.onMenuOpen();
        _this2.announceAriaLiveContext({
          event: "menu",
          context: {
            tabSelectsValue
          }
        });
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$props12 = this.props, isMulti = _this$props12.isMulti, isSearchable = _this$props12.isSearchable;
      var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue;
      if (!isMulti)
        return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: "value"
        });
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length)
        return;
      switch (direction) {
        case "previous":
          if (focusedIndex === 0) {
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case "next":
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: "input",
          context: {
            isSearchable,
            isMulti
          }
        });
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first";
      var _this$props13 = this.props, pageSize = _this$props13.pageSize, tabSelectsValue = _this$props13.tabSelectsValue;
      var _this$state5 = this.state, focusedOption = _this$state5.focusedOption, menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length)
        return;
      var nextFocus = 0;
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: "menu",
          context: {
            tabSelectsValue
          }
        });
      }
      if (direction === "up") {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === "down") {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === "pageup") {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0)
          nextFocus = 0;
      } else if (direction === "pagedown") {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1)
          nextFocus = options.length - 1;
      } else if (direction === "last") {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
      this.announceAriaLiveContext({
        event: "menu",
        context: {
          isDisabled: isOptionDisabled(options[nextFocus]),
          tabSelectsValue
        }
      });
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      if (!this.props.theme) {
        return defaultTheme;
      }
      if (typeof this.props.theme === "function") {
        return this.props.theme(defaultTheme);
      }
      return _objectSpread$2(_objectSpread$2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue, cx2 = this.cx, getStyles = this.getStyles, getValue = this.getValue, setValue = this.setValue, selectOption = this.selectOption, props = this.props;
      var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
      var hasValue = this.hasValue();
      return {
        cx: cx2,
        clearValue,
        getStyles,
        getValue,
        hasValue,
        isMulti,
        isRtl,
        options,
        selectOption,
        setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }
      var _this$state6 = this.state, focusedValue = _this$state6.focusedValue, lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) {
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          return nextSelectValue[lastFocusedIndex];
        }
      }
      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props14 = this.props, isClearable2 = _this$props14.isClearable, isMulti = _this$props14.isMulti;
      if (isClearable2 === void 0)
        return isMulti;
      return isClearable2;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled3(option, selectValue) {
      return typeof this.props.isOptionDisabled === "function" ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      var _this3 = this;
      if (selectValue.indexOf(option) > -1)
        return true;
      if (typeof this.props.isOptionSelected === "function") {
        return this.props.isOptionSelected(option, selectValue);
      }
      var candidate = this.getOptionValue(option);
      return selectValue.some(function(i) {
        return _this3.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === "function") {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context,
          inputValue,
          selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel3(data) {
      return this.props.formatGroupLabel(data);
    }
  }, {
    key: "startListeningComposition",
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener("compositionstart", this.onCompositionStart, false);
        document.addEventListener("compositionend", this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener("compositionstart", this.onCompositionStart);
        document.removeEventListener("compositionend", this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener("touchstart", this.onTouchStart, false);
        document.addEventListener("touchmove", this.onTouchMove, false);
        document.addEventListener("touchend", this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener("touchstart", this.onTouchStart);
        document.removeEventListener("touchmove", this.onTouchMove);
        document.removeEventListener("touchend", this.onTouchEnd);
      }
    }
  }, {
    key: "constructAriaLiveMessage",
    value: function constructAriaLiveMessage() {
      var _this$state7 = this.state, ariaLiveContext = _this$state7.ariaLiveContext, selectValue = _this$state7.selectValue, focusedValue = _this$state7.focusedValue, focusedOption = _this$state7.focusedOption;
      var _this$props15 = this.props, options = _this$props15.options, menuIsOpen = _this$props15.menuIsOpen, inputValue = _this$props15.inputValue, screenReaderStatus2 = _this$props15.screenReaderStatus;
      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue
      }) : "";
      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption,
        getOptionLabel: this.getOptionLabel,
        options
      }) : "";
      var resultsMsg = resultsAriaMessage({
        inputValue,
        screenReaderMessage: screenReaderStatus2({
          count: this.countOptions()
        })
      });
      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props16 = this.props, isDisabled = _this$props16.isDisabled, isSearchable = _this$props16.isSearchable, inputId = _this$props16.inputId, inputValue = _this$props16.inputValue, tabIndex = _this$props16.tabIndex, form = _this$props16.form;
      var Input3 = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id2 = inputId || this.getElementId("input");
      var ariaAttributes = {
        "aria-autocomplete": "list",
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"]
      };
      if (!isSearchable) {
        return /* @__PURE__ */ jsx$1(DummyInput, __spreadValues({
          id: id2,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex,
          form,
          value: ""
        }, ariaAttributes));
      }
      var _this$commonProps = this.commonProps, cx2 = _this$commonProps.cx, theme = _this$commonProps.theme, selectProps = _this$commonProps.selectProps;
      return /* @__PURE__ */ jsx$1(Input3, __spreadValues({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx2,
        getStyles: this.getStyles,
        id: id2,
        innerRef: this.getInputRef,
        isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps,
        spellCheck: "false",
        tabIndex,
        form,
        theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this4 = this;
      var _this$components = this.components, MultiValue3 = _this$components.MultiValue, MultiValueContainer2 = _this$components.MultiValueContainer, MultiValueLabel2 = _this$components.MultiValueLabel, MultiValueRemove2 = _this$components.MultiValueRemove, SingleValue3 = _this$components.SingleValue, Placeholder3 = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props17 = this.props, controlShouldRenderValue = _this$props17.controlShouldRenderValue, isDisabled = _this$props17.isDisabled, isMulti = _this$props17.isMulti, inputValue = _this$props17.inputValue, placeholder = _this$props17.placeholder;
      var _this$state8 = this.state, selectValue = _this$state8.selectValue, focusedValue = _this$state8.focusedValue, isFocused = _this$state8.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /* @__PURE__ */ createElement(Placeholder3, __spreadProps(__spreadValues({}, commonProps), {
          key: "placeholder",
          isDisabled,
          isFocused
        }), placeholder);
      }
      if (isMulti) {
        var selectValues = selectValue.map(function(opt, index2) {
          var isOptionFocused = opt === focusedValue;
          return /* @__PURE__ */ createElement(MultiValue3, __spreadProps(__spreadValues({}, commonProps), {
            components: {
              Container: MultiValueContainer2,
              Label: MultiValueLabel2,
              Remove: MultiValueRemove2
            },
            isFocused: isOptionFocused,
            isDisabled,
            key: "".concat(_this4.getOptionValue(opt)).concat(index2),
            index: index2,
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, "value"));
        });
        return selectValues;
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /* @__PURE__ */ jsx$1(SingleValue3, __spreadProps(__spreadValues({}, commonProps), {
        data: singleValue,
        isDisabled,
        children: this.formatOptionLabel(singleValue, "value")
      }));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var ClearIndicator3 = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props18 = this.props, isDisabled = _this$props18.isDisabled, isLoading2 = _this$props18.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator3 || isDisabled || !this.hasValue() || isLoading2) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jsx$1(ClearIndicator3, __spreadProps(__spreadValues({}, commonProps), {
        innerProps,
        isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var LoadingIndicator3 = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props19 = this.props, isDisabled = _this$props19.isDisabled, isLoading2 = _this$props19.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator3 || !isLoading2)
        return null;
      var innerProps = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jsx$1(LoadingIndicator3, __spreadProps(__spreadValues({}, commonProps), {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$components2 = this.components, DropdownIndicator3 = _this$components2.DropdownIndicator, IndicatorSeparator3 = _this$components2.IndicatorSeparator;
      if (!DropdownIndicator3 || !IndicatorSeparator3)
        return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /* @__PURE__ */ jsx$1(IndicatorSeparator3, __spreadProps(__spreadValues({}, commonProps), {
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var DropdownIndicator3 = this.components.DropdownIndicator;
      if (!DropdownIndicator3)
        return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jsx$1(DropdownIndicator3, __spreadProps(__spreadValues({}, commonProps), {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this5 = this;
      var _this$components3 = this.components, Group3 = _this$components3.Group, GroupHeading3 = _this$components3.GroupHeading, Menu3 = _this$components3.Menu, MenuList3 = _this$components3.MenuList, MenuPortal2 = _this$components3.MenuPortal, LoadingMessage3 = _this$components3.LoadingMessage, NoOptionsMessage3 = _this$components3.NoOptionsMessage, Option3 = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state, focusedOption = _this$state9.focusedOption, menuOptions = _this$state9.menuOptions;
      var _this$props20 = this.props, captureMenuScroll = _this$props20.captureMenuScroll, inputValue = _this$props20.inputValue, isLoading2 = _this$props20.isLoading, loadingMessage2 = _this$props20.loadingMessage, minMenuHeight = _this$props20.minMenuHeight, maxMenuHeight = _this$props20.maxMenuHeight, menuIsOpen = _this$props20.menuIsOpen, menuPlacement = _this$props20.menuPlacement, menuPosition = _this$props20.menuPosition, menuPortalTarget = _this$props20.menuPortalTarget, menuShouldBlockScroll = _this$props20.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props20.menuShouldScrollIntoView, noOptionsMessage2 = _this$props20.noOptionsMessage, onMenuScrollToTop = _this$props20.onMenuScrollToTop, onMenuScrollToBottom = _this$props20.onMenuScrollToBottom;
      if (!menuIsOpen)
        return null;
      var render3 = function render4(props) {
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : void 0;
        return /* @__PURE__ */ jsx$1(Option3, __spreadProps(__spreadValues(__spreadValues({}, commonProps), props), {
          isFocused,
          children: _this5.formatOptionLabel(props.data, "menu")
        }));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function(item2) {
          if (item2.type === "group") {
            item2.type;
            var group = _objectWithoutProperties$1(item2, ["type"]);
            var headingId = "".concat(item2.key, "-heading");
            return /* @__PURE__ */ jsx$1(Group3, __spreadProps(__spreadValues(__spreadValues({}, commonProps), group), {
              Heading: GroupHeading3,
              headingProps: {
                id: headingId,
                data: item2.data
              },
              label: _this5.formatGroupLabel(item2.data),
              children: item2.options.map(function(option) {
                return render3(option);
              })
            }));
          } else if (item2.type === "option") {
            return render3(item2);
          }
        });
      } else if (isLoading2) {
        var message = loadingMessage2({
          inputValue
        });
        if (message === null)
          return null;
        menuUI = /* @__PURE__ */ jsx$1(LoadingMessage3, __spreadProps(__spreadValues({}, commonProps), {
          children: message
        }));
      } else {
        var _message = noOptionsMessage2({
          inputValue
        });
        if (_message === null)
          return null;
        menuUI = /* @__PURE__ */ jsx$1(NoOptionsMessage3, __spreadProps(__spreadValues({}, commonProps), {
          children: _message
        }));
      }
      var menuPlacementProps = {
        minMenuHeight,
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView
      };
      var menuElement = /* @__PURE__ */ jsx$1(MenuPlacer, __spreadProps(__spreadValues(__spreadValues({}, commonProps), menuPlacementProps), {
        children: function(_ref10) {
          var ref = _ref10.ref, _ref10$placerProps = _ref10.placerProps, placement = _ref10$placerProps.placement, maxHeight = _ref10$placerProps.maxHeight;
          return /* @__PURE__ */ jsx$1(Menu3, __spreadProps(__spreadValues(__spreadValues({}, commonProps), menuPlacementProps), {
            innerRef: ref,
            innerProps: {
              onMouseDown: _this5.onMenuMouseDown,
              onMouseMove: _this5.onMenuMouseMove
            },
            isLoading: isLoading2,
            placement,
            children: /* @__PURE__ */ jsx$1(ScrollCaptorSwitch, {
              isEnabled: captureMenuScroll,
              onTopArrive: onMenuScrollToTop,
              onBottomArrive: onMenuScrollToBottom,
              children: /* @__PURE__ */ jsx$1(ScrollBlock, {
                isEnabled: menuShouldBlockScroll,
                children: /* @__PURE__ */ jsx$1(MenuList3, __spreadProps(__spreadValues({}, commonProps), {
                  innerRef: _this5.getMenuListRef,
                  isLoading: isLoading2,
                  maxHeight,
                  children: menuUI
                }))
              })
            })
          }));
        }
      }));
      return menuPortalTarget || menuPosition === "fixed" ? /* @__PURE__ */ jsx$1(MenuPortal2, __spreadProps(__spreadValues({}, commonProps), {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement,
        menuPosition,
        children: menuElement
      })) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this6 = this;
      var _this$props21 = this.props, delimiter2 = _this$props21.delimiter, isDisabled = _this$props21.isDisabled, isMulti = _this$props21.isMulti, name2 = _this$props21.name;
      var selectValue = this.state.selectValue;
      if (!name2 || isDisabled)
        return;
      if (isMulti) {
        if (delimiter2) {
          var value = selectValue.map(function(opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter2);
          return /* @__PURE__ */ jsx$1("input", {
            name: name2,
            type: "hidden",
            value
          });
        } else {
          var input2 = selectValue.length > 0 ? selectValue.map(function(opt, i) {
            return /* @__PURE__ */ jsx$1("input", {
              name: name2,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            }, "i-".concat(i));
          }) : /* @__PURE__ */ jsx$1("input", {
            name: name2,
            type: "hidden"
          });
          return /* @__PURE__ */ jsx$1("div", {
            children: input2
          });
        }
      } else {
        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
        return /* @__PURE__ */ jsx$1("input", {
          name: name2,
          type: "hidden",
          value: _value2
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      if (!this.state.isFocused)
        return null;
      return /* @__PURE__ */ jsxs(A11yText, {
        "aria-live": "polite",
        children: [/* @__PURE__ */ jsxs("span", {
          id: "aria-selection-event",
          children: ["\xA0", this.state.ariaLiveSelection]
        }), /* @__PURE__ */ jsxs("span", {
          id: "aria-context",
          children: ["\xA0", this.constructAriaLiveMessage()]
        })]
      });
    }
  }, {
    key: "render",
    value: function render3() {
      var _this$components4 = this.components, Control3 = _this$components4.Control, IndicatorsContainer3 = _this$components4.IndicatorsContainer, SelectContainer3 = _this$components4.SelectContainer, ValueContainer3 = _this$components4.ValueContainer;
      var _this$props22 = this.props, className = _this$props22.className, id2 = _this$props22.id, isDisabled = _this$props22.isDisabled, menuIsOpen = _this$props22.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ jsxs(SelectContainer3, __spreadProps(__spreadValues({}, commonProps), {
        className,
        innerProps: {
          id: id2,
          onKeyDown: this.onKeyDown
        },
        isDisabled,
        isFocused,
        children: [this.renderLiveRegion(), /* @__PURE__ */ jsxs(Control3, __spreadProps(__spreadValues({}, commonProps), {
          innerRef: this.getControlRef,
          innerProps: {
            onMouseDown: this.onControlMouseDown,
            onTouchEnd: this.onControlTouchEnd
          },
          isDisabled,
          isFocused,
          menuIsOpen,
          children: [/* @__PURE__ */ jsxs(ValueContainer3, __spreadProps(__spreadValues({}, commonProps), {
            isDisabled,
            children: [this.renderPlaceholderOrValue(), this.renderInput()]
          })), /* @__PURE__ */ jsxs(IndicatorsContainer3, __spreadProps(__spreadValues({}, commonProps), {
            isDisabled,
            children: [this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator()]
          }))]
        })), this.renderMenu(), this.renderFormField()]
      }));
    }
  }]);
  return Select2;
}(Component);
Select$1.defaultProps = defaultProps$2;
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var defaultProps$1 = {
  defaultInputValue: "",
  defaultMenuIsOpen: false,
  defaultValue: null
};
var manageState = function manageState2(SelectComponent) {
  var _class, _temp;
  return _temp = _class = /* @__PURE__ */ function(_Component) {
    _inherits$1(StateManager, _Component);
    var _super = _createSuper$1(StateManager);
    function StateManager() {
      var _this;
      _classCallCheck$1(this, StateManager);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.select = void 0;
      _this.state = {
        inputValue: _this.props.inputValue !== void 0 ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== void 0 ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== void 0 ? _this.props.value : _this.props.defaultValue
      };
      _this.onChange = function(value, actionMeta) {
        _this.callProp("onChange", value, actionMeta);
        _this.setState({
          value
        });
      };
      _this.onInputChange = function(value, actionMeta) {
        var newValue = _this.callProp("onInputChange", value, actionMeta);
        _this.setState({
          inputValue: newValue !== void 0 ? newValue : value
        });
      };
      _this.onMenuOpen = function() {
        _this.callProp("onMenuOpen");
        _this.setState({
          menuIsOpen: true
        });
      };
      _this.onMenuClose = function() {
        _this.callProp("onMenuClose");
        _this.setState({
          menuIsOpen: false
        });
      };
      return _this;
    }
    _createClass$1(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== void 0 ? this.props[key] : this.state[key];
      }
    }, {
      key: "callProp",
      value: function callProp(name2) {
        if (typeof this.props[name2] === "function") {
          var _this$props;
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          return (_this$props = this.props)[name2].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render3() {
        var _this2 = this;
        var _this$props2 = this.props;
        _this$props2.defaultInputValue;
        _this$props2.defaultMenuIsOpen;
        _this$props2.defaultValue;
        var props = _objectWithoutProperties$1(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);
        return /* @__PURE__ */ jsx$1(SelectComponent, __spreadProps(__spreadValues({}, props), {
          ref: function ref(_ref3) {
            _this2.select = _ref3;
          },
          inputValue: this.getProp("inputValue"),
          menuIsOpen: this.getProp("menuIsOpen"),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp("value")
        }));
      }
    }]);
    return StateManager;
  }(Component), _class.defaultProps = defaultProps$1, _temp;
};
var index = manageState(Select$1);
var ReactSelect = index;
const icon$e = "epic__icon__884";
const ripple$e = "epic__ripple__e56";
const input$2 = "epic__input__b7f";
const component$1 = "epic__component__129";
const button$1 = "epic__button__ffa";
const clearButton$1 = "epic__clearButton__ef9";
const closeHidden$1 = "epic__closeHidden__104";
const buttonRight$1 = "epic__buttonRight__920";
const inputRight$1 = "epic__inputRight__983";
const withHorizontalMargin$1 = "epic__withHorizontalMargin__021";
var stylesDefault = {
  icon: icon$e,
  "epic-icon": "epic__epic-icon__4b6",
  "epic-icon-add": "epic__epic-icon-add__745",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__891",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__878",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__6ed",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__83e",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__514",
  "epic-icon-calendar": "epic__epic-icon-calendar__bcb",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__9c0",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__ed7",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__bf4",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__ace",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__8b9",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__9ce",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__937",
  "epic-icon-close-x": "epic__epic-icon-close-x__ac9",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__4c1",
  "epic-icon-confluence": "epic__epic-icon-confluence__64d",
  "epic-icon-contact": "epic__epic-icon-contact__948",
  "epic-icon-delete": "epic__epic-icon-delete__273",
  "epic-icon-edit": "epic__epic-icon-edit__054",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__2e3",
  "epic-icon-filter": "epic__epic-icon-filter__643",
  "epic-icon-github": "epic__epic-icon-github__9fa",
  "epic-icon-information": "epic__epic-icon-information__e75",
  "epic-icon-jira": "epic__epic-icon-jira__02b",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__079",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__eb7",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__9bd",
  "epic-icon-preview": "epic__epic-icon-preview__50e",
  "epic-icon-profile": "epic__epic-icon-profile__45a",
  "epic-icon-quotes": "epic__epic-icon-quotes__c19",
  "epic-icon-search": "epic__epic-icon-search__83b",
  "epic-icon-share": "epic__epic-icon-share__881",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__216",
  "epic-icon-slack": "epic__epic-icon-slack__ce7",
  "epic-icon-steps": "epic__epic-icon-steps__5c4",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__d07",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__14f",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__f33",
  "epic-icon-warning": "epic__epic-icon-warning__da6",
  "epic-font-base": "epic__epic-font-base__39e",
  "epic-font-base-md": "epic__epic-font-base-md__f61",
  "epic-font-marketing": "epic__epic-font-marketing__78f",
  "epic-font-brand": "epic__epic-font-brand__f85",
  ripple: ripple$e,
  "epic-display-base": "epic__epic-display-base__202",
  "epic-display-1": "epic__epic-display-1__2b8",
  "epic-display-2": "epic__epic-display-2__137",
  "epic-display-3": "epic__epic-display-3__89c",
  "epic-display-4": "epic__epic-display-4__a6b",
  "epic-display-5": "epic__epic-display-5__932",
  "epic-title-base": "epic__epic-title-base__e40",
  "epic-title-1": "epic__epic-title-1__ac0",
  "epic-title-2": "epic__epic-title-2__5bc",
  "epic-title-3": "epic__epic-title-3__191",
  "epic-title-4": "epic__epic-title-4__3dd",
  "epic-title-5": "epic__epic-title-5__979",
  "epic-title-6": "epic__epic-title-6__acd",
  "epic-subtitle-base": "epic__epic-subtitle-base__7a1",
  "epic-subtitle-1": "epic__epic-subtitle-1__442",
  "epic-subtitle-2": "epic__epic-subtitle-2__7da",
  "epic-subtitle-3": "epic__epic-subtitle-3__3df",
  "default": "epic__default__281",
  input: input$2,
  "epic-body-text-base": "epic__epic-body-text-base__921",
  "epic-body-text-1": "epic__epic-body-text-1__1a1",
  "epic-body-text-2": "epic__epic-body-text-2__b2f",
  "epic-body-text": "epic__epic-body-text__6b0",
  "epic-body-text-3": "epic__epic-body-text-3__d50",
  "epic-legal-text": "epic__epic-legal-text__139",
  "epic-label-text": "epic__epic-label-text__959",
  "epic-button-base": "epic__epic-button-base__ddf",
  "epic-button-1": "epic__epic-button-1__1a0",
  "epic-button-2": "epic__epic-button-2__427",
  "epic-button-3": "epic__epic-button-3__8ef",
  component: component$1,
  button: button$1,
  clearButton: clearButton$1,
  closeHidden: closeHidden$1,
  buttonRight: buttonRight$1,
  inputRight: inputRight$1,
  withHorizontalMargin: withHorizontalMargin$1
};
const icon$d = "epic__icon__28e";
const ripple$d = "epic__ripple__3ed";
const input$1 = "epic__input__0ac";
const component = "epic__component__d22";
const button = "epic__button__583";
const clearButton = "epic__clearButton__a9f";
const closeHidden = "epic__closeHidden__4af";
const buttonRight = "epic__buttonRight__1ce";
const inputRight = "epic__inputRight__42e";
const withHorizontalMargin = "epic__withHorizontalMargin__10a";
const inverted = "epic__inverted__f45";
const dropdownOpen = "epic__dropdownOpen__e5c";
const withSelect = "epic__withSelect__af0";
const buttonLeft = "epic__buttonLeft__6d1";
const inputLeft = "epic__inputLeft__fe2";
const large = "epic__large__849";
const select = "epic__select__9d5";
const withBorder = "epic__withBorder__11b";
const hasErrors$1 = "epic__hasErrors__cd0";
const selected$1 = "epic__selected__861";
const dropdownList = "epic__dropdownList__e48";
var stylesInverse = {
  icon: icon$d,
  "epic-icon": "epic__epic-icon__190",
  "epic-icon-add": "epic__epic-icon-add__ddb",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__3e6",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__285",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__6d5",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__5b1",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__1a2",
  "epic-icon-calendar": "epic__epic-icon-calendar__633",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__9ab",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__5e5",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__cad",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__091",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__f50",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__540",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__3fc",
  "epic-icon-close-x": "epic__epic-icon-close-x__45c",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__cff",
  "epic-icon-confluence": "epic__epic-icon-confluence__8fa",
  "epic-icon-contact": "epic__epic-icon-contact__1b8",
  "epic-icon-delete": "epic__epic-icon-delete__2f7",
  "epic-icon-edit": "epic__epic-icon-edit__4f0",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__354",
  "epic-icon-filter": "epic__epic-icon-filter__a8b",
  "epic-icon-github": "epic__epic-icon-github__b00",
  "epic-icon-information": "epic__epic-icon-information__69f",
  "epic-icon-jira": "epic__epic-icon-jira__847",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__ba1",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__961",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__ead",
  "epic-icon-preview": "epic__epic-icon-preview__257",
  "epic-icon-profile": "epic__epic-icon-profile__325",
  "epic-icon-quotes": "epic__epic-icon-quotes__442",
  "epic-icon-search": "epic__epic-icon-search__0ef",
  "epic-icon-share": "epic__epic-icon-share__843",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__5fe",
  "epic-icon-slack": "epic__epic-icon-slack__fbd",
  "epic-icon-steps": "epic__epic-icon-steps__e35",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__16b",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__ee8",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__702",
  "epic-icon-warning": "epic__epic-icon-warning__0d6",
  "epic-font-base": "epic__epic-font-base__648",
  "epic-font-base-md": "epic__epic-font-base-md__eb7",
  "epic-font-marketing": "epic__epic-font-marketing__ace",
  "epic-font-brand": "epic__epic-font-brand__04c",
  ripple: ripple$d,
  "epic-display-base": "epic__epic-display-base__a9d",
  "epic-display-1": "epic__epic-display-1__533",
  "epic-display-2": "epic__epic-display-2__f96",
  "epic-display-3": "epic__epic-display-3__77b",
  "epic-display-4": "epic__epic-display-4__c56",
  "epic-display-5": "epic__epic-display-5__88e",
  "epic-title-base": "epic__epic-title-base__43b",
  "epic-title-1": "epic__epic-title-1__fe2",
  "epic-title-2": "epic__epic-title-2__1d3",
  "epic-title-3": "epic__epic-title-3__9ef",
  "epic-title-4": "epic__epic-title-4__037",
  "epic-title-5": "epic__epic-title-5__7e3",
  "epic-title-6": "epic__epic-title-6__db5",
  "epic-subtitle-base": "epic__epic-subtitle-base__bbc",
  "epic-subtitle-1": "epic__epic-subtitle-1__d27",
  "epic-subtitle-2": "epic__epic-subtitle-2__b82",
  "epic-subtitle-3": "epic__epic-subtitle-3__452",
  "default": "epic__default__e97",
  input: input$1,
  "epic-body-text-base": "epic__epic-body-text-base__450",
  "epic-body-text-1": "epic__epic-body-text-1__cf2",
  "epic-body-text-2": "epic__epic-body-text-2__2b3",
  "epic-body-text": "epic__epic-body-text__699",
  "epic-body-text-3": "epic__epic-body-text-3__6df",
  "epic-legal-text": "epic__epic-legal-text__1c3",
  "epic-label-text": "epic__epic-label-text__7aa",
  "epic-button-base": "epic__epic-button-base__16a",
  "epic-button-1": "epic__epic-button-1__a21",
  "epic-button-2": "epic__epic-button-2__fc6",
  "epic-button-3": "epic__epic-button-3__14b",
  component,
  button,
  clearButton,
  closeHidden,
  buttonRight,
  inputRight,
  withHorizontalMargin,
  inverted,
  dropdownOpen,
  withSelect,
  buttonLeft,
  inputLeft,
  large,
  select,
  withBorder,
  hasErrors: hasErrors$1,
  selected: selected$1,
  dropdownList
};
const styles$d = __spreadValues(__spreadValues({}, stylesDefault), stylesInverse);
const ActionInput = forwardRef(function ActionInput2(_w, ref) {
  var _x = _w, {
    className,
    type,
    inverse: inverse2,
    onAction,
    large: large2,
    rightButton,
    ariaLabel,
    icon: icon2,
    iconSize,
    isPending,
    selectProps,
    value,
    onClear,
    dropdownItems,
    onListItemClick,
    dropdownIsOpen,
    renderListItem,
    spinnerColor,
    submitOnEnter
  } = _x, other = __objRest(_x, [
    "className",
    "type",
    "inverse",
    "onAction",
    "large",
    "rightButton",
    "ariaLabel",
    "icon",
    "iconSize",
    "isPending",
    "selectProps",
    "value",
    "onClear",
    "dropdownItems",
    "onListItemClick",
    "dropdownIsOpen",
    "renderListItem",
    "spinnerColor",
    "submitOnEnter"
  ]);
  const componentClassName = classnames$1(className, styles$d.component, inverse2 || selectProps || dropdownItems.length ? styles$d.inverted : styles$d.default, {
    [styles$d.large]: large2,
    [styles$d.dropdownOpen]: dropdownIsOpen
  });
  const buttonClassName = classnames$1(styles$d.button, rightButton ? styles$d.buttonRight : styles$d.buttonLeft);
  const IconButtonClassName = classnames$1(styles$d.clearButton, styles$d.button, {
    [styles$d.closeHidden]: !value,
    [styles$d.buttonRight]: !rightButton
  });
  const iconClassName = `${large2 ? styles$d.largeIcon : ""}`;
  const inputClassName = classnames$1(styles$d.input, {
    [styles$d.inputRight]: rightButton,
    [styles$d.inputLeft]: !rightButton,
    [styles$d.withSelect]: selectProps,
    [styles$d.dropdownOpen]: dropdownIsOpen
  });
  function onResultClick(result, i) {
    if (typeof onResultClick === "function") {
      onListItemClick(result, i);
    }
  }
  function fireOnAction(e) {
    if (typeof onAction === "function") {
      onAction(e);
    }
  }
  function handleKeypress({
    key
  }) {
    if (key === "Enter" && submitOnEnter) {
      onAction == null ? void 0 : onAction();
    }
  }
  function renderDefaultListItem(result, i) {
    return dropdownItems.length === 0 ? /* @__PURE__ */ jsx$1("li", {
      children: "No results"
    }) : /* @__PURE__ */ jsx$1("li", {
      onClick: () => onResultClick(result, i),
      children: result
    }, result);
  }
  return /* @__PURE__ */ jsxs("div", {
    className: componentClassName,
    children: [/* @__PURE__ */ jsx$1("input", __spreadProps(__spreadValues({}, other), {
      value,
      className: inputClassName,
      "aria-label": `${ariaLabel} field`,
      type: "text",
      ref,
      onKeyPress: handleKeypress
    })), onClear && /* @__PURE__ */ jsx$1(IconButton, {
      iconSize: "m",
      bare: true,
      onClick: onClear,
      type: "Close",
      buttonClassName: IconButtonClassName
    }), /* @__PURE__ */ jsx$1("button", {
      "aria-label": `${ariaLabel} action`,
      type,
      className: buttonClassName,
      onClick: fireOnAction,
      children: isPending ? /* @__PURE__ */ jsx$1(Spinner, {
        color: spinnerColor,
        className: styles$d.withHorizontalMargin
      }) : /* @__PURE__ */ jsx$1(Icon, {
        type: icon2,
        size: iconSize,
        className: iconClassName
      })
    }), selectProps && /* @__PURE__ */ jsx$1(ReactSelect, __spreadProps(__spreadValues({
      formatOptionLabel: ({
        value: value2,
        label: label2
      }, props) => {
        return selectProps.value.value !== value2 ? label2 : /* @__PURE__ */ jsxs("div", {
          className: props.context === "menu" ? styles$d.selected : "",
          children: [props.context === "menu" && /* @__PURE__ */ jsx$1(Icon, {
            type: "Check",
            size: "s"
          }), label2]
        });
      }
    }, selectProps), {
      classNamePrefix: "ActionInput",
      className: classnames$1(styles$d.select, selectProps.className)
    })), dropdownIsOpen && /* @__PURE__ */ jsx$1("ul", {
      className: classnames$1(styles$d.dropdownList, selectProps ? styles$d.withSelect : ""),
      children: dropdownItems.map((result, i) => {
        return renderListItem ? renderListItem(result, i) : renderDefaultListItem(result, i);
      })
    })]
  });
});
ActionInput.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onAction: PropTypes.func,
  onClear: PropTypes.func,
  renderListItem: PropTypes.func,
  onListItemClick: PropTypes.func,
  large: PropTypes.bool,
  rightButton: PropTypes.bool,
  ariaLabel: PropTypes.string.isRequired,
  icon: PropTypes.string,
  iconSize: PropTypes.oneOf(["s", "m", "l"]),
  isPending: PropTypes.bool,
  spinnerColor: PropTypes.string,
  selectProps: PropTypes.object,
  dropdownItems: PropTypes.array,
  dropdownIsOpen: PropTypes.bool,
  submitOnEnter: PropTypes.bool
};
ActionInput.defaultProps = {
  className: "",
  rightButton: false,
  icon: "Search",
  iconSize: "m",
  dropdownItems: [],
  isPending: false,
  spinnerColor: "#111",
  submitOnEnter: false
};
const icon$c = "epic__icon__822";
const ripple$c = "epic__ripple__0b1";
const checkboxContainer = "epic__checkboxContainer__372";
const circle = "epic__circle__5da";
const checkmark = "epic__checkmark__617";
const box = "epic__box__fa2";
const success = "epic__success__5d6";
const hasError = "epic__hasError__66d";
const disabled$2 = "epic__disabled__163";
const indeterminate = "epic__indeterminate__dc6";
const textLabel = "epic__textLabel__76e";
var styles$c = {
  icon: icon$c,
  "epic-icon": "epic__epic-icon__c97",
  "epic-icon-add": "epic__epic-icon-add__f02",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__258",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__2fe",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__912",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__781",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__5ec",
  "epic-icon-calendar": "epic__epic-icon-calendar__e0a",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__1dd",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__b88",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__d9c",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__514",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__ffd",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__b40",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__53d",
  "epic-icon-close-x": "epic__epic-icon-close-x__7f5",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__d9e",
  "epic-icon-confluence": "epic__epic-icon-confluence__e66",
  "epic-icon-contact": "epic__epic-icon-contact__d7f",
  "epic-icon-delete": "epic__epic-icon-delete__d7a",
  "epic-icon-edit": "epic__epic-icon-edit__f27",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__6dd",
  "epic-icon-filter": "epic__epic-icon-filter__e3b",
  "epic-icon-github": "epic__epic-icon-github__e1d",
  "epic-icon-information": "epic__epic-icon-information__d74",
  "epic-icon-jira": "epic__epic-icon-jira__172",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__c5a",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__735",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__0f4",
  "epic-icon-preview": "epic__epic-icon-preview__e2f",
  "epic-icon-profile": "epic__epic-icon-profile__c4d",
  "epic-icon-quotes": "epic__epic-icon-quotes__d5f",
  "epic-icon-search": "epic__epic-icon-search__026",
  "epic-icon-share": "epic__epic-icon-share__45f",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__9b2",
  "epic-icon-slack": "epic__epic-icon-slack__dce",
  "epic-icon-steps": "epic__epic-icon-steps__03b",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__097",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__6e4",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__a70",
  "epic-icon-warning": "epic__epic-icon-warning__df2",
  "epic-font-base": "epic__epic-font-base__0ad",
  "epic-font-base-md": "epic__epic-font-base-md__2a8",
  "epic-font-marketing": "epic__epic-font-marketing__e1d",
  "epic-font-brand": "epic__epic-font-brand__de8",
  ripple: ripple$c,
  "epic-display-base": "epic__epic-display-base__bf9",
  "epic-display-1": "epic__epic-display-1__632",
  "epic-display-2": "epic__epic-display-2__ae6",
  "epic-display-3": "epic__epic-display-3__f97",
  "epic-display-4": "epic__epic-display-4__fa6",
  "epic-display-5": "epic__epic-display-5__89f",
  "epic-title-base": "epic__epic-title-base__630",
  "epic-title-1": "epic__epic-title-1__599",
  "epic-title-2": "epic__epic-title-2__54e",
  "epic-title-3": "epic__epic-title-3__49d",
  "epic-title-4": "epic__epic-title-4__4d2",
  "epic-title-5": "epic__epic-title-5__9e4",
  "epic-title-6": "epic__epic-title-6__a48",
  "epic-subtitle-base": "epic__epic-subtitle-base__a10",
  "epic-subtitle-1": "epic__epic-subtitle-1__f7a",
  "epic-subtitle-2": "epic__epic-subtitle-2__752",
  "epic-subtitle-3": "epic__epic-subtitle-3__e70",
  "epic-body-text-base": "epic__epic-body-text-base__00b",
  "epic-body-text-1": "epic__epic-body-text-1__308",
  "epic-body-text-2": "epic__epic-body-text-2__a86",
  "epic-body-text": "epic__epic-body-text__d90",
  "epic-body-text-3": "epic__epic-body-text-3__641",
  checkboxContainer,
  "epic-legal-text": "epic__epic-legal-text__e03",
  "epic-label-text": "epic__epic-label-text__c76",
  "epic-button-base": "epic__epic-button-base__f3b",
  "epic-button-1": "epic__epic-button-1__b8a",
  "epic-button-2": "epic__epic-button-2__f4c",
  "epic-button-3": "epic__epic-button-3__30b",
  circle,
  checkmark,
  box,
  "default": "epic__default__5d0",
  success,
  hasError,
  disabled: disabled$2,
  indeterminate,
  textLabel
};
let ID$1 = 0;
const Checkbox = forwardRef(function Checkbox2(_y, ref) {
  var _z = _y, {
    className,
    labelClassName,
    checked,
    label: label2,
    success: success2,
    hasError: hasError2,
    disabled: disabled2,
    onValueChange
  } = _z, rest = __objRest(_z, [
    "className",
    "labelClassName",
    "checked",
    "label",
    "success",
    "hasError",
    "disabled",
    "onValueChange"
  ]);
  const [_id] = useState(() => `ep-checkbox-${++ID$1}`);
  const id2 = rest.id || _id;
  let labelClass = classnames$1(styles$c.label, labelClassName);
  let checkboxContainerClass = classnames$1(styles$c.checkboxContainer, className);
  let checkboxClass = styles$c.checkbox;
  let colorStyle;
  if (success2)
    colorStyle = styles$c.success;
  if (hasError2)
    colorStyle = styles$c.hasError;
  if (disabled2)
    colorStyle = styles$c.disabled;
  return /* @__PURE__ */ jsxs("div", {
    className: checkboxContainerClass,
    children: [/* @__PURE__ */ jsx$1("input", __spreadValues({
      ref,
      type: "checkbox",
      className: checkboxClass,
      id: id2,
      checked,
      value: !!checked,
      disabled: disabled2,
      onChange: (e) => {
        onValueChange && onValueChange(e.target.checked);
        return rest.onChange && rest.onChange(e);
      }
    }, rest)), /* @__PURE__ */ jsxs("label", {
      className: labelClass,
      htmlFor: id2,
      children: [/* @__PURE__ */ jsx$1("span", {
        className: styles$c.circle
      }), /* @__PURE__ */ jsxs("svg", {
        className: styles$c.svg,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/* @__PURE__ */ jsx$1("rect", {
          className: classnames$1(styles$c.box, colorStyle),
          x: "0.75",
          y: "0.75",
          width: "22.5",
          height: "22.5",
          rx: "3.25",
          strokeWidth: "1.5"
        }), /* @__PURE__ */ jsx$1("path", {
          className: styles$c.checkmark,
          d: "M6.5 11.4999L10.2508 15.2507L17.5 8",
          strokeWidth: "1.5"
        }), /* @__PURE__ */ jsx$1("path", {
          className: styles$c.indeterminate,
          d: "M6.87296 12.127L17.1259 12.1259",
          strokeWidth: "1.5"
        })]
      }), label2 ? /* @__PURE__ */ jsx$1("span", {
        className: classnames$1(styles$c.textLabel, colorStyle),
        children: label2
      }) : null]
    }), /* @__PURE__ */ jsx$1("br", {})]
  });
});
Checkbox.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.object]),
  success: PropTypes.bool,
  hasError: PropTypes.bool,
  disabled: PropTypes.bool,
  onValueChange: PropTypes.func,
  onChange: PropTypes.func,
  labelClassName: PropTypes.string
};
Checkbox.defaultProps = {
  label: "",
  className: ""
};
const icon$b = "epic__icon__ee5";
const ripple$b = "epic__ripple__25c";
const activeBtn = "epic__activeBtn__077";
const fileInput = "epic__fileInput__430";
const disabled$1 = "epic__disabled__b4d";
const fileInputBtn = "epic__fileInputBtn__5d3";
const fileInputLabel = "epic__fileInputLabel__396";
const active$2 = "epic__active__141";
const helperTextContainer$1 = "epic__helperTextContainer__279";
var styles$b = {
  icon: icon$b,
  "epic-icon": "epic__epic-icon__955",
  "epic-icon-add": "epic__epic-icon-add__a98",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__55b",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__38a",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__088",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__222",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__550",
  "epic-icon-calendar": "epic__epic-icon-calendar__677",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__40e",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__e58",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__0ba",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__fd7",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__354",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__24f",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__714",
  "epic-icon-close-x": "epic__epic-icon-close-x__cde",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__1ad",
  "epic-icon-confluence": "epic__epic-icon-confluence__8cd",
  "epic-icon-contact": "epic__epic-icon-contact__e6f",
  "epic-icon-delete": "epic__epic-icon-delete__992",
  "epic-icon-edit": "epic__epic-icon-edit__a17",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__ead",
  "epic-icon-filter": "epic__epic-icon-filter__3fd",
  "epic-icon-github": "epic__epic-icon-github__523",
  "epic-icon-information": "epic__epic-icon-information__28f",
  "epic-icon-jira": "epic__epic-icon-jira__ac3",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__3a0",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__182",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__1d5",
  "epic-icon-preview": "epic__epic-icon-preview__f73",
  "epic-icon-profile": "epic__epic-icon-profile__a54",
  "epic-icon-quotes": "epic__epic-icon-quotes__d4a",
  "epic-icon-search": "epic__epic-icon-search__8f1",
  "epic-icon-share": "epic__epic-icon-share__5f9",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__ead",
  "epic-icon-slack": "epic__epic-icon-slack__b8c",
  "epic-icon-steps": "epic__epic-icon-steps__9be",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__954",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__bd6",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__518",
  "epic-icon-warning": "epic__epic-icon-warning__6f0",
  "epic-font-base": "epic__epic-font-base__ce3",
  "epic-font-base-md": "epic__epic-font-base-md__ab7",
  "epic-font-marketing": "epic__epic-font-marketing__8b4",
  "epic-font-brand": "epic__epic-font-brand__637",
  ripple: ripple$b,
  activeBtn,
  fileInput,
  disabled: disabled$1,
  fileInputBtn,
  fileInputLabel,
  active: active$2,
  helperTextContainer: helperTextContainer$1
};
const removeFakePath = (v) => v.replace("C:\\fakepath\\", "");
const imageTypes = ["image/bmp", "image/gif", "image/jpeg", "image/tiff", "image/png"];
const FileInput = forwardRef((_A, ref) => {
  var _B = _A, {
    hasErrors: hasErrors2,
    accept,
    className,
    onChange,
    onFileChange,
    onRemove,
    placeholder,
    multiple
  } = _B, props = __objRest(_B, [
    "hasErrors",
    "accept",
    "className",
    "onChange",
    "onFileChange",
    "onRemove",
    "placeholder",
    "multiple"
  ]);
  const [value, setValue] = useState("");
  const [files, setFiles] = useState([]);
  const [inputKey, setInputKey] = useState(Date.now());
  const input2 = useRef();
  const active2 = !!value;
  let classList = classnames$1(styles$b.fileInput, className);
  if (props.disabled)
    classList = classnames$1(classList, styles$b.disabled);
  if (active2)
    classList = classnames$1(classList, styles$b.active);
  if (hasErrors2)
    classList = classnames$1(classList, styles$b.hasErrors);
  const clearInput = useCallback(() => {
    setInputKey(Date.now());
    if (input2.current) {
      input2.current.focus();
      setTimeout(() => input2.current.blur(), 100);
    }
  }, []);
  const onInputChange = useCallback((e) => {
    setFiles((files2) => {
      const newFiles = Array.from(e.target.files).filter((file) => !files2.find((f2) => f2.name === file.name));
      return files2.concat(newFiles);
    });
    onChange && onChange(e);
    if (!multiple) {
      setValue(e.target && e.target.value);
    } else {
      clearInput();
    }
  }, [multiple]);
  const onInputRemove = useCallback(() => {
    clearInput();
    setValue("");
    setFiles([]);
    onRemove && onRemove();
  }, [onRemove]);
  function onDeleteFile(name2) {
    setFiles(files.filter((file) => file.name !== name2));
  }
  useEffect(() => {
    onFileChange && onFileChange(files);
  }, [files]);
  useImperativeHandle(ref, () => ({
    launchFileWindow: () => {
      var _a;
      (_a = input2 == null ? void 0 : input2.current) == null ? void 0 : _a.click();
    }
  }));
  const label2 = value ? removeFakePath(value) : placeholder;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [multiple && files && /* @__PURE__ */ jsx$1("div", {
      children: files.map((file) => {
        const thumbnail2 = imageTypes.includes(file.type) ? /* @__PURE__ */ jsx$1("img", {
          height: "auto",
          src: URL.createObjectURL(file)
        }) : /* @__PURE__ */ jsx$1(Icon, {
          type: "Hide"
        });
        return /* @__PURE__ */ jsx$1(ListItem, {
          thumbnail: thumbnail2,
          subtitle: new Date(Date.now()).toDateString(),
          name: file.name,
          iconType: "Delete",
          onAction: () => onDeleteFile(file.name)
        }, file.name);
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: classList,
      children: [/* @__PURE__ */ jsx$1("label", {
        className: styles$b.fileInputLabel,
        children: /* @__PURE__ */ jsx$1("span", {
          children: label2
        })
      }), /* @__PURE__ */ jsx$1(TextInput$1, __spreadValues({
        ref: input2,
        placeholder: "",
        accept: accept || "*",
        type: "file",
        hasErrors: hasErrors2,
        floating: false,
        onChange: onInputChange,
        multiple: multiple ? "multiple" : ""
      }, props), inputKey), /* @__PURE__ */ jsx$1("button", {
        type: "button",
        className: styles$b.fileInputBtn,
        onClick: active2 ? onInputRemove : void 0,
        children: /* @__PURE__ */ jsx$1(Icon, {
          type: active2 ? "Close" : "Plus",
          size: "m"
        })
      })]
    })]
  });
});
FileInput.propTypes = {
  name: PropTypes.string,
  accept: PropTypes.string,
  className: PropTypes.string,
  onRemove: PropTypes.func,
  onChange: PropTypes.func,
  onFileChange: PropTypes.func,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  hasErrors: PropTypes.bool,
  errorMessage: PropTypes.string
};
FileInput.defaultProps = {
  className: "",
  placeholder: "Select a file",
  disabled: false
};
const icon$a = "epic__icon__dca";
const formSection = "epic__formSection__904";
const header = "epic__header__913";
const ripple$a = "epic__ripple__c72";
const done = "epic__done__320";
var styles$a = {
  icon: icon$a,
  "epic-icon": "epic__epic-icon__c9a",
  "epic-icon-add": "epic__epic-icon-add__91e",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__a15",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__7ea",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__438",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__02c",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__d71",
  "epic-icon-calendar": "epic__epic-icon-calendar__4ca",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__bf4",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__612",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__893",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__b2d",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__7b5",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__418",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__bc8",
  "epic-icon-close-x": "epic__epic-icon-close-x__88b",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__8f8",
  "epic-icon-confluence": "epic__epic-icon-confluence__f52",
  "epic-icon-contact": "epic__epic-icon-contact__59a",
  "epic-icon-delete": "epic__epic-icon-delete__073",
  "epic-icon-edit": "epic__epic-icon-edit__830",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__ad1",
  "epic-icon-filter": "epic__epic-icon-filter__ef4",
  "epic-icon-github": "epic__epic-icon-github__536",
  "epic-icon-information": "epic__epic-icon-information__d77",
  "epic-icon-jira": "epic__epic-icon-jira__c31",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__43e",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__748",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__36d",
  "epic-icon-preview": "epic__epic-icon-preview__19d",
  "epic-icon-profile": "epic__epic-icon-profile__2ab",
  "epic-icon-quotes": "epic__epic-icon-quotes__a3e",
  "epic-icon-search": "epic__epic-icon-search__f94",
  "epic-icon-share": "epic__epic-icon-share__a02",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__a3c",
  "epic-icon-slack": "epic__epic-icon-slack__085",
  "epic-icon-steps": "epic__epic-icon-steps__46d",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__ccf",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__217",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__7f5",
  "epic-icon-warning": "epic__epic-icon-warning__8fb",
  "epic-font-base": "epic__epic-font-base__bad",
  formSection,
  header,
  "epic-font-base-md": "epic__epic-font-base-md__ce0",
  "epic-font-marketing": "epic__epic-font-marketing__5f1",
  "epic-font-brand": "epic__epic-font-brand__b78",
  ripple: ripple$a,
  done
};
const FormSection = ({
  title: title2,
  children,
  subtitle: subtitle2,
  attributes,
  className
}) => {
  let formClassName = className ? `${styles$a.formSection} ${className}` : styles$a.formSection;
  return /* @__PURE__ */ jsxs("div", __spreadProps(__spreadValues({}, attributes), {
    className: formClassName,
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles$a.header,
      children: [title2 && /* @__PURE__ */ jsx$1("h1", {
        children: title2
      }), subtitle2 && /* @__PURE__ */ jsx$1("h3", {
        children: subtitle2
      })]
    }), children]
  }));
};
FormSection.propTypes = {
  className: PropTypes.string,
  title: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.string,
  children: PropTypes.PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  attributes: PropTypes.object
};
FormSection.defaultProps = {
  className: ""
};
const icon$9 = "epic__icon__0df";
const label = "epic__label__af4";
const labelWrapper = "epic__labelWrapper__f2d";
const labelText = "epic__labelText__f1a";
const errorText = "epic__errorText__c63";
const ripple$9 = "epic__ripple__3e3";
const required = "epic__required__435";
var styles$9 = {
  icon: icon$9,
  "epic-icon": "epic__epic-icon__b3f",
  "epic-icon-add": "epic__epic-icon-add__668",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__0bb",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__7a0",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__f3e",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__146",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__0d0",
  "epic-icon-calendar": "epic__epic-icon-calendar__193",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__e74",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__ad6",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__1f1",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__04d",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__4d5",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__647",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__953",
  "epic-icon-close-x": "epic__epic-icon-close-x__50b",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__11c",
  "epic-icon-confluence": "epic__epic-icon-confluence__369",
  "epic-icon-contact": "epic__epic-icon-contact__74a",
  "epic-icon-delete": "epic__epic-icon-delete__c8a",
  "epic-icon-edit": "epic__epic-icon-edit__fd7",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__784",
  "epic-icon-filter": "epic__epic-icon-filter__004",
  "epic-icon-github": "epic__epic-icon-github__68d",
  "epic-icon-information": "epic__epic-icon-information__51a",
  "epic-icon-jira": "epic__epic-icon-jira__e74",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__675",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__eb8",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__e88",
  "epic-icon-preview": "epic__epic-icon-preview__a26",
  "epic-icon-profile": "epic__epic-icon-profile__7b0",
  "epic-icon-quotes": "epic__epic-icon-quotes__760",
  "epic-icon-search": "epic__epic-icon-search__1b0",
  "epic-icon-share": "epic__epic-icon-share__e9b",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__603",
  "epic-icon-slack": "epic__epic-icon-slack__30e",
  "epic-icon-steps": "epic__epic-icon-steps__738",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__3bb",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__c05",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__078",
  "epic-icon-warning": "epic__epic-icon-warning__0c2",
  "epic-font-base": "epic__epic-font-base__3c5",
  label,
  labelWrapper,
  labelText,
  errorText,
  "epic-font-base-md": "epic__epic-font-base-md__0b9",
  "epic-font-marketing": "epic__epic-font-marketing__581",
  "epic-font-brand": "epic__epic-font-brand__348",
  ripple: ripple$9,
  required
};
function Label$1(_C) {
  var _D = _C, {
    hasErrors: hasErrors2,
    errorMessage,
    required: required2,
    label: label2,
    className,
    children
  } = _D, props = __objRest(_D, [
    "hasErrors",
    "errorMessage",
    "required",
    "label",
    "className",
    "children"
  ]);
  let labelClass = classnames$1(styles$9.label, className);
  return /* @__PURE__ */ jsxs("label", __spreadProps(__spreadValues({}, props), {
    className: labelClass,
    children: [/* @__PURE__ */ jsxs("span", {
      className: styles$9.labelWrapper,
      children: [label2 && /* @__PURE__ */ jsxs("span", {
        className: styles$9.labelText,
        children: [label2, " ", required2 && /* @__PURE__ */ jsx$1("span", {
          className: styles$9.required,
          children: " *"
        })]
      }), hasErrors2 && errorMessage && /* @__PURE__ */ jsx$1("span", {
        className: styles$9.errorText,
        children: errorMessage
      })]
    }), children]
  }));
}
Label$1.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.object]),
  required: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  hasErrors: PropTypes.bool,
  errorMessage: PropTypes.string,
  className: PropTypes.string
};
Label$1.defaultProps = {
  className: ""
};
const icon$8 = "epic__icon__c32";
const ripple$8 = "epic__ripple__9f6";
const optionLabel = "epic__optionLabel__613";
const radio = "epic__radio__e0b";
const input = "epic__input__6e9";
const inner = "epic__inner__1bb";
var styles$8 = {
  icon: icon$8,
  "epic-icon": "epic__epic-icon__483",
  "epic-icon-add": "epic__epic-icon-add__0cd",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__b37",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__e70",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__888",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__874",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__cbd",
  "epic-icon-calendar": "epic__epic-icon-calendar__167",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__0ca",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__85b",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__85e",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__d3d",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__990",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__264",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__b33",
  "epic-icon-close-x": "epic__epic-icon-close-x__425",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__9a9",
  "epic-icon-confluence": "epic__epic-icon-confluence__c90",
  "epic-icon-contact": "epic__epic-icon-contact__375",
  "epic-icon-delete": "epic__epic-icon-delete__154",
  "epic-icon-edit": "epic__epic-icon-edit__aea",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__f36",
  "epic-icon-filter": "epic__epic-icon-filter__caa",
  "epic-icon-github": "epic__epic-icon-github__6e7",
  "epic-icon-information": "epic__epic-icon-information__d5f",
  "epic-icon-jira": "epic__epic-icon-jira__413",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__b47",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__3b8",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__658",
  "epic-icon-preview": "epic__epic-icon-preview__13b",
  "epic-icon-profile": "epic__epic-icon-profile__833",
  "epic-icon-quotes": "epic__epic-icon-quotes__f7f",
  "epic-icon-search": "epic__epic-icon-search__a2c",
  "epic-icon-share": "epic__epic-icon-share__aea",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__76b",
  "epic-icon-slack": "epic__epic-icon-slack__eb9",
  "epic-icon-steps": "epic__epic-icon-steps__28b",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__e8f",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__307",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__cb4",
  "epic-icon-warning": "epic__epic-icon-warning__4ce",
  "epic-font-base": "epic__epic-font-base__c67",
  "epic-font-base-md": "epic__epic-font-base-md__172",
  "epic-font-marketing": "epic__epic-font-marketing__ab0",
  "epic-font-brand": "epic__epic-font-brand__4f0",
  ripple: ripple$8,
  optionLabel,
  radio,
  input,
  inner
};
let ID = 0;
const RadioButton = forwardRef(function RadioButton2(_E, ref) {
  var _F = _E, {
    value,
    onChange,
    checked,
    name: name2,
    label: label2
  } = _F, rest = __objRest(_F, [
    "value",
    "onChange",
    "checked",
    "name",
    "label"
  ]);
  const [_id] = useState(() => `ep-checkbox-${++ID}`);
  const id2 = rest.id || _id;
  return /* @__PURE__ */ jsxs("label", {
    className: styles$8.optionLabel,
    htmlFor: id2,
    children: [/* @__PURE__ */ jsx$1("input", __spreadValues({
      onChange: onChange ? () => onChange(value) : void 0,
      checked,
      className: styles$8.input,
      name: name2,
      id: id2,
      value,
      type: "radio",
      ref
    }, rest)), /* @__PURE__ */ jsx$1("span", {
      className: styles$8.radio,
      children: /* @__PURE__ */ jsx$1("span", {
        className: styles$8.inner
      })
    }), label2]
  });
});
RadioButton.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.object]),
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};
const icon$7 = "epic__icon__375";
const ripple$7 = "epic__ripple__731";
const radioGroup = "epic__radioGroup__8fd";
var styles$7 = {
  icon: icon$7,
  "epic-icon": "epic__epic-icon__a9d",
  "epic-icon-add": "epic__epic-icon-add__a31",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__2ec",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__bff",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__49c",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__f35",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__382",
  "epic-icon-calendar": "epic__epic-icon-calendar__421",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__1fe",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__342",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__1c7",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__6c7",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__2b8",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__0b9",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__e6f",
  "epic-icon-close-x": "epic__epic-icon-close-x__901",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__b79",
  "epic-icon-confluence": "epic__epic-icon-confluence__7a3",
  "epic-icon-contact": "epic__epic-icon-contact__a94",
  "epic-icon-delete": "epic__epic-icon-delete__d11",
  "epic-icon-edit": "epic__epic-icon-edit__1cd",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__d3b",
  "epic-icon-filter": "epic__epic-icon-filter__5a4",
  "epic-icon-github": "epic__epic-icon-github__f8d",
  "epic-icon-information": "epic__epic-icon-information__0ce",
  "epic-icon-jira": "epic__epic-icon-jira__870",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__d73",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__a1b",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__92e",
  "epic-icon-preview": "epic__epic-icon-preview__48b",
  "epic-icon-profile": "epic__epic-icon-profile__a93",
  "epic-icon-quotes": "epic__epic-icon-quotes__002",
  "epic-icon-search": "epic__epic-icon-search__59f",
  "epic-icon-share": "epic__epic-icon-share__cda",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__14b",
  "epic-icon-slack": "epic__epic-icon-slack__01c",
  "epic-icon-steps": "epic__epic-icon-steps__4d9",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__d19",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__a15",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__609",
  "epic-icon-warning": "epic__epic-icon-warning__c80",
  "epic-font-base": "epic__epic-font-base__8d6",
  "epic-font-base-md": "epic__epic-font-base-md__d00",
  "epic-font-marketing": "epic__epic-font-marketing__b6e",
  "epic-font-brand": "epic__epic-font-brand__ec5",
  ripple: ripple$7,
  radioGroup
};
function RadioGroup(_G) {
  var _H = _G, {
    list,
    name: name2,
    value,
    onChange,
    className
  } = _H, rest = __objRest(_H, [
    "list",
    "name",
    "value",
    "onChange",
    "className"
  ]);
  return /* @__PURE__ */ jsx$1(Label$1, __spreadProps(__spreadValues({}, rest), {
    className: styles$7.label,
    children: /* @__PURE__ */ jsx$1("span", {
      className: className ? `${styles$7.radioGroup} ${className}` : styles$7.radioGroup,
      "data-testid": "RadioButtonsWrapper",
      children: list.map((item2) => {
        return /* @__PURE__ */ jsx$1(RadioButton, {
          name: name2,
          value: item2.value,
          label: item2.label,
          "aria-label": item2.label,
          checked: value === item2.value,
          onChange: () => onChange(item2.value)
        }, item2.label);
      })
    })
  }));
}
RadioGroup.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })).isRequired,
  name: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.object]),
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  attributes: PropTypes.object
};
RadioGroup.defaultProps = {
  list: []
};
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var compareOption = function compareOption2() {
  var inputValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var option = arguments.length > 1 ? arguments[1] : void 0;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(option.value).toLowerCase();
  var optionLabel2 = String(option.label).toLowerCase();
  return optionValue === candidate || optionLabel2 === candidate;
};
var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "'.concat(inputValue, '"');
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function(option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function(option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel2) {
    return {
      label: optionLabel2,
      value: inputValue,
      __isNew__: true
    };
  }
};
var defaultProps = _objectSpread({
  allowCreateWhileLoading: false,
  createOptionPosition: "last"
}, builtins);
var makeCreatableSelect = function makeCreatableSelect2(SelectComponent) {
  var _class, _temp;
  return _temp = _class = /* @__PURE__ */ function(_Component) {
    _inherits$1(Creatable2, _Component);
    var _super = _createSuper(Creatable2);
    function Creatable2(props) {
      var _this;
      _classCallCheck$1(this, Creatable2);
      _this = _super.call(this, props);
      _this.select = void 0;
      _this.onChange = function(newValue, actionMeta) {
        var _this$props = _this.props, getNewOptionData2 = _this$props.getNewOptionData, inputValue = _this$props.inputValue, isMulti = _this$props.isMulti, onChange = _this$props.onChange, onCreateOption = _this$props.onCreateOption, value = _this$props.value, name2 = _this$props.name;
        if (actionMeta.action !== "select-option") {
          return onChange(newValue, actionMeta);
        }
        var newOption = _this.state.newOption;
        var valueArray = Array.isArray(newValue) ? newValue : [newValue];
        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption)
            onCreateOption(inputValue);
          else {
            var newOptionData = getNewOptionData2(inputValue, inputValue);
            var newActionMeta = {
              action: "create-option",
              name: name2
            };
            if (isMulti) {
              onChange([].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }
        onChange(newValue, actionMeta);
      };
      var options = props.options || [];
      _this.state = {
        newOption: void 0,
        options
      };
      return _this;
    }
    _createClass$1(Creatable2, [{
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading, createOptionPosition = nextProps.createOptionPosition, formatCreateLabel2 = nextProps.formatCreateLabel, getNewOptionData2 = nextProps.getNewOptionData, inputValue = nextProps.inputValue, isLoading2 = nextProps.isLoading, isValidNewOption2 = nextProps.isValidNewOption, value = nextProps.value;
        var options = nextProps.options || [];
        var newOption = this.state.newOption;
        if (isValidNewOption2(inputValue, cleanValue(value), options)) {
          newOption = getNewOptionData2(inputValue, formatCreateLabel2(inputValue));
        } else {
          newOption = void 0;
        }
        this.setState({
          newOption,
          options: (allowCreateWhileLoading || !isLoading2) && newOption ? createOptionPosition === "first" ? [newOption].concat(_toConsumableArray(options)) : [].concat(_toConsumableArray(options), [newOption]) : options
        });
      }
    }, {
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "render",
      value: function render3() {
        var _this2 = this;
        var options = this.state.options;
        return /* @__PURE__ */ jsx$1(SelectComponent, __spreadProps(__spreadValues({}, this.props), {
          ref: function ref(_ref3) {
            _this2.select = _ref3;
          },
          options,
          onChange: this.onChange
        }));
      }
    }]);
    return Creatable2;
  }(Component), _class.defaultProps = defaultProps, _temp;
};
var SelectCreatable = makeCreatableSelect(Select$1);
var Creatable = manageState(SelectCreatable);
const icon$6 = "epic__icon__07a";
const container = "epic__container__d0a";
const textFieldset = "epic__textFieldset__2ab";
const ripple$6 = "epic__ripple__3c7";
const labelInInput = "epic__labelInInput__61b";
const textInputLabel = "epic__textInputLabel__a0f";
const labelOutInput = "epic__labelOutInput__241";
const active$1 = "epic__active__2bd";
const disabled = "epic__disabled__f8e";
const hasErrors = "epic__hasErrors__ed6";
const baseFormElement = "epic__baseFormElement__933";
const helperText = "epic__helperText__980";
const helperTextContainer = "epic__helperTextContainer__1fa";
var styles$6 = {
  icon: icon$6,
  "epic-icon": "epic__epic-icon__c48",
  "epic-icon-add": "epic__epic-icon-add__cc6",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__bf6",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__98e",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__f96",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__32d",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__659",
  "epic-icon-calendar": "epic__epic-icon-calendar__dae",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__6f9",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__86f",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__443",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__901",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__6be",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__931",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__2e6",
  "epic-icon-close-x": "epic__epic-icon-close-x__94b",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__de0",
  "epic-icon-confluence": "epic__epic-icon-confluence__428",
  "epic-icon-contact": "epic__epic-icon-contact__0fc",
  "epic-icon-delete": "epic__epic-icon-delete__7fe",
  "epic-icon-edit": "epic__epic-icon-edit__e18",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__f30",
  "epic-icon-filter": "epic__epic-icon-filter__479",
  "epic-icon-github": "epic__epic-icon-github__1c5",
  "epic-icon-information": "epic__epic-icon-information__221",
  "epic-icon-jira": "epic__epic-icon-jira__2b8",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__f38",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__869",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__492",
  "epic-icon-preview": "epic__epic-icon-preview__f9e",
  "epic-icon-profile": "epic__epic-icon-profile__881",
  "epic-icon-quotes": "epic__epic-icon-quotes__f19",
  "epic-icon-search": "epic__epic-icon-search__0ab",
  "epic-icon-share": "epic__epic-icon-share__293",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__8e8",
  "epic-icon-slack": "epic__epic-icon-slack__99a",
  "epic-icon-steps": "epic__epic-icon-steps__d5a",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__6fe",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__523",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__ed5",
  "epic-icon-warning": "epic__epic-icon-warning__573",
  "epic-font-base": "epic__epic-font-base__65a",
  container,
  textFieldset,
  "epic-font-base-md": "epic__epic-font-base-md__008",
  "epic-font-marketing": "epic__epic-font-marketing__170",
  "epic-font-brand": "epic__epic-font-brand__69d",
  ripple: ripple$6,
  labelInInput,
  textInputLabel,
  labelOutInput,
  active: active$1,
  disabled,
  hasErrors,
  baseFormElement,
  helperText,
  helperTextContainer
};
const TextFieldSet = ({
  legend,
  floating
}) => /* @__PURE__ */ jsx$1("fieldset", {
  className: styles$6.textFieldset,
  children: floating ? /* @__PURE__ */ jsx$1("legend", {
    children: legend
  }) : null
});
const Label = (_I) => {
  var _J = _I, {
    label: label2,
    className
  } = _J, props = __objRest(_J, [
    "label",
    "className"
  ]);
  return /* @__PURE__ */ jsx$1("label", __spreadProps(__spreadValues({}, props), {
    className: classnames$1(styles$6.textInputLabel, className),
    children: /* @__PURE__ */ jsx$1("span", {
      className: styles$6.labelText,
      children: label2
    })
  }));
};
const FormBase = (_K) => {
  var _L = _K, {
    label: label2,
    placeholder,
    required: required2
  } = _L, props = __objRest(_L, [
    "label",
    "placeholder",
    "required"
  ]);
  let classList = styles$6.container;
  if (props.isActive)
    classList = classnames$1(classList, styles$6.active);
  if (props.disabled)
    classList = classnames$1(classList, styles$6.disabled);
  if (props.hasErrors)
    classList = classnames$1(classList, styles$6.hasErrors);
  label2 = label2 && required2 ? `${label2}*` : label2;
  placeholder = placeholder && required2 ? `${placeholder}*` : placeholder;
  const msg = props.helperText || "";
  return /* @__PURE__ */ jsxs("div", {
    className: classnames$1(classList, props.className),
    children: [props.children, !placeholder && /* @__PURE__ */ jsx$1(Label, {
      label: label2,
      required: required2
    }), /* @__PURE__ */ jsxs("span", {
      className: styles$6.helperTextContainer,
      children: [/* @__PURE__ */ jsx$1("span", {
        className: styles$6.helperText,
        children: props.hasErrors ? props.errorMessage : msg
      }), !props.disabled && props.maxLength && /* @__PURE__ */ jsx$1("span", {
        className: styles$6.maxLength,
        children: `${props.textLength} / ${props.maxLength}`
      })]
    }), /* @__PURE__ */ jsx$1(TextFieldSet, {
      floating: !placeholder && props.floating,
      legend: props.isActive && label2
    })]
  });
};
FormBase.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  helperText: PropTypes.string,
  textLength: PropTypes.number,
  maxLength: PropTypes.number,
  isActive: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  floating: PropTypes.bool,
  hasErrors: PropTypes.bool
};
FormBase.defaultProps = {
  className: "",
  placeholder: "",
  disabled: false,
  floating: true
};
const formTypes = ["input", "label", "select", "textarea", "button", "fieldset", "legend", "datalist", "output", "option", "optgroup"];
const FormBaseCtrl = React__default.forwardRef((props, ref) => {
  var _b, _c, _d;
  const [value, setValue] = useState(props.value || "");
  const [active2, setActive] = useState(false);
  const compProps = __spreadValues({}, props);
  const baseProps = Object.keys(FormBase.propTypes).reduce((acc, cv) => __spreadProps(__spreadValues({}, acc), {
    [cv]: compProps[cv]
  }), {});
  const _a = props, {
    required: required2,
    placeholder,
    children,
    label: label2,
    errorMessage,
    helperText: helperText2,
    hasErrors: hasErrors2,
    floating
  } = _a, rest = __objRest(_a, [
    "required",
    "placeholder",
    "children",
    "label",
    "errorMessage",
    "helperText",
    "hasErrors",
    "floating"
  ]);
  ref = ref || useRef();
  const onChange = (e) => {
    setValue(e.target.value);
    props.onChange && props.onChange(e);
  };
  const onFocus = (e) => {
    props.onFocus && props.onFocus(e);
    setActive(true);
  };
  const onBlur = (e) => {
    props.onBlur && props.onBlur(e);
    if (ref.current && ref.current.value === "") {
      setValue("");
      setActive(false);
    }
  };
  const boundedChild = React__default.cloneElement(children, __spreadProps(__spreadValues({
    ref,
    required: required2,
    placeholder: placeholder && required2 ? `${placeholder} *` : placeholder,
    value
  }, rest), {
    className: styles$6.baseFormElement,
    onChange,
    onFocus,
    onBlur
  }));
  return /* @__PURE__ */ jsx$1(FormBase, __spreadProps(__spreadValues({}, baseProps), {
    textLength: ((_b = boundedChild.props.value) == null ? void 0 : _b.toString()) ? boundedChild.props.value.toString().length : 0,
    label: label2,
    hasErrors: hasErrors2,
    errorMessage,
    helperText: helperText2,
    isActive: active2 || !!((_d = (_c = boundedChild.props.value) == null ? void 0 : _c.toString()) == null ? void 0 : _d.length),
    floating,
    children: boundedChild
  }));
});
FormBaseCtrl.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  helperText: PropTypes.string,
  textLength: PropTypes.number,
  maxLength: PropTypes.number,
  isActive: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  floating: PropTypes.bool,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
  children(props, propName, componentName) {
    let prop = props[propName];
    let types = formTypes;
    if (React__default.Children.count(prop) !== 1 || types.indexOf(prop.type) === -1) {
      return new Error("`" + componentName + "` should have a single child of the following types:  `" + types.join("`, `") + "`.");
    }
  }
};
const icon$5 = "epic__icon__f28";
const ripple$5 = "epic__ripple__227";
const NextGenSelect = "epic__NextGenSelect__dea";
var styles$5 = {
  icon: icon$5,
  "epic-icon": "epic__epic-icon__0df",
  "epic-icon-add": "epic__epic-icon-add__8ed",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__259",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__01c",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__548",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__619",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__d0b",
  "epic-icon-calendar": "epic__epic-icon-calendar__448",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__788",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__983",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__3e9",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__85a",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__cfc",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__8b7",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__a0d",
  "epic-icon-close-x": "epic__epic-icon-close-x__9e3",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__5c4",
  "epic-icon-confluence": "epic__epic-icon-confluence__17a",
  "epic-icon-contact": "epic__epic-icon-contact__5ab",
  "epic-icon-delete": "epic__epic-icon-delete__709",
  "epic-icon-edit": "epic__epic-icon-edit__7d0",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__a56",
  "epic-icon-filter": "epic__epic-icon-filter__f2e",
  "epic-icon-github": "epic__epic-icon-github__08a",
  "epic-icon-information": "epic__epic-icon-information__a76",
  "epic-icon-jira": "epic__epic-icon-jira__4cb",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__c08",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__791",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__dea",
  "epic-icon-preview": "epic__epic-icon-preview__4ea",
  "epic-icon-profile": "epic__epic-icon-profile__0ef",
  "epic-icon-quotes": "epic__epic-icon-quotes__eb7",
  "epic-icon-search": "epic__epic-icon-search__bf6",
  "epic-icon-share": "epic__epic-icon-share__e7c",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__2a6",
  "epic-icon-slack": "epic__epic-icon-slack__743",
  "epic-icon-steps": "epic__epic-icon-steps__b9c",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__3f9",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__300",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__502",
  "epic-icon-warning": "epic__epic-icon-warning__395",
  "epic-font-base": "epic__epic-font-base__171",
  "epic-font-base-md": "epic__epic-font-base-md__ce4",
  "epic-font-marketing": "epic__epic-font-marketing__283",
  "epic-font-brand": "epic__epic-font-brand__538",
  ripple: ripple$5,
  NextGenSelect
};
const DropdownIndicator2 = () => /* @__PURE__ */ jsx$1(Icon, {
  type: "CaretDown"
});
const MenuList2 = (_M) => {
  var _N = _M, {
    children,
    innerProps
  } = _N, props = __objRest(_N, [
    "children",
    "innerProps"
  ]);
  return /* @__PURE__ */ jsx$1(components.MenuList, __spreadProps(__spreadValues({}, props), {
    innerProps: __spreadValues({
      "data-testid": "select-menu-list"
    }, innerProps),
    children
  }));
};
const Control2 = (_O) => {
  var _P = _O, {
    children,
    innerProps
  } = _P, props = __objRest(_P, [
    "children",
    "innerProps"
  ]);
  return /* @__PURE__ */ jsx$1(components.Control, __spreadProps(__spreadValues({}, props), {
    innerProps: __spreadValues({
      "data-testid": "select-control"
    }, innerProps),
    children
  }));
};
const Option2 = (_Q) => {
  var _R = _Q, {
    children,
    innerProps
  } = _R, props = __objRest(_R, [
    "children",
    "innerProps"
  ]);
  return /* @__PURE__ */ jsx$1(components.Option, __spreadProps(__spreadValues({}, props), {
    innerProps: __spreadValues({
      "data-testid": "select-option"
    }, innerProps),
    children
  }));
};
const Select = (_S) => {
  var _T = _S, {
    isCreatable,
    className,
    errorMessage,
    required: required2,
    menuPlacement = "auto"
  } = _T, props = __objRest(_T, [
    "isCreatable",
    "className",
    "errorMessage",
    "required",
    "menuPlacement"
  ]);
  const Component2 = isCreatable ? Creatable : ReactSelect;
  let selectClass = classnames$1(styles$5.NextGenSelect, className);
  return /* @__PURE__ */ jsx$1(FormBase, {
    helperText: props.helperText,
    hasErrors: props.hasErrors,
    errorMessage,
    required: required2,
    static: true,
    className: styles$5.Select,
    disabled: props.disabled,
    children: /* @__PURE__ */ jsx$1(Component2, __spreadValues({
      className: selectClass,
      classNamePrefix: "NextGenSelect",
      isDisabled: props.disabled,
      components: {
        DropdownIndicator: DropdownIndicator2,
        MenuList: MenuList2,
        Control: Control2,
        Option: Option2
      },
      menuPlacement
    }, props))
  });
};
Select.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })).isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  isClearable: PropTypes.bool,
  isCreatable: PropTypes.bool,
  menuIsOpen: PropTypes.bool,
  isMulti: PropTypes.bool,
  inputValue: PropTypes.string,
  onInputChange: PropTypes.func,
  onCreateOption: PropTypes.func,
  onMenuOpen: PropTypes.func,
  onMenuClose: PropTypes.func,
  helperText: PropTypes.string,
  hasErrors: PropTypes.bool,
  errorMessage: PropTypes.string,
  menuPlacement: PropTypes.string
};
Select.defaultProps = {
  options: [],
  autoFocus: false,
  disabled: false,
  isClearable: false,
  isCreatable: false,
  placeholder: "Select..."
};
const icon$4 = "epic__icon__e6a";
const ripple$4 = "epic__ripple__a42";
const stepFormProgress = "epic__stepFormProgress__819";
const item = "epic__item__5b0";
const itemTitleDefault = "epic__itemTitleDefault__601";
const itemTitleHighlighted = "epic__itemTitleHighlighted__000";
const barContainer = "epic__barContainer__f84";
const bar = "epic__bar__ee4";
const barDefault = "epic__barDefault__96a";
const barHighlighted = "epic__barHighlighted__ba6";
var styles$4 = {
  icon: icon$4,
  "epic-icon": "epic__epic-icon__5d9",
  "epic-icon-add": "epic__epic-icon-add__b01",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__8e1",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__bc5",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__814",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__4d9",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__e11",
  "epic-icon-calendar": "epic__epic-icon-calendar__8a2",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__3fb",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__b42",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__287",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__fc9",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__4b3",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__0aa",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__1e1",
  "epic-icon-close-x": "epic__epic-icon-close-x__c30",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__e90",
  "epic-icon-confluence": "epic__epic-icon-confluence__5f2",
  "epic-icon-contact": "epic__epic-icon-contact__2c8",
  "epic-icon-delete": "epic__epic-icon-delete__847",
  "epic-icon-edit": "epic__epic-icon-edit__c72",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__39a",
  "epic-icon-filter": "epic__epic-icon-filter__2a1",
  "epic-icon-github": "epic__epic-icon-github__391",
  "epic-icon-information": "epic__epic-icon-information__764",
  "epic-icon-jira": "epic__epic-icon-jira__deb",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__77d",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__770",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__049",
  "epic-icon-preview": "epic__epic-icon-preview__ff4",
  "epic-icon-profile": "epic__epic-icon-profile__00b",
  "epic-icon-quotes": "epic__epic-icon-quotes__b4c",
  "epic-icon-search": "epic__epic-icon-search__58e",
  "epic-icon-share": "epic__epic-icon-share__c9a",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__8d4",
  "epic-icon-slack": "epic__epic-icon-slack__fc1",
  "epic-icon-steps": "epic__epic-icon-steps__d18",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__d5f",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__d04",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__955",
  "epic-icon-warning": "epic__epic-icon-warning__064",
  "epic-font-base": "epic__epic-font-base__ee3",
  "epic-font-base-md": "epic__epic-font-base-md__cff",
  "epic-font-marketing": "epic__epic-font-marketing__246",
  "epic-font-brand": "epic__epic-font-brand__839",
  ripple: ripple$4,
  stepFormProgress,
  item,
  itemTitleDefault,
  itemTitleHighlighted,
  barContainer,
  bar,
  barDefault,
  barHighlighted
};
const StepFormProgressBars = ({
  steps,
  activeStepIndex
}) => /* @__PURE__ */ jsx$1("div", {
  className: styles$4.stepFormProgress,
  children: steps.map((step, index2) => {
    const isActiveStep = activeStepIndex >= index2;
    return /* @__PURE__ */ jsxs("div", {
      className: styles$4.item,
      children: [/* @__PURE__ */ jsx$1("div", {
        className: styles$4.barContainer,
        children: /* @__PURE__ */ jsx$1("div", {
          className: classnames$1(styles$4.bar, {
            [styles$4.barHighlighted]: isActiveStep,
            [styles$4.barDefault]: !isActiveStep
          })
        })
      }), /* @__PURE__ */ jsx$1("span", {
        className: classnames$1({
          [styles$4.itemTitleHighlighted]: isActiveStep,
          [styles$4.itemTitleDefault]: !isActiveStep
        }),
        children: step.title
      })]
    }, step.title);
  })
});
StepFormProgressBars.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired
  })).isRequired,
  activeStepIndex: PropTypes.number
};
const icon$3 = "epic__icon__62d";
const textArea = "epic__textArea__ddd";
const ripple$3 = "epic__ripple__c6f";
const disableResize = "epic__disableResize__2ff";
var styles$3 = {
  icon: icon$3,
  "epic-icon": "epic__epic-icon__747",
  "epic-icon-add": "epic__epic-icon-add__94e",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__75e",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__686",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__e86",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__765",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__6e5",
  "epic-icon-calendar": "epic__epic-icon-calendar__f45",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__53b",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__7bf",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__750",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__5b9",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__ca3",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__9c4",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__3d3",
  "epic-icon-close-x": "epic__epic-icon-close-x__1ca",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__0ac",
  "epic-icon-confluence": "epic__epic-icon-confluence__04f",
  "epic-icon-contact": "epic__epic-icon-contact__3c8",
  "epic-icon-delete": "epic__epic-icon-delete__a04",
  "epic-icon-edit": "epic__epic-icon-edit__61f",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__161",
  "epic-icon-filter": "epic__epic-icon-filter__e90",
  "epic-icon-github": "epic__epic-icon-github__907",
  "epic-icon-information": "epic__epic-icon-information__c2b",
  "epic-icon-jira": "epic__epic-icon-jira__979",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__dfb",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__a2f",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__602",
  "epic-icon-preview": "epic__epic-icon-preview__8e1",
  "epic-icon-profile": "epic__epic-icon-profile__099",
  "epic-icon-quotes": "epic__epic-icon-quotes__c1f",
  "epic-icon-search": "epic__epic-icon-search__ddd",
  "epic-icon-share": "epic__epic-icon-share__00b",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__679",
  "epic-icon-slack": "epic__epic-icon-slack__e61",
  "epic-icon-steps": "epic__epic-icon-steps__f21",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__4fd",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__4d4",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__884",
  "epic-icon-warning": "epic__epic-icon-warning__763",
  "epic-font-base": "epic__epic-font-base__e12",
  textArea,
  "epic-font-base-md": "epic__epic-font-base-md__9c5",
  "epic-font-marketing": "epic__epic-font-marketing__689",
  "epic-font-brand": "epic__epic-font-brand__c4b",
  ripple: ripple$3,
  disableResize
};
const TextArea = React__default.forwardRef((props, ref) => {
  let classList = classnames$1(styles$3.textArea, props.className);
  if (props.disableResize)
    classList = classnames$1(classList, styles$3.disableResize);
  const baseProps = __spreadProps(__spreadValues({}, props), {
    disableResize: void 0
  });
  delete baseProps.disableResize;
  return /* @__PURE__ */ jsx$1(FormBaseCtrl, __spreadProps(__spreadValues({}, baseProps), {
    ref,
    className: classList,
    children: /* @__PURE__ */ jsx$1("textarea", {
      type: "text",
      value: ""
    })
  }));
});
TextArea.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.object]),
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  className: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  disableResize: PropTypes.bool,
  hasErrors: PropTypes.bool,
  errorMessage: PropTypes.string
};
TextArea.defaultProps = {
  className: "",
  placeholder: "",
  disabled: false
};
const icon$2 = "epic__icon__dea";
const ripple$2 = "epic__ripple__c2f";
const textInput = "epic__textInput__40f";
var styles$2 = {
  icon: icon$2,
  "epic-icon": "epic__epic-icon__ee6",
  "epic-icon-add": "epic__epic-icon-add__38e",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__629",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__077",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__ce9",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__b17",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__8af",
  "epic-icon-calendar": "epic__epic-icon-calendar__12a",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__39e",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__054",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__cc5",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__aa7",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__c70",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__614",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__f13",
  "epic-icon-close-x": "epic__epic-icon-close-x__914",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__2ad",
  "epic-icon-confluence": "epic__epic-icon-confluence__029",
  "epic-icon-contact": "epic__epic-icon-contact__8b5",
  "epic-icon-delete": "epic__epic-icon-delete__795",
  "epic-icon-edit": "epic__epic-icon-edit__b28",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__029",
  "epic-icon-filter": "epic__epic-icon-filter__d3a",
  "epic-icon-github": "epic__epic-icon-github__ea9",
  "epic-icon-information": "epic__epic-icon-information__c26",
  "epic-icon-jira": "epic__epic-icon-jira__2f8",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__58c",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__85a",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__df1",
  "epic-icon-preview": "epic__epic-icon-preview__9e0",
  "epic-icon-profile": "epic__epic-icon-profile__104",
  "epic-icon-quotes": "epic__epic-icon-quotes__cca",
  "epic-icon-search": "epic__epic-icon-search__45a",
  "epic-icon-share": "epic__epic-icon-share__5e8",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__f6d",
  "epic-icon-slack": "epic__epic-icon-slack__d38",
  "epic-icon-steps": "epic__epic-icon-steps__046",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__fde",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__170",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__d5f",
  "epic-icon-warning": "epic__epic-icon-warning__dea",
  "epic-font-base": "epic__epic-font-base__d95",
  "epic-font-base-md": "epic__epic-font-base-md__909",
  "epic-font-marketing": "epic__epic-font-marketing__8b1",
  "epic-font-brand": "epic__epic-font-brand__194",
  ripple: ripple$2,
  textInput
};
const TextInput = React__default.forwardRef((props, ref) => /* @__PURE__ */ jsx$1(FormBaseCtrl, __spreadProps(__spreadValues({}, props), {
  ref,
  className: classnames$1(styles$2.textInput, props.className),
  children: /* @__PURE__ */ jsx$1("input", {})
})));
TextInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.object]),
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  className: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  hasErrors: PropTypes.bool,
  errorMessage: PropTypes.string
};
TextInput.defaultProps = {
  className: "",
  placeholder: "",
  disabled: false
};
var TextInput$1 = TextInput;
const icon$1 = "epic__icon__9b4";
const ripple$1 = "epic__ripple__ea7";
const toggle = "epic__toggle__ca8";
const toggleItem = "epic__toggleItem__bcc";
var styles$1 = {
  icon: icon$1,
  "epic-icon": "epic__epic-icon__02d",
  "epic-icon-add": "epic__epic-icon-add__74f",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__edc",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__b5b",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__b42",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__625",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__24b",
  "epic-icon-calendar": "epic__epic-icon-calendar__a29",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__950",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__993",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__87e",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__486",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__907",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__041",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__ce4",
  "epic-icon-close-x": "epic__epic-icon-close-x__1c6",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__612",
  "epic-icon-confluence": "epic__epic-icon-confluence__e96",
  "epic-icon-contact": "epic__epic-icon-contact__3b4",
  "epic-icon-delete": "epic__epic-icon-delete__b98",
  "epic-icon-edit": "epic__epic-icon-edit__1ff",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__5f8",
  "epic-icon-filter": "epic__epic-icon-filter__f27",
  "epic-icon-github": "epic__epic-icon-github__9d7",
  "epic-icon-information": "epic__epic-icon-information__957",
  "epic-icon-jira": "epic__epic-icon-jira__107",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__555",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__07d",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__f33",
  "epic-icon-preview": "epic__epic-icon-preview__710",
  "epic-icon-profile": "epic__epic-icon-profile__a79",
  "epic-icon-quotes": "epic__epic-icon-quotes__179",
  "epic-icon-search": "epic__epic-icon-search__4bd",
  "epic-icon-share": "epic__epic-icon-share__881",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__ad8",
  "epic-icon-slack": "epic__epic-icon-slack__25c",
  "epic-icon-steps": "epic__epic-icon-steps__cb0",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__1e4",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__a43",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__05f",
  "epic-icon-warning": "epic__epic-icon-warning__8c8",
  "epic-font-base": "epic__epic-font-base__489",
  "epic-font-base-md": "epic__epic-font-base-md__62d",
  "epic-font-marketing": "epic__epic-font-marketing__0b9",
  "epic-font-brand": "epic__epic-font-brand__915",
  ripple: ripple$1,
  toggle,
  toggleItem
};
let id = 0;
function ToggleOption({
  name: name2,
  onChange,
  option,
  value,
  clearable
}) {
  id = id++;
  return /* @__PURE__ */ jsxs("div", {
    className: styles$1.toggleItem,
    children: [/* @__PURE__ */ jsx$1("input", {
      type: "radio",
      name: name2,
      id: `er-toggle-switch-${id}`,
      checked: option.value === value,
      readOnly: true
    }), /* @__PURE__ */ jsx$1("label", {
      className: "epic-font-base-md",
      onClick: () => onChange(option.value === value ? clearable ? null : option.value : option.value),
      htmlFor: `er-toggle-switch-${id}`,
      children: option.label
    })]
  });
}
const ToggleSwitch = (_U) => {
  var _V = _U, {
    label: label2,
    required: required2,
    hasErrors: hasErrors2,
    errorMessage,
    options,
    className = ""
  } = _V, props = __objRest(_V, [
    "label",
    "required",
    "hasErrors",
    "errorMessage",
    "options",
    "className"
  ]);
  return /* @__PURE__ */ jsx$1(Label$1, {
    label: label2,
    required: !!required2,
    hasErrors: hasErrors2,
    errorMessage,
    children: /* @__PURE__ */ jsx$1("span", {
      className: `${styles$1.toggle} ${className}`,
      children: options.map((option) => /* @__PURE__ */ jsx$1(ToggleOption, __spreadValues({
        option
      }, props), option.value))
    })
  });
};
ToggleSwitch.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.object]),
  required: PropTypes.bool,
  hasErrors: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })).isRequired,
  className: PropTypes.string,
  clearable: PropTypes.bool
};
ToggleSwitch.defaultProps = {
  clearable: false,
  className: "",
  options: []
};
const icon = "epic__icon__db9";
const ripple = "epic__ripple__e7d";
const noData = "epic__noData__7ba";
const title = "epic__title__b88";
const filterDropdownWrapper = "epic__filterDropdownWrapper__3d8";
const filterDropdown = "epic__filterDropdown__f46";
const filterCount = "epic__filterCount__2d0";
const columnFilterWrapper = "epic__columnFilterWrapper__6b9";
const columnFilterDropdown = "epic__columnFilterDropdown__009";
const paginationControls = "epic__paginationControls__b82";
const table = "epic__table__5b1";
const thead = "epic__thead__ce3";
const tr = "epic__tr__da0";
const th = "epic__th__715";
const tbody = "epic__tbody__405";
const td = "epic__td__f82";
const isSorted = "epic__isSorted__531";
const filterCheckboxes = "epic__filterCheckboxes__bd3";
const checkboxFilter = "epic__checkboxFilter__db8";
const bulkSelect = "epic__bulkSelect__00b";
const selected = "epic__selected__76c";
const subtitle = "epic__subtitle__768";
const pageSizeSelect = "epic__pageSizeSelect__e2e";
const filtersSection = "epic__filtersSection__3bf";
const filtersInfo = "epic__filtersInfo__ded";
const filtersClearSelected = "epic__filtersClearSelected__662";
const section = "epic__section__c87";
const selectionSection = "epic__selectionSection__c0e";
const hideSelectionSection = "epic__hideSelectionSection__806";
const caretButton = "epic__caretButton__fe4";
const navigation = "epic__navigation__b5c";
const firstLast = "epic__firstLast__b9f";
const colorActive = "epic__colorActive__b57";
const colorDisabled = "epic__colorDisabled__3ff";
const pageNumbers = "epic__pageNumbers__bc4";
const active = "epic__active__03a";
const inverse = "epic__inverse__bed";
const sortAsc = "epic__sortAsc__740";
const sortDesc = "epic__sortDesc__e95";
const sortIcon = "epic__sortIcon__636";
const compactCell = "epic__compactCell__6f5";
const expander = "epic__expander__492";
const canSort = "epic__canSort__a46";
const searchFilterSection = "epic__searchFilterSection__3eb";
const searchBarSectionLabel = "epic__searchBarSectionLabel__0be";
const searchBarSection = "epic__searchBarSection__779";
const filters = "epic__filters__3a8";
const filterDropdownButton = "epic__filterDropdownButton__96f";
const actionInput = "epic__actionInput__42c";
const resetDisabled = "epic__resetDisabled__fbb";
const indeterminateInput = "epic__indeterminateInput__d28";
const columnFilterDropdownVisible = "epic__columnFilterDropdownVisible__326";
const isLoading = "epic__isLoading__12d";
const scrollTable = "epic__scrollTable__282";
const additionalSection = "epic__additionalSection__6b5";
const withCheckboxColumn = "epic__withCheckboxColumn__210";
const bulkSelectRowActive = "epic__bulkSelectRowActive__de0";
const iconButton = "epic__iconButton__44d";
var styles = {
  icon,
  "epic-icon": "epic__epic-icon__098",
  "epic-icon-add": "epic__epic-icon-add__a6d",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__ff1",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__f55",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__ba9",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__d93",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__5ec",
  "epic-icon-calendar": "epic__epic-icon-calendar__ba1",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__961",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__2fc",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__bf6",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__e71",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__d2d",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__562",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__44b",
  "epic-icon-close-x": "epic__epic-icon-close-x__a70",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__c3f",
  "epic-icon-confluence": "epic__epic-icon-confluence__cad",
  "epic-icon-contact": "epic__epic-icon-contact__517",
  "epic-icon-delete": "epic__epic-icon-delete__09b",
  "epic-icon-edit": "epic__epic-icon-edit__5e3",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__1b7",
  "epic-icon-filter": "epic__epic-icon-filter__9fe",
  "epic-icon-github": "epic__epic-icon-github__c32",
  "epic-icon-information": "epic__epic-icon-information__1bc",
  "epic-icon-jira": "epic__epic-icon-jira__061",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__ebc",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__53f",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__97e",
  "epic-icon-preview": "epic__epic-icon-preview__272",
  "epic-icon-profile": "epic__epic-icon-profile__de7",
  "epic-icon-quotes": "epic__epic-icon-quotes__c0f",
  "epic-icon-search": "epic__epic-icon-search__4e6",
  "epic-icon-share": "epic__epic-icon-share__b12",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__1d5",
  "epic-icon-slack": "epic__epic-icon-slack__f35",
  "epic-icon-steps": "epic__epic-icon-steps__5b6",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__d74",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__0c7",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__475",
  "epic-icon-warning": "epic__epic-icon-warning__8f6",
  "epic-font-base": "epic__epic-font-base__ac7",
  "epic-font-base-md": "epic__epic-font-base-md__461",
  "epic-font-marketing": "epic__epic-font-marketing__762",
  "epic-font-brand": "epic__epic-font-brand__29c",
  ripple,
  "epic-display-base": "epic__epic-display-base__bfc",
  "epic-display-1": "epic__epic-display-1__337",
  "epic-display-2": "epic__epic-display-2__4b6",
  "epic-display-3": "epic__epic-display-3__17a",
  "epic-display-4": "epic__epic-display-4__6b3",
  "epic-display-5": "epic__epic-display-5__29f",
  "epic-title-base": "epic__epic-title-base__6c4",
  "epic-title-1": "epic__epic-title-1__b2a",
  "epic-title-2": "epic__epic-title-2__4dd",
  "epic-title-3": "epic__epic-title-3__827",
  "epic-title-4": "epic__epic-title-4__0f5",
  "epic-title-5": "epic__epic-title-5__c80",
  "epic-title-6": "epic__epic-title-6__807",
  noData,
  title,
  filterDropdownWrapper,
  filterDropdown,
  filterCount,
  columnFilterWrapper,
  columnFilterDropdown,
  "epic-subtitle-base": "epic__epic-subtitle-base__4f0",
  "epic-subtitle-1": "epic__epic-subtitle-1__833",
  "epic-subtitle-2": "epic__epic-subtitle-2__6ea",
  "epic-subtitle-3": "epic__epic-subtitle-3__3a5",
  paginationControls,
  table,
  thead,
  tr,
  th,
  tbody,
  td,
  isSorted,
  filterCheckboxes,
  checkboxFilter,
  bulkSelect,
  selected,
  "epic-body-text-base": "epic__epic-body-text-base__136",
  "epic-body-text-1": "epic__epic-body-text-1__79d",
  "epic-body-text-2": "epic__epic-body-text-2__863",
  "epic-body-text": "epic__epic-body-text__50c",
  "epic-body-text-3": "epic__epic-body-text-3__39b",
  subtitle,
  "epic-legal-text": "epic__epic-legal-text__e82",
  "epic-label-text": "epic__epic-label-text__6ea",
  "epic-button-base": "epic__epic-button-base__2a4",
  "epic-button-1": "epic__epic-button-1__bf7",
  "epic-button-2": "epic__epic-button-2__0de",
  "epic-button-3": "epic__epic-button-3__7fb",
  pageSizeSelect,
  filtersSection,
  filtersInfo,
  filtersClearSelected,
  section,
  selectionSection,
  hideSelectionSection,
  caretButton,
  navigation,
  firstLast,
  colorActive,
  colorDisabled,
  pageNumbers,
  active,
  inverse,
  sortAsc,
  sortDesc,
  sortIcon,
  compactCell,
  expander,
  canSort,
  searchFilterSection,
  searchBarSectionLabel,
  searchBarSection,
  filters,
  filterDropdownButton,
  actionInput,
  resetDisabled,
  indeterminateInput,
  columnFilterDropdownVisible,
  isLoading,
  scrollTable,
  additionalSection,
  withCheckboxColumn,
  bulkSelectRowActive,
  iconButton
};
function SearchBar({
  globalFilter,
  setGlobalFilter,
  searchBarPlaceholder,
  searchBarLabel,
  maxLength
}) {
  return /* @__PURE__ */ jsx$1(GlobalFilter, {
    filter: globalFilter,
    setFilter: setGlobalFilter,
    placeholderText: searchBarPlaceholder,
    label: searchBarLabel,
    maxLength
  });
}
function FilterButton({
  filterCount: filterCount2,
  handleFilterBtnClick
}) {
  return /* @__PURE__ */ jsx$1(IconButton, {
    type: "Filter",
    onClick: handleFilterBtnClick,
    children: `Filters${filterCount2 > 0 ? ` ${filterCount2}` : ""}`
  });
}
function FilterSection({
  showAllFilters,
  setShowAllFilters,
  filters: filters2,
  selectedFilters,
  handleChangeSelectedFilters,
  handleSelectAllFilters,
  handleClearSelectedFilters,
  filterFilterQueries,
  handleUpdateFilterFilterQuery
}) {
  const firstLevelNum = 5;
  const visibleFilters = showAllFilters ? filters2 : filters2.slice(0, firstLevelNum);
  return /* @__PURE__ */ jsxs("div", {
    className: styles.filtersSection,
    children: [/* @__PURE__ */ jsx$1("div", {
      className: styles.filtersInfo,
      children: /* @__PURE__ */ jsx$1("p", {
        children: /* @__PURE__ */ jsx$1("a", {
          onClick: () => handleClearSelectedFilters(),
          children: "Clear Filters"
        })
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: styles.filters,
      children: [visibleFilters.map((v) => {
        const filterGroupName = v.name;
        const filterGroup = v.accessor;
        const selected2 = selectedFilters[filterGroup] || [];
        const selectedCount = selected2.length;
        const filterFilterQuery = filterFilterQueries[filterGroup] || "";
        return /* @__PURE__ */ jsx$1(FilterDropdown, {
          dropdownFilters: v,
          selected: selected2,
          selectedCount,
          handleChangeSelectedFilters,
          handleSelectAllFilters,
          handleClearSelectedFilters,
          filterFilterQuery,
          handleUpdateFilterFilterQuery,
          filterGroup,
          filterGroupName,
          children: /* @__PURE__ */ jsxs(Button$1, {
            inverse: true,
            className: styles.filterDropdownButton,
            children: [`${filterGroupName}${selectedCount > 0 ? ` (${selectedCount})` : ""}`, /* @__PURE__ */ jsx$1(Icon, {
              type: "chevron-down"
            })]
          })
        }, v.accessor);
      }), filters2.length > firstLevelNum && /* @__PURE__ */ jsx$1(Button$1, {
        onClick: () => setShowAllFilters(!showAllFilters),
        inverse: true,
        children: `Show ${filters2.length - firstLevelNum} ${showAllFilters ? "Less" : "More"}`
      })]
    })]
  });
}
function FilterDropdown({
  children,
  dropdownFilters,
  selected: selected2,
  selectedCount,
  handleChangeSelectedFilters,
  handleSelectAllFilters,
  handleClearSelectedFilters,
  filterFilterQuery,
  handleUpdateFilterFilterQuery,
  filterGroup,
  filterGroupName
}) {
  const dropdownFilterCount = dropdownFilters.filters.length;
  const hasFilterFilters = dropdownFilters.isControlled || dropdownFilterCount >= 15;
  const hasActiveFilterQuery = !!filterFilterQuery.length;
  const visibleFilterValues = dropdownFilters.isControlled ? dropdownFilters.filters : hasFilterFilters && hasActiveFilterQuery ? dropdownFilters.filters.filter((filter) => filter.name.toLowerCase().includes(filterFilterQuery.toLowerCase())) : dropdownFilters.filters || [];
  const dropdownVisibleFilterCount = visibleFilterValues.length;
  return /* @__PURE__ */ jsxs("div", {
    className: styles.filterDropdownWrapper,
    children: [children, /* @__PURE__ */ jsxs("div", {
      className: styles.filterDropdown,
      children: [/* @__PURE__ */ jsx$1("p", {
        className: styles.filterCount,
        children: `${filterGroupName} (${selectedCount}/${dropdownFilterCount})`
      }), hasFilterFilters && /* @__PURE__ */ jsx$1(ActionInput, {
        className: styles.actionInput,
        ariaLabel: "dropdownFilter",
        value: filterFilterQuery,
        onChange: (e) => handleUpdateFilterFilterQuery(filterGroup, e),
        isPending: dropdownFilters.isFetching,
        placeholder: dropdownFilters.searchBarPlaceholder
      }), /* @__PURE__ */ jsxs("div", {
        className: styles.filterCheckboxes,
        children: [dropdownVisibleFilterCount > 0 ? /* @__PURE__ */ jsx$1(Checkbox, {
          className: styles.checkboxFilter,
          label: hasActiveFilterQuery ? `Select ${dropdownVisibleFilterCount} Matched` : `Select All ${dropdownVisibleFilterCount}`,
          checked: !visibleFilterValues.filter((x) => !selected2.includes(x.accessor)).length,
          onChange: () => handleSelectAllFilters(filterGroup, visibleFilterValues)
        }) : /* @__PURE__ */ jsx$1("p", {
          children: "No matches"
        }), visibleFilterValues.map((v) => {
          return /* @__PURE__ */ jsx$1(Checkbox, {
            className: styles.checkboxFilter,
            label: v.name,
            name: v.accessor,
            checked: selected2.includes(v.accessor) || false,
            onChange: (e) => handleChangeSelectedFilters(filterGroup, e)
          }, `${filterGroup}-${v.accessor}`);
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: styles.filtersClearSelected,
        children: /* @__PURE__ */ jsx$1("p", {
          children: selectedCount > 0 ? /* @__PURE__ */ jsx$1("a", {
            onClick: () => handleClearSelectedFilters(filterGroup),
            children: `Clear ${selectedCount} Selected`
          }) : "Clear Selected"
        })
      })]
    })]
  });
}
function ColumnFilterButton({
  columns,
  toggleAll,
  columnFilterVisible,
  setColumnFilterVisible,
  columnFilterQuery,
  setColumnFilterQuery,
  withSelectableRows
}) {
  const handleClick = () => {
    setColumnFilterVisible(!columnFilterVisible);
  };
  const handleOnClear = () => {
    setColumnFilterQuery("");
  };
  const handleBlur = () => {
    setColumnFilterVisible(false);
  };
  const usableColumns = withSelectableRows ? columns.slice(1) : columns;
  const queryFilteredColumns = columnFilterQuery ? usableColumns.filter((c) => {
    var _a;
    return (_a = c.Header) == null ? void 0 : _a.toLowerCase().includes(columnFilterQuery.toLowerCase());
  }) : usableColumns || [];
  const visibleColumnsCount = usableColumns.reduce((a, b) => {
    return b.isVisible ? a : a - 1;
  }, usableColumns.length);
  const allColumnsVisible = visibleColumnsCount === usableColumns.length;
  return /* @__PURE__ */ jsxs("div", {
    className: styles.columnFilterWrapper,
    children: [/* @__PURE__ */ jsx$1(IconButton, {
      type: "PlusMinus",
      onClick: handleClick,
      children: "Columns"
    }), /* @__PURE__ */ jsxs("div", {
      className: classnames$1(styles.columnFilterDropdown, columnFilterVisible && styles.columnFilterDropdownVisible),
      tabIndex: "0",
      onMouseLeave: handleBlur,
      children: [/* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsxs("div", {
          children: ["Columns (", visibleColumnsCount, "/", usableColumns.length, ")"]
        }), columns.length > 15 && /* @__PURE__ */ jsx$1(ActionInput, {
          className: styles.actionInput,
          ariaLabel: "columnFilter",
          value: columnFilterQuery,
          onChange: (e) => setColumnFilterQuery(e.target.value),
          onClear: handleOnClear
        }), /* @__PURE__ */ jsx$1("div", {
          className: styles.filterCheckboxes,
          children: queryFilteredColumns.map((c) => /* @__PURE__ */ jsx$1(Checkbox, __spreadValues({
            className: styles.checkboxFilter,
            label: c.Header,
            name: c.id
          }, c.getToggleHiddenProps()), c.id))
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        children: /* @__PURE__ */ jsxs("label", {
          className: allColumnsVisible && styles.resetDisabled,
          children: [/* @__PURE__ */ jsx$1(IndeterminateCheckboxAlt, __spreadProps(__spreadValues({
            className: styles.indeterminateInput
          }, toggleAll()), {
            disabled: allColumnsVisible
          })), /* @__PURE__ */ jsx$1("span", {
            children: "Reset"
          })]
        })
      })]
    })]
  });
}
function GlobalFilter({
  filter,
  setFilter,
  placeholderText,
  maxLength,
  label: label2
}) {
  return /* @__PURE__ */ jsxs("div", {
    className: styles.searchBarSection,
    children: [/* @__PURE__ */ jsx$1(ActionInput, {
      value: filter || "",
      onChange: (e) => setFilter(e.target.value),
      placeholder: placeholderText,
      ariaLabel: "GlobalTableFilter",
      id: "GlobalTableFilter",
      maxLength
    }), label2 && /* @__PURE__ */ jsx$1(Label$1, {
      className: styles.searchBarSectionLabel,
      htmlFor: "GlobalTableFilter",
      children: label2
    })]
  });
}
function getPagingRange(currentPage, {
  minLink = 1,
  pageCount = 10,
  linkCount = 5
} = {}) {
  if (linkCount > pageCount)
    linkCount = pageCount;
  let start2 = currentPage - Math.floor(linkCount / 2);
  start2 = Math.max(start2, minLink);
  start2 = Math.min(start2, minLink + pageCount - linkCount);
  return Array.from({
    length: linkCount
  }, (_, i) => start2 + i);
}
function PaginationNumbers({
  gotoPage,
  pageIndex,
  pageCount,
  onPageClick
}) {
  return /* @__PURE__ */ jsx$1(Fragment, {
    children: getPagingRange(pageIndex + 1, {
      pageCount
    }).map((gotoPageNum) => {
      const isActive = gotoPageNum === pageIndex + 1;
      return /* @__PURE__ */ jsx$1("div", {
        "data-testid": `page-number-${gotoPageNum}`,
        className: classnames$1(styles.pageNumbers, isActive && styles.active),
        onClick: () => {
          gotoPage(gotoPageNum - 1);
          onPageClick({
            pageIndex: gotoPageNum - 1
          });
        },
        children: gotoPageNum
      }, gotoPageNum);
    })
  });
}
function PaginationControls({
  canPreviousPage,
  previousPage,
  canNextPage,
  nextPage,
  pageIndex,
  totalRowCount,
  gotoPage,
  pageCount,
  pageSize,
  setPageSize,
  pageSizeOptions,
  onPageClick = (pageIndex2) => pageIndex2,
  inverse: inverse2 = false,
  className,
  pageSizeLabel = "Rows Per Page:",
  allowPageSizeChange = true,
  selectDropdownMenuPlacement
}) {
  const paginationNumbersProps = {
    gotoPage,
    pageIndex,
    pageCount,
    onPageClick
  };
  const goToFirstPage = () => gotoPage(0);
  const goToLastPage = () => gotoPage(pageCount - 1);
  const currentPageStart = pageIndex * pageSize + 1;
  const currentPageEnd = pageIndex * pageSize + pageSize;
  return /* @__PURE__ */ jsxs("div", {
    className: classnames$1(className, styles.paginationControls, inverse2 && styles.inverse),
    children: [/* @__PURE__ */ jsx$1("div", {
      className: styles.section,
      children: /* @__PURE__ */ jsxs("div", {
        children: [currentPageStart && currentPageEnd ? `${currentPageStart}-${currentPageEnd}` : null, currentPageStart && currentPageEnd && totalRowCount ? " of " : null, totalRowCount ? `${totalRowCount} Results` : null]
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: classnames$1(styles.section, styles.navigation),
      children: [/* @__PURE__ */ jsx$1("div", {
        className: styles.firstLast,
        onClick: goToFirstPage,
        children: "First"
      }), /* @__PURE__ */ jsx$1(IconButton, {
        bare: true,
        type: "CaretLeft",
        iconClassName: chevronColor(canPreviousPage),
        buttonClassName: styles.caretButton,
        onClick: () => previousPage(),
        disabled: !canPreviousPage
      }), /* @__PURE__ */ jsx$1(PaginationNumbers, __spreadValues({}, paginationNumbersProps)), /* @__PURE__ */ jsx$1(IconButton, {
        bare: true,
        type: "CaretRight",
        iconClassName: chevronColor(canNextPage),
        buttonClassName: styles.caretButton,
        onClick: () => nextPage(),
        disabled: !canNextPage
      }), /* @__PURE__ */ jsx$1("div", {
        className: styles.firstLast,
        onClick: goToLastPage,
        children: "Last"
      })]
    }), /* @__PURE__ */ jsx$1("div", {
      className: classnames$1(styles.section, styles.selectionSection, !allowPageSizeChange && styles.hideSelectionSection),
      children: /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx$1("div", {
          className: styles.label,
          children: pageSizeLabel
        }), /* @__PURE__ */ jsx$1("div", {
          className: styles.pageSizeSelect,
          children: /* @__PURE__ */ jsx$1(Select, {
            inverse: inverse2,
            border: false,
            options: pageSizeOptions.map((sizeOpt) => ({
              value: sizeOpt,
              label: sizeOpt.toString()
            })),
            value: {
              value: Number(pageSize),
              label: pageSize.toString()
            },
            onChange: (selected2) => setPageSize(selected2.value),
            menuPlacement: selectDropdownMenuPlacement
          })
        })]
      })
    })]
  });
}
PaginationControls.propTypes = {
  canPreviousPage: PropTypes.bool,
  previousPage: PropTypes.func,
  canNextPage: PropTypes.bool,
  nextPage: PropTypes.func,
  pageIndex: PropTypes.number,
  totalRowCount: PropTypes.number,
  gotoPage: PropTypes.func,
  onPageClick: PropTypes.func,
  pageCount: PropTypes.number,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  inverse: PropTypes.bool,
  pageSizeLabel: PropTypes.string,
  allowPageSizeChange: PropTypes.bool,
  selectDropdownMenuPlacement: PropTypes.string
};
function Pagination({
  page,
  prepareRow,
  isCompact
}) {
  return page.map((row, rowIx) => {
    prepareRow(row);
    return /* @__PURE__ */ jsx$1(Tr, __spreadProps(__spreadValues({}, row.getRowProps()), {
      children: row.cells.map((cell, cellIx) => {
        return /* @__PURE__ */ jsx$1(Td, __spreadProps(__spreadValues({}, cell.getCellProps()), {
          className: isCompact && styles.compactCell,
          children: cell.render("Cell")
        }), `body-cell-${cellIx}`);
      })
    }), `body-row-${rowIx}`);
  });
}
function NoPagination({
  rows,
  prepareRow,
  isCompact,
  getChildRows,
  expanderCell,
  onRowClick
}) {
  return rows.map((row, rowIx) => {
    prepareRow(row);
    const _a = row.getRowProps(), {
      key: rowKey
    } = _a, rowProps = __objRest(_a, [
      "key"
    ]);
    return /* @__PURE__ */ jsxs(React__default.Fragment, {
      children: [/* @__PURE__ */ jsx$1(Tr, __spreadProps(__spreadValues({
        rowindex: rowIx,
        rowRecord: row.original,
        onClick: onRowClick
      }, rowProps), {
        children: row.cells.map((cell, cellIx) => {
          return /* @__PURE__ */ jsx$1(Td, __spreadProps(__spreadValues({}, cell.getCellProps()), {
            className: classnames$1({
              [styles.compactCell]: isCompact,
              [cell.column.className]: cell.column.className,
              [styles.isSorted]: cell.column.isSorted || cell.column.isSortedDesc
            }),
            children: cell.render("Cell")
          }), `body-cell-${cellIx}`);
        })
      }), `body-row-${rowIx}`), row.isExpanded ? getChildRows({
        row,
        expanderCell
      }) : null]
    }, rowKey);
  });
}
function NoDataRow({
  title: title2 = "No Data Found",
  subtitle: subtitle2 = "Try to adjust your search or filters"
}) {
  return /* @__PURE__ */ jsxs("div", {
    className: styles.noData,
    children: [/* @__PURE__ */ jsx$1("div", {
      className: styles.title,
      children: title2
    }), /* @__PURE__ */ jsx$1("div", {
      className: styles.subtitle,
      children: subtitle2
    })]
  });
}
function LoadingRow({
  message = "Loading...",
  isCompact
}) {
  return /* @__PURE__ */ jsx$1(Tr, {
    children: /* @__PURE__ */ jsx$1(Td, {
      className: classnames$1(styles.isLoading, isCompact && styles.compactCell),
      colSpan: "10000",
      children: message
    })
  });
}
function TableContainer(_W) {
  var _X = _W, {
    className
  } = _X, props = __objRest(_X, [
    "className"
  ]);
  return /* @__PURE__ */ jsx$1("table", __spreadProps(__spreadValues({}, props), {
    className: `${styles.table} ${className || ""}`
  }));
}
function Thead(_Y) {
  var _Z = _Y, {
    className
  } = _Z, props = __objRest(_Z, [
    "className"
  ]);
  return /* @__PURE__ */ jsx$1("thead", __spreadProps(__spreadValues({}, props), {
    className: `${styles.thead} ${className || ""}`
  }));
}
function Th(__) {
  var _$ = __, {
    isSorted: isSorted2,
    isSortedDesc,
    className
  } = _$, props = __objRest(_$, [
    "isSorted",
    "isSortedDesc",
    "className"
  ]);
  const mergedClassname = `${styles.th} ${isSorted2 ? isSortedDesc ? styles.sortDesc : styles.sortAsc : ""} ${className || ""}`;
  return /* @__PURE__ */ jsx$1("th", __spreadProps(__spreadValues({
    role: "columnheader"
  }, props), {
    className: mergedClassname
  }));
}
function Tbody(_aa) {
  var _ba = _aa, {
    className
  } = _ba, props = __objRest(_ba, [
    "className"
  ]);
  return /* @__PURE__ */ jsx$1("tbody", __spreadProps(__spreadValues({}, props), {
    className: `${styles.tbody} ${className || ""}`
  }));
}
function Tr(_ca) {
  var _da = _ca, {
    className,
    onClick,
    rowRecord
  } = _da, props = __objRest(_da, [
    "className",
    "onClick",
    "rowRecord"
  ]);
  let cursorStyle = onClick ? {
    cursor: "pointer"
  } : {};
  return /* @__PURE__ */ jsx$1("tr", __spreadValues({
    role: "row",
    style: cursorStyle,
    className: classnames$1(styles.tr, styles.rowClick, className),
    onClick: () => onClick == null ? void 0 : onClick(rowRecord)
  }, props));
}
function Td(_ea) {
  var _fa = _ea, {
    className
  } = _fa, props = __objRest(_fa, [
    "className"
  ]);
  return /* @__PURE__ */ jsx$1("td", __spreadProps(__spreadValues({
    role: "cell"
  }, props), {
    className: `${styles.td} ${className || ""}`
  }));
}
const chevronColor = (isActive) => {
  return isActive ? styles.colorActive : styles.colorDisabled;
};
const SortAscending = /* @__PURE__ */ jsx$1(Icon, {
  type: "SortAscending",
  size: "s",
  className: styles.sortIcon
});
const SortDescending = /* @__PURE__ */ jsx$1(Icon, {
  type: "SortDescending",
  size: "s",
  className: styles.sortIcon
});
function createHeaderCell(column) {
  const {
    render: render3,
    isSorted: isSorted2,
    isSortedDesc,
    canSort: canSort2
  } = column;
  if (!canSort2)
    return render3("Header");
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [isSorted2 ? isSortedDesc ? SortDescending : SortAscending : "", render3("Header")]
  });
}
function TableHeader({
  headerGroups,
  isCompact
}) {
  return /* @__PURE__ */ jsx$1(Thead, {
    children: headerGroups.map((headerGroup, rowIx) => /* @__PURE__ */ jsx$1(Tr, __spreadProps(__spreadValues({}, headerGroup.getHeaderGroupProps()), {
      children: headerGroup.headers.map((column, cellIx) => /* @__PURE__ */ createElement(Th, __spreadProps(__spreadValues({}, column.getHeaderProps(column.getSortByToggleProps())), {
        isSorted: column.isSorted,
        isSortedDesc: column.isSortedDesc,
        key: `head-cell-${cellIx}`,
        className: classnames$1({
          [styles.canSort]: column.canSort,
          [styles.compactCell]: isCompact,
          [column.className]: column.className
        })
      }), createHeaderCell(column)))
    }), `head-row-${rowIx}`))
  });
}
function BulkSelectRow({
  children,
  selectedFlatRows,
  toggleAllRowsSelected
}) {
  return /* @__PURE__ */ jsxs("div", {
    className: styles.bulkSelect,
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles.selected,
      children: [/* @__PURE__ */ jsx$1(Icon, {
        type: "Close",
        onClick: () => toggleAllRowsSelected(false)
      }), selectedFlatRows.length, " Selected"]
    }), /* @__PURE__ */ jsx$1("div", {
      className: styles.additionalSection,
      children
    })]
  });
}
const IndeterminateCheckbox = React__default.forwardRef((_ga, ref) => {
  var _ha = _ga, {
    indeterminate: indeterminate2
  } = _ha, rest = __objRest(_ha, [
    "indeterminate"
  ]);
  const defaultRef = React__default.useRef();
  const resolvedRef = ref || defaultRef;
  React__default.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate2;
  }, [resolvedRef, indeterminate2]);
  return /* @__PURE__ */ jsx$1(Checkbox, __spreadValues({
    type: "checkbox",
    ref: resolvedRef
  }, rest));
});
const IndeterminateCheckboxAlt = React__default.forwardRef((_ia, ref) => {
  var _ja = _ia, {
    indeterminate: indeterminate2
  } = _ja, rest = __objRest(_ja, [
    "indeterminate"
  ]);
  const defaultRef = React__default.useRef();
  const resolvedRef = ref || defaultRef;
  React__default.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate2;
  }, [resolvedRef, indeterminate2]);
  return /* @__PURE__ */ jsx$1("input", __spreadValues({
    type: "checkbox",
    ref: resolvedRef
  }, rest));
});
function StaticTable({
  className,
  columns,
  data,
  isCompact
}) {
  const rowOrder = columns.map(({
    accessor
  }) => accessor);
  if (columns.length === 0)
    return null;
  return /* @__PURE__ */ jsxs(TableContainer, __spreadProps(__spreadValues({}, className), {
    children: [/* @__PURE__ */ jsx$1(Thead, {
      children: /* @__PURE__ */ jsx$1(Tr, {
        children: columns.map(({
          Header
        }, i) => /* @__PURE__ */ jsx$1(Th, {
          className: isCompact && styles.compactCell,
          children: Header
        }, i))
      })
    }), /* @__PURE__ */ jsx$1(Tbody, {
      children: data.map((rowData, ix) => {
        return /* @__PURE__ */ jsx$1(Tr, {
          children: rowOrder.map((cellData, jx) => /* @__PURE__ */ jsx$1(Td, {
            className: isCompact && styles.compactCell,
            children: rowData[cellData]
          }, `${ix}-${jx}`))
        }, `${ix}`);
      })
    })]
  }));
}
StaticTable.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape({
    Header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    accessor: PropTypes.string
  })).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  isCompact: PropTypes.bool
};
StaticTable.defaultProps = {
  columns: [],
  data: [],
  className: "",
  isCompact: false
};
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(module, exports) {
  (function() {
    var undefined$12;
    var VERSION = "4.17.21";
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar2 = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo, "g");
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      "\xC0": "A",
      "\xC1": "A",
      "\xC2": "A",
      "\xC3": "A",
      "\xC4": "A",
      "\xC5": "A",
      "\xE0": "a",
      "\xE1": "a",
      "\xE2": "a",
      "\xE3": "a",
      "\xE4": "a",
      "\xE5": "a",
      "\xC7": "C",
      "\xE7": "c",
      "\xD0": "D",
      "\xF0": "d",
      "\xC8": "E",
      "\xC9": "E",
      "\xCA": "E",
      "\xCB": "E",
      "\xE8": "e",
      "\xE9": "e",
      "\xEA": "e",
      "\xEB": "e",
      "\xCC": "I",
      "\xCD": "I",
      "\xCE": "I",
      "\xCF": "I",
      "\xEC": "i",
      "\xED": "i",
      "\xEE": "i",
      "\xEF": "i",
      "\xD1": "N",
      "\xF1": "n",
      "\xD2": "O",
      "\xD3": "O",
      "\xD4": "O",
      "\xD5": "O",
      "\xD6": "O",
      "\xD8": "O",
      "\xF2": "o",
      "\xF3": "o",
      "\xF4": "o",
      "\xF5": "o",
      "\xF6": "o",
      "\xF8": "o",
      "\xD9": "U",
      "\xDA": "U",
      "\xDB": "U",
      "\xDC": "U",
      "\xF9": "u",
      "\xFA": "u",
      "\xFB": "u",
      "\xFC": "u",
      "\xDD": "Y",
      "\xFD": "y",
      "\xFF": "y",
      "\xC6": "Ae",
      "\xE6": "ae",
      "\xDE": "Th",
      "\xFE": "th",
      "\xDF": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u010E": "D",
      "\u0110": "D",
      "\u010F": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011A": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011B": "e",
      "\u011C": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011D": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u012E": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u012F": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013B": "L",
      "\u013D": "L",
      "\u013F": "L",
      "\u0141": "L",
      "\u013A": "l",
      "\u013C": "l",
      "\u013E": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014A": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014B": "n",
      "\u014C": "O",
      "\u014E": "O",
      "\u0150": "O",
      "\u014D": "o",
      "\u014F": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015A": "S",
      "\u015C": "S",
      "\u015E": "S",
      "\u0160": "S",
      "\u015B": "s",
      "\u015D": "s",
      "\u015F": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016A": "U",
      "\u016C": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016B": "u",
      "\u016D": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u017A": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017F": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        var value = array[index2];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }
    function arrayEach(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (iteratee(array[index2], index2, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;
      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (!predicate(array[index2], index2, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (predicate(value, index2, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    function arrayIncludesWith(array, value, comparator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (comparator(value, array[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
      while (++index2 < length) {
        result[index2] = iteratee(array[index2], index2, array);
      }
      return result;
    }
    function arrayPush(array, values) {
      var index2 = -1, length = values.length, offset2 = array.length;
      while (++index2 < length) {
        array[offset2 + index2] = values[index2];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index2 = -1, length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[++index2];
      }
      while (++index2 < length) {
        accumulator = iteratee(accumulator, array[index2], index2, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }
    function arraySome(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty("length");
    function asciiToArray(string) {
      return string.split("");
    }
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (comparator(array[index2], value)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$12 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$12 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result, index2 = -1, length = array.length;
      while (++index2 < length) {
        var current = iteratee(array[index2]);
        if (current !== undefined$12) {
          result = result === undefined$12 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes(n2, iteratee) {
      var index2 = -1, result = Array(n2);
      while (++index2 < n2) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseToPairs(object, props) {
      return arrayMap(props, function(key) {
        return [key, object[key]];
      });
    }
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues(object, props) {
      return arrayMap(props, function(key) {
        return object[key];
      });
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length = strSymbols.length;
      while (++index2 < length && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array, placeholder) {
      var length = array.length, result = 0;
      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue(object, key) {
      return object == null ? undefined$12 : object[key];
    }
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }
    function iteratorToArray(iterator) {
      var data, result = [];
      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }
    function mapToArray(map) {
      var index2 = -1, result = Array(map.size);
      map.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index2 = -1, length = array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index2] = PLACEHOLDER;
          result[resIndex++] = index2;
        }
      }
      return result;
    }
    function setToArray(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    function setToPairs(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array, value, fromIndex) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    function trimmedEndIndex(string) {
      var index2 = string.length;
      while (index2-- && reWhitespace.test(string.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
      var coreJsData = context["__core-js_shared__"];
      var funcToString = funcProto.toString;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString = objectProto.toString;
      var objectCtorString = funcToString.call(Object2);
      var oldDash = root._;
      var reIsNative = RegExp2("^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      var Buffer2 = moduleExports ? context.Buffer : undefined$12, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined$12, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$12, symIterator = Symbol2 ? Symbol2.iterator : undefined$12, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$12;
      var defineProperty2 = function() {
        try {
          var func = getNative(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined$12, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
      var DataView2 = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
      var metaMap = WeakMap2 && new WeakMap2();
      var realNames = {};
      var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
      var symbolProto = Symbol2 ? Symbol2.prototype : undefined$12, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$12, symbolToString = symbolProto ? symbolProto.toString : undefined$12;
      function lodash2(value) {
        if (isObjectLike(value) && !isArray2(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty2.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = function() {
        function object() {
        }
        return function(proto) {
          if (!isObject(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result2 = new object();
          object.prototype = undefined$12;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$12;
      }
      lodash2.templateSettings = {
        "escape": reEscape,
        "evaluate": reEvaluate,
        "interpolate": reInterpolate,
        "variable": "",
        "imports": {
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start2 = view.start, end2 = view.end, length = end2 - start2, index2 = isRight ? end2 : start2 - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value = array[index2];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result2 = data[key];
          return result2 === HASH_UNDEFINED ? undefined$12 : result2;
        }
        return hasOwnProperty2.call(data, key) ? data[key] : undefined$12;
      }
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$12 : hasOwnProperty2.call(data, key);
      }
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$12 ? HASH_UNDEFINED : value;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index2 == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        return index2 < 0 ? undefined$12 : data[index2][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index2][1] = value;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash(),
          "map": new (Map2 || ListCache)(),
          "string": new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result2 = getMapData(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value) {
        var data = getMapData(this, key), size2 = data.size;
        data.set(key, value);
        this.size += data.size == size2 ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values2) {
        var index2 = -1, length = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache();
        while (++index2 < length) {
          this.add(values2[index2]);
        }
      }
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data = this.__data__, result2 = data["delete"](key);
        this.size = data.size;
        return result2;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer3(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$12;
      }
      function arraySampleSize(array, n2) {
        return shuffleSelf(copyArray(array), baseClamp(n2, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }
      function assignMergeValue(object, key, value) {
        if (value !== undefined$12 && !eq(object[key], value) || value === undefined$12 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty2.call(object, key) && eq(objValue, value)) || value === undefined$12 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      function baseAssignValue(object, key, value) {
        if (key == "__proto__" && defineProperty2) {
          defineProperty2(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object[key] = value;
        }
      }
      function baseAt(object, paths2) {
        var index2 = -1, length = paths2.length, result2 = Array2(length), skip = object == null;
        while (++index2 < length) {
          result2[index2] = skip ? undefined$12 : get(object, paths2[index2]);
        }
        return result2;
      }
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$12) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$12) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result2 = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result2 !== undefined$12) {
          return result2;
        }
        if (!isObject(value)) {
          return value;
        }
        var isArr = isArray2(value);
        if (isArr) {
          result2 = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result2);
          }
        } else {
          var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer3(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result2 = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result2 = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result2);
        if (isSet2(value)) {
          value.forEach(function(subValue) {
            result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap2(value)) {
          value.forEach(function(subValue, key2) {
            result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? undefined$12 : keysFunc(value);
        arrayEach(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
        return result2;
      }
      function baseConforms(source) {
        var props = keys(source);
        return function(object) {
          return baseConformsTo(object, source, props);
        };
      }
      function baseConformsTo(object, source, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (length--) {
          var key = props[length], predicate = source[key], value = object[key];
          if (value === undefined$12 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return setTimeout2(function() {
          func.apply(undefined$12, args);
        }, wait);
      }
      function baseDifference(array, values2, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
        if (!length) {
          return result2;
        }
        if (iteratee2) {
          values2 = arrayMap(values2, baseUnary(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values2.length >= LARGE_ARRAY_SIZE) {
          includes2 = cacheHas;
          isCommon = false;
          values2 = new SetCache(values2);
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes2(values2, computed, comparator)) {
              result2.push(value);
            }
          }
        return result2;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach(collection, function(value, index2, collection2) {
          result2 = !!predicate(value, index2, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array, iteratee2, comparator) {
        var index2 = -1, length = array.length;
        while (++index2 < length) {
          var value = array[index2], current = iteratee2(value);
          if (current != null && (computed === undefined$12 ? current === current && !isSymbol2(current) : comparator(current, computed))) {
            var computed = current, result2 = value;
          }
        }
        return result2;
      }
      function baseFill(array, value, start2, end2) {
        var length = array.length;
        start2 = toInteger(start2);
        if (start2 < 0) {
          start2 = -start2 > length ? 0 : length + start2;
        }
        end2 = end2 === undefined$12 || end2 > length ? length : toInteger(end2);
        if (end2 < 0) {
          end2 += length;
        }
        end2 = start2 > end2 ? 0 : toLength(end2);
        while (start2 < end2) {
          array[start2++] = value;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result2.push(value);
          }
        });
        return result2;
      }
      function baseFlatten(array, depth, predicate, isStrict, result2) {
        var index2 = -1, length = array.length;
        predicate || (predicate = isFlattenable);
        result2 || (result2 = []);
        while (++index2 < length) {
          var value = array[index2];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result2);
            } else {
              arrayPush(result2, value);
            }
          } else if (!isStrict) {
            result2[result2.length] = value;
          }
        }
        return result2;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee2) {
        return object && baseFor(object, iteratee2, keys);
      }
      function baseForOwnRight(object, iteratee2) {
        return object && baseForRight(object, iteratee2, keys);
      }
      function baseFunctions(object, props) {
        return arrayFilter(props, function(key) {
          return isFunction(object[key]);
        });
      }
      function baseGet(object, path) {
        path = castPath(path, object);
        var index2 = 0, length = path.length;
        while (object != null && index2 < length) {
          object = object[toKey(path[index2++])];
        }
        return index2 && index2 == length ? object : undefined$12;
      }
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object);
        return isArray2(object) ? result2 : arrayPush(result2, symbolsFunc(object));
      }
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$12 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString2(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty2.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object2(object);
      }
      function baseInRange(number, start2, end2) {
        return number >= nativeMin(start2, end2) && number < nativeMax(start2, end2);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee2) {
            array = arrayMap(array, baseUnary(iteratee2));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$12;
        }
        array = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length && result2.length < maxLength) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseInverter(object, setter, iteratee2, accumulator) {
        baseForOwn(object, function(value, key, object2) {
          setter(accumulator, iteratee2(value), key, object2);
        });
        return accumulator;
      }
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$12 : apply(func, object, args);
      }
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer3(object)) {
          if (!isBuffer3(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      function baseIsMatch(object, source, matchData, customizer) {
        var index2 = matchData.length, length = index2, noCustomizer = !customizer;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (index2--) {
          var data = matchData[index2];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index2 < length) {
          data = matchData[index2];
          var key = data[0], objValue = object[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$12 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result2 === undefined$12 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result2 = [];
        for (var key in Object2(object)) {
          if (hasOwnProperty2.call(object, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object), result2 = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee2) {
        var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result2[++index2] = iteratee2(value, key, collection2);
        });
        return result2;
      }
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get(object, path);
          return objValue === undefined$12 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function(srcValue, key) {
          stack || (stack = new Stack());
          if (isObject(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined$12;
            if (newValue === undefined$12) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined$12;
        var isCommon = newValue === undefined$12;
        if (isCommon) {
          var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer3(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray2(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n2) {
        var length = array.length;
        if (!length) {
          return;
        }
        n2 += n2 < 0 ? length : 0;
        return isIndex(n2, length) ? array[n2] : undefined$12;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee2) {
            if (isArray2(iteratee2)) {
              return function(value) {
                return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity];
        }
        var index2 = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result2 = baseMap(collection, function(value, key, collection2) {
          var criteria = arrayMap(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index2, "value": value };
        });
        return baseSortBy(result2, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths2) {
        return basePickBy(object, paths2, function(value, path) {
          return hasIn(object, path);
        });
      }
      function basePickBy(object, paths2, predicate) {
        var index2 = -1, length = paths2.length, result2 = {};
        while (++index2 < length) {
          var path = paths2[index2], value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result2, castPath(path, object), value);
          }
        }
        return result2;
      }
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }
      function basePullAll(array, values2, iteratee2, comparator) {
        var indexOf3 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length = values2.length, seen = array;
        if (array === values2) {
          values2 = copyArray(values2);
        }
        if (iteratee2) {
          seen = arrayMap(array, baseUnary(iteratee2));
        }
        while (++index2 < length) {
          var fromIndex = 0, value = values2[index2], computed = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf3(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0, lastIndex = length - 1;
        while (length--) {
          var index2 = indexes[length];
          if (length == lastIndex || index2 !== previous) {
            var previous = index2;
            if (isIndex(index2)) {
              splice.call(array, index2, 1);
            } else {
              baseUnset(array, index2);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start2, end2, step, fromRight) {
        var index2 = -1, length = nativeMax(nativeCeil((end2 - start2) / (step || 1)), 0), result2 = Array2(length);
        while (length--) {
          result2[fromRight ? length : ++index2] = start2;
          start2 += step;
        }
        return result2;
      }
      function baseRepeat(string, n2) {
        var result2 = "";
        if (!string || n2 < 1 || n2 > MAX_SAFE_INTEGER) {
          return result2;
        }
        do {
          if (n2 % 2) {
            result2 += string;
          }
          n2 = nativeFloor(n2 / 2);
          if (n2) {
            string += string;
          }
        } while (n2);
        return result2;
      }
      function baseRest(func, start2) {
        return setToString(overRest(func, start2, identity), func + "");
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n2) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n2, 0, array.length));
      }
      function baseSet(object, path, value, customizer) {
        if (!isObject(object)) {
          return object;
        }
        path = castPath(path, object);
        var index2 = -1, length = path.length, lastIndex = length - 1, nested = object;
        while (nested != null && ++index2 < length) {
          var key = toKey(path[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$12;
            if (newValue === undefined$12) {
              newValue = isObject(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function(func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty2 ? identity : function(func, string) {
        return defineProperty2(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice(array, start2, end2) {
        var index2 = -1, length = array.length;
        if (start2 < 0) {
          start2 = -start2 > length ? 0 : length + start2;
        }
        end2 = end2 > length ? length : end2;
        if (end2 < 0) {
          end2 += length;
        }
        length = start2 > end2 ? 0 : end2 - start2 >>> 0;
        start2 >>>= 0;
        var result2 = Array2(length);
        while (++index2 < length) {
          result2[index2] = array[index2 + start2];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach(collection, function(value, index2, collection2) {
          result2 = predicate(value, index2, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array, value, retHighest) {
        var low = 0, high = array == null ? low : array.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed = array[mid];
            if (computed !== null && !isSymbol2(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }
      function baseSortedIndexBy(array, value, iteratee2, retHighest) {
        var low = 0, high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol2(value), valIsUndefined = value === undefined$12;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined$12, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol2(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee2) {
        var index2 = -1, length = array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
          if (!index2 || !eq(computed, seen)) {
            var seen = computed;
            result2[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result2;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN;
        }
        return +value;
      }
      function baseToString(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray2(value)) {
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol2(value)) {
          return symbolToString ? symbolToString.call(value) : "";
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function baseUniq(array, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set2 = iteratee2 ? null : createSet(array);
          if (set2) {
            return setToArray(set2);
          }
          isCommon = false;
          includes2 = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed);
              }
              result2.push(value);
            } else if (!includes2(seen, computed, comparator)) {
              if (seen !== result2) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length, index2 = fromRight ? length : -1;
        while ((fromRight ? index2-- : ++index2 < length) && predicate(array[index2], index2, array)) {
        }
        return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length : index2);
      }
      function baseWrapperValue(value, actions2) {
        var result2 = value;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce(actions2, function(result3, action2) {
          return action2.func.apply(action2.thisArg, arrayPush([result3], action2.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index2 = -1, result2 = Array2(length);
        while (++index2 < length) {
          var array = arrays[index2], othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index2) {
              result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values2, assignFunc) {
        var index2 = -1, length = props.length, valsLength = values2.length, result2 = {};
        while (++index2 < length) {
          var value = index2 < valsLength ? values2[index2] : undefined$12;
          assignFunc(result2, props[index2], value);
        }
        return result2;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }
      function castPath(value, object) {
        if (isArray2(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath3(toString(value));
      }
      var castRest = baseRest;
      function castSlice(array, start2, end2) {
        var length = array.length;
        end2 = end2 === undefined$12 ? length : end2;
        return !start2 && end2 >= length ? array : baseSlice(array, start2, end2);
      }
      var clearTimeout2 = ctxClearTimeout || function(id2) {
        return root.clearTimeout(id2);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result2);
        return result2;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
        return result2;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$12, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol2(value);
          var othIsDefined = other !== undefined$12, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol2(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length) {
          var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
          if (result2) {
            if (index2 >= ordersLength) {
              return result2;
            }
            var order2 = orders[index2];
            return result2 * (order2 == "desc" ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset2 = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset2 + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset2 + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray(source, array) {
        var index2 = -1, length = source.length;
        array || (array = Array2(length));
        while (++index2 < length) {
          array[index2] = source[index2];
        }
        return array;
      }
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index2 = -1, length = props.length;
        while (++index2 < length) {
          var key = props[index2];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$12;
          if (newValue === undefined$12) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$12, guard = length > 2 ? sources[2] : undefined$12;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$12;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$12 : customizer;
            length = 1;
          }
          object = Object2(object);
          while (++index2 < length) {
            var source = sources[index2];
            if (source) {
              assigner(object, source, index2, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length = collection.length, index2 = fromRight ? length : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function(object, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn2 = this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn2.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$12;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function(string) {
          return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length, placeholder = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$12, args, holders, undefined$12, undefined$12, arity - length);
          }
          var fn2 = this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply(fn2, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$12;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length = funcs.length, index2 = length, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func = funcs[index2];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length;
          while (++index2 < length) {
            func = funcs[index2];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$12;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray2(value)) {
              return wrapper.plant(value).value();
            }
            var index3 = 0, result2 = length ? funcs[index3].apply(this, args) : value;
            while (++index3 < length) {
              result2 = funcs[index3].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$12 : createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary2, arity - length);
          }
          var thisBinding = isBind ? thisArg : this, fn2 = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length) {
            args.length = ary2;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn2 = Ctor || createCtor(fn2);
          }
          return fn2.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object, iteratee2) {
          return baseInverter(object, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result2;
          if (value === undefined$12 && other === undefined$12) {
            return defaultValue;
          }
          if (value !== undefined$12) {
            result2 = value;
          }
          if (other !== undefined$12) {
            if (result2 === undefined$12) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result2 = operator(value, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$12 ? " " : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn2 = this && this !== root && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn2, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start2, end2, step) {
          if (step && typeof step != "number" && isIterateeCall(start2, end2, step)) {
            end2 = step = undefined$12;
          }
          start2 = toFinite(start2);
          if (end2 === undefined$12) {
            end2 = start2;
            start2 = 0;
          } else {
            end2 = toFinite(end2);
          }
          step = step === undefined$12 ? start2 < end2 ? 1 : -1 : toFinite(step);
          return baseRange(start2, end2, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$12, newHoldersRight = isCurry ? undefined$12 : holders, newPartials = isCurry ? partials : undefined$12, newPartialsRight = isCurry ? undefined$12 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$12, newData);
        if (isLaziable(func)) {
          setData(result2, newData);
        }
        result2.placeholder = placeholder;
        return setWrapToString(result2, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number, precision) {
          number = toNumber(number);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number)) {
            var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number);
        };
      }
      var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop3 : function(values2) {
        return new Set2(values2);
      };
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$12;
        }
        ary2 = ary2 === undefined$12 ? ary2 : nativeMax(toInteger(ary2), 0);
        arity = arity === undefined$12 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$12;
        }
        var data = isBindKey ? undefined$12 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$12 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$12, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result2, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$12 || eq(objValue, objectProto[key]) && !hasOwnProperty2.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject(objValue) && isObject(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$12, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject(value) ? undefined$12 : value;
      }
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$12;
        stack.set(array, other);
        stack.set(other, array);
        while (++index2 < arrLength) {
          var arrValue = array[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
          }
          if (compared !== undefined$12) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result2;
      }
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + "";
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result2;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result2 = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$12 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result2;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$12, flatten), func + "");
      }
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop3 : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty2.call(realNames, result2) ? array.length : 0;
        while (length--) {
          var data = array[length], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result2;
      }
      function getHolder(func) {
        var object = hasOwnProperty2.call(lodash2, "placeholder") ? lodash2 : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData(map2, key) {
        var data = map2.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      function getMatchData(object) {
        var result2 = keys(object), length = result2.length;
        while (length--) {
          var key = result2[length], value = object[key];
          result2[length] = [key, value, isStrictComparable(value)];
        }
        return result2;
      }
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$12;
      }
      function getRawTag(value) {
        var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$12;
          var unmasked = true;
        } catch (e) {
        }
        var result2 = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result2;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object2(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result2 = [];
        while (object) {
          arrayPush(result2, getSymbols(object));
          object = getPrototype(object);
        }
        return result2;
      };
      var getTag = baseGetTag;
      if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
        getTag = function(value) {
          var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined$12, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result2;
        };
      }
      function getView(start2, end2, transforms) {
        var index2 = -1, length = transforms.length;
        while (++index2 < length) {
          var data = transforms[index2], size2 = data.size;
          switch (data.type) {
            case "drop":
              start2 += size2;
              break;
            case "dropRight":
              end2 -= size2;
              break;
            case "take":
              end2 = nativeMin(end2, start2 + size2);
              break;
            case "takeRight":
              start2 = nativeMax(start2, end2 - size2);
              break;
          }
        }
        return { "start": start2, "end": end2 };
      }
      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index2 = -1, length = path.length, result2 = false;
        while (++index2 < length) {
          var key = toKey(path[index2]);
          if (!(result2 = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result2 || ++index2 != length) {
          return result2;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray2(object) || isArguments(object));
      }
      function initCloneArray(array) {
        var length = array.length, result2 = new array.constructor(length);
        if (length && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
          result2.index = array.index;
          result2.input = array.input;
        }
        return result2;
      }
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value) {
        return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
      }
      function isIterateeCall(value, index2, object) {
        if (!isObject(object)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
          return eq(object[index2], value);
        }
        return false;
      }
      function isKey(value, object) {
        if (isArray2(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
      }
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction : stubFalse;
      function isPrototype(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value === proto;
      }
      function isStrictComparable(value) {
        return value === value && !isObject(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$12 || key in Object2(object));
        };
      }
      function memoizeCapped(func) {
        var result2 = memoize2(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result2.cache;
        return result2;
      }
      function mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn(object) {
        var result2 = [];
        if (object != null) {
          for (var key in Object2(object)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString2(value) {
        return nativeObjectToString.call(value);
      }
      function overRest(func, start2, transform2) {
        start2 = nativeMax(start2 === undefined$12 ? func.length - 1 : start2, 0);
        return function() {
          var args = arguments, index2 = -1, length = nativeMax(args.length - start2, 0), array = Array2(length);
          while (++index2 < length) {
            array[index2] = args[start2 + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start2 + 1);
          while (++index2 < start2) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start2] = transform2(array);
          return apply(func, this, otherArgs);
        };
      }
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
        while (length--) {
          var index2 = indexes[length];
          array[length] = isIndex(index2, arrLength) ? oldArray[index2] : undefined$12;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference2, bitmask) {
        var source = reference2 + "";
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut(func) {
        var count2 = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count2 >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count2 = 0;
          }
          return func.apply(undefined$12, arguments);
        };
      }
      function shuffleSelf(array, size2) {
        var index2 = -1, length = array.length, lastIndex = length - 1;
        size2 = size2 === undefined$12 ? length : size2;
        while (++index2 < size2) {
          var rand = baseRandom(index2, lastIndex), value = array[rand];
          array[rand] = array[index2];
          array[index2] = value;
        }
        array.length = size2;
        return array;
      }
      var stringToPath3 = memoizeCapped(function(string) {
        var result2 = [];
        if (string.charCodeAt(0) === 46) {
          result2.push("");
        }
        string.replace(rePropName2, function(match, number, quote2, subString) {
          result2.push(quote2 ? subString.replace(reEscapeChar2, "$1") : number || match);
        });
        return result2;
      });
      function toKey(value) {
        if (typeof value == "string" || isSymbol2(value)) {
          return value;
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {
          }
          try {
            return func + "";
          } catch (e) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result2.__actions__ = copyArray(wrapper.__actions__);
        result2.__index__ = wrapper.__index__;
        result2.__values__ = wrapper.__values__;
        return result2;
      }
      function chunk(array, size2, guard) {
        if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined$12) {
          size2 = 1;
        } else {
          size2 = nativeMax(toInteger(size2), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size2 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
        while (index2 < length) {
          result2[resIndex++] = baseSlice(array, index2, index2 += size2);
        }
        return result2;
      }
      function compact3(array) {
        var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2];
          if (value) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array2(length - 1), array = arguments[0], index2 = length;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush(isArray2(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function(array, values2) {
        var iteratee2 = last(values2);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$12;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest(function(array, values2) {
        var comparator = last(values2);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$12;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$12, comparator) : [];
      });
      function drop(array, n2, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n2 = guard || n2 === undefined$12 ? 1 : toInteger(n2);
        return baseSlice(array, n2 < 0 ? 0 : n2, length);
      }
      function dropRight(array, n2, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n2 = guard || n2 === undefined$12 ? 1 : toInteger(n2);
        n2 = length - n2;
        return baseSlice(array, 0, n2 < 0 ? 0 : n2);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value, start2, end2) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start2 && typeof start2 != "number" && isIterateeCall(array, value, start2)) {
          start2 = 0;
          end2 = length;
        }
        return baseFill(array, value, start2, end2);
      }
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length - 1;
        if (fromIndex !== undefined$12) {
          index2 = toInteger(fromIndex);
          index2 = fromIndex < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
      }
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$12 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index2 = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
        while (++index2 < length) {
          var pair = pairs[index2];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$12;
      }
      function indexOf2(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseIndexOf(array, value, index2);
      }
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$12;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$12;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$12, comparator) : [];
      });
      function join(array, separator) {
        return array == null ? "" : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$12;
      }
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length;
        if (fromIndex !== undefined$12) {
          index2 = toInteger(fromIndex);
          index2 = index2 < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index2) : baseFindIndex(array, baseIsNaN, index2, true);
      }
      function nth(array, n2) {
        return array && array.length ? baseNth(array, toInteger(n2)) : undefined$12;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
      }
      function pullAllBy(array, values2, iteratee2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
      }
      function pullAllWith(array, values2, comparator) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined$12, comparator) : array;
      }
      var pullAt = flatRest(function(array, indexes) {
        var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function(index2) {
          return isIndex(index2, length) ? +index2 : index2;
        }).sort(compareAscending));
        return result2;
      });
      function remove(array, predicate) {
        var result2 = [];
        if (!(array && array.length)) {
          return result2;
        }
        var index2 = -1, indexes = [], length = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length) {
          var value = array[index2];
          if (predicate(value, index2, array)) {
            result2.push(value);
            indexes.push(index2);
          }
        }
        basePullAt(array, indexes);
        return result2;
      }
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice2(array, start2, end2) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end2 && typeof end2 != "number" && isIterateeCall(array, start2, end2)) {
          start2 = 0;
          end2 = length;
        } else {
          start2 = start2 == null ? 0 : toInteger(start2);
          end2 = end2 === undefined$12 ? length : toInteger(end2);
        }
        return baseSlice(array, start2, end2);
      }
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }
      function sortedIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value);
          if (index2 < length && eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }
      function sortedLastIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee2) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }
      function take(array, n2, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n2 = guard || n2 === undefined$12 ? 1 : toInteger(n2);
        return baseSlice(array, 0, n2 < 0 ? 0 : n2);
      }
      function takeRight(array, n2, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n2 = guard || n2 === undefined$12 ? 1 : toInteger(n2);
        n2 = length - n2;
        return baseSlice(array, n2 < 0 ? 0 : n2, length);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$12;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$12;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$12, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee2) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$12;
        return array && array.length ? baseUniq(array, undefined$12, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function(group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function(index2) {
          return arrayMap(array, baseProperty(index2));
        });
      }
      function unzipWith(array, iteratee2) {
        if (!(array && array.length)) {
          return [];
        }
        var result2 = unzip(array);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap(result2, function(group) {
          return apply(iteratee2, undefined$12, group);
        });
      }
      var without = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
      });
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$12;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$12;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$12, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values2) {
        return baseZipObject(props || [], values2 || [], assignValue);
      }
      function zipObjectDeep(props, values2) {
        return baseZipObject(props || [], values2 || [], baseSet);
      }
      var zipWith = baseRest(function(arrays) {
        var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$12;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$12;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value) {
        var result2 = lodash2(value);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths2) {
        var length = paths2.length, start2 = length ? paths2[0] : 0, value = this.__wrapped__, interceptor = function(object) {
          return baseAt(object, paths2);
        };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start2)) {
          return this.thru(interceptor);
        }
        value = value.slice(start2, +start2 + (length ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$12
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array) {
          if (length && !array.length) {
            array.push(undefined$12);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$12) {
          this.__values__ = toArray(this.value());
        }
        var done2 = this.__index__ >= this.__values__.length, value = done2 ? undefined$12 : this.__values__[this.__index__++];
        return { "done": done2, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result2, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone2 = wrapperClone(parent2);
          clone2.__index__ = 0;
          clone2.__values__ = undefined$12;
          if (result2) {
            previous.__wrapped__ = clone2;
          } else {
            result2 = clone2;
          }
          var previous = clone2;
          parent2 = parent2.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result2;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$12
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray2(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$12;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), INFINITY);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$12 ? 1 : toInteger(depth);
        return baseFlatten(map(collection, iteratee2), depth);
      }
      function forEach(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          result2[key].push(value);
        } else {
          baseAssignValue(result2, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString2(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function(collection, path, args) {
        var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value) {
          result2[++index2] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result2;
      });
      var keyBy = createAggregator(function(result2, value, key) {
        baseAssignValue(result2, key, value);
      });
      function map(collection, iteratee2) {
        var func = isArray2(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray2(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$12 : orders;
        if (!isArray2(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result2, value, key) {
        result2[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray2(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n2, guard) {
        if (guard ? isIterateeCall(collection, n2, guard) : n2 === undefined$12) {
          n2 = 1;
        } else {
          n2 = toInteger(n2);
        }
        var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n2);
      }
      function shuffle(collection) {
        var func = isArray2(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString2(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray2(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$12;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now = ctxNow || function() {
        return root.Date.now();
      };
      function after(n2, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n2 = toInteger(n2);
        return function() {
          if (--n2 < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n2, guard) {
        n2 = guard ? undefined$12 : n2;
        n2 = func && n2 == null ? func.length : n2;
        return createWrap(func, WRAP_ARY_FLAG, undefined$12, undefined$12, undefined$12, undefined$12, n2);
      }
      function before(n2, func) {
        var result2;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n2 = toInteger(n2);
        return function() {
          if (--n2 > 0) {
            result2 = func.apply(this, arguments);
          }
          if (n2 <= 1) {
            func = undefined$12;
          }
          return result2;
        };
      }
      var bind3 = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind3));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$12 : arity;
        var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$12, undefined$12, undefined$12, undefined$12, undefined$12, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$12 : arity;
        var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$12, undefined$12, undefined$12, undefined$12, undefined$12, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce2(func, wait, options) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$12;
          lastInvokeTime = time;
          result2 = func.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result2;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$12 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$12;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$12;
          return result2;
        }
        function cancel() {
          if (timerId !== undefined$12) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$12;
        }
        function flush() {
          return timerId === undefined$12 ? result2 : trailingEdge(now());
        }
        function debounced() {
          var time = now(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$12) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$12) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });
      function flip2(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize2(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result2 = func.apply(this, args);
          memoized.cache = cache.set(key, result2) || cache;
          return result2;
        };
        memoized.cache = new (memoize2.Cache || MapCache)();
        return memoized;
      }
      memoize2.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index2 = -1, length = nativeMin(args.length, funcsLength);
          while (++index2 < length) {
            args[index2] = transforms[index2].call(this, args[index2]);
          }
          return apply(func, this, args);
        });
      });
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$12, partials, holders);
      });
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$12, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$12, undefined$12, undefined$12, indexes);
      });
      function rest(func, start2) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start2 = start2 === undefined$12 ? start2 : toInteger(start2);
        return baseRest(func, start2);
      }
      function spread(func, start2) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start2 = start2 == null ? 0 : nativeMax(toInteger(start2), 0);
        return baseRest(function(args) {
          var array = args[start2], otherArgs = castSlice(args, 0, start2);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }
      function throttle3(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        if (isObject(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce2(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray2(value) ? value : [value];
      }
      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys(source));
      }
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(function() {
        return arguments;
      }()) ? baseIsArguments : function(value) {
        return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
      var isArray2 = Array2.isArray;
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      function isBoolean2(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }
      var isBuffer3 = nativeIsBuffer || stubFalse;
      var isDate2 = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement2(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
      }
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer3(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty2.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual3(value, other) {
        return baseIsEqual(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        var result2 = customizer ? customizer(value, other) : undefined$12;
        return result2 === undefined$12 ? baseIsEqual(value, other, undefined$12, customizer) : !!result2;
      }
      function isError2(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
      }
      function isFinite2(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value) {
        return typeof value == "number" && value == toInteger(value);
      }
      function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }
      var isMap2 = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }
      function isNaN2(value) {
        return isNumber2(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber2(value) {
        return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
      }
      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp3 = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }
      var isSet2 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString2(value) {
        return typeof value == "string" || !isArray2(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }
      function isSymbol2(value) {
        return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined(value) {
        return value === undefined$12;
      }
      function isWeakMap2(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }
      function isWeakSet2(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString2(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result2 = toFinite(value), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }
      function toString(value) {
        return value == null ? "" : baseToString(value);
      }
      var assign2 = createAssigner(function(object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty2.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object, source) {
        copyObject(source, keysIn(source), object);
      });
      var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });
      var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keys(source), object, customizer);
      });
      var at = flatRest(baseAt);
      function create(prototype, properties) {
        var result2 = baseCreate(prototype);
        return properties == null ? result2 : baseAssign(result2, properties);
      }
      var defaults2 = baseRest(function(object, sources) {
        object = Object2(object);
        var index2 = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$12;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index2 < length) {
          var source = sources[index2];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined$12 || eq(value, objectProto[key]) && !hasOwnProperty2.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$12, customDefaultsMerge);
        return apply(mergeWith, undefined$12, args);
      });
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee2) {
        return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forInRight(object, iteratee2) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forOwn(object, iteratee2) {
        return object && baseForOwn(object, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object, iteratee2) {
        return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }
      function get(object, path, defaultValue) {
        var result2 = object == null ? undefined$12 : baseGet(object, path);
        return result2 === undefined$12 ? defaultValue : result2;
      }
      function has2(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      var invert = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        result2[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty2.call(result2, value)) {
          result2[value].push(key);
        } else {
          result2[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      function mapKeys(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, iteratee2(value, key, object2), value);
        });
        return result2;
      }
      function mapValues(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, key, iteratee2(value, key, object2));
        });
        return result2;
      }
      var merge3 = createAssigner(function(object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      var omit = flatRest(function(object, paths2) {
        var result2 = {};
        if (object == null) {
          return result2;
        }
        var isDeep = false;
        paths2 = arrayMap(paths2, function(path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result2);
        if (isDeep) {
          result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths2.length;
        while (length--) {
          baseUnset(result2, paths2[length]);
        }
        return result2;
      });
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function(object, paths2) {
        return object == null ? {} : basePick(object, paths2);
      });
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }
      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index2 = -1, length = path.length;
        if (!length) {
          length = 1;
          object = undefined$12;
        }
        while (++index2 < length) {
          var value = object == null ? undefined$12 : object[toKey(path[index2])];
          if (value === undefined$12) {
            index2 = length;
            value = defaultValue;
          }
          object = isFunction(value) ? value.call(object) : value;
        }
        return object;
      }
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        return object == null ? object : baseSet(object, path, value, customizer);
      }
      var toPairs = createToPairs(keys);
      var toPairsIn = createToPairs(keysIn);
      function transform(object, iteratee2, accumulator) {
        var isArr = isArray2(object), isArrLike = isArr || isBuffer3(object) || isTypedArray(object);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject(object)) {
            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(value, index2, object2) {
          return iteratee2(accumulator, value, index2, object2);
        });
        return accumulator;
      }
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }
      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }
      function clamp(number, lower, upper) {
        if (upper === undefined$12) {
          upper = lower;
          lower = undefined$12;
        }
        if (upper !== undefined$12) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$12) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number), lower, upper);
      }
      function inRange(number, start2, end2) {
        start2 = toFinite(start2);
        if (end2 === undefined$12) {
          end2 = start2;
          start2 = 0;
        } else {
          end2 = toFinite(end2);
        }
        number = toNumber(number);
        return baseInRange(number, start2, end2);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$12;
        }
        if (floating === undefined$12) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$12;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$12;
          }
        }
        if (lower === undefined$12 && upper === undefined$12) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$12) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result2, word, index2) {
        word = word.toLowerCase();
        return result2 + (index2 ? capitalize(word) : word);
      });
      function capitalize(string) {
        return upperFirst(toString(string).toLowerCase());
      }
      function deburr(string) {
        string = toString(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith(string, target, position) {
        string = toString(string);
        target = baseToString(target);
        var length = string.length;
        position = position === undefined$12 ? length : baseClamp(toInteger(position), 0, length);
        var end2 = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end2) == target;
      }
      function escape2(string) {
        string = toString(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }
      function escapeRegExp(string) {
        string = toString(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
      }
      var kebabCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
      }
      function padStart(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
      }
      function parseInt2(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
      }
      function repeat2(string, n2, guard) {
        if (guard ? isIterateeCall(string, n2, guard) : n2 === undefined$12) {
          n2 = 1;
        } else {
          n2 = toInteger(n2);
        }
        return baseRepeat(toString(string), n2);
      }
      function replace2() {
        var args = arguments, string = toString(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split(string, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$12;
        }
        limit = limit === undefined$12 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString(string);
        if (string && (typeof separator == "string" || separator != null && !isRegExp3(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }
      var startCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + upperFirst(word);
      });
      function startsWith(string, target, position) {
        string = toString(string);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }
      function template(string, options, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$12;
        }
        string = toString(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
        var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset2) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string.slice(index2, offset2).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset2 + match.length;
          return match;
        });
        source += "';\n";
        var variable = hasOwnProperty2.call(options, "variable") && options.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result2 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$12, importsValues);
        });
        result2.source = source;
        if (isError2(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value) {
        return toString(value).toLowerCase();
      }
      function toUpper(value) {
        return toString(value).toUpperCase();
      }
      function trim(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$12)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start2 = charsStartIndex(strSymbols, chrSymbols), end2 = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start2, end2).join("");
      }
      function trimEnd(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$12)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), end2 = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end2).join("");
      }
      function trimStart(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$12)) {
          return string.replace(reTrimStart, "");
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), start2 = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start2).join("");
      }
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length = "length" in options ? toInteger(options.length) : length;
          omission = "omission" in options ? baseToString(options.omission) : omission;
        }
        string = toString(string);
        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end2 = length - stringSize(omission);
        if (end2 < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice(strSymbols, 0, end2).join("") : string.slice(0, end2);
        if (separator === undefined$12) {
          return result2 + omission;
        }
        if (strSymbols) {
          end2 += result2.length - end2;
        }
        if (isRegExp3(separator)) {
          if (string.slice(end2).search(separator)) {
            var match, substring = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match = separator.exec(substring)) {
              var newEnd = match.index;
            }
            result2 = result2.slice(0, newEnd === undefined$12 ? end2 : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end2) != end2) {
          var index2 = result2.lastIndexOf(separator);
          if (index2 > -1) {
            result2 = result2.slice(0, index2);
          }
        }
        return result2 + omission;
      }
      function unescape2(string) {
        string = toString(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }
      var upperCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string, pattern, guard) {
        string = toString(string);
        pattern = guard ? undefined$12 : pattern;
        if (pattern === undefined$12) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      var attempt = baseRest(function(func, args) {
        try {
          return apply(func, undefined$12, args);
        } catch (e) {
          return isError2(e) ? e : new Error2(e);
        }
      });
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object, key, bind3(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function(args) {
          var index2 = -1;
          while (++index2 < length) {
            var pair = pairs[index2];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }
      function constant(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function(path, args) {
        return function(object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function(object, args) {
        return function(path) {
          return baseInvoke(object, path, args);
        };
      });
      function mixin(object, source, options) {
        var props = keys(source), methodNames = baseFunctions(source, props);
        if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys(source));
        }
        var chain2 = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
        arrayEach(methodNames, function(methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result2 = object(this.__wrapped__), actions2 = result2.__actions__ = copyArray(this.__actions__);
                actions2.push({ "func": func, "args": arguments, "thisArg": object });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }
      function noop3() {
      }
      function nthArg(n2) {
        n2 = toInteger(n2);
        return baseRest(function(args) {
          return baseNth(args, n2);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object) {
        return function(path) {
          return object == null ? undefined$12 : baseGet(object, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n2, iteratee2) {
        n2 = toInteger(n2);
        if (n2 < 1 || n2 > MAX_SAFE_INTEGER) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH, length = nativeMin(n2, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n2 -= MAX_ARRAY_LENGTH;
        var result2 = baseTimes(length, iteratee2);
        while (++index2 < n2) {
          iteratee2(index2);
        }
        return result2;
      }
      function toPath(value) {
        if (isArray2(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol2(value) ? [value] : copyArray(stringToPath3(toString(value)));
      }
      function uniqueId(prefix) {
        var id2 = ++idCounter;
        return toString(prefix) + id2;
      }
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max2(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$12;
      }
      function maxBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$12;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee2) {
        return baseMean(array, getIteratee(iteratee2, 2));
      }
      function min2(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$12;
      }
      function minBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$12;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round2 = createRound("round");
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee2) {
        return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign2;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at;
      lodash2.before = before;
      lodash2.bind = bind3;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact3;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant;
      lodash2.countBy = countBy;
      lodash2.create = create;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce2;
      lodash2.defaults = defaults2;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip2;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys;
      lodash2.keysIn = keysIn;
      lodash2.map = map;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize2;
      lodash2.merge = merge3;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick;
      lodash2.pickBy = pickBy;
      lodash2.property = property;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice2;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle3;
      lodash2.thru = thru;
      lodash2.toArray = toArray;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update;
      lodash2.updateWith = updateWith;
      lodash2.values = values;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp;
      lodash2.clone = clone;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq;
      lodash2.escape = escape2;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find;
      lodash2.findIndex = findIndex;
      lodash2.findKey = findKey;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get;
      lodash2.gt = gt;
      lodash2.gte = gte;
      lodash2.has = has2;
      lodash2.hasIn = hasIn;
      lodash2.head = head;
      lodash2.identity = identity;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf2;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments;
      lodash2.isArray = isArray2;
      lodash2.isArrayBuffer = isArrayBuffer;
      lodash2.isArrayLike = isArrayLike;
      lodash2.isArrayLikeObject = isArrayLikeObject;
      lodash2.isBoolean = isBoolean2;
      lodash2.isBuffer = isBuffer3;
      lodash2.isDate = isDate2;
      lodash2.isElement = isElement2;
      lodash2.isEmpty = isEmpty;
      lodash2.isEqual = isEqual3;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError2;
      lodash2.isFinite = isFinite2;
      lodash2.isFunction = isFunction;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength;
      lodash2.isMap = isMap2;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber2;
      lodash2.isObject = isObject;
      lodash2.isObjectLike = isObjectLike;
      lodash2.isPlainObject = isPlainObject;
      lodash2.isRegExp = isRegExp3;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet2;
      lodash2.isString = isString2;
      lodash2.isSymbol = isSymbol2;
      lodash2.isTypedArray = isTypedArray;
      lodash2.isUndefined = isUndefined;
      lodash2.isWeakMap = isWeakMap2;
      lodash2.isWeakSet = isWeakSet2;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt;
      lodash2.lte = lte;
      lodash2.max = max2;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min2;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray;
      lodash2.stubFalse = stubFalse;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop3;
      lodash2.now = now;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat2;
      lodash2.replace = replace2;
      lodash2.result = result;
      lodash2.round = round2;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape2;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn(lodash2, function(func, methodName) {
          if (!hasOwnProperty2.call(lodash2.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n2) {
          n2 = n2 === undefined$12 ? 1 : nativeMax(toInteger(n2), 0);
          var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin(n2, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin(n2, MAX_ARRAY_LENGTH),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n2) {
          return this.reverse()[methodName](n2).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start2, end2) {
        start2 = toInteger(start2);
        var result2 = this;
        if (result2.__filtered__ && (start2 > 0 || end2 < 0)) {
          return new LazyWrapper(result2);
        }
        if (start2 < 0) {
          result2 = result2.takeRight(-start2);
        } else if (start2) {
          result2 = result2.drop(start2);
        }
        if (end2 !== undefined$12) {
          end2 = toInteger(end2);
          result2 = end2 < 0 ? result2.dropRight(-end2) : result2.take(end2 - start2);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value);
          var interceptor = function(value2) {
            var result3 = lodashFunc.apply(lodash2, arrayPush([value2], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result2 = func.apply(value, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$12 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray2(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray2(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty2.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$12, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$12
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _ = runInContext();
    if (freeModule) {
      (freeModule.exports = _)._ = _;
      freeExports._ = _;
    } else {
      root._ = _;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var reactTable = { exports: {} };
var reactTable_production_min = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    t(exports, React__default);
  }(commonjsGlobal, function(e, t) {
    function n2(e2, t2, n3, o2, r2, i2, u2) {
      try {
        var l2 = e2[i2](u2), s2 = l2.value;
      } catch (e3) {
        return void n3(e3);
      }
      l2.done ? t2(s2) : Promise.resolve(s2).then(o2, r2);
    }
    function o(e2) {
      return function() {
        var t2 = this, o2 = arguments;
        return new Promise(function(r2, i2) {
          var u2 = e2.apply(t2, o2);
          function l2(e3) {
            n2(u2, r2, i2, l2, s2, "next", e3);
          }
          function s2(e3) {
            n2(u2, r2, i2, l2, s2, "throw", e3);
          }
          l2(void 0);
        });
      };
    }
    function r() {
      return (r = Object.assign || function(e2) {
        for (var t2 = 1; t2 < arguments.length; t2++) {
          var n3 = arguments[t2];
          for (var o2 in n3)
            Object.prototype.hasOwnProperty.call(n3, o2) && (e2[o2] = n3[o2]);
        }
        return e2;
      }).apply(this, arguments);
    }
    function i(e2, t2) {
      if (e2 == null)
        return {};
      var n3, o2, r2 = {}, i2 = Object.keys(e2);
      for (o2 = 0; o2 < i2.length; o2++)
        n3 = i2[o2], t2.indexOf(n3) >= 0 || (r2[n3] = e2[n3]);
      return r2;
    }
    function u(e2) {
      var t2 = function(e3, t3) {
        if (typeof e3 != "object" || e3 === null)
          return e3;
        var n3 = e3[Symbol.toPrimitive];
        if (n3 !== void 0) {
          var o2 = n3.call(e3, t3 || "default");
          if (typeof o2 != "object")
            return o2;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (t3 === "string" ? String : Number)(e3);
      }(e2, "string");
      return typeof t2 == "symbol" ? t2 : String(t2);
    }
    t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    var l = { init: "init" }, s = function(e2) {
      var t2 = e2.value;
      return t2 === void 0 ? "" : t2;
    }, a = function() {
      return t.createElement(t.Fragment, null, "\xA0");
    }, c = { Cell: s, width: 150, minWidth: 0, maxWidth: Number.MAX_SAFE_INTEGER };
    function d() {
      for (var e2 = arguments.length, t2 = new Array(e2), n3 = 0; n3 < e2; n3++)
        t2[n3] = arguments[n3];
      return t2.reduce(function(e3, t3) {
        var n4 = t3.style, o2 = t3.className;
        return e3 = r({}, e3, {}, i(t3, ["style", "className"])), n4 && (e3.style = e3.style ? r({}, e3.style || {}, {}, n4 || {}) : n4), o2 && (e3.className = e3.className ? e3.className + " " + o2 : o2), e3.className === "" && delete e3.className, e3;
      }, {});
    }
    var f2 = function(e2, t2) {
      return t2 === void 0 && (t2 = {}), function(n3) {
        return n3 === void 0 && (n3 = {}), [].concat(e2, [n3]).reduce(function(e3, o2) {
          return function e4(t3, n4, o3) {
            return typeof n4 == "function" ? e4({}, n4(t3, o3)) : Array.isArray(n4) ? d.apply(void 0, [t3].concat(n4)) : d(t3, n4);
          }(e3, o2, r({}, t2, { userProps: n3 }));
        }, {});
      };
    }, p2 = function(e2, t2, n3, o2) {
      return n3 === void 0 && (n3 = {}), e2.reduce(function(e3, t3) {
        return t3(e3, n3);
      }, t2);
    }, g2 = function(e2, t2, n3) {
      return n3 === void 0 && (n3 = {}), e2.forEach(function(e3) {
        e3(t2, n3);
      });
    };
    function v(e2, t2, n3, o2) {
      e2.findIndex(function(e3) {
        return e3.pluginName === n3;
      });
      t2.forEach(function(t3) {
        e2.findIndex(function(e3) {
          return e3.pluginName === t3;
        });
      });
    }
    function m2(e2, t2) {
      return typeof e2 == "function" ? e2(t2) : e2;
    }
    function h(e2) {
      var n3 = t.useRef();
      return n3.current = e2, t.useCallback(function() {
        return n3.current;
      }, []);
    }
    var y = typeof document != "undefined" ? t.useLayoutEffect : t.useEffect;
    function w(e2, n3) {
      var o2 = t.useRef(false);
      y(function() {
        o2.current && e2(), o2.current = true;
      }, n3);
    }
    function R(e2, t2, n3) {
      return n3 === void 0 && (n3 = {}), function(o2, i2) {
        i2 === void 0 && (i2 = {});
        var u2 = typeof o2 == "string" ? t2[o2] : o2;
        if (u2 === void 0)
          throw console.info(t2), new Error("Renderer Error \u261D\uFE0F");
        return b(u2, r({}, e2, { column: t2 }, n3, {}, i2));
      };
    }
    function b(e2, n3) {
      return function(e3) {
        return typeof e3 == "function" && ((t2 = Object.getPrototypeOf(e3)).prototype && t2.prototype.isReactComponent);
        var t2;
      }(o2 = e2) || typeof o2 == "function" || function(e3) {
        return typeof e3 == "object" && typeof e3.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e3.$$typeof.description);
      }(o2) ? t.createElement(e2, n3) : e2;
      var o2;
    }
    function S(e2, t2, n3) {
      return n3 === void 0 && (n3 = 0), e2.map(function(e3) {
        return x(e3 = r({}, e3, { parent: t2, depth: n3 })), e3.columns && (e3.columns = S(e3.columns, e3, n3 + 1)), e3;
      });
    }
    function C(e2) {
      return G(e2, "columns");
    }
    function x(e2) {
      var t2 = e2.id, n3 = e2.accessor, o2 = e2.Header;
      if (typeof n3 == "string") {
        t2 = t2 || n3;
        var r2 = n3.split(".");
        n3 = function(e3) {
          return function(e4, t3, n4) {
            if (!t3)
              return e4;
            var o3, r3 = typeof t3 == "function" ? t3 : JSON.stringify(t3), i2 = E.get(r3) || function() {
              var e5 = function(e6) {
                return function e7(t4, n5) {
                  n5 === void 0 && (n5 = []);
                  if (Array.isArray(t4))
                    for (var o4 = 0; o4 < t4.length; o4 += 1)
                      e7(t4[o4], n5);
                  else
                    n5.push(t4);
                  return n5;
                }(e6).map(function(e7) {
                  return String(e7).replace(".", "_");
                }).join(".").replace(W, ".").replace(O, "").split(".");
              }(t3);
              return E.set(r3, e5), e5;
            }();
            try {
              o3 = i2.reduce(function(e5, t4) {
                return e5[t4];
              }, e4);
            } catch (e5) {
            }
            return o3 !== void 0 ? o3 : n4;
          }(e3, r2);
        };
      }
      if (!t2 && typeof o2 == "string" && o2 && (t2 = o2), !t2 && e2.columns)
        throw console.error(e2), new Error('A column ID (or unique "Header" value) is required!');
      if (!t2)
        throw console.error(e2), new Error("A column ID (or string accessor) is required!");
      return Object.assign(e2, { id: t2, accessor: n3 }), e2;
    }
    function P(e2, t2) {
      if (!t2)
        throw new Error();
      return Object.assign(e2, r({ Header: a, Footer: a }, c, {}, t2, {}, e2)), Object.assign(e2, { originalWidth: e2.width }), e2;
    }
    function B(e2, t2, n3) {
      n3 === void 0 && (n3 = function() {
        return {};
      });
      for (var o2 = [], i2 = e2, u2 = 0, l2 = function() {
        return u2++;
      }, s2 = function() {
        var e3 = { headers: [] }, u3 = [], s3 = i2.some(function(e4) {
          return e4.parent;
        });
        i2.forEach(function(o3) {
          var i3, a2 = [].concat(u3).reverse()[0];
          if (s3) {
            if (o3.parent)
              i3 = r({}, o3.parent, { originalId: o3.parent.id, id: o3.parent.id + "_" + l2(), headers: [o3] }, n3(o3));
            else
              i3 = P(r({ originalId: o3.id + "_placeholder", id: o3.id + "_placeholder_" + l2(), placeholderOf: o3, headers: [o3] }, n3(o3)), t2);
            a2 && a2.originalId === i3.originalId ? a2.headers.push(o3) : u3.push(i3);
          }
          e3.headers.push(o3);
        }), o2.push(e3), i2 = u3;
      }; i2.length; )
        s2();
      return o2.reverse();
    }
    var E = /* @__PURE__ */ new Map();
    function I() {
      for (var e2 = arguments.length, t2 = new Array(e2), n3 = 0; n3 < e2; n3++)
        t2[n3] = arguments[n3];
      for (var o2 = 0; o2 < t2.length; o2 += 1)
        if (t2[o2] !== void 0)
          return t2[o2];
    }
    function F(e2) {
      if (typeof e2 == "function")
        return e2;
    }
    function G(e2, t2) {
      var n3 = [];
      return function e3(o2) {
        o2.forEach(function(o3) {
          o3[t2] ? e3(o3[t2]) : n3.push(o3);
        });
      }(e2), n3;
    }
    function A(e2, t2) {
      var n3 = t2.manualExpandedKey, o2 = t2.expanded, r2 = t2.expandSubRows, i2 = r2 === void 0 || r2, u2 = [];
      return e2.forEach(function(e3) {
        return function e4(t3, r3) {
          r3 === void 0 && (r3 = true), t3.isExpanded = t3.original && t3.original[n3] || o2[t3.id], t3.canExpand = t3.subRows && !!t3.subRows.length, r3 && u2.push(t3), t3.subRows && t3.subRows.length && t3.isExpanded && t3.subRows.forEach(function(t4) {
            return e4(t4, i2);
          });
        }(e3);
      }), u2;
    }
    function k(e2, t2, n3) {
      return F(e2) || t2[e2] || n3[e2] || n3.text;
    }
    function H(e2, t2, n3) {
      return e2 ? e2(t2, n3) : t2 === void 0;
    }
    function T() {
      throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
    }
    var z = null;
    var W = /\[/g, O = /\]/g;
    var M = function(e2) {
      return r({ role: "table" }, e2);
    }, j = function(e2) {
      return r({ role: "rowgroup" }, e2);
    }, N = function(e2, t2) {
      var n3 = t2.column;
      return r({ key: "header_" + n3.id, colSpan: n3.totalVisibleHeaderCount, role: "columnheader" }, e2);
    }, L = function(e2, t2) {
      var n3 = t2.column;
      return r({ key: "footer_" + n3.id, colSpan: n3.totalVisibleHeaderCount }, e2);
    }, D = function(e2, t2) {
      return r({ key: "headerGroup_" + t2.index, role: "row" }, e2);
    }, V = function(e2, t2) {
      return r({ key: "footerGroup_" + t2.index }, e2);
    }, _ = function(e2, t2) {
      return r({ key: "row_" + t2.row.id, role: "row" }, e2);
    }, X = function(e2, t2) {
      var n3 = t2.cell;
      return r({ key: "cell_" + n3.row.id + "_" + n3.column.id, role: "cell" }, e2);
    };
    function q2() {
      return { useOptions: [], stateReducers: [], useControlledState: [], columns: [], columnsDeps: [], allColumns: [], allColumnsDeps: [], accessValue: [], materializedColumns: [], materializedColumnsDeps: [], useInstanceAfterData: [], visibleColumns: [], visibleColumnsDeps: [], headerGroups: [], headerGroupsDeps: [], useInstanceBeforeDimensions: [], useInstance: [], prepareRow: [], getTableProps: [M], getTableBodyProps: [j], getHeaderGroupProps: [D], getFooterGroupProps: [V], getHeaderProps: [N], getFooterProps: [L], getRowProps: [_], getCellProps: [X], useFinalInstance: [] };
    }
    l.resetHiddenColumns = "resetHiddenColumns", l.toggleHideColumn = "toggleHideColumn", l.setHiddenColumns = "setHiddenColumns", l.toggleHideAllColumns = "toggleHideAllColumns";
    var K = function(e2) {
      e2.getToggleHiddenProps = [U], e2.getToggleHideAllColumnsProps = [$], e2.stateReducers.push(J), e2.useInstanceBeforeDimensions.push(Y), e2.headerGroupsDeps.push(function(e3, t2) {
        var n3 = t2.instance;
        return [].concat(e3, [n3.state.hiddenColumns]);
      }), e2.useInstance.push(Q);
    };
    K.pluginName = "useColumnVisibility";
    var U = function(e2, t2) {
      var n3 = t2.column;
      return [e2, { onChange: function(e3) {
        n3.toggleHidden(!e3.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isVisible, title: "Toggle Column Visible" }];
    }, $ = function(e2, t2) {
      var n3 = t2.instance;
      return [e2, { onChange: function(e3) {
        n3.toggleHideAllColumns(!e3.target.checked);
      }, style: { cursor: "pointer" }, checked: !n3.allColumnsHidden && !n3.state.hiddenColumns.length, title: "Toggle All Columns Hidden", indeterminate: !n3.allColumnsHidden && n3.state.hiddenColumns.length }];
    };
    function J(e2, t2, n3, o2) {
      if (t2.type === l.init)
        return r({ hiddenColumns: [] }, e2);
      if (t2.type === l.resetHiddenColumns)
        return r({}, e2, { hiddenColumns: o2.initialState.hiddenColumns || [] });
      if (t2.type === l.toggleHideColumn) {
        var i2 = (t2.value !== void 0 ? t2.value : !e2.hiddenColumns.includes(t2.columnId)) ? [].concat(e2.hiddenColumns, [t2.columnId]) : e2.hiddenColumns.filter(function(e3) {
          return e3 !== t2.columnId;
        });
        return r({}, e2, { hiddenColumns: i2 });
      }
      return t2.type === l.setHiddenColumns ? r({}, e2, { hiddenColumns: m2(t2.value, e2.hiddenColumns) }) : t2.type === l.toggleHideAllColumns ? r({}, e2, { hiddenColumns: (t2.value !== void 0 ? t2.value : !e2.hiddenColumns.length) ? o2.allColumns.map(function(e3) {
        return e3.id;
      }) : [] }) : void 0;
    }
    function Y(e2) {
      var n3 = e2.headers, o2 = e2.state.hiddenColumns;
      t.useRef(false).current;
      var r2 = 0;
      n3.forEach(function(e3) {
        return r2 += function e4(t2, n4) {
          t2.isVisible = n4 && !o2.includes(t2.id);
          var r3 = 0;
          return t2.headers && t2.headers.length ? t2.headers.forEach(function(n5) {
            return r3 += e4(n5, t2.isVisible);
          }) : r3 = t2.isVisible ? 1 : 0, t2.totalVisibleHeaderCount = r3, r3;
        }(e3, true);
      });
    }
    function Q(e2) {
      var n3 = e2.columns, o2 = e2.flatHeaders, r2 = e2.dispatch, i2 = e2.allColumns, u2 = e2.getHooks, s2 = e2.state.hiddenColumns, a2 = e2.autoResetHiddenColumns, c2 = a2 === void 0 || a2, d2 = h(e2), p3 = i2.length === s2.length, g3 = t.useCallback(function(e3, t2) {
        return r2({ type: l.toggleHideColumn, columnId: e3, value: t2 });
      }, [r2]), v2 = t.useCallback(function(e3) {
        return r2({ type: l.setHiddenColumns, value: e3 });
      }, [r2]), m3 = t.useCallback(function(e3) {
        return r2({ type: l.toggleHideAllColumns, value: e3 });
      }, [r2]), y2 = f2(u2().getToggleHideAllColumnsProps, { instance: d2() });
      o2.forEach(function(e3) {
        e3.toggleHidden = function(t2) {
          r2({ type: l.toggleHideColumn, columnId: e3.id, value: t2 });
        }, e3.getToggleHiddenProps = f2(u2().getToggleHiddenProps, { instance: d2(), column: e3 });
      });
      var R2 = h(c2);
      w(function() {
        R2() && r2({ type: l.resetHiddenColumns });
      }, [r2, n3]), Object.assign(e2, { allColumnsHidden: p3, toggleHideColumn: g3, setHiddenColumns: v2, toggleHideAllColumns: m3, getToggleHideAllColumnsProps: y2 });
    }
    var Z = {}, ee = {}, te = function(e2, t2, n3) {
      return e2;
    }, ne = function(e2, t2) {
      return e2.subRows || [];
    }, oe = function(e2, t2, n3) {
      return "" + (n3 ? [n3.id, t2].join(".") : t2);
    }, re = function(e2) {
      return e2;
    };
    function ie(e2) {
      var t2 = e2.initialState, n3 = t2 === void 0 ? Z : t2, o2 = e2.defaultColumn, u2 = o2 === void 0 ? ee : o2, l2 = e2.getSubRows, s2 = l2 === void 0 ? ne : l2, a2 = e2.getRowId, c2 = a2 === void 0 ? oe : a2, d2 = e2.stateReducer, f3 = d2 === void 0 ? te : d2, p3 = e2.useControlledState, g3 = p3 === void 0 ? re : p3;
      return r({}, i(e2, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]), { initialState: n3, defaultColumn: u2, getSubRows: s2, getRowId: c2, stateReducer: f3, useControlledState: g3 });
    }
    function ue(e2, t2) {
      t2 === void 0 && (t2 = 0);
      var n3 = 0, o2 = 0, r2 = 0, i2 = 0;
      return e2.forEach(function(e3) {
        var u2 = e3.headers;
        if (e3.totalLeft = t2, u2 && u2.length) {
          var l2 = ue(u2, t2), s2 = l2[0], a2 = l2[1], c2 = l2[2], d2 = l2[3];
          e3.totalMinWidth = s2, e3.totalWidth = a2, e3.totalMaxWidth = c2, e3.totalFlexWidth = d2;
        } else
          e3.totalMinWidth = e3.minWidth, e3.totalWidth = Math.min(Math.max(e3.minWidth, e3.width), e3.maxWidth), e3.totalMaxWidth = e3.maxWidth, e3.totalFlexWidth = e3.canResize ? e3.totalWidth : 0;
        e3.isVisible && (t2 += e3.totalWidth, n3 += e3.totalMinWidth, o2 += e3.totalWidth, r2 += e3.totalMaxWidth, i2 += e3.totalFlexWidth);
      }), [n3, o2, r2, i2];
    }
    function le(e2) {
      var t2 = e2.data, n3 = e2.rows, o2 = e2.flatRows, r2 = e2.rowsById, i2 = e2.column, u2 = e2.getRowId, l2 = e2.getSubRows, s2 = e2.accessValueHooks, a2 = e2.getInstance;
      t2.forEach(function(e3, c2) {
        return function e4(n4, c3, d2, f3, g3) {
          d2 === void 0 && (d2 = 0);
          var v2 = n4, m3 = u2(n4, c3, f3), h2 = r2[m3];
          if (h2)
            h2.subRows && h2.originalSubRows.forEach(function(t3, n5) {
              return e4(t3, n5, d2 + 1, h2);
            });
          else if ((h2 = { id: m3, original: v2, index: c3, depth: d2, cells: [{}] }).cells.map = T, h2.cells.filter = T, h2.cells.forEach = T, h2.cells[0].getCellProps = T, h2.values = {}, g3.push(h2), o2.push(h2), r2[m3] = h2, h2.originalSubRows = l2(n4, c3), h2.originalSubRows) {
            var y2 = [];
            h2.originalSubRows.forEach(function(t3, n5) {
              return e4(t3, n5, d2 + 1, h2, y2);
            }), h2.subRows = y2;
          }
          i2.accessor && (h2.values[i2.id] = i2.accessor(n4, c3, h2, g3, t2)), h2.values[i2.id] = p2(s2, h2.values[i2.id], { row: h2, column: i2, instance: a2() });
        }(e3, c2, 0, void 0, n3);
      });
    }
    l.resetExpanded = "resetExpanded", l.toggleRowExpanded = "toggleRowExpanded", l.toggleAllRowsExpanded = "toggleAllRowsExpanded";
    var se = function(e2) {
      e2.getToggleAllRowsExpandedProps = [ae], e2.getToggleRowExpandedProps = [ce], e2.stateReducers.push(de), e2.useInstance.push(fe), e2.prepareRow.push(pe);
    };
    se.pluginName = "useExpanded";
    var ae = function(e2, t2) {
      var n3 = t2.instance;
      return [e2, { onClick: function(e3) {
        n3.toggleAllRowsExpanded();
      }, style: { cursor: "pointer" }, title: "Toggle All Rows Expanded" }];
    }, ce = function(e2, t2) {
      var n3 = t2.row;
      return [e2, { onClick: function() {
        n3.toggleRowExpanded();
      }, style: { cursor: "pointer" }, title: "Toggle Row Expanded" }];
    };
    function de(e2, t2, n3, o2) {
      if (t2.type === l.init)
        return r({ expanded: {} }, e2);
      if (t2.type === l.resetExpanded)
        return r({}, e2, { expanded: o2.initialState.expanded || {} });
      if (t2.type === l.toggleAllRowsExpanded) {
        var s2 = t2.value, a2 = o2.isAllRowsExpanded, c2 = o2.rowsById;
        if (s2 !== void 0 ? s2 : !a2) {
          var d2 = {};
          return Object.keys(c2).forEach(function(e3) {
            d2[e3] = true;
          }), r({}, e2, { expanded: d2 });
        }
        return r({}, e2, { expanded: {} });
      }
      if (t2.type === l.toggleRowExpanded) {
        var f3, p3 = t2.id, g3 = t2.value, v2 = e2.expanded[p3], m3 = g3 !== void 0 ? g3 : !v2;
        if (!v2 && m3)
          return r({}, e2, { expanded: r({}, e2.expanded, (f3 = {}, f3[p3] = true, f3)) });
        if (v2 && !m3) {
          var h2 = e2.expanded;
          h2[p3];
          return r({}, e2, { expanded: i(h2, [p3].map(u)) });
        }
        return e2;
      }
    }
    function fe(e2) {
      var n3 = e2.data, o2 = e2.rows, r2 = e2.rowsById, i2 = e2.manualExpandedKey, u2 = i2 === void 0 ? "expanded" : i2, s2 = e2.paginateExpandedRows, a2 = s2 === void 0 || s2, c2 = e2.expandSubRows, d2 = c2 === void 0 || c2, p3 = e2.autoResetExpanded, g3 = p3 === void 0 || p3, m3 = e2.getHooks, y2 = e2.plugins, R2 = e2.state.expanded, b2 = e2.dispatch;
      v(y2, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
      var S2 = h(g3), C2 = Boolean(Object.keys(r2).length && Object.keys(R2).length);
      C2 && Object.keys(r2).some(function(e3) {
        return !R2[e3];
      }) && (C2 = false), w(function() {
        S2() && b2({ type: l.resetExpanded });
      }, [b2, n3]);
      var x2 = t.useCallback(function(e3, t2) {
        b2({ type: l.toggleRowExpanded, id: e3, value: t2 });
      }, [b2]), P2 = t.useCallback(function(e3) {
        return b2({ type: l.toggleAllRowsExpanded, value: e3 });
      }, [b2]), B2 = t.useMemo(function() {
        return a2 ? A(o2, { manualExpandedKey: u2, expanded: R2, expandSubRows: d2 }) : o2;
      }, [a2, o2, u2, R2, d2]), E2 = t.useMemo(function() {
        return function(e3) {
          var t2 = 0;
          return Object.keys(e3).forEach(function(e4) {
            var n4 = e4.split(".");
            t2 = Math.max(t2, n4.length);
          }), t2;
        }(R2);
      }, [R2]), I2 = h(e2), F2 = f2(m3().getToggleAllRowsExpandedProps, { instance: I2() });
      Object.assign(e2, { preExpandedRows: o2, expandedRows: B2, rows: B2, expandedDepth: E2, isAllRowsExpanded: C2, toggleRowExpanded: x2, toggleAllRowsExpanded: P2, getToggleAllRowsExpandedProps: F2 });
    }
    function pe(e2, t2) {
      var n3 = t2.instance.getHooks, o2 = t2.instance;
      e2.toggleRowExpanded = function(t3) {
        return o2.toggleRowExpanded(e2.id, t3);
      }, e2.getToggleRowExpandedProps = f2(n3().getToggleRowExpandedProps, { instance: o2, row: e2 });
    }
    var ge = function(e2, t2, n3) {
      return e2 = e2.filter(function(e3) {
        return t2.some(function(t3) {
          var o2 = e3.values[t3];
          return String(o2).toLowerCase().includes(String(n3).toLowerCase());
        });
      });
    };
    ge.autoRemove = function(e2) {
      return !e2;
    };
    var ve = function(e2, t2, n3) {
      return e2.filter(function(e3) {
        return t2.some(function(t3) {
          var o2 = e3.values[t3];
          return o2 === void 0 || String(o2).toLowerCase() === String(n3).toLowerCase();
        });
      });
    };
    ve.autoRemove = function(e2) {
      return !e2;
    };
    var me = function(e2, t2, n3) {
      return e2.filter(function(e3) {
        return t2.some(function(t3) {
          var o2 = e3.values[t3];
          return o2 === void 0 || String(o2) === String(n3);
        });
      });
    };
    me.autoRemove = function(e2) {
      return !e2;
    };
    var he = function(e2, t2, n3) {
      return e2.filter(function(e3) {
        return t2.some(function(t3) {
          return e3.values[t3].includes(n3);
        });
      });
    };
    he.autoRemove = function(e2) {
      return !e2 || !e2.length;
    };
    var ye = function(e2, t2, n3) {
      return e2.filter(function(e3) {
        return t2.some(function(t3) {
          var o2 = e3.values[t3];
          return o2 && o2.length && n3.every(function(e4) {
            return o2.includes(e4);
          });
        });
      });
    };
    ye.autoRemove = function(e2) {
      return !e2 || !e2.length;
    };
    var we = function(e2, t2, n3) {
      return e2.filter(function(e3) {
        return t2.some(function(t3) {
          var o2 = e3.values[t3];
          return o2 && o2.length && n3.some(function(e4) {
            return o2.includes(e4);
          });
        });
      });
    };
    we.autoRemove = function(e2) {
      return !e2 || !e2.length;
    };
    var Re = function(e2, t2, n3) {
      return e2.filter(function(e3) {
        return t2.some(function(t3) {
          var o2 = e3.values[t3];
          return n3.includes(o2);
        });
      });
    };
    Re.autoRemove = function(e2) {
      return !e2 || !e2.length;
    };
    var be = function(e2, t2, n3) {
      return e2.filter(function(e3) {
        return t2.some(function(t3) {
          return e3.values[t3] === n3;
        });
      });
    };
    be.autoRemove = function(e2) {
      return e2 === void 0;
    };
    var Se = function(e2, t2, n3) {
      return e2.filter(function(e3) {
        return t2.some(function(t3) {
          return e3.values[t3] == n3;
        });
      });
    };
    Se.autoRemove = function(e2) {
      return e2 == null;
    };
    var Ce = function(e2, t2, n3) {
      var o2 = n3 || [], r2 = o2[0], i2 = o2[1];
      if ((r2 = typeof r2 == "number" ? r2 : -1 / 0) > (i2 = typeof i2 == "number" ? i2 : 1 / 0)) {
        var u2 = r2;
        r2 = i2, i2 = u2;
      }
      return e2.filter(function(e3) {
        return t2.some(function(t3) {
          var n4 = e3.values[t3];
          return n4 >= r2 && n4 <= i2;
        });
      });
    };
    Ce.autoRemove = function(e2) {
      return !e2 || typeof e2[0] != "number" && typeof e2[1] != "number";
    };
    var xe = Object.freeze({ __proto__: null, text: ge, exactText: ve, exactTextCase: me, includes: he, includesAll: ye, includesSome: we, includesValue: Re, exact: be, equals: Se, between: Ce });
    l.resetFilters = "resetFilters", l.setFilter = "setFilter", l.setAllFilters = "setAllFilters";
    var Pe = function(e2) {
      e2.stateReducers.push(Be), e2.useInstance.push(Ee);
    };
    function Be(e2, t2, n3, o2) {
      if (t2.type === l.init)
        return r({ filters: [] }, e2);
      if (t2.type === l.resetFilters)
        return r({}, e2, { filters: o2.initialState.filters || [] });
      if (t2.type === l.setFilter) {
        var i2 = t2.columnId, u2 = t2.filterValue, s2 = o2.allColumns, a2 = o2.filterTypes, c2 = s2.find(function(e3) {
          return e3.id === i2;
        });
        if (!c2)
          throw new Error("React-Table: Could not find a column with id: " + i2);
        var d2 = k(c2.filter, a2 || {}, xe), f3 = e2.filters.find(function(e3) {
          return e3.id === i2;
        }), p3 = m2(u2, f3 && f3.value);
        return H(d2.autoRemove, p3, c2) ? r({}, e2, { filters: e2.filters.filter(function(e3) {
          return e3.id !== i2;
        }) }) : r({}, e2, f3 ? { filters: e2.filters.map(function(e3) {
          return e3.id === i2 ? { id: i2, value: p3 } : e3;
        }) } : { filters: [].concat(e2.filters, [{ id: i2, value: p3 }]) });
      }
      if (t2.type === l.setAllFilters) {
        var g3 = t2.filters, v2 = o2.allColumns, h2 = o2.filterTypes;
        return r({}, e2, { filters: m2(g3, e2.filters).filter(function(e3) {
          var t3 = v2.find(function(t4) {
            return t4.id === e3.id;
          });
          return !H(k(t3.filter, h2 || {}, xe).autoRemove, e3.value, t3);
        }) });
      }
    }
    function Ee(e2) {
      var n3 = e2.data, o2 = e2.rows, r2 = e2.flatRows, i2 = e2.rowsById, u2 = e2.allColumns, s2 = e2.filterTypes, a2 = e2.manualFilters, c2 = e2.defaultCanFilter, d2 = c2 !== void 0 && c2, f3 = e2.disableFilters, p3 = e2.state.filters, g3 = e2.dispatch, v2 = e2.autoResetFilters, m3 = v2 === void 0 || v2, y2 = t.useCallback(function(e3, t2) {
        g3({ type: l.setFilter, columnId: e3, filterValue: t2 });
      }, [g3]), R2 = t.useCallback(function(e3) {
        g3({ type: l.setAllFilters, filters: e3 });
      }, [g3]);
      u2.forEach(function(e3) {
        var t2 = e3.id, n4 = e3.accessor, o3 = e3.defaultCanFilter, r3 = e3.disableFilters;
        e3.canFilter = n4 ? I(r3 !== true && void 0, f3 !== true && void 0, true) : I(o3, d2, false), e3.setFilter = function(t3) {
          return y2(e3.id, t3);
        };
        var i3 = p3.find(function(e4) {
          return e4.id === t2;
        });
        e3.filterValue = i3 && i3.value;
      });
      var b2 = t.useMemo(function() {
        if (a2 || !p3.length)
          return [o2, r2, i2];
        var e3 = [], t2 = {};
        return [function n4(o3, r3) {
          r3 === void 0 && (r3 = 0);
          var i3 = o3;
          return (i3 = p3.reduce(function(e4, t3) {
            var n5 = t3.id, o4 = t3.value, i4 = u2.find(function(e5) {
              return e5.id === n5;
            });
            if (!i4)
              return e4;
            r3 === 0 && (i4.preFilteredRows = e4);
            var l2 = k(i4.filter, s2 || {}, xe);
            return l2 ? (i4.filteredRows = l2(e4, [n5], o4), i4.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i4.id + "."), e4);
          }, o3)).forEach(function(o4) {
            e3.push(o4), t2[o4.id] = o4, o4.subRows && (o4.subRows = o4.subRows && o4.subRows.length > 0 ? n4(o4.subRows, r3 + 1) : o4.subRows);
          }), i3;
        }(o2), e3, t2];
      }, [a2, p3, o2, r2, i2, u2, s2]), S2 = b2[0], C2 = b2[1], x2 = b2[2];
      t.useMemo(function() {
        u2.filter(function(e3) {
          return !p3.find(function(t2) {
            return t2.id === e3.id;
          });
        }).forEach(function(e3) {
          e3.preFilteredRows = S2, e3.filteredRows = S2;
        });
      }, [S2, p3, u2]);
      var P2 = h(m3);
      w(function() {
        P2() && g3({ type: l.resetFilters });
      }, [g3, a2 ? null : n3]), Object.assign(e2, { preFilteredRows: o2, preFilteredFlatRows: r2, preFilteredRowsById: i2, filteredRows: S2, filteredFlatRows: C2, filteredRowsById: x2, rows: S2, flatRows: C2, rowsById: x2, setFilter: y2, setAllFilters: R2 });
    }
    Pe.pluginName = "useFilters", l.resetGlobalFilter = "resetGlobalFilter", l.setGlobalFilter = "setGlobalFilter";
    var Ie = function(e2) {
      e2.stateReducers.push(Fe), e2.useInstance.push(Ge);
    };
    function Fe(e2, t2, n3, o2) {
      if (t2.type === l.resetGlobalFilter)
        return r({}, e2, { globalFilter: o2.initialState.globalFilter || void 0 });
      if (t2.type === l.setGlobalFilter) {
        var u2 = t2.filterValue, s2 = o2.userFilterTypes, a2 = k(o2.globalFilter, s2 || {}, xe), c2 = m2(u2, e2.globalFilter);
        if (H(a2.autoRemove, c2)) {
          e2.globalFilter;
          return i(e2, ["globalFilter"]);
        }
        return r({}, e2, { globalFilter: c2 });
      }
    }
    function Ge(e2) {
      var n3 = e2.data, o2 = e2.rows, r2 = e2.flatRows, i2 = e2.rowsById, u2 = e2.allColumns, s2 = e2.filterTypes, a2 = e2.globalFilter, c2 = e2.manualGlobalFilter, d2 = e2.state.globalFilter, f3 = e2.dispatch, p3 = e2.autoResetGlobalFilter, g3 = p3 === void 0 || p3, v2 = e2.disableGlobalFilter, m3 = t.useCallback(function(e3) {
        f3({ type: l.setGlobalFilter, filterValue: e3 });
      }, [f3]), y2 = t.useMemo(function() {
        if (c2 || d2 === void 0)
          return [o2, r2, i2];
        var e3 = [], t2 = {}, n4 = k(a2, s2 || {}, xe);
        if (!n4)
          return console.warn("Could not find a valid 'globalFilter' option."), o2;
        u2.forEach(function(e4) {
          var t3 = e4.disableGlobalFilter;
          e4.canFilter = I(t3 !== true && void 0, v2 !== true && void 0, true);
        });
        var l2 = u2.filter(function(e4) {
          return e4.canFilter === true;
        });
        return [function o3(r3) {
          return (r3 = n4(r3, l2.map(function(e4) {
            return e4.id;
          }), d2)).forEach(function(n5) {
            e3.push(n5), t2[n5.id] = n5, n5.subRows = n5.subRows && n5.subRows.length ? o3(n5.subRows) : n5.subRows;
          }), r3;
        }(o2), e3, t2];
      }, [c2, d2, a2, s2, u2, o2, r2, i2, v2]), R2 = y2[0], b2 = y2[1], S2 = y2[2], C2 = h(g3);
      w(function() {
        C2() && f3({ type: l.resetGlobalFilter });
      }, [f3, c2 ? null : n3]), Object.assign(e2, { preGlobalFilteredRows: o2, preGlobalFilteredFlatRows: r2, preGlobalFilteredRowsById: i2, globalFilteredRows: R2, globalFilteredFlatRows: b2, globalFilteredRowsById: S2, rows: R2, flatRows: b2, rowsById: S2, setGlobalFilter: m3, disableGlobalFilter: v2 });
    }
    function Ae(e2, t2) {
      return t2.reduce(function(e3, t3) {
        return e3 + (typeof t3 == "number" ? t3 : 0);
      }, 0);
    }
    Ie.pluginName = "useGlobalFilter";
    var ke = Object.freeze({ __proto__: null, sum: Ae, min: function(e2) {
      var t2 = e2[0] || 0;
      return e2.forEach(function(e3) {
        typeof e3 == "number" && (t2 = Math.min(t2, e3));
      }), t2;
    }, max: function(e2) {
      var t2 = e2[0] || 0;
      return e2.forEach(function(e3) {
        typeof e3 == "number" && (t2 = Math.max(t2, e3));
      }), t2;
    }, minMax: function(e2) {
      var t2 = e2[0] || 0, n3 = e2[0] || 0;
      return e2.forEach(function(e3) {
        typeof e3 == "number" && (t2 = Math.min(t2, e3), n3 = Math.max(n3, e3));
      }), t2 + ".." + n3;
    }, average: function(e2) {
      return Ae(0, e2) / e2.length;
    }, median: function(e2) {
      if (!e2.length)
        return null;
      var t2 = Math.floor(e2.length / 2), n3 = [].concat(e2).sort(function(e3, t3) {
        return e3 - t3;
      });
      return e2.length % 2 != 0 ? n3[t2] : (n3[t2 - 1] + n3[t2]) / 2;
    }, unique: function(e2) {
      return Array.from(new Set(e2).values());
    }, uniqueCount: function(e2) {
      return new Set(e2).size;
    }, count: function(e2) {
      return e2.length;
    } }), He = [], Te = {};
    l.resetGroupBy = "resetGroupBy", l.setGroupBy = "setGroupBy", l.toggleGroupBy = "toggleGroupBy";
    var ze = function(e2) {
      e2.getGroupByToggleProps = [We], e2.stateReducers.push(Oe), e2.visibleColumnsDeps.push(function(e3, t2) {
        var n3 = t2.instance;
        return [].concat(e3, [n3.state.groupBy]);
      }), e2.visibleColumns.push(Me), e2.useInstance.push(Ne), e2.prepareRow.push(Le);
    };
    ze.pluginName = "useGroupBy";
    var We = function(e2, t2) {
      var n3 = t2.header;
      return [e2, { onClick: n3.canGroupBy ? function(e3) {
        e3.persist(), n3.toggleGroupBy();
      } : void 0, style: { cursor: n3.canGroupBy ? "pointer" : void 0 }, title: "Toggle GroupBy" }];
    };
    function Oe(e2, t2, n3, o2) {
      if (t2.type === l.init)
        return r({ groupBy: [] }, e2);
      if (t2.type === l.resetGroupBy)
        return r({}, e2, { groupBy: o2.initialState.groupBy || [] });
      if (t2.type === l.setGroupBy)
        return r({}, e2, { groupBy: t2.value });
      if (t2.type === l.toggleGroupBy) {
        var i2 = t2.columnId, u2 = t2.value, s2 = u2 !== void 0 ? u2 : !e2.groupBy.includes(i2);
        return r({}, e2, s2 ? { groupBy: [].concat(e2.groupBy, [i2]) } : { groupBy: e2.groupBy.filter(function(e3) {
          return e3 !== i2;
        }) });
      }
    }
    function Me(e2, t2) {
      var n3 = t2.instance.state.groupBy, o2 = n3.map(function(t3) {
        return e2.find(function(e3) {
          return e3.id === t3;
        });
      }).filter(Boolean), r2 = e2.filter(function(e3) {
        return !n3.includes(e3.id);
      });
      return (e2 = [].concat(o2, r2)).forEach(function(e3) {
        e3.isGrouped = n3.includes(e3.id), e3.groupedIndex = n3.indexOf(e3.id);
      }), e2;
    }
    var je = {};
    function Ne(e2) {
      var n3 = e2.data, o2 = e2.rows, r2 = e2.flatRows, i2 = e2.rowsById, u2 = e2.allColumns, s2 = e2.flatHeaders, a2 = e2.groupByFn, c2 = a2 === void 0 ? De : a2, d2 = e2.manualGroupBy, p3 = e2.aggregations, g3 = p3 === void 0 ? je : p3, m3 = e2.plugins, y2 = e2.state.groupBy, R2 = e2.dispatch, b2 = e2.autoResetGroupBy, S2 = b2 === void 0 || b2, C2 = e2.disableGroupBy, x2 = e2.defaultCanGroupBy, P2 = e2.getHooks;
      v(m3, ["useColumnOrder", "useFilters"], "useGroupBy");
      var B2 = h(e2);
      u2.forEach(function(t2) {
        var n4 = t2.accessor, o3 = t2.defaultGroupBy, r3 = t2.disableGroupBy;
        t2.canGroupBy = n4 ? I(t2.canGroupBy, r3 !== true && void 0, C2 !== true && void 0, true) : I(t2.canGroupBy, o3, x2, false), t2.canGroupBy && (t2.toggleGroupBy = function() {
          return e2.toggleGroupBy(t2.id);
        }), t2.Aggregated = t2.Aggregated || t2.Cell;
      });
      var E2 = t.useCallback(function(e3, t2) {
        R2({ type: l.toggleGroupBy, columnId: e3, value: t2 });
      }, [R2]), F2 = t.useCallback(function(e3) {
        R2({ type: l.setGroupBy, value: e3 });
      }, [R2]);
      s2.forEach(function(e3) {
        e3.getGroupByToggleProps = f2(P2().getGroupByToggleProps, { instance: B2(), header: e3 });
      });
      var A2 = t.useMemo(function() {
        if (d2 || !y2.length)
          return [o2, r2, i2, He, Te, r2, i2];
        var e3 = y2.filter(function(e4) {
          return u2.find(function(t3) {
            return t3.id === e4;
          });
        }), t2 = [], n4 = {}, l2 = [], s3 = {}, a3 = [], f3 = {}, p4 = function o3(r3, i3, d3) {
          if (i3 === void 0 && (i3 = 0), i3 === e3.length)
            return r3;
          var p5 = e3[i3], v2 = c2(r3, p5);
          return Object.entries(v2).map(function(r4, c3) {
            var v3 = r4[0], m4 = r4[1], h2 = p5 + ":" + v3, y3 = o3(m4, i3 + 1, h2 = d3 ? d3 + ">" + h2 : h2), w2 = i3 ? G(m4, "leafRows") : m4, R3 = function(t3, n5, o4) {
              var r5 = {};
              return u2.forEach(function(i4) {
                if (e3.includes(i4.id))
                  r5[i4.id] = n5[0] ? n5[0].values[i4.id] : null;
                else {
                  var u3 = typeof i4.aggregate == "function" ? i4.aggregate : g3[i4.aggregate] || ke[i4.aggregate];
                  if (u3) {
                    var l3 = n5.map(function(e4) {
                      return e4.values[i4.id];
                    }), s4 = t3.map(function(e4) {
                      var t4 = e4.values[i4.id];
                      if (!o4 && i4.aggregateValue) {
                        var n6 = typeof i4.aggregateValue == "function" ? i4.aggregateValue : g3[i4.aggregateValue] || ke[i4.aggregateValue];
                        if (!n6)
                          throw console.info({ column: i4 }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                        t4 = n6(t4, e4, i4);
                      }
                      return t4;
                    });
                    r5[i4.id] = u3(s4, l3);
                  } else {
                    if (i4.aggregate)
                      throw console.info({ column: i4 }), new Error("React Table: Invalid column.aggregate option for column listed above");
                    r5[i4.id] = null;
                  }
                }
              }), r5;
            }(w2, m4, i3), b3 = { id: h2, isGrouped: true, groupByID: p5, groupByVal: v3, values: R3, subRows: y3, leafRows: w2, depth: i3, index: c3 };
            return y3.forEach(function(e4) {
              t2.push(e4), n4[e4.id] = e4, e4.isGrouped ? (l2.push(e4), s3[e4.id] = e4) : (a3.push(e4), f3[e4.id] = e4);
            }), b3;
          });
        }(o2);
        return p4.forEach(function(e4) {
          t2.push(e4), n4[e4.id] = e4, e4.isGrouped ? (l2.push(e4), s3[e4.id] = e4) : (a3.push(e4), f3[e4.id] = e4);
        }), [p4, t2, n4, l2, s3, a3, f3];
      }, [d2, y2, o2, r2, i2, u2, g3, c2]), k2 = A2[0], H2 = A2[1], T2 = A2[2], z2 = A2[3], W2 = A2[4], O2 = A2[5], M2 = A2[6], j2 = h(S2);
      w(function() {
        j2() && R2({ type: l.resetGroupBy });
      }, [R2, d2 ? null : n3]), Object.assign(e2, { preGroupedRows: o2, preGroupedFlatRow: r2, preGroupedRowsById: i2, groupedRows: k2, groupedFlatRows: H2, groupedRowsById: T2, onlyGroupedFlatRows: z2, onlyGroupedRowsById: W2, nonGroupedFlatRows: O2, nonGroupedRowsById: M2, rows: k2, flatRows: H2, rowsById: T2, toggleGroupBy: E2, setGroupBy: F2 });
    }
    function Le(e2) {
      e2.allCells.forEach(function(t2) {
        var n3;
        t2.isGrouped = t2.column.isGrouped && t2.column.id === e2.groupByID, t2.isPlaceholder = !t2.isGrouped && t2.column.isGrouped, t2.isAggregated = !t2.isGrouped && !t2.isPlaceholder && ((n3 = e2.subRows) == null ? void 0 : n3.length);
      });
    }
    function De(e2, t2) {
      return e2.reduce(function(e3, n3, o2) {
        var r2 = "" + n3.values[t2];
        return e3[r2] = Array.isArray(e3[r2]) ? e3[r2] : [], e3[r2].push(n3), e3;
      }, {});
    }
    var Ve = /([0-9]+)/gm;
    function _e(e2, t2) {
      return e2 === t2 ? 0 : e2 > t2 ? 1 : -1;
    }
    function Xe(e2, t2, n3) {
      return [e2.values[n3], t2.values[n3]];
    }
    function qe(e2) {
      return typeof e2 == "number" ? isNaN(e2) || e2 === 1 / 0 || e2 === -1 / 0 ? "" : String(e2) : typeof e2 == "string" ? e2 : "";
    }
    var Ke = Object.freeze({ __proto__: null, alphanumeric: function(e2, t2, n3) {
      var o2 = Xe(e2, t2, n3), r2 = o2[0], i2 = o2[1];
      for (r2 = qe(r2), i2 = qe(i2), r2 = r2.split(Ve).filter(Boolean), i2 = i2.split(Ve).filter(Boolean); r2.length && i2.length; ) {
        var u2 = r2.shift(), l2 = i2.shift(), s2 = parseInt(u2, 10), a2 = parseInt(l2, 10), c2 = [s2, a2].sort();
        if (isNaN(c2[0])) {
          if (u2 > l2)
            return 1;
          if (l2 > u2)
            return -1;
        } else {
          if (isNaN(c2[1]))
            return isNaN(s2) ? -1 : 1;
          if (s2 > a2)
            return 1;
          if (a2 > s2)
            return -1;
        }
      }
      return r2.length - i2.length;
    }, datetime: function(e2, t2, n3) {
      var o2 = Xe(e2, t2, n3), r2 = o2[0], i2 = o2[1];
      return _e(r2 = r2.getTime(), i2 = i2.getTime());
    }, basic: function(e2, t2, n3) {
      var o2 = Xe(e2, t2, n3);
      return _e(o2[0], o2[1]);
    }, string: function(e2, t2, n3) {
      var o2 = Xe(e2, t2, n3), r2 = o2[0], i2 = o2[1];
      for (r2 = r2.split("").filter(Boolean), i2 = i2.split("").filter(Boolean); r2.length && i2.length; ) {
        var u2 = r2.shift(), l2 = i2.shift(), s2 = u2.toLowerCase(), a2 = l2.toLowerCase();
        if (s2 > a2)
          return 1;
        if (a2 > s2)
          return -1;
        if (u2 > l2)
          return 1;
        if (l2 > u2)
          return -1;
      }
      return r2.length - i2.length;
    }, number: function(e2, t2, n3) {
      var o2 = Xe(e2, t2, n3), r2 = o2[0], i2 = o2[1], u2 = /[^0-9.]/gi;
      return _e(r2 = Number(String(r2).replace(u2, "")), i2 = Number(String(i2).replace(u2, "")));
    } });
    l.resetSortBy = "resetSortBy", l.setSortBy = "setSortBy", l.toggleSortBy = "toggleSortBy", l.clearSortBy = "clearSortBy", c.sortType = "alphanumeric", c.sortDescFirst = false;
    var Ue = function(e2) {
      e2.getSortByToggleProps = [$e], e2.stateReducers.push(Je), e2.useInstance.push(Ye);
    };
    Ue.pluginName = "useSortBy";
    var $e = function(e2, t2) {
      var n3 = t2.instance, o2 = t2.column, r2 = n3.isMultiSortEvent, i2 = r2 === void 0 ? function(e3) {
        return e3.shiftKey;
      } : r2;
      return [e2, { onClick: o2.canSort ? function(e3) {
        e3.persist(), o2.toggleSortBy(void 0, !n3.disableMultiSort && i2(e3));
      } : void 0, style: { cursor: o2.canSort ? "pointer" : void 0 }, title: o2.canSort ? "Toggle SortBy" : void 0 }];
    };
    function Je(e2, t2, n3, o2) {
      if (t2.type === l.init)
        return r({ sortBy: [] }, e2);
      if (t2.type === l.resetSortBy)
        return r({}, e2, { sortBy: o2.initialState.sortBy || [] });
      if (t2.type === l.clearSortBy)
        return r({}, e2, { sortBy: e2.sortBy.filter(function(e3) {
          return e3.id !== t2.columnId;
        }) });
      if (t2.type === l.setSortBy)
        return r({}, e2, { sortBy: t2.sortBy });
      if (t2.type === l.toggleSortBy) {
        var i2, u2 = t2.columnId, s2 = t2.desc, a2 = t2.multi, c2 = o2.allColumns, d2 = o2.disableMultiSort, f3 = o2.disableSortRemove, p3 = o2.disableMultiRemove, g3 = o2.maxMultiSortColCount, v2 = g3 === void 0 ? Number.MAX_SAFE_INTEGER : g3, m3 = e2.sortBy, h2 = c2.find(function(e3) {
          return e3.id === u2;
        }).sortDescFirst, y2 = m3.find(function(e3) {
          return e3.id === u2;
        }), w2 = m3.findIndex(function(e3) {
          return e3.id === u2;
        }), R2 = s2 != null, b2 = [];
        return (i2 = !d2 && a2 ? y2 ? "toggle" : "add" : w2 !== m3.length - 1 || m3.length !== 1 ? "replace" : y2 ? "toggle" : "replace") !== "toggle" || f3 || R2 || a2 && p3 || !(y2 && y2.desc && !h2 || !y2.desc && h2) || (i2 = "remove"), i2 === "replace" ? b2 = [{ id: u2, desc: R2 ? s2 : h2 }] : i2 === "add" ? (b2 = [].concat(m3, [{ id: u2, desc: R2 ? s2 : h2 }])).splice(0, b2.length - v2) : i2 === "toggle" ? b2 = m3.map(function(e3) {
          return e3.id === u2 ? r({}, e3, { desc: R2 ? s2 : !y2.desc }) : e3;
        }) : i2 === "remove" && (b2 = m3.filter(function(e3) {
          return e3.id !== u2;
        })), r({}, e2, { sortBy: b2 });
      }
    }
    function Ye(e2) {
      var n3 = e2.data, o2 = e2.rows, r2 = e2.flatRows, i2 = e2.allColumns, u2 = e2.orderByFn, s2 = u2 === void 0 ? Qe : u2, a2 = e2.sortTypes, c2 = e2.manualSortBy, d2 = e2.defaultCanSort, p3 = e2.disableSortBy, g3 = e2.flatHeaders, m3 = e2.state.sortBy, y2 = e2.dispatch, R2 = e2.plugins, b2 = e2.getHooks, S2 = e2.autoResetSortBy, C2 = S2 === void 0 || S2;
      v(R2, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
      var x2 = t.useCallback(function(e3) {
        y2({ type: l.setSortBy, sortBy: e3 });
      }, [y2]), P2 = t.useCallback(function(e3, t2, n4) {
        y2({ type: l.toggleSortBy, columnId: e3, desc: t2, multi: n4 });
      }, [y2]), B2 = h(e2);
      g3.forEach(function(e3) {
        var t2 = e3.accessor, n4 = e3.canSort, o3 = e3.disableSortBy, r3 = e3.id, i3 = t2 ? I(o3 !== true && void 0, p3 !== true && void 0, true) : I(d2, n4, false);
        e3.canSort = i3, e3.canSort && (e3.toggleSortBy = function(t3, n5) {
          return P2(e3.id, t3, n5);
        }, e3.clearSortBy = function() {
          y2({ type: l.clearSortBy, columnId: e3.id });
        }), e3.getSortByToggleProps = f2(b2().getSortByToggleProps, { instance: B2(), column: e3 });
        var u3 = m3.find(function(e4) {
          return e4.id === r3;
        });
        e3.isSorted = !!u3, e3.sortedIndex = m3.findIndex(function(e4) {
          return e4.id === r3;
        }), e3.isSortedDesc = e3.isSorted ? u3.desc : void 0;
      });
      var E2 = t.useMemo(function() {
        if (c2 || !m3.length)
          return [o2, r2];
        var e3 = [], t2 = m3.filter(function(e4) {
          return i2.find(function(t3) {
            return t3.id === e4.id;
          });
        });
        return [function n4(o3) {
          var r3 = s2(o3, t2.map(function(e4) {
            var t3 = i2.find(function(t4) {
              return t4.id === e4.id;
            });
            if (!t3)
              throw new Error("React-Table: Could not find a column with id: " + e4.id + " while sorting");
            var n5 = t3.sortType, o4 = F(n5) || (a2 || {})[n5] || Ke[n5];
            if (!o4)
              throw new Error("React-Table: Could not find a valid sortType of '" + n5 + "' for column '" + e4.id + "'.");
            return function(t4, n6) {
              return o4(t4, n6, e4.id, e4.desc);
            };
          }), t2.map(function(e4) {
            var t3 = i2.find(function(t4) {
              return t4.id === e4.id;
            });
            return t3 && t3.sortInverted ? e4.desc : !e4.desc;
          }));
          return r3.forEach(function(t3) {
            e3.push(t3), t3.subRows && t3.subRows.length !== 0 && (t3.subRows = n4(t3.subRows));
          }), r3;
        }(o2), e3];
      }, [c2, m3, o2, r2, i2, s2, a2]), G2 = E2[0], A2 = E2[1], k2 = h(C2);
      w(function() {
        k2() && y2({ type: l.resetSortBy });
      }, [c2 ? null : n3]), Object.assign(e2, { preSortedRows: o2, preSortedFlatRows: r2, sortedRows: G2, sortedFlatRows: A2, rows: G2, flatRows: A2, setSortBy: x2, toggleSortBy: P2 });
    }
    function Qe(e2, t2, n3) {
      return [].concat(e2).sort(function(e3, o2) {
        for (var r2 = 0; r2 < t2.length; r2 += 1) {
          var i2 = t2[r2], u2 = n3[r2] === false || n3[r2] === "desc", l2 = i2(e3, o2);
          if (l2 !== 0)
            return u2 ? -l2 : l2;
        }
        return n3[0] ? e3.index - o2.index : o2.index - e3.index;
      });
    }
    l.resetPage = "resetPage", l.gotoPage = "gotoPage", l.setPageSize = "setPageSize";
    var Ze = function(e2) {
      e2.stateReducers.push(et), e2.useInstance.push(tt);
    };
    function et(e2, t2, n3, o2) {
      if (t2.type === l.init)
        return r({ pageSize: 10, pageIndex: 0 }, e2);
      if (t2.type === l.resetPage)
        return r({}, e2, { pageIndex: o2.initialState.pageIndex || 0 });
      if (t2.type === l.gotoPage) {
        var i2 = o2.pageCount, u2 = o2.page, s2 = m2(t2.pageIndex, e2.pageIndex), a2 = false;
        return s2 > e2.pageIndex ? a2 = i2 === -1 ? u2.length >= e2.pageSize : s2 < i2 : s2 < e2.pageIndex && (a2 = s2 > -1), a2 ? r({}, e2, { pageIndex: s2 }) : e2;
      }
      if (t2.type === l.setPageSize) {
        var c2 = t2.pageSize, d2 = e2.pageSize * e2.pageIndex;
        return r({}, e2, { pageIndex: Math.floor(d2 / c2), pageSize: c2 });
      }
    }
    function tt(e2) {
      var n3 = e2.rows, o2 = e2.autoResetPage, r2 = o2 === void 0 || o2, i2 = e2.manualExpandedKey, u2 = i2 === void 0 ? "expanded" : i2, s2 = e2.plugins, a2 = e2.pageCount, c2 = e2.paginateExpandedRows, d2 = c2 === void 0 || c2, f3 = e2.expandSubRows, p3 = f3 === void 0 || f3, g3 = e2.state, m3 = g3.pageSize, y2 = g3.pageIndex, R2 = g3.expanded, b2 = g3.globalFilter, S2 = g3.filters, C2 = g3.groupBy, x2 = g3.sortBy, P2 = e2.dispatch, B2 = e2.data, E2 = e2.manualPagination;
      v(s2, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
      var I2 = h(r2);
      w(function() {
        I2() && P2({ type: l.resetPage });
      }, [P2, E2 ? null : B2, b2, S2, C2, x2]);
      var F2 = E2 ? a2 : Math.ceil(n3.length / m3), G2 = t.useMemo(function() {
        return F2 > 0 ? [].concat(new Array(F2)).fill(null).map(function(e3, t2) {
          return t2;
        }) : [];
      }, [F2]), k2 = t.useMemo(function() {
        var e3;
        if (E2)
          e3 = n3;
        else {
          var t2 = m3 * y2, o3 = t2 + m3;
          e3 = n3.slice(t2, o3);
        }
        return d2 ? e3 : A(e3, { manualExpandedKey: u2, expanded: R2, expandSubRows: p3 });
      }, [p3, R2, u2, E2, y2, m3, d2, n3]), H2 = y2 > 0, T2 = F2 === -1 ? k2.length >= m3 : y2 < F2 - 1, z2 = t.useCallback(function(e3) {
        P2({ type: l.gotoPage, pageIndex: e3 });
      }, [P2]), W2 = t.useCallback(function() {
        return z2(function(e3) {
          return e3 - 1;
        });
      }, [z2]), O2 = t.useCallback(function() {
        return z2(function(e3) {
          return e3 + 1;
        });
      }, [z2]), M2 = t.useCallback(function(e3) {
        P2({ type: l.setPageSize, pageSize: e3 });
      }, [P2]);
      Object.assign(e2, { pageOptions: G2, pageCount: F2, page: k2, canPreviousPage: H2, canNextPage: T2, gotoPage: z2, previousPage: W2, nextPage: O2, setPageSize: M2 });
    }
    Ze.pluginName = "usePagination", l.resetPivot = "resetPivot", l.togglePivot = "togglePivot";
    var nt = function(e2) {
      e2.getPivotToggleProps = [rt], e2.stateReducers.push(it), e2.useInstanceAfterData.push(ut), e2.allColumns.push(lt), e2.accessValue.push(st), e2.materializedColumns.push(at), e2.materializedColumnsDeps.push(ct), e2.visibleColumns.push(dt), e2.visibleColumnsDeps.push(ft), e2.useInstance.push(pt), e2.prepareRow.push(gt);
    };
    nt.pluginName = "usePivotColumns";
    var ot = [], rt = function(e2, t2) {
      var n3 = t2.header;
      return [e2, { onClick: n3.canPivot ? function(e3) {
        e3.persist(), n3.togglePivot();
      } : void 0, style: { cursor: n3.canPivot ? "pointer" : void 0 }, title: "Toggle Pivot" }];
    };
    function it(e2, t2, n3, o2) {
      if (t2.type === l.init)
        return r({ pivotColumns: ot }, e2);
      if (t2.type === l.resetPivot)
        return r({}, e2, { pivotColumns: o2.initialState.pivotColumns || ot });
      if (t2.type === l.togglePivot) {
        var i2 = t2.columnId, u2 = t2.value, s2 = u2 !== void 0 ? u2 : !e2.pivotColumns.includes(i2);
        return r({}, e2, s2 ? { pivotColumns: [].concat(e2.pivotColumns, [i2]) } : { pivotColumns: e2.pivotColumns.filter(function(e3) {
          return e3 !== i2;
        }) });
      }
    }
    function ut(e2) {
      e2.allColumns.forEach(function(t2) {
        t2.isPivotSource = e2.state.pivotColumns.includes(t2.id);
      });
    }
    function lt(e2, t2) {
      var n3 = t2.instance;
      return e2.forEach(function(e3) {
        e3.isPivotSource = n3.state.pivotColumns.includes(e3.id), e3.uniqueValues = /* @__PURE__ */ new Set();
      }), e2;
    }
    function st(e2, t2) {
      var n3 = t2.column;
      return n3.uniqueValues && e2 !== void 0 && n3.uniqueValues.add(e2), e2;
    }
    function at(e2, t2) {
      var n3 = t2.instance, o2 = n3.allColumns, i2 = n3.state;
      if (!i2.pivotColumns.length || !i2.groupBy || !i2.groupBy.length)
        return e2;
      var u2 = i2.pivotColumns.map(function(e3) {
        return o2.find(function(t3) {
          return t3.id === e3;
        });
      }).filter(Boolean), l2 = o2.filter(function(e3) {
        return !e3.isPivotSource && !i2.groupBy.includes(e3.id) && !i2.pivotColumns.includes(e3.id);
      }), s2 = C(function e3(t3, n4, o3) {
        t3 === void 0 && (t3 = 0), o3 === void 0 && (o3 = []);
        var i3 = u2[t3];
        return i3 ? Array.from(i3.uniqueValues).sort().map(function(u3) {
          var l3 = r({}, i3, { Header: i3.PivotHeader || typeof i3.header == "string" ? i3.Header + ": " + u3 : u3, isPivotGroup: true, parent: n4, depth: t3, id: n4 ? n4.id + "." + i3.id + "." + u3 : i3.id + "." + u3, pivotValue: u3 });
          return l3.columns = e3(t3 + 1, l3, [].concat(o3, [function(e4) {
            return e4.values[i3.id] === u3;
          }])), l3;
        }) : l2.map(function(e4) {
          return r({}, e4, { canPivot: false, isPivoted: true, parent: n4, depth: t3, id: "" + (n4 ? n4.id + "." + e4.id : e4.id), accessor: function(t4, n5, r2) {
            if (o3.every(function(e5) {
              return e5(r2);
            }))
              return r2.values[e4.id];
          } });
        });
      }());
      return [].concat(e2, s2);
    }
    function ct(e2, t2) {
      var n3 = t2.instance.state, o2 = n3.pivotColumns, r2 = n3.groupBy;
      return [].concat(e2, [o2, r2]);
    }
    function dt(e2, t2) {
      var n3 = t2.instance.state;
      return e2 = e2.filter(function(e3) {
        return !e3.isPivotSource;
      }), n3.pivotColumns.length && n3.groupBy && n3.groupBy.length && (e2 = e2.filter(function(e3) {
        return e3.isGrouped || e3.isPivoted;
      })), e2;
    }
    function ft(e2, t2) {
      var n3 = t2.instance;
      return [].concat(e2, [n3.state.pivotColumns, n3.state.groupBy]);
    }
    function pt(e2) {
      var t2 = e2.columns, n3 = e2.allColumns, o2 = e2.flatHeaders, r2 = e2.getHooks, i2 = e2.plugins, u2 = e2.dispatch, s2 = e2.autoResetPivot, a2 = s2 === void 0 || s2, c2 = e2.manaulPivot, d2 = e2.disablePivot, p3 = e2.defaultCanPivot;
      v(i2, ["useGroupBy"], "usePivotColumns");
      var g3 = h(e2);
      n3.forEach(function(t3) {
        var n4 = t3.accessor, o3 = t3.defaultPivot, r3 = t3.disablePivot;
        t3.canPivot = n4 ? I(t3.canPivot, r3 !== true && void 0, d2 !== true && void 0, true) : I(t3.canPivot, o3, p3, false), t3.canPivot && (t3.togglePivot = function() {
          return e2.togglePivot(t3.id);
        }), t3.Aggregated = t3.Aggregated || t3.Cell;
      });
      o2.forEach(function(e3) {
        e3.getPivotToggleProps = f2(r2().getPivotToggleProps, { instance: g3(), header: e3 });
      });
      var m3 = h(a2);
      w(function() {
        m3() && u2({ type: l.resetPivot });
      }, [u2, c2 ? null : t2]), Object.assign(e2, { togglePivot: function(e3, t3) {
        u2({ type: l.togglePivot, columnId: e3, value: t3 });
      } });
    }
    function gt(e2) {
      e2.allCells.forEach(function(e3) {
        e3.isPivoted = e3.column.isPivoted;
      });
    }
    l.resetSelectedRows = "resetSelectedRows", l.toggleAllRowsSelected = "toggleAllRowsSelected", l.toggleRowSelected = "toggleRowSelected", l.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
    var vt = function(e2) {
      e2.getToggleRowSelectedProps = [mt], e2.getToggleAllRowsSelectedProps = [ht], e2.getToggleAllPageRowsSelectedProps = [yt], e2.stateReducers.push(wt), e2.useInstance.push(Rt), e2.prepareRow.push(bt);
    };
    vt.pluginName = "useRowSelect";
    var mt = function(e2, t2) {
      var n3 = t2.instance, o2 = t2.row, r2 = n3.manualRowSelectedKey, i2 = r2 === void 0 ? "isSelected" : r2;
      return [e2, { onChange: function(e3) {
        o2.toggleRowSelected(e3.target.checked);
      }, style: { cursor: "pointer" }, checked: !(!o2.original || !o2.original[i2]) || o2.isSelected, title: "Toggle Row Selected", indeterminate: o2.isSomeSelected }];
    }, ht = function(e2, t2) {
      var n3 = t2.instance;
      return [e2, { onChange: function(e3) {
        n3.toggleAllRowsSelected(e3.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isAllRowsSelected, title: "Toggle All Rows Selected", indeterminate: Boolean(!n3.isAllRowsSelected && Object.keys(n3.state.selectedRowIds).length) }];
    }, yt = function(e2, t2) {
      var n3 = t2.instance;
      return [e2, { onChange: function(e3) {
        n3.toggleAllPageRowsSelected(e3.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isAllPageRowsSelected, title: "Toggle All Current Page Rows Selected", indeterminate: Boolean(!n3.isAllPageRowsSelected && n3.page.some(function(e3) {
        var t3 = e3.id;
        return n3.state.selectedRowIds[t3];
      })) }];
    };
    function wt(e2, t2, n3, o2) {
      if (t2.type === l.init)
        return r({ selectedRowIds: {} }, e2);
      if (t2.type === l.resetSelectedRows)
        return r({}, e2, { selectedRowIds: o2.initialState.selectedRowIds || {} });
      if (t2.type === l.toggleAllRowsSelected) {
        var i2 = t2.value, u2 = o2.isAllRowsSelected, s2 = o2.rowsById, a2 = o2.nonGroupedRowsById, c2 = a2 === void 0 ? s2 : a2, d2 = i2 !== void 0 ? i2 : !u2, f3 = Object.assign({}, e2.selectedRowIds);
        return d2 ? Object.keys(c2).forEach(function(e3) {
          f3[e3] = true;
        }) : Object.keys(c2).forEach(function(e3) {
          delete f3[e3];
        }), r({}, e2, { selectedRowIds: f3 });
      }
      if (t2.type === l.toggleRowSelected) {
        var p3 = t2.id, g3 = t2.value, v2 = o2.rowsById, m3 = o2.selectSubRows, h2 = m3 === void 0 || m3, y2 = o2.getSubRows, w2 = e2.selectedRowIds[p3], R2 = g3 !== void 0 ? g3 : !w2;
        if (w2 === R2)
          return e2;
        var b2 = r({}, e2.selectedRowIds);
        return function e3(t3) {
          var n4 = v2[t3];
          if (n4.isGrouped || (R2 ? b2[t3] = true : delete b2[t3]), h2 && y2(n4))
            return y2(n4).forEach(function(t4) {
              return e3(t4.id);
            });
        }(p3), r({}, e2, { selectedRowIds: b2 });
      }
      if (t2.type === l.toggleAllPageRowsSelected) {
        var S2 = t2.value, C2 = o2.page, x2 = o2.rowsById, P2 = o2.selectSubRows, B2 = P2 === void 0 || P2, E2 = o2.isAllPageRowsSelected, I2 = o2.getSubRows, F2 = S2 !== void 0 ? S2 : !E2, G2 = r({}, e2.selectedRowIds);
        return C2.forEach(function(e3) {
          return function e4(t3) {
            var n4 = x2[t3];
            if (n4.isGrouped || (F2 ? G2[t3] = true : delete G2[t3]), B2 && I2(n4))
              return I2(n4).forEach(function(t4) {
                return e4(t4.id);
              });
          }(e3.id);
        }), r({}, e2, { selectedRowIds: G2 });
      }
      return e2;
    }
    function Rt(e2) {
      var n3 = e2.data, o2 = e2.rows, r2 = e2.getHooks, i2 = e2.plugins, u2 = e2.rowsById, s2 = e2.nonGroupedRowsById, a2 = s2 === void 0 ? u2 : s2, c2 = e2.autoResetSelectedRows, d2 = c2 === void 0 || c2, p3 = e2.state.selectedRowIds, g3 = e2.selectSubRows, m3 = g3 === void 0 || g3, y2 = e2.dispatch, R2 = e2.page, b2 = e2.getSubRows;
      v(i2, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
      var S2 = t.useMemo(function() {
        var e3 = [];
        return o2.forEach(function(t2) {
          var n4 = m3 ? function e4(t3, n5, o3) {
            if (n5[t3.id])
              return true;
            var r3 = o3(t3);
            if (r3 && r3.length) {
              var i3 = true, u3 = false;
              return r3.forEach(function(t4) {
                u3 && !i3 || (e4(t4, n5, o3) ? u3 = true : i3 = false);
              }), !!i3 || !!u3 && null;
            }
            return false;
          }(t2, p3, b2) : !!p3[t2.id];
          t2.isSelected = !!n4, t2.isSomeSelected = n4 === null, n4 && e3.push(t2);
        }), e3;
      }, [o2, m3, p3, b2]), C2 = Boolean(Object.keys(a2).length && Object.keys(p3).length), x2 = C2;
      C2 && Object.keys(a2).some(function(e3) {
        return !p3[e3];
      }) && (C2 = false), C2 || R2 && R2.length && R2.some(function(e3) {
        var t2 = e3.id;
        return !p3[t2];
      }) && (x2 = false);
      var P2 = h(d2);
      w(function() {
        P2() && y2({ type: l.resetSelectedRows });
      }, [y2, n3]);
      var B2 = t.useCallback(function(e3) {
        return y2({ type: l.toggleAllRowsSelected, value: e3 });
      }, [y2]), E2 = t.useCallback(function(e3) {
        return y2({ type: l.toggleAllPageRowsSelected, value: e3 });
      }, [y2]), I2 = t.useCallback(function(e3, t2) {
        return y2({ type: l.toggleRowSelected, id: e3, value: t2 });
      }, [y2]), F2 = h(e2), G2 = f2(r2().getToggleAllRowsSelectedProps, { instance: F2() }), A2 = f2(r2().getToggleAllPageRowsSelectedProps, { instance: F2() });
      Object.assign(e2, { selectedFlatRows: S2, isAllRowsSelected: C2, isAllPageRowsSelected: x2, toggleRowSelected: I2, toggleAllRowsSelected: B2, getToggleAllRowsSelectedProps: G2, getToggleAllPageRowsSelectedProps: A2, toggleAllPageRowsSelected: E2 });
    }
    function bt(e2, t2) {
      var n3 = t2.instance;
      e2.toggleRowSelected = function(t3) {
        return n3.toggleRowSelected(e2.id, t3);
      }, e2.getToggleRowSelectedProps = f2(n3.getHooks().getToggleRowSelectedProps, { instance: n3, row: e2 });
    }
    var St = function(e2) {
      return {};
    }, Ct = function(e2) {
      return {};
    };
    l.setRowState = "setRowState", l.setCellState = "setCellState", l.resetRowState = "resetRowState";
    var xt = function(e2) {
      e2.stateReducers.push(Pt), e2.useInstance.push(Bt), e2.prepareRow.push(Et);
    };
    function Pt(e2, t2, n3, o2) {
      var i2 = o2.initialRowStateAccessor, u2 = i2 === void 0 ? St : i2, s2 = o2.initialCellStateAccessor, a2 = s2 === void 0 ? Ct : s2, c2 = o2.rowsById;
      if (t2.type === l.init)
        return r({ rowState: {} }, e2);
      if (t2.type === l.resetRowState)
        return r({}, e2, { rowState: o2.initialState.rowState || {} });
      if (t2.type === l.setRowState) {
        var d2, f3 = t2.rowId, p3 = t2.value, g3 = e2.rowState[f3] !== void 0 ? e2.rowState[f3] : u2(c2[f3]);
        return r({}, e2, { rowState: r({}, e2.rowState, (d2 = {}, d2[f3] = m2(p3, g3), d2)) });
      }
      if (t2.type === l.setCellState) {
        var v2, h2, y2, w2, R2, b2 = t2.rowId, S2 = t2.columnId, C2 = t2.value, x2 = e2.rowState[b2] !== void 0 ? e2.rowState[b2] : u2(c2[b2]), P2 = (x2 == null ? void 0 : (v2 = x2.cellState) == null ? void 0 : v2[S2]) !== void 0 ? x2.cellState[S2] : a2((h2 = c2[b2]) == null ? void 0 : (y2 = h2.cells) == null ? void 0 : y2.find(function(e3) {
          return e3.column.id === S2;
        }));
        return r({}, e2, { rowState: r({}, e2.rowState, (R2 = {}, R2[b2] = r({}, x2, { cellState: r({}, x2.cellState || {}, (w2 = {}, w2[S2] = m2(C2, P2), w2)) }), R2)) });
      }
    }
    function Bt(e2) {
      var n3 = e2.autoResetRowState, o2 = n3 === void 0 || n3, r2 = e2.data, i2 = e2.dispatch, u2 = t.useCallback(function(e3, t2) {
        return i2({ type: l.setRowState, rowId: e3, value: t2 });
      }, [i2]), s2 = t.useCallback(function(e3, t2, n4) {
        return i2({ type: l.setCellState, rowId: e3, columnId: t2, value: n4 });
      }, [i2]), a2 = h(o2);
      w(function() {
        a2() && i2({ type: l.resetRowState });
      }, [r2]), Object.assign(e2, { setRowState: u2, setCellState: s2 });
    }
    function Et(e2, t2) {
      var n3 = t2.instance, o2 = n3.initialRowStateAccessor, r2 = o2 === void 0 ? St : o2, i2 = n3.initialCellStateAccessor, u2 = i2 === void 0 ? Ct : i2, l2 = n3.state.rowState;
      e2 && (e2.state = l2[e2.id] !== void 0 ? l2[e2.id] : r2(e2), e2.setState = function(t3) {
        return n3.setRowState(e2.id, t3);
      }, e2.cells.forEach(function(t3) {
        e2.state.cellState || (e2.state.cellState = {}), t3.state = e2.state.cellState[t3.column.id] !== void 0 ? e2.state.cellState[t3.column.id] : u2(t3), t3.setState = function(o3) {
          return n3.setCellState(e2.id, t3.column.id, o3);
        };
      }));
    }
    xt.pluginName = "useRowState", l.resetColumnOrder = "resetColumnOrder", l.setColumnOrder = "setColumnOrder";
    var It = function(e2) {
      e2.stateReducers.push(Ft), e2.visibleColumnsDeps.push(function(e3, t2) {
        var n3 = t2.instance;
        return [].concat(e3, [n3.state.columnOrder]);
      }), e2.visibleColumns.push(Gt), e2.useInstance.push(At);
    };
    function Ft(e2, t2, n3, o2) {
      return t2.type === l.init ? r({ columnOrder: [] }, e2) : t2.type === l.resetColumnOrder ? r({}, e2, { columnOrder: o2.initialState.columnOrder || [] }) : t2.type === l.setColumnOrder ? r({}, e2, { columnOrder: m2(t2.columnOrder, e2.columnOrder) }) : void 0;
    }
    function Gt(e2, t2) {
      var n3 = t2.instance.state.columnOrder;
      if (!n3 || !n3.length)
        return e2;
      for (var o2 = [].concat(n3), r2 = [].concat(e2), i2 = [], u2 = function() {
        var e3 = o2.shift(), t3 = r2.findIndex(function(t4) {
          return t4.id === e3;
        });
        t3 > -1 && i2.push(r2.splice(t3, 1)[0]);
      }; r2.length && o2.length; )
        u2();
      return [].concat(i2, r2);
    }
    function At(e2) {
      var n3 = e2.dispatch;
      e2.setColumnOrder = t.useCallback(function(e3) {
        return n3({ type: l.setColumnOrder, columnOrder: e3 });
      }, [n3]);
    }
    It.pluginName = "useColumnOrder", c.canResize = true, l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize";
    var kt = function(e2) {
      e2.getResizerProps = [Ht], e2.getHeaderProps.push({ style: { position: "relative" } }), e2.stateReducers.push(Tt), e2.useInstance.push(Wt), e2.useInstanceBeforeDimensions.push(zt);
    }, Ht = function(e2, t2) {
      var n3 = t2.instance, o2 = t2.header, r2 = n3.dispatch, i2 = function(e3, t3) {
        var n4 = false;
        if (e3.type === "touchstart") {
          if (e3.touches && e3.touches.length > 1)
            return;
          n4 = true;
        }
        var o3 = function(e4) {
          var t4 = [];
          return function e5(n5) {
            n5.columns && n5.columns.length && n5.columns.map(e5);
            t4.push(n5);
          }(e4), t4;
        }(t3).map(function(e4) {
          return [e4.id, e4.totalWidth];
        }), i3 = n4 ? Math.round(e3.touches[0].clientX) : e3.clientX, u2 = function(e4) {
          r2({ type: l.columnResizing, clientX: e4 });
        }, s2 = function() {
          return r2({ type: l.columnDoneResizing });
        }, a2 = { mouse: { moveEvent: "mousemove", moveHandler: function(e4) {
          return u2(e4.clientX);
        }, upEvent: "mouseup", upHandler: function(e4) {
          document.removeEventListener("mousemove", a2.mouse.moveHandler), document.removeEventListener("mouseup", a2.mouse.upHandler), s2();
        } }, touch: { moveEvent: "touchmove", moveHandler: function(e4) {
          return e4.cancelable && (e4.preventDefault(), e4.stopPropagation()), u2(e4.touches[0].clientX), false;
        }, upEvent: "touchend", upHandler: function(e4) {
          document.removeEventListener(a2.touch.moveEvent, a2.touch.moveHandler), document.removeEventListener(a2.touch.upEvent, a2.touch.moveHandler), s2();
        } } }, c2 = n4 ? a2.touch : a2.mouse, d2 = !!function() {
          if (typeof z == "boolean")
            return z;
          var e4 = false;
          try {
            var t4 = { get passive() {
              return e4 = true, false;
            } };
            window.addEventListener("test", null, t4), window.removeEventListener("test", null, t4);
          } catch (t5) {
            e4 = false;
          }
          return z = e4;
        }() && { passive: false };
        document.addEventListener(c2.moveEvent, c2.moveHandler, d2), document.addEventListener(c2.upEvent, c2.upHandler, d2), r2({ type: l.columnStartResizing, columnId: t3.id, columnWidth: t3.totalWidth, headerIdWidths: o3, clientX: i3 });
      };
      return [e2, { onMouseDown: function(e3) {
        return e3.persist() || i2(e3, o2);
      }, onTouchStart: function(e3) {
        return e3.persist() || i2(e3, o2);
      }, style: { cursor: "col-resize" }, draggable: false, role: "separator" }];
    };
    function Tt(e2, t2) {
      if (t2.type === l.init)
        return r({ columnResizing: { columnWidths: {} } }, e2);
      if (t2.type === l.resetResize)
        return r({}, e2, { columnResizing: { columnWidths: {} } });
      if (t2.type === l.columnStartResizing) {
        var n3 = t2.clientX, o2 = t2.columnId, i2 = t2.columnWidth, u2 = t2.headerIdWidths;
        return r({}, e2, { columnResizing: r({}, e2.columnResizing, { startX: n3, headerIdWidths: u2, columnWidth: i2, isResizingColumn: o2 }) });
      }
      if (t2.type === l.columnResizing) {
        var s2 = t2.clientX, a2 = e2.columnResizing, c2 = a2.startX, d2 = a2.columnWidth, f3 = a2.headerIdWidths, p3 = (s2 - c2) / d2, g3 = {};
        return (f3 === void 0 ? [] : f3).forEach(function(e3) {
          var t3 = e3[0], n4 = e3[1];
          g3[t3] = Math.max(n4 + n4 * p3, 0);
        }), r({}, e2, { columnResizing: r({}, e2.columnResizing, { columnWidths: r({}, e2.columnResizing.columnWidths, {}, g3) }) });
      }
      return t2.type === l.columnDoneResizing ? r({}, e2, { columnResizing: r({}, e2.columnResizing, { startX: null, isResizingColumn: null }) }) : void 0;
    }
    kt.pluginName = "useResizeColumns";
    var zt = function(e2) {
      var t2 = e2.flatHeaders, n3 = e2.disableResizing, o2 = e2.getHooks, r2 = e2.state.columnResizing, i2 = h(e2);
      t2.forEach(function(e3) {
        var t3 = I(e3.disableResizing !== true && void 0, n3 !== true && void 0, true);
        e3.canResize = t3, e3.width = r2.columnWidths[e3.id] || e3.originalWidth || e3.width, e3.isResizing = r2.isResizingColumn === e3.id, t3 && (e3.getResizerProps = f2(o2().getResizerProps, { instance: i2(), header: e3 }));
      });
    };
    function Wt(e2) {
      var n3 = e2.plugins, o2 = e2.dispatch, r2 = e2.autoResetResize, i2 = r2 === void 0 || r2, u2 = e2.columns;
      v(n3, ["useAbsoluteLayout"], "useResizeColumns");
      var s2 = h(i2);
      w(function() {
        s2() && o2({ type: l.resetResize });
      }, [u2]);
      var a2 = t.useCallback(function() {
        return o2({ type: l.resetResize });
      }, [o2]);
      Object.assign(e2, { resetResizing: a2 });
    }
    var Ot = { position: "absolute", top: 0 }, Mt = function(e2) {
      e2.getTableBodyProps.push(jt), e2.getRowProps.push(jt), e2.getHeaderGroupProps.push(jt), e2.getFooterGroupProps.push(jt), e2.getHeaderProps.push(function(e3, t2) {
        var n3 = t2.column;
        return [e3, { style: r({}, Ot, { left: n3.totalLeft + "px", width: n3.totalWidth + "px" }) }];
      }), e2.getCellProps.push(function(e3, t2) {
        var n3 = t2.cell;
        return [e3, { style: r({}, Ot, { left: n3.column.totalLeft + "px", width: n3.column.totalWidth + "px" }) }];
      }), e2.getFooterProps.push(function(e3, t2) {
        var n3 = t2.column;
        return [e3, { style: r({}, Ot, { left: n3.totalLeft + "px", width: n3.totalWidth + "px" }) }];
      });
    };
    Mt.pluginName = "useAbsoluteLayout";
    var jt = function(e2, t2) {
      return [e2, { style: { position: "relative", width: t2.instance.totalColumnsWidth + "px" } }];
    }, Nt = { display: "inline-block", boxSizing: "border-box" }, Lt = function(e2, t2) {
      return [e2, { style: { display: "flex", width: t2.instance.totalColumnsWidth + "px" } }];
    }, Dt = function(e2) {
      e2.getRowProps.push(Lt), e2.getHeaderGroupProps.push(Lt), e2.getFooterGroupProps.push(Lt), e2.getHeaderProps.push(function(e3, t2) {
        var n3 = t2.column;
        return [e3, { style: r({}, Nt, { width: n3.totalWidth + "px" }) }];
      }), e2.getCellProps.push(function(e3, t2) {
        var n3 = t2.cell;
        return [e3, { style: r({}, Nt, { width: n3.column.totalWidth + "px" }) }];
      }), e2.getFooterProps.push(function(e3, t2) {
        var n3 = t2.column;
        return [e3, { style: r({}, Nt, { width: n3.totalWidth + "px" }) }];
      });
    };
    function Vt(e2) {
      e2.getTableProps.push(_t), e2.getRowProps.push(Xt), e2.getHeaderGroupProps.push(Xt), e2.getFooterGroupProps.push(Xt), e2.getHeaderProps.push(qt), e2.getCellProps.push(Kt), e2.getFooterProps.push(Ut);
    }
    Dt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";
    var _t = function(e2, t2) {
      return [e2, { style: { minWidth: t2.instance.totalColumnsMinWidth + "px" } }];
    }, Xt = function(e2, t2) {
      return [e2, { style: { display: "flex", flex: "1 0 auto", minWidth: t2.instance.totalColumnsMinWidth + "px" } }];
    }, qt = function(e2, t2) {
      var n3 = t2.column;
      return [e2, { style: { boxSizing: "border-box", flex: n3.totalFlexWidth ? n3.totalFlexWidth + " 0 auto" : void 0, minWidth: n3.totalMinWidth + "px", width: n3.totalWidth + "px" } }];
    }, Kt = function(e2, t2) {
      var n3 = t2.cell;
      return [e2, { style: { boxSizing: "border-box", flex: n3.column.totalFlexWidth + " 0 auto", minWidth: n3.column.totalMinWidth + "px", width: n3.column.totalWidth + "px" } }];
    }, Ut = function(e2, t2) {
      var n3 = t2.column;
      return [e2, { style: { boxSizing: "border-box", flex: n3.totalFlexWidth ? n3.totalFlexWidth + " 0 auto" : void 0, minWidth: n3.totalMinWidth + "px", width: n3.totalWidth + "px" } }];
    };
    function $t(e2) {
      e2.stateReducers.push(Qt), e2.getTableProps.push(Jt), e2.getHeaderProps.push(Yt);
    }
    $t.pluginName = "useGridLayout";
    var Jt = function(e2, t2) {
      return [e2, { style: { display: "grid", gridTemplateColumns: t2.instance.state.gridLayout.columnWidths.map(function(e3) {
        return e3;
      }).join(" ") } }];
    }, Yt = function(e2, t2) {
      return [e2, { id: "header-cell-" + t2.column.id, style: { position: "sticky" } }];
    };
    function Qt(e2, t2, n3, o2) {
      if (t2.type === "init")
        return r({ gridLayout: { columnWidths: o2.columns.map(function() {
          return "auto";
        }) } }, e2);
      if (t2.type === "columnStartResizing") {
        var i2 = t2.columnId, u2 = o2.visibleColumns.findIndex(function(e3) {
          return e3.id === i2;
        }), l2 = function(e3) {
          var t3, n4 = (t3 = document.getElementById("header-cell-" + e3)) == null ? void 0 : t3.offsetWidth;
          if (n4 !== void 0)
            return n4;
        }(i2);
        return l2 !== void 0 ? r({}, e2, { gridLayout: r({}, e2.gridLayout, { columnId: i2, columnIndex: u2, startingWidth: l2 }) }) : e2;
      }
      if (t2.type === "columnResizing") {
        var s2 = e2.gridLayout, a2 = s2.columnIndex, c2 = s2.startingWidth, d2 = s2.columnWidths, f3 = c2 - (e2.columnResizing.startX - t2.clientX), p3 = [].concat(d2);
        return p3[a2] = f3 + "px", r({}, e2, { gridLayout: r({}, e2.gridLayout, { columnWidths: p3 }) });
      }
    }
    e._UNSTABLE_usePivotColumns = nt, e.actions = l, e.defaultColumn = c, e.defaultGroupByFn = De, e.defaultOrderByFn = Qe, e.defaultRenderer = s, e.emptyRenderer = a, e.ensurePluginOrder = v, e.flexRender = b, e.functionalUpdate = m2, e.loopHooks = g2, e.makePropGetter = f2, e.makeRenderer = R, e.reduceHooks = p2, e.safeUseLayoutEffect = y, e.useAbsoluteLayout = Mt, e.useAsyncDebounce = function(e2, n3) {
      n3 === void 0 && (n3 = 0);
      var r2 = t.useRef({}), i2 = h(e2), u2 = h(n3);
      return t.useCallback(function() {
        var e3 = o(regeneratorRuntime.mark(function e4() {
          var t2, n4, l2, s2 = arguments;
          return regeneratorRuntime.wrap(function(e5) {
            for (; ; )
              switch (e5.prev = e5.next) {
                case 0:
                  for (t2 = s2.length, n4 = new Array(t2), l2 = 0; l2 < t2; l2++)
                    n4[l2] = s2[l2];
                  return r2.current.promise || (r2.current.promise = new Promise(function(e6, t3) {
                    r2.current.resolve = e6, r2.current.reject = t3;
                  })), r2.current.timeout && clearTimeout(r2.current.timeout), r2.current.timeout = setTimeout(o(regeneratorRuntime.mark(function e6() {
                    return regeneratorRuntime.wrap(function(e7) {
                      for (; ; )
                        switch (e7.prev = e7.next) {
                          case 0:
                            return delete r2.current.timeout, e7.prev = 1, e7.t0 = r2.current, e7.next = 5, i2().apply(void 0, n4);
                          case 5:
                            e7.t1 = e7.sent, e7.t0.resolve.call(e7.t0, e7.t1), e7.next = 12;
                            break;
                          case 9:
                            e7.prev = 9, e7.t2 = e7.catch(1), r2.current.reject(e7.t2);
                          case 12:
                            return e7.prev = 12, delete r2.current.promise, e7.finish(12);
                          case 15:
                          case "end":
                            return e7.stop();
                        }
                    }, e6, null, [[1, 9, 12, 15]]);
                  })), u2()), e5.abrupt("return", r2.current.promise);
                case 5:
                case "end":
                  return e5.stop();
              }
          }, e4);
        }));
        return function() {
          return e3.apply(this, arguments);
        };
      }(), [i2, u2]);
    }, e.useBlockLayout = Dt, e.useColumnOrder = It, e.useExpanded = se, e.useFilters = Pe, e.useFlexLayout = Vt, e.useGetLatest = h, e.useGlobalFilter = Ie, e.useGridLayout = $t, e.useGroupBy = ze, e.useMountedLayoutEffect = w, e.usePagination = Ze, e.useResizeColumns = kt, e.useRowSelect = vt, e.useRowState = xt, e.useSortBy = Ue, e.useTable = function(e2) {
      for (var n3 = arguments.length, o2 = new Array(n3 > 1 ? n3 - 1 : 0), i2 = 1; i2 < n3; i2++)
        o2[i2 - 1] = arguments[i2];
      e2 = ie(e2), o2 = [K].concat(o2);
      var u2 = t.useRef({}), s2 = h(u2.current);
      Object.assign(s2(), r({}, e2, { plugins: o2, hooks: q2() })), o2.filter(Boolean).forEach(function(e3) {
        e3(s2().hooks);
      });
      var a2 = h(s2().hooks);
      s2().getHooks = a2, delete s2().hooks, Object.assign(s2(), p2(a2().useOptions, ie(e2)));
      var c2 = s2(), d2 = c2.data, v2 = c2.columns, m3 = c2.initialState, y2 = c2.defaultColumn, w2 = c2.getSubRows, b2 = c2.getRowId, E2 = c2.stateReducer, I2 = c2.useControlledState, F2 = h(E2), G2 = t.useCallback(function(e3, t2) {
        if (!t2.type)
          throw console.info({ action: t2 }), new Error("Unknown Action \u{1F446}");
        return [].concat(a2().stateReducers, Array.isArray(F2()) ? F2() : [F2()]).reduce(function(n4, o3) {
          return o3(n4, t2, e3, s2()) || n4;
        }, e3);
      }, [a2, F2, s2]), A2 = t.useReducer(G2, void 0, function() {
        return G2(m3, { type: l.init });
      }), k2 = A2[0], H2 = A2[1], T2 = p2([].concat(a2().useControlledState, [I2]), k2, { instance: s2() });
      Object.assign(s2(), { state: T2, dispatch: H2 });
      var z2 = t.useMemo(function() {
        return S(p2(a2().columns, v2, { instance: s2() }));
      }, [a2, s2, v2].concat(p2(a2().columnsDeps, [], { instance: s2() })));
      s2().columns = z2;
      var W2 = t.useMemo(function() {
        return p2(a2().allColumns, C(z2), { instance: s2() }).map(x);
      }, [z2, a2, s2].concat(p2(a2().allColumnsDeps, [], { instance: s2() })));
      s2().allColumns = W2;
      var O2 = t.useMemo(function() {
        for (var e3 = [], t2 = [], n4 = {}, o3 = [].concat(W2); o3.length; ) {
          var r2 = o3.shift();
          le({ data: d2, rows: e3, flatRows: t2, rowsById: n4, column: r2, getRowId: b2, getSubRows: w2, accessValueHooks: a2().accessValue, getInstance: s2 });
        }
        return [e3, t2, n4];
      }, [W2, d2, b2, w2, a2, s2]), M2 = O2[0], j2 = O2[1], N2 = O2[2];
      Object.assign(s2(), { rows: M2, initialRows: [].concat(M2), flatRows: j2, rowsById: N2 }), g2(a2().useInstanceAfterData, s2());
      var L2 = t.useMemo(function() {
        return p2(a2().visibleColumns, W2, { instance: s2() }).map(function(e3) {
          return P(e3, y2);
        });
      }, [a2, W2, s2, y2].concat(p2(a2().visibleColumnsDeps, [], { instance: s2() })));
      W2 = t.useMemo(function() {
        var e3 = [].concat(L2);
        return W2.forEach(function(t2) {
          e3.find(function(e4) {
            return e4.id === t2.id;
          }) || e3.push(t2);
        }), e3;
      }, [W2, L2]), s2().allColumns = W2;
      var D2 = t.useMemo(function() {
        return p2(a2().headerGroups, B(L2, y2), s2());
      }, [a2, L2, y2, s2].concat(p2(a2().headerGroupsDeps, [], { instance: s2() })));
      s2().headerGroups = D2;
      var V2 = t.useMemo(function() {
        return D2.length ? D2[0].headers : [];
      }, [D2]);
      s2().headers = V2, s2().flatHeaders = D2.reduce(function(e3, t2) {
        return [].concat(e3, t2.headers);
      }, []), g2(a2().useInstanceBeforeDimensions, s2());
      var _2 = L2.filter(function(e3) {
        return e3.isVisible;
      }).map(function(e3) {
        return e3.id;
      }).sort().join("_");
      L2 = t.useMemo(function() {
        return L2.filter(function(e3) {
          return e3.isVisible;
        });
      }, [L2, _2]), s2().visibleColumns = L2;
      var X2 = ue(V2), U2 = X2[0], $2 = X2[1], J2 = X2[2];
      return s2().totalColumnsMinWidth = U2, s2().totalColumnsWidth = $2, s2().totalColumnsMaxWidth = J2, g2(a2().useInstance, s2()), [].concat(s2().flatHeaders, s2().allColumns).forEach(function(e3) {
        e3.render = R(s2(), e3), e3.getHeaderProps = f2(a2().getHeaderProps, { instance: s2(), column: e3 }), e3.getFooterProps = f2(a2().getFooterProps, { instance: s2(), column: e3 });
      }), s2().headerGroups = t.useMemo(function() {
        return D2.filter(function(e3, t2) {
          return e3.headers = e3.headers.filter(function(e4) {
            return e4.headers ? function e5(t3) {
              return t3.filter(function(t4) {
                return t4.headers ? e5(t4.headers) : t4.isVisible;
              }).length;
            }(e4.headers) : e4.isVisible;
          }), !!e3.headers.length && (e3.getHeaderGroupProps = f2(a2().getHeaderGroupProps, { instance: s2(), headerGroup: e3, index: t2 }), e3.getFooterGroupProps = f2(a2().getFooterGroupProps, { instance: s2(), headerGroup: e3, index: t2 }), true);
        });
      }, [D2, s2, a2]), s2().footerGroups = [].concat(s2().headerGroups).reverse(), s2().prepareRow = t.useCallback(function(e3) {
        e3.getRowProps = f2(a2().getRowProps, { instance: s2(), row: e3 }), e3.allCells = W2.map(function(t2) {
          var n4 = e3.values[t2.id], o3 = { column: t2, row: e3, value: n4 };
          return o3.getCellProps = f2(a2().getCellProps, { instance: s2(), cell: o3 }), o3.render = R(s2(), t2, { row: e3, cell: o3, value: n4 }), o3;
        }), e3.cells = L2.map(function(t2) {
          return e3.allCells.find(function(e4) {
            return e4.column.id === t2.id;
          });
        }), g2(a2().prepareRow, e3, { instance: s2() });
      }, [a2, s2, W2, L2]), s2().getTableProps = f2(a2().getTableProps, { instance: s2() }), s2().getTableBodyProps = f2(a2().getTableBodyProps, { instance: s2() }), g2(a2().useFinalInstance, s2()), s2();
    }, Object.defineProperty(e, "__esModule", { value: true });
  });
})(reactTable_production_min, reactTable_production_min.exports);
{
  reactTable.exports = reactTable_production_min.exports;
}
const setMaxHeight = (visibleRowsCount, isCompact) => {
  const compactRowHeight = 56;
  const defaultRowHeight = 72;
  const cellHeight = isCompact ? compactRowHeight : defaultRowHeight;
  return !lodash.exports.isNil(visibleRowsCount) ? {
    maxHeight: `${visibleRowsCount * cellHeight}px`
  } : {};
};
const Table = ({
  columns: appColumns,
  data,
  withSearchBar,
  maxLength,
  withColumnFilter,
  emptyTitle,
  emptySubtitle,
  filters: filters2,
  defaultFilters,
  onFiltersChange,
  searchBarPlaceholder,
  searchBarLabel,
  className,
  visibleRowsCount,
  isCompact,
  withSelectableRows,
  getChildRows,
  onSelectedRowChange,
  BulkSelectRowAside,
  initialState,
  onRowClick
}) => {
  const columns = useMemo(() => getChildRows ? [makeExpanderColumn(getChildRows), ...appColumns] : appColumns, [appColumns]);
  const plugins = [reactTable.exports.useGlobalFilter, reactTable.exports.useSortBy];
  if (getChildRows)
    plugins.push(reactTable.exports.useExpanded);
  const {
    state: {
      globalFilter,
      selectedRowIds
    },
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setGlobalFilter,
    selectedFlatRows,
    toggleAllRowsSelected,
    getToggleHideAllColumnsProps,
    allColumns
  } = reactTable.exports.useTable({
    columns,
    data,
    initialState
  }, ...plugins, reactTable.exports.useRowSelect, (hooks) => {
    if (withSelectableRows) {
      hooks.visibleColumns.push((columns2) => [{
        id: "selection",
        Header: ({
          getToggleAllRowsSelectedProps
        }) => /* @__PURE__ */ jsx$1(IndeterminateCheckbox, __spreadValues({}, getToggleAllRowsSelectedProps())),
        Cell: ({
          row
        }) => /* @__PURE__ */ jsx$1(IndeterminateCheckbox, __spreadValues({}, row.getToggleRowSelectedProps()))
      }, ...columns2]);
    }
  });
  const [showFilters, setShowFilters] = useState(false);
  const [showAllFilters, setShowAllFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(defaultFilters || {});
  const [filterFilterQueries, setFilterFilterQueries] = useState({});
  const [columnFilterVisible, setColumnFilterVisible] = useState(false);
  const [columnFilterQuery, setColumnFilterQuery] = useState("");
  const setFilters = (newFilterState) => {
    setSelectedFilters(newFilterState);
    onFiltersChange && onFiltersChange(newFilterState);
  };
  const handleChangeSelectedFilters = (filterGroup, event) => {
    if (!selectedFilters[filterGroup])
      selectedFilters[filterGroup] = [];
    setFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      [filterGroup]: event.target.checked ? [...selectedFilters[filterGroup], event.target.name] : [...selectedFilters[filterGroup]].filter((item2) => item2 !== event.target.name)
    }));
  };
  const handleSelectAllFilters = (filterGroup, childFilterArray) => {
    setFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      [filterGroup]: childFilterArray.map((item2) => item2.accessor)
    }));
  };
  const handleClearSelectedFilters = (filterGroup) => {
    if (filterGroup) {
      setFilters(__spreadProps(__spreadValues({}, selectedFilters), {
        [filterGroup]: []
      }));
    } else {
      setFilters({});
    }
  };
  const handleUpdateFilterFilterQuery = (filterGroup, e) => {
    setFilterFilterQueries(__spreadProps(__spreadValues({}, filterFilterQueries), {
      [filterGroup]: e.target.value
    }));
  };
  const searchBarProps = {
    globalFilter,
    setGlobalFilter,
    searchBarPlaceholder,
    searchBarLabel,
    maxLength
  };
  const headerProps = {
    headerGroups,
    isCompact
  };
  const bodyProps = {
    rows,
    prepareRow,
    isCompact,
    getChildRows
  };
  const bulkSelectProps = {
    selectedRowIds,
    selectedFlatRows,
    toggleAllRowsSelected,
    clearSelectedRow: () => toggleAllRowsSelected(false)
  };
  withSelectableRows && onSelectedRowChange && onSelectedRowChange({
    selectedRowIds,
    selectedFlatRows
  });
  const filterCount2 = useMemo(() => Object.keys(selectedFilters).reduce((acc, curr) => acc + selectedFilters[curr].length, 0), [selectedFilters]);
  const handleFilterBtnClick = useCallback(() => setShowFilters(!showFilters), [showFilters]);
  if (columns.length === 0)
    return /* @__PURE__ */ jsx$1(Fragment, {});
  return /* @__PURE__ */ jsxs("div", {
    className: classnames$1(className),
    children: [(withSearchBar || (filters2 == null ? void 0 : filters2.length) || withColumnFilter) && /* @__PURE__ */ jsxs("div", {
      className: styles.searchFilterSection,
      children: [withSearchBar && /* @__PURE__ */ jsx$1(SearchBar, __spreadValues({}, searchBarProps)), (filters2 == null ? void 0 : filters2.length) > 0 && /* @__PURE__ */ jsx$1(FilterButton, {
        showFilters,
        handleFilterBtnClick,
        filterCount: filterCount2
      }), withColumnFilter && /* @__PURE__ */ jsx$1(ColumnFilterButton, {
        columns: allColumns,
        toggleAll: getToggleHideAllColumnsProps,
        columnFilterVisible,
        setColumnFilterVisible,
        columnFilterQuery,
        setColumnFilterQuery,
        withSelectableRows
      })]
    }), showFilters && (filters2 == null ? void 0 : filters2.length) > 0 && /* @__PURE__ */ jsx$1(FilterSection, {
      selectedFilters,
      handleChangeSelectedFilters,
      handleSelectAllFilters,
      handleClearSelectedFilters,
      showAllFilters,
      setShowAllFilters,
      filters: filters2,
      filterFilterQueries,
      handleUpdateFilterFilterQuery
    }), /* @__PURE__ */ jsxs("div", {
      className: `${styles.scrollTable}`,
      children: [withSelectableRows && (selectedFlatRows == null ? void 0 : selectedFlatRows.length) > 0 && /* @__PURE__ */ jsx$1(BulkSelectRow, __spreadProps(__spreadValues({}, bulkSelectProps), {
        children: BulkSelectRowAside && /* @__PURE__ */ jsx$1(BulkSelectRowAside, __spreadValues({}, bulkSelectProps))
      })), (data == null ? void 0 : data.length) === 0 ? /* @__PURE__ */ jsx$1(NoDataRow, {
        title: emptyTitle,
        subtitle: emptySubtitle
      }) : /* @__PURE__ */ jsxs(TableContainer, __spreadProps(__spreadValues({
        className: classnames$1(withSelectableRows && styles.withCheckboxColumn, withSelectableRows && (selectedFlatRows == null ? void 0 : selectedFlatRows.length) > 0 && styles.bulkSelectRowActive)
      }, getTableProps()), {
        children: [/* @__PURE__ */ jsx$1(TableHeader, __spreadValues({}, headerProps)), /* @__PURE__ */ jsx$1(Tbody, __spreadProps(__spreadValues({}, getTableBodyProps()), {
          style: setMaxHeight(visibleRowsCount, isCompact),
          children: (data == null ? void 0 : data.length) === 0 ? /* @__PURE__ */ jsx$1(NoDataRow, {}) : /* @__PURE__ */ jsx$1(NoPagination, __spreadProps(__spreadValues({
            onRowClick
          }, bodyProps), {
            expanderCell: /* @__PURE__ */ jsx$1(Td, {
              className: styles.expander
            })
          }))
        }))]
      }))]
    })]
  });
};
Table.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape({
    Header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    accessor: PropTypes.string.isRequired,
    defaultCanSort: PropTypes.bool,
    disableSortBy: PropTypes.bool,
    sortDescFirst: PropTypes.bool,
    sortInverted: PropTypes.bool,
    sortType: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  })).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  withSearchBar: PropTypes.bool,
  maxLength: PropTypes.number,
  filters: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    accessor: PropTypes.string.isRequired,
    filters: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      accessor: PropTypes.string.isRequired
    }))
  })),
  defaultFilters: PropTypes.object,
  onFiltersChange: PropTypes.func,
  searchBarPlaceholder: PropTypes.string,
  searchBarLabel: PropTypes.string,
  isCompact: PropTypes.bool,
  visibleRowsCount: PropTypes.number,
  withSelectableRows: PropTypes.bool,
  onSelectedRowChange: PropTypes.func,
  BulkSelectRowAside: PropTypes.func,
  withColumnFilter: PropTypes.bool,
  getChildRows: PropTypes.func,
  onRowClick: PropTypes.func,
  emptyTitle: PropTypes.string,
  emptySubtitle: PropTypes.string
};
Table.defaultProps = {
  className: "",
  columns: [],
  data: [],
  withSearchBar: false,
  filters: [],
  onFiltersChange: null,
  searchBarPlaceholder: "Search",
  searchBarLabel: "",
  isCompact: false,
  visibleRowsCount: 10,
  withSelectableRows: false,
  withColumnFilter: false
};
function makeExpanderColumn(getChildRows) {
  return {
    Header: () => null,
    id: "expander",
    className: styles.expander,
    Cell: ({
      row
    }) => {
      var _a;
      if (!((_a = getChildRows({
        row
      })) == null ? void 0 : _a.length))
        return null;
      return /* @__PURE__ */ jsx$1("span", __spreadProps(__spreadValues({}, row.getToggleRowExpandedProps()), {
        children: row.isExpanded ? /* @__PURE__ */ jsx$1(Icon, {
          type: "CaretUp",
          size: "m"
        }) : /* @__PURE__ */ jsx$1(Icon, {
          type: "CaretDown",
          size: "m"
        })
      }));
    }
  };
}
function PaginationTable({
  columns,
  data,
  withSearchBar,
  maxLength,
  withColumnFilter,
  searchBarPlaceholder,
  searchBarLabel,
  pageSizeOptions,
  className,
  isCompact,
  initialState,
  defaultFilters,
  filters: filters2,
  onFiltersChange,
  withSelectableRows,
  onSelectedRowChange,
  BulkSelectRowAside,
  emptyTitle,
  emptySubtitle,
  getRowId,
  autoResetSelectedRows = true,
  visibleRowsCount,
  paginationSelectDropdownMenuPlacement
}) {
  const {
    state: {
      globalFilter,
      pageIndex,
      pageSize,
      selectedRowIds
    },
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    setGlobalFilter,
    selectedFlatRows,
    toggleAllRowsSelected,
    getToggleHideAllColumnsProps,
    allColumns
  } = reactTable.exports.useTable({
    columns,
    data,
    initialState: __spreadValues({
      pageSize: pageSizeOptions.length > 0 ? pageSizeOptions[0] : 10
    }, initialState),
    autoResetSelectedRows,
    getRowId
  }, reactTable.exports.useGlobalFilter, reactTable.exports.useSortBy, reactTable.exports.usePagination, reactTable.exports.useRowSelect, (hooks) => {
    if (withSelectableRows) {
      hooks.visibleColumns.push((columns2) => [{
        id: "selection",
        Header: ({
          getToggleAllPageRowsSelectedProps
        }) => /* @__PURE__ */ jsx$1(IndeterminateCheckbox, __spreadValues({}, getToggleAllPageRowsSelectedProps())),
        Cell: ({
          row
        }) => {
          return /* @__PURE__ */ jsx$1(IndeterminateCheckbox, __spreadValues({}, row.getToggleRowSelectedProps()));
        }
      }, ...columns2]);
    }
  });
  if (columns.length === 0)
    return null;
  const [showFilters, setShowFilters] = useState(false);
  const [showAllFilters, setShowAllFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(defaultFilters || {});
  const [filterFilterQueries, setFilterFilterQueries] = useState({});
  const [columnFilterVisible, setColumnFilterVisible] = useState(false);
  const [columnFilterQuery, setColumnFilterQuery] = useState("");
  const setFilters = (newFilterState) => {
    setSelectedFilters(newFilterState);
    onFiltersChange(newFilterState);
  };
  const handleChangeSelectedFilters = (filterGroup, event) => {
    if (!selectedFilters[filterGroup])
      selectedFilters[filterGroup] = [];
    setFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      [filterGroup]: event.target.checked ? [...selectedFilters[filterGroup], event.target.name] : [...selectedFilters[filterGroup]].filter((item2) => item2 !== event.target.name)
    }));
  };
  const handleSelectAllFilters = (filterGroup, childFilterArray) => {
    setFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      [filterGroup]: childFilterArray.map((item2) => item2.accessor)
    }));
  };
  const handleClearSelectedFilters = (filterGroup) => {
    if (filterGroup) {
      setFilters(__spreadProps(__spreadValues({}, selectedFilters), {
        [filterGroup]: []
      }));
    } else {
      setFilters({});
    }
  };
  const handleUpdateFilterFilterQuery = (filterGroup, e) => {
    setFilterFilterQueries(__spreadProps(__spreadValues({}, filterFilterQueries), {
      [filterGroup]: e.target.value
    }));
  };
  const paginationProps = {
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageIndex,
    pageOptions,
    totalRowCount: rows.length,
    gotoPage,
    pageCount,
    pageSize,
    setPageSize,
    pageSizeOptions,
    pageNumbersOptions: [...Array(pageCount)].map((_, num) => ({
      value: num.toString(),
      label: `${num + 1}`.toString()
    })),
    selectDropdownMenuPlacement: paginationSelectDropdownMenuPlacement
  };
  const searchBarProps = {
    className: styles.SearchBar,
    globalFilter,
    setGlobalFilter,
    searchBarPlaceholder,
    searchBarLabel,
    ariaLabel: "GlobalTableFilter",
    maxLength
  };
  const headerProps = {
    headerGroups,
    isCompact
  };
  const bodyProps = {
    page,
    prepareRow,
    isCompact
  };
  const bulkSelectProps = {
    selectedRowIds,
    selectedFlatRows,
    toggleAllRowsSelected,
    clearSelectedRow: () => toggleAllRowsSelected(false)
  };
  useEffect(() => {
    withSelectableRows && onSelectedRowChange && onSelectedRowChange({
      selectedRowIds,
      selectedFlatRows
    });
  }, [selectedFlatRows.length]);
  const filterCount2 = useMemo(() => Object.keys(selectedFilters).reduce((acc, curr) => acc + selectedFilters[curr].length, 0), [selectedFilters]);
  const handleFilterBtnClick = useCallback(() => setShowFilters(!showFilters), [showFilters]);
  return /* @__PURE__ */ jsxs("div", __spreadProps(__spreadValues({}, className), {
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles.searchFilterSection,
      children: [withSearchBar && /* @__PURE__ */ jsx$1(SearchBar, __spreadValues({}, searchBarProps)), !!filters2.length && /* @__PURE__ */ jsx$1(FilterButton, {
        showFilters,
        handleFilterBtnClick,
        filterCount: filterCount2
      }), withColumnFilter && /* @__PURE__ */ jsx$1(ColumnFilterButton, {
        columns: allColumns,
        toggleAll: getToggleHideAllColumnsProps,
        columnFilterVisible,
        setColumnFilterVisible,
        columnFilterQuery,
        setColumnFilterQuery,
        withSelectableRows
      })]
    }), showFilters ? /* @__PURE__ */ jsx$1(FilterSection, {
      selectedFilters,
      handleChangeSelectedFilters,
      handleSelectAllFilters,
      handleClearSelectedFilters,
      showAllFilters,
      setShowAllFilters,
      filters: filters2,
      filterFilterQueries,
      handleUpdateFilterFilterQuery
    }) : null, selectedFlatRows.length > 0 && /* @__PURE__ */ jsx$1(BulkSelectRow, __spreadProps(__spreadValues({}, bulkSelectProps), {
      children: BulkSelectRowAside && /* @__PURE__ */ jsx$1(BulkSelectRowAside, __spreadValues({}, bulkSelectProps))
    })), data.length === 0 ? /* @__PURE__ */ jsx$1(NoDataRow, {
      title: emptyTitle,
      subtitle: emptySubtitle
    }) : /* @__PURE__ */ jsx$1(TableContainer, __spreadProps(__spreadValues({
      className: classnames$1({
        [styles.scrollTable]: !lodash.exports.isNil(visibleRowsCount) && visibleRowsCount > 0,
        [styles.withCheckboxColumn]: withSelectableRows,
        [styles.bulkSelectRowActive]: withSelectableRows && selectedFlatRows.length > 0
      })
    }, getTableProps()), {
      children: /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx$1(TableHeader, __spreadValues({}, headerProps)), /* @__PURE__ */ jsx$1(Tbody, __spreadProps(__spreadValues({}, getTableBodyProps()), {
          style: setMaxHeight(visibleRowsCount, isCompact),
          children: /* @__PURE__ */ jsx$1(Pagination, __spreadValues({}, bodyProps))
        }))]
      })
    })), data.length !== 0 && /* @__PURE__ */ jsx$1(PaginationControls, __spreadValues({}, paginationProps))]
  }));
}
PaginationTable.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape({
    Header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    accessor: PropTypes.string.isRequired,
    defaultCanSort: PropTypes.bool,
    disableSortBy: PropTypes.bool,
    sortDescFirst: PropTypes.bool,
    sortInverted: PropTypes.bool,
    sortType: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  })).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  withSearchBar: PropTypes.bool,
  maxLength: PropTypes.number,
  searchBarPlaceholder: PropTypes.string,
  searchBarLabel: PropTypes.string,
  isCompact: PropTypes.bool,
  initialState: PropTypes.object,
  defaultFilters: PropTypes.object,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  withSelectableRows: PropTypes.bool,
  onSelectedRowChange: PropTypes.func,
  BulkSelectRowAside: PropTypes.func,
  filters: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    accessor: PropTypes.string.isRequired,
    filters: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      accessor: PropTypes.string.isRequired
    }))
  })),
  onFiltersChange: PropTypes.func,
  withColumnFilter: PropTypes.bool,
  emptyTitle: PropTypes.string,
  emptySubtitle: PropTypes.string,
  visibleRowsCount: PropTypes.number,
  paginationSelectDropdownMenuPlacement: PropTypes.string
};
PaginationTable.defaultProps = {
  className: "",
  columns: [],
  data: [],
  withSearchBar: false,
  searchBarPlaceholder: "Search",
  searchBarLabel: "",
  isCompact: false,
  initialState: {},
  filters: [],
  onFiltersChange: null,
  pageSizeOptions: [10, 20, 25],
  withSelectableRows: false,
  withColumnFilter: false
};
const PaginationControlledTable = forwardRef((_ka, ref) => {
  var _la = _ka, {
    className,
    columns,
    data,
    withSearchBar,
    withColumnFilter,
    searchBarPlaceholder,
    searchBarLabel,
    maxLength,
    onTableChange,
    loading,
    pageCount: controlledPageCount,
    pageSizeOptions,
    isCompact,
    initialState,
    defaultFilters,
    filters: filters2,
    onFiltersChange,
    totalRowCount,
    withSelectableRows,
    onSelectedRowChange,
    BulkSelectRowAside,
    emptyTitle,
    emptySubtitle,
    getRowId,
    autoResetSelectedRows = true,
    autoResetPage = false,
    visibleRowsCount,
    onControlledFilterQueryChange,
    paginationSelectDropdownMenuPlacement
  } = _la, props = __objRest(_la, [
    "className",
    "columns",
    "data",
    "withSearchBar",
    "withColumnFilter",
    "searchBarPlaceholder",
    "searchBarLabel",
    "maxLength",
    "onTableChange",
    "loading",
    "pageCount",
    "pageSizeOptions",
    "isCompact",
    "initialState",
    "defaultFilters",
    "filters",
    "onFiltersChange",
    "totalRowCount",
    "withSelectableRows",
    "onSelectedRowChange",
    "BulkSelectRowAside",
    "emptyTitle",
    "emptySubtitle",
    "getRowId",
    "autoResetSelectedRows",
    "autoResetPage",
    "visibleRowsCount",
    "onControlledFilterQueryChange",
    "paginationSelectDropdownMenuPlacement"
  ]);
  const {
    state: {
      globalFilter,
      pageIndex,
      pageSize,
      sortBy,
      selectedRowIds
    },
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    selectedFlatRows,
    toggleAllPageRowsSelected,
    getToggleHideAllColumnsProps,
    allColumns,
    dispatch
  } = reactTable.exports.useTable({
    columns,
    data,
    initialState: __spreadValues({
      pageSize: pageSizeOptions.length > 0 ? pageSizeOptions[0] : 10
    }, initialState),
    pageCount: controlledPageCount,
    manualPagination: true,
    manualGlobalFilter: true,
    manualSortBy: true,
    autoResetPage,
    autoResetSortBy: false,
    autoResetSelectedRows,
    getRowId
  }, reactTable.exports.useGlobalFilter, reactTable.exports.useSortBy, reactTable.exports.usePagination, reactTable.exports.useRowSelect, (hooks) => {
    if (withSelectableRows) {
      hooks.visibleColumns.push((columns2) => [{
        id: "selection",
        Header: ({
          getToggleAllPageRowsSelectedProps
        }) => /* @__PURE__ */ jsx$1(IndeterminateCheckbox, __spreadValues({}, getToggleAllPageRowsSelectedProps())),
        Cell: ({
          row
        }) => /* @__PURE__ */ jsx$1(IndeterminateCheckbox, __spreadValues({}, row.getToggleRowSelectedProps()))
      }, ...columns2]);
    }
  });
  useEffect(() => {
    onTableChange == null ? void 0 : onTableChange({
      pageIndex,
      pageSize,
      globalFilter,
      sortBy
    });
  }, [onTableChange, pageIndex, pageSize, globalFilter, sortBy]);
  useImperativeHandle(ref, () => ({
    resetAllSelectedRows: () => dispatch({
      type: reactTable.exports.actions.resetSelectedRows
    }),
    resetPageIndex: () => dispatch({
      type: reactTable.exports.actions.gotoPage,
      pageIndex: 0
    })
  }));
  const [showFilters, setShowFilters] = useState(false);
  const [showAllFilters, setShowAllFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(defaultFilters || {});
  const [filterFilterQueries, setFilterFilterQueries] = useState({});
  const [columnFilterVisible, setColumnFilterVisible] = useState(false);
  const [columnFilterQuery, setColumnFilterQuery] = useState("");
  useEffect(() => {
    onFiltersChange == null ? void 0 : onFiltersChange(selectedFilters);
  }, [onFiltersChange, selectedFilters]);
  const setFilters = (newFilterState) => {
    setSelectedFilters(newFilterState);
  };
  const handleChangeSelectedFilters = (filterGroup, event) => {
    if (!selectedFilters[filterGroup])
      selectedFilters[filterGroup] = [];
    setFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      [filterGroup]: event.target.checked ? [...selectedFilters[filterGroup], event.target.name] : [...selectedFilters[filterGroup]].filter((item2) => item2 !== event.target.name)
    }));
  };
  const handleSelectAllFilters = (filterGroup, childFilterArray) => {
    setFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      [filterGroup]: childFilterArray.map((item2) => item2.accessor)
    }));
  };
  const handleClearSelectedFilters = (filterGroup) => {
    if (filterGroup) {
      setFilters(__spreadProps(__spreadValues({}, selectedFilters), {
        [filterGroup]: []
      }));
    } else {
      setFilters({});
    }
  };
  const handleUpdateFilterFilterQuery = (filterGroup, e) => {
    setFilterFilterQueries(__spreadProps(__spreadValues({}, filterFilterQueries), {
      [filterGroup]: e.target.value
    }));
    onControlledFilterQueryChange == null ? void 0 : onControlledFilterQueryChange({
      [filterGroup]: e.target.value
    });
  };
  const searchBarProps = {
    globalFilter,
    setGlobalFilter,
    searchBarPlaceholder,
    searchBarLabel,
    maxLength
  };
  const paginationProps = __spreadValues({
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageIndex,
    pageOptions,
    totalRowCount,
    gotoPage,
    pageCount,
    pageSize,
    setPageSize,
    pageSizeOptions,
    pageNumbersOptions: [...Array(pageCount)].map((_, num) => ({
      value: num.toString(),
      label: `${num + 1}`.toString()
    })),
    selectDropdownMenuPlacement: paginationSelectDropdownMenuPlacement
  }, props);
  const headerProps = {
    headerGroups,
    controledPagination: true,
    isCompact
  };
  const bodyProps = {
    page,
    prepareRow,
    isCompact
  };
  const clearSelectedRows = () => toggleAllPageRowsSelected(false);
  const bulkSelectProps = {
    selectedRowIds,
    selectedFlatRows,
    toggleAllRowsSelected: toggleAllPageRowsSelected,
    clearSelectedRow: clearSelectedRows
  };
  useEffect(() => {
    withSelectableRows && onSelectedRowChange && onSelectedRowChange({
      selectedRowIds,
      selectedFlatRows,
      clearSelectedRows
    });
  }, [selectedFlatRows.length]);
  const filterCount2 = useMemo(() => Object.keys(selectedFilters).reduce((acc, curr) => acc + selectedFilters[curr].length, 0), [selectedFilters]);
  const handleFilterBtnClick = useCallback(() => setShowFilters(!showFilters), [showFilters]);
  return /* @__PURE__ */ jsxs("div", __spreadProps(__spreadValues({}, className), {
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles.searchFilterSection,
      children: [withSearchBar && /* @__PURE__ */ jsx$1(SearchBar, __spreadValues({}, searchBarProps)), !!filters2.length && /* @__PURE__ */ jsx$1(FilterButton, {
        showFilters,
        handleFilterBtnClick,
        filterCount: filterCount2
      }), withColumnFilter && /* @__PURE__ */ jsx$1(ColumnFilterButton, {
        columns: allColumns,
        toggleAll: getToggleHideAllColumnsProps,
        columnFilterVisible,
        setColumnFilterVisible,
        columnFilterQuery,
        setColumnFilterQuery,
        withSelectableRows
      })]
    }), showFilters ? /* @__PURE__ */ jsx$1(FilterSection, {
      selectedFilters,
      handleChangeSelectedFilters,
      handleSelectAllFilters,
      handleClearSelectedFilters,
      showAllFilters,
      setShowAllFilters,
      filters: filters2,
      filterFilterQueries,
      handleUpdateFilterFilterQuery
    }) : null, selectedFlatRows.length > 0 && /* @__PURE__ */ jsx$1(BulkSelectRow, __spreadProps(__spreadValues({}, bulkSelectProps), {
      children: BulkSelectRowAside && /* @__PURE__ */ jsx$1(BulkSelectRowAside, __spreadValues({}, bulkSelectProps))
    })), !loading && data.length === 0 ? /* @__PURE__ */ jsx$1(NoDataRow, {
      title: emptyTitle,
      subtitle: emptySubtitle
    }) : /* @__PURE__ */ jsx$1(TableContainer, __spreadProps(__spreadValues({
      className: classnames$1({
        [styles.scrollTable]: !lodash.exports.isNil(visibleRowsCount) && visibleRowsCount > 0,
        [styles.withCheckboxColumn]: withSelectableRows,
        [styles.bulkSelectRowActive]: withSelectableRows && selectedFlatRows.length > 0
      })
    }, getTableProps()), {
      children: /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx$1(TableHeader, __spreadValues({}, headerProps)), /* @__PURE__ */ jsx$1(Tbody, __spreadProps(__spreadValues({}, getTableBodyProps()), {
          style: setMaxHeight(visibleRowsCount, isCompact),
          children: loading ? /* @__PURE__ */ jsx$1(LoadingRow, {
            isCompact: true
          }) : /* @__PURE__ */ jsx$1(Pagination, __spreadValues({}, bodyProps))
        }))]
      })
    })), data.length !== 0 && /* @__PURE__ */ jsx$1(PaginationControls, __spreadValues({}, paginationProps))]
  }));
});
PaginationControlledTable.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape({
    Header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    accessor: PropTypes.string.isRequired,
    defaultCanSort: PropTypes.bool,
    disableSortBy: PropTypes.bool,
    sortDescFirst: PropTypes.bool,
    sortInverted: PropTypes.bool,
    sortType: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  })).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  withSearchBar: PropTypes.bool,
  maxLength: PropTypes.number,
  searchBarPlaceholder: PropTypes.string,
  searchBarLabel: PropTypes.string,
  isCompact: PropTypes.bool,
  initialState: PropTypes.object,
  defaultFilters: PropTypes.object,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  loading: PropTypes.bool.isRequired,
  onTableChange: PropTypes.func,
  totalRowCount: PropTypes.number,
  withSelectableRows: PropTypes.bool,
  onSelectedRowChange: PropTypes.func,
  BulkSelectRowAside: PropTypes.func,
  filters: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    accessor: PropTypes.string.isRequired,
    filters: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      accessor: PropTypes.string.isRequired
    }))
  })),
  onFiltersChange: PropTypes.func,
  withColumnFilter: PropTypes.bool,
  emptyTitle: PropTypes.string,
  emptySubtitle: PropTypes.string,
  getRowId: PropTypes.func,
  autoResetSelectedRows: PropTypes.bool,
  autoResetPage: PropTypes.bool,
  visibleRowsCount: PropTypes.number,
  onControlledFilterQueryChange: PropTypes.func,
  paginationSelectDropdownMenuPlacement: PropTypes.string
};
PaginationControlledTable.defaultProps = {
  className: "",
  columns: [],
  data: [],
  withSearchBar: false,
  searchBarPlaceholder: "Search",
  searchBarLabel: "",
  isCompact: false,
  initialState: {},
  filters: [],
  onFiltersChange: null,
  totalRowCount: 0,
  pageSizeOptions: [10, 20, 25],
  loading: true,
  withSelectableRows: false,
  withColumnFilter: false
};
export { ActionInput, Avatar, Badge, Breadcrumbs, Button$1 as Button, Card, Checkbox, Chips, Collapsible, Container$1 as Container, Drawer, Favorites, FileInput, FormSection, Icon, IconButton, Label$1 as Label, ListItem, Modal, NavBar, Overlay, PaginationControlledTable, PaginationControls, PaginationTable, RadioButton, RadioGroup, Scrollspy, Section, Select, Spinner, StaticTable, StepFormProgressBars, Table, TableContainer, Tabs, Tbody, Td, TextArea, TextInput$1 as TextInput, Th, Thead, ToggleSwitch, Tooltip, Tr };
//# sourceMappingURL=index.esm.js.map
